(function () {
    'use strict';

    angular
        .module('seatonApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            //'angular-loading-bar',
            'oc.lazyLoad',
            'googlechart',
            'angularMoment',
            'ui.bootstrap.datepicker',
            'angular.filter',
            //'daterangepicker',
            //'ngFlatDatepicker',
            'toastr',
            'ui.mask',
            'ngTable',
            'ui.checkbox',
            'oitozero.ngSweetAlert',
            'ngSanitize',
            'ui.toggle',
            'angular-intro',
            'ngIntlTelInput',
            'colorpicker',
            'dndLists'
        ])
        .config(['$locationProvider', '$urlRouterProvider', 'ngIntlTelInputProvider', function ($locationProvider, $urlRouterProvider, ngIntlTelInputProvider) {

            ngIntlTelInputProvider.set(
                {
                    initialCountry: 'us',
                    nationalMode: false,
                    formatOnDisplay: true
                });

            /*$urlRouterProvider.when("/clover/access",
             ['$stateParams', function ($stateParams) {
             $state.transitionTo("account.clover", $stateParams);
             }]
             )*/
            //$locationProvider.html5Mode(true);
        }])
        .run(run);

    run.$inject = ['$rootScope', '$localStorage', '$timeout', '$location', 'stateHandler', 'translationHandler', '$state',
        'Principal', 'Notification', 'Log', 'ApplicationContext', '$locale', 'tmhDynamicLocale'];

    function run($rootScope, $localStorage, $timeout, $location, stateHandler, translationHandler, $state,
                 Principal, Notification, Log, ApplicationContext, $locale, tmhDynamicLocale) {


        //TODO branimir cleanup
        if ($localStorage.TimeZone) {
            ApplicationContext.setLanguageAndLocale();
            Log.debug("AppModule", "Application start: $localStorage.TimeZone.timezone: " + $localStorage.TimeZone);

            //if timezone is defined in localStorage then set it
            //moment.tz.setDefault($localStorage.TimeZone);
            //moment.locale('de');
            //$locale.id = 'en-gb';
            //tmhDynamicLocale.changeLanguage($localStorage.Locale);
            //var ret = tmhDynamicLocale.set('en-gb');
            //console.log(ret);
        }

        stateHandler.initialize();
        translationHandler.initialize();

        // consuming please-wait events, please-wait interceptor on http request and reponse thros those events
        $rootScope.$on('_start-please_wait_', function () {
            // show div block defined in begining of app_layout.html
            $rootScope.show_loading_started = true;
            $timeout(delayShowingPleaseWait, 250);
        });

        $rootScope.$on('_end-please_wait_', function () {
            // hide div block defined in begining of app_layout.html
            $rootScope.show_loading = false;
            $rootScope.show_loading_started = false;
        });

        //if _end-please_wait_ is not received for delayed interval, then show please wait message
        function delayShowingPleaseWait() {
            if ($rootScope.show_loading_started == true) {
                $rootScope.show_loading = true;
            }
        }

        $rootScope.$on('authenticationSuccess', function () {
            Principal.identity(true);
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            data: {
                specialClass: ""
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/app_layout.html'
                },
                'navbar@app': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'topnavbar@app': {
                    templateUrl: 'app/layouts/topnavbar/topnavbar.html',
                    controller: 'TopNavbarController',
                    controllerAs: 'vm'
                },
                'footer@app': {
                    templateUrl: 'app/layouts/footer/footer.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('seatonApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

/**
 * INSPINIA - Responsive Admin Theme
 * 2.6.2
 *
 * Custom scripts
 */

$(document).ready(function () {

    // Full height of sidebar
    function fix_height() {
        var heightWithoutNavbar = $("body > #wrapper").height() - 61;
        $(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

        var navbarHeigh = $('nav.navbar-default').height();
        var wrapperHeigh = $('#page-wrapper').height();

        if(navbarHeigh > wrapperHeigh){
            $('#page-wrapper').css("min-height", navbarHeigh + "px");
        }

        if(navbarHeigh < wrapperHeigh){
            $('#page-wrapper').css("min-height", $(window).height()  + "px");
        }

        if ($('body').hasClass('fixed-nav')) {
            if (navbarHeigh > wrapperHeigh) {
                $('#page-wrapper').css("min-height", navbarHeigh + "px");
            } else {
                $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
            }
        }

    }


    $(window).bind("load resize scroll", function() {
        if(!$("body").hasClass('body-small')) {
            fix_height();
        }
    });

    // Move right sidebar top after scroll
    $(window).scroll(function(){
        if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav') ) {
            $('#right-sidebar').addClass('sidebar-top');
        } else {
            $('#right-sidebar').removeClass('sidebar-top');
        }
    });


    setTimeout(function(){
        fix_height();
    })
});

// Minimalize menu when screen is less than 768px
$(function() {
    $(window).bind("load resize", function() {
        if ($(document).width() < 769) {
            $('body').addClass('body-small')
        } else {
            $('body').removeClass('body-small')
        }
    })
})

/**
 * INSPINIA - Responsive Admin Theme
 *
 * Comment branimir: $inject's are needed to add due to angular strict mode
 *
 */


/**
 * pageTitle - Directive for set Page title - mata title
 */
pageTitle.$inject = ['$rootScope', '$timeout'];
function pageTitle($rootScope, $timeout) {
    return {
        link: function (scope, element) {
            var listener = function (event, toState, toParams, fromState, fromParams) {
                // Default title - load on Dashboard 1
                var title = 'INSPINIA | Responsive Admin Theme';
                // Create your own title pattern
                if (toState.data && toState.data.pageTitle) title = 'INSPINIA | ' + toState.data.pageTitle;
                $timeout(function () {
                    element.text(title);
                });
            };
            $rootScope.$on('$stateChangeStart', listener);
        }
    }
}

/**
 * sideNavigation - Directive for run metsiMenu on sidebar navigation
 */
sideNavigation.$inject = ['$timeout'];
function sideNavigation($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element) {
            // Call the metsiMenu plugin and plug it to sidebar navigation
            $timeout(function () {
                element.metisMenu();
            });
        }
    };
}

/**
 * iboxTools - Directive for iBox tools elements in right corner of ibox
 */
iboxTools.$inject = ['$timeout'];
function iboxTools($timeout) {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'views/common/ibox_tools.html',
        controller: function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.find('div.ibox-content');
                content.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            },
                // Function for close ibox
                $scope.closebox = function () {
                    var ibox = $element.closest('div.ibox');
                    ibox.remove();
                }
        }
    };
}

/**
 * iboxTools with full screen - Directive for iBox tools elements in right corner of ibox with full screen option
 */
iboxToolsFullScreen.$inject = ['$timeout'];
function iboxToolsFullScreen($timeout) {
    return {
        restrict: 'A',
        scope: true,
        templateUrl: 'views/common/ibox_tools_full_screen.html',
        controller: function ($scope, $element) {
            // Function for collapse ibox
            $scope.showhide = function () {
                var ibox = $element.closest('div.ibox');
                var icon = $element.find('i:first');
                var content = ibox.find('div.ibox-content');
                content.slideToggle(200);
                // Toggle icon from up to down
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                ibox.toggleClass('').toggleClass('border-bottom');
                $timeout(function () {
                    ibox.resize();
                    ibox.find('[id^=map-]').resize();
                }, 50);
            };
            // Function for close ibox
            $scope.closebox = function () {
                var ibox = $element.closest('div.ibox');
                ibox.remove();
            };
            // Function for full screen
            $scope.fullscreen = function () {
                var ibox = $element.closest('div.ibox');
                var button = $element.find('i.fa-expand');
                $('body').toggleClass('fullscreen-ibox-mode');
                button.toggleClass('fa-expand').toggleClass('fa-compress');
                ibox.toggleClass('fullscreen');
                setTimeout(function () {
                    $(window).trigger('resize');
                }, 100);
            }
        }
    };
}

/**
 * minimalizaSidebar - Directive for minimalize sidebar
 */
minimalizaSidebar.$inject = ['$timeout'];
function minimalizaSidebar($timeout) {
    return {
        restrict: 'A',
        template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
        controller: minimalizaSidebarCtrlFunc
    };
}

minimalizaSidebarCtrlFunc.$inject = ['$scope', '$element'];
function minimalizaSidebarCtrlFunc($scope, $element) {
    $scope.minimalize = function () {
        $("body").toggleClass("mini-navbar");
        if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
            // Hide menu in order to smoothly turn on when maximize menu
            $('#side-menu').hide();
            // For smoothly turn on menu
            setTimeout(
                function () {
                    $('#side-menu').fadeIn(400);
                }, 200);
        } else if ($('body').hasClass('fixed-sidebar')) {
            $('#side-menu').hide();
            setTimeout(
                function () {
                    $('#side-menu').fadeIn(400);
                }, 100);
        } else {
            // Remove all inline style from jquery fadeIn function to reset menu state
            $('#side-menu').removeAttr('style');
        }
    }
}


/**
 *
 * Pass all functions into module
 */
angular
    .module('seatonApp')
    .directive('pageTitle', pageTitle)
    .directive('sideNavigation', sideNavigation)
    .directive('iboxTools', iboxTools)
    .directive('minimalizaSidebar', minimalizaSidebar)
    .directive('iboxToolsFullScreen', iboxToolsFullScreen);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            getAccountData: getAccountData
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function getAccountData() {
            return _identity;
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'ApplicationContext'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, ApplicationContext) {
        var service = {
            authorize: authorize,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            storePreviousState: storePreviousState,
            resetPreviousState: resetPreviousState
        };

        return service;

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && ($rootScope.toState.name === 'account.login' || $rootScope.toState.name === 'clover.access')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. store the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            $state.go("account.login");
                        });
                    }
                }
            }
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            ApplicationContext.logout();
            Principal.authenticate(null);
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/auth/admin', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/auth/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

'use strict';

angular.module('seatonApp')
    .factory('CloverResource',CloverResource );

CloverResource.$inject = ['$resource'];
function CloverResource($resource) {

        return $resource('api/clover/', {
        }, {
            'cloverTest': {method: 'GET', url: 'api/admin/test'},
            'healthCheck': {method: 'GET', url: 'api/v1/public/health-check'},
            'cloverAuthorization': {method: 'GET', url: 'api/auth/clover/web'},
            'cloverSync': {method: 'GET', url: '/api/auth/clover/web/sync'},
            'setResourceType': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/resource_type/:resourceType'}
        });

}


(function() {
    'use strict';

    angular
        .module('seatonApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('seatonApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('seatonApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('seatonApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'en-gb',
            'en-ie',
            'en-ca',
            'de',
            'it'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('seatonApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('seatonApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.endsWith('app-error') || header.endsWith('app-params')
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('seatonApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        //jshint validthis: true
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('seatonApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .provider('Notification', Notification);

    function Notification () {

        this.$get = getService;

        getService.$inject = ['toastr','$translate'];

        function getService (toastr, $translate) {

            return {
                success: success,
                error: error,
                info: info,
                warning : warning,
                infoLang: infoLang,
                showAlert: showAlert
            };

            function infoLang(messageKey, titleKey) {
                titleKey = titleKey || "global.messages.info.title";
                $translate([messageKey, titleKey]).then(function (translations) {
                    var messageText = translations[messageKey];
                    var titleText = translations[titleKey];
                    info(messageText, titleText);
                });

            }

            function info(body, title, config) {
                title = title || "Information";
                toastr.info(body, title, config);
            }

            function success(body, title, config) {
                title = title || "Action completed";
                toastr.success(body, title, config);
            }

            function warning(body, title, config) {
                title = title || "Warning";
                toastr.warning(body, title, config);
            }

            function error(body, title, config) {
                title = title || "Error occured.";
                toastr.error(body, title, config);
            }

            function showAlert(alertType, alertMessage) {
                switch (alertType) {
                    case 'success':
                        success(alertMessage);
                        break;
                    case 'error':
                        error(alertMessage);
                        break;
                    case 'warn':
                        warning(alertMessage);
                        break;
                    default:
                        info(alertMessage);
                        break;
                }
            }

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$rootScope', 'Notification'];

    function notificationInterceptor ($rootScope, Notification) {
        var service = {
            response: response
        };

        return service;

        function response (response) {

            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.endsWith('pp-alert') || header.endsWith('pp-alert-type')
            }).sort();

            var alertMessage = response.headers(headers[0]);
            if (angular.isString(alertMessage)) {
                var alertType = response.headers(headers[1]);
                if (angular.isString(alertType)) {
                    Notification.showAlert(alertType, alertMessage);
                }
            }

            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('loadingInterceptor', loadingInterceptor);

    loadingInterceptor.$inject = ['$q', '$rootScope', '$injector'];

    function loadingInterceptor ($q, $rootScope, $injector) {

        // reset please-wait div block, default message + hide div block
        complete();

        var $http;

        var service = {

            request: function ( config ) {
                $rootScope.$broadcast('_start-please_wait_');
                return config;
            },

            response: function ( response ) {
                // get $http via $injector because of circular dependency problem
                $http = $http || $injector.get( '$http' );
                if ( $http.pendingRequests.length < 1 ) {
                    complete();
                }
                return response;
            },

            responseError: function ( response ) {
                // get $http via $injector because of circular dependency problem
                $http = $http || $injector.get( '$http' );
                if ( $http.pendingRequests.length < 1 ) {
                    complete();
                }
                return $q.reject( response );
            }
        };

        return service;

        function complete() {
            // dispose please wait messgae and modl dialog, set loading message to default value
            $rootScope.$broadcast('_end-please_wait_');
            $rootScope.LoadingMessage = "Processing ...";
        }
    }

})();


(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$rootScope', '$q', '$injector', '$location', 'Notification'];

    function errorHandlerInterceptor ($rootScope, $q, $injector, $location, Notification) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {

            var Log = $injector.get('Log');
            switch(response.status) {
                case 0:
                    Log.error("errorhandler.interceptor","Server not reachable (err-code: 0). " + response.data);
                    showError("Server not reachable.", response.status, false);
                    break;
                case 400:
                    Log.error("errorhandler.interceptor","Bad request from server (err-code 400). " + response.data);
                    var headers = Object.keys(response.headers()).filter(function (header) {
                        return header.endsWith('app-alert') || header.endsWith('app-alert-type')
                    }).sort();
                    Log.debug("errorhandler.interceptor","Object.keys=" + Object.keys(response.headers()));

                    var alertMessage = response.headers(headers[0]);
                    if (angular.isString(alertMessage)) {
                        var alertType = response.headers(headers[1]);
                        if (angular.isString(alertType)) {
                            Notification.showAlert(alertType, alertMessage);
                        } else {
                            showError(response.data.description, response.status, true)
                        }
                    } else {
                        showError(response.data.description, response.status, true)
                    }
                    break;
                case 401:
                    // handled by auth-expired.interceptor.js
                    break;
                case 404:
                    Log.error("errorhandler.interceptor", "Page not found (err-code 404). " + response.data);
                    showError("Page not found. Msg:"+response.data.description, response.status, true);
                    break;
                case 408:
                    Log.error("errorhandler.interceptor", "Action timeout (err-code 408). Please try again later. " + response.data);
                    Notification.error("Timeout occur, please try later again.");
                    break;
                case 409:
                    // should be handled by individual controllers
                    Log.error("errorhandler.interceptor", "Conflict exception (err-code 409). ", response.data);
                    break;
                case 500:
                    Log.error("errorhandler.interceptor","Internal server error (err-code 500)." + response.data.description);
                    showError("Internal server error.", response.status, true);
                    break;
                default:
                    Log.error("errorhandler.interceptor", "Application error (err-code "+response.status+"). " + response.data);
                    showError("Application error. Msg:"+response.data, response.status, true);
                    break;
            }

            return $q.reject(response);

        }

        function showError(msg, code, contExec) {

            var page = $location.path().trim();
            if(page=="/account/clover" || page=="/account/login" || page=="/account/locations" || page=="/") {
                // cannot recover from exception if I'm on clover access screen or admin access screen or home page
                contExec=false;
                var Auth = $injector.get('Auth');
                Auth.logout();
            }

            var $state = $injector.get('$state');
            if(page.startsWith("/public")) {
                if(!page.startsWith("/public/online")) {
                    //show error page for public access
                    var params = {'errorMessage': msg};
                    $state.go("public.error", params);
                } else {
                    // leave to each public online page to handle exceptions
                }
            } else {
                // otherwise show general error page
                var params = { 'errorCode': code, 'errorMessage': msg, 'contExec': contExec};
                $state.go("account.error",params);
            }

        }

    }

})();

 (function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage', '$location'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage, $location) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            var page = $location.path().trim();
            console.log("Page is "+page+" status="+response.status);
            if (response.status === 401) {
                var Principal = $injector.get('Principal');
                var Auth = $injector.get('Auth');
                if (!isAdminEntryPage() && Principal.isAuthenticated()) {
                    console.log("Authenticate again with known credentials. ADMIN access.");
                    Auth.authorize(true);

                } else {
                    console.log("Auth interceptor: Not Authenticated.");
                    Auth.logout(); // to delete stored data in browser, if any

                    var params = { 'errorCode': response.status, 'errorMessage': response.data, 'contExec': true};
                    console.log("Params:"+params);

                    var $state = $injector.get('$state');
                    $state.go("account.error",params);

                }
            }
            return $q.reject(response);
        }

        function isAdminEntryPage(page) {
            return (page == "/account/login");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('merchantidInterceptor', merchantidInterceptor);

    merchantidInterceptor.$inject = ['$rootScope', '$q', 'ApplicationContext', 'Notification'];

    function merchantidInterceptor ($rootScope, $q, ApplicationContext, Notification) {
        var service = {
            request: request
        };

        return service;

        function request (config) {

            /* check if "_MERCHANTID_" code is part of url replace  "_MERCHANTID_" with merchant id value frm localStorage*/
            if(config.url.indexOf("_MERCHANTID_")>-1) {
                // console.log("_MERCHANTID_ string found");
                // url require merchantid, check if merchantid is defined in ApplicationContext
                if(ApplicationContext.getLocationID()==undefined) {
                    console.log("Merchantid not defined in ApplicationContext.");
                    //merchantid is not defined in ApplicationContext, stop request and show notification to merchant
                    var canceller = $q.defer();
                    config.timeout = canceller.promise;
                    Notification.error("Error 0x001. Please contact support with error description!","Internal Error");
                } else {
                    // console.log("Replacing _MERCHANTID_ string with merchantid value from ApplicationContext.");
                    // console.log("URL before replacement:"+config.url+":");
                    //merchantid is defined in ApplicationContext, replace "_MERCHANTID" string with value from ApplicationContext
                    config.url = config.url.replace("_MERCHANTID_",ApplicationContext.getLocationID());
                    // console.log("URL after replacement:"+config.url+":");
                }
            }

            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION', 'ApplicationContext', 'AuthServerProvider', 'Log'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
                          Auth, Principal, VERSION, ApplicationContext, AuthServerProvider, Log) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState, fromParams) {

                Log.debug("StateHandler", "State transition from state:" + fromState.name + ": to state:" + toState.name + ":");
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;
                $rootScope.fromStateParams = fromParams;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                // check if already on login screen and define backgound
                //var isGrayBg = toState.name === "account.login" || toState.name === "account.locations" ||
                //    toState.name === "account.clover" || toState.name === "account.error" || toState.name === "account.clover.logout";

                var isGrayBg = toState.name.startsWith("account") || toState.name.startsWith("public.");
                if (isGrayBg) {
                    if (toState.name.startsWith("public.online")) {
                        $rootScope.bodyClass = 'transparent-bg';
                    } else {
                        $rootScope.bodyClass = 'white-bg';
                    }
                    if (toState.name === "account.clover") {
                        // each time on clover login clear stored data in local storage if client didn't logout
                        // new token will be generated from server side on each access
                        Log.debug("StateHandler", "Clover access. Clear local storage.");
                        AuthServerProvider.logout();
                        ApplicationContext.clear();
                    }
                    return; // no need to redirect
                } else {
                    $rootScope.bodyClass = '';
                }

                if (toState.name === "account.error" || toState.name === "account.clover.logout") {
                    Log.debug("StateHandler", "Proceed to error/logout page");
                } else {

                    Principal.identity().then(function (account) {
                        if (!Principal.isAuthenticated() || !ApplicationContext.getLocation()) {
                            //if (!Principal.isAuthenticated()) {
                            event.preventDefault(); // stop current execution
                            Log.debug("StateHandler", "NotAuthenticated: Preventing transition from:" + fromState.name + ": to:" + toState.name
                                + ":. Preventing transition.");

                            $rootScope.bodyClass = 'white-bg';

                            var params = {'errorCode': 401, 'errorMessage': "Not authenticated.", 'contExec': true};
                            Log.debug("StateHandler", "Params:" + params);
                            $state.go("account.error", params);

                        } else {
                            if (fromState.name == '') {
                                //moment.tz.setDefault(ApplicationContext.getLocation().timezone);
                                ApplicationContext.setLanguageAndLocale();
                                Log.debug("StateHanlder", "Timezone set  on page reload to: " + ApplicationContext.getLocation().timezone);
                            }
                        }
                    });
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title';

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        //console.log("TRANSLATION CONFIG: lang:" + lang + " part:" + part + " locale" + locale);
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        //TODO check tmhDynamicLocaleProvider config
        //tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        $httpProvider.interceptors.push('merchantidInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        //custom interceptors
            // show please wiat/loading message on request, hide on last response
        $httpProvider.interceptors.push('loadingInterceptor');

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();


(function() {
    'use strict';

    angular.module('seatonApp')
        .constant('toastrConfig', {
            allowHtml: true,
            autoDismiss: false,
            closeButton: true,
            closeHtml: '<button>&times;</button>',
            containerId: 'toast-container',
            extendedTimeOut: 2000,
            iconClasses: {
                error: 'toast-error',
                info: 'toast-info',
                success: 'toast-success',
                warning: 'toast-warning'
            },
            maxOpened: 0,
            messageClass: 'toast-message',
            newestOnTop: true,
            onHidden: null,
            onShown: null,
            onTap: null,
            positionClass: 'toast-top-right',
            preventDuplicates: false,
            preventOpenDuplicates: false,
            progressBar: true,
            tapToDismiss: true,
            target: 'body',
            templates: {
                toast: 'directives/toast/toast.html',
                progressbar: 'directives/progressbar/progressbar.html'
            },
            timeOut: 5000,
            titleClass: 'toast-title',
            toastClass: 'toast',
            showEasing: 'swing',
            hideEasing: 'linear',
            showMethod: 'fadeIn',
            hideMethod: 'fadeOut'
        });
}());

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('Log', Log);

    Log.$inject = ['$rootScope', '$http','ApplicationContext'];

    function Log ($rootScope, $http, ApplicationContext) {

        var service = {
            debug: debug,
            info: info,
            warn: warn,
            error: error
        };

        return service;

        function debug(scriptName, message) {
            log(4, "DEBUG", scriptName, message);
        }

        function info(scriptName, message) {
            log(3, "INFO", scriptName, message);
        }

        function warn(scriptName, message) {
            log(2, "WARNING", scriptName, message);
        }

        function error(scriptName, message) {
            log(1, "ERROR", scriptName, message);
        }

        function log(severity, prepend, scriptName, message) {
            if($rootScope.severity==undefined) {
                $rootScope.severity = 1;
            }

            console.log(prepend+" -> "+scriptName+" : "+message);
            if(severity<=$rootScope.severity) {

                var data = {
                    severity: $rootScope.severity,
                    merchantId: ApplicationContext.getMerchantID(),
                    employeeId: ApplicationContext.getEmployeeID(),
                    message: scriptName + ":" + message
                };

                //console.log("Sending to server:"+data.severity+" message:"+data.message);
                //return $http.post('api/admin/log', data).success(logSuccess);

            }

            function logSuccess(data, status, headers) {
                $rootScope.severity = data.severity;
                console.log("Set LOG severity to "+$rootScope.severity);
            }

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('ApplicationContext', ApplicationContext);

    ApplicationContext.$inject = ['$rootScope', '$localStorage', '$translate', 'tmhDynamicLocale', '$locale'];

    function ApplicationContext($rootScope, $localStorage, $translate, tmhDynamicLocale, $locale) {

        var service = {
            storeLocation: storeLocation,
            storeAppContext: storeAppContext,
            getLocation: getLocation,
            hasLocation: hasLocation,
            getLocationID: getLocationID,
            hasLocationID: hasLocationID,
            getLocale: getLocale,
            hasLocale: hasLocale,
            getTimeZone: getTimeZone,
            hasTimeZone: hasTimeZone,
            getAuthType: getAuthType,
            getMerchantID: getMerchantID,
            getEmployeeID: getEmployeeID,
            getClientID: getClientID,
            clear: clear,
            logout: logout,
            setLanguageAndLocale: setLanguageAndLocale,
            getCurrencySym: getCurrencySym,
            storeWarnings: storeWarnings,
            isConfigNotCompleted: isConfigNotCompleted,
            isBusinessHoursNotDefined: isBusinessHoursNotDefined,
            getPhoneRegion: getPhoneRegion,
            getPhoneCountryPrefix: getPhoneCountryPrefix,
            setResourceType: setResourceType,
            getResourceType: getResourceType,
            setProductType: setProductType,
            getProductType: getProductType,
            isTableManaged: isTableManaged

        };

        return service;

        function storeLocation(location) {
            $localStorage.LocationID = location.id;
            $localStorage.Locale = location.locale;
            $localStorage.TimeZone = location.timezone;
            $localStorage.Location = location;
            $localStorage.ResourceType = location.managedResourceType;
            $localStorage.ProductType = location.productType;
            $rootScope.$broadcast("_LS_location_stored_");
        }

        function storeAppContext(authType, merchant_id, employee_id, client_id) {
            $localStorage.AuthType = authType;
            $localStorage.MerchantID = merchant_id;
            $localStorage.EmployeeID = employee_id;
            $localStorage.ClientID = client_id;
        }

        function setLanguageAndLocale() {

            if ($localStorage.TimeZone) {
                //if timezone is defined in localStorage then set it
                moment.tz.setDefault($localStorage.TimeZone);

                //REMOVE - for testing only!
                //$rootScope.isEU = true;

                var localeApp = $localStorage.Locale.toLowerCase();
                if (localeApp == 'en-us') {
                    localeApp = 'en';
                    $rootScope.currencyIcon = 'fa fa-dollar';
                } else if (localeApp == 'en-gb') {
                    $rootScope.currencyIcon = 'fa fa-gbp';
                    $rootScope.isEU = true;
                } else if (localeApp == 'en-ie') {
                    $rootScope.currencyIcon = 'fa fa-euro';
                    $rootScope.isEU = true;
                } else if (localeApp == 'en-ca') {
                    $rootScope.currencyIcon = 'fa fa-money';
                }

                moment.locale(localeApp);
                //TODO check $translate config
                //$translate.use(localeApp);
                tmhDynamicLocale.set(localeApp);
            } else {
                console.log("Unable to set Language And Locale - not defined!");
            }
        }

        function getCurrencySym() {
            return $locale.NUMBER_FORMATS.CURRENCY_SYM;
        }

        function getPhoneRegion() {
            var localePhone = 'US'; //default
            var localeApp = $localStorage.Locale.toLowerCase();
            if (localeApp == 'en-us') {
                localePhone = 'US';
            } else if (localeApp == 'en-gb') {
                localePhone = 'GB';
            } else if (localeApp == 'en-ie') {
                localePhone = 'IE';
            } else if (localeApp == 'en-ca') {
                localePhone = 'CA';
            }
            return localePhone;
        }

        function getPhoneCountryPrefix() {
            var localePhonePrefix = '+1'; //default
            var localeApp = $localStorage.Locale.toLowerCase();
            if (localeApp == 'en-us') {
                localePhonePrefix = '+1';
            } else if (localeApp == 'en-gb') {
                localePhonePrefix = '+44';
            } else if (localeApp == 'en-ie') {
                localePhonePrefix = '+353';
            } else if (localeApp == 'en-ca') {
                localePhonePrefix = '+1';
            }
            return localePhonePrefix;
        }

        function storeWarnings(configNotCompleted, businessHoursNotDefined) {
            $localStorage.configNotCompleted = configNotCompleted;
            $localStorage.businessHoursNotDefined = businessHoursNotDefined;
        }

        function getLocation() {
            return $localStorage.Location;
        }

        function hasLocation() {
            return angular.isDefined(getLocation());
        }

        //LocationID
        function getLocationID() {
            return $localStorage.LocationID;
        }

        function hasLocationID() {
            return angular.isDefined(getLocationID());
        }

        //Locale
        function getLocale() {
            return $localStorage.Locale;
        }

        function hasLocale() {
            return angular.isDefined(getLocale());
        }

        //ZimeZone
        function getTimeZone() {
            return $localStorage.TimeZone;
        }

        function hasTimeZone() {
            return angular.isDefined(getTimeZone());
        }

        // AuthType
        function getAuthType() {
            if ($localStorage.AuthType == undefined) {
                return "CLOVER";
            }
            return $localStorage.AuthType;
        }

        // MerchantID
        function getMerchantID() {
            return $localStorage.MerchantID;
        }

        // EmployeeID
        function getEmployeeID() {
            return $localStorage.EmployeeID;
        }

        // ClientID
        function getClientID() {
            return $localStorage.ClientID;
        }

        // configNotCompleted
        function isConfigNotCompleted() {
            return $localStorage.configNotCompleted;
        }

        // businessHoursNotDefined
        function isBusinessHoursNotDefined() {
            return $localStorage.businessHoursNotDefined;
        }

        function getResourceType() {
            return $localStorage.ResourceType;
        }

        function setResourceType(resourceType) {
            if (resourceType == 1 || resourceType == "TABLE") {
                $localStorage.ResourceType = "TABLE";
            } else {
                $localStorage.ResourceType = "OTHER";
            }
        }

        function getProductType() {
            return $localStorage.ProductType;
        }

        function setProductType(productType) {
            $localStorage.ProductType = productType;
        }

        function isTableManaged() {
            return (getResourceType() == 'TABLE');
        }


        function clear() {
            delete $localStorage.LocationID;
            delete $localStorage.Locale;
            delete $localStorage.TimeZone;
            delete $localStorage.Location;
            delete $localStorage.AuthType;
            delete $localStorage.MerchantID;
            delete $localStorage.EmployeeID;
            delete $localStorage.ClientID;
            delete $localStorage.configNotCompleted;
            delete $localStorage.businessHoursNotDefined;
            delete $localStorage.ResourceType;
            delete $localStorage.ProductType;

            $rootScope.$broadcast("_LS_location_deleted_");

        }

        function logout() {
            clear();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('ApplicationProfile', ApplicationProfile);

    ApplicationProfile.$inject = ['$window', 'ApplicationContext'];

    function ApplicationProfile($window, ApplicationContext) {

        var service = {
            openAppCloverPage : openAppCloverPage,
            countStrategy: countStrategy,
            exceedBehavior: exceedBehavior,
            limitType: limitType,
            getReservationLimit: getReservationLimit,
            getWaitlistLimit: getWaitlistLimit,
            getOnlineReservationLimit: getOnlineReservationLimit,
            isCustomerGrowthTrendEnabled: isCustomerGrowthTrendEnabled,
            isCustomerMemberTypeEnabled: isCustomerMemberTypeEnabled,
            isCustomerProfileSpendTrendEnabled: isCustomerProfileSpendTrendEnabled,
            isCustomerProfileAggregatedSpendTrendEnabled: isCustomerProfileAggregatedSpendTrendEnabled,
            isTablesTodayVsEnabled: isTablesTodayVsEnabled,
            isReportEmployeePerformanceEnabled: isReportEmployeePerformanceEnabled,
            isReportAggregatedRevenueEnabled: isReportAggregatedRevenueEnabled,
            isReportOccupancyRateEnabled: isReportOccupancyRateEnabled,
            isEmployeeWeeklyPerformanceEnabled: isEmployeeWeeklyPerformanceEnabled,
            isEmployeeMonthlyPerformanceEnabled: isEmployeeMonthlyPerformanceEnabled,
            isInternationalSmsEnabled: isInternationalSmsEnabled,
            isEventCreateCustomerStatsEnabled: isEventCreateCustomerStatsEnabled,
            isEventChangeHistoryEnabled: isEventChangeHistoryEnabled,
            isOnlineReservationEnabled: isOnlineReservationEnabled,
            isIVRReservationEnabled: isIVRReservationEnabled,
            getIVRReservationLimit: getIVRReservationLimit,
            upgradeTierText: upgradeTierText
        };

        return service;

        function openAppCloverPage() {
            var url = "https://www.clover.com/appmarket/apps/VW368JQ4FJ6SY?clientCountry=US";
            if(ApplicationContext.getLocale() != "en-US") {
                // TODO fix once EU market ready, GB for now to distinguish while testing
                url = "https://www.clover.com/appmarket/apps/VW368JQ4FJ6SY?clientCountry=GB";
            }
            var win = $window.open(url, '_blank');
            win.focus();
        }

        function isInternationalSmsEnabled() {
            var enabled = ApplicationContext.getLocation().profile.internationalSms;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isEventCreateCustomerStatsEnabled() {
            var enabled = ApplicationContext.getLocation().profile.eventCreateCustomerStatistic;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isEventChangeHistoryEnabled() {
            var enabled = ApplicationContext.getLocation().profile.eventDetailsChangeHistory;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isOnlineReservationEnabled() {
            var enabled = ApplicationContext.getLocation().profile.onlineReservation;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isIVRReservationEnabled() {
            var enabled = ApplicationContext.getLocation().profile.ivrReservation;
            if(enabled == undefined) return true;
            return enabled;
        }

        function countStrategy() {
            var countStrategy = ApplicationContext.getLocation().profile.limitation.countStrategy;
            if(countStrategy == undefined) return 'none';
            return countStrategy;
        }

        function exceedBehavior() {
            var exceedBehavior = ApplicationContext.getLocation().profile.limitation.exceedBehavior;
            if(exceedBehavior == undefined) return 'none';
            return exceedBehavior;
        }

        function limitType() {
            var limitType = ApplicationContext.getLocation().profile.limitation.limitType;
            if(limitType == undefined) return 'none';
            return limitType;
        }

        function getReservationLimit() {
            var limit = ApplicationContext.getLocation().profile.limitation.reservation;
            if(limit == undefined) return -1;
            return limit;
        }

        function getWaitlistLimit() {
            var limit = ApplicationContext.getLocation().profile.limitation.waitlist;
            if(limit == undefined) return -1;
            return limit;
        }

        function getOnlineReservationLimit() {
            var limit = ApplicationContext.getLocation().profile.limitation.onlineReservation;
            if(limit == undefined) return -1;
            return limit;
        }

        function getIVRReservationLimit() {
            var limit = ApplicationContext.getLocation().profile.limitation.ivrReservation;
            if(limit == undefined) return -1;
            return limit;
        }


        function isCustomerGrowthTrendEnabled() {
            var enabled = ApplicationContext.getLocation().profile.customer.dashboardGrowthTrend;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isCustomerMemberTypeEnabled() {
            var enabled = ApplicationContext.getLocation().profile.customer.dashboardMemberTypeStatistics;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isCustomerProfileSpendTrendEnabled() {
            var enabled = ApplicationContext.getLocation().profile.customer.profileSpendTrend;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isCustomerProfileAggregatedSpendTrendEnabled() {
            var enabled = ApplicationContext.getLocation().profile.customer.profileAggregatedSpendTrend;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isTablesTodayVsEnabled() {
            var enabled = ApplicationContext.getLocation().profile.tables.dashboardTodayVs;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isReportEmployeePerformanceEnabled() {
            var enabled = ApplicationContext.getLocation().profile.reports.employeePerformance;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isReportAggregatedRevenueEnabled() {
            var enabled = ApplicationContext.getLocation().profile.reports.aggregatedRevenue;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isReportOccupancyRateEnabled() {
            var enabled = ApplicationContext.getLocation().profile.reports.occupancy;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isEmployeeWeeklyPerformanceEnabled() {
            var enabled = ApplicationContext.getLocation().profile.settings.employeeWeeklyPerformance;
            if(enabled == undefined) return true;
            return enabled;
        }

        function isEmployeeMonthlyPerformanceEnabled() {
            var enabled = ApplicationContext.getLocation().profile.settings.employeeMonthlyPerformance;
            if(enabled == undefined) return true;
            return enabled;
        }


        function upgradeTierText(name) {

            var text = "Upgrade to ";

            switch(name) {
                case "CustomerMembershipTypeStatistic": text = text + "PROFESSIONAL"; break;
                case "CustomerGrowthTrend": text = text + "PAY AS YOU GO, STANDARD or PROFESSIONAL"; break;
                case "TablesTodayVs": text = text + "PAY AS YOU GO, STANDARD or PROFESSIONAL"; break;
                case "ReportEmployeePerformance": text = text + "PAY AS YOU GO, STANDARD or PROFESSIONAL"; break;
                case "ReportAggregatedRevenue": text = text + "PROFESSIONAL"; break;
                case "ReportOccupancyRate": text = text + "PROFESSIONAL"; break;
                case "EmployeeWeeklyPerformance": text = text + "PAY AS YOU GO, STANDARD or PROFESSIONAL"; break;
                case "EmployeeMonthlyPerformance": text = text + "PROFESSIONAL"; break;
                case "CreateReservation": return "Upgrade subscription to activate this functionality."; break;
                case "EventChangeHistory": return "Upgrade subscription to activate this functionality."; break;
                case "ProfileSpendTrend": text = text + "PAY AS YOU GO, STANDARD or PROFESSIONAL"; break;
                case "ProfileAggregatedSpendTrend": text = text + "PROFESSIONAL"; break;
                case "IVRReservation": text = text + "STANDARD or PROFESSIONAL"; break;
            }

            text = text + " tier(s) to activate this functionality.";
            return text;

        }

    }
})();

'use strict';

angular.module('seatonApp')
    .directive('level', function () {
        return {
            restrict: 'EA',
            scope: {
                'value': '=',
                'display': '@',
                'invert': '@'
            },
            transclude: true,
            template: '<span style="white-space: nowrap"><span ng-if="value>0"><span class="{{colorLevelUp}}"><i ng-if="display == \'left\'" class="fa fa-level-up"></i><ng-transclude></ng-transclude><i ng-if="display == \'right\'" class="fa fa-level-up"></i></span></span>' +
            '<span ng-if="value==0"><span class="{{colorEqual}}"><ng-transclude></ng-transclude></span></span>' +
            '<span ng-if="value<0"><span class="{{colorLevelDown}}"><i ng-if="display == \'left\'" class="fa fa-level-down"></i><ng-transclude></ng-transclude><i ng-if="display == \'right\'" class="fa fa-level-down"></i></span></span></span>',
            controller: levelCtrl
        };
    });

levelCtrl.$inject = ['$scope'];
function levelCtrl($scope) {
    $scope.colorEqual = 'text-success';
    $scope.colorLevelUp = 'text-navy';
    $scope.colorLevelDown = 'text-danger';
    if ($scope.invert == 'true') {
        $scope.colorLevelUp = 'text-danger';
        $scope.colorLevelDown = 'text-navy';
    }
};

angular.module('seatonApp').directive('levelPct', ['Reporting', function (Reporting) {
    return {
        restrict: 'EA',
        scope: {
            'val1': '=',
            'val2': '=',
            'display': '@',
            'desc': '@',
            'desc1': '@',
            'desc2': '@',
            'invert': '@'
        },
        transclude: true,
        template: '<span style="white-space: nowrap" uib-tooltip="{{ desc }} ({{ desc1 }}: {{ val1 | number: 2 }} ; {{ desc2 }}: {{ val2 | number: 2 }}).">' +
        '<span ng-if="val1>val2"><span class="{{colorLevelUp}}"><i ng-if="display == \'left\'" class="fa fa-level-up"></i>{{calcPct(val1, val2) | percentage:2}}<ng-transclude></ng-transclude><i ng-if="display != \'left\'" class="fa fa-level-up"></i></span></span>' +
        '<span ng-if="val1==val2"><span class="{{colorEqual}}">{{ 0 | percentage:2}}<ng-transclude></ng-transclude></span></span>' +
        '<span ng-if="val1<val2"><span class="{{colorLevelDown}}"><i ng-if="display == \'left\'" class="fa fa-level-down"></i>{{calcPct(val1, val2) | percentage:2}}<ng-transclude></ng-transclude><i ng-if="display != \'left\'" class="fa fa-level-down"></i></span></span></span>',
        controller: levelPctCtrl
    };

}]);

levelPctCtrl.$inject = ['$scope', 'Reporting'];
function levelPctCtrl($scope, Reporting) {
    //console.log('val1:' + $scope.val1 + '  val2:' + $scope.val2);
    //console.log($scope);
    $scope.calcPct = Reporting.calcPct;
    $scope.colorEqual = 'text-success';
    $scope.colorLevelUp = 'text-navy';
    $scope.colorLevelDown = 'text-danger';
    if ($scope.invert == 'true') {
        $scope.colorLevelUp = 'text-danger';
        $scope.colorLevelDown = 'text-navy';
    }
};

'use strict';

angular.module('seatonApp').directive('includePieChart', ['Reporting', function (Reporting) {
    return {
        restrict: 'EA',
        scope: {
            'piechartdata': '=',

        },
        transclude: true,
        template: '<div ng-show="showChart" google-chart chart="piechartdata" style="width: 95%"></div>' +
        '<div ng-show="!showChart">' +
        '<div class="row">' +
        '<div class="col-lg-10 col-lg-offset-2"><br><br>' +
        '<span class="text-info font-bold">{{piechartdata.options.title}}</span>' +
        '</div>' +
        '</div>' +
        '<div class="row">' +
        '<div class="col-lg-11 text-center">' +
        '<img  src="content\\images\\NoDataPieChart.png">' +
        '</div>' +
        '</div>' +
        '</div>',
        controller: includePieChartCtrl
    };

}]);

includePieChartCtrl.$inject = ['$scope', 'Reporting'];
function includePieChartCtrl($scope, Reporting) {
    //console.log($scope.piechartdata);
    //console.log('piechartdata:' + $scope.piechartdata);
    if ($scope.piechartdata != null && typeof $scope.piechartdata != 'undefined') {
        $scope.showChart = !Reporting.allZeroesInPieChartData($scope.piechartdata.data.rows);
    } else {
        $scope.showChart = false;
    }
};

'use strict';

angular.module('seatonApp')
    .directive('ngIncludeTemplate', function () {
        return {
            templateUrl: function (elem, attrs) {
                return attrs.ngIncludeTemplate;
            },
            restrict: 'A',
            scope: {
                'ngIncludeVariables': '&'
            },
            link: function (scope, elem, attrs) {
                var key, results, value, vars;
                vars = scope.ngIncludeVariables();
                results = [];
                for (key in vars) {
                    value = vars[key];
                    results.push(scope[key] = value);
                }
                return results;
            }
        };
    });

/**
 * Created by branimir on 18.12.2016..
 */
(function () {
    'use strict';
    angular.module('seatonApp')
        .filter('percentage', ['$filter', function ($filter) {
            return function (input, decimals) {
                return $filter('number')(input * 100, decimals) + '%';
            };
        }]);
})();


(function () {
    'use strict';
    angular.module('seatonApp')
        .directive('elemReady', function ($parse) {
            return {
                restrict: 'A',
                link: function ($scope, elem, attrs) {
                    elem.ready(function () {
                        $scope.$apply(function () {
                            var func = $parse(attrs.elemReady);
                            func($scope);
                        })
                    })
                }
            }
        })
})();


/**
 * Created by branimir on 20.5.2017..
 */
(function () {
    'use strict';
    angular.module('seatonApp')
        .filter('highlight', function () {
            return function (text, phrase, style) {
                //console.log('highlight ' + text + phrase + style);
                return phrase
                    ? text.replace(new RegExp('(' + phrase + ')', 'gi'), '<span class=' + style + '>$1</span>')
                    : text;
            };
        });
})();



(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('TextUtil', TextUtil);

    TextUtil.$inject = ['ApplicationContext'];

    function TextUtil (ApplicationContext) {

        var service = {
            translate : translate
        };

        return service;


        function translate(text, type) {
            var resourceType = ApplicationContext.getResourceType();
            switch(text) {
                case 'resource': return translateResourceText(resourceType, type);
                case 'capacity': return translateCapacityText(resourceType, type);
                case 'person': return translatePersonText(resourceType, type);
                case 'category': return translateCategoryText(resourceType, type);
                case undefined: return '';
            }
        }

        function translateResourceText(resourceType, type) {
            if (resourceType == 'TABLE') {
                //console.log("type="+type);
                switch (type) {
                    case 's':
                        return "table";
                    case 'sc':
                        return "Table";
                    case 'p':
                        return "tables";
                    case 'pc':
                        return "Tables";
                    case undefined:
                        return "table(s)";
                    case "":
                        return "table(s)";
                    case 'c':
                        return "Table(s)";
                    case 'SC':
                        return "TABLE";
                }
            } else {
                switch (type) {
                    case 's':
                        return "resource";
                    case 'sc':
                        return "Resource";
                    case 'p':
                        return "resources";
                    case 'pc':
                        return "Resources";
                    case '':
                        return "resource(s)";
                    case undefined:
                        return "resource(s)";
                    case 'c':
                        return "Resource(s)";
                    case 'SC':
                        return "RESOURCE";
                }
            }
        }

        function translatePersonText(resourceType, type) {
            if (resourceType == 'TABLE') {
                switch (type) {
                    case 's':
                        return "cover";
                    case 'sc':
                        return "Cover";
                    case 'p':
                        return "covers";
                    case 'pc':
                        return "Covers";
                    case undefined:
                        return "cover(s)";
                    case "":
                        return "cover(s)";
                    case 'c':
                        return "Cover(s)";
                    case 'SC':
                        return "COVER";

                }
            } else {
                switch (type) {
                    case 's':
                        return "person";
                    case 'sc':
                        return "Person";
                    case 'p':
                        return "persons";
                    case 'pc':
                        return "Persons";
                    case '':
                        return "person(s)";
                    case 'c':
                        return "Person(s)";
                    case undefined:
                        return "person(s)";
                    case 'SC':
                        return "PERSON";

                }
            }
        }

        function translateCategoryText(resourceType, type) {
            if (resourceType == 'TABLE') {
                switch (type) {
                    case 's':
                        return "area";
                    case 'sc':
                        return "Area";
                    case 'p':
                        return "areas";
                    case 'pc':
                        return "Areas";
                    case undefined:
                        return "area(s)";
                    case "":
                        return "area(s)";
                    case 'c':
                        return "Area(s)";
                }
            } else {
                switch (type) {
                    case 's':
                        return "category";
                    case 'sc':
                        return "Category";
                    case 'p':
                        return "categories";
                    case 'pc':
                        return "Categories";
                    case '':
                        return "category(ies)";
                    case undefined:
                        return "category(ies)";
                    case 'c':
                        return "Category(ies)";
                }
            }
        }


        function translateCapacityText(resourceType, type) {
            if (resourceType == 'TABLE') {
                switch (type) {
                    case 's':
                        return "seat";
                    case 'sc':
                        return "Seat";
                    case 'p':
                        return "seats";
                    case 'pc':
                        return "Seats";
                    case undefined:
                        return "seat(s)";
                    case "":
                        return "seat(s)";
                    case 'c':
                        return "Seat(s)";
                    case 'n':
                        return "seated";
                    case 'SC':
                        return "SEAT";
                }
            } else {
                if (type == 'c' || type == 'sc' || type == 'pc') {
                    return "Capacity";
                } else if( type == 'SC') {
                    return "CAPACITY";
                } else if(type == 'n') {
                    return "accommodated";
                } else {
                    return "capacity";
                }
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .directive('stran', stran);

    function stran() {
        var directive = {
            restrict: 'EA',
            scope: {
                'stext': '@',
                'type': '@'
            },
            transclude: true,
            controller: TranslateNameController,
            template: ' {{translatedText}}'
        };

        return directive;
    }

    TranslateNameController.$inject = ['$scope', 'TextUtil'];

    function TranslateNameController($scope, TextUtil) {

        $scope.translatedText = TextUtil.translate($scope.stext, $scope.type);

    }


})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'ApplicationContext'];

    function NavbarController($state, Auth, Principal, ProfileService, ApplicationContext) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.isTableManaged = (ApplicationContext.getResourceType() == 'TABLE');
        vm.isProduction = (window.location.href.indexOf("//getseat.net") != -1) || (window.location.href.indexOf("//eu.getseat.net") != -1);

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }


        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            $state.go("account.login");
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('account.login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
        'use strict';

        angular
            .module('seatonApp')
            .controller('TopNavbarController', TopNavbarController);

        TopNavbarController.$inject = ['$state', '$scope', '$window', 'Auth', 'Principal', 'ApplicationContext', 'SweetAlert', 'HelpPagesMapping'];

        function TopNavbarController($state, $scope, $window, Auth, Principal, ApplicationContext, SweetAlert, HelpPagesMapping) {
            var vm = this;
            vm.isAuthenticated = Principal.isAuthenticated;
            vm.HelpPagesMapping = HelpPagesMapping;
            vm.showHelp = HelpPagesMapping.showHelp;
            vm.showHelpButton = false;
            vm.keyword = null;

            vm.$state = $state;

            vm.hashedLocationId = ApplicationContext.getLocation().hashedLocationId;
            //console.log('vm.$state: ' + vm.$state.current.name);

            $(window).scroll(function (event) {
                var pageYOffset = $window.pageYOffset;
                var oldState = vm.showHelpButton;
                //console.log(pageYOffset);
                if (pageYOffset > 7 || pageYOffset == undefined) {
                    vm.showHelpButton = true;
                } else {
                    vm.showHelpButton = false;
                }
                if (oldState !== vm.showHelpButton) {
                    //console.log('$scope.$apply()');
                    $scope.$apply();
                }
            });

            vm.logout = logout;
            vm.toggleNavbar = toggleNavbar;
            vm.collapseNavbar = collapseNavbar;

            vm.searchEvent = function() {
                $state.go("tables.search", {keyword: vm.keyword});
            }

            function logout() {
                var authType = ApplicationContext.getAuthType();

                collapseNavbar();
                Auth.logout();

                if (authType == "ADMIN") {
                    console.log("Logout. Open admin login screen.");
                    $state.go('account.login');
                } else {
                    console.log("Logout. Clover logout screen.");
                    $state.go('account.clover.logout');
                }
            }

            function toggleNavbar() {
                vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
            }

            function collapseNavbar() {
                vm.isNavbarCollapsed = true;
            }

        }
    }
)
();

'use strict';

angular.module('seatonApp')
    .factory('CustomerSearch', customerSearch)
    .factory('CustomerResource', customerResource)
    .factory('CalcCustomerStats', calcCustomerStats)
    .factory('CustomerStats', ['CalcCustomerStats', customerStats]);

customerResource.$inject = ['$resource', 'ApplicationContext'];
function customerResource($resource, ApplicationContext) {
    return $resource('api/v1/merchants/_MERCHANTID_/customers/:id', {
        //merchantId: ApplicationContext.getLocationID()
    }, {
        'lists': {
            method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/customers/lists',
            isArray: true
        },
        'get': {
            method: 'GET',
            transformResponse: function (data) {
                data = angular.fromJson(data);
                return data;
            }
        },
        'updateCustomer': { method:'PUT', url: 'api/v1/merchants/_MERCHANTID_/customers/update' },
        'updateAttribute': { method:'GET', url: 'api/v1/merchants/_MERCHANTID_/customers/updateAttribute/:id' },
        'getProfile': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/customers/:id/statistics/profileVisitStats'},
        'getSpendTrend': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/customers/:id/statistics/spendTrend'},
        'getAggregateByHourData': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/customers/:id/statistics/aggregateSpendByHour'
        },
        'getAggregateByWeekdayData': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/customers/:id/statistics/aggregateSpendByWeekday'
        },
        'getDashboardGeneralData': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/customers/statistics/dashboard/general'
        },
        'getDashboardGrowthTrendData': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/customers/statistics/dashboard/growthTrend'
        },
        'getDashboardMemberTypeData': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/customers/statistics/dashboard/memberType'
        },
        'numberOfCustomers': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/customers/statistics/numberOfCustomers'
        }
    });
}

customerSearch.$inject = ['$resource'];
function customerSearch($resource) {

    return $resource('api/v1/merchants/_MERCHANTID_/customers/', {}, {
        'searchCustomers': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/customers/search?keyword=:keyword&page=:page&size=:size',
            isArray: false
        }
    });
}

function calcCustomerStats() {
    function calculateCustomerPcts(customer) {
        var totalEvents = customer.totalReservation + customer.totalWaitlist + customer.totalWalkinSeated;
        if (totalEvents > 0) {
            customer.reservationsPct = customer.totalReservation / totalEvents;
            customer.noShowPct = customer.totalNoShow / totalEvents;
            customer.canceledPct = customer.totalCanceled / totalEvents;
            customer.walkinSeatedPct = customer.totalWalkinSeated / totalEvents;
            customer.waitlistPct = customer.totalWaitlist / totalEvents;
        } else {
            customer.reservationsPct = customer.noShowPct = customer.canceledPct = customer.walkinSeatedPct = customer.waitlistPct = 0;
        }

        return customer;
    }

    return {
        calculateCustomerPcts: calculateCustomerPcts
    };
}

function customerStats(CalcCustomerStats) {
    function calculatePcts(customers) {
        return _.map(customers, CalcCustomerStats.calculateCustomerPcts);
    }

    return {
        calculatePcts: calculatePcts
    };
}

'use strict';

angular.module('seatonApp')
    .factory('EmployeeResource', employeeResource)
    .service('EmployeeService', employeeService);

employeeResource.$inject = ['$resource', 'ApplicationContext'];

function employeeResource($resource, ApplicationContext) {
    return $resource('api/v1/merchants/_MERCHANTID_/employees/:id', {
        merchantId: ApplicationContext.getLocationID()
    }, {
        'getEmployeeWithStats': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/employees/:id/statistics/employeeWithStats'
        },
        'weeklyPerformance': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/employees/:id/statistics/weeklyPerformance'
        },
        'monthlyPerformance': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/employees/:id/statistics/monthlyPerformance'
        },
        'sinceLastLogin': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/employees/:id/statistics/sinceLastLogin'
        },
        'getAllEmployees': {
            method: 'GET',
            url: 'api/v1/merchants/_MERCHANTID_/employees/getAllEmployees',
            isArray: true
        },
        'updateAttribute': {
            method: 'POST',
            url: 'api/v1/merchants/_MERCHANTID_/employees/:id/updateAttribute?attribute=:attribute&value=:value',
            params: {attribute: '@attribute', id: '@id', value: '@value'}
        }

    });
}

function employeeService() {

    function _toNumberOrZero(number) {
        if (_.isNumber(number)) {
            return number;
        } else {
            return 0;
        }
    }

    function _avgRevenuePerCover(employee) {
        var avg = 0.00;
        var totalCustomerRevenue = _toNumberOrZero(employee.totalCustomerRevenue);
        var totalUnknownCustomerCover = _toNumberOrZero(employee.totalUnknownCustomerCover);
        var totalReservationCover = _toNumberOrZero(employee.totalReservationCover);
        var totalWaitlistCover = _toNumberOrZero(employee.totalWaitlistCover);
        var totalWalkInSeatedCover = _toNumberOrZero(employee.totalWalkinSeatedCover);
        var totalCovers = (totalReservationCover + totalWaitlistCover + totalWalkInSeatedCover);
        if (totalCovers > 0 && totalCustomerRevenue >= 0) {
            avg = employee.totalCustomerRevenue / totalCovers;
        }
        return avg;
    }

    function _avgTipPerCover(employee) {
        var avg = 0.0;
        var totalTips = _toNumberOrZero(employee.totalTips);
        var totalVisitsWithTip = _toNumberOrZero(employee.totalVisitsWithTip);
        var totalReservationCover = _toNumberOrZero(employee.totalReservationCover);
        var totalWaitlistCover = _toNumberOrZero(employee.totalWaitlistCover);
        var totalWalkInSeatedCover = _toNumberOrZero(employee.totalWalkinSeatedCover);
        var totalCovers = (totalReservationCover + totalWaitlistCover + totalWalkInSeatedCover);
        if (totalCovers > 0) {
            avg = totalTips / totalCovers;
        }
        return avg;
    }

    function _rating(employee) {
        if (_.isUndefined(employee.totalRatedVisits) || employee.totalRatedVisits <= 0) {
            return 0;
        } else {
            return employee.totalRatedPoints / employee.totalRatedVisits;
        }
    }

    function _avgTipPercentage(employee) {
        var avg = 0;
        var avgTipPerCover = _avgTipPerCover(employee);
        var avgRevenuePerCover = _avgRevenuePerCover(employee);
        if (avgRevenuePerCover > 0) {
            avg = 100 * (avgTipPerCover / avgRevenuePerCover);
        }
        return avg;
    }

    function _totalNoShows(employee) {
        var total = 0;
        total += _toNumberOrZero(employee.totalReservationNoShow);
        total += _toNumberOrZero(employee.totalWaitlistNoShow);
        return total;
    }

    function _noShowRate(employee) {
        var rate = 0;
        var totalNoShows = _totalNoShows(employee);

        var totalReservationAndWaitlist = 0;

        //CALCULATING noShowPct same as in reports!!
        //totalReservationAndWaitlist += employee.totalReservationShow + employee.totalReservationNoShow + employee.totalReservationCanceled;
        //totalReservationAndWaitlist += employee.totalWaitlistShow + employee.totalWaitlistNoShow + employee.totalWaitlistCanceled;
        totalReservationAndWaitlist += employee.totalReservationShow + employee.totalReservationNoShow ;
        totalReservationAndWaitlist += employee.totalWaitlistShow + employee.totalWaitlistNoShow ;

        if (totalReservationAndWaitlist > 0) {
            rate =  (totalNoShows / totalReservationAndWaitlist);
        }
        return rate;
    }

    function getLocationById(locations, id) {

        if (typeof locations.id !== 'undefined') {
            return locations;
        }

        return _.find(locations, function (location) {
            return location.id === id;
        });
    }

    function enrichEmployee(employee, locations) {
        if (locations) {
            employee.location = getLocationById(locations, employee.locationId);
        }
        //employee.role = _.chain(employee.authorities).pluck('name').find(function (name) {
        //    return !_.isUndefined(name);
        //}).value();
        //employee.name = employee.firstName + ' ' + employee.lastName;
        employee.rating = _rating(employee);
        employee.avgRevenuePerCover = _avgRevenuePerCover(employee);
        employee.avgTipPerCover = _avgTipPerCover(employee);

        employee.avgTipPercentage = _avgTipPercentage(employee);
        employee.noShowRate = _noShowRate(employee);
        employee.totalNoShows = _totalNoShows(employee);
        return employee;
    }

    return {
        enrichEmployee: enrichEmployee
    };
}


'use strict';

(function () {
    var module = angular.module('seatonApp');

    module.factory('EventResource', eventResource);

    eventResource.$inject = ['$resource', 'ApplicationContext'];
    function eventResource($resource, ApplicationContext) {
        return $resource('api/v1/merchants/_MERCHANTID_/events/:id', {}, {
            'get': { //TBD implement server side
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }, 'getHomeDashboardTodayData': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events/statistics/home/today',
                isArray: false
            }, 'getHomeWeekStats': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events/statistics/home/weekStats',
                isArray: false
            }, 'getHomeDashboardTodayVsData': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events/statistics/home/compareToday',
                isArray: false
            }, 'getEventsDashboardTodayData': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events/statistics/dashboard/today',
                isArray: false
            }, 'getEventsDashboardTodayVsData': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events/statistics/dashboard/compareToday',
                isArray: false
            }, 'getEventsOverview': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events/statistics/overview/reservations',
                isArray: false
            }, 'getEmployeeLastActivity': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/employees/history',  //TODO move to employe.service.js
                isArray: true
            }, 'overview': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events/overview',
                isArray: true
            }
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('Reporting', Reporting);

    Reporting.$inject = ['$filter'];

    function Reporting($filter) {
        function setSpendTrendChartData(chartObj, chartData) {
            var max = _.max(chartData, function (o) {
                return o.sumTotal;
            });
            var z = max.sumTotal == 0 ? 0 : 0.01;

            _.each(chartData, function (item) {
                var sumReservation = item.sumReservation == 0 ? z : item.sumReservation;
                var sumSeated = item.sumSeated == 0 ? z : item.sumSeated;
                var sumWaitlist = item.sumWaitlist == 0 ? z : item.sumWaitlist;

                chartObj.addRow([item.intervalUnit,
                    {
                        v: sumReservation,
                        f: $filter('currency')(sumReservation)
                    },
                    {
                        v: sumSeated,
                        f: $filter('currency')(sumSeated)
                    },
                    {
                        v: sumWaitlist,
                        f: $filter('currency')(sumWaitlist)
                    },
                    $filter('currency')(item.sumTotal)]);
            });
        }

        function calcPct(a, b) {
            if (b == 0)
                return a == 0 ? 0 : 1;
            else
                return (a - b) / b;
        }

        function divide(a, b) {
            if (b == 0)
                return a == 0 ? 0 : 1;
            else
                return a / b;
        }

        function calcAggrByWeekdayDataItem(day_data, locationStats) {
            if (typeof day_data === 'undefined') return day_data;
            //calculate percentage vs general location stats
            day_data.calcAmountAvgPerCoverPct = calcPct(day_data.amountAvgPerCover, locationStats.avgSpendByCover);
            day_data.calcTipAvgPct = calcPct(day_data.tipAvg, locationStats.avgTipPerVisit);
            day_data.calcCoversPerVisitPct = calcPct(day_data.coversPerVisit, locationStats.avgCoversPerVisit);
            return day_data;
        }

        function allZeroesInPieChartData(pieChartRows) {

            for (var i = 0; i < pieChartRows.length; i++) {
                //console.log('i:'+i+ ' pieChartRows[i].c[1].v: '+pieChartRows[i].c[1].v);
                if (pieChartRows[i].c[1].v != 0) return false;
            }
            return true;
        }

        return {
            setSpendTrendChartData: setSpendTrendChartData,
            calcPct: calcPct,
            divide: divide,
            calcAggrByWeekdayDataItem: calcAggrByWeekdayDataItem,
            allZeroesInPieChartData: allZeroesInPieChartData
        };
    }
})();





'use strict';

angular.module('seatonApp')
    .factory('Statistics',statisticsResource );

statisticsResource.$inject = ['$resource', 'ApplicationContext'];
function statisticsResource($resource, ApplicationContext) {

        return $resource('api/v1/merchants/_MERCHANTID_/reports', {
            //merchantId: ApplicationContext.getLocationID()
        }, {
            'getLocationRegularsStats': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/reports/customerLocationStats', isArray: false},
            'getCustomerLocationAllVisitsStats': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/reports/customerLocationAllVisitsStats'},
            'getReportingRevenueTrend': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/reports/revenueTrend'},
            'getReportingRevenueTrendLastMonth': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/reports/revenueTrendLastMonth'},
            'getReportingRevenueTrendMonthDetails': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/reports/revenueTrendMonthDetails'},
            'getReportingRevenueTrendDayDetails': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/reports/revenueTrendDayDetails'},
            'getReportingEmployeesPerformance': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/reports/employeePerformance'},
            'getReportingOccupancy': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/reports/occupancy'},
            'getReportingOccupancyByHour': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/reports/occupancyByHour'},
            'getReportingExpectedOccupancyByHour': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/reports/expectedOccupancyByHour'}
        });

}


'use strict';

angular.module('seatonApp')
    .factory('LocationResource', locationResource);

locationResource.$inject = ['$resource', 'ApplicationContext'];

function locationResource($resource, ApplicationContext) {
    return $resource('api/v1/merchants/_MERCHANTID_', {},
        {
            'getLocation': {
                method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/getLocation', isArray: false
            },
            'getLocationSettings': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/getLocationSettings'},
            'requestIVR': {method: 'POST', url: 'api/v1/merchants/_MERCHANTID_/requestIVR'},
            'activateIvrPhone': {method: 'POST', url: 'api/v1/merchants/_MERCHANTID_/activateIvrPhone'},
            'changeHome': {method: 'POST', url: 'api/v1/merchants/_MERCHANTID_/changeHome'}
        });
}


'use strict';

angular.module('seatonApp')
    .factory('FeedbackResource', feedbackResource);

feedbackResource.$inject = ['$resource', 'ApplicationContext'];
function feedbackResource($resource, ApplicationContext) {
    return $resource('api/v1/merchants/_MERCHANTID_/feedbacks', {},
        {
            'getLastFeedbacks': {
                method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/feedbacks/getLastFeedbacks', isArray: true
            },
            'searchFeedbacks': {
                method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/feedbacks/searchFeedbacks', isArray: false
            }
        });
}


'use strict';

angular.module('seatonApp')
    .factory('SettingsResource',settingsResource );

settingsResource.$inject = ['$resource', 'ApplicationContext'];
function settingsResource($resource, ApplicationContext) {

        return $resource('api/v1/merchants/_MERCHANTID_/areas', {}, {

            'getAreasAndTables': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/areas', isArray: true},
            'getAreas': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/areas_without_resources', isArray: true},

            'createArea': {method: 'POST', url: 'api/v1/merchants/_MERCHANTID_/settings/areas'},
            'updateArea': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/areas'},
            'deleteArea': {method: 'DELETE', url: 'api/v1/merchants/_MERCHANTID_/settings/areas/:id'},

            'createTable': {method: 'POST', url: 'api/v1/merchants/_MERCHANTID_/settings/resources'},
            'updateTable': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/resources'},
            'deleteTable': {method: 'DELETE', url: 'api/v1/merchants/_MERCHANTID_/settings/resources/:id'},

            'saveGeneralSettings': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/general'},
            'getGeneralSettings': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/general'},
            'getLocationData': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/general/location'},

            'getWorkTimeSettings': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/worktime'},
            'addBusinessHours': {method: 'POST', url: 'api/v1/merchants/_MERCHANTID_/settings/worktime/business_hours'},
            'deleteBusinessHours': {method: 'DELETE', url: 'api/v1/merchants/_MERCHANTID_/settings/worktime/business_hours/:id'},
            'syncWithClover': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/worktime/sync/:syncClover'},
            'addNonWorkingDay': {method: 'POST', url: 'api/v1/merchants/_MERCHANTID_/settings/worktime/non_working_day'},
            'deleteNonWorkingDay': {method: 'DELETE', url: 'api/v1/merchants/_MERCHANTID_/settings/worktime/non_working_day/:id'},
            'addPredefinedBookingTime': {method: 'POST', url: 'api/v1/merchants/_MERCHANTID_/settings/worktime/predefined_booking_times'},
            'deletePredefinedBookingTime': {method: 'DELETE', url: 'api/v1/merchants/_MERCHANTID_/settings/worktime/predefined_booking_times/:id'},
            'enableTimeSlots': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/worktime/enable_predefined_booking_times/:enableTimeSlots'},
            'sameForAllDeysInWeek': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/worktime/use_same_for_all/:useSame'},
            'addSpecialDayWorkingHours': {method: 'POST', url: 'api/v1/merchants/_MERCHANTID_/settings/worktime/special_day'},

            'saveNotificationSettings': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/notification'},
            'getNotificationSettings': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/notification'},

            'saveMemberStatusSettings': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/memberstatus'},
            'getMemberStatusSettings': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/memberstatus'},

            'saveAlertsSettings': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/alerts'},
            'getAlertsSettings': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/alerts'},

            'saveOnlineWaitlistCustomization': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/onlineWaitlist'},
            'getOnlineWaitlistCustomization': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/onlineWaitlist'},
            'saveOnlineReservationCustomization': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/onlineReservation'},
            'getOnlineReservationCustomization': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/onlineReservation'},
            'getAvailabilityIntegrationScript': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/settings/onlineWaitlist/integrationScript',
                transformResponse: function (data) {
                    // workaround to prevent angular from converting the plain text response to an array!
                    return {content: data};
                  }
                },

            'getSeatingOptionSettings': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/seatingOption/'},
            'saveSeatingOption': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/seatingOption'},
            'deleteSeatingOption': {method: 'DELETE', url: 'api/v1/merchants/_MERCHANTID_/settings/seatingOption/:id'},
            'reOrderSeatingOption': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/seatingOption/reorder'},
            'canActivateReservePage': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/seatingOption/canActivate'},

            'getProductSettings': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/product/'},
            'changeProductType': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/product/change_type/:productType'},
            'saveMealSettings': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/product/meal'},
            'saveDurationSettings': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/product/duration'},
            'saveProduct': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/product/', isArray: true},
            'deleteProduct': {method: 'DELETE', url: 'api/v1/merchants/_MERCHANTID_/settings/product/:id', isArray: true},
            'reOrderProduct': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/product/reorder', isArray: true},
            'getSegmentedProductList' : {method: 'GET', url: "api/v1/merchants/_MERCHANTID_/settings/product/segmentedProductList", isArray: false},

            'saveModifierSettings': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/product/modifierSettings', isArray: true},
            'saveProductModifier': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/product/productModifier', isArray: true},
            'getProductModifierList': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/product/productModifier/:productId', isArray: true},
            'deleteProductModifier': {method: 'DELETE', url: 'api/v1/merchants/_MERCHANTID_/settings/product/productModifier/:productModifierId', isArray: true},
            'reOrderProductModifier': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/product/productModifier/reorder', isArray: true},

            'getTimeSlotSettings': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/timeSlotSettings/'},
            'saveOnlineTimeSlotSettings': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/onlineTimeSlotSettings'},
            'saveOfflineTimeSlotSettings': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/offlineTimeSlotSettings'},
            'saveTimeSlotSet': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/saveTimeSlotSet', isArray: true},
            'getTimeSlotSetList': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/timeSlotSetList', isArray: true},
            'timeSlotSetDetails': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/timeSlotSetDetails/:timeSlotSetId'},
            'saveTimeSlot': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/saveTimeSlot'},
            'deleteTimeSlotSet': {method: 'DELETE', url: 'api/v1/merchants/_MERCHANTID_/settings/deleteTimeSlotSet/:timeSlotSetId', isArray: true},
            'deleteTimeSlot': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/deleteTimeSlot'},
            'saveLimitationTimeSlotSettings': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/limitationTimeSlotSettings'},

            'getBlockEvents': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/settings/blockEvents', isArray: true},
            'saveBlockEvent': {method: 'PUT', url: 'api/v1/merchants/_MERCHANTID_/settings/saveBlockEvent', isArray: true},
            'deleteBlockEvent': {method: 'DELETE', url: 'api/v1/merchants/_MERCHANTID_/settings/deleteBlockEvent/:blockEventId', isArray: true},

            'getEmailLookAndFeel' : {method: 'GET', url: "api/v1/merchants/_MERCHANTID_/emailLookAndFeel", isArray: false},
            'updateEmailLookAndFeel' : {method: 'PUT', url: "api/v1/merchants/_MERCHANTID_/emailLookAndFeel", isArray: false}

        });

}


'use strict';

angular.module('seatonApp')
    .factory('PublicResource', publicResource);

publicResource.$inject = ['$resource', 'ApplicationContext'];
function publicResource($resource, ApplicationContext) {

        return $resource('api/v1/public', {}, {

            // public interfaces
            'getWaitListQueueStatus': {method: 'GET', url: 'api/v1/public/queue/:hashedEventId'},
            //'getWaitListLocationQueueStatus': {method: 'GET', url: 'api/v1/public/waitlist/:hashedLocationId'},
            'getFeedbackDetails': {method: 'GET', url: 'api/v1/public/feedback/:hashedEventId'},
            'saveFeedback': {method: 'POST', url: 'api/v1/public/feedback/:hashedEventId'},
            'cancelEventDetails': {method: 'GET', url: 'api/v1/public/cancelDetails/:hashedEventId'},
            'cancelEvent': {method: 'GET', url: 'api/v1/public/cancel/:hashedEventId'},
            'confirmReservationByCustomer': {method: 'GET', url: 'api/v1/public/confirm/:hashedEventId'},

            // public online interfaces
            'calculateWaitTimes': {method: 'GET', url: 'api/v1/public/online/waitlist/wait-times/:hashedLocationId'},
            'addToWaitlistFromWeb': {method: 'POST', url: 'api/v1/public/online/waitlist/add/:hashedLocationId'},
            'fetchReservationSettings': {method: 'GET', url: 'api/v1/public/online/reservation/settings/:hashedLocationId'},
            'fetchReservationHourList': {method: 'GET', url: 'api/v1/public/online/reservation/hourSet/:hashedLocationId?requestedDate=:requestedDate'},
            'fetchProductList': {method: 'GET', url: 'api/v1/public/online/reservation/productList/:hashedLocationId?requestedDate=:requestedDate&requestedTime=:requestedTime'},
            'findTable': {method: 'POST', url: 'api/v1/public/online/reservation/findTable/:hashedLocationId'},
            'prereserve': {method: 'POST', url: 'api/v1/public/online/reservation/prereserve/:hashedLocationId'},
            'getPaymentSettings': {method: 'PUT', url: 'api/v1/public/online/reservation/payment_settings/:hashedLocationId'},
            'getCompletedSettings': {method: 'GET', url: 'api/v1/public/online/reservation/completed/:hashedLocationId'},


            'getReservationPage': {method: 'GET', url: 'api/v1/public/online/reservation/page/:hashedLocationId'},
            'getProductModifiers': {method: 'GET', url: 'api/v1/public/online/reservation/modifiers/:hashedLocationId?productId=:productId', isArray: true},

            // modifiers


            // new reservation implementation
            'getReserveSettings': {method: 'GET', url: 'api/v1/public/online/reserve/settings/:hashedLocationId?productId=:productId'},
            'getReserveAvailability': {method: 'POST', url: 'api/v1/public/online/reserve/availability/:hashedLocationId'},

            // submit questionnaire for settings
            'submitQuestionnaire': {method: 'POST', url: 'api/v1/public/questionnaire'}
        });
}

'use strict';

angular.module('seatonApp')
    .factory('Tables', tblMngmntResource);

tblMngmntResource.$inject = ['$resource', 'ApplicationContext'];
function tblMngmntResource($resource, ApplicationContext) {

        return $resource('api/v1/merchants/_MERCHANTID_/', {
            //merchantId: ApplicationContext.getLocationID()
            id: "@id", trigger: "@trigger"
        }, {
            'getExpArrivalsToday': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/events/exp_arrivals_today', isArray: true},
            'getActiveEvents': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/events/active', isArray: true},
            'getEventDetails': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/events/:id', isArray: false},
            'getResourceAvailability': {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/resources/availability', isArray: true},
            'getOpenReservations': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events/open_reservations?from=:from&to=:to&page=:page&size=:size',
                isArray: false
            },
            'getPreresevedReservations': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events/prereserved_reservations?from=:from&to=:to&page=:page&size=:size',
                isArray: false
            },
            'getReservationOverview': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events/reservation/overview?from=:from&to=:to',
                isArray: false
            },
            'searchEvents': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events?page=:page&size=:size',
                isArray: false
            },
            'triggerStateChange' : {method: 'POST', url: "api/v1/merchants/_MERCHANTID_/events/:id?trigger=:trigger", isArray: false},
            'getWaitlistQueues' : {method: 'GET', url: "api/v1/merchants/_MERCHANTID_/waitlist/data", isArray: false},
            'addToWaitlist' : {method: 'POST', url: "/api/v1/merchants/_MERCHANTID_/waitlist/add", isArray: false},
            'getSuggestedTimes' : {method: 'GET', url: 'api/v1/merchants/_MERCHANTID_/reservation/suggestedTimes?date=:date', isArray: false},
            'findAvailableTables' : {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/reservation/availableResources?date=:date&time=:time&numberOfPersons=:numberOfPersons&duration=:duration&eventToIgnoreId=:eventToIgnoreId',
                isArray: false
            },
            'createReservation' : {method: 'POST', url: "api/v1/merchants/_MERCHANTID_/reservation/create", isArray: false},
            'createWalkin' : {method: 'POST', url: "api/v1/merchants/_MERCHANTID_/walkins", isArray: false},
            'updateEvent' : {method: 'PUT', url: "api/v1/merchants/_MERCHANTID_/events/:id", isArray: false},
            'updateTimelineEvent' : {method: 'PUT', url: "api/v1/merchants/_MERCHANTID_/events/timeline/:id", isArray: false},
            'updateEventNote' : {method: 'PUT', url: "api/v1/merchants/_MERCHANTID_/events/:id/note", isArray: false},
            'sendThankYou' : {method: 'GET', url: "api/v1/merchants/_MERCHANTID_/events/:id/sendThankYou", isArray: false},
            'rearrangeFetch' : {method: 'GET', url: "api/v1/merchants/_MERCHANTID_/reservation/rearrangeTables", isArray: false},
            'rearrangeSave' : {method: 'POST', url: "api/v1/merchants/_MERCHANTID_/reservation/rearrangeTables", isArray: false},
            'personalized' : {method: 'GET', url: "api/v1/merchants/_MERCHANTID_/reservation/personalized?messageType=:messageType", isArray: false},
            'refundReservationFee' : {method: 'POST', url: "api/v1/merchants/_MERCHANTID_/reservation/refund", isArray: false},
            'captureReservationFee' : {method: 'POST', url: "api/v1/merchants/_MERCHANTID_/reservation/capture", isArray: false},
            'timeline': {
                method: 'GET',
                url: 'api/v1/merchants/_MERCHANTID_/events/timeline?date=:date',
                isArray: false
            }

        });

}


(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('Utils', Utils);

    Utils.$inject = ['ApplicationContext', '$filter'];

    /** Contains various utility methods used in multiple controllers. */
    function Utils(ApplicationContext, $filter) {

        // 'event type'  -->  ['text displayed to the user', 'CSS background for this type']
        var eventTypes = {
            'RESERVATION': ['Reservation', 'text-navy', 'navy-bg'],
            'WALK_IN_SEATED': ['Walk in (seated)', 'text-info', 'lazur-bg'],
            'WALK_IN_WAITLISTED': ['Walk in (waitlisted)', 'text-warning', 'yellow-bg']
        }

        /** Merges STATE and STATUS into a single, user-friendly status */
        function prettyStatus(state, status) {
            if (status == 'WAITLISTED') {
                return 'Waiting to be accomodated';
            } else if (status == 'NOTIFIED' || status == 'RESERVED' || status == 'CONFIRMED') {
                return 'Expected arrival';
            } else if (status == 'SHOW' && state == 'OPEN') {
                return 'Active';
            } else if (status == 'SHOW' && state == 'CLOSED') {
                return 'Closed (show)';
            } else if (status == 'NO_SHOW') {
                return 'Closed (no show)';
            } else if (status == 'CANCELLED') {
                return 'Closed (cancelled)';
            } else if (status == 'PRERESERVED') {
                return 'Pre-reserved.';
            } else {
                // this should never happen
                return state + "-" + status;
            }
        }

        /** Merges STATE and STATUS into a single, user-friendly status */
        function prettyStatusEventDetails(state, status) {
            if (status == 'WAITLISTED') {
                return 'Guest waiting to be accommodated.';
            } else if (status == 'NOTIFIED' || status == 'RESERVED' || status == 'CONFIRMED') {
                return 'Guest arrival expected.';
            } else if (status == 'SHOW' && state == 'OPEN') {
                return 'Guest accommodated.';
            } else if (status == 'SHOW' && state == 'CLOSED') {
                return 'Guest accommodated and event closed.';
            } else if (status == 'NO_SHOW') {
                return 'Guest did not arrive (No-Show).';
            } else if (status == 'CANCELLED') {
                return 'Event cancelled';
            } else if (status == 'PRERESERVED') {
                return 'Guest requested reservation, table not assigned';

            } else {
                // this should never happen
                return state + "-" + status;
            }
        }


        /** Returns the CSS background to be used when displaying a STATE/STATUS combination. */
        function prettyStatusBkg(state, status) {
            if (status == 'WAITLISTED') {
                return 'label-info';
            } else if (status == 'NOTIFIED' || status == 'RESERVED' || status == 'CONFIRMED') {
                return 'label-success';
            } else if (status == 'SHOW' && state == 'OPEN') {
                return 'label-primary';
            } else if (status == 'SHOW' && state == 'CLOSED') {
                return 'label-default';
            } else if (status == 'NO_SHOW') {
                return 'label-danger';
            } else if (status == 'CANCELLED') {
                return 'label-warning';
            } else {
                // this should never happen
                return 'label-default';
            }
        }

        function buttonForAction(action) {
            if (action == 'Show') {
                return "btn-success";
            } else if (action == 'No show' || action == 'Cancel' || action == 'Close') {
                return "btn-danger";
            } else if (action == 'Move back to arrivals') {
                return "btn-info";
            } else if (action == 'Re-open') {
                return "btn-info";
            } else if (action == 'Notify again') {
                return "btn-success";
            } else {
                return "btn-success"
            }
        }

        function formatEventType(type) {
            return type ? eventTypes[type][0] : '';
        }

        getEventTypeTextStyle

        function getEventTypeTextStyle(type) {
            return type ? eventTypes[type][1] : '';
        }

        function getEventTypeBkg(type) {
            return type ? eventTypes[type][2] : '';
        }

        /** Formats the given amount to dollars. */
        function formatDollar(num) {
            if (num) {
                var p = num.toFixed(2).split(".");
                return "$" + p[0].split("").reverse().reduce(
                    function (acc, num, i, orig) {
                        return num == "-" ? acc : num + (i && !(i % 3) ? "," : "") + acc;
                    }, "") + "." + p[1];
            }
            return '';
        }


        function formatMinutes(minutes) {
            var formatted = "";
            if (minutes >= 60) {
                formatted = Math.floor(minutes / 60) + " hr";
            }
            if (minutes % 60 !== 0) {
                if (minutes >= 60) {
                    formatted += " ";
                }
                formatted += (minutes % 60) + " min";
            }

            if (formatted == "") {
                return "0 min";
            }
            return formatted;
        }

        /** Takes a full customer object with all attributes and returns a new object
         containing only basic customer data (name, email, phone and note) */
        function getBasicCustomerData(cust) {

            return {
                id: cust.id,
                firstName: cust.firstName,
                lastName: cust.lastName,
                primaryPhone: cust.primaryPhone,
                primaryEmail: cust.primaryEmail,
                note: cust.note
            };
        }

        //TODO stipo, branimir - check how to format address
        function formatAddress(addr) {
            var result = '';
            result += (addr.address1 ? addr.address1 : '');
            result += (addr.address2 ? ' ,' + addr.address2 : '');
            result += (addr.address3 ? ' ,' + addr.address3 : '');
            result += (addr.city ? ' ,' + addr.city : '');
            result += (addr.countryState ? ' ,' + addr.countryState : '');
            result += (addr.zipcode ? ' ,' + addr.zipcode : '');
            result += (addr.country ? ' ,' + addr.country : '');
            return result;
        }

        function formatAmount(number) {
            return $filter('currency')(number);
        }

        return {
            formatMinutes: formatMinutes,
            formatEventType: formatEventType,
            getEventTypeBkg: getEventTypeBkg,
            formatDollar: formatDollar,
            prettyStatus: prettyStatus,
            prettyStatusBkg: prettyStatusBkg,
            formatAddress: formatAddress,
            getBasicCustomerData: getBasicCustomerData,
            buttonForAction: buttonForAction,
            prettyStatusEventDetails: prettyStatusEventDetails,
            getEventTypeTextStyle: getEventTypeTextStyle,
            formatAmount: formatAmount
        };
    }
})();





(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('ListUtils', ListUtils);

    ListUtils.$inject = ['ApplicationContext'];

    /** Contains various utility methods used in multiple controllers. */
    function ListUtils(ApplicationContext) {


        var ruleList = [
            {id: 'RESERVATION', name: 'Fee per reservation'},
            {id: 'COVER', name: 'Fee per person'}
        ];

        var availableTimesForDay30MinStep = [
            {time: "12:00 AM", timeForDB: "00:00"},
            {time: "12:30 AM", timeForDB: "00:30"},
            {time: "1:00 AM", timeForDB: "01:00"},
            {time: "1:30 AM", timeForDB: "01:30"},
            {time: "2:00 AM", timeForDB: "02:00"},
            {time: "2:30 AM", timeForDB: "02:30"},
            {time: "3:00 AM", timeForDB: "03:00"},
            {time: "3:30 AM", timeForDB: "03:30"},
            {time: "4:00 AM", timeForDB: "04:00"},
            {time: "4:30 AM", timeForDB: "04:30"},
            {time: "5:00 AM", timeForDB: "05:00"},
            {time: "5:30 AM", timeForDB: "05:30"},
            {time: "6:00 AM", timeForDB: "06:00"},
            {time: "6:30 AM", timeForDB: "06:30"},
            {time: "7:00 AM", timeForDB: "07:00"},
            {time: "7:30 AM", timeForDB: "07:30"},
            {time: "8:00 AM", timeForDB: "08:00"},
            {time: "8:30 AM", timeForDB: "08:30"},
            {time: "9:00 AM", timeForDB: "09:00"},
            {time: "9:30 AM", timeForDB: "09:30"},
            {time: "10:00 AM", timeForDB: "10:00"},
            {time: "10:30 AM", timeForDB: "10:30"},
            {time: "11:00 AM", timeForDB: "11:00"},
            {time: "11:30 AM", timeForDB: "11:30"},
            {time: "12:00 PM", timeForDB: "12:00"},
            {time: "12:30 PM", timeForDB: "12:30"},
            {time: "1:00 PM", timeForDB: "13:00"},
            {time: "1:30 PM", timeForDB: "13:30"},
            {time: "2:00 PM", timeForDB: "14:00"},
            {time: "2:30 PM", timeForDB: "14:30"},
            {time: "3:00 PM", timeForDB: "15:00"},
            {time: "3:30 PM", timeForDB: "15:30"},
            {time: "4:00 PM", timeForDB: "16:00"},
            {time: "4:30 PM", timeForDB: "16:30"},
            {time: "5:00 PM", timeForDB: "17:00"},
            {time: "5:30 PM", timeForDB: "17:30"},
            {time: "6:00 PM", timeForDB: "18:00"},
            {time: "6:30 PM", timeForDB: "18:30"},
            {time: "7:00 PM", timeForDB: "19:00"},
            {time: "7:30 PM", timeForDB: "19:30"},
            {time: "8:00 PM", timeForDB: "20:00"},
            {time: "8:30 PM", timeForDB: "20:30"},
            {time: "9:00 PM", timeForDB: "21:00"},
            {time: "9:30 PM", timeForDB: "21:30"},
            {time: "10:00 PM", timeForDB: "22:00"},
            {time: "10:30 PM", timeForDB: "22:30"},
            {time: "11:00 PM", timeForDB: "23:00"},
            {time: "11:30 PM", timeForDB: "23:30"},
            {time: "12:00 AM", timeForDB: "00:00"}
        ];

        var availableTimesForEventDuration = [
            {time: "0:05h", timeForDB: 5},
            {time: "0:10h", timeForDB: 10},
            {time: "0:15h", timeForDB: 15},
            {time: "0:20h", timeForDB: 20},
            {time: "0:25h", timeForDB: 25},
            {time: "0:30h", timeForDB: 30},
            {time: "0:35h", timeForDB: 35},
            {time: "0:40h", timeForDB: 40},
            {time: "0:45h", timeForDB: 45},
            {time: "0:50h", timeForDB: 50},
            {time: "0:55h", timeForDB: 55},
            {time: "1:00h", timeForDB: 60},
            {time: "1:05h", timeForDB: 65},
            {time: "1:10h", timeForDB: 70},
            {time: "1:15h", timeForDB: 75},
            {time: "1:20h", timeForDB: 80},
            {time: "1:25h", timeForDB: 85},
            {time: "1:30h", timeForDB: 90},
            {time: "1:35h", timeForDB: 95},
            {time: "1:40h", timeForDB: 100},
            {time: "1:45h", timeForDB: 105},
            {time: "1:50h", timeForDB: 110},
            {time: "1:55h", timeForDB: 115},
            {time: "2:00h", timeForDB: 120},
            {time: "2:15h", timeForDB: 135},
            {time: "2:30h", timeForDB: 150},
            {time: "2:45h", timeForDB: 165},
            {time: "3:00h", timeForDB: 180},
            {time: "3:15h", timeForDB: 195},
            {time: "3:30h", timeForDB: 210},
            {time: "3:45h", timeForDB: 225},
            {time: "4:00h", timeForDB: 240},
            {time: "4:15h", timeForDB: 255},
            {time: "4:30h", timeForDB: 270},
            {time: "4:45h", timeForDB: 285},
            {time: "5:00h", timeForDB: 300},
            {time: "6:00h", timeForDB: 360},
            {time: "7:00h", timeForDB: 420},
            {time: "8:00h", timeForDB: 480},
            {time: "9:00h", timeForDB: 540},
            {time: "10:00h", timeForDB: 600},
            {time: "11:00h", timeForDB: 660},
            {time: "12:00h", timeForDB: 720},
            {time: "24:00h", timeForDB: 1440}
        ];


        var maxSimpleDurationList = [
            {id: 60, name: '1 hour'},
            {id: 120, name: '2 hours'},
            {id: 180, name: '3 hours'},
            {id: 240, name: '4 hours'},
            {id: 360, name: '6 hours'},
            {id: 720, name: '12 hours'},
            {id: 1440, name: '24 hours'}
        ];

        var minSimpleDurationList = [
            {id: 5, name: '5 min'},
            {id: 10, name: '10 min'},
            {id: 15, name: '15 min'},
            {id: 30, name: '30 min'},
            {id: 60, name: '1 hour'}
        ];

        var timeStepList = [
            {id: 15, name: '15 min'},
            {id: 30, name: '30 min'},
            {id: 60, name: '1 hour'},
            {id: 90, name: '1 hour 30 min'},
            {id: 120, name: '2 hours'}
        ];


        function getPaymentRuleList() {
            return ruleList;
        }

        function getAvailableTimesForDay30MinStep() {
            return availableTimesForDay30MinStep;
        }

        function getAvailableTimesForEventDuration() {
            return availableTimesForEventDuration;
        }

        function getMaxSimpleDurationList() {
            return maxSimpleDurationList;
        }

        function getMinSimpleDurationList() {
            return minSimpleDurationList;
        }

        function getTimeStepList() {
            return timeStepList;
        }

        return {
            getPaymentRuleList: getPaymentRuleList,
            getAvailableTimesForDay30MinStep: getAvailableTimesForDay30MinStep,
            getAvailableTimesForEventDuration: getAvailableTimesForEventDuration,
            getMaxSimpleDurationList: getMaxSimpleDurationList,
            getMinSimpleDurationList: getMinSimpleDurationList,
            getTimeStepList: getTimeStepList
        };
    }
})();





(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('HelpPagesMapping', HelpPagesMapping);

    HelpPagesMapping.$inject = ['$state', '$window', 'SweetAlert'];

    function HelpPagesMapping($state, $window, SweetAlert) {

        function getSupportLinks() {
            var currentState = $state.current.name;
            var currentUrl = $state.href($state.current.name, $state.params, {absolute: false});
            //console.log($state.current.url);
            //console.log('currentUrl: ' + currentUrl);

            var linksUrl = helpLinksMapping[currentUrl];
            var linksStates = helpLinksMapping[currentState];

            //matching by URL has higher priority than angular states!
            if (linksUrl != undefined) {
                return linksUrl;
            } else if (linksStates != undefined) {
                return linksStates;
            } else {
                return [];
            }
        }

        function getSupportLink() {
            var link = '';
            var links = getSupportLinks();
            if (links.length > 0) {
                link = getSupportLinks()[0].link;
            }
            return link;
        }

        function openInNewTab(url) {
            var win = $window.open(url, '_blank');
            win.focus();
        }

        function showHelp() {
            var links = getSupportLinks();
            if (links.length == 0) {
                // go to seaton.support.site home page
                openInNewTab("http://support.seaton.site");
                return;
            } else if (links.length == 1) {
                // go directly to link
                openInNewTab("http://support.seaton.site/" + links[0].link);
                return;
            }

            //' <b>Please click on following link with description of current page:</b> <br>'

            var titleText = ' <b>Help page is on following link: </b>  <br><br>';
            var url = "http://support.seaton.site/" + links[0].link;
            //var htmlText = titleText + "  <a target=\"_blank\" href=\"" + url + "\"><br><b>" + links[0].desc + "</b>  <br> " + url + " <br>(please click)  </a> <br>";
            //var htmlText = titleText + "  <a target=\"_blank\" href=\"" + url + "\">    <br><b>" + url + "</b>  <br>(please click to display)  </a> <br>";
            //style="background:#F9EECF"
            //style="background:#ccffcc"
            //style="background:#ffffcc"
            //var htmlText = titleText + "  <div class=\"widget \" style=\"background:#ccffcc\"><a target=\"_blank\" href=\"" + url + "\"> "+ links[0].desc +"<br>" + url + "  <br>(please click to display)  </a></div> <br>";
            var htmlText = titleText + "  <div class=\"widget \" style=\"background:#ccffcc\"><a target=\"_blank\" href=\"" + url + "\"> " + url + "  <br>(please click to display)  </a></div> <br>";

            if (links.length > 1) htmlText += "Suggested other articles for reading: <br><br>";

            for (var i = 1; i < links.length; i++) {
                var desc = links[i].desc;
                if (desc == '') desc = 'page description ';
                //htmlText += desc;
                htmlText += "  <a target=\"_blank\" href=\"http://support.seaton.site/" + links[i].link + "\">" + desc + "</a> <br>";
            }
            //htmlText += "<br> SeatOn support site: <a target=\"_blank\" href=\"http://support.seaton.site/\">http://support.seaton.site</a> <br>";


            SweetAlert.swal({
                html: true,
                title: '',
                text: htmlText,
                //type: "warning",
                showCancelButton: false,
                confirmButtonColor: "#DD6B55", confirmButtonText: "Close",
                cancelButtonText: "Cancel",
                closeOnConfirm: false,
                closeOnCancel: false
            });
        }

        var helpLinksMapping = {
            'home': [{desc: 'SeatOn Web - Home Dashboard', link: '682495-Home-Dashboard'},
                {desc: 'Getting started guide', link: '669145-Getting-started-guide'},
                {desc: 'Events Workflow description', link: '343584-Events-Workflow description'},
                {
                    desc: 'How to create new reservation? (screencast)',
                    link: '604248-How-to-create-new-reservation#WebReservation'
                },
                {
                    desc: 'How to add customer to the waiting list? (screencast)',
                    link: '135871-How-to-add-customer-to-the-waiting-list'
                },
                {
                    desc: 'How to manage customer walk-ins? (screencast)',
                    link: '596934-How-to-manage-customer-walk-ins#SeatonWeb'
                }
            ],

            'customers.dashboard': [{desc: 'SeatOn Web - Customer dashboard', link: '298278-Customer-Dashboard'}],
            'customers.create': [{desc: 'SeatOn Web - Add new customer', link: '058884-Add-new-customer'}],
            '#/customers/list/basicSearch': [{desc: 'SeatOn Web - Customer search', link: '027126-Customer-search'}],
            'customers.list': [{desc: 'SeatOn Web - Customer list', link: '019831-Customer-list'}],
            'customers.feedback': [{desc: 'SeatOn Web - Customer feedback', link: '858564-Customer-feedback'}],
            'customers.profile': [{desc: 'SeatOn Web - Customer details', link: '781216-Customer-details'}],

            'tables.dashboard': [{desc: 'Tables Dashboard', link: '551222-Tables-Dashboard'}],


            '#/tables/management/arrivals': [{
                desc: 'Table management - Arrivals',
                link: '183821-Table-management#Arrivals'
            },
                {desc: 'Events Workflow description', link: '343584-Events-Workflow'},
                {
                    desc: 'How to create new reservation? (screencast)',
                    link: '604248-How-to-create-new-reservation#WebReservation'
                }
            ],
            '#/tables/management/walkin': [{desc: 'Table management- Walkin', link: '183821-Table-management#Walkin'},
                {desc: 'Events Workflow description', link: '343584-Events-Workflow'},
                {
                    desc: 'How to manage customer walk-ins? (screencast)',
                    link: '596934-How-to-manage-customer-walk-ins#SeatonWeb'
                }
            ],
            '#/tables/management/waitlist': [
                {desc: 'Table management - Waitlist', link: '183821-Table-management#Waitlist'},
                {desc: 'Events Workflow description', link: '343584-Events-Workflow'},
                {
                    desc: 'How to add customer to the waiting list? (screencast)',
                    link: '135871-How-to-add-customer-to-the-waiting-list'
                },
                {
                    desc: 'How to remove customer from the waiting list? (screencast)',
                    link: '785895-How-to-remove-customer-from-the-waiting-list'
                }
            ],
            '#/tables/management/walkout': [{
                desc: 'Table management - Walkout',
                link: '183821-Table-management#Walkout'
            },
                {desc: 'Events Workflow description', link: '343584-Events-Workflow'},
                {
                    desc: 'How to release tables and manage customer payments? (screencast)',
                    link: '442644-How-to-release-tables-and-manage-customer-payments#PaymentWeb'
                },
                {
                    desc: 'How can customers leave feedback?',
                    link: '266465-How-can-customers-leave-feedback'
                }
            ],
            'tables.overview': [{desc: 'SeatOn Web - Reservation overview', link: '094781-Reservation-overview'}],
            'tables.search': [{desc: 'SeatOn Web - Event Search', link: '781869-Search'}],
            'tables.newreservation':
                [{
                    desc: 'How to create new reservation?',
                    link: '604248-How-to-create-new-reservation#WebReservation'
                }],
            'tables.addtowaitlist': [
                {
                    desc: 'Add to Waitlist',
                    link: '755244-Add-to-Waitlist'
                },
                {
                    desc: 'How to add customer to the waiting list? (screencast)',
                    link: '135871-How-to-add-customer-to-the-waiting-list#SeatonWeb'
                },
                {
                    desc: 'How to remove customer from the waiting list? (screencast)',
                    link: '785895-How-to-remove-customer-from-the-waiting-list#SeatonWeb'
                }
            ],
            'tables.eventDetails': [{desc: 'SeatOn Web - Event Details', link: '253835-Event-Details'}],
            'tables.eventUpdate': [{desc: 'SeatOn Web - Edit reservation', link: '452617-Edit-reservation'}],

            'reporting.performance': [{desc: 'SeatOn Web - Daily performance', link: '730299-Daily-performance'}],
            'reporting.revenuetrend': [{desc: 'SeatOn Web - Revenue trend', link: '512011-Revenue-trend'}],
            'reporting.employees': [{desc: 'SeatOn Web - Employees performance', link: '182749-Employees-performance'}],
            'reporting.aggregated': [{desc: 'SeatOn Web - Aggregated revenue', link: '940183-Aggregated-revenue'}],
            'reporting.occupancy': [{desc: 'SeatOn Web - Occupancy report', link: '540061-Occupancy-report'}],

            'settings.general': [{desc: '445302-Settings-General', link: '445302-Settings-General'},
                {
                    desc: 'Customize SeatOn application for your needs (screencast)',
                    link: '627656-Customize-SeatOn-application-for-your-needs'
                }
            ],
            'settings.floor': [{desc: '047082-Floor', link: '047082-Floor'},
                {
                    desc: 'Customize SeatOn application for your needs (screencast)',
                    link: '627656-Customize-SeatOn-application-for-your-needs'
                }
            ],
            'settings.notification': [{desc: 'Notifications', link: '583140-Notification'}],
            'settings.membership': [{desc: 'Settings Membership', link: '712729-Membership'}],
            'settings.employees': [{desc: 'SeatOn Web - Employees', link: '347583-Employees'}],
            'settings.employees.view': [{desc: 'SeatOn Web - Employee details', link: '275736-Employee-details'}],

            //not used - URLs are used insted angular state
            'tables.management': [{desc: 'SeatOn Web - Table management', link: '183821-Table-management'},
                {desc: 'Table management - Arrivals', link: '183821-Table-management#Arrivals'},
                {desc: 'Table management- Walkin', link: '183821-Table-management#Walkin'},
                {desc: 'Table management - Waitlist', link: '183821-Table-management#Waitlist'},
                {desc: 'Table management - Walkout', link: '183821-Table-management#Walkout'}
            ]
        }

        return {
            getSupportLinks: getSupportLinks,
            getSupportLink: getSupportLink,
            showHelp: showHelp
        };
    }
})();





(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('ChannelService', ChannelService);

    ChannelService.$inject = ['$state'];

    function ChannelService($state) {

        function getChannelIcon(channel) {
            var icon = "fa-laptop text-info";
            switch(channel) {
                case "MERCHANT_WEB":
                    icon="fa-home text-danger";
                    break;
                case "DEVICE":
                    icon="fa-laptop text-info";
                    break;
                case "WEB":
                    icon="fa-desktop text-info";
                    break;
                case "FACEBOOK":
                    icon="fa-facebook-square text-success";
                    break;
                case "GOOGLE":
                    icon="fa-google-plus-square text-success";
                    break;
                case "IVR":
                    icon="fa-phone-square text-success";
                    break;

            }
            return icon;
        }

        function getChannelToolTipText (channel) {
            var tooltip = "Clover Device";
            switch(channel) {
                case "MERCHANT_WEB":
                    tooltip="Your Web Page";
                    break;
                case "DEVICE":
                    tooltip="Clover Device";
                    break;
                case "WEB":
                    tooltip="SeatOn Web Application";
                    break;
                case "FACEBOOK":
                    tooltip="Your Facebook Page";
                    break;
                case "GOOGLE":
                    tooltip="Google Pages";
                    break;
                case "IVR":
                    tooltip="Interactive Voice Response (IVR)";
                    break;

            }
            return tooltip;
        }

        return {
            getChannelIcon: getChannelIcon,
            getChannelToolTipText: getChannelToolTipText
        };
    }
})();





/**
 * Created by branimir on 26.3.2017..
 */
(function () {

    'use strict';
    angular.module('seatonApp')
        .directive('timeDiff', function () {
            return {
                restrict: 'EA',
                scope: {
                    startTime: '=startTime'
                },
                template: '<span ng-class="vm.timeDiffCss">{{vm.timeDiffPrefix}}{{vm.timeDiffFormatted }} @ {{vm.startTime | amDateFormat: "LT" }}</span>',
                controller: TimeDiffController,
                controllerAs: 'vm',
                bindToController: true
            };
        });

    function TimeDiffController() {
        var vm = this;
        init();
        function init() {
            vm.timeDiff_millis = moment(vm.startTime).diff(moment());
            if (Math.abs(vm.timeDiff_millis) > 3590000) {
                vm.timeDiffFormatted = moment.duration(Math.abs(vm.timeDiff_millis), 'ms').format("h[h]m[min]");
            } else {
                vm.timeDiffFormatted = moment.duration(Math.abs(vm.timeDiff_millis), 'ms').format("m[min]");
            }
            vm.timeDiffCss = vm.timeDiff_millis < 0 ? 'text-danger' : 'text-navy';
            vm.timeDiffPrefix = vm.timeDiff_millis > 0 ? '' : '-';
        }
    }
})();

(function () {
    'use strict';

    function Time() {
        return {
            fromNow: fromNow,
            isNearDate: isNearDate

        };

        function fromNow(time) {
            return moment(time).diff(moment());            
        }

        function isNearDate(customerDate) {
            var today = moment();
            var diffDates = (moment(customerDate).year(today.year())).diff(today, 'days');
            return 0 <= diffDates && diffDates <= 10;
        }
    }

    angular.module('seatonApp').factory('Time', Time);
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('homeold', {
            parent: 'app',
            url: '/homeold',
            data: {
                // authorities: ['ROLE_USER'],
                authorities: []
            },
            views: {
                'content@app': {
                    templateUrl: 'app/home.dashboard/homedashboard.html',
                    controller: 'HomeDashboardController',
                    controllerAs: 'homeCtrl'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('HomeDashboardController', HomeDashboardController);

    HomeDashboardController.$inject = ['$rootScope', '$scope', 'Principal', '$state', '$q', 'googleChartApiPromise',
        '$filter', 'EventResource', 'CustomerResource', 'Reporting', 'LocationResource', 'ApplicationContext',
        'EmployeeResource', '$document', 'Log'];

    function HomeDashboardController($rootScope, $scope, Principal, $state, $q, googleChartApiPromise, $filter, EventResource,
                                     CustomerResource, Reporting, LocationResource, ApplicationContext, EmployeeResource,
                                     $document, Log) {

        if (ApplicationContext.getLocation().webHome == 0) {
            $state.go("home");
            return;
        }

        var vm = this;
        vm.changeHome = changeHome;
        vm.counters = {};
        vm.numberOfEmployees = -1;
        vm.calcPct = Reporting.calcPct;
        vm.isTableManaged = ApplicationContext.isTableManaged();

        //$scope.showIntro = true;

        if ($rootScope.initialStart == true) {
            $scope.showIntro = true;
            $rootScope.initialStart = false;
            $rootScope.configNotCompleted = true; // always show intro for floor setup when showing intro for home screen
            Log.debug("HomeDashboard", "Show application intro.");
        }

        vm.viewEvent = viewEvent;

        function viewEvent(id) {
            $state.go('tables.eventDetails', {eventId: id});
        }

        //vm.account = Principal.getAccountData();
        $scope.managerAccess = true;
        Principal.identity().then(function (account) {
            vm.account = account;
            if (vm.account.authorities.includes('ROLE_EMPLOYEE') || vm.account.authorities.includes('ROLE_USER')) {
                $scope.managerAccess = false;
            }
        });

        //if (Principal.isAuthenticated()) {
        //    load();
        //}

        $document.ready(load());

        function changeHome() {
            LocationResource.changeHome(
                {},
                function onSuccess(data) {
                    var location = ApplicationContext.getLocation();
                    location.webHome = data.webHome;
                    ApplicationContext.storeLocation(location);
                    $state.go("home");
                    return;
                }
            );
        }

        function load() {

            vm.timeNow = moment();
            vm.lastWeekDay = moment().subtract(1, 'weeks');
            vm.timeDebugNotification = '';

            Log.debug("HomeDashboard", "timeNow=" + vm.timeNow + ", timeNow.format=" + vm.timeNow.format());

            $q.all([
                loadTodayData(),
                loadLastWeekData(),
                loadSettings(),
                loadLocation(),
                getNumberOfCustomers(),
                loadCounters(),
                loadEmployees(),
                googleChartApiPromise
            ]).then(calucalteCustomersStats).then(loadInitialCharts);

        }

        $scope.openingHourNotDefined = function () {
            return ApplicationContext.isBusinessHoursNotDefined();
        }

        function calucalteCustomersStats() {
            var deferred = $q.defer();
            var totalVisits = vm.location.totalReservationShow + vm.location.totalWaitlistShow + vm.location.totalWalkinSeated;
            vm.visitsPct = Reporting.divide(totalVisits - vm.location.totalUnknownCustomerVisit, totalVisits);
            vm.revenuePct = Reporting.divide(vm.location.totalCustomerRevenue - vm.location.totalUnknownCustomerRevenue, vm.location.totalCustomerRevenue);
            //vm.avgSpend = Reporting.divide(vm.location.totalCustomerRevenue, vm.numberOfCustomers);
            //vm.avgSpendVsToday = Reporting.calcPct(vm.todayData.totalDayOccupancy.avgRevenuePerVisit, vm.avgSpend);

            vm.avgSpendPerCover = Reporting.divide(vm.location.totalCustomerRevenue - vm.location.totalUnknownCustomerRevenue, vm.location.totalReservationCover + vm.location.totalWaitlistCover + vm.location.totalWalkinSeatedCover - vm.location.totalUnknownCustomerCover);
            vm.avgSpendPerCoverNonRegulars = Reporting.divide(vm.location.totalUnknownCustomerRevenue, vm.location.totalUnknownCustomerCover);

            deferred.resolve(true);
            return deferred.promise;
        }

        function loadTodayData() {
            return EventResource.getHomeDashboardTodayData({}, function (data) {
                vm.todayData = data;

                if (Math.abs(vm.timeNow - moment(data.dateTime)) > 3590000) {
                    vm.timeDebugNotification = ' POSSIBLE TIME ZONE DIFFERENCE BETWEEN CLIENT AND SERVER!';
                    Log.debug("HomeDashboard", "Time diff(ms): js_time - server_time : " + Math.abs(vm.timeNow - moment(data.dateTime)));
                } else if (Math.abs(vm.timeNow - moment(data.dateTime)) > 10000) {
                    vm.timeDebugNotification = ' TIME DIFFERENCE BETWEEN CLIENT AND SERVER!';
                    Log.debug("HomeDashboard", "Time diff(ms): js_time - server_time : " + Math.abs(vm.timeNow - moment(data.dateTime)));
                }

            }).$promise;
        }

        function loadCounters() {
            //TODO 5 check ApplicationContext.getEmployeeID() has value "ADMIN%20ACCESS"
            Log.debug("HomeDashboard", "Value of ApplicationContext.getEmployeeID():" + ApplicationContext.getEmployeeID())
            return EmployeeResource.sinceLastLogin({id: -1}, function (data) {
                vm.counters = data;
            }).$promise;
        }

        function getNumberOfCustomers() {
            return CustomerResource.numberOfCustomers({}, function (data) {
                vm.numberOfCustomers = data.value;
            }).$promise;
        }

        function loadLastWeekData() {
            return EventResource.getHomeDashboardTodayVsData({
                selectedDate: vm.lastWeekDay.format('YYYY-MM-DD')
            }, function (data) {
                vm.lastWeekDayData = data;
            }).$promise;
        }

        function loadSettings() {
            return LocationResource.getLocationSettings({}, function (settings) {
                vm.settings = settings;
                vm.numberOfAreas = vm.settings.areas.length;
                /*vm.numberOfTables = 0;
                 _.each(vm.settings.areas, function (area) {
                 _.each(area.resources, function (item) { if (item.type == "TABLE") vm.numberOfTables++; });
                 }); */
            }).$promise;
        }

        function loadLocation() {
            return LocationResource.getLocation({}, function (location) {
                vm.location = location;
            }).$promise;
        }

        function loadEmployees() {
            //filter for location
            return EmployeeResource.getAllEmployees({}, function (data) {
                vm.employees = data;
                vm.numberOfEmployees = 0;
                _.each(vm.employees, function (item) {
                    if (item.active) vm.numberOfEmployees++;
                });
            }).$promise;
        }

        function loadInitialCharts() {
            var deferred = $q.defer();

            //revenue by hours
            var dataHours = new google.visualization.DataTable();
            dataHours.addColumn('string', 'Time of Day');
            dataHours.addColumn('number', 'Today', 'color: #1ABC9C');
            dataHours.addColumn({type: 'string', role: 'annotation'});
            dataHours.addColumn('number', 'Last ' + vm.timeNow.format('dddd'), 'color: #336699');
            //dataHours.addColumn('number', 'Last ' + vm.timeNow.format('dddd') + '--' + vm.timeNow.format('dddd h:mm:ss a'), 'color: #336699');

            var todayItem = null;
            var lastWeekDayItem = null;
            for (var i = 0; i < vm.todayData.revenueByHour.length; i++) {
                todayItem = vm.todayData.revenueByHour[i];
                lastWeekDayItem = vm.lastWeekDayData.revenueByHour[i];
                dataHours.addRow([
                    todayItem.hourOfDayFmt,
                    {
                        v: todayItem.revenue,
                        f: $filter('currency')(todayItem.revenue)
                    },
                    $filter('currency')(todayItem.revenue),
                    lastWeekDayItem.revenue]);
            }

            var optionsHours = {
                //width: 900,
                height: 350,
                vAxis: {
                    title: 'Revenue in ' + ApplicationContext.getCurrencySym(),
                    textPosition: 'none',
                    gridlines: {count: 13},
                    viewWindow: {min: 0},
                    titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true},
                    minValue: 0
                },
                hAxis: {title: 'Time of Day', titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}},

                annotations: {
                    alwaysOutside: true,
                    textStyle: {
                        fontSize: 10,
                        bold: 'true',
                        color: '#000',
                        auraColor: 'none'
                    }
                },
                chartArea: {width: '90%', height: '70%'},
                seriesType: 'bars',
                series: {1: {type: 'line'}},
                formatters: {},
                colors: ['#1ABC9C', '#CC3333'],
                legend: {position: 'top', alignment: 'end'}
            };

            vm.chartComboObjectHours = {
                type: "ComboChart",
                options: optionsHours,
                data: dataHours
            };

            deferred.resolve(true);
            return deferred.promise;
        }

        $scope.IntroOptions = {
            steps: [
                {
                    intro: "<h3 align=\"center\">Welcome to SeatOn Reservations</h3>" +
                        "<p>" +
                        "<strong>Dear Customer</strong>,<br/><br/>" +
                        "Thank you for choosing our solution to assist you in running your business. <br/><br/>" +
                        "Any time when you need support or have any questions related to SeatOn, please do not hesitate to contact us via email " +
                        "<a href=\"mailto:support@seaton.site\"/>support@seaton.site</a> or visit SeatOn customer support portal at " +
                        "<a href=\"http://support.seaton.site\" target=\"_blank\"/>http://support.seaton.site</a>" +
                        "</p>" +
                        "<p>" +
                        "As a SeatOn user you will use one of the following applications:<br/>" +
                        "<ul>" +
                        "<li><strong>SeatOn Clover</strong> - intended for use by employees on Clover device</li>" +
                        "<li><strong>SeatOn Web</strong> - intended for use by management or employees using any modern internet browser</li>" +
                        "</ul>" +
                        "</p>" +
                        "<p>" +
                        "SeatOn Web consists of three main modules:" +
                        "<ul>" +
                        "<li> Resource management" +
                        "<li> Customer relationship management" +
                        "<li> Reports and analytics" +
                        "</ul>" +
                        "</p>" +
                        "<p><small><font color=\"red\">Press button \"Next\" or right arrow key on your keyboard to continue with the introduction guide to SeatOn.</font></small></p>" +
                        "<p>" +
                        "<code>SeatOn Reservations, All rights reserved &copy; 2016-2021</code>" +
                        "</p>"
                },
                {
                    element: '#menu',
                    intro: "<h3 align=\"center\">SeatOn Web application menu</h3>" +
                        "<p>" +
                        "Menu is organized to match main SeatOn Web components including resource management, customer relationship management, reports and settings.<br/><br/>" +
                        "Top level menu includes following items:" +
                        "<ul>" +
                        "<li><i>Home</i> - application entry point with current performance dashboard</li>" +
                        "<li><i>Today reservation</i> - upcoming reservation scheduled for today</li>" +
                        "<li><i>Open pre-reservation</i> - pending reservation which requires your approval / resource assignment.</li>" +
                        "<li><i>Wait list</i> - waiting list management.</li>" +
                        "<li><i>Walk-in</i> - walk-in management.</li>" +
                        "<li><i>Active visits</i> - started visits list.</li>" +
                        "<li><i>Reservation center</i> - management of open reservations.</li>" +
                        "<li><i>Search</i> - search all event on system.</li>" +
                        "<li><i>Customers</i> - all details about your customers.</li>" +
                        "<li><i>Reports</i> - various reports to give you insight in your business.</li>" +
                        "<li><i>Settings</i> - customize SeatOn to fit your needs.</li>" +
                        "</ul>" +
                        "</p>" +
                        "<p>" +
                        "<code>SeatOn Reservations, All rights reserved &copy; 2016-2021</code>" +
                        "</p>",
                    position: 'auto'
                },
                {
                    element: document.querySelectorAll('#performance')[0],
                    intro: "<h3 align=\"center\">Today's performance</h3>" +
                        "<p>" +
                        "In this section of Home dashboard page, you can see <strong>current performance on an hourly basis</strong>. " +
                        "Each time you refresh the page, performance graph will be updated with the latest data. " +
                        "This is the most suitable way to track current performance." +
                        "</p>" +
                        "<p>" +
                        "Performance graph displays total revenue on an hourly basis and compares it to the same day from the previous week.<br/>" +
                        "</p>" +
                        "<p>" +
                        "<code>SeatOn Reservations,, All rights reserved &copy; 2016-2021</code>" +
                        "</p>"
                },
                {
                    element: '#lastlogin',
                    intro: "<h3 align=\"center\">Since your last login</h3>" +
                        "<p>In this section of Home dashboard page, you can see <strong>changes in the system since the last time you used SeatOn Web application</strong>." +
                        " Following changes are displayed:" +
                        "<ul>" +
                        "<li>Number of new customers registered in the system</li>" +
                        "<li>Number of new customer feedbacks received</li>" +
                        "<li>Number of new reservations created in the system</li>" +
                        "</ul>" +
                        "</p>" +
                        "<p>" +
                        "<code>SeatOn Next Generation Table Management System, All rights reserved &copy; 2016-2021</code>" +
                        "</p>",
                    position: 'left'
                },
                {
                    element: '#arrivals',
                    intro: "<h3 align=\"center\">Today's expected arrivals</h3>" +
                        "<p>In this section of Home dashboard page, you can see the list of today's expected arrivals, including <strong>today's reservations</strong> " +
                        "and <strong>wait-listed arrivals</strong>. Clicking on the button \"All expected arrivals\" will take you to the Table management " +
                        "page where you can see all the details regarding expected arrivals." +
                        "</p>" +
                        "<p>" +
                        "<code>SeatOn Reservations,, All rights reserved &copy; 2016-2021</code>" +
                        "</p>",
                    position: 'left'
                },
                {
                    element: '#modules',
                    intro: "<h3 align=\"center\">SeatOn modules</h3>" +
                    "<p>SeatOn consists of following moduels:" +
                    "<ul>" +
                    "<li>Resource managegment - module which take care of your resources</li>" +
                    "<li>Customer management - manage your customer data</li>" +
                    "<li>Reporting - various reports which helps you to analyse your business performance</li>" +
                    "<li>Settings - rich customization options to set up SeatOn to match your business needs</li>" +
                    "</ul>" +
                    "</p>" +
                    "<p>" +
                    "Do not forget to:" +
                    "<ul>" +
                    "<li>Visit SeatOn support pages <a href='http://support.seaton.site' target='_blank'>support.seaton.site</a> to find out more details</li>" +
                    "<li>Send us your feedback on SeatOn application or  email <a href='mailto:support@seaton.site'>support@seaton.site</a></li>" +
                    "</ul>" +
                    "<p class='text-danger font-bold'>" +
                    "Start with the customization to set up SeatOn to better match your business needs.<br/>" +
                    "Follow this link to continue - <a href='/#/settings/floor'>start customization.</a></strong></font>" +
                    "</p>" +
                    "<code>SeatOn Reservations, All rights reserved &copy; since 2018</code>" +
                    "</p>",
                    position: 'auto'
                }

                /*
                {
                    element: '#table',
                    intro: "<h3 align=\"center\">Table management</h3>" +
                        "<p>Table management module of the application manages whole procedure from <strong>customer arrival</strong> to <strong>customer walkout</strong>. " +
                        "It handles all type of your guests' arrivals, including walk-in, reservation, waitlist and walkout management. " +
                        "</p>" +
                        "<p>" +
                        "In the table management module, you can <strong>create reservations</strong>, <strong>handle walk-in guests</strong>," +
                        " as well as <strong>add customers to the waiting list</strong>." +
                        " and finally, <strong>manage customer walkouts</strong>. " +
                        "</p>" +
                        "<p> In Table management section on Home dashboard page you have a quick insight into the status of restaurant tables: " +
                        "<ul>" +
                        "<li>Number of currently available tables</li>" +
                        "<li>Number of currently occupied tables and related covers</li>" +
                        "<li>Number of expected arrivals and related covers</li>" +
                        "<li>Number of wait list events and related covers</li>" +
                        "</ul>" +
                        "</p>" +
                        "<p>" +
                        "<code>SeatOn Reservations,, All rights reserved &copy; 2016-2021</code>" +
                        "</p>",
                    position: 'right'
                },
                {
                    element: '#customer',
                    intro: "<h3 align=\"center\">Customer relationship management</h3>" +
                        "<p>Customer relationship management module <strong>records customer information</strong>, <strong>feedback</strong>, <strong>visiting habits</strong>, " +
                        "and <strong>spending behavior</strong> to the customer database. By analyzing customer data, it is possible to trace " +
                        "top customers and loyal guests, as well as check for frequent no-show customers, and eventually restrict " +
                        "reservations for them. " +
                        "</p>" +
                        "<p> In Customer management section on Home dashboard page you have a quick insight into some key indicators " +
                        "related to customers:" +
                        "<ul>" +
                        "<li>Number of all registered customers</li>" +
                        "<li>Percentage of visits made by registered customers</li>" +
                        "<li>Percentage of revenue generated by registered customers</li>" +
                        "<li>Average spend per person by registered customers</li>" +
                        "</ul>" +
                        "</p>" +
                        "<p>" +
                        "<code>SeatOn Next Generation Table Management System, All rights reserved &copy; 2016-2021</code>" +
                        "</p>",

                    position: 'right'
                },
                {
                    element: '#report',
                    intro: "<h3 align=\"center\">Reports and analytics</h3>" +
                        "<p>Reporting module contains a number of different reports with extensive analytics, such as <strong>visit statistics</strong>," +
                        " <strong>aggregated spending trend</strong>, <strong>occupancy rate</strong> and <strong>employee performance</strong>. It is intended for users who want to " +
                        "improve and grow their business, recognize new opportunities and maximize profit." +
                        "</p>" +
                        "<p>" +
                        "<code>SeatOn Reservations,, All rights reserved &copy; 2016-2021</code>" +
                        "</p>",
                    position: 'left'
                },
                {
                    element: '#settings',
                    intro: "<h3 align=\"center\">SeatOn settings</h3>" +
                        "<p>Through Settings pages, you can <strong>customize SeatOn application to match your restaurant's needs</strong>. " +
                        "Here you can set up your floor, including areas and tables definitions, notification messages, customer membership," +
                        " check your employees' data, set up employees' restrictions and track their performance." +
                        "</p>" +
                        "<p>" +
                        "Do not forget to:" +
                        "<ul>" +
                        "<li>Visit SeatOn support pages <a href='http://support.seaton.site' target='_blank'>support.seaton.site</a> to find out more details</li>" +
                        "<li>Send us your feedback on SeatOn application or  email <a href='mailto:support@seaton.site'>support@seaton.site</a></li>" +
                        "</ul>" +
                        "<p>" +
                        "<br/><font color=\"red\"><strong>Now you are ready to use SeatOn application. <br/>" +
                        "Let's start with the set up of your restaurant floor first by following this link -> <a href='/#/settings/floor'>Floor setup.</a></strong></font>" +
                        "</p>" +
                        "<p>" +
                        "<small>Note: You will not be able to use SeatOn on Clover devices before you set up your restaurant floor.</small>" +
                        "</p>" +
                        "<p>" +
                        "<code>SeatOn Reservations,, All rights reserved &copy; 2016-2021</code>" +
                        "</p>",
                    position: 'left'
                }
                */

            ],
            showStepNumbers: true,
            showBullets: true,
            exitOnOverlayClick: false,
            exitOnEsc: false,
            nextLabel: '<strong>Next</strong>',
            prevLabel: '<strong>Previous</strong>',
            skipLabel: 'Exit',
            doneLabel: 'Done'
        };

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                // authorities: ['ROLE_USER'],
                authorities: []
            },
            views: {
                'content@app': {
                    templateUrl: 'app/home.new/homenew.html',
                    controller: 'HomeNewController',
                    controllerAs: 'homeCtrl'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('HomeNewController', HomeNewController);

    HomeNewController.$inject = ['$rootScope', '$scope', 'Principal', '$state', '$q', 'googleChartApiPromise',
        '$filter', 'EventResource', 'LocationResource', 'ApplicationContext',
        'EmployeeResource', '$document', 'Log', 'ChannelService', 'Tables', 'TextUtil'];

    function HomeNewController($rootScope, $scope, Principal, $state, $q, googleChartApiPromise, $filter, EventResource, LocationResource, ApplicationContext, EmployeeResource,
                               $document, Log, ChannelService, Tables, TextUtil) {

        if (ApplicationContext.getLocation().webHome == 1) {
            $state.go("homeold");
            return;
        }

        var vm = this;
        vm.changeHome = changeHome;
        vm.weekStart = moment().startOf('week');
        vm.weekEnd = moment().endOf('week');
        vm.lastWeekStart = vm.weekStart.clone().subtract(1, 'weeks');
        vm.lastWeekEnd = vm.weekEnd.clone().subtract(1, 'weeks');
        vm.coverTrans = TextUtil.translate('person', 'c');

        // subscription information
        vm.subscriptionInfo = {
            'tier': ApplicationContext.getLocation().subscription,
            'reservationCounter': ApplicationContext.getLocation().reservationCoverCount,
            'waitlistCounter': ApplicationContext.getLocation().waitlistCoverCount
        };

        if (!vm.subscriptionInfo.reservationCounter) vm.subscriptionInfo.reservationCounter = 0;
        if (!vm.subscriptionInfo.waitlistCounter) vm.subscriptionInfo.waitlistCounter = 0;
        vm.showEUAppLink = $rootScope.isEU;

        console.log("Subscription:" + JSON.stringify(vm.subscriptionInfo));


        $document.ready(load());

        if ($rootScope.initialStart == true) {
            $scope.showIntro = true;
            $rootScope.initialStart = false;
            $rootScope.configNotCompleted == true;
            Log.debug("HomeNew", "Show application intro.");
        }


        function load() {
            vm.timeNow = moment();
            vm.lastWeekDay = moment().subtract(1, 'weeks');
            vm.timeDebugNotification = '';

            Log.debug("HomeDashboard", "timeNow=" + vm.timeNow + ", timeNow.format=" + vm.timeNow.format());

            $q.all([
                loadCounters(),
                getWeekOccupancy(),
                getLastWeekOccupancy(),
                loadWaitlists(),
                getPreresevedReservations(),
                googleChartApiPromise
            ]).then(displayHourChart);
        }

        $scope.openingHourNotDefined = function () {
            return ApplicationContext.isBusinessHoursNotDefined();
        }

        $scope.configNotCompleted = function () {
            return ApplicationContext.isConfigNotCompleted();
        }

        function loadCounters() {
            //TODO 5 check ApplicationContext.getEmployeeID() has value "ADMIN%20ACCESS"
            Log.debug("HomeDashboard", "Value of ApplicationContext.getEmployeeID():" + ApplicationContext.getEmployeeID())
            return EmployeeResource.sinceLastLogin({id: -1}, function (data) {
                vm.counters = data;
            }).$promise;
        }

        function changeHome() {
            LocationResource.changeHome(
                {},
                function onSuccess(data) {
                    var location = ApplicationContext.getLocation();
                    location.webHome = data.webHome;
                    ApplicationContext.storeLocation(location);
                    $state.go("homeold");
                    return;
                }
            );
        }

        function loadWaitlists() {
            Tables.getWaitlistQueues({},
                function (data) {
                    vm.waitlistQueues = data;
                }
            );
        }

        function getWeekOccupancy() {
            return EventResource.getHomeWeekStats({
                selectedDate: vm.weekStart.clone().format('YYYY-MM-DD')
            }, function (data) {
                vm.data = data;
                vm.data.walkinseatedEventsCount = data.totalWeekOccupancy.totalVisits - data.totalWeekOccupancy.reservationEventsCount - data.totalWeekOccupancy.waitlistEventsCount;
                vm.data.walkinseatedCoversCount = data.totalWeekOccupancy.totalCovers - data.totalWeekOccupancy.reservationCoversCount - data.totalWeekOccupancy.waitlistCoversCount;
            }).$promise;
        }

        function getLastWeekOccupancy() {
            return EventResource.getHomeWeekStats({
                selectedDate: vm.lastWeekStart.clone().format('YYYY-MM-DD'),
                reportType: 'lastWeek'
            }, function (data) {
                vm.lastWeekData = data;
            }).$promise;
        }

        function myToolTip(day, occupancy, visit, cover) {
            return '&nbsp;<b>' + day + '</b><br>' +
                '&nbsp;&nbsp;&nbsp;Occupancy: <span class="text-danger">' + occupancy + '</span><br/>' +
                '&nbsp;&nbsp;&nbsp;Visit(s): <span class="text-danger">' + visit + '</span><br/>' +
                '&nbsp;&nbsp;&nbsp;' + vm.coverTrans + ': <span class="text-danger">' + cover + '</span><br/>';
        }

        function displayHourChart() {

            // occupancy bar chart
            var nowHour = moment().startOf('hour');

            var deferred = $q.defer();

            var dataOcuppancyDay = new google.visualization.DataTable();
            dataOcuppancyDay.addColumn('string', 'Day');
            dataOcuppancyDay.addColumn('number', 'Current week', 'color: #1ABC9C');
            dataOcuppancyDay.addColumn({type: 'boolean', role: 'certainty'}); // certainty col.
            dataOcuppancyDay.addColumn({type: 'string', role: 'annotation'});
            dataOcuppancyDay.addColumn({type: 'string', role: 'tooltip', 'p': {'html': true}});
            dataOcuppancyDay.addColumn('number', 'Previous week', 'color: #336699');
            dataOcuppancyDay.addColumn({type: 'boolean', role: 'certainty'}); // certainty col.

            //console.log("vm.weekStart.weekday(): " + vm.weekStart.weekday() + "  moment.weekdays(true): " + moment.weekdays(true))
            var startWeekDay = vm.weekStart.weekday();  // GB -monday(0)

            var i;
            for (i = 0; i < vm.data.occupancyByWeekday.length; i++) {
                var item = vm.data.occupancyByWeekday[i];
                var certainity = (i < moment().weekday());
                dataOcuppancyDay.addRow(
                    [
                        vm.weekStart.clone().add(i, 'days').format('Do MMM, dddd'),
                        item.occupancyPct,
                        certainity,
                        $filter('percentage')(item.occupancyPct, 2), //item.weekdayName,
                        myToolTip(item.weekdayName, $filter('percentage')(item.occupancyPct, 2), item.totalVisits, item.totalCovers),
                        {
                            v: vm.lastWeekData.occupancyByWeekday[i].occupancyPct,
                            f: $filter('percentage')(vm.lastWeekData.occupancyByWeekday[i].occupancyPct, 2)
                        },
                        true
                    ]
                );
            }

            var optionsOccupancyDay = {
                //width: 900,
                height: 300,

                tooltip: {
                    isHtml: true
                },
                annotations: {
                    alwaysOutside: true,
                    textStyle: {
                        fontSize: 10,
                        bold: 'true',
                        color: '#000',
                        auraColor: 'none'
                    }
                },
                hAxis: {
                    title: 'Day of the week',
                    titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true}
                },
                vAxes: {
                    0: {
                        viewWindowMode: 'explicit',
                        //gridlines: {color: 'transparent'},
                        gridlines: {count: 9},
                        title: 'Occupancy rate',
                        titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
                        format: 'percent',
                        viewWindow: {
                            min: 0
                        },
                        minValue: 0
                        //TODO limit chart min value!!
                    },
                    1: {
                        //gridlines: {color: 'transparent'},
                        title: 'Occupancy rate',
                        //titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
                        format: 'percent',
                        color: '#CC9933',
                        viewWindow: {
                            min: 0
                        },
                        textStyle: {color: '#CC3333'},
                        titleTextStyle: {color: '#CC3333'},
                        minValue: 0
                    }
                },
                chartArea: {width: '80%', height: '65%'},
                series: {
                    0: {
                        type: 'bars',
                        targetAxisIndex: 0
                    },
                    1: {
                        type: 'line',
                        targetAxisIndex: 0
                    }
                },
                formatters: {},
                colors: ['#1ABC9C', '#CC3333'],
                legend: {position: 'top', alignment: 'end'}
            };

            $scope.chartComboObjectOccupancyDay = {
                type: "ComboChart",
                options: optionsOccupancyDay,
                data: dataOcuppancyDay
            };

            // visit pie donut chart
            var dataPie = new google.visualization.DataTable();
            dataPie.addColumn('string', 'Visit type');
            dataPie.addColumn('number', 'Number of visits');
            dataPie.addRows([
                ['Reservation', vm.data.totalWeekOccupancy.reservationEventsCount],
                ['Wait list', vm.data.totalWeekOccupancy.waitlistEventsCount],
                ['Walk-in', vm.data.walkinseatedEventsCount]
            ]);

            $scope.showChart = vm.data.totalWeekOccupancy.reservationEventsCount + vm.data.totalWeekOccupancy.waitlistEventsCount + vm.data.walkinseatedEventsCount;

            var optionsPie = {
                /*title: 'Current week visit statistic',
                titleTextStyle: {
                    fontSize: 14,
                    bold: true,
                    color: 757789
                },*/
                pieHole: 0.3,
                legend: 'none',
                chartArea: {
                    top: 15, left: 0, right: 0, bottom: 0
                },
                slices: {
                    0: {color: '#1ab394'},
                    1: {color: '#f8ac59'},
                    2: {color: '#23c6c8'}
                }
            };

            $scope.chartPieDonutVisitStat = {
                type: "PieChart",
                data: dataPie,
                options: optionsPie
            };
            return deferred.promise;
        }

        $scope.channelIcon = function (channel) {
            return ChannelService.getChannelIcon(channel);
        }

        $scope.channelToolTipText = function (channel) {
            return ChannelService.getChannelToolTipText(channel);
        }

        function getPreresevedReservations() {
            Tables.getPreresevedReservations(
                {
                    from: moment("2000-01-01", "YYYY-MM-DD").startOf('day').toISOString(),
                    to: moment().add(1, 'year').toISOString(),
                    page: 0,
                    size: 15
                },
                function (data) {
                    vm.preReservations = data.content;
                    vm.totalPreReservations = data.totalElements;
                }
            );
        }

        $scope.IntroOptions = {
            steps: [
                {
                    intro: "<h3 align=\"center\">Welcome to SeatOn Reservations</h3>" +
                        "<p>" +
                        "<strong>Dear Customer</strong>,<br/><br/>" +
                        "Thank you for choosing our solution to assist you in running your business. <br/><br/>" +
                        "Any time when you need support or have any questions related to SeatOn, please do not hesitate to contact us via email " +
                        "<a href=\"mailto:support@seaton.site\"/>support@seaton.site</a> or visit SeatOn customer support portal at " +
                        "<a href=\"http://support.seaton.site\" target=\"_blank\"/>http://support.seaton.site</a>" +
                        "</p>" +
                        "<p>" +
                        "As a SeatOn user you will use one of the following applications:<br/>" +
                        "<ul>" +
                        "<li><strong>SeatOn Clover</strong> - intended for use by employees on Clover device</li>" +
                        "<li><strong>SeatOn Web</strong> - intended for use by management or employees using any modern internet browser</li>" +
                        "</ul>" +
                        "</p>" +
                        "<p>" +
                        "SeatOn Web consists of three main modules:" +
                        "<ul>" +
                        "<li> Resource management" +
                        "<li> Customer relationship management" +
                        "<li> Reports and analytics" +
                        "</ul>" +
                        "</p>" +
                        "<p><small><font color=\"red\">Press button \"Next\" or right arrow key on your keyboard to continue with the introduction guide to SeatOn.</font></small></p>" +
                        "<p>" +
                        "<code>SeatOn Reservations, All rights reserved &copy; since 2018</code>" +
                        "</p>"
                },
                {
                    element: '#menu',
                    intro: "<h3 align=\"center\">SeatOn Web application menu</h3>" +
                        "<p>" +
                        "Menu is organized to match main SeatOn Web components including resource management, customer relationship management, reports and settings.<br/><br/>" +
                        "Top level menu includes following items:" +
                        "<ul>" +
                        "<li><i>Home</i> - application entry point with current performance dashboard</li>" +
                        "<li><i>Today reservation</i> - upcoming reservation scheduled for today</li>" +
                        "<li><i>Open pre-reservation</i> - pending reservation which requires your approval / resource assignment.</li>" +
                        "<li><i>Wait list</i> - waiting list management.</li>" +
                        "<li><i>Walk-in</i> - walk-in management.</li>" +
                        "<li><i>Active visits</i> - started visits list.</li>" +
                        "<li><i>Reservation center</i> - management of open reservations.</li>" +
                        "<li><i>Search</i> - search all event on system.</li>" +
                        "<li><i>Customers</i> - all details about your customers.</li>" +
                        "<li><i>Reports</i> - various reports to give you insight in your business.</li>" +
                        "<li><i>Settings</i> - customize SeatOn to fit your needs.</li>" +
                        "</ul>" +
                        "</p>" +
                        "<p>" +
                        "<code>SeatOn Reservations, All rights reserved &copy; since 2018</code>" +
                        "</p>",
                    position: 'auto'
                },
                {
                    element: '#performance',
                    intro: "<h3 align=\"center\">Current week overview</h3>" +
                        "<p>" +
                        "In this section of Home dashboard page, you can see <strong>current week overview</strong>, including:. " +
                        "<ul>" +
                        "<li>Occupancy rate for current week and each day in the week</li>" +
                        "<li>Completed and upcoming visit statistics, and open pre-reservation count</li>" +
                        "</ul>" +
                        "</p>" +
                        "<p>" +
                        "Current week occupancy rate is compared with occupancy rate from the previous week for each day in the week.<br/>" +
                        "</p>" +
                        "<p>" +
                        "<code>SeatOn Reservations,, All rights reserved &copy; since 2018</code>" +
                        "</p>",
                    position: 'auto'
                },
                {
                    element: '#lastlogin',
                    intro: "<h3 align=\"center\">Important notes and changes since last login</h3>" +
                        "<p>In this section of Home dashboard page, you can see <strong>important notes</strong> related to actions which require you attention and" +
                        " <strong>changes in the system</strong> since the last time you used SeatOn Web application." +
                        "</p>" +
                        "<p>" +
                        "<code>SeatOn Next Generation Table Management System, All rights reserved &copy; 2016-2021</code>" +
                        "</p>",
                    position: 'left'
                },
                {
                    element: '#events',
                    intro: "<h3 align=\"center\">Events list</h3>" +
                        "<p>In this section of Home dashboard page, you can see the list of event splited in three categories:" +
                        "<ul>" +
                        "<li>Upcoming reservation list for current week</li>" +
                        "<li>Open pre-reservation list</li>" +
                        "<li>Wait list</li>" +
                        "</ul>" +
                        "Press on button at the end of the list and access to page where you can manage different event types." +
                        "</p>" +
                        "<p>" +
                        "Do not forget to:" +
                        "<ul>" +
                        "<li>Visit SeatOn support pages <a href='http://support.seaton.site' target='_blank'>support.seaton.site</a> to find out more details</li>" +
                        "<li>Send us your feedback on SeatOn application or  email <a href='mailto:support@seaton.site'>support@seaton.site</a></li>" +
                        "</ul>" +
                        "<p class='text-danger font-bold'>" +
                        "Start with the customization to set up SeatOn to better match your business needs.<br/>" +
                        "Follow this link to continue - <a href='/#/settings/floor'>start customization.</a></strong></font>" +
                        "</p>" +
                        "<code>SeatOn Reservations,, All rights reserved &copy; since 2018</code>" +
                        "</p>",
                    position: 'top'
                }
                /*
                {
                    element: '#table',
                    intro: "<h3 align=\"center\">Table management</h3>" +
                    "<p>Table management module of the application manages whole procedure from <strong>customer arrival</strong> to <strong>customer walkout</strong>. " +
                    "It handles all type of your guests' arrivals, including walk-in, reservation, waitlist and walkout management. " +
                    "</p>" +
                    "<p>" +
                    "In the table management module, you can <strong>create reservations</strong>, <strong>handle walk-in guests</strong>," +
                    " as well as <strong>add customers to the waiting list</strong>." +
                    " and finally, <strong>manage customer walkouts</strong>. " +
                    "</p>" +
                    "<p> In Table management section on Home dashboard page you have a quick insight into the status of restaurant tables: " +
                    "<ul>" +
                    "<li>Number of currently available tables</li>" +
                    "<li>Number of currently occupied tables and related covers</li>" +
                    "<li>Number of expected arrivals and related covers</li>" +
                    "<li>Number of waitlist events and related covers</li>" +
                    "</ul>" +
                    "</p>" +
                    "<p>" +
                    "<code>SeatOn Reservations,, All rights reserved &copy; 2016-2021</code>" +
                    "</p>",
                    position: 'right'
                },
                {
                    element: '#customer',
                    intro: "<h3 align=\"center\">Customer relationship management</h3>" +
                    "<p>Customer relationship management module <strong>records customer information</strong>, <strong>feedback</strong>, <strong>visiting habits</strong>, " +
                    "and <strong>spending behavior</strong> to the customer database. By analyzing customer data, it is possible to trace " +
                    "top customers and loyal guests, as well as check for frequent no-show customers, and eventually restrict " +
                    "reservations for them. " +
                    "</p>" +
                    "<p> In Customer management section on Home dashboard page you have a quick insight into some key indicators " +
                    "related to customers:" +
                    "<ul>" +
                    "<li>Number of all registered customers</li>" +
                    "<li>Percentage of visits made by registered customers</li>" +
                    "<li>Percentage of revenue generated by registered customers</li>" +
                    "<li>Average spend per person by registered customers</li>" +
                    "</ul>" +
                    "</p>" +
                    "<p>" +
                    "<code>SeatOn Next Generation Table Management System, All rights reserved &copy; 2016-2021</code>" +
                    "</p>",

                    position: 'right'
                },
                {
                    element: '#report',
                    intro: "<h3 align=\"center\">Reports and analytics</h3>" +
                    "<p>Reporting module contains a number of different reports with extensive analytics, such as <strong>visit statistics</strong>," +
                    " <strong>aggregated spending trend</strong>, <strong>occupancy rate</strong> and <strong>employee performance</strong>. It is intended for users who want to " +
                    "improve and grow their business, recognize new opportunities and maximize profit." +
                    "</p>" +
                    "<p>" +
                    "<code>SeatOn Reservations,, All rights reserved &copy; 2016-2021</code>" +
                    "</p>",
                    position: 'left'
                },
                {
                    element: '#settings',
                    intro: "<h3 align=\"center\">SeatOn settings</h3>" +
                    "<p>Through Settings pages, you can <strong>customize SeatOn application to match your restaurant's needs</strong>. " +
                    "Here you can set up your floor, including areas and tables definitions, notification messages, customer membership," +
                    " check your employees' data, set up employees' restrictions and track their performance." +
                    "</p>" +
                    "<p>" +
                    "Do not forget to:" +
                    "<ul>" +
                    "<li>Visit SeatOn support pages <a href='http://support.seaton.site' target='_blank'>support.seaton.site</a> to find out more details</li>" +
                    "<li>Send us your feedback on SeatOn application or  email <a href='mailto:support@seaton.site'>support@seaton.site</a></li>" +
                    "</ul>" +
                    "<p>" +
                    "<br/><font color=\"red\"><strong>Now you are ready to use SeatOn application. <br/>" +
                    "Let's start with the set up of your restaurant floor first by following this link -> <a href='/#/settings/floor'>Floor setup.</a></strong></font>" +
                    "</p>" +
                    "<p>" +
                    "<small>Note: You will not be able to use SeatOn on Clover devices before you set up your restaurant floor.</small>" +
                    "</p>" +
                    "<p>" +
                    "<code>SeatOn Reservations,, All rights reserved &copy; 2016-2021</code>" +
                    "</p>",
                    position: 'left'
                }
                */
            ],

            showStepNumbers: true,
            showBullets: true,
            exitOnOverlayClick: false,
            exitOnEsc: false,
            nextLabel: '<strong>Next</strong>',
            prevLabel: '<strong>Previous</strong>',
            skipLabel: 'Exit',
            doneLabel: 'Done'
        };

        $scope.showSubscriptionInfo = function () {
            if (vm.subscriptionInfo && vm.subscriptionInfo.tier == 'FREE') {
                return true;
            }
            return false;
        }

    }
})();




(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('customers', {
            abstract: true,
            parent: 'app',
            url: '/customers',
            data: {
                roles: ['ROLE_USER']
            }
        });
    }
})();

'use strict';

CustomerProfileController.$inject = ['$state', '$q', '$stateParams', 'Principal', 'CustomerResource', 'LocationResource',
    'googleChartApiPromise', 'EventResource', 'Reporting', 'ApplicationContext', 'Time', 'Utils', 'Tables', 'SweetAlert',
    'ApplicationProfile'];

function CustomerProfileController($state, $q, $stateParams, Principal, CustomerResource, LocationResource,
                                   googleChartApiPromise, EventResource, Reporting, ApplicationContext, Time,
                                   Utils, Tables, SweetAlert, ApplicationProfile) {
    var vm = this;
    vm.calcPct = Reporting.calcPct;
    vm.moment = moment;
    vm.isMeal = (ApplicationContext.getProductType() == 'MEAL');

    vm.edit = edit;
    vm.updateAttribute = updateAttribute;
    vm.adjustPoints = adjustPoints;
    vm.isNearDate = Time.isNearDate;
    vm.tabChange = tabChange;
    vm.viewEvent = viewEvent;
    vm.viewAllEvents = viewAllEvents;
    vm.utils = Utils;
    vm.formatAddress = Utils.formatAddress;

    vm.oneCustomerStats = null;
    vm.aggrSpendType = 'byhour';
    vm.aggrSpendInterval = 12;
    vm.spendTrendChartLoaded = false;
    vm.aggregatedSpendChartLoaded = false;
    vm.aggregatedSpendChartCurrent = '-';

    vm.avgSpendPerCover = -1;

    vm.profileSpendTrend = ApplicationProfile.isCustomerProfileSpendTrendEnabled();
    vm.profileSpendTrendText = ApplicationProfile.upgradeTierText("ProfileSpendTrend");
    vm.profileAggregatedSpendTrend = ApplicationProfile.isCustomerProfileAggregatedSpendTrendEnabled();
    vm.profileAggregatedSpendTrendText = ApplicationProfile.upgradeTierText("ProfileAggregatedSpendTrend");
    vm.openWindow = ApplicationProfile.openAppCloverPage;


    load($stateParams.customerId);

    function load(customerId) {
        $q.all([
            loadCustomer(customerId),
            loadSettings(),
            googleChartApiPromise
        ]).then(calculateStats).then(loadVisitCharts).then(loadEvents(customerId));
    }

    function loadSettings() {
        return LocationResource.getLocationSettings({}, function (settings) {
            vm.settings = settings;
            vm.numberOfAreas = vm.settings.areas.length;
        }).$promise;
    }


    function tabChange(tab) {
        switch (tab) {
            case 'visit':
                $(window).resize();
                break;
            case 'spendTrend':
                if (vm.profileSpendTrend) {
                    if (vm.spendTrendChartLoaded) {
                        $(window).resize(); //if data already loaded just refresh
                    } else {
                        loadSpendTrendData().then(loadSpendTrendChart).then($(window).resize);
                        vm.spendTrendChartLoaded = true;
                    }
                }
                break;
            case 'aggregatedSpend':
                if (vm.profileAggregatedSpendTrend) {
                    var currentChart = vm.aggrSpendType + vm.aggrSpendInterval;

                    if (vm.aggregatedSpendChartLoaded && vm.aggregatedSpendChartCurrent == currentChart) {
                        $(window).resize(); //if data already loaded just refresh
                    } else {
                        if (vm.aggrSpendType == 'byhour') loadAggregatedByHourData().then(loadAggregatedByHourChart).then($(window).resize);
                        if (vm.aggrSpendType == 'byday') loadAggregatedByWeekdayData().then(loadAggregatedByDayChart).then($(window).resize);
                        vm.aggregatedSpendChartCurrent = currentChart;
                        vm.aggregatedSpendChartLoaded = true;
                    }
                }
                break;
        }
    }

    function edit(id) {
        $state.go('customers.create', {customerId: id});
    }

    function viewEvent(id) {
        $state.go('reservations.details', {eventId: id});
    }

    function viewAllEvents(id) {
        //$state.go('tables.search', {keyword: '' + vm.profile.firstName + ' ' + vm.profile.lastName});
        $state.go('tables.search', {keyword: 'customerId:' + id});
    }

    /*
     function viewAllEvents() {
     ViewState.goToState('customer.profile.events', {
     keyword: vm.profile.name,
     customerId: vm.profile.id
     });
     }
     */

    function updateAttribute(attribute) {
        console.log('updateAttribute:' + vm.profile.id);
        if (attribute == 'waitlistAllowed') {
            var msg = !vm.profile[attribute] ? 'Disallow waitlist?' : 'Allow waitlist?';
            var msgConfirmation = '';
        }
        if (attribute == 'reservationAllowed') {
            var msg = !vm.profile[attribute] ? 'Disallow reservations for customer?' : 'Allow reservations for customer?';
            var msgConfirmation = '';
        }

        SweetAlert.swal({
                title: msg,
                //text: "Your will not be able to recover this imaginary file!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55", confirmButtonText: "Ok",
                cancelButtonText: "Cancel",
                closeOnConfirm: false,
                closeOnCancel: false
            },
            function (isConfirm) {


                if (isConfirm) {
                    if (vm.profile.id) {
                        CustomerResource.updateAttribute({
                            id: vm.profile.id,
                            attribute: attribute,
                            attributeValue: false
                        }, function (data) {
                            console.log(data);
                            SweetAlert.swal("Updated", "", "success");
                        });

                    }
                } else {
                    vm.profile[attribute] = !vm.profile[attribute];
                    SweetAlert.swal("No changes", "", "error");
                }
            });


    }

    function adjustPoints(cb) {
        vm.profile.totalPoints = vm.currentPoints;
        calculateStats();
        vm.profile.customerLevel = vm.stats.memberStatus.stars;
        update(['totalPoints']);
        cb();
    }

    function loadEvents(customerId) {
        return Tables.searchEvents(
            {
                keyword: 'customerId:' + customerId,
                page: 0,
                size: 10
            },
            function (data) {
                vm.events = data.content;
                vm.eventTotalItems = data.totalElements;
            }).$promise;
    }

    function loadSpendTrendData() {
        return CustomerResource.getSpendTrend({id: vm.profile.id}, function (data) {
            vm.customerSpendTrendData = data;
        }).$promise;
    }

    function loadAggregatedByHourData() {
        return CustomerResource.getAggregateByHourData({
            id: vm.profile.id,
            months: vm.aggrSpendInterval
        }, function (data) {
            vm.aggrByHourData = data;
        }).$promise;
    }

    function loadAggregatedByWeekdayData() {
        return CustomerResource.getAggregateByWeekdayData({
            id: vm.profile.id,
            months: vm.aggrSpendInterval
        }, function (data) {
            vm.aggrByWeekdayData = data;
            vm.aggrByWeekdayDetailData = vm.aggrByWeekdayData.detailData;
            //calc stat pcts. vs location stats
            //_.each(vm.aggrByWeekdayData.detailData, Reporting.calcAggrByWeekdayDataItem,vm);
            for (var i = 0; i < vm.aggrByWeekdayData.detailData.length; i++)
                Reporting.calcAggrByWeekdayDataItem(vm.aggrByWeekdayData.detailData[i], vm.locationStats);
        }).$promise;
    }

    function loadCustomer(customerId) {
        return CustomerResource.getProfile({id: customerId}, function (customerWithStats) {
            vm.cstats = customerWithStats;
            vm.profile = customerWithStats.customer;
            vm.oneCustomerStats = customerWithStats.customerStats;
            vm.avgSpendPerCover = vm.oneCustomerStats.avgSpendPerCover;
            //vm.customerProfileVisitStats = customerWithStats.locationStats;
            vm.locationStats = customerWithStats.locationStats;

            vm.currentPoints = customerWithStats.customer.totalPoints;

            vm.templateParam1 = vm.locationStats.avgSpendByCover;
            vm.templateParam2 = vm.locationStats.avgTipPerVisit;
            vm.templateParam3 = vm.locationStats.avgCoversPerVisit;
            //vm.templateParam4 = vm.locationStats.totalReservationNoShow + vm.locationStats.totalWaitlistNoShow;
            vm.templateParam4 = vm.locationStats.totalNoShowRatio;

        }).$promise;
    }

    function calculateStats() {
        var deferred = $q.defer();
        var stats = {};

        //TODO check - calculate on server?
        stats.memberStatus = _.chain(vm.settings.memberStatuses)
            .sortBy(function (status) {
                return status.threshold;
            })
            .reverse()
            .find(function (status) {
                return status.threshold <= vm.profile.totalPoints;
            }).value();
        vm.stats = stats;
        deferred.resolve(stats);
        return deferred.promise;
    }

    function loadVisitCharts() {
        var deferred = $q.defer();
        //vistis - general pie chart
        vm.chartObjectVisitGeneral = {};
        vm.chartObjectVisitGeneral.type = "PieChart";

        vm.chartObjectVisitGeneral.options = {
            title: 'Visit statistics',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            legend: {position: 'right'},
            //width: 450,
            height: 350,

            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#3399CC'},
                2: {color: '#996699'},
            },
            chartArea: {width: '85%', height: '65%'}
        };

        vm.chartObjectVisitGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Reservation"},
                        {v: vm.profile.totalReservationShow}
                    ]
                },
                {
                    c: [
                        {v: "Walk-In Seated"},
                        {v: vm.profile.totalWalkinSeated}
                    ]
                },
                {
                    c: [
                        {v: "Walk-In Waitlisted"},
                        {v: vm.profile.totalWaitlistShow}
                    ]
                }
            ]
        };
        vm.showChartObjectVisitGeneral = !Reporting.allZeroesInPieChartData(vm.chartObjectVisitGeneral.data.rows);

        //reservation - general pie chart
        vm.chartObjectReservationGeneral = {};
        vm.chartObjectReservationGeneral.type = "PieChart";

        vm.chartObjectReservationGeneral.options = {
            title: 'Reservation statistics',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            legend: {position: 'right'},
            //width: 450,
            height: 350,

            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#FF3333'},
                2: {color: '#FFCC33'},
            },
            chartArea: {width: '85%', height: '65%'}
        };

        vm.chartObjectReservationGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Show"},
                        {v: vm.profile.totalReservationShow}
                    ]
                },
                {
                    c: [
                        {v: "No Show"},
                        {v: vm.profile.totalReservationNoShow}
                    ]
                },
                {
                    c: [
                        {v: "Canceled"},
                        {v: vm.profile.totalReservationCanceled}
                    ]
                }
            ]
        };

        vm.showChartObjectReservationGeneral = !Reporting.allZeroesInPieChartData(vm.chartObjectReservationGeneral.data.rows);

        //waitlist - general pie chart
        vm.chartObjectWaitlistGeneral = {};
        vm.chartObjectWaitlistGeneral.type = "PieChart";

        vm.chartObjectWaitlistGeneral.options = {
            title: 'Waitlist statistics',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            legend: {position: 'right'},
            //width: 450,
            height: 350,

            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#FF3333'},
                2: {color: '#FFCC33'},
            },
            chartArea: {width: '85%', height: '65%'},
            sliceVisibilityThreshold: 0
        };

        vm.chartObjectWaitlistGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Show"},
                        {v: vm.profile.totalWaitlistShow}
                    ]
                },
                {
                    c: [
                        {v: "No Show"},
                        {v: vm.profile.totalWaitlistNoShow}
                    ]
                },
                {
                    c: [
                        {v: "Canceled"},
                        {v: vm.profile.totalWaitlistCanceled}
                    ]
                }
            ]
        };
        vm.showChartObjectWaitlistGeneral = !Reporting.allZeroesInPieChartData(vm.chartObjectWaitlistGeneral.data.rows);

        return deferred.promise;
    }

    function loadSpendTrendChart() {
        var deferred = $q.defer();
        // Spend trend
        var dataTrend = new google.visualization.DataTable();
        dataTrend.addColumn('string', 'Month');
        dataTrend.addColumn('number', 'Reservation', 'color: #007E3B');
        dataTrend.addColumn('number', 'Walk-In Seated');
        dataTrend.addColumn('number', 'Walk-In Waitlisted');
        dataTrend.addColumn({type: 'string', role: 'annotation'});

        var optionsTrend = {
            title: 'Last 12 months spend statistics (' + moment(vm.customerSpendTrendData.startDate).format('Do MMM YY') + ' - ' + moment(vm.customerSpendTrendData.endDate).format('Do MMM YY') + ')',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            isStacked: 'true',
            //legend: { position: 'top', alignment: 'end'},
            //width: 1000,
            height: 400,
            vAxis: {
                title: 'Customer Spend in ' + ApplicationContext.getCurrencySym(), gridlines: {count: 6}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },
            hAxis: {
                title: "Month",
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true},
                slantedText: true,
                slantedTextAngle: 45
            },
            //hAxis: {
            //title: 'Month in year',
            // viewWindow: {
            //   min: [7, 30, 0],
            //   max: [23, 30, 0]
            // }
            //},
            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            colors: ['#1ABC9C', '#3399CC', '#996699'],
            formatters: {}
        };

        vm.chartObjectTrend = {
            type: 'ColumnChart',
            options: optionsTrend,
            data: dataTrend
        };

        Reporting.setSpendTrendChartData(dataTrend, vm.customerSpendTrendData.chartData);

        return deferred.promise;
    }

    function loadAggregatedByHourChart() {
        var deferred = $q.defer();
        // Aggregated spend
        // Spend by hours
        var dataHours = new google.visualization.DataTable();
        dataHours.addColumn('string', 'Time of Day');
        dataHours.addColumn('number', 'Reservation', 'color: #007E3B');
        dataHours.addColumn('number', 'Walk-In Seated');
        dataHours.addColumn('number', 'Walk-In Waitlisted');
        dataHours.addColumn({type: 'string', role: 'annotation'});

        var optionsHours = {
            title: 'Aggregated customer spend behavior on hourly basis (for inteval: ' + moment(vm.aggrByHourData.startDate).format('Do MMM YY') + ' - ' + moment(vm.aggrByHourData.endDate).format('Do MMM YY') + ')',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            isStacked: 'true',
            //width: 1000,
            height: 400,
            vAxis: {
                title: 'Customer Spend in ' + ApplicationContext.getCurrencySym(), gridlines: {count: 6}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },
            hAxis: {
                title: 'Time of Day',
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            colors: ['#1ABC9C', '#3399CC', '#996699'],
            formatters: {}

        };
        vm.chartObjectHours = {
            type: 'ColumnChart',
            options: optionsHours,
            data: dataHours
        };

        Reporting.setSpendTrendChartData(dataHours, vm.aggrByHourData.chartData);

        return deferred.promise;
    }


    function loadAggregatedByDayChart() {
        var deferred = $q.defer();
        // Days statistics
        var dataDays = new google.visualization.DataTable();
        dataDays.addColumn('string', 'Day');
        dataDays.addColumn('number', 'Reservation', 'color: #007E3B');
        dataDays.addColumn('number', 'Walk-In Seated');
        dataDays.addColumn('number', 'Walk-In Waitlisted');
        dataDays.addColumn({type: 'string', role: 'annotation'});

        var optionsDays = {
            title: 'Aggregated customer spend behavior on daily basis (for inteval: ' + moment(vm.aggrByWeekdayData.startDate).format('Do MMM YY') + ' - ' + moment(vm.aggrByWeekdayData.endDate).format('Do MMM YY') + ')',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            isStacked: 'true',
            //width: 1000,
            height: 400,
            vAxis: {
                title: 'Customer Spend in ' + ApplicationContext.getCurrencySym(), gridlines: {count: 6}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },
            hAxis: {
                title: 'Days of the Week',
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            colors: ['#1ABC9C', '#3399CC', '#996699'],
            formatters: {}
        };
        vm.chartObjectDays = {
            type: 'ColumnChart',
            options: optionsDays,
            data: dataDays
        };

        Reporting.setSpendTrendChartData(dataDays, vm.aggrByWeekdayData.chartData);

        return deferred.promise;
    }
}

angular.module('seatonApp').controller('CustomerProfileController', CustomerProfileController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customers.profile', {
                parent: 'customers',
                url: '/profile/:customerId',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/customer/profile/profile.html',
                        controller: 'CustomerProfileController',
                        controllerAs: 'customer'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

CustomerDashboardController.$inject = ['$q', '$state', '$filter', 'googleChartApiPromise', 'CustomerResource',
    'Reporting', 'ApplicationContext', 'LocationResource', 'ApplicationProfile'];

function CustomerDashboardController($q, $state, $filter, googleChartApiPromise, CustomerResource,
                                     Reporting, ApplicationContext, LocationResource, ApplicationProfile) {
    var vm = this;
    vm.showMoreFeedback = showMoreFeedback;
    vm.tabChange = tabChange;
    vm.calcPct = Reporting.calcPct;
    vm.settings = null;
    vm.search = search;
    vm.searchKeyword = null;

    vm.memberTypeEnabled = ApplicationProfile.isCustomerMemberTypeEnabled();
    vm.memberTypeText = ApplicationProfile.upgradeTierText("CustomerMembershipTypeStatistic");
    vm.growthTrendEnabled = ApplicationProfile.isCustomerGrowthTrendEnabled();
    vm.growthTrendText = ApplicationProfile.upgradeTierText("CustomerGrowthTrend");
    vm.openWindow = ApplicationProfile.openAppCloverPage;

    load();

    function load() {
        $q.all([
            loadGeneralData(),
            loadSettings(),
            googleChartApiPromise
        ]).then(loadInitialCharts).then(loadLastCustomers);
    }

    function loadSettings() {
        return LocationResource.getLocationSettings({}, function (settings) {
            vm.settings = settings;
            vm.numberOfAreas = vm.settings.areas.length;
        }).$promise;
    }

    function tabChange(tab) {
        switch (tab) {
            case 'generalStatsTab':
                $(window).resize();
                break;
            case 'visitTab':
                loadVisitsCharts().then($(window).resize());
                break;
            case 'growthTrendTab':
                //loadGrowthTrendData().then(loadGrowthTrendChart).then($(window).resize);
                if(vm.growthTrendEnabled) { loadGrowthTrendData().then(loadGrowthTrendChart); } //.then($(window).resize); //not needed possibly because of new version of google charts
                break;
            case 'memberTypeTab':
                if(vm.memberTypeEnabled) { loadMemberTypeData().then(loadMemberTypeChart); } //.then($(window).resize);
                break;
        }
    }

    function search() {
        $state.go('customers.list', {listType: 'basicSearch', keyword: vm.searchKeyword});
    }

    function showMoreFeedback() {
        ViewState.goToState('customer.feedback', {
            dates: {
                startDate: moment().subtract(1, 'year'),
                endDate: moment()
            }
        });
    }

    function loadGeneralData() {
        return CustomerResource.getDashboardGeneralData({}, function (data) {
            vm.generalData = data;
        }).$promise;
    }

    function loadGrowthTrendData() {
        return CustomerResource.getDashboardGrowthTrendData({}, function (data) {
            vm.growthTrendData = data;
        }).$promise;
    }

    function loadMemberTypeData() {
        return CustomerResource.getDashboardMemberTypeData({}, function (data) {
            vm.memberTypeData = data;
        }).$promise;
    }

    function loadLastCustomers() {
        return CustomerResource.lists(
            {
                listType: 'createdDate',
                page: 0,
                size: 10,
                sort: ['createdDate,desc', 'id']
            },
            function (data) {
                vm.customers = data;
            }).$promise;
    }

    function loadInitialCharts() {
        var deferred = $q.defer();
        // Regulars vs non-regulars
        var dataKnownVSUnknown = new google.visualization.DataTable();
        dataKnownVSUnknown.addColumn('string', 'CustomerType');
        dataKnownVSUnknown.addColumn('number', 'Revenue');
        dataKnownVSUnknown.addColumn({type: 'string', role: 'tooltip'})
        dataKnownVSUnknown.addColumn({type: 'string', role: 'style'})
        dataKnownVSUnknown.addColumn({type: 'string', role: 'annotation'});

        dataKnownVSUnknown.addRows([
            ['Regulars', vm.generalData.regulars.totalSpend, 'Revenue: ' + $filter('currency')(vm.generalData.regulars.totalSpend) + '\nTips: ' + $filter('currency')(vm.generalData.regulars.totalTips) + '\n Visits: ' + vm.generalData.regulars.totalVisits + '\n Avg spend per visit: ' + $filter('currency')(vm.generalData.regulars.avgSpendByVisit), '#1ABC9C', $filter('currency')(vm.generalData.regulars.totalSpend)],
            ['Non-regulars', vm.generalData.nonRegulars.amountSum, 'Revenue: ' + $filter('currency')(vm.generalData.nonRegulars.amountSum) + '\nTips: ' + $filter('currency')(vm.generalData.nonRegulars.tipSum) + '\n Visits: ' + vm.generalData.nonRegulars.visitsCount + '\n Avg spend per visit: ' + $filter('currency')(vm.generalData.nonRegulars.amountAvgPerVisit), '#CC3333', $filter('currency')(vm.generalData.nonRegulars.amountSum)],
        ]);

        var optionsKnownVSUnknown = {
            title: 'Regulars vs non-regulars',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            //width: 475,
            height: 300,
            vAxis: {
                title: 'Total Spend in ' + ApplicationContext.getCurrencySym(), gridlines: {count: 6}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            legend: 'none',
            formatters: {}
        };

        vm.chartObjectKnownVSUnknown = {
            type: "ColumnChart",
            options: optionsKnownVSUnknown,
            data: dataKnownVSUnknown
        };

        //vistis - membership pie chart
        vm.chartObjectMembership = {};
        vm.chartObjectMembership.type = "PieChart";

        vm.chartObjectMembership.options = {
            title: '# of customer by membership type',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            //width: 475,
            height: 325,
            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#CC9966'},
                2: {color: 'silver'},
                3: {color: 'gold'},
                4: {color: '#E5E4E2'}
            },
            chartArea: {width: '85%', height: '65%'}
        };

        var dataMembership = {};


        dataMembership.cols = [
            {id: "t", label: "Type", type: "string"},
            {id: "s", label: "Number", type: "number"}
        ];


        var pieChartArray = [];
        _.each(vm.generalData.countByLevel, function (item) {
            if (typeof item.customerLevel == "number") {//skip undefined items - in database customerLevel should not be null
                //dataMembership.addRow([vm.settings.memberStatuses[item.customerLevel - 1].name, item.customerCount]);
                var row = {
                    c: [
                        {v: vm.settings.memberStatuses[item.customerLevel - 1].name},
                        {v: item.customerCount}
                    ]
                };
                pieChartArray.push(row);
            }
        });

        vm.chartObjectMembership.data = dataMembership;
        vm.chartObjectMembership.data.rows = pieChartArray;

        deferred.resolve(true);
        return deferred.promise;
    }

    function loadVisitsCharts() {
        var deferred = $q.defer();
        //vistis - general pie chart
        vm.chartObjectVisitGeneral = {};
        vm.chartObjectVisitGeneral.type = "PieChart";

        vm.chartObjectVisitGeneral.options = {
            title: 'Visit statistics',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            legend: {position: 'right'},
            //width: 450,
            height: 350,

            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#3399CC'},
                2: {color: '#996699'}
            },
            chartArea: {width: '85%', height: '65%'}
        };

        vm.chartObjectVisitGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Reservation"},
                        {v: vm.generalData.regulars.totalReservationShow}
                    ]
                },
                {
                    c: [
                        {v: "Walk-in seated"},
                        {v: vm.generalData.regulars.totalWalkinSeated}
                    ]
                },
                {
                    c: [
                        {v: "Walk-in waitlisted"},
                        {v: vm.generalData.regulars.totalWaitlistShow}
                    ]
                }
            ]
        };

        //reservation - general pie chart
        vm.chartObjectReservationGeneral = {};
        vm.chartObjectReservationGeneral.type = "PieChart";

        vm.chartObjectReservationGeneral.options = {
            title: 'Reservation statistics',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            legend: {position: 'right'},
            //width: 450,
            height: 350,

            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#FF3333'},
                2: {color: '#FFCC33'}
            },
            chartArea: {width: '85%', height: '65%'}
        };

        vm.chartObjectReservationGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Show"},
                        {v: vm.generalData.regulars.totalReservationShow},
                    ]
                },
                {
                    c: [
                        {v: "No Show"},
                        {v: vm.generalData.regulars.totalReservationNoShow}
                    ]
                },
                {
                    c: [
                        {v: "Cancellation"},
                        {v: vm.generalData.regulars.totalReservationCanceled},
                    ]
                }
            ]
        };


        //waitlist - general pie chart
        vm.chartObjectWaitlistGeneral = {};
        vm.chartObjectWaitlistGeneral.type = "PieChart";

        vm.chartObjectWaitlistGeneral.options = {
            title: 'Waitlist statistics',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            legend: {position: 'right'},
            //width: 450,
            height: 350,

            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#FF3333'},
                2: {color: '#FFCC33'}
            },
            chartArea: {width: '85%', height: '65%'}

        };

        vm.chartObjectWaitlistGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Show"},
                        {v: vm.generalData.regulars.totalWaitlistShow},
                    ]
                },
                {
                    c: [
                        {v: "No Show"},
                        {v: vm.generalData.regulars.totalWaitlistNoShow}
                    ]
                },
                {
                    c: [
                        {v: "Cancellation"},
                        {v: vm.generalData.regulars.totalWaitlistCanceled},
                    ]
                }
            ]
        };

        deferred.resolve(true);
        return deferred.promise;
    }

    function loadGrowthTrendChart() {
        var deferred = $q.defer();
        // Growth trend
        var dataGrowthTrend = new google.visualization.DataTable();
        dataGrowthTrend.addColumn('string', 'Month');
        dataGrowthTrend.addColumn('number', '# new customers');
        dataGrowthTrend.addColumn({type: 'string', role: 'annotation'});

        _.each(vm.growthTrendData.customerCnt, function (item) {
            dataGrowthTrend.addRow([item.monthName, item.registeredCustomers, '' + item.registeredCustomers]);
        });


        var optionsGrowthTrend = {
            title: 'New customer registrations on monthly basis in last 12 months',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            legend: {position: 'none'},
            //width: 1050,
            height: 425,
            vAxis: {
                title: '# new customers', gridlines: {count: 6}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },
            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            chartArea: {width: '85%', height: '65%'},
            formatters: {},
            colors: ['#1ABC9C']
        };

        vm.chartObjectGrowthTrend = {
            type: "ColumnChart",
            options: optionsGrowthTrend,
            data: dataGrowthTrend
        };

        deferred.resolve(true);
        return deferred.promise;
    }

    function loadMemberTypeChart() {
        var deferred = $q.defer();
        // Member type stats - comperation
        var dataMemberTypeComperation = new google.visualization.DataTable();
        dataMemberTypeComperation.addColumn('string', 'Member type');
        dataMemberTypeComperation.addColumn('number', 'Customer');
        dataMemberTypeComperation.addColumn('number', 'Revenue');
        dataMemberTypeComperation.addColumn('number', 'Tip');
        dataMemberTypeComperation.addColumn('number', 'Visits');
        dataMemberTypeComperation.addColumn('number', 'No Show');

        _.each(vm.memberTypeData.data, function (item) {
            dataMemberTypeComperation.addRow([vm.settings.memberStatuses[item.customerLevel - 1].name, Number((item.customersPct * 100).toFixed(2)), Number((item.revenuePct * 100).toFixed(2)), Number((item.tipPct * 100).toFixed(2)), Number((item.visitsPct * 100).toFixed(2)), Number((item.noShowPct * 100).toFixed(2))]);
        });

        var optionsMemberTypeComperation = {
            title: 'Share of member types in certain areas (number, revenue, tip, visit, no show rate)',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            //width: 900,
            height: 300,
            vAxis: {
                title: '% Percentage',
                gridlines: {count: 6}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true},
                format: '#\'%\''
            },
            hAxis: {
                title: 'Member type',
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true},
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            //legend: { position: 'top', alignment: 'end'},
            //chartArea: {width: '70%', height: '65%'},
            formatters: {},
            colors: ['#3399FF', '#1ABC9C', '#00CC99', '#CCCC99', '#FF3333']

        };

        vm.chartObjectMemberTypeComperation = {
            type: "ColumnChart",
            options: optionsMemberTypeComperation,
            data: dataMemberTypeComperation
        };

        deferred.resolve(true);
        return deferred.promise;
    }
}

angular.module('seatonApp').controller('CustomerDashboardController', CustomerDashboardController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customers.dashboard', {
                parent: 'customers',
                url: '/dashboard',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/customer/dashboard/dashboard.html',
                        controller: 'CustomerDashboardController',
                        controllerAs: 'dashboard'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();


/**
 * Created by branimir on 26.3.2017..
 */
(function () {

    'use strict';
    angular.module('seatonApp')
        .directive('feedbacksWidget', function () {
            return {
                restrict: 'EA',
                scope: {
                    listScope: '@',
                    size: '@',
                    scopeId: '=scopeId',
                    title: '@'
                },
                templateUrl: 'app/customer/feedback/feedbacks.directive.html',
                controller: FeedbacksDirectiveController,
                controllerAs: 'vm',
                bindToController: true
            };
        });

    FeedbacksDirectiveController.$inject = ['FeedbackResource'];
    function FeedbacksDirectiveController(FeedbackResource) {
        var vm = this
        vm.feedbacks = [];
        vm.feedbackLimitInitial = 5;
        vm.feedbackLimit = vm.feedbackLimitInitial;
        console.log(vm);
        console.log(vm.scopeId);

        loadFeedbacks();

        function loadFeedbacks() {
            return FeedbackResource.getLastFeedbacks(
                {
                    listScope: vm.listScope,
                    scopeId: vm.scopeId,
                    size: vm.size
                }, function (data) {
                    vm.feedbacks = data;
                    var sumRating = 0;
                    _.each(vm.feedbacks, function (feedback) {
                        sumRating += feedback.rating;
                    })
                    vm.feedbackAverage = sumRating / vm.feedbacks.length;
                    console.log(vm.feedbacks);
                    console.log(vm.feedbackAverage);
                }).$promise;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('CustomerListController', CustomerListController);

    CustomerListController.$inject = ['$scope', '$state', '$stateParams', 'CustomerResource', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CustomerListController($scope, $state, $stateParams, CustomerResource, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;
        vm.errorMsg = null;
        vm.search = search;
        vm.sort = sort;
        vm.exportCSV = exportCSV;

        function search() {
            loadAll();
        }

        console.log('$stateParams and $state');
        console.log($stateParams);
        console.log($state);

        vm.listNames = {
            'newSinceLastLogin': 'Customers registered since last login',
            'createdDate': 'Customers by registration date',
            'totalSpend': 'Top regulars by spending',
            'avgSpendPerVisit': 'Top regulars by spend per visit',
            'totalVisits': 'Top regulars by number of visits',
            'totalReservation': 'Top regulars by number of reservations',
            'totalNoShow': 'Top regulars by no-show number',
            'totalCanceled': 'Top regulars by number of cancellations',

            'basicSearch': 'Customers matching defined criteria'
        };

        vm.searchKeyword = $stateParams.keyword;

        vm.listType = $stateParams.listType;
        if (vm.listType != 'basicSearch') {
            $stateParams.keyword = null;
            vm.predicate = $stateParams.listType;
            if (vm.searchKeyword != null) $state.go('customers.list', $stateParams, {notify: false}); //just change url - remove koyword as it's not needed
        } else
            vm.predicate = 'createdDate';

        vm.listName = vm.listNames[vm.listType];

        vm.loadPage = loadPage;
        vm.reload = reload;

        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        function reload() {
            console.log('changed listType:' + vm.listType);
            if (vm.listType != 'basicSearch') vm.predicate = vm.listType; else vm.predicate = 'createdDate';
            vm.transition();
        }

        loadAll();

        function loadAll() {
            vm.errorMsg = null;
            vm.customers = {};

            if (vm.listType == 'basicSearch') {
                console.log(vm.searchKeyword);

                if (typeof vm.searchKeyword === 'undefined') {
                    vm.errorMsg = "Search keyword not valid (too short)";
                    return;
                }
                if (vm.searchKeyword == null || vm.searchKeyword == '') {
                    return;
                }

                vm.searchKeyword = vm.searchKeyword.replace(/([A-Za-z])\1{2,}/g, '$1');

                if (vm.searchKeyword.length < 3) {
                    vm.errorMsg = "Search keyword not valid (too short)";
                    return;
                }

                $stateParams.keyword = vm.searchKeyword;
                $state.go('customers.list', $stateParams, {notify: false}); // change the URL, add keyword
            }

            CustomerResource.lists({
                listType: vm.listType,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                searchKeyword: vm.searchKeyword
            }, onSuccess, onError);


            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.customers = data;
                vm.page = pagingParams.page;
                if (vm.totalItems == 0) vm.errorMsg = 'No customers found matching criteria!';
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            console.log('transition: vm.predicate:' + vm.predicate + ' vm.listType:' + vm.listType);
            vm.listType = vm.predicate;

            $state.go($state.$current, {
                listType: vm.listType,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function exportCSV() {
            var allResults = [];
            var pageIndex = 0;
            searchRecursive(allResults, pageIndex);
        }

        function searchRecursive(allResults, pageIndex) {
            CustomerResource.lists(
                {
                    listType: vm.listType,
                    page: pageIndex,
                    size: 1500,
                    sort: sort(),
                    searchKeyword: vm.searchKeyword
                },
                function (data) {
                    var json1 = data;
                    // Check if there is any data in the current page
                    if (json1.length > 0) {
                        // Concatenate the results
                        allResults = allResults.concat(json1);
                        // Increment the pageIndex and continue searching
                        pageIndex++;
                        searchRecursive(allResults, pageIndex);
                    } else exportResultsToCSV(allResults);
                }
            );
        }

        function exportResultsToCSV(json1) {
            var json = [];
            for (var i = 0; i < json1.length; i++) {
                json.push(flattenJSON(json1[i])); //push flattened row
            }
            var fields = Object.keys(json[0]);
            var replacer = function (key, value) {
                return value === null ? '' : value
            }
            //flatten
            var csv = json.map(function (row) {
                return fields.map(function (fieldName) {
                    return JSON.stringify(row[fieldName], replacer)
                }).join(',')
            })
            csv.unshift(fields.join(',')) // add header column
            csv = csv.join('\r\n');

            var blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = 'customer_list.csv';
            a.click();
            URL.revokeObjectURL(url);
        }

        function flattenJSON(obj, prefix) {
            var flattened = {};
            if (!prefix) {
                prefix = "";
            }
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (typeof obj[key] === "object" && obj[key] !== null) {
                        var nested = flattenJSON(obj[key], prefix + key + ".");
                        flattened = Object.assign(flattened, nested);
                    } else {
                        flattened[prefix + key] = obj[key];
                    }
                }
            }
            return flattened;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customers.list', {
                parent: 'customers',
                url: '/list/:listType?keyword',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/customer/list/list.html',
                        controller: 'CustomerListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'totalSpend,desc',
                        squash: true
                    },
                    search: null,
                    listType: 'totalSpend'
                    , keyword: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {

    'use strict';

    CustomerSearchCtrl.$inject = ['$scope', '$state', 'CustomerSearch'];

    function CustomerSearchCtrl($scope, $state, CustomerSearch) {

        var vm = this;

        vm.currentPage = 1;
        vm.itemsPerPage = 5;

        // this will be two-way bound with some property from the parent field (look below)
        // if you want to perform some action on it just use $scope.$watch
        $scope.customerSearchKeyword;

        vm.refreshList = function() {

            if (!$scope.customerSearchKeyword) return; // can not search if keyword not defined

            CustomerSearch.searchCustomers(
                {
                    keyword: $scope.customerSearchKeyword,
                    page: vm.currentPage - 1,
                    size: vm.itemsPerPage
                },
                function (data) {
                    vm.customers = data.content;
                    vm.totalItems = data.totalElements;
                 });
        }

        vm.customerSelected = function(customer) {
            // send the selected customer to parent controller
            $scope.customerSelectedCallback(customer);
            vm.close();
        };

        /** Called when user changes a page */
        vm.pageChanged = function() {
            vm.refreshList();
        };

        vm.close = function() {
            // the same instance that was created in element.on('click',...)
            $scope.modalInstance.close();
        }
    }

    angular.module('seatonApp').controller('CustomerSearchCtrl', CustomerSearchCtrl);

})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .directive("customerSearchDialog", customerSearchDirective)
        .config(stateConfig);

    customerSearchDirective.$inject = ['$uibModal']
    stateConfig.$inject = ['$stateProvider'];

    function customerSearchDirective($uibModal) {
        return {
            controller: 'CustomerSearchCtrl',
            controllerAs: 'vm',
            scope : {
                customerSearchKeyword: '=', // here you will set two-way data bind with a property from the parent scope
                customerSelectedCallback: '='
            },

            link: function (scope, element, attrs) {

                element.on("click", function (event) { // when button is clicked we show the dialog
                    scope.modalInstance = $uibModal.open({
                        templateUrl: 'app/customer/search/customer.search.html',
                        scope: scope, // this will pass the isolated scope of search-dialog to the angular-ui modal,
                        windowClass: 'high-zindex',
                        size: 'lg',
                        controller: 'CustomerSearchCtrl',
                        controllerAs: 'vm'
                    });
                });
            }
        }
    }

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customer.search', {
                abstract: true,
                parent: 'customers',
                url: '/customer/search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Search customers'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/customer/search/customer.search.html',
                        controller: 'CustomerSearchCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('tables.management');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customers.create', {
                parent: 'customers',
                url: '/create/:customerId',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/customer/create/create.html',
                        controller: 'CustomerCreateController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('customers.create');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    PreviousState: [ '$state', function($state) {
                        return {
                            name: $state.current.name,
                            params: $state.params
                        };
                    }]
                }
            });
    }

})();

angular.module('seatonApp')
    .directive('chosen', chosenCtrl)
    .directive('addrList', addrListCtrl)
    .directive('isolateForm', [isolateFormCtrl]);

function isolateFormCtrl() {
    'use strict';
    return {
        restrict: 'A',
        require: '?form',
        link: linkCtrl
    };
}

linkCtrl.$inject = ['$scope', 'element', 'iAttrs', 'formController'];
function linkCtrl(scope, element, iAttrs, formController) {

    if (!formController) {
        return;
    }

    // Remove this form from parent controller
    formController.$$parentForm.$removeControl(formController);

    var _handler = formController.$setValidity;
    formController.$setValidity = function (validationErrorKey, isValid, cntrl) {
        _handler(validationErrorKey, isValid, cntrl);
        formController.$$parentForm.$setValidity(validationErrorKey, true, this);
    };
}

function chosenCtrl() {
    'use strict';
    var linker = function (scope, element, attr) {
        // update the select when data is loaded
        scope.$watch(attr.chosen, function (oldVal, newVal) {
            element.trigger('chosen:updated');
        });

        // update the select when the model changes
        scope.$watch(attr.ngModel, function () {
            element.trigger('chosen:updated');
        });

        element.chosen();
    };

    return {
        restrict: 'A',
        link: linker
    };
}


function addrListCtrl() {
    'use strict';
    return {
        scope: {
            addresses: '=model',
            debug: '@'
        },
        restrict: 'E',
        transclude: false,
        templateUrl: 'app/customer/create/partials/address_list.html',
        controller: addrList_Ctrl
    };
}

addrList_Ctrl.$inject = ['$scope', 'LocationResource', 'Utils'];
function addrList_Ctrl($scope, LocationResource, Utils) {
    $scope.formatAddress = Utils.formatAddress;
    $scope.codelists = $scope.$root.codelists;

    $scope.newAddress = {};

    $scope.us_selected = true;

    $scope.defaults = {};

    $scope.$watch(
        function (scope) {
            return scope.newAddress.country;
        },
        function () {
            $scope.us_selected = ('US' === $scope.newAddress.country);
        }
    );

    $scope.load = function () {
        LocationResource.getLocation({}, function (company) {
            $scope.defaults.country = company.country;
            $scope.defaults.countryState = company.countryState;
            $scope.defaults.city = company.city;
            $scope.initNewAddress();
        });
    };

    $scope.addAddress = function () {
        if (!$scope.addresses) $scope.addresses = [];
        var index = $scope.newAddress.index;
        if (!_.isUndefined(index)) {
            delete $scope.newAddress.index;
            $scope.addresses[index] = $scope.newAddress;
        } else {
            $scope.addresses.push($scope.newAddress);
        }
        $scope.initNewAddress();
    };

    $scope.initNewAddress = function () {
        $scope.newAddress = {};
        $scope.newAddress.country = $scope.defaults.country;
        $scope.newAddress.countryState = $scope.defaults.countryState;
        $scope.newAddress.city = $scope.defaults.city;
    };

    $scope.editAddress = function (index) {
        $scope.newAddress = _.clone($scope.addresses[index]);
        $scope.newAddress.index = index;
    };

    $scope.deleteAddress = function (index) {
        $scope.addresses.splice(index, 1);
    };

    $scope.load();

    $scope.countries = [
        {name: 'Afghanistan', code: 'AF'},
        {name: 'Åland Islands', code: 'AX'},
        {name: 'Albania', code: 'AL'},
        {name: 'Algeria', code: 'DZ'},
        {name: 'American Samoa', code: 'AS'},
        {name: 'Andorra', code: 'AD'},
        {name: 'Angola', code: 'AO'},
        {name: 'Anguilla', code: 'AI'},
        {name: 'Antarctica', code: 'AQ'},
        {name: 'Antigua and Barbuda', code: 'AG'},
        {name: 'Argentina', code: 'AR'},
        {name: 'Armenia', code: 'AM'},
        {name: 'Aruba', code: 'AW'},
        {name: 'Australia', code: 'AU'},
        {name: 'Austria', code: 'AT'},
        {name: 'Azerbaijan', code: 'AZ'},
        {name: 'Bahamas', code: 'BS'},
        {name: 'Bahrain', code: 'BH'},
        {name: 'Bangladesh', code: 'BD'},
        {name: 'Barbados', code: 'BB'},
        {name: 'Belarus', code: 'BY'},
        {name: 'Belgium', code: 'BE'},
        {name: 'Belize', code: 'BZ'},
        {name: 'Benin', code: 'BJ'},
        {name: 'Bermuda', code: 'BM'},
        {name: 'Bhutan', code: 'BT'},
        {name: 'Bolivia', code: 'BO'},
        {name: 'Bosnia and Herzegovina', code: 'BA'},
        {name: 'Botswana', code: 'BW'},
        {name: 'Bouvet Island', code: 'BV'},
        {name: 'Brazil', code: 'BR'},
        {name: 'British Indian Ocean Territory', code: 'IO'},
        {name: 'Brunei Darussalam', code: 'BN'},
        {name: 'Bulgaria', code: 'BG'},
        {name: 'Burkina Faso', code: 'BF'},
        {name: 'Burundi', code: 'BI'},
        {name: 'Cambodia', code: 'KH'},
        {name: 'Cameroon', code: 'CM'},
        {name: 'Canada', code: 'CA'},
        {name: 'Cape Verde', code: 'CV'},
        {name: 'Cayman Islands', code: 'KY'},
        {name: 'Central African Republic', code: 'CF'},
        {name: 'Chad', code: 'TD'},
        {name: 'Chile', code: 'CL'},
        {name: 'China', code: 'CN'},
        {name: 'Christmas Island', code: 'CX'},
        {name: 'Cocos (Keeling) Islands', code: 'CC'},
        {name: 'Colombia', code: 'CO'},
        {name: 'Comoros', code: 'KM'},
        {name: 'Congo', code: 'CG'},
        {name: 'Congo, The Democratic Republic of the', code: 'CD'},
        {name: 'Cook Islands', code: 'CK'},
        {name: 'Costa Rica', code: 'CR'},
        {name: 'Cote D\'Ivoire', code: 'CI'},
        {name: 'Croatia', code: 'HR'},
        {name: 'Cuba', code: 'CU'},
        {name: 'Cyprus', code: 'CY'},
        {name: 'Czech Republic', code: 'CZ'},
        {name: 'Denmark', code: 'DK'},
        {name: 'Djibouti', code: 'DJ'},
        {name: 'Dominica', code: 'DM'},
        {name: 'Dominican Republic', code: 'DO'},
        {name: 'Ecuador', code: 'EC'},
        {name: 'Egypt', code: 'EG'},
        {name: 'El Salvador', code: 'SV'},
        {name: 'Equatorial Guinea', code: 'GQ'},
        {name: 'Eritrea', code: 'ER'},
        {name: 'Estonia', code: 'EE'},
        {name: 'Ethiopia', code: 'ET'},
        {name: 'Falkland Islands (Malvinas)', code: 'FK'},
        {name: 'Faroe Islands', code: 'FO'},
        {name: 'Fiji', code: 'FJ'},
        {name: 'Finland', code: 'FI'},
        {name: 'France', code: 'FR'},
        {name: 'French Guiana', code: 'GF'},
        {name: 'French Polynesia', code: 'PF'},
        {name: 'French Southern Territories', code: 'TF'},
        {name: 'Gabon', code: 'GA'},
        {name: 'Gambia', code: 'GM'},
        {name: 'Georgia', code: 'GE'},
        {name: 'Germany', code: 'DE'},
        {name: 'Ghana', code: 'GH'},
        {name: 'Gibraltar', code: 'GI'},
        {name: 'Greece', code: 'GR'},
        {name: 'Greenland', code: 'GL'},
        {name: 'Grenada', code: 'GD'},
        {name: 'Guadeloupe', code: 'GP'},
        {name: 'Guam', code: 'GU'},
        {name: 'Guatemala', code: 'GT'},
        {name: 'Guernsey', code: 'GG'},
        {name: 'Guinea', code: 'GN'},
        {name: 'Guinea-Bissau', code: 'GW'},
        {name: 'Guyana', code: 'GY'},
        {name: 'Haiti', code: 'HT'},
        {name: 'Heard Island and Mcdonald Islands', code: 'HM'},
        {name: 'Holy See (Vatican City State)', code: 'VA'},
        {name: 'Honduras', code: 'HN'},
        {name: 'Hong Kong', code: 'HK'},
        {name: 'Hungary', code: 'HU'},
        {name: 'Iceland', code: 'IS'},
        {name: 'India', code: 'IN'},
        {name: 'Indonesia', code: 'ID'},
        {name: 'Iran, Islamic Republic Of', code: 'IR'},
        {name: 'Iraq', code: 'IQ'},
        {name: 'Ireland', code: 'IE'},
        {name: 'Isle of Man', code: 'IM'},
        {name: 'Israel', code: 'IL'},
        {name: 'Italy', code: 'IT'},
        {name: 'Jamaica', code: 'JM'},
        {name: 'Japan', code: 'JP'},
        {name: 'Jersey', code: 'JE'},
        {name: 'Jordan', code: 'JO'},
        {name: 'Kazakhstan', code: 'KZ'},
        {name: 'Kenya', code: 'KE'},
        {name: 'Kiribati', code: 'KI'},
        {name: 'Korea, Democratic People\'s Republic of', code: 'KP'},
        {name: 'Korea, Republic of', code: 'KR'},
        {name: 'Kuwait', code: 'KW'},
        {name: 'Kyrgyzstan', code: 'KG'},
        {name: 'Lao People\'s Democratic Republic', code: 'LA'},
        {name: 'Latvia', code: 'LV'},
        {name: 'Lebanon', code: 'LB'},
        {name: 'Lesotho', code: 'LS'},
        {name: 'Liberia', code: 'LR'},
        {name: 'Libyan Arab Jamahiriya', code: 'LY'},
        {name: 'Liechtenstein', code: 'LI'},
        {name: 'Lithuania', code: 'LT'},
        {name: 'Luxembourg', code: 'LU'},
        {name: 'Macao', code: 'MO'},
        {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
        {name: 'Madagascar', code: 'MG'},
        {name: 'Malawi', code: 'MW'},
        {name: 'Malaysia', code: 'MY'},
        {name: 'Maldives', code: 'MV'},
        {name: 'Mali', code: 'ML'},
        {name: 'Malta', code: 'MT'},
        {name: 'Marshall Islands', code: 'MH'},
        {name: 'Martinique', code: 'MQ'},
        {name: 'Mauritania', code: 'MR'},
        {name: 'Mauritius', code: 'MU'},
        {name: 'Mayotte', code: 'YT'},
        {name: 'Mexico', code: 'MX'},
        {name: 'Micronesia, Federated States of', code: 'FM'},
        {name: 'Moldova, Republic of', code: 'MD'},
        {name: 'Monaco', code: 'MC'},
        {name: 'Mongolia', code: 'MN'},
        {name: 'Montserrat', code: 'MS'},
        {name: 'Morocco', code: 'MA'},
        {name: 'Mozambique', code: 'MZ'},
        {name: 'Myanmar', code: 'MM'},
        {name: 'Namibia', code: 'NA'},
        {name: 'Nauru', code: 'NR'},
        {name: 'Nepal', code: 'NP'},
        {name: 'Netherlands', code: 'NL'},
        {name: 'Netherlands Antilles', code: 'AN'},
        {name: 'New Caledonia', code: 'NC'},
        {name: 'New Zealand', code: 'NZ'},
        {name: 'Nicaragua', code: 'NI'},
        {name: 'Niger', code: 'NE'},
        {name: 'Nigeria', code: 'NG'},
        {name: 'Niue', code: 'NU'},
        {name: 'Norfolk Island', code: 'NF'},
        {name: 'Northern Mariana Islands', code: 'MP'},
        {name: 'Norway', code: 'NO'},
        {name: 'Oman', code: 'OM'},
        {name: 'Pakistan', code: 'PK'},
        {name: 'Palau', code: 'PW'},
        {name: 'Palestinian Territory, Occupied', code: 'PS'},
        {name: 'Panama', code: 'PA'},
        {name: 'Papua New Guinea', code: 'PG'},
        {name: 'Paraguay', code: 'PY'},
        {name: 'Peru', code: 'PE'},
        {name: 'Philippines', code: 'PH'},
        {name: 'Pitcairn', code: 'PN'},
        {name: 'Poland', code: 'PL'},
        {name: 'Portugal', code: 'PT'},
        {name: 'Puerto Rico', code: 'PR'},
        {name: 'Qatar', code: 'QA'},
        {name: 'Reunion', code: 'RE'},
        {name: 'Romania', code: 'RO'},
        {name: 'Russian Federation', code: 'RU'},
        {name: 'Rwanda', code: 'RW'},
        {name: 'Saint Helena', code: 'SH'},
        {name: 'Saint Kitts and Nevis', code: 'KN'},
        {name: 'Saint Lucia', code: 'LC'},
        {name: 'Saint Pierre and Miquelon', code: 'PM'},
        {name: 'Saint Vincent and the Grenadines', code: 'VC'},
        {name: 'Samoa', code: 'WS'},
        {name: 'San Marino', code: 'SM'},
        {name: 'Sao Tome and Principe', code: 'ST'},
        {name: 'Saudi Arabia', code: 'SA'},
        {name: 'Senegal', code: 'SN'},
        {name: 'Serbia and Montenegro', code: 'CS'},
        {name: 'Seychelles', code: 'SC'},
        {name: 'Sierra Leone', code: 'SL'},
        {name: 'Singapore', code: 'SG'},
        {name: 'Slovakia', code: 'SK'},
        {name: 'Slovenia', code: 'SI'},
        {name: 'Solomon Islands', code: 'SB'},
        {name: 'Somalia', code: 'SO'},
        {name: 'South Africa', code: 'ZA'},
        {name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
        {name: 'Spain', code: 'ES'},
        {name: 'Sri Lanka', code: 'LK'},
        {name: 'Sudan', code: 'SD'},
        {name: 'Suriname', code: 'SR'},
        {name: 'Svalbard and Jan Mayen', code: 'SJ'},
        {name: 'Swaziland', code: 'SZ'},
        {name: 'Sweden', code: 'SE'},
        {name: 'Switzerland', code: 'CH'},
        {name: 'Syrian Arab Republic', code: 'SY'},
        {name: 'Taiwan, Province of China', code: 'TW'},
        {name: 'Tajikistan', code: 'TJ'},
        {name: 'Tanzania, United Republic of', code: 'TZ'},
        {name: 'Thailand', code: 'TH'},
        {name: 'Timor-Leste', code: 'TL'},
        {name: 'Togo', code: 'TG'},
        {name: 'Tokelau', code: 'TK'},
        {name: 'Tonga', code: 'TO'},
        {name: 'Trinidad and Tobago', code: 'TT'},
        {name: 'Tunisia', code: 'TN'},
        {name: 'Turkey', code: 'TR'},
        {name: 'Turkmenistan', code: 'TM'},
        {name: 'Turks and Caicos Islands', code: 'TC'},
        {name: 'Tuvalu', code: 'TV'},
        {name: 'Uganda', code: 'UG'},
        {name: 'Ukraine', code: 'UA'},
        {name: 'United Arab Emirates', code: 'AE'},
        {name: 'United Kingdom', code: 'GB'},
        {name: 'United States', code: 'US'},
        {name: 'United States Minor Outlying Islands', code: 'UM'},
        {name: 'Uruguay', code: 'UY'},
        {name: 'Uzbekistan', code: 'UZ'},
        {name: 'Vanuatu', code: 'VU'},
        {name: 'Venezuela', code: 'VE'},
        {name: 'Vietnam', code: 'VN'},
        {name: 'Virgin Islands, British', code: 'VG'},
        {name: 'Virgin Islands, U.S.', code: 'VI'},
        {name: 'Wallis and Futuna', code: 'WF'},
        {name: 'Western Sahara', code: 'EH'},
        {name: 'Yemen', code: 'YE'},
        {name: 'Zambia', code: 'ZM'},
        {name: 'Zimbabwe', code: 'ZW'}
    ];

    $scope.us_states = [
        {code: "AL", name: 'Alabama'},
        {code: "AK", name: 'Alaska'},
        {code: "AZ", name: 'Arizona'},
        {code: "AR", name: 'Arkansas'},
        {code: "CA", name: 'California'},
        {code: "CO", name: 'Colorado'},
        {code: "CT", name: 'Connecticut'},
        {code: "DE", name: 'Delaware'},
        {code: "DC", name: 'District Of Columbia'},
        {code: "FL", name: 'Florida'},
        {code: "GA", name: 'Georgia'},
        {code: "HI", name: 'Hawaii'},
        {code: "ID", name: 'Idaho'},
        {code: "IL", name: 'Illinois'},
        {code: "IN", name: 'Indiana'},
        {code: "IA", name: 'Iowa'},
        {code: "KS", name: 'Kansas'},
        {code: "KY", name: 'Kentucky'},
        {code: "LA", name: 'Louisiana'},
        {code: "ME", name: 'Maine'},
        {code: "MD", name: 'Maryland'},
        {code: "MA", name: 'Massachusetts'},
        {code: "MI", name: 'Michigan'},
        {code: "MN", name: 'Minnesota'},
        {code: "MS", name: 'Mississippi'},
        {code: "MO", name: 'Missouri'},
        {code: "MT", name: 'Montana'},
        {code: "NE", name: 'Nebraska'},
        {code: "NV", name: 'Nevada'},
        {code: "NH", name: 'New Hampshire'},
        {code: "NJ", name: 'New Jersey'},
        {code: "NM", name: 'New Mexico'},
        {code: "NY", name: 'New York'},
        {code: "NC", name: 'North Carolina'},
        {code: "ND", name: 'North Dakota'},
        {code: "OH", name: 'Ohio'},
        {code: "OK", name: 'Oklahoma'},
        {code: "OR", name: 'Oregon'},
        {code: "PA", name: 'Pennsylvania'},
        {code: "RI", name: 'Rhode Island'},
        {code: "SC", name: 'South Carolina'},
        {code: "SD", name: 'South Dakota'},
        {code: "TN", name: 'Tennessee'},
        {code: "TX", name: 'Texas'},
        {code: "UT", name: 'Utah'},
        {code: "VT", name: 'Vermont'},
        {code: "VA", name: 'Virginia'},
        {code: "WA", name: 'Washington'},
        {code: "WV", name: 'West Virginia'},
        {code: "WI", name: 'Wisconsin'},
        {code: "WY", name: 'Wyoming'}
    ];


}

angular.module('seatonApp')
    .directive('allergyList', allergyListCtrl);

function allergyListCtrl() {
    'use strict';
    return {
        scope: {
            'selectedAllergies': '=model',
            'debug': '@'
        },
        restrict: 'E',
        transclude: false,
        templateUrl: 'app/customer/create/partials/allergy_list.html',
        controllerAs: 'allergyCtrl',
        bindToController: true,
        controller: allergyCtrl
    };
}

allergyCtrl.$inject = ['$scope'];
function allergyCtrl($scope) {



    var ctrl = this;
    ctrl.codelists = $scope.$root.codelists;
    ctrl.predefinedAllergies = {};
    ctrl.otherAllergies = [];

    ctrl._allergies = [
        {name: 'Peanuts', value: 'PEANUTS'},
        {name: 'Milk', value: 'MILK'},
        {name: 'Soy', value: 'SOY'},
        {name: 'Eggs', value: 'EGGS'},
        {name: 'Wheat', value: 'WHEAT'},
        {name: 'Tree nuts', value: 'TREE_NUTS'},
        {name: 'Fish', value: 'FISH'},
        {name: 'Shellfish', value: 'SHELLFISH'},
        {name: 'Seeds', value: 'SEEDS'},
        {name: 'Other', value: 'OTHER'}
    ];

    function load() {
        if (_.isUndefined(ctrl.selectedAllergies)) {
            ctrl.selectedAllergies = {};
        }
        _.each(ctrl._allergies, function (allergy) {
            if ('OTHER' !== allergy.value) {
                var isChecked = false;
                if (ctrl.selectedAllergies[allergy.name]) {
                    isChecked = true;
                }
                ctrl.predefinedAllergies[allergy.name] = {
                    checked: isChecked,
                    allergy: {otherName: allergy.name, allergyType: allergy.value}
                };
            }
        });
        ctrl.otherAllergies = [];
        _.each(ctrl.selectedAllergies, function (allergy) {
            if ('OTHER' === allergy.allergyType) {
                ctrl.otherAllergies.push(allergy);
            }
        });
    }

    load();

    $scope.$watch(angular.bind(ctrl, function () {
            return this.selectedAllergies;
        }),
        function (newVal, oldVal) {
            if (newVal) {
                load();
            }
        });

    ctrl.newAllergy = function (el) {
        ctrl.selectedAllergies[el.otherName] = _.extend(el, {'allergyType': 'OTHER'});
    };

    ctrl.removeAllergy = function (el) {
        delete ctrl.selectedAllergies[el.otherName];
    };

    ctrl.updateAllergies = function (av) {
        if (av.checked === true && _.isUndefined(ctrl.selectedAllergies[av.allergy.otherName])) {
            ctrl.selectedAllergies[av.allergy.otherName] = av.allergy;
        } else if (av.checked === false && av.allergy.otherName in ctrl.selectedAllergies) {
            delete ctrl.selectedAllergies[av.allergy.otherName];
        }
    };

}

angular.module('seatonApp')
    .directive('emailList', emailListCtrl);

function emailListCtrl() {
    'use strict';
    return {
        scope: {
            items: '=ngModel'
        },
        restrict: 'E',
        transclude: true,
        require: ['ngModel', '^form'],
        templateUrl: 'app/customer/create/partials/email_list.html',
        link: function (scope, elem, attrs, ctrls) {
            scope.ngModelCtrl = ctrls[0];
            scope.ngFormCtrl = ctrls[1];
        },
        controller: emailCtrl
    }
}

emailCtrl.$inject = ['$scope'];
function emailCtrl($scope) {

    $scope.newItem = {};

    $scope.addItem = function () {
        var propertyName = 'email';

        //if new email not defined or email input field is empty  - return
        if (!$scope.newItem[propertyName] || $scope.newItem[propertyName].trim() == '') {
            $scope.newItem = {};
            return;
        }

        //if format of email is not valid - also return
        if (!$scope.ngFormCtrl.email.$valid) {
            return;
        }

        var index = $scope.newItem.index;
        if (!_.isUndefined(index)) {
            delete $scope.newItem.index;
            $scope.items[index] = $scope.newItem;
        } else {
            if ($scope.newItem[propertyName]) {
                $scope.items.push($scope.newItem);
            }
        }
        $scope.newItem = {};
        validate();
    };

    $scope.editItem = function (index) {
        $scope.newItem = _.clone($scope.items[index]);
        $scope.newItem.index = index;
    };

    $scope.deleteItem = function (index) {
        $scope.items.splice(index, 1);
        validate();
    };

    $scope.makePrimary = function (index) {
        _.each($scope.items, function (email) {
            email.primaryEmail = false;
        });
        $scope.items[index].primaryEmail = true;
        validate();
    };

    function validate() {
        $scope.ngModelCtrl.$setDirty();
        $scope.ngModelCtrl.$validate();
    }
}

angular.module('seatonApp')
    .directive('phoneList', phoneListCtrl);

function phoneListCtrl() {
    'use strict';
    return {
        scope: {
            items: '=ngModel'
        },
        restrict: 'E',
        transclude: true,
        require: ['ngModel', '^form'],
        templateUrl: 'app/customer/create/partials/phone_list.html',
        link: function (scope, elem, attrs, ctrls) {
            scope.ngModelCtrl = ctrls[0];
            scope.ngFormCtrl = ctrls[1];
        },
        controller: phone_Ctrl
    };
}

phone_Ctrl.$inject = ['$scope', '$document', 'ApplicationContext'];

function phone_Ctrl($scope, $document, ApplicationContext) {

    $scope.newItem = {};

    $scope.phoneRegion = ApplicationContext.getPhoneRegion();
    $scope.phonePrefix = ApplicationContext.getPhoneCountryPrefix();

    $scope.reformatPhone = function () {
        $scope.numInput = $document.find('#phoneNumber');
        if (typeof intlTelInputUtils !== 'undefined') { // utils are lazy loaded, so must check
            var currentText = $scope.numInput.intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
            if (typeof currentText === 'string') { // sometimes the currentText is an object :)
                $scope.numInput.intlTelInput('setNumber', currentText); // will autoformat because of formatOnDisplay=true
            }
        }
    }

    /*

    $document.ready(
        function () {
            $scope.numInput = $document.find('#phoneNumber');

            $scope.numInput.intlTelInput({
                utilsScript: "bower_components/intl-tel-input/build/js/utils.js",
                initialCountry: ApplicationContext.getPhoneRegion(),
                preferredCountries: [ApplicationContext.getPhoneRegion()],
                nationalMode: false,
                formatOnDisplay: true // SET THIS!!!
            });

            $scope.numInput.on("keyup change", resetIntlTelInput);

            function resetIntlTelInput() {
                if (typeof intlTelInputUtils !== 'undefined') { // utils are lazy loaded, so must check
                    var currentText = $scope.numInput.intlTelInput("getNumber", intlTelInputUtils.numberFormat.E164);
                    if (typeof currentText === 'string') { // sometimes the currentText is an object :)
                        $scope.numInput.intlTelInput('setNumber', currentText); // will autoformat because of formatOnDisplay=true
                    }
                }
            }
        }
    );

    $scope.myCustomValidationFunction = function (phoneNumber) {

        console.log(phoneNumber);

        return false;
    }
    */


    $scope.addItem = function () {
        var propertyName = 'phoneNumber';
        if (!$scope.newItem[propertyName] || $scope.newItem[propertyName].trim() == '') {
            $scope.newItem = {};
            return;
        }

        var index = $scope.newItem.index;
        if (!_.isUndefined(index)) {
            delete $scope.newItem.index;
            $scope.items[index] = $scope.newItem;
        } else {
            if ($scope.newItem[propertyName]) {
                $scope.items.push($scope.newItem);
            }
        }
        $scope.initItem();
        validate();
    };

    $scope.initItem = function () {
        $scope.newItem = {};
        $scope.phoneType = 1;
    };

    $scope.editItem = function (index) {
        $scope.newItem = _.clone($scope.items[index]);
        $scope.newItem.index = index;
    };

    $scope.deleteItem = function (index) {
        $scope.items.splice(index, 1);
        validate();
    };

    $scope.makePrimary = function (index) {
        _.each($scope.items, function (phone) {
            phone.primaryPhone = false;
        });
        $scope.items[index].primaryPhone = true;
        validate();
    };

    function validate() {
        $scope.ngModelCtrl.$setDirty();
        $scope.ngModelCtrl.$validate();
    }

}

'use strict';

function ngEnterDirective() {
    var link = function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if (event.which === 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.ngEnter);
                });

                event.preventDefault();
            }
        });
    };
    var directive = {
        link: link
    };
    return directive;
}

//ImportantDatesListController.$inject = ['$scope', 'datepickerPopupConfig', '$filter'];
//function ImportantDatesListController($scope, datepickerPopupConfig, $filter) {
ImportantDatesListController.$inject = ['$scope', '$filter', '$document'];
function ImportantDatesListController($scope, $filter, $document) {
    var vm = this;
    // data model:
    vm.codelists = $scope.$root.codelists;
    vm.dateformat = 'yyyy-MM-dd';
    vm.datepicker_options = {
        class: 'datepicker',
        showWeeks: false,
        format: vm.dateformat  // ISO 8601
    };

    function getPicker(inputName) {
        return $document.find('input[name="' + inputName + '"]');
    }

    function openPicker(inputName) {
        getPicker(inputName).focus();
    }

    function clearPicker(inputName) {
        getPicker(inputName).val('');
    }

    function dPickerInit(inputName, initDate) {
        console.log('dPickerInit:' + inputName + '   :' + initDate);
        var pickerObj
        pickerObj = $document.find('input[name="' + inputName + '"]');
        console.log(pickerObj);
        pickerObj.daterangepicker(
            {
                //configuration parameters
                autoUpdateInput: false,
                singleDatePicker: true,
                showDropdowns: true,
                locale: {format: 'MMM D, YYYY'}
                //startDate: (!initDate ? '' : initDate)
            },
            function (start, end, label) {
                //callback function - called on picker value change - dates sent in callback
                //console.log('inputName:' + inputName)
                //console.log(vm.otherDates);
                if (inputName == 'picker_birthday') {
                    vm.birthday.value = start;
                    updateImportantDates(vm.birthday, null, vm.birthday.value);
                } else if (inputName == 'picker_anniversary') {
                    vm.anniversary.value = start;
                    updateImportantDates(vm.anniversary, 'BIRTHDAY', vm.anniversary.value);
                } else if (inputName.startsWith("otherDate_")) {
                    var idx = parseInt(inputName.replace(/[^0-9]/g, ''));
                    vm.otherDates[idx].value = start;
                }
            }
        );

        pickerObj.on('apply.daterangepicker', function (ev, picker) {
            $(this).val(picker.startDate.format('MMM D, YYYY'));
        });

        pickerObj.on('cancel.daterangepicker', function (ev, picker) {
            $(this).val('');
        });

        //initial datepicker values
        //console.log('dPickerInit   2:' + inputName + '   :' + initDate);
        if (initDate != null) {
            pickerObj.data('daterangepicker').setStartDate(moment(initDate));
            pickerObj.data('daterangepicker').setEndDate(moment(initDate));
            pickerObj.val(moment(initDate).format('MMM D, YYYY'));
        }
    }

    $document.ready(
        function () {
            dPickerInit('picker_anniversary', vm.anniversary.value);
            dPickerInit('picker_birthday', vm.birthday.value);
            for (var i = 0; i < vm.otherDates.length; i++)
                dPickerInit('otherDate_' + i + '_date', vm.otherDates[i].value);
        }
    );

    vm.birthday = {
        dateType: 'BIRTHDAY',
        value: null,
        opened: false
    };
    vm.anniversary = {
        dateType: 'ANNIVERSARY',
        value: null,
        opened: false
    };
    vm.otherDates = []; // dateType: 'OTHER', otherName: '',

    // controller methods:
    vm.clearBirthday = clearBirthday;
    vm.clearAnniversary = clearAnniversary;
    vm.removeOtherDate = removeOtherDate;
    vm.newOtherDate = newOtherDate;

    vm.addImportantDate = addImportantDate;

    vm.openBirthday = openBirthday;
    vm.openAnniversary = openAnniversary;
    vm.openImportantDate = openImportantDate;

    function openBirthday() {
        vm.birthday.opened = !vm.birthday.opened;
        openPicker('picker_birthday');
    }

    function openAnniversary() {
        vm.anniversary.opened = !vm.anniversary.opened;
        openPicker('picker_anniversary');
    }

    function openImportantDate(index) {
        vm.otherDates[index].opened = !vm.otherDates[index].opened;
        openPicker('otherDate_' + index + '_date');
    }

    function removeOtherDate(index) {
        var removedItem = vm.otherDates[index];
        vm.otherDates.splice(index, 1);
        var importantDateIndex = _.findIndex(vm.importantDates, function (elem) {
            return elem === removedItem;
        });
        if (importantDateIndex > -1) {
            vm.importantDates.splice(importantDateIndex, 1);
        }
    }

    function newOtherDate() {
        var newDateVal = {
            dateType: 'OTHER',
            value: null
        };
        vm.otherDates.push(newDateVal);
        vm.addImportantDate(newDateVal);

        var idx = vm.otherDates.length - 1;
        //TODO 1 branimir - tbd test - find better way to init datePickers
        $document.ready(
            function () {
                dPickerInit('otherDate_' + idx + '_date', vm.otherDates[idx].value);
            });
        return newDateVal;
    }

    function clearBirthday() {
        vm.birthday.value = null;
        clearPicker('picker_birthday');
    }

    function clearAnniversary() {
        vm.anniversary.value = null;
        clearPicker('picker_anniversary');
    }

    function addImportantDate(date) {
        vm.importantDates.push(date);
    }

    function watch(date, relativeTo) {
        //console.log('watch ' + date + ' relativeTo:' + relativeTo);
        $scope.$watch(angular.bind(vm, function () {
                return date.value;
            }),
            function (newVal, oldVal) {
                //console.log('watch' + ' ' + date + '  newVal:' + newVal);
                updateImportantDates(date, relativeTo, newVal);
            }
        );
    }

    function updateImportantDates(date, relativeTo, newVal) {
        var index = indexOf(vm.importantDates, date.dateType);
        if (newVal !== null) {
            if (index > -1) {
                vm.importantDates.splice(index, 1, date);
            } else {
                var relativeIndex = -1;
                if (relativeTo) {
                    relativeIndex = indexOf(vm.importantDates, relativeTo);
                }
                vm.importantDates.splice(relativeIndex + 1, 0, date);
            }
        } else {
            if (index > -1) {
                vm.importantDates.splice(index, 1);
            }
        }
    }

    function indexOf(col, dateType) {
        return _.findIndex(col, function (elem) {
            return elem.dateType === dateType;
        });
    }

    $scope.$watch(angular.bind(vm, function () {
            return this.importantDates;
        }),
        changedImportantDates
    );

    function changedImportantDates(newVal, oldVal) {
        //console.log('$scope.$watch newVal:' + newVal);
        _.each(newVal, function (item) {
            switch (item.dateType) {
                case 'BIRTHDAY':
                    vm.birthday.value = item.value;
                    break;
                case 'ANNIVERSARY':
                    vm.anniversary.value = item.value;
                    break;
                case 'OTHER':
                    var index = _.findIndex(vm.otherDates, function (elem) {
                        return elem.otherName === item.otherName;
                    });
                    if (index > -1) {
                        vm.otherDates.splice(index, 1, item);
                    } else {
                        vm.otherDates.push(item);
                    }
                    break;
            }
        });
    }

    watch(vm.birthday);
    watch(vm.anniversary, 'BIRTHDAY');
}

function importantDatesListDirective() {
    var directive = {
        scope: {
            importantDates: '=model',
            debug: '@'
        },
        restrict: 'E',
        transclude: false,
        templateUrl: 'app/customer/create/partials/important_dates.html',
        controller: ImportantDatesListController,
        controllerAs: 'vm',
        bindToController: true
    };
    return directive;
}

angular.module('seatonApp').directive('ngEnter', ngEnterDirective);
angular.module('seatonApp').directive('importantDatesList', importantDatesListDirective);

angular.module('seatonApp')
    .directive('favoriteTable', favoriteTableDirective);

function favoriteTableDirective() {
    'use strict';
    return {
        scope: {
            favorite_table: '=model',
            areas: '=',
            debug: '@',
            readonly: '='
        },
        restrict: 'EA',
        transclude: false,
        templateUrl: 'app/customer/create/partials/favorite_table.html',
        controllerAs: 'ctrl',
        bindToController: true,
        controller: favCtrl
    };
}

favCtrl.$inject = ['$scope'];
function favCtrl($scope) {
    var ctrl = this;
    ctrl.selected_area = {};
    ctrl.resources_with_areas = [];

    $scope.$watch('ctrl.areas', ctrlAreasWatch);

    $scope.$watch('ctrl.favorite_table', ctrlFavWatch);

    function searchResourceAreas(tableId) {
        var ra = _.find(ctrl.resources_with_areas, function (ra) {
            return tableId === ra.resource.id;
        });
        return ra;
    }

    function updateSelectedTable() {
        //console.log('ctrl.favorite_table:' + ctrl.favorite_table);
        //console.log(ctrl.favorite_table);
        if (ctrl.favorite_table) {
            var r = searchResourceAreas(ctrl.favorite_table.id);
            if (r) {
                ctrl.selected_area = r.area;
                ctrl.favorite_table = r.resource;
            }
        }
    }



    //ctrlAreasWatch.$inject = ['newVal'];
    function ctrlAreasWatch(newVal) {
        if (newVal) {
            var flatMap = _.compose(_.flatten, _.map);
            ctrl.resources_with_areas = flatMap(ctrl.areas, function (ar) {
                return _.map(ar.resources, function (resource) {
                    return {resource: resource, area: ar};
                });
            });
            updateSelectedTable();
        }
    }

    //ctrlFavWatch.$inject = ['newVal', 'oldVal'];
    function ctrlFavWatch(newVal, oldVal) {
        if (newVal) {
            updateSelectedTable();
        }
    }
}



angular.module('seatonApp')
       .directive('validateEmail', [validateEmail]);

function validateEmail() {

    var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // most common domains taken from t_email_address
    var KNOWN_EMAIL_DOMAINS = [
        "gmail.com", "yahoo.com", "hotmail.com", "aol.com", "comcast.net", "icloud.com",
        "msn.com", "me.com", "outlook.com", "sbcglobal.net", "live.com", "verizon.net",
        "att.net", "mac.com", "cox.net", "ymail.com", "hotmail.co.uk", "btinternet.com",
        "yahoo.co.uk", "sky.com", "protonmail.com", "googlemail.com", "live.co.uk",
        "benefis.org", "colostate.edu"
    ];

    function isEmailDomainValid(domain) {

        if (!domain) {
            return false;
        } else if (KNOWN_EMAIL_DOMAINS.indexOf(domain) >= 0) {
            return true;
        }

        var xhttp = new XMLHttpRequest();

        xhttp.open("GET", 'api/v1/public/domain_validation?domain=' + domain, false);
        xhttp.send(null);

        if (xhttp.status === 200) {
            var responseObj = JSON.parse(xhttp.responseText);
            if (responseObj.valid === true) {
                return true;
            }
        }
        return false;
    }

    function isEmailValid(email) {
        // must have a '@' and a '.' inside
        if (!email || !EMAIL_REGEX.test(email)) {
            console.log('Regex check FAIL (or empty)');
            return false;
        }
        var emailDomain = email.substring(email.indexOf('@') + 1);
        return isEmailDomainValid(emailDomain);
    }

    return {
        require: '?ngModel',
        link: function(scope, elm, attrs, ctrl) {
            // only apply the validator if ngModel is present and Angular has added the email validator
            if (ctrl && ctrl.$validators.email) {
                // this will overwrite the default Angular email validator
                ctrl.$validators.email = function (modelValue) {
                    var valid = isEmailValid(modelValue);
                    console.log('Email: ' + modelValue + ", valid: " + valid);
                    return ctrl.$isEmpty(modelValue) || valid;
                };
            }
        }
    }
}

'use strict';

angular.module('seatonApp').controller('CustomerCreateController', CustomerCreateController);
// services to use: Customer (customer), CodeList (predefined allergies), Resource (tables)

CustomerCreateController.$inject = ['$scope', '$state', '$stateParams', 'Notification', 'CustomerResource', 'ApplicationContext', 'LocationResource', 'PreviousState', '$timeout', '$document'];
function CustomerCreateController($scope, $state, $stateParams, Notification, CustomerResource, ApplicationContext, LocationResource, PreviousState, $timeout, $document) {
    $scope.customer = {
        reservationAllowed: true,
        waitlistAllowed: true,
        importantDates: [],
        emailAddresses: [],
        phoneNumbers: []
    };

    $scope.dataIsloaded = false;

    $scope.defaults = {};

    $scope.tables = [];

    $scope.areas = [];

    $scope.load = function (customerId) {
        if (customerId) {
            $scope.customer = CustomerResource.get({id: customerId}, function (data) {
                    var old = data.allergies;
                    data.allergies = {};
                    _.each(old, function (al) {
                        data.allergies[al.otherName] = al;
                    });
                    $scope.customer.favoriteTable = data.favoriteTable;
                    if (_.isUndefined($scope.customer.importantDates)) {
                        $scope.customer.importantDates = [];
                    }
                    $scope.dataIsloaded = true;
                }
            );
        } else {
            loadLocation();
            $scope.dataIsloaded = true;
        }

        if (_.isUndefined($scope.customer.importantDates)) {
            $scope.customer.importantDates = [];
        }

        //TODO 4 branimir check - add load of settings FIRST
        loadSettings();

        return $scope.customer;
    };

    function loadLocation() {
        return LocationResource.getLocation({}, function (location) {
            $scope.defaults.country = location.country;
            $scope.defaults.countryState = location.countryState;
        }).$promise;
    }

    function loadSettings() {
        return LocationResource.getLocationSettings({}, function (settings) {
            $scope.areas = settings.areas;
        }).$promise;
    }

    $scope.load($stateParams.customerId);
    //$timeout(function () {
    //    $scope.load($stateParams.customerId);
    //});
    //$document.ready($scope.load($stateParams.customerId));

    $scope.save = function () {
        $scope.customer.allergies = _.map($scope.customer.allergies, function (allergy) {
            return allergy;
        });
        console.log("$scope.customer:");
        console.log($scope.customer);

        CustomerResource.updateCustomer($scope.customer,
            function (savedCustomer) {
                var customerResource = $scope.load(savedCustomer.id);
                customerResource.$promise.then(function (customer) {
                    //var msgHtml = "<a target=\"_blank\" ui-sref=\"customers.profile({customerId:" + savedCustomer.id + " })\">Customer " + customer.firstName + ' ' + customer.lastName + ' saved</a>';
                    var msgHtml = 'Customer ' + customer.firstName + ' ' + customer.lastName + ' saved';
                    Notification.info('Customer saved', msgHtml);
                });
                var newState;
                var params;
                if (angular.isDefined(PreviousState) && PreviousState.name.match(/^customer\.profile/)) {
                    newState = PreviousState.name;
                    params = PreviousState.params;
                } else {
                    newState = $state.current;
                    params = angular.copy($stateParams);
                    params.customerId = undefined;
                }
                $state.go('customers.profile', {customerId: savedCustomer.id});
                //return $state.transitionTo(newState, params, {reload: true, inherit: true, notify: true});
            },
            function (response) {
                // TODO more appropriate error handling
                console.log(response);
            }
        );
    };

    $scope.nonEmpty = function (value) {
        if (_.isArray(value) && !_.isEmpty(value)) {
            return true;
        } else {
            return false;
        }
    };
}

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('customers.feedback', {
                parent: 'customers',
                url: '/feedback',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/customer/feedback/feedback.html',
                        controller: 'FeedbackSearchController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    employees: null,
                    employeeLogin: null,
                    employeeName: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('FeedbackSearchController', FeedbackSearchController);

    FeedbackSearchController.$inject = ['$scope', '$state', '$stateParams', '$document', 'FeedbackResource'];

    function FeedbackSearchController($scope, $state, $stateParams, $document, FeedbackResource) {
        var vm = this;
        vm.moment = moment;
        vm.employeeLogin = $stateParams.employeeLogin;
        vm.employees = $stateParams.employees;
        vm.employeeName = $stateParams.employeeName;

        // paging data
        vm.currentPage = 1;
        vm.itemsPerPage = 10;
        vm.totalItems = 0;
        vm.searchFeedbacks = searchFeedbacks;
        vm.reset = reset;

        vm.filterFrom = null;
        vm.filterTo = null;

        vm.slider_stars = $document.find('#slider_stars');
        vm.slider_stars.ionRangeSlider({
            type: 'double',
            grid: true,
            values: [
                "zero", "one",
                "two", "three",
                "four", "five"
            ], onChange: function (data) {
                console.log(data);
                vm.minRating = data.from;
                vm.maxRating = data.to;
            }
        });

        // initialize date picker
        $document.ready(
            function () {
                vm.pickerDates = $document.find('input[name="pickerDates"]');
                vm.pickerDates.daterangepicker(
                    {
                        showDropdowns: true,
                        alwaysShowCalendars: true,
                        ranges: {
                            'Today': [moment(), moment()],
                            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                            'Last 12 Months': [moment().subtract(12, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                        },
                        locale: {format: 'MMM D, YYYY'}
                    },
                    function (start, end, label) {
                        vm.filterFrom = moment(start).toISOString();
                        vm.filterTo = moment(end).toISOString();
                    }
                );
                vm.pickerDates.val('');
            }
        );

        function reset() {
            vm.slider_stars.data("ionRangeSlider").update({
                from: 0,
                to: 5
            });
            vm.minRating = null;
            vm.maxRating = null;
            vm.pickerDates.val('');
            vm.filterFrom = null;
            vm.filterTo = null;
        }

        vm.openPicker = function () {
            vm.pickerDates.focus();
        }

        vm.pageChanged = function () {
            vm.searchFeedbacks();
        };


        load();

        function load() {
            vm.searchFeedbacks();
        }

        function searchFeedbacks() {
            console.log('searchFeedbacks() vm:');
            console.log(vm);

            // mandatory params
            var params = {
                page: vm.currentPage - 1,
                size: vm.itemsPerPage
            };

            // extend with date range if it's selected
            if (vm.filterFrom != null && vm.filterTO != null) {
                params.startDate = vm.filterFrom;
                params.endDate = vm.filterTo;
            }

            FeedbackResource.searchFeedbacks(
                {
                    startDate: vm.filterFrom,
                    endDate: vm.filterTo,
                    minRating: vm.minRating,
                    maxRating: vm.maxRating,
                    employeeLogin: vm.employeeLogin,
                    page: vm.currentPage - 1,
                    size: vm.itemsPerPage
                },
                function (data) {
                    vm.feedbacks = data.feedbacks.content;
                    vm.totalItems = data.feedbacks.totalElements;
                    vm.dto = data;
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reporting', {
            parent: 'app',
            url: '/reporting',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/reporting/reporting.html'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('reporting');
                    return $translate.refresh();
                }]
            }
        });
    }
})();


(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reporting.aggregated', {
                parent: 'reporting',
                url: '/aggregated',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/reporting/aggregated/aggregated.html',
                        controller: 'AggregatedController',
                        controllerAs: 'aggregated'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

AggregatedController.$inject = ['$scope', 'Principal', '$q', 'CustomerResource', 'googleChartApiPromise', '$filter',
    'Statistics', 'Reporting', 'ApplicationContext', 'ApplicationProfile'];

function AggregatedController($scope, Principal, $q, CustomerResource, googleChartApiPromise, $filter, Statistics,
                              Reporting, ApplicationContext, ApplicationProfile) {
    var vm = this;

    vm.reload = reload;
    vm.isMeal = (ApplicationContext.getProductType() == 'MEAL');

    vm.aggrSpendType = 'byhour';
    vm.aggrSpendInterval = 12;
    vm.aggrCustomerType = 'all';
    vm.aggregatedSpendChartLoaded = false;
    vm.aggregatedSpendChartCurrent = '-';

    vm.avgSpendPerCover = -1;

    vm.reportAggregatedRevenue = ApplicationProfile.isReportAggregatedRevenueEnabled();
    vm.reportAggregatedRevenueText = ApplicationProfile.upgradeTierText("ReportAggregatedRevenue");
    vm.openWindow = ApplicationProfile.openAppCloverPage;

    if (vm.reportAggregatedRevenue) {
        Principal.identity().then(function (account) {
            $scope.account = account;
            $scope.isAuthenticated = Principal.isAuthenticated;
            load();
        });
    }

    function reload() {
        loadData();
    }

    function loadData() {
        if (vm.aggrSpendType == 'byhour') loadAggregatedByHourData().then(displayAggregatedByHourChart).then($(window).resize);
        if (vm.aggrSpendType == 'byday') loadAggregatedByWeekdayData().then(displayAggregatedByDayChart).then($(window).resize);
    }

    function load() {
        $q.all([
            googleChartApiPromise,
            loadAggregatedByHourData(),
            loadLocationStats()
        ]).then(displayAggregatedByHourChart).then($(window).resize);
    }

    function loadLocationStats() {
        return Statistics.getLocationRegularsStats({}, function (data) {
            //TODO check - reload on each selection change - all customers, regulars, non regulars - ?
            vm.customerLocationStats = data;
            vm.avgSpendPerCover = vm.customerLocationStats.avgSpendByCover;
        }).$promise;
    }

    function loadAggregatedByHourData() {
        return CustomerResource.getAggregateByHourData({
            id: 0,
            months: vm.aggrSpendInterval,
            customerType: vm.aggrCustomerType
        }, function (data) {
            vm.aggrByHourData = data;
        }).$promise;
    }

    function loadAggregatedByWeekdayData() {
        return CustomerResource.getAggregateByWeekdayData({
            id: 0,
            months: vm.aggrSpendInterval,
            customerType: vm.aggrCustomerType
        }, function (data) {
            vm.aggrByWeekdayData = data;
            vm.aggrByWeekdayDetailData = vm.aggrByWeekdayData.detailData;
            //calc stat pcts. vs location stats
            //_.each(vm.aggrByWeekdayData.detailData, calcAggrByWeekdayDataItem);
            for (var i = 0; i < vm.aggrByWeekdayData.detailData.length; i++)
                Reporting.calcAggrByWeekdayDataItem(vm.aggrByWeekdayData.detailData[i], vm.customerLocationStats);
        }).$promise;
    }

    function displayAggregatedByHourChart() {
        var deferred = $q.defer();
        // Aggregated spend
        // Spend by hours
        var dataHours = new google.visualization.DataTable();
        dataHours.addColumn('string', 'Time of Day');
        dataHours.addColumn('number', 'Reservation', 'color: #007E3B');
        dataHours.addColumn('number', 'Walk-In Seated');
        dataHours.addColumn('number', 'Walk-In Waitlisted');
        dataHours.addColumn({type: 'string', role: 'annotation'});

        var optionsHours = {
            title: 'Aggregated revenue on hourly basis',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            legend: {position: 'top', alignment: 'end'},
            isStacked: 'true',
            chartArea: {width: '90%', height: '70%'},
            //width: 1000,
            height: 450,
            vAxis: {
                title: 'Revenue in ' + ApplicationContext.getCurrencySym(),
                textPosition: 'none',
                gridlines: {count: 13}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },
            hAxis: {
                title: 'Time of Day',
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            colors: ['#1ABC9C', '#3399CC', '#996699'],
            formatters: {}

        };

        vm.chartObjectHours = {
            type: 'ColumnChart',
            options: optionsHours,
            data: dataHours
        };

        Reporting.setSpendTrendChartData(dataHours, vm.aggrByHourData.chartData);

        return deferred.promise;
    }

    function displayAggregatedByDayChart() {
        var deferred = $q.defer();
        // Days statistics
        var dataDays = new google.visualization.DataTable();
        dataDays.addColumn('string', 'Day');
        dataDays.addColumn('number', 'Reservation', 'color: #007E3B');
        dataDays.addColumn('number', 'Walk-In Seated');
        dataDays.addColumn('number', 'Walk-In Waitlisted');
        dataDays.addColumn({type: 'string', role: 'annotation'});

        var optionsDays = {
            title: 'Aggregated revenue on daily basis',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            isStacked: 'true',
            //width: 1000,
            height: 400,
            vAxis: {
                title: 'Revenue in ' + ApplicationContext.getCurrencySym(),
                textPosition: 'none',
                gridlines: {count: 13}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },
            hAxis: {
                title: 'Days of the Week',
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            colors: ['#1ABC9C', '#3399CC', '#996699'],
            formatters: {}
        };

        vm.chartObjectDays = {
            type: 'ColumnChart',
            options: optionsDays,
            data: dataDays
        };

        Reporting.setSpendTrendChartData(dataDays, vm.aggrByWeekdayData.chartData);

        return deferred.promise;
    }

}

angular.module('seatonApp').controller('AggregatedController', AggregatedController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reporting.performance', {
                parent: 'reporting',
                url: '/performance',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/reporting/performance/performance.html',
                        controller: 'PerformanceController',
                        controllerAs: 'performance'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.performance');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

angular.module('seatonApp')
    .controller('PerformanceController', PerformanceController);

PerformanceController.$inject = ['$scope', 'Principal', '$q', '$filter', 'googleChartApiPromise', 'Statistics', 'Reporting', '$timeout', 'ApplicationContext'];

function PerformanceController($scope, Principal, $q, $filter, googleChartApiPromise, Statistics, Reporting, $timeout, ApplicationContext) {
    var vm = this;
    vm.customerFilter = 'all';
    vm.reload = reload;
    vm.onChartSelect = onChartSelect;
    vm.selectedDay = -1;
    vm.calcPct = Reporting.calcPct;
    vm.isMeal = (ApplicationContext.getProductType() == 'MEAL');

    Principal.identity().then(function (account) {
        $scope.account = account;
        $scope.isAuthenticated = Principal.isAuthenticated;
    });

    function onChartSelect(selectedItem) {
        //console.log(selectedItem);
        if (typeof selectedItem != 'undefined') {
            var selDay = selectedItem.row - 31;
            if (selDay != vm.selectedDay) {
                vm.selectedDay = selDay;
                reloadDayDetails().then(displayDayDetailsCharts);
            }
        }
    }

    load();

    function reload() {
        getReportingRevenueTrend().then(displaySpendTrendChart);
        reloadDayDetails().then(displayDayDetailsCharts);
    }

    function reloadDayDetails() {
        return getReportingRevenueTrendDayDetails();
    }

    function displayDayDetailsCharts() {
        displayVisitsChart();
        displayMealChart();
    }

    function displayAllCharts() {
        displaySpendTrendChart();
        displayVisitsChart();
        displayMealChart();
    }

    function load() {
        $q.all([
            googleChartApiPromise,
            getReportingRevenueTrend(),
            getReportingRevenueTrendDayDetails()
        ]).then(displayAllCharts);
    }

    function getReportingRevenueTrend() {
        return Statistics.getReportingRevenueTrendLastMonth({
            customerFilter: vm.customerFilter
        }, function (data) {
            vm.revenueData = data;
            vm.total = vm.revenueData.total;
            vm.avgSpendPerCover = data.total.amountAvgPerCover;

            vm.templateParam1 = data.total.amountAvgPerCover;
            vm.templateParam2 = data.total.tipAvg;
            vm.templateParam3 = data.total.coversPerVisit;
            vm.templateParam4 = data.total.noShowPct;
        }).$promise;
    }

    function getReportingRevenueTrendDayDetails() {
        return Statistics.getReportingRevenueTrendDayDetails({
            customerFilter: vm.customerFilter,
            days: vm.selectedDay
        }, function (data) {
            vm.revenueDayDetailsData = data;
            vm.mealData = data.mealData;
            vm.visitTypeData = data.visitTypeData;
        }).$promise;
    }


    function displaySpendTrendChart() {
        var deferred = $q.defer();

        // Spend trend
        var dataTrend = new google.visualization.DataTable();
        dataTrend.addColumn('string', 'Day');
        dataTrend.addColumn('number', 'Reservation', 'color: #007E3B');
        dataTrend.addColumn('number', 'Walk-In Seated');
        dataTrend.addColumn('number', 'Walk-In Waitlisted');
        dataTrend.addColumn({type: 'string', role: 'annotation'});

        Reporting.setSpendTrendChartData(dataTrend, vm.revenueData.chartData);

        var optionsTrend = {
            isStacked: 'true',
            legend: {position: 'top', alignment: 'end'},
            //width: 1050,
            height: 425,
            vAxis: {
                title: 'Revenue in ' + ApplicationContext.getCurrencySym(),
                textPosition: 'none',
                gridlines: {count: 13}, viewWindow: {min: 0},
                titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true}
            },
            hAxis: {
                title: "Day",
                //slantedText: true,
                //slantedTextAngle: 45,
                titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true}
            },
            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            chartArea: {width: '90%', height: '70%'},
            formatters: {},
            colors: ['#1ABC9C', '#3399CC', '#996699']
        };

        $scope.chartObjectTrend = {
            type: "ColumnChart",
            options: optionsTrend,
            data: dataTrend
        };

        return deferred.promise;

    }

    function displayVisitsChart() {
        var deferred = $q.defer();
        //visits - general pie chart
        $scope.chartObjectVisitGeneral = null;

        var chartObject = new google.visualization.DataTable();
        chartObject.type = "PieChart";

        chartObject.options = {
            title: 'Revenue spread by visit type',
            legend: {position: 'right'},
            //width: 450,
            height: 425,
            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#3399CC'},
                2: {color: '#996699'},
            }

        };

        var chartData = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Reservation"},
                        {
                            v: vm.visitTypeData.reservation.amountSum,
                            f: $filter('currency')(vm.visitTypeData.reservation.amountSum)
                        },
                    ]
                },
                {
                    c: [
                        {v: "Walk-In Seated"},
                        {
                            v: vm.visitTypeData.seated.amountSum,
                            f: $filter('currency')(vm.visitTypeData.seated.amountSum)
                        }
                    ]
                },
                {
                    c: [
                        {v: "Walk-In Waitlisted"},
                        {
                            v: vm.visitTypeData.waitlist.amountSum,
                            f: $filter('currency')(vm.visitTypeData.waitlist.amountSum)
                        }
                    ]
                }
            ]
        };

        $timeout(function () {
            chartObject.data = chartData;
            $scope.chartObjectVisitGeneral = chartObject;
            $scope.$apply();
        });
        return deferred.promise;
    }

    function displayMealChart() {
        var deferred = $q.defer();

        $scope.chartObjectMealGeneral = null;

        $timeout(function () {
            //Meal -  pie chart
            $scope.chartObjectMealGeneral = {};
            $scope.chartObjectMealGeneral.type = "PieChart";

            $scope.chartObjectMealGeneral.options = {
                title: 'Revenue spread by period of the day',
                legend: {position: 'right'},
                //width: 450,
                height: 425,
                slices: {
                    0: {color: '#1ABC9C'},
                    1: {color: '#3399CC'},
                    2: {color: '#996699'},
                }

            };

            $scope.chartObjectMealGeneral.data = {
                "cols": [
                    {id: "t", label: "Type", type: "string"},
                    {id: "s", label: "Number", type: "number"}
                ], "rows": [
                    {
                        c: [
                            {v: "Breakfast (" + vm.mealData.breakfestStart + " - " + vm.mealData.breakfestEnd + ")"},
                            {
                                v: vm.mealData.breakfest.amountSum,
                                f: $filter('currency')(vm.mealData.breakfest.amountSum)
                            },
                        ]
                    },
                    {
                        c: [
                            {v: "Lunch (" + vm.mealData.lunchStart + " - " + vm.mealData.lunchEnd + ")"},
                            {
                                v: vm.mealData.lunch.amountSum,
                                f: $filter('currency')(vm.mealData.lunch.amountSum)
                            }
                        ]
                    },
                    {
                        c: [
                            {v: "Dinner (" + vm.mealData.dinnerStart + " - " + vm.mealData.dinnerEnd + ")"},
                            {
                                v: vm.mealData.dinner.amountSum,
                                f: $filter('currency')(vm.mealData.dinner.amountSum)
                            }
                        ]
                    }
                ]
            };
        });
        return deferred.promise;
    }
}

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reporting.revenuetrend', {
                parent: 'reporting',
                url: '/revenuetrend',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/reporting/revenuetrend/revenuetrend.html',
                        controller: 'RevenueTrendController',
                        controllerAs: 'revenuetrend'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

angular.module('seatonApp')
    .controller('RevenueTrendController', RevenueTrendController);

RevenueTrendController.$inject = ['$scope', 'Principal', '$q', '$filter', 'googleChartApiPromise', 'Statistics', 'Reporting', '$timeout', 'ApplicationContext'];

function RevenueTrendController($scope, Principal, $q, $filter, googleChartApiPromise, Statistics, Reporting, $timeout, ApplicationContext) {
    var vm = this;
    vm.customerFilter = 'all';
    vm.reload = reload;
    vm.onChartSelect = onChartSelect;
    vm.selectedMonth = -1;
    vm.calcPct = Reporting.calcPct;

    Principal.identity().then(function (account) {
        $scope.account = account;
        $scope.isAuthenticated = Principal.isAuthenticated;
    });

    function onChartSelect(selectedItem) {
        //console.log(selectedItem);
        if (typeof selectedItem != 'undefined') {
            var selMonth = selectedItem.row - 12;
            if (selMonth != vm.selectedMonth) {
                vm.selectedMonth = selMonth;
                reloadMonthDetails().then(displayMonthDetailsCharts);
            }
        }
    }

    load();

    function reload() {
        getReportingRevenueTrend().then(displaySpendTrendChart);
        reloadMonthDetails().then(displayMonthDetailsCharts);
    }

    function reloadMonthDetails() {
        return getReportingRevenueTrendMonthDetails();
    }

    function displayMonthDetailsCharts() {
        displayVisitsChart();
        displayMealChart();
    }

    function displayAllCharts() {
        displaySpendTrendChart();
        displayVisitsChart();
        displayMealChart();
    }

    function load() {
        $q.all([
            googleChartApiPromise,
            getReportingRevenueTrend(),
            getReportingRevenueTrendMonthDetails()
        ]).then(displayAllCharts);
    }

    function getReportingRevenueTrend() {
        return Statistics.getReportingRevenueTrend({
            customerFilter: vm.customerFilter
        }, function (data) {
            vm.revenueData = data;
            vm.total = vm.revenueData.total;
            vm.avgSpendPerCover = data.total.amountAvgPerCover;

            vm.templateParam1 = data.total.amountAvgPerCover;
            vm.templateParam2 = data.total.tipAvg;
            vm.templateParam3 = data.total.coversPerVisit;
            vm.templateParam4 = data.total.noShowPct;
        }).$promise;
    }

    function getReportingRevenueTrendMonthDetails() {
        return Statistics.getReportingRevenueTrendMonthDetails({
            customerFilter: vm.customerFilter,
            months: vm.selectedMonth
        }, function (data) {
            vm.revenueMonthDetailsData = data;
            vm.mealData = data.mealData;
            vm.visitTypeData = data.visitTypeData;
        }).$promise;
    }


    function displaySpendTrendChart() {
        var deferred = $q.defer();

        // Spend trend
        var dataTrend = new google.visualization.DataTable();
        dataTrend.addColumn('string', 'Month');
        dataTrend.addColumn('number', 'Reservation', 'color: #007E3B');
        dataTrend.addColumn('number', 'Walk-In Seated');
        dataTrend.addColumn('number', 'Walk-In Waitlisted');
        dataTrend.addColumn({type: 'string', role: 'annotation'});

        Reporting.setSpendTrendChartData(dataTrend, vm.revenueData.chartData);

        var optionsTrend = {
            legend: {position: 'top', alignment: 'end'},
            isStacked: 'true',
            //width: 1050,
            height: 425,
            vAxis: {
                title: 'Revenue in ' + ApplicationContext.getCurrencySym(),
                textPosition: 'none',
                gridlines: {count: 13}, viewWindow: {min: 0},
                titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true}
            },
            hAxis: {
                title: "Month",
                //slantedText: true,
                //slantedTextAngle: 45,
                titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true}
            },
            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            chartArea: {width: '90%', height: '70%'},
            formatters: {},
            colors: ['#1ABC9C', '#3399CC', '#996699']
        };

        $scope.chartObjectTrend = {
            type: "ColumnChart",
            options: optionsTrend,
            data: dataTrend
        };

        return deferred.promise;

    }

    function displayVisitsChart() {
        var deferred = $q.defer();
        //visits - general pie chart
        $scope.chartObjectVisitGeneral = null;

        var chartObject = new google.visualization.DataTable();
        chartObject.type = "PieChart";

        chartObject.options = {
            title: 'Revenue spread by visit type',
            legend: {position: 'right'},
            //width: 450,
            height: 425,
            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#3399CC'},
                2: {color: '#996699'},
            }

        };

        var chartData = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Reservation"},
                        {
                            v: vm.visitTypeData.reservation.amountSum,
                            f: $filter('currency')(vm.visitTypeData.reservation.amountSum)
                        },
                    ]
                },
                {
                    c: [
                        {v: "Walk-In Seated"},
                        {
                            v: vm.visitTypeData.seated.amountSum,
                            f: $filter('currency')(vm.visitTypeData.seated.amountSum)
                        }
                    ]
                },
                {
                    c: [
                        {v: "Walk-In Waitlisted"},
                        {
                            v: vm.visitTypeData.waitlist.amountSum,
                            f: $filter('currency')(vm.visitTypeData.waitlist.amountSum)
                        }
                    ]
                }
            ]
        };

        $timeout(function () {
            chartObject.data = chartData;
            $scope.chartObjectVisitGeneral = chartObject;
            $scope.$apply();
        });
        return deferred.promise;
    }

    function displayMealChart() {
        var deferred = $q.defer();

        $scope.chartObjectMealGeneral = null;

        $timeout(function () {
            //Meal -  pie chart
            $scope.chartObjectMealGeneral = {};
            $scope.chartObjectMealGeneral.type = "PieChart";

            $scope.chartObjectMealGeneral.options = {
                title: 'Revenue spread by period of the day',
                legend: {position: 'right'},
                //width: 450,
                height: 425,
                slices: {
                    0: {color: '#1ABC9C'},
                    1: {color: '#3399CC'},
                    2: {color: '#996699'},
                }

            };

            $scope.chartObjectMealGeneral.data = {
                "cols": [
                    {id: "t", label: "Type", type: "string"},
                    {id: "s", label: "Number", type: "number"}
                ], "rows": [
                    {
                        c: [
                            {v: "Breakfast (" + vm.mealData.breakfestStart + " - " + vm.mealData.breakfestEnd + ")"},
                            {
                                v: vm.mealData.breakfest.amountSum,
                                f: $filter('currency')(vm.mealData.breakfest.amountSum)
                            },
                        ]
                    },
                    {
                        c: [
                            {v: "Lunch (" + vm.mealData.lunchStart + " - " + vm.mealData.lunchEnd + ")"},
                            {
                                v: vm.mealData.lunch.amountSum,
                                f: $filter('currency')(vm.mealData.lunch.amountSum)
                            }
                        ]
                    },
                    {
                        c: [
                            {v: "Dinner (" + vm.mealData.dinnerStart + " - " + vm.mealData.dinnerEnd + ")"},
                            {
                                v: vm.mealData.dinner.amountSum,
                                f: $filter('currency')(vm.mealData.dinner.amountSum)
                            }
                        ]
                    }
                ]
            };
        });
        return deferred.promise;
    }
}

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reporting.occupancy', {
                parent: 'reporting',
                url: '/occupancy',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/reporting/occupancy/occupancy.html',
                        controller: 'OccupancyReportController',
                        controllerAs: 'occupancy'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

OccupancyReportController.$inject = ['$state', '$scope', '$document', '$timeout', 'Principal', '$q', '$filter',
    'googleChartApiPromise', 'Statistics', 'Reporting', 'ApplicationContext', 'ApplicationProfile', 'TextUtil'];

function OccupancyReportController($state, $scope, $document, $timeout, Principal, $q, $filter,
                                   googleChartApiPromise, Statistics, Reporting, ApplicationContext,
                                   ApplicationProfile, TextUtil) {
    var vm = this;
    vm.displayChart = displayChart;
    vm.onChartSelect = onChartSelect;
    vm.setSimulationToActuals = setSimulationToActuals;
    vm.calculateSimulation = calculateSimulation;
    vm.calcPct = Reporting.calcPct;
    vm.calculateAvgDuration = calculateAvgDuration;

    vm.isMeal = (ApplicationContext.getProductType() == 'MEAL');
    vm.isTableManaged = ApplicationContext.isTableManaged();
    vm.coverTrans = TextUtil.translate('person','s');

    vm.reportOccupancyRate = ApplicationProfile.isReportOccupancyRateEnabled();
    vm.reportOccupancyRateText = ApplicationProfile.upgradeTierText("ReportOccupancyRate");
    vm.openWindow = ApplicationProfile.openAppCloverPage;

    vm.openPicker = openPicker;

    vm.selectedDate = moment().subtract(1, 'weeks');
    vm.endDate = null;
    vm.selectedDay = 0;

    vm.minDate = moment().subtract(10);
    vm.maxDate = moment();

    vm.pickerDate = moment(); //initial

    function onChartSelect(selectedItem) {
        if (typeof selectedItem != 'undefined') {
            var selDay = selectedItem.row;
            if (selDay != vm.selectedDay) {
                vm.selectedDay = selDay;
                getReportingOccupancyByHour().then(displayHourChart);
            }
        }
    }

    $scope.openingHourNotDefined = function () {
        return ApplicationContext.isBusinessHoursNotDefined();
    }

    if (vm.reportOccupancyRate) {
        load();
    }

    function calculateAvgDuration(occupancyData) {
        if (occupancyData == null) return '';
        if (occupancyData.totalVisits == 0) return '-';
        else {
            return '' + Math.round(occupancyData.totalEventsSeconds / occupancyData.totalVisits / 60) + 'min';
        }
    }

    //datepicker code
    function getPicker(inputName) {
        return $document.find('input[name="' + inputName + '"]');
    }

    function openPicker(inputName) {
        getPicker(inputName).focus();
    }

    function clearPicker(inputName) {
        getPicker(inputName).val('');
    }

    function dPickerInit(inputName, initDate) {
        var pickerObj
        pickerObj = getPicker(inputName);
        pickerObj.daterangepicker(
            {
                //configuration parameters
                autoUpdateInput: false,
                singleDatePicker: true,
                showDropdowns: true,
                locale: {format: 'MMM D, YYYY'}
            },
            function (start, end, label) {
                //callback function - called on picker value change - dates sent in callback
                if (start != vm.selectedDate) {
                    vm.selectedDate = start;
                    reload();
                } else {
                    console.log("Selected date same as existing - no need for reload")
                }
            }
        );

        pickerObj.on('apply.daterangepicker', function (ev, picker) {
            $(this).val(picker.startDate.format('MMM D, YYYY'));
        });

        pickerObj.on('cancel.daterangepicker', function (ev, picker) {
            $(this).val('');
        });

        //initial datepicker values
        //console.log('dPickerInit   2:' + inputName + '   :' + initDate);
        if (initDate != null) {
            pickerObj.data('daterangepicker').setStartDate(moment(initDate));
            pickerObj.data('daterangepicker').setEndDate(moment(initDate));
            pickerObj.val(moment(initDate).format('MMM D, YYYY'));
        }
    }

    $document.ready(
        function () {
            dPickerInit('pickerDate', vm.selectedDate);
        }
    );


    function load() {
        $q.all([
            googleChartApiPromise,
            getReportingOccupancy(),
            getReportingOccupancyByHour()
        ]).then(displayCharts);
    }

    function displayCharts() {
        displayChart();
        displayHourChart();
        setSimulationToActuals('week');
        setSimulationToActuals('day');
    }

    function reload() {
        load();
        //getReportingOccupancy().then(displayChart);
    }

    function getReportingOccupancy() {
        vm.endDate = moment(vm.selectedDate).clone().add(6, 'days');
        return Statistics.getReportingOccupancy({
            //selectedDate: vm.selectedDate == null ? null : vm.selectedDate.clone().startOf('day').toISOString()
            selectedDate: vm.selectedDate == null ? null : vm.selectedDate.clone().format('YYYY-MM-DD')
        }, function (data) {
            vm.data = data;
        }).$promise;
    }

    function getReportingOccupancyByHour() {
        //return Statistics.getReportingExpectedOccupancyByHour({ //uncomment for test/comparison of values
        return Statistics.getReportingOccupancyByHour({
            selectedDate: vm.selectedDate == null ? null : vm.selectedDate.clone().add(vm.selectedDay, 'days').format('YYYY-MM-DD'),
            reportType: 'excludeExpected'
        }, function (data) {
            vm.hourData = data;
        }).$promise;
    }

    Principal.identity().then(function (account) {
        $scope.account = account;
        $scope.isAuthenticated = Principal.isAuthenticated;
    });

    function myToolTip(day, occupancy, revenue, loss) {
        return '&nbsp;<b>' + day + '</b><br>' +
            '&nbsp;&nbsp;&nbsp;Occupancy: <span class="text-danger">' + occupancy + '</span><br/>' +
            '&nbsp;&nbsp;&nbsp;Revenue: <span class="text-danger">' + revenue + '</span><br/>' +
            '&nbsp;&nbsp;&nbsp;No show loss: <span class="text-danger">' + loss + '</span>'
    }

    function displayChart() {
        var deferred = $q.defer();
        setSimulationToActuals('week');
        // Occupance report
        //WEEK
        var dataOcuppancyWeek = new google.visualization.DataTable();
        dataOcuppancyWeek.addColumn('string', 'Day in Week');
        dataOcuppancyWeek.addColumn('number', 'Occupancy rate', 'color: #1ABC9C');
        dataOcuppancyWeek.addColumn({type: 'string', role: 'annotation'});
        dataOcuppancyWeek.addColumn({type: 'string', role: 'tooltip', 'p': {'html': true}});
        dataOcuppancyWeek.addColumn('number', 'Avg revenue per '+vm.coverTrans, 'color: #336699');


        _.each(vm.data.occupancyByWeekday, function (item) {
            dataOcuppancyWeek.addRow(
                [
                    item.weekdayName,
                    item.occupancyPct,
                    $filter('percentage')(item.occupancyPct, 2),
                    myToolTip(item.weekdayName, $filter('percentage')(item.occupancyPct, 2), $filter('currency')(item.revenue), $filter('currency')(item.noShowLoss)),
                    {
                        v: item.avgRevenuePerCover,
                        f: $filter('currency')(item.avgRevenuePerCover)
                    }
                ]
            );
        });
        /*
         dataOcuppancyWeek.addRows([
         ['Sunday', 0.6543, '65.43%', myToolTip('Sunday', '65.43%', '$13,456.34', '$2.435,98'), 35.32],
         ['Monday', 0.4345, '43.45%', myToolTip('Monday', '43.45%', '$13,456.34', '$2.435,98'), 41.54],
         ['Tuesday', 0.5532, '55.32%', myToolTip('Tuesday', '55.32%', '$13,456.34', '$2.435,98'), 35.55],
         ['Wednesday', 0.5745, '57.45%', myToolTip('Wednesday', '57.45%', '$13,456.34', '$2.435,98'), 36.65],
         ['Thursday', 0.6121, '61.21%', myToolTip('Thursday', '61.21%', '$13,456.34', '$2.435,98'), 43.55],
         ['Friday', 0.6744, '67.44%', myToolTip('Friday', '67.44%', '$13,456.34', '$2.435,98'), 49.34],
         ['Saturday', 0.7756, '77.56%', myToolTip('Saturday', '77.56%', '$13,456.34', '$2.435,98'), 55.32]
         ]);
         */

        var optionsOccupancyWeek = {
            //width: 900,
            height: 400,

            tooltip: {
                isHtml: true
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 10,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },

            hAxis: {
                title: 'Day in week',
                titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true}
            },

            vAxes: {
                0: {
                    viewWindowMode: 'explicit',
                    //gridlines: {color: 'transparent'},
                    gridlines: {count: 9}, viewWindow: {min: 0},
                    title: 'Occupancy rate',
                    format: 'percent',
                    titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true}
                },
                1: {
                    gridlines: {color: 'transparent'},
                    title: 'Avg per '+vm.coverTrans,
                    format: 'currency',
                    color: '#CC9933',
                    viewWindow: {
                        min: 0
                    },
                    textStyle: {color: '#CC3333'},
                    titleTextStyle: {color: '#CC3333', fontSize: 14, bold: true}
                }
            },
            chartArea: {width: '80%', height: '65%'},
            series: {
                0: {
                    type: 'bars',
                    targetAxisIndex: 0
                },
                1: {
                    type: 'line',
                    targetAxisIndex: 1
                }
            },
            formatters: {},
            colors: ['#1ABC9C', '#CC3333'],
            legend: {position: 'top', alignment: 'end'}
        };

        $scope.chartComboObjectOccupancyWeek = {
            type: "ComboChart",
            options: optionsOccupancyWeek,
            data: dataOcuppancyWeek
        };
        return deferred.promise;

    }

    function displayHourChart() {
        var deferred = $q.defer();
        setSimulationToActuals('day');
        // DAY
        var dataOcuppancyDay = new google.visualization.DataTable();
        dataOcuppancyDay.addColumn('string', 'Hour');
        dataOcuppancyDay.addColumn('number', 'Seat occupancy rate', 'color: #1ABC9C');
        dataOcuppancyDay.addColumn({type: 'string', role: 'annotation'});
        dataOcuppancyDay.addColumn({type: 'string', role: 'tooltip', 'p': {'html': true}});
        dataOcuppancyDay.addColumn('number', 'Table occupancy rate', 'color: #336699');

        _.each(vm.hourData.occupancyByHour, function (item) {
            dataOcuppancyDay.addRow(
                [
                    item.hourOfDayFmt,
                    item.occupancyPct,
                    $filter('percentage')(item.occupancyPct, 2),
                    myToolTip(item.hourOfDayFmt, $filter('percentage')(item.occupancyPct, 2), $filter('currency')(item.revenue), $filter('currency')(item.noShowLoss)),
                    {
                        v: item.occupancyTablePct,
                        f: $filter('percentage')(item.occupancyTablePct, 2)
                    }
                ]);
        });
        /*
         dataOcuppancyDay.addRows([
         ['7am', 0.3450, '34.50%', myToolTip('7am', '65.43%', '$13,456.34', '$2.435,98'), 27.50],
         ['8am', 0.4253, '42.53%', myToolTip('8am', '65.43%', '$13,456.34', '$2.435,98'), 33.34],
         ]);
         */

        var optionsOccupancyDay = {
            //width: 900,
            height: 400,

            tooltip: {
                isHtml: true
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 10,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },

            hAxis: {
                title: 'Hour of day',
                titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true}
            },

            vAxes: {
                0: {
                    viewWindowMode: 'explicit',
                    //gridlines: {color: 'transparent'},
                    gridlines: {count: 9},
                    title: 'Seat occupancy rate',
                    titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
                    format: 'percent',
                    viewWindow: {
                        min: 0
                    }
                },
                1: {
                    //gridlines: {color: 'transparent'},
                    title: 'Table occupancy rate',
                    //titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
                    format: 'percent',
                    color: '#CC9933',
                    viewWindow: {
                        min: 0
                    },
                    textStyle: {color: '#CC3333'},
                    titleTextStyle: {color: '#CC3333'}
                }
            },
            chartArea: {width: '80%', height: '65%'},
            series: {
                0: {
                    type: 'bars',
                    targetAxisIndex: 0
                },
                1: {
                    type: 'line',
                    targetAxisIndex: 0
                }
            },
            formatters: {},
            colors: ['#1ABC9C', '#CC3333'],
            legend: {position: 'top', alignment: 'end'}
        };

        $scope.chartComboObjectOccupancyDay = {
            type: "ComboChart",
            options: optionsOccupancyDay,
            data: dataOcuppancyDay
        };

        return deferred.promise;
    }

////////////////////
//simulation sliders
////////////////////

    function setSimulationToActuals(slider) {
        if ('week' == slider) {
            vm.slider_occupancy_week.update({from: vm.data.totalWeekOccupancy.occupancyPct * 100});
            vm.slider_avgrevenuepercover_week.update({
                from: vm.data.totalWeekOccupancy.avgRevenuePerCover,
                max: Number(3 * vm.data.totalWeekOccupancy.avgRevenuePerCover).toFixed(0)
            });
            vm.slider_noshow_week.update({from: vm.data.totalWeekOccupancy.noShowPct * 100});
            calculateSimulation('week');
        }
        if ('day' == slider) {
            vm.slider_occupancy_day.update({from: vm.hourData.totalDayOccupancy.occupancyPct * 100});
            vm.slider_avgrevenuepercover_day.update({
                from: vm.hourData.totalDayOccupancy.avgRevenuePerCover,
                max: Number(3 * vm.hourData.totalDayOccupancy.avgRevenuePerCover).toFixed(0)
            });
            vm.slider_noshow_day.update({from: vm.hourData.totalDayOccupancy.noShowPct * 100});

            calculateSimulation('day');
        }
    }

    function calculateSimulation(slider) {
        $timeout(function () {
            if ('week' == slider) {
                var estimatedCovers = vm.slider_occupancy_week.result.from / 100 * vm.data.totalWeekOccupancy.totalCovers / vm.data.totalWeekOccupancy.occupancyPct;
                var estimatedVisits = vm.slider_occupancy_week.result.from / 100 * vm.data.totalWeekOccupancy.totalVisits / vm.data.totalWeekOccupancy.occupancyPct;
                vm.week_calc.noShowLoss = vm.slider_noshow_week.result.from / 100 * vm.data.totalWeekOccupancy.noShowLoss / vm.data.totalWeekOccupancy.noShowPct;
                vm.week_calc.revenue = vm.slider_avgrevenuepercover_week.result.from * estimatedCovers - (vm.week_calc.noShowLoss - vm.data.totalWeekOccupancy.noShowLoss);
                vm.week_calc.tips = vm.week_calc.revenue * vm.data.totalWeekOccupancy.noShowPct;
                //$scope.$apply();
            }
            if ('day' == slider) {
                var estimatedCovers = vm.slider_occupancy_day.result.from / 100 * vm.hourData.totalDayOccupancy.totalCovers / vm.hourData.totalDayOccupancy.occupancyPct;
                var estimatedVisits = vm.slider_occupancy_day.result.from / 100 * vm.hourData.totalDayOccupancy.totalVisits / vm.hourData.totalDayOccupancy.occupancyPct;
                vm.day_calc.noShowLoss = vm.slider_noshow_day.result.from / 100 * vm.hourData.totalDayOccupancy.noShowLoss / vm.hourData.totalDayOccupancy.noShowPct;
                vm.day_calc.revenue = vm.slider_avgrevenuepercover_day.result.from * estimatedCovers - (vm.day_calc.noShowLoss - vm.hourData.totalDayOccupancy.noShowLoss);
                vm.day_calc.tips = vm.day_calc.revenue * vm.hourData.totalDayOccupancy.noShowPct;
                //$scope.$apply();
            }
        });
    }

    vm.week_calc = {
        revenue: 0,
        tips: 0,
        noShowLoss: 0
    };

    vm.day_calc = {
        revenue: 0,
        tips: 0,
        noShowLoss: 0
    };

//WEEK
    vm.div_slider_occupancy_week = $document.find('#slider_occupancy_week');
    vm.div_slider_occupancy_week.ionRangeSlider({
        min: 0,
        max: 100,
        step: 0.01,
        from: 0,
        postfix: "%",
        prettify: true,
        grid: true,
        decorate_both: true,
        onChange: function (data) {
            calculateSimulation('week');
        }
    });
    vm.slider_occupancy_week = vm.div_slider_occupancy_week.data("ionRangeSlider");

    vm.div_slider_avgrevenuepercover_week = $document.find('#slider_avgrevenuepercover_week');
    vm.div_slider_avgrevenuepercover_week.ionRangeSlider({
        min: 0,
        max: 250, // 3x avg revenue per cover
        step: 0.01,
        from: 0,
        prefix: "$",
        max_postfix: '+',
        prettify: true,
        grid: true,
        decorate_both: true,
        onChange: function (data) {
            vm.calculateSimulation('week');
        }
    });
    vm.slider_avgrevenuepercover_week = vm.div_slider_avgrevenuepercover_week.data("ionRangeSlider");

    vm.div_slider_noshow_week = $document.find('#slider_noshow_week');
    vm.div_slider_noshow_week.ionRangeSlider({
        min: 0,
        max: 100, // 3x avg revenue per cover
        step: 0.01,
        from: 0,
        postfix: "%",
        prettify: true,
        grid: true,
        decorate_both: true,
        onChange: function (data) {
            vm.calculateSimulation('week');
        }
    });
    vm.slider_noshow_week = vm.div_slider_noshow_week.data("ionRangeSlider");

//DAY
    vm.div_slider_occupancy_day = $document.find('#slider_occupancy_day');
    $("#slider_occupancy_day").ionRangeSlider({
        min: 0,
        max: 100,
        step: 0.01,
        from: 0,
        postfix: "%",
        prettify: true,
        grid: true,
        decorate_both: true,
        onChange: function (data) {
            vm.calculateSimulation('day');
        }
    });
    vm.slider_occupancy_day = vm.div_slider_occupancy_day.data("ionRangeSlider");

    vm.div_slider_avgrevenuepercover_day = $document.find('#slider_avgrevenuepercover_day');
    $("#slider_avgrevenuepercover_day").ionRangeSlider({
        min: 0,
        max: 250, // 3x avg revenue per cover
        step: 0.01,
        from: 0,
        prefix: "$",
        max_postfix: '+',
        prettify: true,
        grid: true,
        decorate_both: true,
        onChange: function (data) {
            vm.calculateSimulation('day');
        }
    });
    vm.slider_avgrevenuepercover_day = vm.div_slider_avgrevenuepercover_day.data("ionRangeSlider");

    vm.div_slider_noshow_day = $document.find('#slider_noshow_day');
    $("#slider_noshow_day").ionRangeSlider({
        min: 0,
        max: 100, // 3x avg revenue per cover
        step: 0.01,
        from: 0,
        postfix: "%",
        prettify: true,
        grid: true,
        decorate_both: true,
        onChange: function (data) {
            vm.calculateSimulation('day');
        }
    });
    vm.slider_noshow_day = vm.div_slider_noshow_day.data("ionRangeSlider");

}

angular.module('seatonApp')
    .controller('OccupancyReportController', OccupancyReportController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reporting.employees', {
                parent: 'reporting',
                url: '/employees',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/reporting/employees/employees.html',
                        controller: 'EmployeesPerformanceController',
                        controllerAs: 'employees'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

EmployeesPerformanceController.$inject = ['$state', '$scope', '$document', '$q', '$filter', 'googleChartApiPromise',
    'Statistics', 'Reporting', 'ApplicationContext', 'ApplicationProfile'];

function EmployeesPerformanceController($state, $scope, $document, $q, $filter, googleChartApiPromise, Statistics,
                                        Reporting, ApplicationContext, ApplicationProfile) {
    var vm = this;
    vm.viewEmployeeDetails = viewEmployeeDetails;
    vm.changedSelectedInterval = changedSelectedInterval;
    vm.changedSelectedDates = changedSelectedDates;

    vm.reportEmployeePerformance = ApplicationProfile.isReportEmployeePerformanceEnabled();
    vm.reportEmployeePerformanceText = ApplicationProfile.upgradeTierText("ReportEmployeePerformance");
    vm.openWindow = ApplicationProfile.openAppCloverPage;

    vm.dateRanges = {
        'last12Months': [moment().subtract(12, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'lastMonth': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'lastWeek': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
        'yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'today': [moment(), moment()],
        'currentWeek': [moment().startOf('week'), moment().endOf('week')],
        'currentMonth': [moment().startOf('month'), moment().endOf('month')]
    };

    vm.selectedInterval = 'currentWeek';
    vm.filterStartDate = vm.dateRanges[vm.selectedInterval][0];
    vm.filterEndDate = vm.dateRanges[vm.selectedInterval][1];
    vm.selectedDates = {
        startDate: null,
        endDate: null
    };
    vm.currentFilter = '';

    vm.order = {
        field: 'amountSum',
        reverse: true
    };
    vm.dynamicOrder = function (item) {
        return item[vm.order.field];
    }

    //picker
    $document.ready(
        function () {
            vm.pickerDates = $document.find('input[name="pickerDates"]');
            vm.pickerDates.daterangepicker(
                {
                    showDropdowns: true,
                    ranges: {
                        'Today': [moment(), moment()],
                        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                        'Last 12 Months': [moment().subtract(12, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                    },
                    locale: {format: 'MMM D, YYYY'}
                },
                function (start, end, label) {
                    vm.selectedInterval = '';
                    vm.filterStartDate = start;
                    vm.filterEndDate = end;
                    reload();
                }
            );
            vm.pickerDates.val('');
        }
    );
    vm.openPicker = openPicker;

    function openPicker() {
        vm.pickerDates.focus();
    }

    //end - picker


    if(vm.reportEmployeePerformance) {
        load();
    }

    function changedSelectedInterval() {
        vm.filterStartDate = vm.dateRanges[vm.selectedInterval][0].startOf('day');
        vm.filterEndDate = vm.dateRanges[vm.selectedInterval][1].endOf('day');

        vm.pickerDates.data('daterangepicker').setStartDate(vm.filterStartDate);
        vm.pickerDates.data('daterangepicker').setEndDate(vm.filterEndDate);

        reload();
    }

    function changedSelectedDates() {
        vm.selectedInterval = '';
        vm.filterStartDate = vm.selectedDates.startDate.clone();
        vm.filterEndDate = vm.selectedDates.endDate.clone();
        reload();
    }

    function load() {
        //clearDatesFilter();
        $q.all([
            googleChartApiPromise,
            loadLocationStats()
        ]).then(getReportingEmployeesPerformance).then(displayEmployeesChart);
    }

    function reload() {
        var selectedFilter = vm.filterStartDate.toISOString() + vm.filterEndDate.toISOString();
        console.log('selectedFilter' + selectedFilter + '  vm.currentFilter' + vm.currentFilter + '  vm.filterStartDate.format():' + vm.filterStartDate.format());
        if (vm.currentFilter != selectedFilter) {
            vm.currentFilter = selectedFilter;
            getReportingEmployeesPerformance().then(displayEmployeesChart);
        }
    }

    function clearDatesFilter() {
        vm.selectedDates = {
            startDate: null,
            endDate: null
        };
    }

    function loadLocationStats() {
        return Statistics.getCustomerLocationAllVisitsStats({}, function (data) {
            vm.customerLocationStats = data;
            vm.avgSpendPerCover = vm.customerLocationStats.avgSpendByCover;
        }).$promise;
    }

    function getReportingEmployeesPerformance() {
        return Statistics.getReportingEmployeesPerformance({
            selectedInterval: vm.selectedInterval,
            filterStartDate: vm.filterStartDate == null ? null : vm.filterStartDate.toISOString(),
            filterEndDate: vm.filterEndDate == null ? null : vm.filterEndDate.toISOString()
        }, function (data) {
            vm.chartData = data.chartData;
            vm.employeesDetails = data.details;
            for (var i = 0; i < vm.employeesDetails.detailData.length; i++)
                Reporting.calcAggrByWeekdayDataItem(vm.employeesDetails.detailData[i], vm.customerLocationStats);
        }).$promise;
    }

    function viewEmployeeDetails(id) {
        $state.go('settings.employees.view', {id: id});
    }

    function displayEmployeesChart() {
        var deferred = $q.defer();

        // employees performance
        var dataEmployees = new google.visualization.DataTable();
        dataEmployees.addColumn('string', 'Employee');
        dataEmployees.addColumn('number', 'Revenue');
        dataEmployees.addColumn('number', 'Tips');
        dataEmployees.addColumn({type: 'string', role: 'annotation'});

        _.each(vm.chartData, function (item) {
            dataEmployees.addRow(
                [
                    (item.firstName != null ? item.firstName : '') + ' ' + (item.lastName != null ? item.lastName : ''),
                    {
                        v: item.revenue,
                        f: $filter('currency')(item.revenue)
                    },
                    {
                        v: item.tips,
                        f: $filter('currency')(item.tips)
                    },
                    $filter('currency')(item.revenue + item.tips)]);
        });

        var optionsEmployees = {
            //title: 'Employee performance',
            isStacked: 'true',
            chartArea: {width: '90%', height: '70%'},
            legend: {position: 'top', alignment: 'end'},
            //width: 1000,
            height: 450,
            vAxis: {
                title: 'Revenue and Tips in ' + ApplicationContext.getCurrencySym(),
                textPosition: 'none',
                gridlines: {count: 13}, viewWindow: {min: 0},
                titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true}
            },
            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            colors: ['#1ABC9C', '#3399CC'],
            formatters: {}
        };

        vm.chartObjectEmployees = {
            type: 'ColumnChart',
            options: optionsEmployees,
            data: dataEmployees
        };

        deferred.resolve(true);
        return deferred.promise;
    }
}

angular.module('seatonApp').controller('EmployeesPerformanceController', EmployeesPerformanceController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tables', {
            abstract: true,
            parent: 'app',
            url: '/tables',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_OWNER', 'ROLE_MANAGER']
            }
        });
    }
})();


(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tables.dashboard', {
                parent: 'tables',
                url: '/dashboard',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/tables/dashboard/dashboard.html',
                        controller: 'ReservationsDashboardController',
                        controllerAs: 'dashboard'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

ReservationsDashboardController.$inject = ['$state', '$scope', '$q', '$document', '$filter', 'googleChartApiPromise',
    'EventResource', 'Reporting', 'ApplicationContext', 'ApplicationProfile'];

function ReservationsDashboardController($state, $scope, $q, $document, $filter, googleChartApiPromise, EventResource,
                                         Reporting, ApplicationContext, ApplicationProfile) {
    var vm = this;
    //vm.showMoreFeedback = showMoreFeedback;
    vm.tabChange = tabChange;
    vm.changedSelectedDates = changedSelectedDates;
    vm.changedCompareDaysBeforeButton = changedCompareDaysBeforeButton;
    vm.calcPct = Reporting.calcPct;
    vm.pickerDate;

    vm.compareDaysBeforeButton = -1;
    vm.lastWeekDay = moment().subtract(1, 'weeks');
    vm.lastWeekDayData = null;
    vm.comparedDay = vm.lastWeekDay.clone();

    vm.todayVsEnabled = ApplicationProfile.isTablesTodayVsEnabled();
    vm.todayVsText = ApplicationProfile.upgradeTierText("TablesTodayVs");
    vm.openWindow = ApplicationProfile.openAppCloverPage;

    vm.isMeal = (ApplicationContext.getProductType() == 'MEAL');


    $document.ready(
        function () {
            vm.comparedate = $document.find('input[name="comparedate"]');
            vm.comparedate.daterangepicker(
                {
                    //configuration parameters
                    singleDatePicker: true,
                    showDropdowns: true,
                    locale: {format: 'MMM D, YYYY'}
                },
                function (start, end, label) {
                    //callback function - called on picker value change - dates sent in callback parameters
                    vm.comparedDay = start;
                    vm.compareDaysBeforeButton = -1;
                    loadComparedDayData().then(loadTodayVsChart).then(windowResize);
                }
            );

            //initial datepicker values
            vm.comparedate.data('daterangepicker').setStartDate(vm.comparedDay);
            vm.comparedate.data('daterangepicker').setEndDate(vm.comparedDay);
        }
    );

	$scope.openingHourNotDefined = function() {
            return ApplicationContext.isBusinessHoursNotDefined();
    }

    vm.openPicker = openPicker;
    function openPicker() {
        vm.comparedate.focus();
    }

    load();

    function load() {
        $q.all([
            loadTodayData(),
            loadComparedDayData(),
            googleChartApiPromise
        ]).then(loadInitialCharts).then(copyLastWeekDayData);
    }

    function copyLastWeekDayData() {
        var deferred = $q.defer();
        vm.lastWeekDayData = angular.copy(vm.comparedDayData);
        deferred.resolve(true);
        return deferred.promise;
    }

    function tabChange(tab) {
        switch (tab) {
            case 'todayTab':
                $(window).resize();
                break;
            case 'visitTab':
                loadVisitsCharts().then(windowResize);
                break;
            case 'todayVsTab':
                if(vm.todayVsEnabled) { loadTodayVsChart().then(windowResize); }
                break;
        }
    }

    //not used!
    function changedSelectedDates() {
        if ((typeof vm.pickerDate) != 'string') {
            vm.comparedDay = vm.pickerDate.clone();
            vm.compareDaysBeforeButton = -1;
            loadComparedDayData().then(loadTodayVsChart).then(windowResize);
        }
    }

    function changedCompareDaysBeforeButton() {
        vm.comparedDay = moment().subtract(vm.compareDaysBeforeButton, 'days');
        vm.comparedate.data('daterangepicker').setStartDate(vm.comparedDay);
        vm.comparedate.data('daterangepicker').setEndDate(vm.comparedDay);
        loadComparedDayData().then(loadTodayVsChart).then(windowResize);
    }

    function windowResize() {
        var deferred = $q.defer();
        $(window).resize();
        deferred.resolve(true);
        return deferred.promise;
    }

    /*
     function showMoreFeedback() {
     ViewState.goToState('customer.feedback', {
     dates: {
     startDate: moment().subtract(1, 'year'),
     endDate: moment()
     }
     });
     }
     */

    function loadTodayData() {
        return EventResource.getEventsDashboardTodayData({}, function (data) {
            vm.todayData = data;
        }).$promise;
    }

    function loadComparedDayData() {
        //console.log(vm.comparedDay);
        return EventResource.getEventsDashboardTodayVsData({
            selectedDate: vm.comparedDay.format('YYYY-MM-DD')
        }, function (data) {
            vm.comparedDayData = data;
        }).$promise;
    }

    function loadInitialCharts() {
        var deferred = $q.defer();
        // revenue by hours
        var dataHours = new google.visualization.DataTable();
        dataHours.addColumn('string', 'Time of Day');
        dataHours.addColumn('number', 'Revenue', 'color: #1ABC9C');
        dataHours.addColumn({'type': 'string', 'role': 'tooltip'});
        dataHours.addColumn({type: 'string', role: 'annotation'});

        _.each(vm.todayData.revenueByHour, function (item) {
            dataHours.addRow([item.hourOfDayFmt, item.revenue,
                'Revenue ' + $filter('currency')(item.revenue)
                + '\n Tips ' + $filter('currency')(item.tips)
                + '\n Visits ' + $filter('number')(item.totalVisits)
                + '\n Covers ' + $filter('number')(item.totalCovers)
                + '', $filter('currency')(item.revenue)]);
        });

        var optionsHours = {
            title: 'Today\'s performance on hourly basis',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            //width: 950,
            height: 400,
            vAxis: {
                title: 'Revenue',
                gridlines: {count: 12}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },
            hAxis: {
                title: 'Time of Day',
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            chartArea: {width: '85%', height: '65%'},
            formatters: {},
            colors: ['#1ABC9C'],
            legend: 'none'
        };

        vm.chartObjectHours = {
            type: "ColumnChart",
            options: optionsHours,
            data: dataHours
        };

        deferred.resolve(true);
        return deferred.promise;
    }

    function loadVisitsCharts() {
        var deferred = $q.defer();
        //vistis - general pie chart
        vm.chartObjectVisitGeneral = {};
        vm.chartObjectVisitGeneral.type = "PieChart";

        vm.chartObjectVisitGeneral.options = {
            title: 'Visit statistics',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            legend: {position: 'right'},
            width: 380,
            height: 320,
            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#3399CC'},
                2: {color: '#996699'}
            }

        };

        vm.chartObjectVisitGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Reservation"},
                        {v: vm.todayData.todayVisitStats.totalReservationShow},
                    ]
                },
                {
                    c: [
                        {v: "Walk-In Seated"},
                        {v: vm.todayData.todayVisitStats.totalWalkinSeated}
                    ]
                },
                {
                    c: [
                        {v: "Walk-In Waitlist"},
                        {v: vm.todayData.todayVisitStats.totalWaitlistShow},
                    ]
                }
            ]
        };

        //reservation - general pie chart
        vm.chartObjectReservationGeneral = {};
        vm.chartObjectReservationGeneral.type = "PieChart";

        vm.chartObjectReservationGeneral.options = {
            title: 'Reservation statistics',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            legend: {position: 'right'},
            width: 450,
            height: 300,
            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#FF3333'},
                2: {color: '#FFCC33'}
            }
        };

        vm.chartObjectReservationGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Show"},
                        {v: vm.todayData.todayVisitStats.totalReservationShow},
                    ]
                },
                {
                    c: [
                        {v: "No Show"},
                        {v: vm.todayData.todayVisitStats.totalReservationNoShow}
                    ]
                },
                {
                    c: [
                        {v: "Canceled"},
                        {v: vm.todayData.todayVisitStats.totalReservationCanceled},
                    ]
                }
            ]
        };

        //wait list - general pie chart
        vm.chartObjectWaitlistGeneral = {};
        vm.chartObjectWaitlistGeneral.type = "PieChart";

        vm.chartObjectWaitlistGeneral.options = {
            title: 'Wait list statistics',
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            legend: {position: 'right'},
            width: 450,
            height: 300,
            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#FF3333'},
                2: {color: '#FFCC33'}
            }
        };

        vm.chartObjectWaitlistGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Show"},
                        {v: vm.todayData.todayVisitStats.totalWaitlistShow},
                    ]
                },
                {
                    c: [
                        {v: "No Show"},
                        {v: vm.todayData.todayVisitStats.totalWaitlistNoShow}
                    ]
                },
                {
                    c: [
                        {v: "Canceled"},
                        {v: vm.todayData.todayVisitStats.totalWaitlistCanceled},
                    ]
                }
            ]
        };

        deferred.resolve(true);
        return deferred.promise;
    }

    function loadTodayVsChart() {
        var deferred = $q.defer();
        // performance today vs ...
        var dataCompare = new google.visualization.DataTable();
        dataCompare.addColumn('string', 'Time of Day');
        dataCompare.addColumn('number', 'Today');
        dataCompare.addColumn('number', vm.comparedDay.format('dddd (Do MMM YY)'));

        var todayItem = null;
        var comparedDayItem = null;
        for (var i = 0; i < vm.todayData.revenueByHour.length; i++) {
            todayItem = vm.todayData.revenueByHour[i];
            comparedDayItem = vm.comparedDayData.revenueByHour[i];

            dataCompare.addRow(
                [
                    todayItem.hourOfDayFmt,
                    {
                        v: todayItem.revenue,
                        f: $filter('currency')(todayItem.revenue)
                    },
                    {
                        v: comparedDayItem.revenue,
                        f: $filter('currency')(comparedDayItem.revenue)
                    }
                ]
            );
        }

        var optionsCompare = {
            title: 'Today vs ' + vm.comparedDay.format('dddd (Do MMM YY)'),
            titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
            //width: 950,
            height: 450,
            bar: {groupWidth: "95%"},
            legend: {position: 'top', alignment: 'end'},
            vAxis: {
                title: 'Revenue',
                gridlines: {count: 12}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },
            hAxis: {
                title: 'Time of Day',
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            chartArea: {width: '75%', height: '65%'},
            formatters: {},
            colors: ['#1ABC9C', '#FF3333']
            //legend: {position: 'top', alignment: 'end'}
        };

        vm.chartObjectCompare = {
            type: "ColumnChart",
            options: optionsCompare,
            data: dataCompare
        };

        deferred.resolve(true);
        return deferred.promise;
    }
}

angular.module('seatonApp').controller('ReservationsDashboardController', ReservationsDashboardController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tables.management', {
                parent: 'tables',
                url: '/management/:tab',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/tables/management/management.html',
                        controller: 'TableManagementController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        // $translatePartialLoader.addPart('tables.management');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('TableManagementController', TableManagementController);

    TableManagementController.$inject = ['$scope', '$state', '$stateParams', 'Tables', 'Time', '$uibModal', 'Utils',
        'SweetAlert', 'SettingsResource', 'ApplicationContext', '$document', '$timeout', 'ChannelService', 'TextUtil'];

    function TableManagementController($scope, $state, $stateParams, Tables, Time, $uibModal, Utils,
                                       SweetAlert, SettingsResource, ApplicationContext, $document, $timeout,
                                       ChannelService, TextUtil) {
        var vm = this;

        vm.refreshText = 'Refresh list';
        vm.activeTab = -1;
        vm.initialLoad = true;
        // if Show is clicked 15 minutes before expected start time, we will display a Warning
        var EARLY_SHOW_WARNING_MINUTES = 15;
        var tabUrls = ['arrivals', 'walkin', 'waitlist', 'active', 'online-res'];
        vm.tabRefreshTimes = [];
        var TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
        vm.selectedProduct = {};
        vm.eventDuration = 0;

        vm.isTableManaged = ApplicationContext.isTableManaged();

        vm.timeNow = moment();
        var updateTimeNow = function () {
            vm.timeNow = moment();
            //console.log('vm.timeNow:' + vm.timeNow)
            //console.log($state.current.name);
            if ('tables.management' == $state.current.name) {
                $timeout(updateTimeNow, 10000);
            }
        }
        $timeout(updateTimeNow, 10000);
        vm.diffInSeconds = function (time, timeNow) {
            var diff = -Math.round(moment(time).diff(timeNow) / 1000);
            return diff;
        }

        function updateTabTime(tabInd) {
            vm.timeNow = moment();
            vm.tabRefreshTimes[tabInd] = moment();
        }

        vm.selectTab = function (tabIndex) {
            tabIndex = (tabIndex != -1) ? tabIndex : 0; // in case of wrong URL, we will load /arrivals by default
            vm.activeTab = tabIndex;
            $state.go('tables.management', {tab: tabUrls[tabIndex]}, {notify: false}); // change the URL
            if (vm.initialLoad) {
                loadDataForAllTabs();
                vm.initialLoad = false;
            } else {
                loadDataForSelectedTab();
            }
        }

        vm.utils = Utils;
        vm.arrivals = [];
        vm.tables = [];
        vm.activeEvents = [];

        // init Walkins filters
        vm.walkinsFilterSeats = 0;
        vm.walkinsFilterAvailableTime = 0;

        $scope.customerSearchKeyword = '';

        // walkin form
        vm.walkinForm = {
            noOfPersons: 0,
            quotedWaitTime: 0,
            note: null,
            customer: {}
        }

        // fetch general settings from server
        SettingsResource.getGeneralSettings({}, function (data) {
            vm.settings = data;
        });

        /** Called by the customer search directive when user selects a customer from a list */
        $scope.customerSelected = function (customer) {

            vm.walkinForm.customer = customer;
            vm.walkinForm.customer.primaryPhone = intlTelInputUtils.formatNumber(customer.primaryPhone, ApplicationContext.getPhoneRegion(), intlTelInputUtils.numberFormat.INTERNATIONAL);
            vm.walkinForm.customerOriginal = Utils.getBasicCustomerData(customer);

            vm.showNewWalkinCustomerForm(true);
        }

        vm.loadExpArrivals = function () {
            vm.refreshStart();
            Tables.getExpArrivalsToday({}, function (data) {
                vm.arrivals = data;
                updateTabTime(0);
                updateExpArrivalsData(vm.arrivals);

                vm.refreshStop();
            });
        }

        vm.loadWalkouts = function () {
            vm.refreshStart();
            Tables.getActiveEvents({}, function (data) {
                vm.activeEvents = data;
                updateTabTime(3);
                updateWalkoutData(vm.activeEvents);
                vm.refreshStop();
            });
        }

        vm.loadWalkins = function () {
            vm.refreshStart();
            Tables.getResourceAvailability({}, function (data) {
                vm.tables = data;
                updateTabTime(1);
                updateWalkinData(vm.tables);
                vm.refreshStop();
            });
        }

        // just used to animate the 'Refresh list' button
        vm.refreshStart = function() {
            vm.isRefreshing = true; // causes the icon to rotate
            vm.refreshText = 'In progress';
            vm.refreshStartTimeMillis = (new Date()).getMilliseconds();
        }
        // the minimum time spinner is being shown: 500 millis
        vm.refreshStop = function() {
        var serverFetchTimeMillis = (new Date()).getMilliseconds() - vm.refreshStartTimeMillis;
            var delay = Math.max(500 - serverFetchTimeMillis, 0);
            $timeout(function() {
                vm.isRefreshing = false;
                vm.refreshText = 'Refresh list';
            }, delay);
        }

        vm.cancelEvent = function (eventId, customerName, customerEmail) {
            SweetAlert.swal({
                    title: "Please confirm action",
                    text: "Are you sure you want to cancel this reservation?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {

                        vm.cancelCustomerName = customerName;
                        vm.cancelCustomerEmail = customerEmail;
                        vm.cancelEventId = eventId;

                        Tables.personalized(
                            {
                                messageType: 'RESERVATION_CANCEL'
                            },
                            function (data) {
                                vm.cancel = data;
                                if(vm.cancel.enabled) {
                                    vm.cancelMessageText = vm.cancel.defaultMessage;

                                    vm.cancelDialog = $uibModal.open({
                                        templateUrl: 'app/tables/management/cancel.dialog.html',
                                        scope: $scope
                                    });

                                } else {
                                    vm.triggerStateChange(eventId, 'CANCELLATION');
                                }
                            }
                        );
                    }
                });
        }

        vm.closeCancelDialog = function () {
            vm.cancelDialog.dismiss('cancel');
        }

        vm.cancelWithPersonalizedMessage = function () {

            vm.triggerStateChange(
                vm.cancelEventId,
                'CANCELLATION',
                null,
                {message: vm.cancelMessageText});

            vm.closeCancelDialog();
        }



        vm.triggerShow = function (id, expectedStartTime) {
            var confirmMsg = null;
            if (moment(expectedStartTime).diff(moment(), 'minutes') > EARLY_SHOW_WARNING_MINUTES) {
                var timeFmt = moment(expectedStartTime).format('hh:mmA');
                confirmMsg = 'The expected start time for this reservation is at ' + timeFmt + '. Are you sure you want to seat the customer this early?';
            }
            vm.triggerStateChange(id, 'ARRIVAL', confirmMsg)
        }

        vm.triggerStateChange = function (id, trigger, confirmMsg, params) {

            if (confirmMsg) {
                SweetAlert.swal({
                        title: "Please confirm action",
                        text: confirmMsg,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            triggerStateChangeOnServer(id, trigger, params);
                        }
                    });
            } else {
                triggerStateChangeOnServer(id, trigger, params);
            }
        }

        function triggerStateChangeOnServer(id, trigger, params) {
            var postParams = params ? params : {};
            postParams.id = id;
            postParams.trigger = trigger;

            Tables.triggerStateChange(
                postParams,
                function (data) {
                    loadDataForSelectedTab();
                },
                function (error) {
                   // this will usually happen if someone else updated the event state (server will return HTTP code 409 Conflict)
                   // we'll just refresh the screen
                   console.log("Tables.triggerStateChange() returned na error: ", error)

                   loadDataForSelectedTab();
                });
        }

        vm.releaseTable = function (eventId) {
            vm.walkoutPaymentInfo = null;
            vm.walkoutSelectedEventId = eventId;
            vm.walkoutDialog = $uibModal.open({
                templateUrl: 'app/tables/management/walkout.option.select.html',
                scope: $scope
            });
        }

        vm.walkoutNoPaymentInfo = function () {
            vm.triggerStateChange(vm.walkoutSelectedEventId, 'CLOSE_WITHOUT_PAYMENT');
            vm.closeWalkoutDialog();
        }

        vm.walkoutWithPaymentInfo = function () {

            if (vm.walkoutPaymentInfo && vm.walkoutPaymentInfo.amount >= 0 && (!vm.walkoutPaymentInfo.tip || vm.walkoutPaymentInfo.tip >= 0)) {

                if (!vm.walkoutPaymentInfo.tip) {
                    vm.walkoutPaymentInfo.tip = 0;
                }

                vm.triggerStateChange(
                    vm.walkoutSelectedEventId,
                    'PAYMENT',
                    null,
                    {
                        amount: parseInt(vm.walkoutPaymentInfo.amount * 100),
                        tip: parseInt(vm.walkoutPaymentInfo.tip * 100)
                    });
                vm.closeWalkoutDialog();
            }
        }

        vm.refreshWaitlistQueue = function () {
            vm.refreshStart();
            Tables.getWaitlistQueues(
                {},
                function (data) {
                    vm.waitlistQueues = data;
                    updateTabTime(2);

                    vm.refreshStop();
                }
            );
        }

        function updateExpArrivalsData(arrivals) {
            vm.arrivalsTotal = 0;
            vm.arrivalsTotalCover = 0;
            vm.arrivalsTotalOverdue = 0;
            vm.arrivalsTotalOverdueCover = 0;
            for (var i = 0; i < arrivals.length; i++) {
                var arrival = arrivals[i];
                vm.arrivalsTotal++;
                vm.arrivalsTotalCover += arrival.numberOfPersons;

                if (Time.fromNow(arrival.expectedStartTime) < 0) {
                    arrival.overdue = true;
                    vm.arrivalsTotalOverdue++;
                    vm.arrivalsTotalOverdueCover += arrival.numberOfPersons;
                }
            }
        }

        function updateWalkoutData(activeEvents) {
            vm.walkoutTotal = 0;
            vm.walkoutTotalCovers = 0;
            vm.walkoutTotalOverdue = 0;
            vm.walkoutTotalOverdueCovers = 0;

            for (var i = 0; i < activeEvents.length; i++) {
                var event = activeEvents[i];
                vm.walkoutTotal += event.resources.length;
                vm.walkoutTotalCovers += event.numberOfPersons;
                if (Time.fromNow(event.expectedEndTime) < 0) {
                    event.overdue = true;
                    vm.walkoutTotalOverdue += event.resources.length;
                    vm.walkoutTotalOverdueCovers += event.numberOfPersons;
                }
            }
        }

        function updateWalkinData(tables) {
            vm.walkinsAvailableTables = 0;
            vm.walkinsAvailableSeats = 0;
            vm.walkinsOccupiedTables = 0;
            vm.walkinsOccupiesSeats = 0;

            for (var i = 0; i < tables.length; i++) {
                var table = tables[i];
                if (table.availableIn === 0) {
                    vm.walkinsAvailableTables++;
                    vm.walkinsAvailableSeats += table.resource.capacity;
                    table.status = "Available now"
                } else {
                    vm.walkinsOccupiedTables++;
                    vm.walkinsOccupiesSeats += table.resource.capacity;
                    if (table.availableIn > 0) {
                        table.status = "Available in " + Utils.formatMinutes(table.availableIn);
                    } else {
                        table.status = Utils.formatMinutes(Math.abs(table.availableIn)) + " overdue";
                    }
                }
            }
        }

        vm.getWalkinsMaxCapacity = function () {
            var capacity = 0;
            for (var i = 0; i < vm.tables.length; i++) {
                if (vm.tables[i].selected) {
                    capacity += vm.tables[i].resource.capacity;
                }
            }
            return capacity;
        }

        /* Returns the available time of selected tables. If more that one table is selected, the minimal available time is returned. */
        vm.getSelectedTablesAvailTime = function () {
            var availableTime = 1440; // available the whole day
            for (var i = 0; i < vm.tables.length; i++) {
                if (vm.tables[i].selected && vm.tables[i].availableIn === 0 && vm.tables[i].availableTime < availableTime) {
                    availableTime = vm.tables[i].availableTime;
                }
            }
            return availableTime;
        }

        /** Returns true is the available time of tables selected for walkin less that the current meal duration */
        vm.isAvailableTimeTooShort = function () {
            return vm.getSelectedTablesAvailTime() < vm.walkinForm.duration;
        }

        /* Checks if all mandatory customer fields are filled on walkin form */
        vm.isWalkinFormCustomerDataFilled = function () {
            var filled = vm.walkinForm.customer && vm.walkinForm.customer.firstName &&
                (vm.walkinForm.customer.primaryPhone || vm.walkinForm.customer.primaryEmail);
            return filled;
        }

        function getSelectedWalkinTables() {
            var selectedIds = [];
            for (var i = 0; i < vm.tables.length; i++) {
                if (vm.tables[i].selected) {
                    selectedIds.push(vm.tables[i].resource.id);
                }
            }
            return selectedIds;
        }

        /* Returns the duration (from global settings), of the current meal (which is determined by the current time). */
        vm.getCurrentMealDuration = function () {
            var now = moment();
            var breakStart = moment(vm.settings.breakfastStart, TIME_SERVER_FORMAT);
            var breakEnd = moment(vm.settings.breakfastEnd, TIME_SERVER_FORMAT);
            if (now.isBetween(breakStart, breakEnd)) {
                return vm.settings.breakfastDuration;
            }
            var lunchStart = moment(vm.settings.lunchStart, TIME_SERVER_FORMAT);
            var lunchEnd = moment(vm.settings.lunchEnd, TIME_SERVER_FORMAT);
            if (now.isBetween(lunchStart, lunchEnd)) {
                return vm.settings.lunchDuration;
            }
            var dinnerStart = moment(vm.settings.dinnerStart, TIME_SERVER_FORMAT);
            var dinnerEnd = moment(vm.settings.dinnerEnd, TIME_SERVER_FORMAT);
            if (now.isBetween(dinnerStart, dinnerEnd)) {
                return vm.settings.dinnerDuration;
            }

            // we are outside of working hours, just return the maximum duration
            return Math.max(vm.settings.breakfastDuration, vm.settings.lunchDuration, vm.settings.dinnerDuration);
        }

        vm.showWalkinDialog = function () {
            vm.showNewWalkinCustomerForm(false);
            vm.walkinForm = {};
            vm.walkinForm.duration = Math.min(vm.getCurrentMealDuration(), vm.getSelectedTablesAvailTime());

            vm.walkinDialog = $uibModal.open({
                templateUrl: 'app/tables/management/walkins.dialog.html',
                scope: $scope,
                size: 'lg'
            });
        }

        vm.changeDuration = function(productId) {
            vm.selectedProduct = findProduct(productId);
            vm.eventDuration = vm.selectedProduct.duration;
        }

        vm.closeWalkoutDialog = function () {
            vm.walkoutDialog.dismiss('cancel');
        }

        vm.closeWalkinDialog = function () {
            vm.walkinDialog.dismiss('cancel');
        }

        vm.showNewWalkinCustomerForm = function (show) {
            $scope.showWalkinCustomerForm = show;
        }

        function doCreateWalkin() {

            var currentCustomer = null;
            if (vm.walkinForm.customer && !angular.equals(vm.walkinForm.customer, {})) {
                currentCustomer = Utils.getBasicCustomerData(vm.walkinForm.customer);
            }

            var customerChangedFlag = false;
            if (vm.walkinForm.customer && vm.walkinForm.customer.id != undefined && !angular.equals(currentCustomer, vm.walkinForm.customerOriginal)) {
                customerChangedFlag = true;
            }

            var params = {
                numberOfPersons: vm.walkinForm.noOfPersons,
                channel: 'WEB',
                note: vm.walkinForm.note,
                duration: vm.eventDuration,
                resourceIds: getSelectedWalkinTables(),
                existingCustomerUpdated: customerChangedFlag,
                customer: currentCustomer,
                productId: vm.walkinForm.productId,
                productType: vm.settings.productType
            }

            Tables.createWalkin(
                params,
                function (data) {
                    vm.closeWalkinDialog();
                    loadDataForSelectedTab();
                });
        }

        vm.createWalkin = function () {


            if (vm.walkinForm.noOfPersons > vm.getWalkinsMaxCapacity()) {
                // ask for confirmation
                SweetAlert.swal({
                        title: "Are you sure?",
                        text: 'Total ' + TextUtil.translate('resource','sc') + ' capacity (' + vm.getWalkinsMaxCapacity() + ') is not enough to accommodate ' + vm.walkinForm.noOfPersons + ' person(s)!',
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Create",
                        cancelButtonText: "Cancel",
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            doCreateWalkin();
                        }
                    });
            } else {
                doCreateWalkin();
            }
        }

        vm.waitlistNotify = function (eventId, numberOfPersons) {

            vm.loadWalkins(); // fetch fresh information about table availability

            vm.waitlistSelectedEventId = eventId;
            vm.waitlistSelectedNumberOfPersons = numberOfPersons;
            vm.waitlistNotifyDialog = $uibModal.open({
                templateUrl: 'app/tables/management/waitlist.notify.html',
                scope: $scope,
                size: 'lg'
            });
        }

        vm.closeWaitlistNotifyDialog = function () {
            vm.waitlistNotifyDialog.dismiss('cancel');
        }

        vm.waitlistNotifyCustomer = function () {
            var selectedTables = [];
            for (var i = 0; i < vm.tables.length; i++) {
                var table = vm.tables[i];
                if (table.selected) {
                    selectedTables.push(table.resource.id);
                }
            }
            vm.triggerStateChange(
                vm.waitlistSelectedEventId,
                'NOTIFICATION',
                null,
                {
                    resources: selectedTables,
                    duration: vm.eventDuration,
                    productId: vm.selectedProduct.id,
                    productType: vm.settings.productType
                }
            );

            vm.closeWaitlistNotifyDialog();
        }

        /** Fetches data from the server for the currently selected tab */
        function loadDataForSelectedTab() {
            if (vm.activeTab == 0) {
                vm.loadExpArrivals();
            } else if (vm.activeTab == 1) {
                vm.loadWalkins();
            } else if (vm.activeTab == 2) {
                vm.refreshWaitlistQueue();
            } else if (vm.activeTab == 3) {
                vm.loadWalkouts();
            } else if (vm.activeTab == 4) {
                vm.getPreresevedReservations();
            }
        }

        /** Fetches data from the server for all tabs */
        function loadDataForAllTabs() {
            vm.loadExpArrivals();
            vm.loadWalkins();
            vm.refreshWaitlistQueue();
            vm.loadWalkouts();
            vm.getPreresevedReservations();
        }

        vm.tabTimeout = function (tabInd, timeNow) {
            var diffInSec = vm.diffInSeconds(vm.tabRefreshTimes[tabInd], timeNow);
            //console.log('tabInd: '+tabInd+' diffInSec' + diffInSec);
            if (diffInSec >= 59) {
                return true;
            }
            return false;
        }

        // initial tab selection
        var tabIndex = tabUrls.indexOf($stateParams.tab);
        vm.activeTab = (tabIndex != -1) ? tabIndex : 0; // in case of wrong URL, we will load /arrivals by default

        vm.phoneRegion = ApplicationContext.getPhoneRegion();
        vm.reformatPhone = function () {
            $scope.numInput = $document.find('#primaryPhone');
            if (typeof intlTelInputUtils !== 'undefined') { // utils are lazy loaded, so must check
                var currentText = $scope.numInput.intlTelInput("getNumber", intlTelInputUtils.numberFormat.E164);
                if (typeof currentText === 'string') { // sometimes the currentText is an object :)
                    $scope.numInput.intlTelInput('setNumber', currentText); // will autoformat because of formatOnDisplay=true
                }
            }
        }

        //online reservations part

        vm.getPreresevedReservations = function () {
            vm.refreshStart();
            Tables.getPreresevedReservations(
                {
                    //from: moment().subtract(14, 'days').startOf('day').toISOString(),
                    from: moment("2000-01-01", "YYYY-MM-DD").startOf('day').toISOString(),
                    to: moment().add(1, 'year').toISOString(),
                    page: vm.currentPage - 1,
                    size: vm.itemsPerPage
                },
                function (data) {
                    vm.reservations = data.content;
                    vm.totalReservations = data.totalElements;
                    vm.tabRefreshTimes[4] = moment();
                    vm.refreshStop();
                }
            );
        }

        // paging data
        vm.currentPage = 1;
        vm.itemsPerPage = 25;
        vm.pageChanged = function () {
            vm.getPreresevedReservations();
        };

        vm.findTables = function (event) {
            $state.go('tables.newreservation', {prereservedEventId: event.id});
        }

        vm.diffInMinutes = function (time) {
            var diff = -Math.round(moment(time).diff(moment()) / 1000 / 60);
            return diff;
        }

        $scope.channelIcon = function(channel) {
            return ChannelService.getChannelIcon(channel);
        }

        $scope.channelToolTipText = function(channel) {
            return ChannelService.getChannelToolTipText(channel);
        }

        function findProduct(productId) {
            if(vm.settings.shortProductList) {
                for (var i = 0; i < vm.settings.shortProductList.length; i++) {
                    if(vm.settings.shortProductList[i].id == productId)
                        return vm.settings.shortProductList[i];
                }
            }

            if(vm.settings.selectProductList) {
                for (var i = 0; i < vm.settings.selectProductList.length; i++) {
                    if(vm.settings.selectProductList[i].id == productId)
                        return vm.settings.selectProductList[i];
                }
            }
            // product not found for product id
            return null;
        }

        vm.selectText = function() {
            if(vm.settings.productType=='MEAL') {
                return " meal or custom duration";
            } else if(vm.settings.productType=='PRODUCT') {
                return " product";
            } else if(vm.settings.productType=='DURATION') {
                return " duration";
            } else {
                return "";
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tables.eventDetails', {
            parent: 'tables',
            url: '/events/:eventId',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/tables/event/details/event.details.html',
                    controller: 'EventDetailsController',
                    controllerAs: 'vm'
                },
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('tables.event');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('EventDetailsController', EventDetailsController);

    EventDetailsController.$inject = ['$scope', '$state', '$stateParams', 'Tables', 'Notification', 'Utils',
        'Time', 'ApplicationProfile', 'SweetAlert', '$uibModal','Log'];

    function EventDetailsController($scope, $state, $stateParams, Tables, Notification, Utils, Time, ApplicationProfile,
                                    SweetAlert, $uibModal, Log) {

        var vm = this;
        vm.utils = Utils;
        vm.event = {};
        vm.eventId = $stateParams.eventId;

        vm.showChangeHistory = ApplicationProfile.isEventChangeHistoryEnabled();
        vm.showChangeHistoryText = ApplicationProfile.upgradeTierText("EventChangeHistory");
        vm.openWindow = ApplicationProfile.openAppCloverPage;
        vm.noteEditMode = false;

        // defines possible actions (state transitions) for each event type/state/status combination
        // KEY: type - state - status
        var actions = {

            "RESERVATION-OPEN-RESERVED" : ["Show", "No show", "Cancel"],
            "RESERVATION-OPEN-PRERESERVED" : ["Cancel"],
            "RESERVATION-OPEN-CONFIRMED" : ["Cancel"],
            "RESERVATION-OPEN-SHOW" : ["Cancel", "Move back to arrivals"],
            "RESERVATION-CLOSED-CANCELLED" : ["Re-open"],
            "RESERVATION-CLOSED-NO_SHOW" : ["Re-open"],

            "WALK_IN_SEATED-OPEN-SHOW" : ["Close"],

            "WALK_IN_WAITLISTED-OPEN-WAITLISTED" : ["Cancel"],
            "WALK_IN_WAITLISTED-OPEN-NOTIFIED" : ["Show", "No show", "Cancel"],
            "WALK_IN_WAITLISTED-OPEN-CONFIRMED" : ["Show", "No show", "Cancel"],
            "WALK_IN_WAITLISTED-OPEN-SHOW" : ["Cancel"],
            "WALK_IN_WAITLISTED-CLOSED-CANCELLED" : ["Re-open"],
            "WALK_IN_WAITLISTED-CLOSED-NO_SHOW" : ["Re-open"]
        }

        var actionMap = {
            "Confirm" : "CONFIRMATION",
            "Show" : "ARRIVAL",
            "No show" : "NO_ARRIVAL",
            "Cancel" : "CANCELLATION",
            "Close" : "CLOSE_WITHOUT_PAYMENT",
            "Move back to arrivals" : "BACK_TO_ARRIVALS",
            "Re-open" : "REOPEN",
            "Notify" : "NOTIFICATION"
        }

        var messageMap = {
            "No show": "Are you sure you want to mark event as No-SHOW (customer did not show up)?",
            "Cancel": "Are you sure you want to cancel event?",
            "Close": "Dow you want to close this event without payment details?"
        }

        vm.refresh = function() {
            Tables.getEventDetails(
                {
                    id: vm.eventId
                },
                function (data) {
                    vm.event = data;
                    updateTimeDiffs(data);
                    vm.specialDate = getSpecialDateToday(data);
                }
            );
        }
        vm.refresh();

        vm.capitalize = function (str) {
            if (str) {
                str = str.replace('_', ' ');
                return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
            } else {
                return "";
            }
        }

        vm.enableEditNote = function() {
            vm.editNoteMode = true;
            vm.newNote = vm.event.note;
        }

        vm.saveNote = function() {
            vm.editNoteMode = false;
            vm.event.note = vm.newNote;

            var putParams = {};
            putParams.note = vm.newNote;
            putParams.id = vm.eventId;

            Tables.updateEventNote(
                putParams,
                function (data) {
                    vm.refresh();
                },
                function (error) {
                    Log.debug("EventDetailsController", "Tables.updateEventNote() returned na error: " + error);
                    vm.refresh();
                }
            );
        }

        vm.cancelEditNote = function() {
            vm.editNoteMode = false;
            vm.newNote = vm.event.note;
        }

        vm.sendThankYou = function() {
            console.log("Thank you");
            var putParams = {};
            putParams.id = vm.eventId;

            SweetAlert.swal({
                    title: "Please confirm action",
                    text: 'Do you want to send thank you email?',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {

                        Tables.sendThankYou(
                            putParams,
                            function (data) {
                                vm.numberOfEmails = data.value;
                            },
                            function (error) {
                                console.log("Error sending thank you email");
                            }
                        );
                    }
                })
        }

        vm.getActions = function() {
            var key = vm.event.type + "-" + vm.event.state + "-" + vm.event.status;
            var hasTables = vm.event.resources && vm.event.resources.length > 0;

            return actions[key] || [];
        }

        vm.changeStatus = function(action, params) {

            var confirmMsg = messageMap[action];
            if (confirmMsg) {
                SweetAlert.swal({
                        title: "Please confirm action",
                        text: confirmMsg,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            if(vm.event.type == 'RESERVATION' && action=='Cancel') {
                                vm.cancelCustomerName = vm.event.customer.firstName + ' ' + vm.event.customer.lastName;
                                vm.cancelCustomerEmail = vm.event.customer.primaryEmail;
                                vm.cancelEventId = vm.event.id;

                                Tables.personalized(
                                    {
                                        messageType: 'RESERVATION_CANCEL'
                                    },
                                    function (data) {

                                        vm.cancel = data;
                                        if (vm.cancel.enabled) {
                                            vm.cancelMessageText = vm.cancel.defaultMessage;

                                            vm.cancelDialog = $uibModal.open({
                                                templateUrl: 'app/tables/management/cancel.dialog.html',
                                                scope: $scope
                                            });

                                        } else{
                                            vm.triggerStateChange(vm.event.id, actionMap[action]);
                                        }
                                    }
                                );
                            } else {
                                vm.triggerStateChange(vm.event.id, actionMap[action]);
                            }
                        }
                    });
            } else {
                vm.triggerStateChange(vm.event.id, actionMap[action]);
            }
        }

        vm.triggerStateChange = function(eventId, action, params) {
            var postParams = params ? params : {};
            postParams.id = eventId;
            postParams.trigger = action;

            Tables.triggerStateChange(
                postParams,
                function (data) {
                    vm.refresh();
                },
                function (error) {
                    // this will usually happen if someone else updated the event state (server will return HTTP code 409 Conflict)
                    // we'll just refresh the screen
                    Log.debug("EventDetailsController", "Tables.triggerStateChange() returned na error: " + error);
                    vm.refresh();
                }
            );
        }

        vm.closeCancelDialog = function () {
            vm.cancelDialog.dismiss('cancel');
        }

        vm.cancelWithPersonalizedMessage = function () {

            vm.triggerStateChange(
                vm.cancelEventId,
                'CANCELLATION',
                {message: vm.cancelMessageText});

            vm.closeCancelDialog();
        }

        vm.findTables = function (event) {
            $state.go('tables.newreservation', {prereservedEventId: event.id});
        }

        vm.formatChannel = function (channel) {
            if (channel == 'DEVICE') {
                return 'Clover device';
            } else if (channel == 'WEB') {
                return 'SeatOn web app';
            } else if (channel == 'MERCHANT_WEB') {
                return 'Restaurant\'s web page';
            } else if (channel == 'FACEBOOK') {
                return 'Restaurant\'s Facebook page';
             } else if (channel == 'GOOGLE') {
                return 'Restaurant\'s Google page';
            } else if (channel == 'IVR') {
                    return 'SeatOn IVR system';
            } else {
                return channel;
            }
        }

        /** If the feedback is older than two days, this method returns false,
            otherwise it returns true. */
        vm.isNewFeedback = function (time) {
            var timeDiffMillis = Time.fromNow(time);
            var timeDiffDays   = timeDiffMillis / 1000.0 / 60.0 / 60.0 / 24.0;

            return (timeDiffDays > -2);
        }

        function updateTimeDiffs(event) {
            if (event.expectedStartTime && event.arrivalTime) {
                // negative : came in DIFF minutes early
                // zero     : came on time
                // positive : came in DIFF minute late
                vm.arrivalDiff = (moment(event.arrivalTime).diff(event.expectedStartTime) / 60000.0).toFixed(0);
            }

            if (event.expectedEndTime && (event.paidTime || event.checkOutTime)) {
                var closingTime = event.paidTime ? event.paidTime : event.checkOutTime;
                // negative : left DIFF minutes early
                // zero     : left on time
                // positive : left in DIFF minute late
                vm.closingDiff = (moment(closingTime).diff(event.expectedEndTime) / 60000.0).toFixed(0);
            }

            if (event.notifiedTime && event.quotedWaitTime && event.createdDate) {
                var expectedTime = moment(event.createdDate).add(event.quotedWaitTime, 'minutes');
                // negative : notified DIFF minutes before quoted time
                // zero     : notified on time
                // positive : notified DIFF minutes later then quoted time
                vm.notifiedDiff = (moment(event.notifiedTime).diff(expectedTime) / 60000.0).toFixed(0);
            }
        }

        function getSpecialDateToday(event) {

            if (event.customer) {
                for (var i = 0; i < event.customer.importantDates.length; i++) {
                    var imDate = event.customer.importantDates[0];
                    if (moment().isSame(moment(imDate.value), 'day')) {
                        return imDate.dateType; // return only the first one
                    }
                }
            }
            return undefined;
        }

        vm.calculateActualDuration = function() {
            var closingTime = vm.event.paidTime ? vm.event.paidTime : vm.event.checkOutTime;
            if(closingTime && vm.event.arrivalTime) {
                 var actualDuration = (moment(closingTime).diff(vm.event.arrivalTime) / 60000.0).toFixed(0);
                return actualDuration;
            }
            return 0;
        }

        // Reservation fee
        vm.captureUntil = function(createdDate) {
            var start = moment(createdDate);
            return start.add(7, 'days').format("MMM Do YYYY");
        }

        vm.paymentEnabled = function() {
            return vm.event.paymentFeeAmount && vm.event.paymentFeeAmount>0;
        }

        vm.showPaymentDetails = function() {
            return vm.paymentEnabled();// && vm.event.paymentTipAmount;
        }

        vm.hasModifiers = function() {
            return vm.event.productModifierList && (vm.event.productModifierList.length>0);
        }

        vm.refundApprovedAmount = function() {
            var confirmMsg = "Please confirm you want to refund reservation fee.";
            SweetAlert.swal({
                    title: "Reservation fee refund",
                    text: confirmMsg,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if(isConfirm) {

                        var postParams = {
                            eventId: vm.event.id,
                            chargeId: vm.event.paymentChargeId,
                            amount: vm.event.paymentApprovedAmount
                        };

                        Tables.refundReservationFee (
                            postParams,
                            function (data) {
                                var msgTitle = "Refund successfully completed!";
                                var alertType = "success";
                                var msgText = "";
                                if(data.refundSucceed) {
                                    vm.event.paymentStatus = data.paymentStatus;
                                    vm.event.eventPaymentHistories = data.eventPaymentHistories;
                                } else {
                                    msgTitle = "Refund failed!";
                                    msgText = "Refund declined by Clover. Please try later again. If the error persists please see refund decline details under transaction list in Clover dashboard.";
                                    alertType = "error"
                                }

                                SweetAlert.swal({
                                        title: msgTitle,
                                        text: msgText,
                                        type: alertType,
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "OK",
                                        closeOnConfirm: true
                                    },
                                    function (isConfirm) {
                                    });
                            }
                        )
                    }
                });

        }

        vm.captureApprovedAmount = function() {
            var confirmMsg = "Please confirm you want to capture reservation fee.";
            SweetAlert.swal({
                    title: "Reservation fee capture.",
                    text: confirmMsg,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if(isConfirm) {

                        var postParams = {
                            eventId: vm.event.id,
                            chargeId: vm.event.paymentChargeId,
                            amount: vm.event.paymentApprovedAmount,
                            receiptEmail: vm.event.customer.primaryEmail
                        };

                        Tables.captureReservationFee (
                            postParams,
                            function (data) {
                                var msgTitle = "Reservation fee successfully captured!";
                                var alertType = "success";
                                var msgText = "";
                                if(data.refundSucceed) {
                                    vm.event.paymentStatus = data.paymentStatus;
                                    vm.event.eventPaymentHistories = data.eventPaymentHistories;
                                } else {
                                    msgTitle = "Reservation fee capture failed!";
                                    msgText = "Reservation fee capture declined by Clover. Please try later again. If the error persists please see capture decline details under transaction list in Clover dashboard.";
                                    alertType = "error"
                                }

                                SweetAlert.swal({
                                        title: msgTitle,
                                        text: msgText,
                                        type: alertType,
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "OK",
                                        closeOnConfirm: true
                                    },
                                    function (isConfirm) {
                                    });
                            }
                        )
                    }
                });
        }
    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tables.eventUpdate', {
            parent: 'tables',
            url: '/events/:eventId/update',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/tables/event/update/event.update.html',
                    controller: 'EventUpdateController',
                    controllerAs: 'vm'
                },
            },
            params: {
                "event": {}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('tables.event');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('EventUpdateController', EventUpdateController);

    EventUpdateController.$inject = ['$scope', '$state', '$stateParams', '$document', 'Tables', 'Notification', 'Utils',
        'Time', 'CustomerResource', 'SweetAlert', 'ApplicationContext', 'Log', 'SettingsResource', '$uibModal'];

    var DATE_FORMAT = 'YYYY-MM-DD';
    var TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
    var TIME_DISPLAY_FORMAT = 'hh:mmA';
    var DATE_PICKER_FORMAT = 'MMM D, YYYY';

    function EventUpdateController($scope, $state, $stateParams, $document, Tables, Notification, Utils,
                                   Time, CustomerResource, SweetAlert, ApplicationContext, Log, SettingsResource, $uibModal) {

        var vm = this;
        vm.eventId = $stateParams.eventId;
        vm.utils = Utils;
        vm.event = $stateParams.event;
        vm.productList = {};
        vm.selectedProduct = null;
        vm.settings = null;
        vm.notificationMessageText = null;
        vm.notificationDialog = null;

        // function definition
        vm.findTables = findTables;
        vm.daySelected = daySelected;
        vm.clearTables = clearTables;
        vm.getSelectedResources = getSelectedResources;
        vm.getSelectedResourcesCapacity = getSelectedResourcesCapacity;
        vm.getSelectedResourcesIds = getSelectedResourcesIds;
        vm.altTimeSelected = altTimeSelected;
        vm.resetCustomer = resetCustomer;
        vm.isUpdateDisabled = isUpdateDisabled;
        vm.isUpdateWithWarning = isUpdateWithWarning;
        vm.isTimeSet = isTimeSet;
        vm.startUpdate = startUpdate;
        vm.reformatPhone = reformatPhone;
        vm.openDatePicker = openDatePicker;
        vm.findProduct = findProduct;
        vm.findDuration = findDuration;
        vm.selectProductText = selectProductText;
        vm.getProductInfo = getProductInfo;
        vm.changeDuration = changeDuration;
        vm.doUpdate = doUpdate;
        vm.closeNotificationDialog = closeNotificationDialog;


        function getGeneralSettings() {
            SettingsResource.getGeneralSettings(
                {},
                function (data) {
                    vm.settings = data;
                    if(vm.settings.shortProductList) {
                        vm.productList = vm.settings.shortProductList.concat(vm.settings.selectProductList);
                    } else {
                        vm.productList = vm.settings.selectProductList;
                    }

                    if(!vm.event || !vm.event.id) {
                        Log.debug("Fetching event details with id " + vm.eventId + "from database.")
                        Tables.getEventDetails(
                            {
                                id: vm.eventId
                            },
                            function (data) {
                                vm.event = data;
                                init();
                            }
                        );
                    } else {
                        init();
                    }
                }
            );
        }
        getGeneralSettings();

        function init() {
            vm.oldExpectedStartTime = vm.event.expectedStartTime;
            vm.oldDuration = vm.event.expectedDuration;
            vm.oldNumberOfPersons = vm.event.numberOfPersons;
            vm.oldResources = vm.event.resources;
            vm.oldCustomer = vm.event.customer;
            vm.isExpectedArrival = vm.event.state === 'OPEN' && (vm.event.status === 'RESERVED' || vm.event.status == 'NOTIFIED' || vm.event.status === 'CONFIRMED');

            vm.note = vm.event.note;
            vm.customer = vm.event.customer;
            vm.customerOriginal = vm.event.customer != null ? Utils.getBasicCustomerData(vm.event.customer) : null;
            vm.numberOfPersons = vm.event.numberOfPersons;
            vm.oldSelectedDay = moment(vm.event.expectedStartTime).format(DATE_FORMAT);
            vm.selectedDay = moment(vm.event.expectedStartTime).format(DATE_FORMAT);
            vm.selectedDayFormatted = moment(vm.selectedDay, DATE_FORMAT).format(DATE_PICKER_FORMAT);
            vm.oldSelectedTime = moment(vm.event.expectedStartTime).format(TIME_DISPLAY_FORMAT);
            vm.selectedTime = moment(vm.event.expectedStartTime).format(TIME_DISPLAY_FORMAT);
            vm.duration = vm.event.expectedDuration;
            vm.productId = vm.event.product.id;
            vm.findTables();
        }

        function daySelected() {

            vm.clearTables();
            vm.selectedDayFormatted = moment(vm.selectedDay, DATE_FORMAT).format(DATE_PICKER_FORMAT);
            vm.findTables();
        }

        function clearTables() {
            vm.tables = null;
            vm.alternativeTimes = null;
        }

        function findTables() {

            if (vm.selectedDay && vm.isTimeSet() && vm.numberOfPersons && vm.duration) {
                var currentlySelectedResources = (vm.getSelectedResources().length == 0) ? vm.oldResources : vm.getSelectedResources();

                vm.clearTables();
                Tables.findAvailableTables(
                    {
                        date: vm.selectedDay,
                        time: timeToServerFormat(vm.selectedTime),
                        numberOfPersons: vm.numberOfPersons,
                        duration: vm.duration,
                        eventToIgnoreId : vm.event.id
                    },
                    function (data) {

                        vm.tables = selectPreviouslySelected(data.availableResources, currentlySelectedResources);
                        vm.noResource = data.noResource;

                        vm.alternativeTimes = [];
                        for (var j = 0; j < data.alternativeTimes.length; j++) {
                            vm.alternativeTimes.push({
                                time: moment(data.alternativeTimes[j].time, TIME_SERVER_FORMAT).format(TIME_DISPLAY_FORMAT),
                                capacity: data.alternativeTimes[j].capacity
                            });
                        }
                    }
                );
            }
        }

        // Returns the list passed as tables, but if marks tables that were previously selected (if any) as selected.
        function selectPreviouslySelected(tables, previouslySelected) {

            var resultList = [];

            for (var i = 0; i < tables.length; i++) {
                var table = tables[i];
                var wasSelected = false;
                for (var j = 0; j < previouslySelected.length; j++) {
                    if (table.id == previouslySelected[j].id) {
                        wasSelected = true;
                        break;
                    }
                }
                table.selected = wasSelected;
                resultList.push(table);
            }
            return resultList;
        }

        /** Returns a list of all currently selected resources. */
        function getSelectedResources() {
            var selectedResources = [];

            if (vm.tables) {
                for (var i = 0; i < vm.tables.length; i++) {
                    if (vm.tables[i].selected === true) {
                        selectedResources.push(vm.tables[i]);
                    }
                }
            }
            return selectedResources;
        }

        function getSelectedResourcesIds() {
            var selectedIds = [];
            var selectedResources = getSelectedResources();

            for (var i = 0; i < selectedResources.length; i++) {
                selectedIds.push(selectedResources[i].id);
            }
            return selectedIds;
        }

        function getSelectedResourcesCapacity() {
            var capacity = 0;
            var selectedResources = getSelectedResources();

            for (var i = 0; i < selectedResources.length; i++) {
                capacity += selectedResources.capacity;
            }
            return capacity;
        }

        function altTimeSelected() {
            vm.selectedTime = vm.selectedAltTime;

            if (vm.selectedDay && vm.selectedTime && vm.numberOfPersons && vm.duration) {
                vm.findTables();
            }
        }

        /** Called by the customer search directive when user selects a customer from a list */
        $scope.customerSelected = function (selCust) {

            CustomerResource.get(
                {id: selCust.id},
                function (data) {
                    vm.customer = data;
                    vm.customer.primaryPhone = intlTelInputUtils.formatNumber(vm.customer.primaryPhone, ApplicationContext.getPhoneRegion(), intlTelInputUtils.numberFormat.INTERNATIONAL);
                    vm.customerTotal = vm.customer.totalVisits + vm.customer.totalNoShow + vm.customer.totalCanceled;
                    vm.customerOriginal = Utils.getBasicCustomerData(data);
                }
            );
        }

        function resetCustomer() {
            // workaround for https://github.com/angular/angular.js/issues/2743
            jQuery("input[name='primaryEmail']").val("");
            jQuery("input[name='primaryPhone']").val("");

            vm.customer = null;
            vm.customerTotal = null;
            vm.customerOriginal = null;
            $scope.customerSearchKeyword = '';
        }

        function isUpdateDisabled() {
            var isDisabled =
                !vm.numberOfPersons ||
                !vm.duration ||
                !vm.isTimeSet() ||
                !vm.selectedDayFormatted ||
                vm.getSelectedResources().length === 0 ||
                $scope.customerForm.primaryEmail.$error.email ||
                (vm.event.type !== 'WALK_IN_SEATED' &&
                    (!vm.customer ||
                        !vm.customer.firstName ||
                        !(vm.customer.primaryPhone || vm.customer.primaryEmail)));
            return isDisabled;
        }

        function isUpdateWithWarning() {
            var warning =
                (vm.getSelectedResources().length > 0 && vm.getSelectedResourcesCapacity() < vm.numberOfPersons);

            return warning;
        }

        function isTimeSet() {
            return vm.selectedTime && moment(vm.selectedTime, TIME_DISPLAY_FORMAT).isValid();
        }

        // user confirmed update or there was no confirm dialog
        function updateConfirmed() {

            // personalized update dialog should be displayed in these cases:
            // type = RESERVATION && state = OPEN && customerEmail != null && (date change || time changed || party size changed) && messageSending enabled && custom message enabled
            if (vm.event.type === 'RESERVATION' && vm.event.state === 'OPEN' && vm.event.customer.primaryEmail &&
                (vm.oldNumberOfPersons != vm.numberOfPersons || vm.oldSelectedDay != vm.selectedDay || vm.oldSelectedTime != vm.selectedTime)) {

                // need to check if personalization is enabled for location
                Tables.personalized(
                {
                    messageType: 'RESERVATION_UPDATE'
                },
                function (data) {

                    if (data.enabled) {
                        vm.notificationMessageText = data.defaultMessage;
                        vm.notificationDialog = $uibModal.open({
                            templateUrl: 'app/tables/event/update/notification.message.dialog.html',
                            scope: $scope
                        });
                    } else{
                        // personalization not enabled
                        doUpdate();
                    }
                });
            } else {
                doUpdate();
            }
        }

        function doUpdate() {

            var currentCustomer = vm.customer != null ? Utils.getBasicCustomerData(vm.customer) : null;
            var customerChangedFlag = currentCustomer && currentCustomer.id && !angular.equals(currentCustomer, vm.customerOriginal);


            var params = {
                id: vm.eventId,
                date: vm.selectedDay,
                time: timeToServerFormat(vm.selectedTime),
                channel: 'WEB',
                duration: vm.duration,
                numberOfPersons: vm.numberOfPersons,
                resourceIds: vm.getSelectedResourcesIds(),
                note: vm.note,
                existingCustomerUpdated: customerChangedFlag,
                customer: currentCustomer,
                productType: vm.settings.productType,
                productId: vm.productId,
                customNotificationText: vm.notificationMessageText
            }

            Tables.updateEvent(
                params,
                function (data) {
                    $state.go('tables.eventDetails', {eventId: data.id});
                });
        }

        function startUpdate() {

            if (vm.isUpdateWithWarning()) {

                var text = ' ';
                if (vm.getSelectedResourcesCapacity() < vm.numberOfPersons) {
                    text += ' Total table capacity (' + vm.getSelectedResourcesCapacity() + ') is not enough to seat ' + vm.numberOfPersons + ' person(s)!';
                }

                SweetAlert.swal({
                        title: "Are you sure?",
                        text: text,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Update event",
                        cancelButtonText: "Cancel",
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            updateConfirmed();
                        }
                    });
            } else {
                updateConfirmed();
            }
        }

        /** Returns the selected time in the format expected by the REST service. */
        function timeToServerFormat(time) {
            return moment(time, TIME_DISPLAY_FORMAT).format(TIME_SERVER_FORMAT);
        }

        // initialize date & time picker
        $document.ready(
            function () {
                // date picker
                vm.datePicker = $document.find('input[name="datePicker"]');
                vm.datePicker.daterangepicker(
                    {
                        singleDatePicker: true,
                        showDropdowns: true,
                        locale: {format: DATE_PICKER_FORMAT}
                    },
                    function (start, end, label) {
                        vm.selectedDay = start.format(DATE_FORMAT)
                        vm.daySelected();
                    }
                );
                vm.datePicker.val(vm.selectedDayFormatted);

                // time picker
                vm.timePicker = $('.clockpicker').clockpicker({
                    donetext: 'Done',
                    twelvehour: true
                });
            }
        );

        function openDatePicker() {
            vm.datePicker.focus();
        }

        vm.phoneRegion = ApplicationContext.getPhoneRegion();
        function reformatPhone() {
            $scope.numInput = $document.find('#primaryPhone');
            if (typeof intlTelInputUtils !== 'undefined') { // utils are lazy loaded, so must check
                var currentText = $scope.numInput.intlTelInput("getNumber", intlTelInputUtils.numberFormat.E164);
                if (typeof currentText === 'string') { // sometimes the currentText is an object :)
                    $scope.numInput.intlTelInput('setNumber', currentText); // will autoformat because of formatOnDisplay=true
                }
            }
        }

        function findProduct(productId) {
            if(vm.productList) {
                for (var i = 0; i < vm.productList.length; i++) {
                    if(vm.productList[i].id == productId)
                        return vm.productList[i];
                }
            }
            // product not found for product id
            return null;
        }

        function findDuration(duration) {
            if(vm.productList) {
                for (var i = 0; i < vm.productList.length; i++) {
                    if(vm.productList[i].duration == duration)
                        return vm.productList[i];
                }
            }
            // product not found for product id
            return null;
        }

        function selectProductText() {
            if(vm.event.productType=='MEAL') {
                return " meal or custom duration";
            } else if(vm.event.productType=='PRODUCT') {
                return " product";
            } else {
                return " duration";
            }
        }

        function getProductInfo() {
            if(vm.event.product) {
                return vm.event.product.name;
            } else {
                return "unknown";
            }
        }

        function changeDuration(productId) {
            if (productId) {
                vm.selectedProduct = findProduct(productId);
                vm.duration = vm.selectedProduct.duration;
                vm.productId = vm.selectedProduct.id;
                findTables();
            } else {
                vm.selectedProduct = null;
                vm.duration = null;
                vm.productId = null;
            }
        }

        function closeNotificationDialog () {
            vm.notificationDialog.dismiss('cancel');
        }
    }
})();




(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tables.overview', {
                parent: 'tables',
                url: '/overview/:range?from&to',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/tables/overview/overview.html',
                        controller: 'ReservationOverviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

ReservationOverviewController.$inject = ['$state', '$stateParams', '$location', '$scope', '$q', '$filter', '$document',
    'Tables', 'Statistics', 'googleChartApiPromise', 'Reporting', 'ApplicationContext', '$uibModal', 'ChannelService',
    'TextUtil', 'EventResource'];

function ReservationOverviewController($state, $stateParams, $location, $scope, $q, $filter, $document,
                                       Tables, Statistics, googleChartApiPromise, Reporting, ApplicationContext, $uibModal, ChannelService, TextUtil, EventResource) {

    var vm = this;
    vm.coverTrans = TextUtil.translate('person', 'c');

    //console.log($state);
    //console.log($stateParams);

    $scope.openingHourNotDefined = function () {
        return ApplicationContext.isBusinessHoursNotDefined();
    };

    var ranges_day = {
        'today': {
            from: moment().startOf('day').toISOString(),
            to: moment().endOf('day').toISOString(),
            label: 'Today'
        },
        'tomorrow': {
            from: moment().add(1, 'days').startOf('day').toISOString(),
            to: moment().add(1, 'days').endOf('day').toISOString(),
            label: 'Tomorrow'
        },
        'todayplus2': {
            from: moment().add(2, 'days').startOf('day').toISOString(),
            to: moment().add(2, 'days').endOf('day').toISOString(),
            label: moment().add(2, 'days').format('dddd')
        },
        'todayplus3': {
            from: moment().add(3, 'days').startOf('day').toISOString(),
            to: moment().add(3, 'days').endOf('day').toISOString(),
            label: moment().add(3, 'days').format('dddd')
        },
        'todayplus4': {
            from: moment().add(4, 'days').startOf('day').toISOString(),
            to: moment().add(4, 'days').endOf('day').toISOString(),
            label: moment().add(4, 'days').format('dddd')
        },
        'todayplus5': {
            from: moment().add(5, 'days').startOf('day').toISOString(),
            to: moment().add(5, 'days').endOf('day').toISOString(),
            label: moment().add(5, 'days').format('dddd')
        },
        'todayplus6': {
            from: moment().add(6, 'days').startOf('day').toISOString(),
            to: moment().add(6, 'days').endOf('day').toISOString(),
            label: moment().add(6, 'days').format('dddd')
        }
    };

    var ranges_week = {
        'this_week': {
            from: moment().startOf('week').startOf('day').toISOString(),
            to: moment().startOf('week').add(6, 'days').endOf('day').toISOString(),
            label: 'This week'
        },
        'next_week': {
            from: moment().startOf('week').add(7, 'days').startOf('day').toISOString(),
            to: moment().startOf('week').add(13, 'days').endOf('day').toISOString(),
            label: 'Next week'
        },
        'weekplus2': {
            from: moment().startOf('week').add(14, 'days').startOf('day').toISOString(),
            to: moment().startOf('week').add(20, 'days').endOf('day').toISOString(),
            label: '' + moment().startOf('week').add(14, 'days').startOf('day').format('Do MMM') + ' - ' + moment().startOf('week').add(20, 'days').endOf('day').format('Do MMM')
        },
        'weekplus3': {
            from: moment().startOf('week').add(21, 'days').startOf('day').toISOString(),
            to: moment().startOf('week').add(27, 'days').endOf('day').toISOString(),
            label: '' + moment().startOf('week').add(21, 'days').startOf('day').format('Do MMM') + ' - ' + moment().startOf('week').add(27, 'days').endOf('day').format('Do MMM')
        },
        'weekplus4': {
            from: moment().startOf('week').add(28, 'days').startOf('day').toISOString(),
            to: moment().startOf('week').add(34, 'days').endOf('day').toISOString(),
            label: '' + moment().startOf('week').add(28, 'days').startOf('day').format('Do MMM') + ' - ' + moment().startOf('week').add(34, 'days').endOf('day').format('Do MMM')
        },
        'weekplus5': {
            from: moment().startOf('week').add(35, 'days').startOf('day').toISOString(),
            to: moment().startOf('week').add(41, 'days').endOf('day').toISOString(),
            label: '' + moment().startOf('week').add(35, 'days').startOf('day').format('Do MMM') + ' - ' + moment().startOf('week').add(41, 'days').endOf('day').format('Do MMM')
        },
        'weekplus6': {
            from: moment().startOf('week').add(42, 'days').startOf('day').toISOString(),
            to: moment().startOf('week').add(48, 'days').endOf('day').toISOString(),
            label: '' + moment().startOf('week').add(42, 'days').startOf('day').format('Do MMM') + ' - ' + moment().startOf('week').add(48, 'days').endOf('day').format('Do MMM')
        }
    };

    //var ranges = ranges_day;
    //vm.ranges = ranges;
    //vm.selectedRange = 'this_week';
    //vm.viewType = null;

    vm.getOverview = function (period) {
        var range = getRange(period);
        Tables.getReservationOverview(
            range,
            function (data) {
                vm.overview = data;
            }
        );
        //getReportingOccupancyByHour(range.from);
    };

    // fetch overview for today reservations
    function fetchOverviewAll() {
        Tables.getReservationOverview(
            {
                //range interval for fetching of all reservations
                from: moment().startOf('day').toISOString(),
                to: '9999-12-31T00:00:00.000Z'
            },
            function (data) {
                vm.overviewAll = data;
            }
        );
    }

    vm.getOpenReservations = function (period) {
        var range = getRange(period);
        vm.range = range;

        Tables.getOpenReservations(
            {
                from: range.from,
                to: range.to,
                page: vm.currentPage - 1,
                size: vm.itemsPerPage
            },
            function (data) {
                vm.reservations = data.content;
                vm.totalItems = data.totalElements;
            }
        );
        getReportingExpectedOccupancyByHour(range.from).then(displayHourChart);
    };

    function getRange(period) {
        if (period === 'custom') { // range selected on the date picker
            return {
                from: vm.filterFrom,
                to: vm.filterTo
            };
        } else {
            // pre-defined period
            return vm.ranges[period];
        }
    }

    vm.reload = function (rangeType) {
        //console.log("vm.reload :" + rangeType);
        //console.log(rangeType);
        //console.log("vm.selectedRange:" + vm.selectedRange);

        if (vm.viewType == 'weekly') {
            vm.ranges = ranges_week;
            if (rangeType == 'weekly') vm.selectedRange = 'this_week';
            //getWeekOccupancy(vm.selectedRange).then(getLastWeekOccupancy(vm.selectedRange)).then(displayWeekChart);
            getWeekOccupancy(vm.selectedRange);
        } else {
            vm.ranges = ranges_day;
            if (rangeType == 'daily') vm.selectedRange = 'today';
        }

        vm.getOverview(vm.selectedRange);
        vm.getOpenReservations(vm.selectedRange);
        var params = {
            range: vm.selectedRange,
            from: null,
            to: null
        };
        if (vm.selectedRange === 'custom') {
            params.from = vm.filterFrom;
            params.to = vm.filterTo;
        }
        $state.go('tables.overview', params, {notify: false}); // change the URL
        updateDatePickerText();
    };

    // reservations list, page changed
    vm.pageChanged = function () {
        vm.getOpenReservations(vm.selectedRange);
    };

    // paging data
    vm.currentPage = 1;
    vm.itemsPerPage = 100;

    // fetch data for the right column with overview of all reservations
    fetchOverviewAll();

    if (isPredefinedRange($stateParams.range)) {
        vm.selectedRange = $stateParams.range;
        if (vm.selectedRange.startsWith('today') || vm.selectedRange.startsWith('tomorrow')) vm.viewType = 'daily';
        else vm.viewType = 'weekly';
    } else if ($stateParams.range === 'custom' && $stateParams.from && moment($stateParams.from).isValid() && $stateParams.to && moment($stateParams.to).isValid()) {
        vm.selectedRange = 'custom';
        vm.filterFrom = moment($stateParams.from).toISOString();
        vm.filterTo = moment($stateParams.to).toISOString();
    } else {
        vm.selectedRange = 'today';
        //vm.selectedRange = 'this_week';
        vm.viewType = 'daily';
    }
    console.log("vm.selectedRange:" + vm.selectedRange);

    $q.all([
        googleChartApiPromise
    ]).then(vm.reload);

    // initialize date picker
    $document.ready(
        function () {
            vm.pickerDates = $document.find('input[name="pickerDates"]');
            vm.pickerDates.daterangepicker(
                {
                    showDropdowns: true,
                    autoApply: true,
                    autoUpdateInput: false,
                    alwaysShowCalendars: true,
                    locale: {format: 'MMM D, YYYY'},
                    singleDatePicker: true,
                },
                function (start, end, label) {
                    vm.selectedRange = 'custom';
                    vm.filterFrom = moment(start).startOf('day').toISOString();
                    vm.filterTo = moment(end).endOf('day').toISOString();
                    vm.reload();
                }
            );
            updateDatePickerText();
        }
    );

    vm.openPicker = function () {
        vm.pickerDates.focus();
    };

    function isPredefinedRange(range) {
        //console.log("range" + range);
        if (range) {
            //console.log("vm.ranges_day" + vm.ranges_day);
            if (ranges_day[range] !== undefined) {
                vm.ranges = ranges_day;
                return true;
            }
            //console.log("vm.ranges_day" + vm.ranges_week);
            if (ranges_week[range] !== undefined) {
                vm.ranges = ranges_week;
                return true;
            }
        }
        vm.ranges = ranges_day;
        return false;
    }

    function updateDatePickerText() {
        if (vm.pickerDates) {
            if (vm.selectedRange == 'custom') {
                //vm.pickerDates.val(moment(vm.filterFrom).format('MMM D, YYYY') + ' - ' + moment(vm.filterTo).format('MMM D, YYYY'));
                vm.pickerDates.val(moment(vm.filterFrom).format('MMM D, YYYY'));
            } else {
                vm.pickerDates.val('');
            }
        }
    }

    function getReportingExpectedOccupancyByHour(selectedDateRangeFrom) {
        return Statistics.getReportingExpectedOccupancyByHour({
            selectedDate: selectedDateRangeFrom == null ? null : moment(selectedDateRangeFrom).format('YYYY-MM-DD'),
            reportType: 'includeExpected'
        }, function (data) {
            vm.hourData = data;
        }).$promise;
    }

    function myToolTip(day, occupancy, revenue, tips) {
        return '&nbsp;<b>' + day + '</b><br>' +
            '&nbsp;&nbsp;&nbsp;Occupancy: <span class="text-danger">' + occupancy + '</span><br/>' +
            '&nbsp;&nbsp;&nbsp;Revenue: <span class="text-danger">' + revenue + '</span><br/>' +
            '&nbsp;&nbsp;&nbsp;Tips: <span class="text-danger">' + tips + '</span><br/>';
    }

    function displayHourChart() {
        //console.log(' displayHourChart range.from');
        //console.log(vm.range.from);

        var tableLegendText = TextUtil.translate('resource', 'sc')
        var seatLegendText = TextUtil.translate('capacity', 'sc')

        var nowHour = moment().startOf('hour');
        //console.log(' nowHour');
        //console.log(nowHour.toISOString());

        var deferred = $q.defer();
        //setSimulationToActuals('day');
        // DAY
        var dataOcuppancyDay = new google.visualization.DataTable();
        dataOcuppancyDay.addColumn('string', 'Hour');
        dataOcuppancyDay.addColumn('number', seatLegendText + ' occupancy rate', 'color: #1ABC9C');
        dataOcuppancyDay.addColumn({type: 'boolean', role: 'certainty'}); // certainty col.
        //dataOcuppancyDay.addColumn({type: 'string', role: 'style'});
        dataOcuppancyDay.addColumn({type: 'string', role: 'annotation'});
        dataOcuppancyDay.addColumn({type: 'string', role: 'tooltip', 'p': {'html': true}});
        dataOcuppancyDay.addColumn('number', tableLegendText + ' occupancy rate', 'color: #336699');
        dataOcuppancyDay.addColumn({type: 'boolean', role: 'certainty'}); // certainty col.
        //dataOcuppancyDay.addColumn({type: 'string', role: 'style'});

        _.each(vm.hourData.occupancyByHour, function (item) {
            var chartItemHour = moment(vm.range.from).set('hour', item.hourOfDay);
            //console.log(' chartItemHour - item.hourOfDayFmt: ' + item.hourOfDayFmt + '  item.hourOfDay: ' + item.hourOfDay);
            //console.log(chartItemHour.toISOString());
            var style = null;
            var certainty = true;
            if (!chartItemHour.isBefore(nowHour)) {
                certainty = false;
                style = 'color: #D3D3D3; fill-color: #D3D3D3; stroke-color: #D3D3D3; opacity: 0.5';
            }

            dataOcuppancyDay.addRow(
                [
                    item.hourOfDayFmt,
                    item.occupancyPct,
                    certainty,
                    //style,
                    $filter('percentage')(item.occupancyPct, 2),
                    myToolTip(item.hourOfDayFmt, $filter('percentage')(item.occupancyPct, 2), $filter('currency')(item.revenue), $filter('currency')(item.tips)),
                    {
                        v: item.occupancyTablePct,
                        f: $filter('percentage')(item.occupancyTablePct, 2)
                    },
                    certainty
                    //,style
                ]);
        });
        /*
         dataOcuppancyDay.addRows([
         ['7am', 0.3450, '34.50%', myToolTip('7am', '65.43%', '$13,456.34', '$2.435,98'), 27.50],
         ['8am', 0.4253, '42.53%', myToolTip('8am', '65.43%', '$13,456.34', '$2.435,98'), 33.34],
         ]);
         */

        var optionsOccupancyDay = {
            //width: 900,
            height: 300,

            tooltip: {
                isHtml: true
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 10,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },

            hAxis: {
                title: 'Hour of day',
                titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true}
            },

            vAxes: {
                0: {
                    viewWindowMode: 'explicit',
                    //gridlines: {color: 'transparent'},
                    gridlines: {count: 9},
                    format: 'percent',
                    viewWindow: {
                        min: 0
                    }
                },
                1: {
                    //gridlines: {color: 'transparent'},
                    format: 'percent',
                    color: '#CC9933',
                    viewWindow: {
                        min: 0
                    },
                    textStyle: {color: '#CC3333'},
                    titleTextStyle: {color: '#CC3333'}
                }
            },
            chartArea: {width: '80%', height: '65%'},
            series: {
                0: {
                    type: 'bars',
                    targetAxisIndex: 0
                },
                1: {
                    type: 'line',
                    targetAxisIndex: 0
                }
            },
            formatters: {},
            colors: ['#1ABC9C', '#CC3333'],
            legend: {position: 'top', alignment: 'end'}
        };

        $scope.chartComboObjectOccupancyDay = {
            type: "ComboChart",
            options: optionsOccupancyDay,
            data: dataOcuppancyDay
        };

        return deferred.promise;
    }

    $scope.showReservationListForPrinting = function () {
        var itemsPerPageSave = vm.itemsPerPage;
        vm.itemsPerPage = 100000;
        vm.reload();
        vm.itemsPerPage = itemsPerPageSave;
        vm.waitlistNotifyDialog = $uibModal.open({
            templateUrl: 'app/tables/overview/list.html',
            scope: $scope,
            size: 'lg'
        });
    };

    $scope.printElement = function () {
        var domClone = document.getElementById("printThis").cloneNode(true);
        var divElements = domClone.innerHTML;
        document.body.innerHTML =
            "<html><head><title></title></head><body>" +
            divElements +
            "</body>";
        window.print();
        window.location.reload();
    };

    $scope.channelIcon = function (channel) {
        return ChannelService.getChannelIcon(channel);
    }

    $scope.channelToolTipText = function (channel) {
        return ChannelService.getChannelToolTipText(channel);
    }


    function getWeekOccupancy(period) {
        var range = getRange(period);
        vm.weekStart = moment(range.from);
        //console.log('getWeekOccupancy' + vm.weekStart.format('YYYY-MM-DD'));
        return EventResource.getHomeWeekStats({
            selectedDate: moment(range.from).format('YYYY-MM-DD')
        }, function (data) {
            vm.data = data;
            vm.data.walkinseatedEventsCount = data.totalWeekOccupancy.totalVisits - data.totalWeekOccupancy.reservationEventsCount - data.totalWeekOccupancy.waitlistEventsCount;
            vm.data.walkinseatedCoversCount = data.totalWeekOccupancy.totalCovers - data.totalWeekOccupancy.reservationCoversCount - data.totalWeekOccupancy.waitlistCoversCount;
            getLastWeekOccupancy(period);
        }).$promise;
    }

    function getLastWeekOccupancy(period) {
        var range = getRange(period);
        vm.lastWeekStart = moment(range.from).subtract(1, 'weeks');
        //console.log('getLastWeekOccupancy' + vm.lastWeekStart.format('YYYY-MM-DD'));
        return EventResource.getHomeWeekStats({
            selectedDate: vm.lastWeekStart.format('YYYY-MM-DD'),
            reportType: 'lastWeek'
        }, function (data) {
            vm.lastWeekData = data;
            displayWeekChart();
        }).$promise;
    }

    function myToolTip2(day, occupancy, visit, cover) {
        return '&nbsp;<b>' + day + '</b><br>' +
            '&nbsp;&nbsp;&nbsp;Occupancy: <span class="text-danger">' + occupancy + '</span><br/>' +
            '&nbsp;&nbsp;&nbsp;Visit(s): <span class="text-danger">' + visit + '</span><br/>' +
            '&nbsp;&nbsp;&nbsp;' + vm.coverTrans + ': <span class="text-danger">' + cover + '</span><br/>';
    }

    function displayWeekChart() {
        // occupancy bar chart
        var nowHour = moment().startOf('hour');

        var deferred = $q.defer();

        var dataOcuppancyDay = new google.visualization.DataTable();
        dataOcuppancyDay.addColumn('string', 'Day');
        dataOcuppancyDay.addColumn('number', 'Current week', 'color: #1ABC9C');
        dataOcuppancyDay.addColumn({type: 'boolean', role: 'certainty'}); // certainty col.
        dataOcuppancyDay.addColumn({type: 'string', role: 'annotation'});
        dataOcuppancyDay.addColumn({type: 'string', role: 'tooltip', 'p': {'html': true}});
        dataOcuppancyDay.addColumn('number', 'Previous week', 'color: #336699');
        dataOcuppancyDay.addColumn({type: 'boolean', role: 'certainty'}); // certainty col.

        var i;
        for (i = 0; i < vm.data.occupancyByWeekday.length; i++) {
            var item = vm.data.occupancyByWeekday[i];
            var certainity = (i < moment().weekday());
            dataOcuppancyDay.addRow(
                [
                    vm.weekStart.clone().add(i, 'days').format('Do MMM, dddd'),
                    item.occupancyPct,
                    certainity,
                    $filter('percentage')(item.occupancyPct, 2), //item.weekdayName,
                    myToolTip2(item.weekdayName, $filter('percentage')(item.occupancyPct, 2), item.totalVisits, item.totalCovers),
                    {
                        v: vm.lastWeekData.occupancyByWeekday[i].occupancyPct,
                        f: $filter('percentage')(vm.lastWeekData.occupancyByWeekday[i].occupancyPct, 2)
                    },
                    true
                ]
            );
        }

        var optionsOccupancyDay = {
            //width: 900,
            height: 300,

            tooltip: {
                isHtml: true
            },
            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 10,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            hAxis: {
                title: 'Day of the week',
                titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true}
            },
            vAxes: {
                0: {
                    viewWindowMode: 'explicit',
                    //gridlines: {color: 'transparent'},
                    gridlines: {count: 9},
                    title: 'Occupancy rate',
                    titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
                    format: 'percent',
                    viewWindow: {
                        min: 0
                    },
                    minValue: 0
                },
                1: {
                    //gridlines: {color: 'transparent'},
                    title: 'Occupancy rate',
                    //titleTextStyle: {color: '#23c6c8', fontSize: 14, bold: true},
                    format: 'percent',
                    color: '#CC9933',
                    viewWindow: {
                        min: 0
                    },
                    textStyle: {color: '#CC3333'},
                    titleTextStyle: {color: '#CC3333'},
                    minValue: 0
                }
            },
            chartArea: {width: '80%', height: '65%'},
            series: {
                0: {
                    type: 'bars',
                    targetAxisIndex: 0
                },
                1: {
                    type: 'line',
                    targetAxisIndex: 0
                }
            },
            formatters: {},
            colors: ['#1ABC9C', '#CC3333'],
            legend: {position: 'top', alignment: 'end'}
        };

        $scope.chartComboObjectOccupancyWeek = {
            type: "ComboChart",
            options: optionsOccupancyDay,
            data: dataOcuppancyDay
        };

        return deferred.promise;
    }
}

angular.module('seatonApp').controller('ReservationOverviewController', ReservationOverviewController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tables.search', {
                parent: 'tables',
                url: '/search?keyword?from?to',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/tables/search/search.html',
                        controller: 'EventSearchController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

EventSearchController.$inject = ['$state', '$stateParams', '$scope', '$q', '$filter', '$document', 'Tables',
    'Utils', 'ChannelService'];

function EventSearchController($state, $stateParams, $scope, $q, $filter, $document, Tables,
                               Utils, ChannelService) {
    var vm = this;
    vm.utils = Utils;

    // paging data
    vm.currentPage = 1;
    vm.itemsPerPage = 25;
    vm.totalItems = 0;
    vm.searchEvents = searchEvents;
    vm.exportCSV = exportCSV;

    vm.keyword = $stateParams.keyword ? $stateParams.keyword : null;
    vm.filterFrom = null;
    vm.filterTo = null;
    if ($stateParams.from && moment($stateParams.from).isValid() && $stateParams.to && moment($stateParams.to).isValid()) {
        vm.filterFrom = moment($stateParams.from).toISOString();
        vm.filterTo = moment($stateParams.to).toISOString();
    }

    vm.searchAllowed = function () {
        if (vm.keyword && vm.keyword.length >= 3) {
            return true;
        }
        if (vm.filterFrom && moment(vm.filterFrom).isValid() && vm.filterTo && moment(vm.filterTo).isValid()) {
            return true;
        }
        return false;
    }

    searchEvents();

    function searchEvents() {

        if (!vm.searchAllowed()) {
            return; // can not search if either keyword or range are defined
        }

        Tables.searchEvents(
            {
                keyword: vm.keyword,
                from: vm.filterFrom,
                to: vm.filterTo,
                page: vm.currentPage - 1,
                size: vm.itemsPerPage
            },
            function (data) {
                vm.events = data.content;
                vm.totalItems = data.totalElements;
            }
        );
        var params = {
            keyword: null,
            from: null,
            to: null
        }

        if (vm.keyword && vm.keyword.length >= 3) {
            params.keyword = vm.keyword;
        }

        if (vm.filterFrom && moment(vm.filterFrom).isValid() && vm.filterTo && moment(vm.filterTo).isValid()) {
            params.from = vm.filterFrom;
            params.to = vm.filterTo;
        }

        $state.go('tables.search', params, {notify: false}); // change the URL
    }

    vm.resetSearch = function () {
        vm.keyword = null;
        vm.filterFrom = null;
        vm.filterTo = null;
        vm.pickerDates.val('');
        vm.events = null;
        vm.totalItems = 0;

        $state.go('tables.search', {keyword: null, from: null, to: null}, {notify: false});
    }

    vm.searchToday = function () {
        //vm.keyword = null;
        vm.pickerDates.val('');
        vm.filterFrom = moment().startOf('day').toISOString();
        vm.filterTo = moment().add(1, 'day').startOf('day').toISOString();
        vm.events = null;
        vm.totalItems = 0;
        updateDatePickerText();
        searchEvents();
    }

    vm.searchLastWeek = function () {
        //vm.keyword = null;
        vm.pickerDates.val('');
        vm.filterFrom = moment().startOf('day').subtract(7, 'day').toISOString();
        vm.filterTo = moment().add(1, 'day').startOf('day').toISOString();
        vm.events = null;
        vm.totalItems = 0;
        updateDatePickerText();
        searchEvents();
    }

    // reservations list, page changed
    vm.pageChanged = function () {
        vm.searchEvents();
    };

    // initialize date picker
    $document.ready(
        function () {
            vm.pickerDates = $document.find('input[name="pickerDates"]');
            vm.pickerDates.daterangepicker(
                {
                    showDropdowns: true,
                    autoApply: true,
                    autoUpdateInput: false,
                    alwaysShowCalendars: true,
                    locale: {format: 'MMM D, YYYY'}
                },
                function (start, end, label) {
                    vm.filterFrom = moment(start).toISOString();
                    vm.filterTo = moment(end).toISOString();
                    updateDatePickerText();
                    $scope.$apply(); // to propagate model changes to angular
                }
            );
            updateDatePickerText();
        }
    );

    vm.openPicker = function () {
        vm.pickerDates.focus();
    }

    function updateDatePickerText() {
        if (vm.filterFrom && vm.filterTo) {
            vm.pickerDates.val(moment(vm.filterFrom).format('MMM D, YYYY') + ' - ' + moment(vm.filterTo).format('MMM D, YYYY'));
        } else {
            vm.pickerDates.val('');
        }
    }

    $scope.channelIcon = function (channel) {
        return ChannelService.getChannelIcon(channel);
    }

    $scope.channelToolTipText = function (channel) {
        return ChannelService.getChannelToolTipText(channel);
    }

    function exportCSV() {
        if (!vm.searchAllowed()) {
            return; // can not search if either keyword or range are defined
        }
        var allResults = [];
        var pageIndex = 0;
        searchRecursive(allResults, pageIndex);
    }

    function searchRecursive(allResults, pageIndex) {
        Tables.searchEvents(
            {
                keyword: vm.keyword,
                from: vm.filterFrom,
                to: vm.filterTo,
                page: pageIndex,
                size: 1500
            },
            function (data) {
                var json1 = data.content;
                // Check if there is any data in the current page
                if (json1.length > 0) {
                    // Concatenate the results
                    allResults = allResults.concat(json1);
                    // Increment the pageIndex and continue searching
                    pageIndex++;
                    searchRecursive(allResults, pageIndex);
                } else exportResultsToCSV(allResults);
            }
        );
    }

    function exportResultsToCSV(json1) {
        var json = [];
        for (var i = 0; i < json1.length; i++) {
            json.push(flattenJSON(json1[i])); //push flattened row
        }

        var fields = Object.keys(json[0]);
        var replacer = function (key, value) {
            return value === null ? '' : value
        }
        //flatten
        var csv = json.map(function (row) {
            return fields.map(function (fieldName) {
                return JSON.stringify(row[fieldName], replacer)
            }).join(',')
        })
        csv.unshift(fields.join(',')) // add header column
        csv = csv.join('\r\n');

        var blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'events_list.csv';
        a.click();
        URL.revokeObjectURL(url);
    }

    function flattenJSON(obj, prefix) {
        var flattened = {};
        if (!prefix) {
            prefix = "";
        }
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (typeof obj[key] === "object" && obj[key] !== null) {
                    var nested = flattenJSON(obj[key], prefix + key + ".");
                    flattened = Object.assign(flattened, nested);
                } else {
                    flattened[prefix + key] = obj[key];
                }
            }
        }
        return flattened;
    }

}

angular.module('seatonApp').controller('EventSearchController', EventSearchController);

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tables.addtowaitlist', {
            parent: 'tables',
            url: '/create/waitlist',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/tables/create/waitlist/waitlist.html',
                    controller: 'CreateWaitlistController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('tables.event');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('CreateWaitlistController', CreateWaitlistController);

    CreateWaitlistController.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'Tables', 'Notification', '$uibModal',
        'CustomerResource', 'Utils', 'SweetAlert', 'ApplicationProfile', 'ApplicationContext', '$document'];

    function CreateWaitlistController($rootScope, $scope, $state, $stateParams, Tables, Notification, $uibModal, CustomerResource,
                                      Utils, SweetAlert, ApplicationProfile, ApplicationContext, $document) {

        var vm = this;

        vm.showCustomerStatistic = ApplicationProfile.isEventCreateCustomerStatsEnabled();
        vm.showCustomerStatisticText = ApplicationProfile.upgradeTierText("CreateReservation");
        vm.openWindow = ApplicationProfile.openAppCloverPage;


        vm.refreshQueue = function () {
            Tables.getWaitlistQueues(
                {},
                function (data) {
                    vm.waitlistQueues = data;
                }
            );
        }
        vm.refreshQueue();

        vm.phoneRegion = ApplicationContext.getPhoneRegion();
        vm.phonePrefix = ApplicationContext.getPhoneCountryPrefix();
        vm.isInternationalSmsEnabled = ApplicationProfile.isInternationalSmsEnabled();

        if (vm.isInternationalSmsEnabled || $rootScope.isEU) {
            vm.phonePattern = '';
        } else {
            vm.phonePattern = new RegExp('^\\' + ApplicationContext.getPhoneCountryPrefix());
        }

        vm.reformatPhone = function () {
            $scope.numInput = $document.find('#primaryPhone');
            //console.log("vm.reformatPhone:" + $scope.numInput.val());
            if (typeof intlTelInputUtils !== 'undefined') { // utils are lazy loaded, so must check
                //console.log("ng-change:" + vm.customer.primaryPhone);
                var currentText = $scope.numInput.intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
                //console.log("currentText:" + currentText);
                if (typeof currentText === 'string') { // sometimes the currentText is an object :)
                    $scope.numInput.intlTelInput('setNumber', currentText); // will autoformat because of formatOnDisplay=true
                }
            }
        }

        /** Called by the customer search directive when user selects a customer from a list */
        $scope.customerSelected = function (selCust) {

            CustomerResource.get(
                {id: selCust.id},
                function (data) {
                    vm.customer = data;
                    vm.customer.primaryPhone = intlTelInputUtils.formatNumber(vm.customer.primaryPhone, vm.phoneRegion, intlTelInputUtils.numberFormat.INTERNATIONAL);
                    //vm.reformatPhone();
                    vm.customerTotal = vm.customer.totalVisits + vm.customer.totalNoShow + vm.customer.totalCanceled;
                    vm.customerOriginal = Utils.getBasicCustomerData(data);
                }
            );
        }

        vm.resetCustomer = function () {
            // workaround for https://github.com/angular/angular.js/issues/2743
            jQuery("input[name='primaryEmail']").val("");
            jQuery("input[name='primaryPhone']").val("");

            vm.customer = null;
            vm.customerTotal = null;
            vm.customerOriginal = null;
            $scope.customerSearchKeyword = null;
        }

        vm.reset = function () {
            vm.note = null;
            vm.quotedWaitTime = null;
            vm.numberOfPersons = null;
            vm.resetCustomer();
        }

        vm.isAddingDisabled = function () {
            var disabled = !(vm.quotedWaitTime > 0) ||
                !(vm.numberOfPersons > 0) ||
                !vm.customer ||
                !vm.customer.firstName ||
                ($rootScope.isEU==true && !vm.customer.primaryEmail) ||
                $scope.customerForm.primaryEmail.$error.email ||
                !(vm.customer.primaryPhone && $scope.customerForm.primaryPhone.$valid) ||
                (vm.customer.id && !vm.customer.waitlistAllowed);

            return disabled;
        }

        vm.addToWaitlist = function () {

            var currentCustomer = Utils.getBasicCustomerData(vm.customer);
            var customerChangedFlag = currentCustomer.id && !angular.equals(currentCustomer, vm.customerOriginal);

            var event = {
                note: vm.note,
                quotedWaitTime: vm.quotedWaitTime,
                numberOfPersons: vm.numberOfPersons,
                channel: 'WEB',
                existingCustomerUpdated: customerChangedFlag,
                customer: currentCustomer
            };
            Tables.addToWaitlist(
                event,
                function (data) {
                    SweetAlert.swal({
                            title: "Added customer to waitlist",
                            text: "What do you want to do next?",
                            type: "success",
                            showCancelButton: true,
                            cancelButtonColor: "#1a94b3",
                            confirmButtonColor: "#1ab394",
                            cancelButtonText: "See event details",
                            confirmButtonText: "Add new customer to waitlist",
                            closeOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                vm.reset();
                                vm.refreshQueue();
                            } else {
                                $state.go('tables.eventDetails', {eventId: data.id});
                            }
                        });
                }
            );
        }
    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tables.newreservation', {
            parent: 'tables',
            url: '/create/reservation/:prereservedEventId',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_USER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/tables/create/reservation/reservation.html',
                    controller: 'CreateReservationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('tables.event');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('CreateReservationController', CreateReservationController);

    CreateReservationController.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$document', 'Tables', 'CustomerResource', 'Utils',
        'SettingsResource', 'SweetAlert', 'ApplicationProfile', 'ApplicationContext', 'Notification'];


    var DATE_FORMAT = 'YYYY-MM-DD';
    var TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
    var TIME_DISPLAY_FORMAT = 'hh:mmA';
    var DATE_PICKER_FORMAT = 'MMM D, YYYY';


    function CreateReservationController($rootScope, $scope, $state, $stateParams, $document, Tables, CustomerResource, Utils,
                                         SettingsResource, SweetAlert, ApplicationProfile, ApplicationContext, Notification) {

        var vm = this;
        vm.productId = null;

        vm.showCustomerStatistic = ApplicationProfile.isEventCreateCustomerStatsEnabled();
        vm.showCustomerStatisticText = ApplicationProfile.upgradeTierText("CreateReservation");
        vm.openWindow = ApplicationProfile.openAppCloverPage;
        vm.daySelected = daySelected;
        vm.findTables = findTables;
        vm.fillDataFromTimelineNewEvent = fillDataFromTimelineNewEvent;
        vm.fillDataFromPreReservedEvent = fillDataFromPreReservedEvent;
        vm.clearTables = clearTables;

        vm.days = [
            {
                date: moment().format(DATE_FORMAT),
                label: 'Today'
            },
            {
                date: moment().add(1, 'days').format(DATE_FORMAT),
                label: 'Tomorrow'
            },
            {
                date: moment().add(2, 'days').format(DATE_FORMAT),
                label: moment().add(2, 'days').format('dddd')
            },
            {
                date: moment().add(3, 'days').format(DATE_FORMAT),
                label: moment().add(3, 'days').format('dddd')
            },
            {
                date: moment().add(4, 'days').format(DATE_FORMAT),
                label: moment().add(4, 'days').format('dddd')
            }];

        function getGeneralSettings() {
            SettingsResource.getGeneralSettings(
                {},
                function (data) {
                    vm.settings = data;
                    vm.prereservedEventId = $stateParams.prereservedEventId;
                    vm.timelineNewEvent = $rootScope.timelineNewEvent;
                    $rootScope.timelineNewEvent = null;

                    if (vm.prereservedEventId) {
                        Tables.getEventDetails(
                            {
                                id: vm.prereservedEventId,
                            },
                            function (data) {
                                vm.prereservedEvent = data;
                                vm.fillDataFromPreReservedEvent();
                            });
                    } else if (vm.timelineNewEvent) {
                        vm.fillDataFromTimelineNewEvent();
                    } else {

                        // check for pending reservations (online | IVR) and notify user if necessary
                        Tables.getPreresevedReservations(
                            {
                                from: moment().startOf('day').toISOString(),
                                to: moment().add(1, 'year').toISOString(),
                                page: 0,
                                size: 1
                            },
                            function (data) {
                                if (data.totalElements > 0) {
                                    Notification.warning('There are pre-reservations in the queue. Please go to <b><a href="/#/tables/management/online-res">Pre-Reservations</a></b> screen and assign tables.');
                                }
                            }
                        );
                    }
                }
            );
        }

        getGeneralSettings();


        function clearTables() {
            vm.tables = null;
            vm.alternativeTimes = null;
            vm.nonWorkingDay = false;
        }

        vm.formatDateForDisplay = function (dateToFormat) {
            return moment(dateToFormat, DATE_FORMAT).format(DATE_PICKER_FORMAT);
        }

        function daySelected() {

            vm.slots = null;
            vm.clearTables();
            vm.selectedDayFormatted = moment(vm.selectedDay, DATE_FORMAT).format(DATE_PICKER_FORMAT);
            Tables.getSuggestedTimes(
                {
                    date: vm.selectedDay
                },
                function (data) {
                    vm.openHours = data.openHours;
                    vm.slots = [];
                    for (var i = 0; i < data.times.length; i++) {
                        vm.slots.push(moment(data.times[i], TIME_SERVER_FORMAT).format(TIME_DISPLAY_FORMAT));
                    }
                }
            );
        }

        vm.timeChanged = function () {
            if (vm.isReservationTimeInPast()) {
                SweetAlert.swal({
                        title: "Selected time is the past.",
                        text: "Please choose another time.?",
                        type: "error",
                        showCancelButton: false,
                        cancelButtonColor: "#1a94b3",
                        confirmButtonColor: "#1ab394",
                        confirmButtonText: "OK",
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                        vm.selectedTime = null;
                    });

            } else if (!vm.isWithinOpenHours(vm.selectedTime)) {
                SweetAlert.swal({
                        title: "Selected time is outside business hours.",
                        text: "Do you want to create reservation with time outside business hours?",
                        type: "info",
                        showCancelButton: true,
                        cancelButtonColor: "#1a94b3",
                        confirmButtonColor: "#1ab394",
                        cancelButtonText: "No",
                        confirmButtonText: "Yes",
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                        if (!isConfirm) {
                            vm.selectedTime = null;
                        }
                    });
            }
            vm.clearTables();
        }

        vm.isTimeSet = function () {
            return vm.selectedTime && moment(vm.selectedTime, TIME_DISPLAY_FORMAT).isValid();
        }

        function findTables() {
            vm.clearTables();

            Tables.findAvailableTables(
                {
                    date: vm.selectedDay,
                    time: timeToServerFormat(vm.selectedTime),
                    numberOfPersons: vm.numberOfPersons,
                    duration: findDuration(vm.productId)
                },
                function (data) {

                    vm.tables = data.availableResources;
                    vm.noResource = data.noResource;
                    vm.nonWorkingDay = data.nonWorkingDay;

                    vm.alternativeTimes = [];
                    for (var i = 0; i < data.alternativeTimes.length; i++) {
                        vm.alternativeTimes.push({
                            time: moment(data.alternativeTimes[i].time, TIME_SERVER_FORMAT).format(TIME_DISPLAY_FORMAT),
                            capacity: data.alternativeTimes[i].capacity
                        });
                    }

                    if (vm.timelineNewEvent)
                        if (vm.tables) {
                            for (var i = 0; i < vm.tables.length; i++) {
                                if (vm.tables[i].name == vm.timelineNewEvent.new_resource_name) {
                                    vm.tables[i].selected = true;
                                }
                            }
                        }
                }
            );
        }

        vm.selectedDay = vm.days[0].date;
        vm.daySelected();

        vm.isWithinOpenHours = function (timeStr) {
            var time = moment(timeStr, TIME_DISPLAY_FORMAT);

            for (var i = 0; i < vm.openHours.length; i++) {

                var from = moment(vm.openHours[i].fromHour, TIME_SERVER_FORMAT);
                var to = moment(vm.openHours[i].endHour, TIME_SERVER_FORMAT);

                if (time.isSameOrAfter(from) && time.isBefore(to)) {
                    return true;
                }
            }
            return false;
        }

        /** Returns a list of IDs of all selected tables. */
        vm.getSelectedTables = function () {
            var selectedIds = [];

            if (vm.tables) {
                for (var i = 0; i < vm.tables.length; i++) {
                    if (vm.tables[i].selected === true) {
                        selectedIds.push(vm.tables[i].id);
                    }
                }
            }
            return selectedIds;
        }

        vm.getSelectedTablesCapacity = function () {
            var capacity = 0;
            if (vm.tables) {
                for (var i = 0; i < vm.tables.length; i++) {
                    if (vm.tables[i].selected === true) {
                        capacity += vm.tables[i].capacity;
                    }
                }
            }
            return capacity;
        }

        vm.altTimeSelected = function () {
            vm.selectedTime = vm.selectedAltTime;

            if (vm.selectedDay && vm.selectedTime && vm.numberOfPersons && vm.productId) {
                vm.findTables();
            }
        }

        /** Called by the customer search directive when user selects a customer from a list */
        $scope.customerSelected = function (selCust) {

            CustomerResource.get(
                {id: selCust.id},
                function (data) {
                    vm.customer = data;
                    //var primPhone = vm.customer.primaryPhone;

                    //isValidNumber

                    vm.customer.primaryPhone = intlTelInputUtils.formatNumber(vm.customer.primaryPhone, vm.phoneRegion, intlTelInputUtils.numberFormat.INTERNATIONAL);
                    vm.reformatPhone();
                    //vm.customer.primaryPhone = null;
                    //console.log('currentText:' + currentText);
                    //$scope.numInput = $document.find('#primaryPhone');
                    //$scope.numInput.intlTelInput('setNumber', currentText);
                    //$scope.numInput.val(currentText);

                    //vm.customer.primaryPhone = undefined;
                    //$scope.customerForm.primaryPhone.$modelValue = undefined;
                    //$scope.customerForm.primaryPhone.$viewValue = currentText;

                    //vm.customer.primaryPhone.validate();
                    vm.customerTotal = vm.customer.totalVisits + vm.customer.totalNoShow + vm.customer.totalCanceled;
                    vm.customerOriginal = Utils.getBasicCustomerData(data);
                }
            );
        }

        vm.resetCustomer = function () {
            // workaround for https://github.com/angular/angular.js/issues/2743
            jQuery("input[name='primaryEmail']").val("");
            jQuery("input[name='primaryPhone']").val("");

            vm.customer = null;
            vm.customerTotal = null;
            vm.customerOriginal = null;
            $scope.customerSearchKeyword = '';
        }

        vm.reset = function () {
            vm.selectedDay = null;
            vm.selectedTime = null;
            vm.selectedDayFormatted = null;
            vm.numberOfPersons = null;
            vm.duration = null;
            vm.productId = null;
            vm.clearTables();
            vm.note = null;
            vm.selectedAltTime = null;
            vm.prereservedEventId = null;
            vm.resetCustomer();
        }


        vm.isCreateDisabled = function () {
            var isDisabled =
                vm.getSelectedTables().length === 0 ||
                !vm.customer ||
                !vm.customer.firstName ||
                $scope.customerForm.primaryEmail.$error.email ||
                !((vm.customer.primaryPhone && $scope.customerForm.primaryPhone.$valid) || vm.customer.primaryEmail) ||
                (vm.customer.id && !vm.customer.reservationAllowed);
            return isDisabled;
        }

        vm.isReservationTimeInPast = function () {
            if (vm.selectedDay && vm.isTimeSet()) {
                var selectedDateTime = vm.selectedDay + ' ' + vm.selectedTime;
                var FORMAT = DATE_FORMAT + ' ' + TIME_DISPLAY_FORMAT;

                var reservationTime = moment(selectedDateTime, FORMAT);
                var now = moment();

                return reservationTime.isBefore(now);
            }
            return false;
        }

        vm.isCreateWithWarning = function () {
            return (vm.getSelectedTables().length > 0 && vm.getSelectedTablesCapacity() < vm.numberOfPersons);
        }


        function doCreate() {

            var currentCustomer = Utils.getBasicCustomerData(vm.customer);
            var customerChangedFlag = currentCustomer.id && !angular.equals(currentCustomer, vm.customerOriginal);

            var params = {
                reservationDate: vm.selectedDay,
                reservationTime: timeToServerFormat(vm.selectedTime),
                numberOfPersons: vm.numberOfPersons,
                channel: 'WEB',
                note: vm.note,
                duration: findDuration(vm.productId),
                productId: vm.productId,
                resourceIds: vm.getSelectedTables(),
                existingCustomerUpdated: customerChangedFlag,
                customer: currentCustomer,
                prereservedEventId: vm.prereservedEventId
            }

            Tables.createReservation(
                params,
                function (data) {
                    if (vm.prereservedEventId) {
                        vm.confirmButtonText = "Go to open pre-reservations list";
                    } else {
                        vm.confirmButtonText = "Create new reservation";
                    }

                    SweetAlert.swal({
                            title: "Successfully created a reservation",
                            text: "What do you want to do next?",
                            type: "success",
                            showCancelButton: true,
                            cancelButtonColor: "#1a94b3",
                            confirmButtonColor: "#1ab394",
                            cancelButtonText: "Go to reservation center",
                            confirmButtonText: vm.confirmButtonText,
                            closeOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                if (vm.prereservedEventId) {
                                    $state.go('tables.management', {tab: 'online-res'});
                                } else {
                                    vm.reset();
                                }
                            } else {
                                $state.go('tables.overview');
                            }
                        });

                });
        }

        vm.createReservation = function () {

            if (vm.getSelectedTablesCapacity() < vm.numberOfPersons) {

                var text = ' Total table(s) capacity (' + vm.getSelectedTablesCapacity() + ') is not enough for ' + vm.numberOfPersons + ' person(s)!';

                SweetAlert.swal({
                        title: "Are you sure?",
                        text: text,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Create reservation",
                        cancelButtonText: "Cancel",
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            doCreate();
                        }
                    });
            } else {
                doCreate();
            }
        }

        /** Returns the selected time in the format expected by the REST service. */
        function timeToServerFormat(time) {
            return moment(time, TIME_DISPLAY_FORMAT).format(TIME_SERVER_FORMAT);
        }

        // initialize date & time picker
        $document.ready(
            function () {
                // date picker
                vm.datePicker = $document.find('input[name="datePicker"]');
                vm.datePicker.daterangepicker(
                    {
                        singleDatePicker: true,
                        showDropdowns: true,
                        locale: {format: DATE_PICKER_FORMAT}
                    },
                    function (start, end, label) {
                        vm.selectedDay = start.format(DATE_FORMAT)
                        vm.daySelected();
                    }
                );
                vm.datePicker.val(vm.selectedDayFormatted);

                // time picker
                vm.timePicker = $('.clockpicker').clockpicker({
                    donetext: 'Done',
                    twelvehour: true
                });
            }
        );

        vm.openDatePicker = function () {
            vm.datePicker.focus();
        }

        vm.phoneRegion = ApplicationContext.getPhoneRegion();
        vm.phonePrefix = ApplicationContext.getPhoneCountryPrefix();
        vm.isInternationalSmsEnabled = ApplicationProfile.isInternationalSmsEnabled();
        if (vm.isInternationalSmsEnabled) {
            vm.phonePattern = '';
        } else {
            //vm.phonePattern='^\+44';  // /^\+44/
            vm.phonePattern = new RegExp('^\\+44');
            //vm.phonePattern = '/^\+' + ApplicationContext.getPhoneCountryPrefix() + '/';
        }

        vm.reformatPhone = function () {
            $scope.numInput = $document.find('#primaryPhone');
            if (typeof intlTelInputUtils !== 'undefined') { // utils are lazy loaded, so must check
                var currentText = $scope.numInput.intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
                if (typeof currentText === 'string') { // sometimes the currentText is an object :)
                    $scope.numInput.intlTelInput('setNumber', currentText); // will autoformat because of formatOnDisplay=true
                }
            }
        }


        function fillDataFromPreReservedEvent() {
            if (vm.prereservedEvent) {
                vm.selectedDay = moment(vm.prereservedEvent.expectedStartTime).format(DATE_FORMAT);
                vm.selectedTime = moment(vm.prereservedEvent.expectedStartTime).format(TIME_DISPLAY_FORMAT);
                vm.duration = vm.prereservedEvent.expectedDuration;
                vm.productId = findProductId(vm.duration); // TODO productId is baze
                vm.numberOfPersons = vm.prereservedEvent.numberOfPersons;
                vm.note = vm.prereservedEvent.note;

                vm.seatingOptionId = vm.prereservedEvent.seatingOptionId;
                vm.seatingOptionLabel = vm.prereservedEvent.seatingOptionLabel;
                vm.seatingAreaIds = vm.prereservedEvent.seatingAreaIds;

                //vm.customer = vm.prereservedEvent.customer;

                $scope.customerSelected(vm.prereservedEvent.customer);

                vm.daySelected();
                //vm.duration = vm.prereservedEvent.expectedDuration;
                vm.findTables();
            }
        }

        function fillDataFromTimelineNewEvent() {
            var e = vm.timelineNewEvent;
            console.log("vm.timelineNewEvent");
            console.log(vm.timelineNewEvent);
            var newDate = moment("" + e.start_date.getFullYear() + "-" + (e.start_date.getMonth() + 1) + "-" + e.start_date.getDate() + " " +
                e.start_date.getHours() + ":" + e.start_date.getMinutes(), "YYYY-M-D H:m").clone().tz(moment().tz());
            vm.selectedDay = newDate.format(DATE_FORMAT);
            var new_start_time = newDate.format("hh:mmA");
            vm.selectedTime = new_start_time;
            vm.numberOfPersons = 2;
            vm.duration = moment(e.end_date).diff(moment(e.start_date), 'minutes');
            //vm.duration = 50;
            vm.productId = findProductId(vm.duration);
            vm.daySelected();
            vm.findTables();

            /* TODO check seating options cases
            vm.seatingOptionId = vm.prereservedEvent.seatingOptionId;
            vm.seatingOptionLabel = vm.prereservedEvent.seatingOptionLabel;
            vm.seatingAreaIds = vm.prereservedEvent.seatingAreaIds;
            */
        }

        function findProductId(duration) {
            if (vm.settings.shortProductList) {
                for (var i = 0; i < vm.settings.shortProductList.length; i++) {
                    if (vm.settings.shortProductList[i].duration == duration)
                        return vm.settings.shortProductList[i].id;
                }
            }

            if (vm.settings.selectProductList) {
                for (var i = 0; i < vm.settings.selectProductList.length; i++) {
                    if (vm.settings.selectProductList[i].duration == duration)
                        return vm.settings.selectProductList[i].id;
                }
            }
            // product id not found for duration
            return null;
        }

        function findDuration(productId) {
            if (vm.settings.shortProductList) {
                for (var i = 0; i < vm.settings.shortProductList.length; i++) {
                    if (vm.settings.shortProductList[i].id == productId)
                        return vm.settings.shortProductList[i].duration;
                }
            }

            if (vm.settings.selectProductList) {
                for (var i = 0; i < vm.settings.selectProductList.length; i++) {
                    if (vm.settings.selectProductList[i].id == productId)
                        return vm.settings.selectProductList[i].duration;
                }
            }
            // duration not found for product id
            if (vm.prereservedEvent) {
                if (vm.prereservedEvent.product) return vm.prereservedEvent.product.duration;
            }
            return 0;

        }

        vm.tableButtonStyle = function (table) {
            if (vm.seatingOptionId) {
                if (vm.seatingAreaIds) {
                    if (vm.seatingAreaIds.includes(table.areaId)) {
                        return "btn btn-primary btn-outline"
                    }
                }
            }
            return "btn btn-default btn-outline"
        }


    }
})();



(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tables.onlineres', {
                parent: 'tables',
                url: '/online-res',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/tables/online-res/online-res.html',
                        controller: 'OnlineListReservationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

OnlineListReservationController.$inject = ['$scope', '$state', 'ApplicationContext', '$uibModal', 'Tables', 'Utils', 'SweetAlert'];

function OnlineListReservationController($scope, $state, ApplicationContext, $uibModal, Tables, Utils, SweetAlert) {

    var vm = this;
    vm.utils = Utils;

    vm.diffInMinutes = function (time) {
        var diff = -Math.round(moment(time).diff(moment()) / 1000 / 60);
        return diff;
    }
    //var online.reservations = 3;

    vm.getPreresevedReservations = function () {

        Tables.getPreresevedReservations(
            {
                from: moment().startOf('day').toISOString(),
                to: moment().add(1, 'year').toISOString(),
                page: vm.currentPage - 1,
                size: vm.itemsPerPage
            },
            function (data) {
                vm.reservations = data.content;
                vm.totalItems = data.totalElements;
            }
        );
    }

    vm.pageChanged = function () {
        vm.getPreresevedReservations();
    };

    // paging data
    vm.currentPage = 1;
    vm.itemsPerPage = 25;

    vm.getPreresevedReservations();

    vm.showAssignDialog = function () {
        console.log('Test');
        vm.assignDialog = $uibModal.open({
            templateUrl: 'app/tables/online-res/assign.dialog.html',
            scope: $scope
        });
    }

    vm.triggerStateChange = function (id, trigger, confirmMsg, params) {

        if (confirmMsg) {
            SweetAlert.swal({
                    title: "Please confirm action",
                    text: confirmMsg + id,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        triggerStateChangeOnServer(id, trigger, params);
                    }
                });
        } else {
            triggerStateChangeOnServer(id, trigger, params);
        }
    }

    function triggerStateChangeOnServer(id, trigger, params) {
        var postParams = params ? params : {};
        postParams.id = id;
        postParams.trigger = trigger;

        Tables.triggerStateChange(
            postParams,
            function (data) {
                vm.getPreresevedReservations();
            });
    }

    vm.findTables = function (event) {
        $state.go('tables.newreservation', {prereservedEventId: event.id});
    }
}

angular.module('seatonApp').controller('OnlineListReservationController', OnlineListReservationController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tables.rearrange', {
                parent: 'tables',
                url: '/rearrange/:eventId',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/tables/rearrange/rearrange.html',
                        controller: 'RearrangeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

RearrangeController.$inject = ['$state', '$scope', '$q', '$document', '$filter', '$stateParams',
    'EventResource', 'ApplicationContext', 'ApplicationProfile', 'Tables', 'SweetAlert','Principal', 'Log','$timeout'];

var DATE_SERVER_FORMAT = 'YYYY-MM-DD';
var TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
var TIME_DISPLAY_FORMAT = 'hh:mmA';
var DATE_DISPLAY_FORMAT = 'MMM D, YYYY';

function RearrangeController($state, $scope, $q, $document, $filter, $stateParams,
                             EventResource, ApplicationContext, ApplicationProfile, Tables, SweetAlert, Principal, Log,  $timeout) {
    var vm = this;
    vm.eventId = $stateParams.eventId;

    vm.requiredCapacity = 0;
    vm.textColor = "";
    vm.currentCapacity = 0;
    vm.occupancy = 0;
    vm.originalModel = null;

    // holder for save
    vm.date = null;
    vm.startTime = null;
    vm.endTime = null;
    vm.control = null;

    var alertAction = function (event) {

        event.stopImmediatePropagation();
        event.preventDefault();
        //alert("I'm your default action override");
        return true;
    };

    var polyfillApplied = MobileDragDrop.polyfill({
//            dragImageCenterOnTouch: true,
//            dragImageOffset: {
//                x: 0,
//                y: 0
//            },
//            dragStartConditionOverride: allowHorizontalDragOnly,
//            defaultActionOverride: alertAction,
        dragImageTranslateOverride: MobileDragDrop.scrollBehaviourDragImageTranslateOverride,
        // holdToDrag: 300
    });
    try {
        window.addEventListener('touchmove', function () {
        }, {passive: false})
    } catch(e) {}

    //vm.onLoad();

    //vm.onLoad = function() {

        Tables.rearrangeFetch(
            {
                eventId: vm.eventId
            },
            onSuccess,
            onError
        );
    //}

    vm.save = function() {

        if(!vm.tableAssignedToEachEvent($scope.model)) {
            console.log("Tabel not assigned to event.");
            SweetAlert.swal({
                    title: "Please assign table(s) to all events?",
                    text: '',
                    type: "error",
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "OK",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    return;
                }
            );
        } else {

            console.log("All table assigned to event.");

            SweetAlert.swal({
                    title: "Do you want to update reservations?",
                    text: '',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No"
                    ,closeOnConfirm: true
                },
                function (isConfirm) {

                    if (isConfirm) {
                        Tables.rearrangeSave(
                            {
                                date: vm.date,
                                startTime: vm.startTime,
                                endTime: vm.endTime,
                                control: vm.control,
                                model: $scope.model,
                                selectedEventId: vm.eventId
                            },
                            onSuccessSave,
                            onError
                        );
                    }
                });
        }
    }

    function onSuccessSave(data, headers) {

        onSuccess(data, headers);

        //Log.debug("Saved. Changed="+data.eventChanged);
        if (data.eventChanged) {
            SweetAlert.swal({
                title: "Changes in system since rearrange started. Save canceled.",
                text: "New changes loaded, please continue to rearrange tables.",
                type: "warning",
                showCancelButton: false,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "OK",
                //cancelButtonText: "No",
                closeOnConfirm: true
            });
        } else {
            //dirty workaround for SweetAlert issues
            $timeout(showRedirectAlert, 70);
        }
    }

    function onSuccess(data, headers) {

        $scope.model = data.model;
        $scope.dateDisplay = moment(data.date, DATE_SERVER_FORMAT).format(DATE_DISPLAY_FORMAT);
        $scope.startTimeDisplay = moment(data.startTime, TIME_SERVER_FORMAT).format(TIME_DISPLAY_FORMAT);
        $scope.endTimeDisplay = moment(data.endTime, TIME_SERVER_FORMAT).format(TIME_DISPLAY_FORMAT);
        vm.requiredCapacity = vm.sumRequiredCapacity(data.model);
        vm.originalModel = JSON.parse(JSON.stringify(data.model));

        vm.date = data.date;
        vm.startTime = data.startTime;
        vm.endTime = data.endTime;
        vm.control = data.control;

        Log.debug("RearrangeController", "HTTP request succeed.");
    }

    function onError(error) {
        Log.debug("RearrangeController", "HTTP request error." + error);
    }

    function showRedirectAlert() {
        SweetAlert.swal({
                title: "Reservations changes successfully saved.",
                text: "",
                type: "success",
                showCancelButton: true,
                cancelButtonColor: "#1a94b3",
                confirmButtonColor: "#1ab394",
                cancelButtonText: "Ok, go to reservation center",
                confirmButtonText: "Ok, go to open pre-reservations list"
                ,closeOnConfirm: true
            },
            function (isConfirmed) {
                if (isConfirmed) {
                    $state.go('tables.management',{tab: 'online-res'});
                } else {
                    $state.go('tables.overview');
                }
            });
    }


    vm.restore = function() {
        SweetAlert.swal({
                title: "Restore to initial table assignment.",
                text: 'Please note that the changes from last save will be lost.',
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                closeOnConfirm: true
            },
            function (isConfirm) {
                if (isConfirm) {
                    if(vm.originalModel)
                        $scope.model = JSON.parse(JSON.stringify(vm.originalModel))
                }
            });

    }

    $scope.allowDrop = function(ev) {
        ev.preventDefault();
    }

    $scope.drag = function(ev) {
        ev.dataTransfer.setData("text", ev.target.id);
    }

    $scope.drop = function(ev) {
        ev.preventDefault();
        var data = ev.dataTransfer.getData("text");
        ev.target.appendChild($document.getElementById(data));
    }

    // drag and drop
    $scope.dragoverCallback = function(index, external, type, callback) {
        $scope.logListEvent('dragged over', index, external, type);
        // Invoke callback to origin for container types.
        return true;
    };

    $scope.dropCallback = function(index, item, external, type) {
        $scope.logListEvent('dropped at', index, external, type);
        // Return false here to cancel drop. Return true if you insert the item yourself.
        return item;
    };

    $scope.logEvent = function(message) {
        //console.log(message);
    };

    $scope.logListEvent = function(action, index, external, type) {
        //var message = external ? 'External ' : '';
        //message += type + ' element was ' + action + ' position ' + index;
    };

    $scope.$watch('model', function(model) {
        $scope.modelAsJson = angular.toJson(model, true);
    }, true);

    $scope.sumCapacity = function(container) {
        var total = 0;
        if (container.items) {
            angular.forEach(container.items, function(index) {
                total += index.capacity;
            });
        }
        return total;
    }

    vm.tableAssignedToEachEvent = function(model) {
        var allAssigned = true;
        if (model) {
            angular.forEach(model, function(containers) {
                angular.forEach(containers, function(container) {
                    if(container.type!='available' && $scope.sumCapacity(container)===0) {
                        console.log("Not assigned to container.name="+container.name);
                        allAssigned = false;
                    }
                });
            });
        }
        console.log("All assigned " + allAssigned);
        // all event have at least one table
        return allAssigned;
    }

    vm.totalCapacity = function(model) {
        var total = 0;
        if (model) {
            angular.forEach(model, function(containers) {
                angular.forEach(containers, function(container) {
                    angular.forEach(container.items, function(index) {
                        if(container.type!='available')
                            total += index.capacity;
                    });
                });
            });
        }
        return total;
    }

    vm.sumRequiredCapacity = function(model) {
        var total = 0;
        if (model) {
            angular.forEach(model, function(containers) {
                angular.forEach(containers, function(container) {
                    if(container.type!='available')
                        total += container.covers;
                });
            });
        }
        return total;
    }


    vm.calculateOccupancy = function(currentCapacity) {
        if(currentCapacity>0) {
            vm.occupancy = (vm.requiredCapacity/currentCapacity*100).toFixed(2);
        } else {
            vm.occupancy = 0;
        }

        if(vm.occupancy<50) {
            vm.textColor = "text-danger";
        } else if(vm.occupancy<90 && vm.occupancy >=50) {
            vm.textColor = "text-warning";
        } else {
            vm.textColor = "text-navy";
        }
        return vm.occupancy;
    }


    // Initialize model
    /*$scope.model = [[], []];
    var id = 10;
    angular.forEach(['all', 'move', 'copy', 'link', 'copyLink', 'copyMove'], function(effect, i) {
        var container = {items: [], effectAllowed: effect};
        for (var k = 0; k < 7; ++k) {
            container.items.push({label: effect + ' ' + id++, effectAllowed: effect});
        }
        $scope.model[i % $scope.model.length].push(container);
        console.log('Container;'+container)
    });*/

    /*$scope.model = [
        [
            {
                "items": [
                    {
                        "id": 12345,
                        "name": "A012",
                        "capacity": 4,
                        "areaColor": "#DD6633",
                        "effectAllowed": "move"

                    },
                    {
                        "id": 12346,
                        "name": "A011",
                        "capacity": 4,
                        "areaColor": "#DD6633",
                        "effectAllowed": "move"

                    }
                ],
                "type": "event",
                "panel": "panel-success",
                "effectAllowed": "move",
                "date": "June 7th 2020",
                "start": "6:00 PM",
                "end": "6:00 PM",
                "customer": "John Legend",
                "customerEmail": "legend@gmail.com",
                "customerPhone": "(345) 123-1234",
                "note": "",
                "covers": 5

            }
        ],
        [
            {
                "items": [
                    {
                        "id": 12345,
                        "name": "C001",
                        "capacity": 4,
                        "areaColor": "#3366DD",
                        "effectAllowed": "move"

                    },
                    {
                        "id": 12346,
                        "name": "C002",
                        "capacity": 4,
                        "areaColor": "#3366DD",
                        "effectAllowed": "move"

                    }
                ],
                "type": "event",
                "panel": "panel-default",
                "effectAllowed": "move",
                "date": "June 7th 2020",
                "start": "6:00 PM",
                "end": "6:00 PM",
                "customer": "John Legend",
                "customerEmail": "legend@gmail.com",
                "customerPhone": "(345) 123-1234",
                "note": "Table by window please",
                "covers": 7
            },
            {
                "items": [
                    {
                        "id": 12345,
                        "name": "A007",
                        "capacity": 4,
                        "areaColor": "#DD6633",
                        "effectAllowed": "move"

                    }
                ],
                "type": "event",
                "panel": "panel-default",
                "effectAllowed": "move",
                "date": "June 7th 2020",
                "start": "6:00 PM",
                "end": "6:00 PM",
                "customer": "John Legend",
                "customerEmail": "legend@gmail.com",
                "customerPhone": "(345) 123-1234",
                "note": "",
                "covers": 3
            },
            {
                "items": [
                    {
                        "id": 12345,
                        "name": "B005",
                        "capacity": 2,
                        "areaColor": "#66DD33",
                        "effectAllowed": "move"

                    },
                    {
                        "id": 12346,
                        "name": "B011",
                        "capacity": 2,
                        "areaColor": "#66DD33",
                        "effectAllowed": "move"

                    }
                ],
                "type": "event",
                "panel": "panel-default",
                "effectAllowed": "move",
                "date": "June 7th 2020",
                "start": "6:00 PM",
                "end": "8:00 PM",
                "customer": "John Legend",
                "customerEmail": "legend@gmail.com",
                "customerPhone": "(345) 123-1234",
                "note": "",
                "covers": 4
            },

        ],
        [
            {
                "items": [
                    {
                        "id": 12345,
                        "name": "A002",
                        "capacity": 4,
                        "areaColor": "#FF6633",
                        "effectAllowed": "move"

                    },
                    {
                        "id": 12346,
                        "name": "B011",
                        "capacity": 4,
                        "areaColor": "#66DD33",
                        "effectAllowed": "move"

                    },
                    {
                        "id": 12346,
                        "name": "B011",
                        "capacity": 4,
                        "areaColor": "#66DD33",
                        "effectAllowed": "move"

                    }
                ],
                "type": "available",
                "panel": "panel-primary",
                "effectAllowed": "move",
                "date": "",
                "start": "6:00 PM",
                "end": "8:00 PM",
                "customer": "",
                "customerEmail": "",
                "customerPhone": "",
                "note": "",
                "covers": 12

            }
        ]
    ]
*/

   /* $scope.model = {
        event:
            {
                "resources": [
                    {
                        "id": 12345,
                        "name": "A012",
                        "capacity": 4,
                        "areaColor": "#FF0000",
                        "effectAllowed": "move"
                    },
                    {
                        "id": 12346,
                        "name": "A011",
                        "capacity": 2,
                        "areaColor": "#FF0000",
                        "effectAllowed": "move"
                    }
                ],
                "effectAllowed": "none",
                "date": "June 7th 2020",
                "start": "6:00 PM",
                "end": "6:00 PM",
                "customer": "John Legend",
                "customerEmail": "legend@gmail.com",
                "customerPhone": "(345) 123-1234",
                "note": "",
                "covers": 5
            },
        matchingEvents:
            [
                {
                    "resources": [
                        {
                            "id": 12346,
                            "name": "A014",
                            "capacity": 4,
                            "areaColor": "#FF0000",
                            "effectAllowed": "move"
                        }
                    ],
                    "effectAllowed": "none",
                    "date": "June 7th 2020",
                    "start": "6:00 PM",
                    "end": "6:00 PM",
                    "customer": "John Legend",
                    "customerEmail": "legend@gmail.com",
                    "customerPhone": "(345) 123-1234",
                    "note": "Outside table please.",
                    "covers": 4
                },
                {
                    "resources": [
                        {
                            "id": 12345,
                            "name": "A012",
                            "capacity": 4,
                            "areaColor": "#FF0000",
                            "effectAllowed": "move"
                        },
                        {
                            "id": 12346,
                            "name": "B001",
                            "capacity": 4,
                            "areaColor": "#00FF00",
                            "effectAllowed": "move"
                        }
                    ],
                    "effectAllowed": "none",
                    "date": "June 7th 2020",
                    "start": "6:00 PM",
                    "end": "6:00 PM",
                    "customer": "John Legend",
                    "customerEmail": "legend@gmail.com",
                    "customerPhone": "(345) 123-1234",
                    "note": "",
                    "covers": 6
                },
                {
                    "resources": [
                        {
                            "id": 12346,
                            "name": "B011",
                            "capacity": 2,
                            "areaColor": "#00FF00",
                            "effectAllowed": "move"
                        }
                    ],
                    "effectAllowed": "none",
                    "date": "June 7th 2020",
                    "start": "6:00 PM",
                    "end": "6:00 PM",
                    "customer": "John Legend",
                    "customerEmail": "legend@gmail.com",
                    "customerPhone": "(345) 123-1234",
                    "note": "Table at window.",
                    "covers": 5
                }
            ],
        availableResources:
            [
                {
                    "id": 21234,
                    "name": "B012",
                    "capacity": 4,
                    "areaColor": "#00FF00",
                    "effectAllowed": "move"
                },
                {
                    "id": 22346,
                    "name": "A009",
                    "capacity": 2,
                    "areaColor": "#FF0000",
                    "effectAllowed": "move"
                },
                {
                    "id": 12116,
                    "name": "A009",
                    "capacity": 6,
                    "areaColor": "#FF0000",
                    "effectAllowed": "move"
                },
                {
                    "id": 12226,
                    "name": "C009",
                    "capacity": 4,
                    "areaColor": "#0000FF",
                    "effectAllowed": "move"
                }
            ]

    }*/

}

angular.module('seatonApp').controller('RearrangeController', RearrangeController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tables.timeline', {
                parent: 'tables',
                url: '/timeline/:range?from&to',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/tables/timeline/timeline.html',
                        controller: 'ReservationTimelineController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

ReservationTimelineController.$inject = ['$rootScope', '$state', '$stateParams', '$location', '$scope', '$q', '$filter', '$document', '$timeout',
    'Tables', 'Statistics', 'googleChartApiPromise', 'Reporting', 'ApplicationContext', '$uibModal', '$uibModalStack', 'ChannelService',
    'TextUtil', 'EventResource', 'SettingsResource', 'SweetAlert'];

function ReservationTimelineController($rootScope, $state, $stateParams, $location, $scope, $q, $filter, $document, $timeout,
                                       Tables, Statistics, googleChartApiPromise, Reporting, ApplicationContext, $uibModal, $uibModalStack, ChannelService, TextUtil, EventResource, SettingsResource, SweetAlert) {

    var vm = this;
    vm.coverTrans = TextUtil.translate('person', 'c');
    vm.currentDate = null;
    vm.doUpdate = doUpdate;
    vm.closeNotificationDialog = closeNotificationDialog;
    vm.closeConfirmationDialog = closeConfirmationDialog;
    vm.notificationMessageText = null;
    vm.notificationDialog = null;
    vm.confirmationDialog = null;
    vm.scrollPosition = null;

    vm.displayNotifictionMessageDialog = displayNotifictionMessageDialog;

    var DBG = false;

    $scope.openingHourNotDefined = function () {
        return ApplicationContext.isBusinessHoursNotDefined();
    };

    var ranges_day = {
        'today': {
            from: moment().startOf('day').toISOString(),
            to: moment().endOf('day').toISOString(),
            label: 'Today'
        },
        'tomorrow': {
            from: moment().add(1, 'days').startOf('day').toISOString(),
            to: moment().add(1, 'days').endOf('day').toISOString(),
            label: 'Tomorrow'
        },
        'todayplus2': {
            from: moment().add(2, 'days').startOf('day').toISOString(),
            to: moment().add(2, 'days').endOf('day').toISOString(),
            label: moment().add(2, 'days').format('dddd')
        },
        'todayplus3': {
            from: moment().add(3, 'days').startOf('day').toISOString(),
            to: moment().add(3, 'days').endOf('day').toISOString(),
            label: moment().add(3, 'days').format('dddd')
        },
        'todayplus4': {
            from: moment().add(4, 'days').startOf('day').toISOString(),
            to: moment().add(4, 'days').endOf('day').toISOString(),
            label: moment().add(4, 'days').format('dddd')
        },
        'todayplus5': {
            from: moment().add(5, 'days').startOf('day').toISOString(),
            to: moment().add(5, 'days').endOf('day').toISOString(),
            label: moment().add(5, 'days').format('dddd')
        },
        'todayplus6': {
            from: moment().add(6, 'days').startOf('day').toISOString(),
            to: moment().add(6, 'days').endOf('day').toISOString(),
            label: moment().add(6, 'days').format('dddd')
        }
    };

    SettingsResource.getAreas({},
        function (data) {
            vm.areas = data;
            if (DBG) console.log("vm.areas");
            if (DBG) console.log(vm.areas);
            vm.reload();
        }
    );

    function doUpdate() {
        vm.updateParams["customNotificationText"] = vm.notificationMessageText;
        Tables.updateTimelineEvent(
            vm.updateParams,
            function (data) {
                SweetAlert.swal("Updated!", "", "success");
                if (vm.timelineView) vm.scrollPosition = vm.timelineView.getScrollPosition(); // { left: 0, top: 0 }
                vm.reload();
                //vm.timelineView.scrollTo(vm.scrollPosition);  //comment to reset position to start on day change
                //$state.go('tables.eventDetails', {eventId: data.id});
            },
            function (data) {
                SweetAlert.swal("Change not performed as resources are not available or event is closed.", "", "error");
                return false;
            }
        );
        vm.closeNotificationDialog();
        vm.closeConfirmationDialog()
    }


    function displayNotifictionMessageDialog() {
        vm.closeConfirmationDialog();
        var ev = vm.ev;
        if (ev.seaton_id) {
            var params = {
                id: ev.seaton_id,
                time_new: vm.new_start_time,
                time_old: vm.initial_start_time,
                resource_id_new: vm.new_resource_id,
                resource_id_old: vm.original.seaton_resource_id,
                changeTime: vm.changeTime,
                keepOld: vm.keepOld,
                addNew: vm.addNew
            }
            vm.updateParams = params;

            if (vm.changeTime && (vm.initial_start_time != vm.new_start_time)) {
                //check for update message if there was change of time
                //Log.debug("Fetching event details with id " + vm.eventId + "from database.")
                Tables.getEventDetails(
                    {
                        id: ev.seaton_id,
                    },
                    function (data) {
                        vm.event = data;
                        // need to check if personalization is enabled for location
                        Tables.personalized(
                            {
                                messageType: 'RESERVATION_UPDATE'
                            },
                            function (data) {
                                if (data.enabled) {
                                    vm.notificationMessageText = data.defaultMessage;
                                    vm.closeConfirmationDialog();
                                    vm.notificationDialog = $uibModal.open({
                                        templateUrl: 'app/tables/event/update/notification.message.dialog.html',
                                        scope: $scope,
                                        windowClass: "center-modal"
                                    });
                                } else {
                                    // personalization not enabled
                                    doUpdate();
                                }
                            });
                    }
                );
            } else {
                doUpdate();
            }
        }
    }

    function closeNotificationDialog() {
        if (vm.notificationDialog != null) {
            vm.notificationDialog.close('cancel');
            vm.notificationDialog.dismiss('cancel');
        }
    }

    function closeConfirmationDialog() {
        //$uibModalStack.closeAll();
        $uibModalStack.dismissAll();
        if (vm.confirmationDialog != null) {
            vm.confirmationDialog.close('cancel');
            vm.confirmationDialog.dismiss('cancel');
        }
    }


    vm.getTimelineData = function (period) {
        var range = getRange(period);
        vm.currentDate = moment(range.from);

        if (DBG) console.log(range);
        if (DBG) console.log($location.timezone);

        Tables.timeline(
            {
                date: moment(range.from).format('YYYY-MM-DD')
            },
            function (data) {
                vm.timeline = data;
                var i, j;
                var dhtmlx_sections = []; //example entry: {key: 1, label: "James Smith"}
                var dhtmlx_events = []; //dhtmlx events: {start_date: "2017-06-30 09:00", end_date: "2017-06-30 12:00", text: "Task A-12458", section_id: 1}

                //creating dhtmlx sections - areas
                for (i = 0; i < vm.areas.length; i++) {
                    var area = vm.areas[i];
                    var children = [];
                    //area name truncated due to display issue - if name is too long it is nod displayed at all
                    dhtmlx_sections.push({key: area.id, label: area.name.substring(0, 12), open: true, children: []});
                }


                for (i = 0; i < data.resourceEvents.length; i++) {
                    var resource = data.resourceEvents[i].resource;
                    var events = data.resourceEvents[i].events;
                    if (DBG) console.log(resource);
                    //console.log("events");  console.log(events);
                    //console.log("i=" + i + "  " + data.resourceEvents[i]);

                    //adding table to corresponding section/area
                    _.each(dhtmlx_sections, function (dh_sec) {
                        if (dh_sec.key == resource.areaId) {
                            dh_sec.children.push({
                                key: 'T' + resource.id,
                                label: resource.name,
                                capacity: resource.capacity,
                                color: resource.areaColor
                            });
                        }
                    });

                    //adding events to corresponding section
                    for (j = 0; j < events.length; j++) {
                        if (DBG) console.log(events[j]);
                        var name = events[j].customer;
                        if (name != null) name = events[j].customer.name;
                        if (name == null || name == 'null') name = "Unknown customer";

                        if (DBG) console.log("END TIME" + events[j].endTime);
                        if (DBG) console.log(moment(events[j].endTime));
                        if (DBG) console.log("" + moment(events[j].startTime).format("YYYY-MM-DD HH:mm") + " - " + moment(events[j].endTime).format("YYYY-MM-DD HH:mm"));

                        var type_short = events[j].type.charAt(0);
                        if (events[j].type == "WALK_IN_SEATED") type_short = "S";

                        var numberOfPersons = events[j].numberOfPersons;
                        if (numberOfPersons < 0) numberOfPersons = "B";

                        var element = {
                            start_date: "" + moment(events[j].startTime).format("YYYY-MM-DD HH:mm"),
                            end_date: "" + moment(events[j].endTime).format("YYYY-MM-DD HH:mm"),
                            //text: "<span style=\"background-color:  " + resource.areaColor + " ;\">" + events[j].numberOfPersons + " " + events[j].type.charAt(0) + " " + name + "</span>",
                            text: "",
                            n_of_covers: numberOfPersons,
                            type: type_short,
                            customer_name: name,
                            section_id: 'T' + resource.id,
                            seaton_id: events[j].id,
                            seaton_resource_id: resource.id,
                            seaton_resource_name: resource.name,
                            section_color: resource.areaColor,
                            state: events[j].state,
                            status: events[j].status,
                            note: events[j].note
                        };
                        //element.color = resource.areaColor;  //sets box element color

                        if (DBG) console.log(element);
                        if (DBG) console.log("_____END TIME");
                        dhtmlx_events.push(element);
                    }

                }
                if (DBG) console.log("dhtmlx_sections");
                if (DBG) console.log(dhtmlx_sections);
                if (DBG) console.log("dhtmlx_events");
                if (DBG) console.log(dhtmlx_events);

                $document.ready(
                    function () {

                        var vopt = 1;

                        if (DBG) console.log("scheduler");
                        if (DBG) console.log(scheduler);
                        if (DBG) console.log("scheduler.isViewExists" + scheduler.isViewExists("timeline"));
                        var isTimelineExists = scheduler.isViewExists("timeline");
                        if (isTimelineExists) {
                            //scheduler.render();
                            isTimelineExists = false;
                            scheduler.clearAll();
                        }

                        scheduler.plugins({
                            limit: true,
                            timeline: true,
                            treetimeline: true
                        });
                        //TODO check scheduler.i18n.setLocale("de");

                        //scheduler.resetLightbox();
                        scheduler.locale.labels.timeline_tab = "Timeline";
                        scheduler.locale.labels.section_custom = "Section";
                        scheduler.config.details_on_create = false;
                        scheduler.config.details_on_dblclick = false;
                        scheduler.config.drag_resize = false;
                        //scheduler.config.drag_create = true;

                        scheduler.attachEvent("onBeforeEventCreated", function (ev) {
                            return true;
                        });


                        //handling drag&drop of event
                        scheduler.attachEvent("onBeforeEventChanged", function (ev, e, is_new, original) {
                            console.log(ev);

                            //setting defaults for new events
                            if (ev.text == 'New event') {

                                _.each(dhtmlx_sections, function (dh_area) {
                                    _.each(dh_area.children, function (dh_sec) {
                                        if (dh_sec.key == ev.section_id) vm.new_resource_name = dh_sec.label;
                                    });
                                });

                                $rootScope.timelineNewEvent = ev;
                                $rootScope.timelineNewEvent.new_resource_name = vm.new_resource_name;
                                $state.go('tables.newreservation');
                                return false;
                            }

                            if (typeof original.start_date === 'undefined' || ev.seaton_id == -1 || ev.state == 'CLOSED' || ev.status == 'SHOW') {
                                return false;
                            }

                            vm.new_start_time = ev.start_date.getHours() + ":" + moment(ev.start_date).format("mm");
                            vm.initial_start_time = original.start_date.getHours() + ":" + moment(original.start_date).format("mm");
                            vm.new_resource_id = ("" + ev.section_id).substring(1);
                            vm.new_resource_name = 'NA';

                            _.each(dhtmlx_sections, function (dh_area) {
                                _.each(dh_area.children, function (dh_sec) {
                                    if (dh_sec.key == ev.section_id) vm.new_resource_name = dh_sec.label;
                                });
                            });

                            var titleText = ' <b>Update event? </b>  <br><br>';
                            vm.ev = ev;
                            vm.original = original;
                            var htmlText = titleText + "Update event for " + ev.customer_name + ".<br/><br/> <b>Changes:</b><br/>";
                            var isEventChanged = false;

                            vm.isTimeChanged = false;
                            vm.isSectionChanged = false;
                            vm.changeTime = false;
                            vm.keepOld = false;
                            vm.addNew = true;

                            if (vm.initial_start_time != vm.new_start_time) {
                                vm.isTimeChanged = true;
                                htmlText += "<span class='fa fa-clock-o text-danger'> Reservation time changed from <b>" +
                                    vm.initial_start_time + "</b> to <b>" + vm.new_start_time + "</b></span><br>";
                                isEventChanged = true;
                            }
                            if (ev.section_id != original.section_id) {
                                vm.isSectionChanged = true;
                                htmlText += "<span class='fa fa-dot-circle-o text-danger'> Reservation moved from <b>" +
                                    original.seaton_resource_name + "</b> to <b>" + vm.new_resource_name + "</b>"; //fetch section name from ID
                                isEventChanged = true;
                            }
                            if (!isEventChanged)
                                return false;
                            //" to new time:" + new_start_time + " initial: " + initial_start_time + " resource change:" + ev.section_id + "  initial:" + original.section_id;

                            vm.htmlText = htmlText;
                            vm.confirmationDialog = $uibModal.open({
                                templateUrl: 'app/tables/timeline/timeline.drag.dialog.html',
                                scope: $scope,
                                windowClass: "center-modal"
                            });
                            //vm.closeConfirmationDialog();

                            return false;  //return true to confirm move
                        });

                        //prevent dblClick
                        scheduler.attachEvent("onDblClick", function () {
                            return false;
                        });

                        //add event - onClick go to event details page
                        scheduler.attachEvent("onClick", function (id, e) {
                            //any custom logic here
                            if (typeof id === 'undefined') {
                                return false;
                            }

                            if (DBG) console.log("onClick event:" + id);
                            var dh_ev;
                            _.each(dhtmlx_events, function (dh_ev) {
                                if (DBG) console.log(dh_ev);
                                if (dh_ev.id == id) {
                                    if (DBG) console.log("found seaton_id" + dh_ev.seaton_id);
                                    // if id less than 0. its block, go to block page
                                    if (dh_ev.seaton_id < 0) $state.go("tables.block");
                                    else $state.go("tables.eventDetails", {eventId: dh_ev.seaton_id});
                                }
                            });
                            return false;
                        });

                        scheduler.templates.event_bar_text = function (start, end, ev) {

                            if (typeof ev.type === 'undefined') {
                                ev.type = 'R';
                                ev.n_of_covers = 2;
                            }

                            if (typeof ev.customer_name === 'undefined') {
                                ev.customer_name = 'New';
                            }

                            var eventType = scheduler.serverList("eventType").find(function (type) {
                                if (type.key == ev.type) {
                                    return true;
                                }
                            });

                            if (DBG) console.log("EVENT------------------------------");
                            if (DBG) console.log(ev);

                            var details = [];
                            if (ev.type != "B" && ev.text && ev.text.length) {
                                details.push("<span>?</span>");
                            }
                            if (ev.type != "B" && ev.note) {
                                details.push("<span>!</span>");
                            }

                            var detailsBlock = "";
                            if (details.length) {
                                detailsBlock = "<div class='event-details'>" + details.join("") + "</div>";
                            }

                            var ev_color = 'green'; //ev.section_color
                            if (ev.start_date.valueOf() > currentDate.valueOf()) {
                                ev_color = '#3e8c66';   //ev_color = 'green';
                            }
                            if (ev.start_date.valueOf() < currentDate.valueOf()) {
                                //ev_color = 'red';
                                ev_color = '#e67575';
                            }

                            if (ev.type == 'B') ev_color = '#aaaaaa';   //ev_color = '#aaa';
                            else {
                                if (ev.status == 'SHOW') ev_color = '#7cafe6';   //ev_color = 'blue';
                                if (ev.state == 'CLOSED') ev_color = '#dcdcdc';  //ev_color = '#eee';
                            }

                            var ret_value = "<div class='event-content'>" +
                                "<div style='width: 15px;background:" + ev_color + ";'>" + ev.n_of_covers + "</div>";

                            if (ev.state != 'CLOSED') {
                                if (ev.type == 'R') ret_value += "<div class='event-type_r'><div>" + ev.type + "</div></div>";
                                if (ev.type == 'W') ret_value += "<div class='event-type_w'><div>" + ev.type + "</div></div>";
                                if (ev.type == 'S') ret_value += "<div class='event-type_s'><div>" + ev.type + "</div></div>";
                            } else {
                                ret_value += "<div class='event-type_old'><div>" + ev.type + "</div></div>";
                            }

                            //"<div class='event-type'><div>" + eventType.short + "</div></div>" +
                            //"<div class='event-type'><div>" + ev.type + "</div></div>" +
                            //"<span style='background:blue;'><div class='event-type'><div>" + ev.type + "</div></div></span>" +
                            //"<span><div style='width: 18px;height: 18px;border-radius: 20px;color:white;text-align:center;vertical-align: middle;background:" + ev.section_color + ";'><div>" + ev.type + "</div></div></span>" +
                            ret_value += "<div class='customer-name'>" +
                                ev.customer_name + "</div>" +
                                detailsBlock +
                                "</div>";

                            return ret_value;
                        };

                        var currentMoment = moment();
                        if (DBG) console.log(currentMoment);
                        if (DBG) console.log("moment().hour():"+moment().hour());
                        if (DBG) console.log("moment().format( 'H:mm:ss a') :"+moment().format( 'H:mm:ss a'));

                        var currentDate = new Date(new Date(moment().year(), moment().month(), moment().date(), moment().hour(), moment().minute()));
                        if (DBG) console.log(currentDate);

                        //different display of event depending if it's OPEN or CLOSED
                        scheduler.templates.event_class = function (start, end, event) {
                            //determines
                            if (event.type == 'B') return "block-event";
                            if (event.state == 'OPEN') return "";
                            if (event.state == 'CLOSED') return "old-event";
                            if (event.end_date.valueOf() < currentDate.valueOf()) {
                                return "old-event";
                            }
                            return "";
                        }


                        scheduler.config.now_date = currentDate;
                        scheduler.config.mark_now = true;
                        scheduler.locale.labels.timeline_tab = "Timeline";

                        //===============
                        //Configuration
                        //===============
                        var sections = dhtmlx_sections;
                        scheduler.serverList("tables", dhtmlx_sections);

                        if (vopt == 1)
                            scheduler.createTimelineView({
                                section_autoheight: false,
                                name: "timeline",
                                x_unit: "minute",
                                x_date: "%H:%i",
                                x_step: 15,
                                x_size: 24 * 4,
                                x_start: 0 * 4,
                                x_length: 24 * 60 / 15,
                                y_unit: scheduler.serverList("tables"),
                                y_property: "section_id",
                                render: "tree",
                                scrollable: true,
                                column_width: 50,
                                dx: 140,
                                event_dy: 38,
                                resize_events: false,
                                folder_dy: 44,
                                dy: 44
                            });


                        if (vopt == 2 && !isTimelineExists) scheduler.createTimelineView({
                            section_autoheight: false,
                            name: "timeline",
                            x_unit: "minute",
                            x_date: "%i",
                            x_step: 15,
                            //x_size: 17 * 4,
                            //x_start: 7 * 4,
                            x_size: 24 * 4,
                            x_start: 0 * 4,
                            x_length: 24 * 60 / 15,
                            y_unit: scheduler.serverList("tables"),
                            y_property: "section_id",
                            render: "tree",
                            second_scale: {
                                x_unit: "hour", // unit which should be used for second scale
                                x_date: "%h%a" // date format which should be used for second scale, "July 01"
                            },
                            scrollable: true,
                            column_width: 50,
                            //,
                            //folder_dy:30,
                            //dy:60
                            dx: 130,
                            event_dy: 38,
                            resize_events: false,
                            folder_dy: 44,
                            dy: 44
                        });

                        var hourFormat = scheduler.date.date_to_str("%g%A");

                        //defines HEADER text
                        scheduler.templates.timeline_scale_date = function (date) {
                            //console.log("date");
                            //console.log(date);
                            if (date.getMinutes() == 0) {
                                return hourFormat(date);
                            } else {
                                return date.getMinutes();
                            }
                        };

                        //formats VERTICAL LINES (but not HEADER line!)
                        scheduler.templates.timeline_cell_class = function (evs, date, section) {
                            //sets css for vertical line
                            if (date.getMinutes() == 45 && !section.children) {
                                return "hour-end";
                            }
                            return "";
                        };

                        //formats HEADER - lines and text
                        scheduler.templates.timeline_scalex_class = function (date) {
                            //"hour-end";   //bolds text
                            //"hour-start";  //bolds line

                            if (date.getMinutes() == 0) {
                                return "hour-end hour-start";
                            }
                            return "";
                            /*
                            if (!date.getMinutes()) {
                                return "hour-end";
                            } else if (date.getMinutes() == 45) {
                                return "hour-start";  //bolds line
                            }
                            return "";
                            */
                        };

                        //===============
                        //Data loading
                        //===============
                        //scheduler.config.lightbox.sections = [
                        //    {name: "description", height: 50, map_to: "text", type: "textarea", focus: true},
                        //    {name: "custom", height: 30, type: "select", options: sections, map_to: "section_id"},
                        //    {name: "time", height: 72, type: "time", map_to: "auto"}
                        //];

                        scheduler.templates.timeline_scale_label = function (key, label, section) {
                            var name = label;
                            if (section.capacity) {
                                name += " (" + section.capacity + ")";
                            }
                            return "<p style='color:" + section.color + "'>" + name + "</p>";
                        };


                        scheduler.serverList("eventType", [
                            {key: "R", label: "Reservation", short: "R"},
                            {key: "S", label: "Walk-in seated", short: "S"},
                            {key: "W", label: "Waitlisted seated", short: "W"},
                            {key: "B", label: "Block", short: "B"}
                        ]);


                        /*scheduler.config.lightbox.sections = [
                            {name: "description", height: 50, map_to: "text", type: "textarea", focus: true},
                            {name: "custom", height: 30, type: "timeline", options: null, map_to: "section_id"}, //type should be the same as name of the tab
                            {name: "time", height: 72, type: "time", map_to: "auto"}
                        ];*/

                        scheduler.locale.labels.section_custom = "Table";
                        scheduler.locale.labels.section_customer = "Customer";
                        scheduler.locale.labels.section_numberOfCovers = "Number Of Covers";
                        scheduler.locale.labels.section_type = "Type";
                        scheduler.locale.labels.section_notes = "Notes";


                        scheduler.config.lightbox.sections = [
                            {name: "customer", height: 30, map_to: "customer_name", type: "textarea", focus: true},
                            {name: "numberOfCovers", height: 30, map_to: "n_of_covers", type: "textarea"},
                            {name: "type", map_to: "type", type: "select", options: scheduler.serverList("eventType")},
                            {name: "notes", height: 50, map_to: "text", type: "textarea"},
                            {name: "custom", height: 30, type: "timeline", options: null, map_to: "section_id"}, //type should be the same as name of the tab
                            {name: "time", height: 72, type: "time", map_to: "auto"}
                        ];

                        //scheduler.config.container_autoresize = false;

                        if (DBG) console.log("INIT_START");
                        var initDate = new Date(new Date(moment(range.from).year(), moment(range.from).month(), moment(range.from).date(), moment(range.from).hour(), moment(range.from).minute()));
                        if (!isTimelineExists) scheduler.init('scheduler_here', initDate, "timeline");

                        if (DBG) console.log("INIT_END - START PARSE");
                        scheduler.parse(dhtmlx_events);
                        if (DBG) console.log("PARSE END");
                        var timeline = scheduler.getView();
                        vm.timelineView = timeline;
                        //var gridWidth = scheduler.getDataGridWidth;  //undefined
                        //console.log("gridWidth:" + gridWidth)
                        //timeline.scrollTo(gridWidth);
                        //timeline.scrollTo(10000);
                        if (DBG) console.log("(timeline._x_scroll:" + timeline._x_scroll);

                        var scrollToNow = function () {
                            if (DBG) console.log("timeline.getScrollPosition(): " + timeline.getScrollPosition());
                            if (DBG) console.log(timeline.getScrollPosition());
                            if (DBG) console.log(timeline);
                            if (DBG) console.log("(timeline._x_scroll:" + timeline._x_scroll);
                            var xsccroll_div2 = Math.round(timeline._x_scroll / 2);
                            if (DBG) console.log("xsccroll_div2:" + xsccroll_div2);
                            var mmt = moment();
                            var mmtMidnight = mmt.clone().startOf('day');
                            var diffMinutes = mmt.diff(mmtMidnight, 'minutes');
                            timeline.scrollTo(timeline._x_scroll * diffMinutes / (24 * 60));
                        }

                        if (DBG) console.log(moment().toDate());
                        if (moment().isSame(vm.currentDate, 'day')) {
                            var scrollToMoment = moment().subtract(60, 'minutes');
                            timeline.scrollTo(new Date(scrollToMoment.year(), scrollToMoment.month(), scrollToMoment.date(), scrollToMoment.hour(), scrollToMoment.minute()));
                        } else {
                            timeline.scrollTo(new Date(vm.currentDate.year(), vm.currentDate.month(), vm.currentDate.date(), 7, 0));
                        }
                        if (DBG) console.log(new Date(moment().year(), moment().month(), moment().date(), moment().hour(), moment().minute()));

                        //timeline.scrollTo(timeline.posFromDate(moment().format("YYYY-MM-DD HH:mm")));

                        if (vm.scrollPosition) {
                            vm.timelineView.scrollTo(vm.scrollPosition);
                            vm.scrollPosition = null;
                        }

                        /* var timeline_navline_div = document.getElementById("timeline_navline");
                           var timeline_navline_date = document.getElementById("timeline_navline_date");
                           timeline_navline_date.style.visibility = "hidden";
                           timeline_navline_date.style = "min-height: 0px;height: 0px;";
                           timeline_navline_div.style.visibility = "hidden";
                           timeline_navline_div.style = "min-height: 0px;height: 0px;";  */

                    });
            }
        );


    }
    ;


    function getRange(period) {
        if (period === 'custom') { // range selected on the date picker
            return {
                from: vm.filterFrom,
                to: vm.filterTo
            };
        } else {
            // pre-defined period
            return vm.ranges[period];
        }
    }

    vm.reload = function (isChanged) {

        if (true || isChanged == 'refresh') { //TODO check
            if (vm.timelineView)
                vm.scrollPosition = vm.timelineView.getScrollPosition(); // { left: 0, top: 0 }
        }


        vm.ranges = ranges_day;
        //if (isChanged) vm.selectedRange = 'today'; //resseting view to today

        vm.range = getRange(vm.selectedRange);

        vm.getTimelineData(vm.selectedRange);

        var params = {
            range: vm.selectedRange,
            from: null,
            to: null
        };
        if (vm.selectedRange === 'custom') {
            params.from = vm.filterFrom;
            params.to = vm.filterTo;
        }
        $state.go('tables.timeline', params, {notify: false}); // change the URL
        updateDatePickerText();
    };

// reservations list, page changed
    vm.pageChanged = function () {
        vm.getOpenReservations(vm.selectedRange);
    };

// paging data
    vm.currentPage = 1;
    vm.itemsPerPage = 100;

    if (isPredefinedRange($stateParams.range)) {
        vm.selectedRange = $stateParams.range;
        if (vm.selectedRange.startsWith('today') || vm.selectedRange.startsWith('tomorrow')) vm.viewType = 'daily';
        else vm.viewType = 'weekly';
    } else if ($stateParams.range === 'custom' && $stateParams.from && moment($stateParams.from).isValid() && $stateParams.to && moment($stateParams.to).isValid()) {
        vm.selectedRange = 'custom';
        vm.filterFrom = moment($stateParams.from).toISOString();
        vm.filterTo = moment($stateParams.to).toISOString();
    } else {
        vm.selectedRange = 'today';
        //vm.selectedRange = 'this_week';
        vm.viewType = 'daily';
    }

//vm.reload();

// initialize date picker
    $document.ready(
        function () {
            vm.pickerDates = $document.find('input[name="pickerDates"]');
            vm.pickerDates.daterangepicker(
                {
                    showDropdowns: true,
                    autoApply: true,
                    autoUpdateInput: false,
                    alwaysShowCalendars: true,
                    locale: {format: 'MMM D, YYYY'},
                    singleDatePicker: true,
                },
                function (start, end, label) {
                    vm.selectedRange = 'custom';
                    vm.filterFrom = moment(start).toISOString();
                    vm.filterTo = moment(end).toISOString();
                    vm.reload();
                }
            );
            updateDatePickerText();
        }
    );

    vm.openPicker = function () {
        vm.pickerDates.focus();
    };

    function isPredefinedRange(range) {
        //console.log("range" + range);
        if (range) {
            //console.log("vm.ranges_day" + vm.ranges_day);
            if (ranges_day[range] !== undefined) {
                vm.ranges = ranges_day;
                return true;
            }
        }
        vm.ranges = ranges_day;
        return false;
    }

    function updateDatePickerText() {
        if (vm.pickerDates) {
            if (vm.selectedRange == 'custom') {
                //vm.pickerDates.val(moment(vm.filterFrom).format('MMM D, YYYY') + ' - ' + moment(vm.filterTo).format('MMM D, YYYY'));
                vm.pickerDates.val(moment(vm.filterFrom).format('MMM D, YYYY'));
            } else {
                vm.pickerDates.val('');
            }
        }
    }
}

angular.module('seatonApp').controller('ReservationTimelineController', ReservationTimelineController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tables.yearview', {
                parent: 'tables',
                url: '/yearview',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/tables/yearview/yearview.html',
                        controller: 'ReservationYearViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

ReservationYearViewController.$inject = ['$state', '$stateParams', '$location', '$scope', '$q', '$filter', '$document', '$timeout',
    'Tables', 'ApplicationContext', '$uibModal', 'TextUtil', 'EventResource', 'SweetAlert'];

function ReservationYearViewController($state, $stateParams, $location, $scope, $q, $filter, $document, $timeout,
                                       Tables, ApplicationContext, $uibModal, TextUtil, EventResource, SweetAlert) {

    var vm = this;
    var today = new Date();
    var yesterday = new Date(today.setDate(today.getDate() - 1));

    var currentYear = new Date().getFullYear();

    EventResource.overview({}, onSuccess, onError);

    function onError(error) {
        Log.debug("tables year calendar", "HTTP request error." + error);
    }

    function onSuccess(data, headers) {
        var text = JSON.stringify(data);

        const dataObj = JSON.parse(text, function (key, value) {
            if (key == "startDate" || key == "endDate") {
                //console.log(new Date(value))
                //console.log(moment(value, "YYYY-MM-DD").toDate());
                return moment(value, "YYYY-MM-DD").toDate();
            } else {
                return value;
            }
        });

        var yearview = new Calendar('#yearview', {
            minDate: yesterday,
            clickDay: function (e) {
                //use moment timezone, not from browser(year view component)
                var dateClicked = moment("" + e.date.getFullYear() + "-" + (e.date.getMonth() + 1) + "-" + e.date.getDate(), "YYYY-M-D").clone().tz(moment().tz());
                console.log("timezone offset: " + dateClicked.format('Z') + "  timezone : " + moment().tz());

                var params = {
                    range: 'custom',
                    from: dateClicked.clone().startOf('day').toISOString(),
                    to: dateClicked.clone().endOf('day').toISOString()
                };

                if (e.events.length > 0) {
                    $(e.element).popover('hide');
                }

                var go = 'NONE';
                if (e.events.length > 0) {
                    var event = e.events[0];
                    if (event.reservationEventCount > 0 && event.preReservationEventCount > 0) {
                        var go = 'CHOICE';
                    } else if (event.reservationEventCount > 0) {
                        var go = 'CENTER';
                    } else {
                        var go = 'PRE-RESERVE';
                    }
                }
                showChoice(params, go)

            },
            mouseOnDay: function (e) {
                if (e.events.length > 0) {
                    var content = '';
                    var event = e.events[0];

                    if (!event.reservationEventCount == '0') {
                        content =
                            '<div class="event-tooltip-content" style="padding-bottom: 6px">'
                            + '<div class="event-name" style="background-color: #e2ecea">Reservations</div>'
                            + '<div class="event-location">' + event.reservationEventCount + ' event(s), ' + event.reservationCoverCount + ' cover(s)</div>'
                            + '</div>';
                    }
                    if (!event.preReservationEventCount == '0') {
                        content += '<div class="event-tooltip-content">'
                            + '<div class="event-name" style="background-color: #fff3cd"> Pre-reservations</div>'
                            + '<div class="event-location">' + event.preReservationEventCount + ' event(s), ' + event.preReservationCoverCount + ' cover(s)</div>'
                            + '</div>';
                    }

                    $(e.element).popover({
                        placement: 'bottom',
                        trigger: 'manual',
                        container: 'body',
                        html: true,
                        content: content
                    });

                    $(e.element).popover('show');
                }
            },
            mouseOutDay: function (e) {
                if (e.events.length > 0) {
                    $(e.element).popover('hide');
                }
            },
            dataSource: dataObj

        });
    }

    function showChoice(params, go) {
        if (go == 'CENTER') {
            $state.go("tables.overview", params);
        } else if (go == 'PRE-RESERVE') {
            $state.go("tables.management", {tab: 'online-res'});
        } else if (go == 'CHOICE') {
            SweetAlert.swal({
                    title: "Please confirm action",
                    text: "Please select where you want to go.",
                    type: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#f8ac59",
                    cancelButtonColor: "#1ab394",
                    confirmButtonText: "Open pre-reservation list",
                    cancelButtonText: "Open reservation center",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        $state.go("tables.management", {tab: 'online-res'});
                    } else {
                        $state.go("tables.overview", params);
                    }
                });
        }
    }

}

angular.module('seatonApp').controller('ReservationYearViewController', ReservationYearViewController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tables.block', {
                parent: 'tables',
                url: '/block',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/tables/block/block.html',
                        controller: 'ReservationBlockController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('ReservationBlockController', ReservationBlockController);

    ReservationBlockController.$inject = ['$scope', '$state', 'SettingsResource', 'Log', '$location', '$uibModal', '$document',
                                'ApplicationContext', 'ListUtils', 'SweetAlert', 'Utils'];

    var DATE_FORMAT = 'YYYY-MM-DD';
    var TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
    var TIME_DISPLAY_FORMAT = 'hh:mmA';
    var DATE_PICKER_FORMAT = 'MMM D, YYYY';

    function ReservationBlockController($scope, $state, SettingsResource, Log, $location, $uibModal, $document,
                               ApplicationContext, ListUtils, SweetAlert, Utils) {

        var vm = this;
        reset();

        SettingsResource.getBlockEvents({}, onSuccessListUpdate, onError);

        // initialize date & time picker
        $document.ready(
            function () {
                // date picker
                var today = new Date();
                var todayWithLocale = moment(today, "YYYY-MM-DD").toDate();
                vm.selectedDay = todayWithLocale;
                vm.datePickerSection = $document.find('input[name="datePickerSection"]');
                vm.datePickerSection.daterangepicker(
                    {
                        singleDatePicker: true,
                        showDropdowns: true,
                        locale: {format: DATE_PICKER_FORMAT},
                        minDate: todayWithLocale
                    },
                    function (start, end, label) {
                        vm.selectedDay = start.format(DATE_FORMAT);
                        vm.selectedDayFormatted = moment(vm.selectedDay, DATE_FORMAT).format(DATE_PICKER_FORMAT);
                    }
                );
                vm.datePickerSection.val(vm.selectedDayFormatted);
            }
        );

        $scope.openDatePickerSection = function () {
            vm.datePickerSection.focus();
        }

        vm.onSection = function() {
            SettingsResource.getAreas({}, onAreaSuccess, onError);

            function onAreaSuccess(data) {
                vm.availableAreas = data;
            }
        }

        vm.onResource = function() {
            SettingsResource.getAreasAndTables({}, onResourceSuccess, onError);

            function onResourceSuccess(data) {
                vm.availableResources = data;
            }
        }


        vm.saveBlockEvent = function() {
            if(checkToBeforeFrom(vm.block.from.hour, vm.block.from.mins, vm.block.from.amPm, vm.block.to.hour, vm.block.to.mins, vm.block.to.amPm)) {
                SweetAlert.swal({
                        html: true,
                        title: "Time not defined properly.",
                        text: "<strong>To</strong> time same or before <strong>from</strong> time.",
                        type: "error",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Ok",
                        closeOnConfirm: true
                    }
                );
                return;
            }

            var titleText = ' <b>Block summary.</b>';
            var htmlMessage =
                "<span class='fa fa-calendar'> &nbsp;&nbsp;</span><strong>" + vm.selectedDayFormatted + "</strong><br/>" +
                "<span class='fa fa-clock-o'> &nbsp;&nbsp;</span><strong>" + vm.block.from.hour + ":" + vm.block.from.mins + " " + vm.block.from.amPm + " -> " + vm.block.to.hour + ":" + vm.block.to.mins + " " + vm.block.to.amPm + "</strong><br/>" +
                "<strong>" + selectedListText() + "</strong><br/>" +
                "" + scopeText(vm.block.scope) + "<br/>";
            SweetAlert.swal({
                    html: true,
                    title: titleText,
                    text: htmlMessage,
                    type: "info",
                    showCancelButton: true,
                    confirmButtonColor: "#1db394", confirmButtonText: "Save",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if(isConfirm) {

                        var startTime = moment(vm.selectedDayFormatted + " " + vm.block.from.hour + ":" + vm.block.from.mins +  vm.block.from.amPm, "MMM D, YYYY hh:mmA").toDate();
                        var endTime = moment(vm.selectedDayFormatted + " " + vm.block.to.hour + ":" + vm.block.to.mins +  vm.block.to.amPm, "MMM D, YYYY hh:mmA").toDate();
                        var data = {
                            startTime: startTime,
                            endTime: endTime,
                            type: vm.block.type,
                            scope: vm.block.scope,
                            description: vm.block.description,
                            listText: selectedListText()
                        };
                        if(vm.block.type=="SECTION") {
                            data.areas = getSelectedIds();
                        } else {
                            data.resources = getSelectedIds();
                        }
                        SettingsResource.saveBlockEvent(data, onSuccessListUpdate, onError);
                    }
                }
            );
        }

        vm.deleteBlockEvent= function(blockId) {
            SweetAlert.swal({
                    html: true,
                    title: "Do you want to delete block event?" ,
                    text: "",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Delete",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        SettingsResource.deleteBlockEvent({blockEventId: blockId}, onSuccessListUpdate, onError);
                    }
                });
        }


        function onSuccessListUpdate(data) {
            reset();
            vm.blockEvents = data;
        }

        function onError(error) {
            console.log("Error "+error);
        }


    // checks and utility functions
        function scopeText(scope) {
            if(scope=="ALL") return "All reservations (online & offline)";
            else return "Only for online reservations";
        }

        vm.listResourceOrSection = function(block) {
            return block.listText;
        }

        $scope.blockScope = [
            {value: "ALL", name: "All reservations (online & offline)"},
            {value: "ONLINE_ONLY", name: "Only for online reservations"}
        ]

        function checkToBeforeFrom(fromHours, fromMins, fromAmPm, toHours, toMins, toAmPm) {

            var from = moment(fromHours + ":" + fromMins + fromAmPm, "hh:mmA");
            var to = moment(toHours + ":" + toMins + toAmPm, "hh:mmA");

            if(to.isBefore(from)) return true;
            if(from.isSame(to)) return true;
            return false;

        }

        vm.openLink = function(to) {
            if(to=='NON') {
                $state.go('settings.worktime');
            } else if (to == 'SPECIAL') {
                $state.go('settings.worktime');
            } else if(to == 'DISABLE') {
                $state.go('settings.online.reservation.settings');
            }
        }

        vm.inputOk = function(type) {
            if(!vm.selectedDayFormatted) return false;
            if(!vm.block.from.hour || !vm.block.from.mins || !vm.block.from.amPm) return false;
            if(!vm.block.to.hour || !vm.block.to.mins || !vm.block.to.amPm) return false;
            if(!vm.block.scope) return false;

            var check = false;
            if(type=='SECTION') {
                if (vm.availableAreas) {
                    for (var i = 0; i < vm.availableAreas.length; i++) {
                        if (vm.availableAreas[i].selected === true) {
                            check = true;
                        }
                    }
                }
            } else if(type=='RESOURCE') {
                if (vm.availableResources) {
                    for (var i = 0; i < vm.availableResources.length; i++) {
                        if(vm.availableResources[i].resources) {
                            for (var j = 0; j < vm.availableResources[i].resources.length; j++) {
                                if (vm.availableResources[i].resources[j].selected === true) {
                                    check = true;
                                }
                            }
                        }
                    }
                }
            }
            if(!check) return check;
            return true;
        }

        function getSelectedIds() {
            var selectedIds = [];
            if (vm.block.type == 'SECTION') {
                if (vm.availableAreas) {
                    for (var i = 0; i < vm.availableAreas.length; i++) {
                        if (vm.availableAreas[i].selected === true) {
                            selectedIds.push(vm.availableAreas[i]);
                        }
                    }
                }
            } else if(vm.block.type == 'RESOURCE') {
                if(vm.availableResources) {
                    for(var i = 0; i < vm.availableResources.length; i++) {
                        for (var j = 0; j < vm.availableResources[i].resources.length; j++) {
                            if (vm.availableResources[i].resources[j].selected === true) {
                                selectedIds.push(vm.availableResources[i].resources[j]);
                            }
                        }
                    }

                }
            }
            console.log("Selected:" + JSON.stringify(selectedIds));
            return selectedIds;
        }


        function selectedListText() {
            var text = "";
            var first = true;
            if (vm.block.type == 'SECTION') {
                if (vm.availableAreas) {
                    for (var i = 0; i < vm.availableAreas.length; i++) {
                        if (vm.availableAreas[i].selected === true) {
                            if (first)text += vm.availableAreas[i].name;
                            else text += ", " + vm.availableAreas[i].name;
                            first = false;
                        }
                    }
                }
            } else if(vm.block.type == 'RESOURCE') {
                if(vm.availableResources) {
                    for(var i = 0; i < vm.availableResources.length; i++) {
                        for (var j = 0; j < vm.availableResources[i].resources.length; j++) {
                            if (vm.availableResources[i].resources[j].selected === true) {
                                if (first)text += vm.availableResources[i].resources[j].name;
                                else text += ", " + vm.availableResources[i].resources[j].name;
                                first = false;
                            }
                        }
                    }
                }
            }
            if(text=="")text="<i>None</i>";
            return text;

        }

        vm.formatDate = function(date) {
            return moment(date).format(DATE_FORMAT);
        }

        vm.formatTime = function(date) {
            return moment(date).format( TIME_DISPLAY_FORMAT);
        }

        vm.isActive = function(end) {
            var now = moment();
            if(now.isBefore(moment(end))) return true;
            return false;
        }

        function reset() {
            vm.block = {};
            vm.block.scope="ONLINE_ONLY";
            vm.block.from = {};
            vm.block.to = {};
            vm.availableAreas = {};
        }


    }
})();




(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public', {
            abstract: true,
            parent: 'app',
            url: '/public',
            data: {
            }
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.queue', {
            parent: 'public',
            url: '/queue/:eventId',
            data: {
                authorities: [],
                bodyClass: " transparent-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.queue': {
                    templateUrl: 'app/public/queue/queue.html',
                    controller: 'WaitListQueueController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@public.queue': {}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('WaitListQueueController', WaitListQueueController);

    WaitListQueueController.$inject = ['$scope', '$state', '$stateParams', 'Log', 'PublicResource'];

    function WaitListQueueController($scope, $state, $stateParams, Log, PublicResource) {

        var vm = this;
		vm.data = null;
        if (window.location.href.indexOf("//eu.getseat.net") != -1)  vm.isEU = true;

        var hashedEventId = $stateParams.eventId;
        Log.debug("queue.controller","Hashed event id is '"+hashedEventId+"'");
        if(hashedEventId==undefined) {
            $state.go("public.error");
        }


        PublicResource.getWaitListQueueStatus({
            hashedEventId: hashedEventId
        }, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.data = data;
            if(vm.data.numberInQueue<=0) {
                Log.info("queue.controllor","Event '"+hashedEventId+"' no longer in wait list queue.");
                vm.noEventinWaitList = true;
                var params = {'code': "WL001",'errorMessage': "Wait list entry not valid anymore"};
                //$state.go("public.error");
            } else {
                vm.expectedIn = vm.data.quotedTime - vm.data.waitingTime;

                if (vm.data.numberInQueue > 5) vm.picNumber = 6;
                else vm.picNumber = vm.data.numberInQueue;

                var list = ['first', 'second', 'third', ' fourth', 'fifth'];
                if (vm.data.numberInQueue <= 5 && vm.data.numberInQueue > 0) vm.queueText = list[vm.data.numberInQueue - 1];
            }
        }

        function onError(error) {
            Log.debug("public.queue", "HTTP request error." + error);
            $state.go("public.error");
        }

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.error', {
            parent: 'public',
            url: '/error',
            data: {
                authorities: [],
                specialClass: " gray-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.error': {
                    templateUrl: 'app/public/error/error.html',
                    controller: 'PublicErrorController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@public.error': {}
                //'footer@app': {
                //    templateUrl: 'app/layouts/footer/footer.html'
                //}

            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('PublicErrorController', PublicErrorController);

    PublicErrorController.$inject = ['$scope', '$state', '$stateParams', 'Log', 'PublicResource'];

    function PublicErrorController($scope, $state, $stateParams, Log, PublicResource) {

        var vm = this;
        vm.code = $stateParams.code;

        if(angular.isString(vm.code)) {
            if(vm.code=="WL001") vm.eventClosed=true;
        } else vm.eventClosed=false;

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.feedback', {
            parent: 'public',
            url: '/feedback/:eventId',
            data: {
                authorities: [],
                specialClass: " gray-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.feedback': {
                    templateUrl: 'app/public/feedback/feedback.html',
                    controller: 'FeedbackController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@public.feedback': {}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('FeedbackController', FeedbackController);

    FeedbackController.$inject = ['$scope', '$state', '$stateParams', 'Log', 'PublicResource'];

    function FeedbackController($scope, $state, $stateParams, Log, PublicResource) {

        var vm = this;
        vm.submitted = false;
        vm.rating = 5;
        vm.feedback = "";

        var hashedEventId = $stateParams.eventId;
        Log.debug("queue.controller","Hashed event id is '"+hashedEventId+"'");
        if(hashedEventId==undefined || hashedEventId=='') {
            $state.go("public.error");
        }


        PublicResource.getFeedbackDetails({
            hashedEventId: hashedEventId
        }, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.data = data;
        }

        function onError(error) {
            Log.debug("feedback.controller", "HTTP request error." + error);
        }

        $scope.submitFeedback = function() {
            Log.debug("feedback.controller", "Submit feedback rating="+vm.rating+" text="+vm.feedback);

            vm.data.rating = vm.rating;
            vm.data.feedback = vm.feedback;

            PublicResource.saveFeedback({
                hashedEventId: hashedEventId
            }, vm.data, onSuccessSave, onErrorSave);

            function onSuccessSave(data, headers) {
                vm.submitted=true;
            }

            function onErrorSave(error) {
                Log.debug("feedback.controller", "HTTP request error." + error);
            }
        }
    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.cancel', {
            parent: 'public',
            url: '/cancel/:eventId',
            data: {
                authorities: [],
                specialClass: " gray-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.cancel': {
                    templateUrl: 'app/public/cancel/cancel.html',
                    controller: 'PublicCancelController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@public.cancel': {}
                //'footer@app': {
                //    templateUrl: 'app/layouts/footer/footer.html'
                //}

            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('PublicCancelController', PublicCancelController);

    PublicCancelController.$inject = ['$scope', '$state', '$stateParams', 'Log', 'PublicResource'];

    function PublicCancelController($scope, $state, $stateParams, Log, PublicResource) {

        var vm = this;
        var hashedEventId = $stateParams.eventId;
        vm.canceled = false;
        vm.loadStatus = loadStatus;
        vm.cancelFailed = false;

        Log.debug("cancel.controller", "Hashed event id is '" + hashedEventId + "'");
        if (hashedEventId == undefined || hashedEventId == '') {
            $state.go("public.error");
        }

        function loadStatus() {
            PublicResource.cancelEventDetails({
                hashedEventId: hashedEventId
            }, onSuccess, onError);
        }

        vm.loadStatus();

        function onSuccess(data, headers) {
            vm.data = data;
            if (vm.data.status == "CANCELLED") vm.canceled = true;
        }

        function onError(error) {
            Log.debug("cancel.controller", "HTTP request error due event details request." + error);
        }

        $scope.cancelEvent = function () {
            PublicResource.cancelEvent({
                hashedEventId: hashedEventId
            }, onCancelSuccess, onCancelError);

            function onCancelSuccess(data, headers) {
                vm.cancelFailed = false;
                PublicResource.cancelEventDetails({
                    hashedEventId: hashedEventId
                }, function (data) {
                    vm.cancelFailed = data.status != "CANCELLED";
                    vm.canceled = data.status == "CANCELLED";
                });
            }

            function onCancelError(error) {
                Log.debug("cancel.controller", "HTTP request error due cancel request." + error);
            }
        }

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.confirm', {
            parent: 'public',
            url: '/confirm/:eventId',
            data: {
                authorities: [],
                specialClass: " gray-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.confirm': {
                    templateUrl: 'app/public/confirm/confirm.html',
                    controller: 'PublicConfirmController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@public.confirm': {}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('PublicConfirmController', PublicConfirmController);

    PublicConfirmController.$inject = ['$scope', '$state', '$stateParams', 'Log', 'PublicResource'];

    function PublicConfirmController($scope, $state, $stateParams, Log, PublicResource) {

        var vm = this;
        var hashedEventId = $stateParams.eventId;

        Log.debug("confirm.controller","Hashed event id is '"+hashedEventId+"'");
        if(hashedEventId==undefined || hashedEventId=='') {
            $state.go("public.error");
        }

        PublicResource.confirmReservationByCustomer({
            hashedEventId: hashedEventId
        }, onSuccess, onError);


        function onSuccess(data, headers) {
            vm.data = data;
        }

        function onError(error) {
            Log.debug("confirm.controller", "HTTP request error due event details request." + error);
        }

    }
})();




(function () {
    'use strict';

    angular
        .module('seatonApp')
        .factory('OnlineReservationContext', OnlineReservationContext);

    OnlineReservationContext.$inject = ['$rootScope', '$localStorage', '$locale'];

    function OnlineReservationContext($rootScope, $localStorage, $locale) {

        var service = {
            storeLocationChannelPage: storeLocationChannelPage,
            storeSettings: storeSettings,
            storeRequest: storeRequest,
            storeReference: storeReference,
            storeCustomer: storeCustomer,
            storePaymentSettings: storePaymentSettings,
            storeVerificationSent: storeVerificationSent,
            storeProductModifiers: storeProductModifiers,
            storeFees: storeFees,

            getLocationId: getLocationId,
            getChannel: getChannel,
            getReservationPage: getReservationPage,
            getSettings: getSettings,
            getRequest: getRequest,
            getReference: getReference,
            getCustomer: getCustomer,
            getPaymentSettings: getPaymentSettings,
            getVerificationSent: getVerificationSent,
            getProductModifiers: getProductModifiers,
            getFees: getFees,

            clear: clear,
            clearModifiers: clearModifiers

        };

        return service;

        function storeLocationChannelPage(locationId, channel, reservationPage) {
            $localStorage.OnlineLocationID = locationId;
            $localStorage.OnlineChannel = channel;
            $localStorage.OnlineReservationPage = reservationPage;
        }

        function storeSettings(settings) {
            $localStorage.OnlineSettings = settings;
        }

        function storeRequest(request) {
            $localStorage.OnlineRequest = request;
        }

        function storeReference(reference) {
            $localStorage.OnlineReference = reference;
        }

        function storeCustomer(customer) {
            $localStorage.OnlineCustomer = customer;
        }

        function storePaymentSettings(payment) {
            $localStorage.OnlinePaymentSettings = payment;
        }

        function storeVerificationSent(sent) {
            $localStorage.OnlineVerificationSent = sent;
        }

        function storeProductModifiers(modifiers) {
            $localStorage.OnlineProductModifiers = modifiers;
        }

        function storeFees(fees) {
            $localStorage.OnlineFees = fees;
        }

        function clearModifiers() {
            // MODIFIER PAGE
            delete $localStorage.OnlineProductModifiers;
            delete $localStorage.OnlineFees;

        }

        function clear() {

            // PROXY PAGE
            delete $localStorage.OnlineLocationID;
            delete $localStorage.OnlineChannel;
            delete $localStorage.OnlineReservationPage;

            // REQUEST PAGE
            delete $localStorage.OnlineSettings;
            delete $localStorage.OnlineRequest;

            clearModifiers();

            // CONTACT PAGE
            delete $localStorage.OnlineCustomer;
            delete $localStorage.OnlinePaymentSettings;
            delete $localStorage.OnlineVerificationSent;


            // GENERAL
            delete $localStorage.OnlineReference;
        }

        function getLocationId() {
            return $localStorage.OnlineLocationID;
        }

        function getChannel() {
            return $localStorage.OnlineChannel;
        }

        function getReservationPage() {
            return $localStorage.OnlineReservationPage;
        }

        function getSettings() {
            return $localStorage.OnlineSettings;
        }

        function getRequest() {
            return $localStorage.OnlineRequest;
        }

        function getReference() {
            return $localStorage.OnlineReference;
        }

        function getCustomer() {
            return $localStorage.OnlineCustomer;
        }

        function getPaymentSettings() {
            return $localStorage.OnlinePaymentSettings;
        }

        function getVerificationSent() {
            return $localStorage.OnlineVerificationSent;
        }

        function getProductModifiers() {
            return $localStorage.OnlineProductModifiers
        }

        function getFees() {
            return $localStorage.OnlineFees;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online', {
            abstract: true,
            parent: 'public',
            url: '/online',
            data: {
            }
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online.waitlist', {
            parent: 'public.online',
            url: '/waitlist/:locationId',
            data: {
                authorities: [],
                bodyClass: " transparent-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.online.waitlist': {
                    templateUrl: 'app/public/online/waitlist/add.html',
                    controller: 'OnlineWaitListController',
                    controllerAs: 'vm'
                },
                'navbar@public.online.waitlist': {},
                'topnavbar@public.online.waitlist': {}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('OnlineWaitListController', OnlineWaitListController);

    OnlineWaitListController.$inject = ['$rootScope', '$scope', '$state', '$document', '$stateParams', 'Log', 'PublicResource', 'Utils',
                                    'OnlineReservationContext'];

    function OnlineWaitListController($rootScope, $scope, $state, $document, $stateParams, Log, PublicResource, Utils,
                                      OnlineReservationContext) {

        var vm = this;
        vm.isInternationalSmsEnabled = false;
        if (window.location.href.indexOf("//eu.getseat.net") != -1)  vm.isEU = true;
        vm.systemErrorOccured = false;
        vm.inputErrorOccured = false;
        vm.phoneRegion = null;
        vm.phonePattern = null;
        vm.addSubmitted = false;
        vm.locationName = "Restaurant waiting list";
        vm.locationAddress = "";
        vm.contactEmail = null;
        vm.contactPhone = null;
        vm.availabilityStatus = null;
        vm.isAddingAllowed = false;

        // Status colors matching onlineWidget.js
        vm.statusColors = {
            1: { // GREEN - Available
                background: "rgb(80, 150, 89)",
                text: "rgb(80, 150, 89)"
            },
            2: { // YELLOW - Almost full
                background: "rgb(160, 156, 3)",
                text: "rgb(204, 204, 51)"
            },
            3: { // RED - Full
                background: "rgb(140, 22, 22)",
                text: "rgb(255, 51, 51)"
            },
            4: { // BLACK - Closed
                background: "rgb(150, 150, 150)",
                text: "rgb(204, 204, 204)"
            }
        };

        vm.persons = [
            {"id": 1, "label": "1 person"},
            {"id": 2, "label": "2 persons"},
            {"id": 3, "label": "3 persons"},
            {"id": 4, "label": "4 persons"},
            {"id": 5, "label": "5 persons"},
            {"id": 6, "label": "6 persons"}
        ];

        vm.reset = function () {
            vm.inputErrorOccured = false;
            vm.numberOfPersons = 2;
            vm.addSubmitted = false;
            vm.resetCustomer();
        };

        vm.resetCustomer = function () {
            // workaround for https://github.com/angular/angular.js/issues/2743
            jQuery("input[name='primaryEmail']").val("");
            jQuery("input[name='primaryPhone']").val("");
            vm.customer = null;
        };

        vm.reset();

        var hashedLocationId = $stateParams.locationId;
        Log.debug("OnlineWaitListController", "Hashed locationId id is '" + hashedLocationId + "'");
        if (hashedLocationId == undefined) {
            vm.systemErrorOccured - true;
        }


        // GET wait times from host
        $(function () {
            if (vm.systemErrorOccured) return; // do not call host

            // Get availability status
            getAvailabilityStatus();

            PublicResource.calculateWaitTimes({
                hashedLocationId: hashedLocationId
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.systemErrorOccured = false;
                vm.data = data;
                vm.isInternationalSmsEnabled = data.internationalSmsEnabled;
                //vm.isInternationalSmsEnabled = false;
                vm.setQuotedWaitTime();

                //vm.phoneRegion = 'US';
                vm.phoneRegion = data.phoneRegion;

                //vm.phonePrefix = '+1'
                vm.phonePrefix = data.phonePrefix;

                vm.locationName = data.locationName;
                vm.locationAddress = data.locationAddress;
                vm.contactEmail = data.contactEmail;
                vm.contactPhone = data.contactPhone;

                if (vm.isInternationalSmsEnabled || vm.isEU) {
                    vm.phonePattern = '';
                } else {
                    vm.phonePattern = new RegExp('^\\' + vm.phonePrefix);
                }
            }

            function onError(error) {
                Log.debug("OnlineWaitListController", "HTTP request error." + error);
                vm.systemErrorOccured = true;
            }
        });

        // Get availability status from API
        function getAvailabilityStatus() {
            $.ajax({
                url: 'api/v1/public/availability/status/' + hashedLocationId,
                type: 'GET',
                success: function(data) {
                    vm.availabilityStatus = data;
                    // Only allow adding to waitlist if status is RED (all tables occupied) and waitlist is allowed
                    vm.isAddingAllowed = (data.status === 3 && data.waitListAllowed === true);
                    Log.debug("OnlineWaitListController", "Availability status: " + JSON.stringify(data));
                },
                error: function(error) {
                    Log.debug("OnlineWaitListController", "Error getting availability status: " + error);
                    vm.systemErrorOccured = true;
                }
            });
        }

        // get wait time text
        vm.getWaitTimeText = function(){
            if(vm.quotedWaitTime>0) {
                return 'Average wait time for ' + vm.numberOfPersons + ' person(s) is ' + vm.quotedWaitTime + ' minute(s).';
            } else {
                return 'The waiting time is short, you will soon be notified that the table is ready.';
            }
        };

        // ADD visitor to wait list
        vm.addToWaitlist = function (phoneValid) {

            if (vm.inputNOK(phoneValid)) {
                vm.inputErrorOccured = true;
                return;
            } else {
                vm.inputErrorOccured = false;
            }

            // Check if adding to waitlist is allowed based on availability status
            if (!vm.isAddingAllowed) {
                Log.debug("OnlineWaitListController", "Adding to waitlist not allowed based on current availability status");
                return;
            }

            var currentCustomer = Utils.getBasicCustomerData(vm.customer);

            var event = {
                note: vm.note,
                quotedWaitTime: vm.quotedWaitTime,
                numberOfPersons: vm.numberOfPersons,
                channel: 'MERCHANT_WEB',
                existingCustomerUpdated: false,
                customer: currentCustomer
            };
            //console.log(event);

            // disable create button, so that the user does not accidentally send two requests
            vm.addSubmitted = true;
            PublicResource.addToWaitlistFromWeb(
                {
                    hashedLocationId: hashedLocationId
                },
                event, onSuccessSave, onErrorSave);

            function onSuccessSave(data, headers) {
                vm.systemErrorOccured = false;
                var settings = {
                    'locationName': vm.locationName,
                    'locationAddress': vm.locationAddress,
                    'contactEmail': vm.contactEmail,
                    'contactPhone': vm.contactPhone
                };

                OnlineReservationContext.storeReference("WAITLIST");
                OnlineReservationContext.storeLocationChannelPage(hashedLocationId, "MERCHANT_WEB");
                OnlineReservationContext.storeSettings(settings);

                $state.go("public.online.success", settings);
                vm.addSubmitted = false;
            }

            function onErrorSave(error) {
                vm.systemErrorOccured = true;
                Log.debug("OnlineWaitListController", "Error while adding visitors to wait list. Err=" + error);
                vm.addSubmitted = false;
            }

        };

        vm.systemErrorOccurs = function () {
            return vm.systemErrorOccured;
        };

        vm.setQuotedWaitTime = function () {
            if (vm.numberOfPersons < 2) {
                if (vm.data.waitlistData.approxWaitTimeOneToTwo != undefined) {
                    vm.quotedWaitTime = vm.data.waitlistData.approxWaitTimeOneToTwo;
                }
            } else if (vm.numberOfPersons < 4) {
                if (vm.data.waitlistData.approxWaitTimeThreeToFour != undefined) {
                    vm.quotedWaitTime = vm.data.waitlistData.approxWaitTimeThreeToFour;
                }
            } else {
                if (vm.data.waitlistData.approxWaitTimeFivePlus != undefined) {
                    vm.quotedWaitTime = vm.data.waitlistData.approxWaitTimeFivePlus;
                }
            }
        };

        vm.inputNOK = function (phoneValid) {
            var input =
                !(vm.numberOfPersons > 0) ||
                !vm.customer ||
                !vm.customer.firstName ||
                !vm.customer.lastName ||
                !vm.customer.primaryEmail ||
                !(vm.customer.primaryPhone && phoneValid);

            return input;
        };

        // Check if adding to waitlist is allowed based on availability status
        vm.isAddingToWaitlistAllowed = function() {
            return vm.isAddingAllowed;
        };

        // Get availability status text
        vm.getAvailabilityStatusText = function() {
            if (!vm.availabilityStatus) {
                return '';
            }

            return vm.availabilityStatus.title + ' ' + vm.availabilityStatus.text;
        };

        // Get status color for the current availability status
        vm.getStatusColor = function(type) {
            if (!vm.availabilityStatus || !vm.statusColors[vm.availabilityStatus.status]) {
                return '';
            }

            return vm.statusColors[vm.availabilityStatus.status][type];
        };

        vm.inputErrorOccurs = function () {
            return vm.inputErrorOccured;
        };

        vm.reformatPhone = function () {
            $scope.numInput = $document.find('#primaryPhone');
            if (typeof intlTelInputUtils !== 'undefined') {
                var currentText = $scope.numInput.intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
                if (typeof currentText === 'string') {
                    $scope.numInput.intlTelInput('setNumber', currentText);
                }
            }
        }
    }


})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online.legacy', {
            parent: 'public.online',
            url: '/reservation/legacy',
            data: {
                authorities: [],
                bodyClass: " transparent-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.online.legacy': {
                    templateUrl: 'app/public/online/reservation/legacy/create.html',
                    controller: 'OnlineCreateLegacyController',
                    controllerAs: 'vm'
                },
                'navbar@public.online.legacy': {},
                'topnavbar@public.online.legacy': {}
            },
            params: {
            },

            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

    (function () {
    'use strict';
    angular.module('seatonApp').controller('OnlineCreateLegacyController', OnlineCreateLegacyController);

    OnlineCreateLegacyController.$inject = ['$rootScope', '$scope', '$state', '$document', '$stateParams', 'Log', 'PublicResource',
                                            'OnlineReservationContext'];

    function OnlineCreateLegacyController($rootScope, $scope, $state, $document, $stateParams, Log, PublicResource,
                                          OnlineReservationContext) {

    // INITIALIZE
        var vm = this;

        vm.DATE_FORMAT = 'YYYY-MM-DD';
        vm.DATE_PICKER_FORMAT = 'MMM D, YYYY';
        vm.TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
        vm.TIME_DISPLAY_FORMAT = 'hh:mmA';
        vm.moment = moment;

        vm.inputErrorOccured = false;
        vm.firstPage = true;
        vm.actionSubmitted = false;
        // when set, we ignore params from the query string (?date=...&party_size&....)
        vm.ignoreInputFromQueryParams = false;

        vm.customer = null;
        vm.resourceNotAvailableAnymore = false;
        vm.productChosenByGuest = false;
        vm.productList = [];

        // function definition
        vm.onDateChange = onDateChange;
        vm.onTimeChange = onTimeChange;
        vm.resetFirstPage = resetFirstPage;
        vm.findTable = findTable;
        vm.selectAlternativeSlot = selectAlternativeSlot;
        vm.inputErrorOccurs = inputErrorOccurs;
        vm.initPicker = initPicker;
        vm.openDatePicker = openDatePicker;
        vm.reformatPhone = reformatPhone;
        vm.findProductById = findProductById;
        vm.filterByParams = filterByParams;

    // PARAMETERS AND SETTINGS
        vm.locationId = OnlineReservationContext.getLocationId();
        Log.debug("OnlineCreateLegacyController", "Hashed locationId id is '" + vm.locationId + "'");
        if (!vm.locationId) {
            // if location id not return to reservation proxy
            $state.go("public.online.reservation");
        } else {
            // if location id defined proceed with initialization
            fetchReservationSettings();
        }

        // GET reservation settings: alternative times, add to wait list, maximum party size, note to customer, etc...
        function fetchReservationSettings() {

            PublicResource.fetchReservationSettings(
                {
                    hashedLocationId: vm.locationId
                },
                function (data) {
                    vm.settings = data;

                    vm.formattedWebPageLink = addHttpPrefix(vm.settings.businessWebPage); // adds http: prefix if missing

                    OnlineReservationContext.storeSettings(vm.settings);
                    if(!vm.settings.minSeats) vm.settings.minSeats=1;
                    vm.persons = [];
                    for (var i = vm.settings.minSeats; i <= vm.settings.maxSeats; i++) {
                        if (i == 1) {
                            vm.persons.push({"id": 1, "label": "1 person"});
                        } else {
                            vm.persons.push({"id": i, "label": "" + i + " persons"});
                        }
                    }

                    vm.phoneRegion = data.phoneRegion;
                    vm.phonePrefix = data.phonePrefix;
                    vm.productChosenByGuest = data.productChosenByGuest;

                    var localeApp = 'en';
                    if (vm.phoneRegion == 'US') {
                        localeApp = 'en';
                        $rootScope.currencyIcon = 'fa fa-dollar';
                    } else if (vm.phoneRegion == 'GB') {
                        localeApp = 'en-gb';
                        $rootScope.currencyIcon = 'fa fa-gbp';
                    } else if (vm.phoneRegion == 'IE') {
                        localeApp = 'en-ie';
                        $rootScope.currencyIcon = 'fa fa-euro';
                    } else if (vm.phoneRegion == 'CA') {
                        localeApp = 'en-ca';
                        $rootScope.currencyIcon = 'fa fa-money';
                    }

                    moment.locale(localeApp);
                    Log.debug("OnlineCreateLegacyController","locale:" + moment.locale() + " firstDay:" + moment.localeData().firstDayOfWeek());


                    vm.request = OnlineReservationContext.getRequest(); // reservation request -> date, time & party_size, productId
                    vm.channel = OnlineReservationContext.getChannel(); // channel
                    vm.reference = OnlineReservationContext.getReference(); // reference PROXY, CONTACT, PAYMENT

                    if(!vm.channel) {
                        $state.go("public.online.reservation");
                        return;
                    }

                    vm.selectedDay = vm.request.date;
                    vm.selectedDayFormatted = moment(vm.selectedDay, vm.DATE_FORMAT).format(vm.DATE_PICKER_FORMAT);
                    if(vm.request.party_size) {
                        vm.numberOfPersons = vm.request.party_size;
                    }

                    vm.selectedTime = vm.request.time;
                    if (vm.settings && vm.settings.productChosenByGuest) {
                        vm.durationTime = vm.request.duration;
                    }

                    if (vm.reference == 'PAYMENT' || vm.reference == 'CONTACT') {
                        // reference is contact or payment page, reschedule action triggered
                        vm.onDateChange();

                    } else if(vm.reference == 'PROXY'){
                        if (isReservationRequestValid(vm.request)) {
                            vm.findTable();
                        } else {
                            vm.resetFirstPage();
                        }
                    } else {
                        vm.resetFirstPage();
                    }

                    $document.ready(
                        function () {
                            vm.initPicker();
                        }
                    );

                },
                onError
            );
        };

        function isReservationRequestValid(request) {
            if(request) {
                Log.debug("OnlineCreateLegacyController","Query params, date:"+request.date+", " +
                    "time:"+request.time+", party_size:"+request.party_size+".");
            }
            if (vm.settings && vm.settings.productChosenByGuest) {
                Log.debug("Additionally check duration, duration is '"+vm.durationTime+"'.");
                if(!vm.durationTime) return false;
            }
            return request && request.date && request.time && request.party_size;
        }

    // FIRST PAGE

        // on selected date change call this function
        function onDateChange () {

            vm.findTableData = null;
            if (moment(vm.selectedDay, vm.DATE_FORMAT).isBefore(moment().startOf('day'))) {
                vm.isDateBeforeToday = true;
                vm.times = [];
                vm.selectedTime = null;
                vm.selectedTimeId = "";
                return;
            } else {
                vm.isDateBeforeToday = false;
            }

            if (moment(vm.selectedDay, vm.DATE_FORMAT).isAfter(moment(vm.settings.maxReservationDate).startOf('day'))) {
                vm.isAfterMaxReservationDate = true;
                vm.times = [];
                vm.selectedTime = null;
                vm.selectedTimeId = "";
                return;
            } else {
                 vm.isAfterMaxReservationDate = false;
            }

            PublicResource.fetchReservationHourList({
                hashedLocationId: vm.locationId,
                requestedDate: vm.selectedDay
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.hoursListData = data.hourList;
                vm.status = data.status;
                vm.addText = data.addText;
                vm.times = [];
                if (vm.status == 0) {
                    for (var i = 0; i < vm.hoursListData.length; i++) {
                        vm.times.push({
                            "id": i,
                            "label": moment(vm.hoursListData[i].time, vm.TIME_SERVER_FORMAT).format(vm.TIME_DISPLAY_FORMAT),
                            "limit": vm.hoursListData[i].limit,
                            "actualAmount": vm.hoursListData[i].actualAmount
                        });
                    }
                    vm.selectedTime = null;
                    vm.selectedTimeId = "";
                } else {
                    vm.selectedTime = null;
                    vm.selectedTimeId = "";
                }
                vm.productList = [];
            }
        };

        // on selected time change call this function
        function onTimeChange () {
            vm.selectedTime = vm.hoursListData[vm.selectedTimeId].time;
            vm.resourceNotAvailableAnymore = false;

            vm.findTableData = null;

            Log.debug("OnlineCreateLegacyController", "Selected time is '" + vm.selectedTime + "'");
            if(!vm.selectedTime || vm.productChosenByGuest==false) {
                vm.productList = [];
                return;
            } // if product not chosen by guest no need to fetch product list

            //if product not chosen by guest fetch product list from server
            PublicResource.fetchProductList({
                hashedLocationId: vm.locationId,
                requestedDate: vm.selectedDay,
                requestedTime: vm.selectedTime
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.productList = data.productList;
            }
        };

        // find table based on dedfined criteria
        function findTable () {

            vm.actionSubmitted = true;
            vm.resourceNotAvailableAnymore = false;
            vm.inputErrorOccured = false;

            if (!vm.selectedTime || vm.selectedTime == null) { // if time not selected report error
                vm.inputErrorOccured = true;
                vm.actionSubmitted = false;
                return;
            }

            vm.product = null; // if duration null server choose duration
            if (vm.settings.productChosenByGuest) {
                // product chosen by guest
                vm.product = findProductById(vm.selectedProductId);
                Log.debug("OnlineCreateLegacyController", "Product found:"+JSON.stringify(vm.product));
                if(!vm.product) { // product not found report error
                    vm.actionSubmitted = false;
                    vm.inputErrorOccured = true;
                    return;
                }
            }

            PublicResource.findTable(
                {
                    hashedLocationId: vm.locationId
                },
                {
                    requestedDate: vm.selectedDay,
                    requestedTime: vm.selectedTime,
                    numberOfPersons: vm.numberOfPersons,
                    product: vm.product // if product null servers will decide
                },
                function (data) {
                    vm.actionSubmitted = false;
                    vm.findTableData = data;
                    if (vm.findTableData.tableFound) {
                        proceedToContactPage();
                    }
                },
                onError
            );
        };

        // if preffered time not available select alternative time slot
        function selectAlternativeSlot (timeSlot) {
            vm.selectedTime = timeSlot;
            proceedToContactPage();
        };

        function proceedToContactPage() {

            var request = {
                'date': vm.selectedDay,
                'time': vm.selectedTime,
                'party_size': vm.numberOfPersons,
                'product': vm.product
            }
            OnlineReservationContext.storeRequest(request);
            OnlineReservationContext.storeReference("LEGACY");

            $state.go("public.online.contact");
        }

        // reset first page form
        function resetFirstPage () {

            vm.selectedDay = moment().format(vm.DATE_FORMAT); // today, always by default today will be choose as reservation date
            vm.selectedDayFormatted = moment(vm.selectedDay, vm.DATE_FORMAT).format(vm.DATE_PICKER_FORMAT); // format to match date picker
            if(vm.settings && vm.settings.minSeats>2) {
                vm.numberOfPersons = vm.settings.minSeats;
            } else {
                vm.numberOfPersons = 2; // default 2 covers if not defined by minSets
            }

            vm.selectedProductId = null; // if product null server will decide about reservation product
            vm.times = []; // list if reservation tiem slots avilable for reservation
            vm.findTableData = null; // result of find table action

            vm.onDateChange(); // featch reservation time slot available, since due to reset reservation date can be chenged to current
            vm.actionSubmitted = false;
        };

        function filterByParams(timeSlot) {
            if (timeSlot.limit == -1 ||  // max allowed  per time slot not activated or
                timeSlot.limit > timeSlot.actualAmount) { //  actual number equal or higher then maximum allowed
                return true;
            }
            return false;
        }



        // HANDLE ERRORS

        function inputErrorOccurs () {
            return vm.inputErrorOccured;
        };

        function onError(error) {
            Log.debug("OnlineCreateLegacyController", "Unexpected error:" + error + ".");
            vm.actionSubmitted = false;

            OnlineReservationContext.storeReference("LEGACY");

            $state.go("public.online.error");
        };


    // UTILS

        // initialize date & time picker
        function initPicker () {
            $(function () {
                // date picker
                vm.datePicker = $document.find('input[name="datePicker"]');
                vm.datePicker.daterangepicker(
                    {
                        singleDatePicker: true,
                        showDropdowns: true,
                        locale: {format: vm.DATE_PICKER_FORMAT}
                    },
                    function (start, end, label) {
                        vm.selectedDay = start.format(vm.DATE_FORMAT);
                        vm.onDateChange();
                    }
                );
                vm.datePicker.val(vm.selectedDayFormatted);
            });
        };

        // focus date picker on open dialog
        function openDatePicker () {
            vm.datePicker.focus();
        };

        // format phone number
        function reformatPhone () {
            $scope.numInput = $document.find('#primaryPhone');
            if (typeof intlTelInputUtils !== 'undefined') {
                var currentText = $scope.numInput.intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
                if (typeof currentText === 'string') {
                    $scope.numInput.intlTelInput('setNumber', currentText);
                }
            }
        };

        function findProductById(productId) {
            if(vm.productList) {
                for (var i = 0; i < vm.productList.length; i++) {
                    if(vm.productList[i].id == productId)
                        return vm.productList[i];
                }
            }
            // product not found for product id
            return null;
        }

        // if the web site does not start with 'http(s)' this function will add the prefix http://
        function addHttpPrefix(originalLink) {
            if (originalLink) {
                if (originalLink.startsWith('http')) {
                    return originalLink;
                } else {
                    return "http://" + originalLink;
                }
            } else {
                return originalLink;
            }
        }
    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online.success', {
            parent: 'public.online',
            url: '/success',
            data: {
                authorities: [],
                bodyClass: " transparent_bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.online.success': {
                    templateUrl: 'app/public/online/success/success.html',
                    controller: 'OnlineSuccessController',
                    controllerAs: 'vm'
                },
                'navbar@public.online.success': {},
                'topnavbar@public.online.success': {}
            },
            params: {
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('OnlineSuccessController', OnlineSuccessController);

    OnlineSuccessController.$inject = ['$scope', '$state', '$stateParams', 'Log', 'PublicResource',
                                    'OnlineReservationContext'];

    function OnlineSuccessController($scope, $state, $stateParams, Log, PublicResource,
                                     OnlineReservationContext) {

        var vm = this;
        vm.type = getType(OnlineReservationContext.getReference());
        vm.hashedLocationId = OnlineReservationContext.getLocationId();
        vm.channel = OnlineReservationContext.getChannel();
        vm.settings = OnlineReservationContext.getSettings();

        if(!vm.channel) {
            if(vm.type=="r")  {
                $state.go("public.online.reservation");
            } else if (vm.type=="w") {
                $state.go("public.online.waitlist");
            }
        }

        if(vm.type=="r") {
            vm.userEmail = OnlineReservationContext.getCustomer().primaryEmail;
            vm.verificationSent = OnlineReservationContext.getVerificationSent();
            vm.enablePayment = vm.settings.enablePayment;
        }

        vm.newReservation = newReservation;
        vm.newWaitList = newWaitList;

        Log.debug("OnlineSuccessController", "Type value is " + vm.type);

        PublicResource.getCompletedSettings(
            {
                hashedLocationId: vm.hashedLocationId
            },
            {},
            function (data) {
                vm.generalMessage = data.generalMessage;
                vm.confirmationSentMessage = data.confirmationSentMessage;
                vm.verificationSentMessage = data.verificationSentMessage;

            },
            onError
        );

        function onError(error) {
            vm.generalMessage = "Thank you for your reservation.";
            vm.confirmationSentMessage = "Your reservation request is being processed and soon you will receive an email with reservation acknowledgment from us on your email.";
            vm.verificationSentMessage = "A verification email is sent to your email. Please open the email and verify your reservation request.";
        }

        function newReservation() {

            var params = {
                'locationId': vm.hashedLocationId
            }

            $state.go("public.online.reservation", params);

        }

        function newWaitList() {

            var params = {
                'locationId': vm.hashedLocationId
            }

            $state.go("public.online.waitlist", params);

        }


        function getType(reference) {
            if("CONTACT" == reference || "PAYMENT"==reference) {
                return "r";
            } else if("WAITLIST" == reference) {
                return "w";
            } else {
                return "";
            }
        }

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online.payment', {
            parent: 'public.online',
            url: '/payment',
            data: {
                authorities: [],
                bodyClass: " transparent-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.online.payment': {
                    templateUrl: 'app/public/online/payment/payment.html',
                    controller: 'OnlinePaymentReservationController',
                    controllerAs: 'vm'
                },
                'navbar@public.online.payment': {},
                'topnavbar@public.online.payment': {}
            },
            params: {
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('seatonApp').controller('OnlinePaymentReservationController', OnlinePaymentReservationController);

    OnlinePaymentReservationController.$inject = ['$rootScope', '$scope', '$state', '$document', '$stateParams', 'Log',
        'PublicResource', 'ApplicationContext', 'Utils', 'Notification', 'OnlineReservationContext', 'TextUtil'];

    function OnlinePaymentReservationController($rootScope, $scope, $state, $document, $stateParams, Log, PublicResource,
                       ApplicationContext, Utils, Notification, OnlineReservationContext, TextUtil) {

        var vm = this;

        // date and time
        vm.DATE_FORMAT = 'YYYY-MM-DD';
        vm.DATE_PICKER_FORMAT = 'MMM D, YYYY';
        vm.TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
        vm.TIME_DISPLAY_FORMAT = 'hh:mmA';
        vm.moment = moment;

        // flags
        vm.errorOccured = false;
        vm.errorStatus = 0;
        vm.actionSubmitted = false;
        vm.resourceNotAvailableAnymore = false;
        vm.resourceText = TextUtil.translate("resource","s");

        vm.showPaymentDetails = false;

        loadAndValidateParams();

        const clover = new Clover(vm.payment.pakms);
        const elements = clover.elements();

        const form = document.getElementById('payment-form');

        const styles = {
            body: {
                fontFamily: 'Roboto, Open Sans, sans-serif',
                fontSize: '14px'
            },
            input: {
                fontSize: '14px',
                // Fixes for https://community.clover.com/questions/24714/issue-in-clover-hosted-iframe-application-running.html
                padding: '0px',
                margin: '0px'
            }
        };

        const cardNumber = elements.create('CARD_NUMBER', styles);
        const cardDate = elements.create('CARD_DATE', styles);
        const cardCvv = elements.create('CARD_CVV', styles);
        const cardPostalCode = elements.create('CARD_POSTAL_CODE', styles);

        cardNumber.mount('#card-number');
        cardDate.mount('#card-date');
        cardCvv.mount('#card-cvv');
        cardPostalCode.mount('#card-postal-code');

        const cardResponse = document.getElementById('card-response');
        const displayCardError = document.getElementById('card-errors');

        const displayCardNumberError = document.getElementById('card-number-errors');
        const displayCardDateError = document.getElementById('card-date-errors');
        const displayCardCvvError = document.getElementById('card-cvv-errors');
        const displayCardPostalCodeError = document.getElementById('card-postal-code-errors');


        cardNumber.addEventListener('change', function (event) {
            displayCardNumberError.innerHTML = event.CARD_NUMBER.error || '';
            displayCardError.innerHTML = '';
        });

        cardNumber.addEventListener('blur', function (event) {
            displayCardNumberError.innerHTML = event.CARD_NUMBER.error || '';
            displayCardError.innerHTML = '';
        });

        cardDate.addEventListener('change', function (event) {
            displayCardDateError.innerHTML = event.CARD_DATE.error || '';
            displayCardError.innerHTML = '';
        });

        cardDate.addEventListener('blur', function (event) {
            displayCardDateError.innerHTML = event.CARD_DATE.error || '';
            displayCardError.innerHTML = '';
        });

        cardCvv.addEventListener('change', function (event) {
            displayCardCvvError.innerHTML = event.CARD_CVV.error || '';
            displayCardError.innerHTML = '';
        });

        cardCvv.addEventListener('blur', function (event) {
            displayCardCvvError.innerHTML = event.CARD_CVV.error || '';
            displayCardError.innerHTML = '';
        });

        cardPostalCode.addEventListener('change', function (event) {
            displayCardPostalCodeError.innerHTML = event.CARD_POSTAL_CODE.error || '';
            displayCardError.innerHTML = '';
        });

        cardPostalCode.addEventListener('blur', function (event) {
            displayCardPostalCodeError.innerHTML = event.CARD_POSTAL_CODE.error || '';
            displayCardError.innerHTML = '';
        });

        form.addEventListener('submit', function(event) {
            event.preventDefault();
            Log.debug("OnlinePaymentReservationController","Payment form submitted.");
            vm.completeReservationWithPayment(event);
        });

        // ONLOAD PARAMS
        function loadAndValidateParams() {
            // location id
            vm.hashedLocationId = OnlineReservationContext.getLocationId();

            // payment page parameters
            vm.settings= OnlineReservationContext.getSettings();
            vm.request = OnlineReservationContext.getRequest();
            vm.customer = OnlineReservationContext.getCustomer();
            vm.payment = OnlineReservationContext.getPaymentSettings();
            vm.channel = OnlineReservationContext.getChannel();
            vm.reference = OnlineReservationContext.getReference();
            vm.reservationPage = OnlineReservationContext.getReservationPage();
            vm.fees = OnlineReservationContext.getFees();
            vm.modifierList = OnlineReservationContext.getProductModifiers();

            Log.debug("Payment page",
                "Input params. location id:" + vm.hashedLocationId
                + ": settings " + JSON.stringify(vm.settings)
                + ": request " + JSON.stringify(vm.request)
                + ": customer " + JSON.stringify(vm.customer)
                + ": payment " + JSON.stringify(vm.payment)
                + ": channel " + vm.channel
                + ": reference " + vm.reference
                + ": reservationPage " + vm.reservationPage
            );

            vm.amountValue = vm.payment.amount;
            vm.amountDisplay = Utils.formatAmount(vm.payment.totalAmount);
            vm.amountPerCoverDisplay = Utils.formatAmount(vm.payment.amount);

            // check if access link contain hash coded locationId
            if (!vm.hashedLocationId ) {
                // if location id not return to reservation proxy
                goToFindResourceState();
            }

            if(!vm.settings || !vm.request || !vm.customer || !vm.payment) {
                goToFindResourceState();
            }
        }

        // COMPLETE RESERVATION
        vm.completeReservationWithPayment = function () {

            // disable action button, so that the user does not accidentally send two requests
            $("#paymentSubmit").attr("disabled", true);
            vm.errorOccured=false;
            vm.errorStatus = 0;

            clover.createToken()
                .then(function (result) {
                    if (result.errors) {
                        $("#paymentSubmit").attr("disabled", false);
                        Log.debug("OnlinePaymentReservationController", "Error occurred while fetching token :"+JSON.stringify(result.errors)+":");
                        if(result.errors.CARD_NUMBER) {
                            displayCardNumberError.innerHTML = result.errors.CARD_NUMBER;
                        } else {
                            displayCardNumberError.innerHTML = '';
                        }
                        if(result.errors.CARD_DATE) {
                            displayCardDateError.innerHTML = result.errors.CARD_DATE;
                        } else {
                            displayCardDateError.innerHTML = '';
                        }
                        if(result.errors.CARD_CVV) {
                            displayCardCvvError.innerHTML = result.errors.CARD_CVV;
                        } else {
                            displayCardCvvError.innerHTML = '';
                        }
                        if(result.errors.CARD_POSTAL_CODE) {
                            displayCardPostalCodeError.innerHTML = result.errors.CARD_POSTAL_CODE;
                        } else {
                            displayCardPostalCodeError.innerHTML = '';
                        }
                    } else {
                        if(vm.actionSubmitted) {
                            Log.debug("OnlinePaymentReservationController", "Already submitted, return.");
                            return;
                        }
                        vm.actionSubmitted = true;
                        onTokenFetchSuccess(result.token);
                    }
                }).catch(function (data) {
                    Log.debug("OnlinePaymentReservationController", "Exception while fetching token from Clover. Exception data:"+data+":");
                    $("#paymentSubmit").attr("disabled", false);
                    goToErrorState("Exception while fetching token from Clover");
                });
        }

        function onTokenFetchSuccess(token) {

            var params = {
                // reservation requested params
                requestedDate: vm.request.date,
                requestedTime: vm.request.time,
                containerId: vm.request.containerId,
                containerName: vm.request.containerName,
                numberOfPersons: vm.request.party_size,
                product: vm.request.product,
                // other
                productChosenByGuest: vm.settings.productChosenByGuest,
                productType: vm.settings.productType,
                // customer details
                firstName: vm.customer.firstName,
                lastName: vm.customer.lastName,
                email: vm.customer.primaryEmail,
                phone: vm.customer.primaryPhone,
                note: vm.customer.note,
                // other
                channel: vm.channel,
                occasion: 1,
                // payment details
                source: token,
                amount: vm.payment.totalAmount,
                fees: vm.fees,
                productModifiers: vm.modifierList

            };

            PublicResource.prereserve(
                {
                    hashedLocationId: vm.hashedLocationId
                },
                params,
                function (data) {

                    vm.resourceNotAvailableAnymore = data.resourceNotAvailable;
                    vm.actionSubmitted = false;
                    if (vm.resourceNotAvailableAnymore == false) {

                        OnlineReservationContext.storeCustomer(vm.customer);
                        OnlineReservationContext.storeVerificationSent(data.verificationSent);

                        // store new reference
                        OnlineReservationContext.storeReference("PAYMENT");

                        $state.go("public.online.success");
                    }
                    vm.actionSubmitted = false;
                    $("#paymentSubmit").attr("disabled", false);
                },
                onError
            );
        }

        function onError(error) {
            Log.debug("OnlinePaymentReservationController", "HTTP request error." + error.status);
            vm.actionSubmitted = false;
            $("#paymentSubmit").attr("disabled", false);
            if(error.status == 402) {
                vm.errorOccured = true;
                vm.errorStatus = error.data.paymentStatus;
                Log.debug("Error status is " + vm.errorStatus);
            } else {
                goToErrorState("Error while performing payment transaction.");
            }
        }

        function goToErrorState(error) {
            Log.debug("OnlinePaymentReservationController", "Unexpected error:" + error + ".");
            // store new reference
            OnlineReservationContext.storeReference("PAYMENT");

            $state.go("public.online.error");
        }

        function goToFindResourceState() {
            Notification.showAlert("error", "Reservation parameters missing. Returning to first step in process.");
            var params = {
                'locationId': vm.hashedLocationId
            };
            $state.go("public.online.reservation", params);

        }

        // RESCHEDULE RESERVATION
        vm.reschedule = function() {

            // store new reference
            OnlineReservationContext.storeReference("PAYMENT");

            if("LEGACY" == vm.reservationPage) {
                $state.go("public.online.legacy");
            } else if("RESERVE" == vm.reservationPage){
                $state.go("public.online.reserve");
            } else {
                onError("Unknown reference value, expected LEGACY OR RESERVE, found:" + vm.reference + ".")
            }
        }

        vm.formatAmount = function(amount) {
            if(!amount) amount = 0;
            return Utils.formatAmount(amount);
        }

        // not needed
        /*
        const form = document.getElementById('payment-form');
        form.addEventListener('submit', function(event) {
            event.preventDefault();

            clover.createToken()
                .then(function(result) {
                    debugger;
                    if (result.errors) {
                        Object.values(result.errors).forEach(function (value) {
                            cardDataDisplayError.textContent = value;
                        });
                    } else {
                        alert(result.token);
                    }
                }).catch(function(data){
                console.log(data);
            });
        });


        // Submit the form with the token ID.
        function cloverTokenHandler(token) {
            // Insert the token ID into the form so it gets submitted to the server
            var form = document.getElementById('payment-form');
            var hiddenInput = document.createElement('input');
            hiddenInput.setAttribute('type', 'hidden');
            hiddenInput.setAttribute('name', 'cloverToken');
            hiddenInput.setAttribute('value', token);
            form.appendChild(hiddenInput);
            alert(token);
            // Submit the form
            // form.submit();
        }

        */

   }

})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online.error', {
            parent: 'public.online',
            url: '/error',
            data: {
                authorities: [],
                bodyClass: " transparent_bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.online.error': {
                    templateUrl: 'app/public/online/error/error.html',
                    controller: 'OnlineErrorController',
                    controllerAs: 'vm'
                },
                'navbar@public.online.error': {},
                'topnavbar@public.online.error': {}
            },
            params: {
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('OnlineErrorController', OnlineErrorController);

    OnlineErrorController.$inject = ['$scope', '$state', '$stateParams', 'Log','OnlineReservationContext'];

    function OnlineErrorController($scope, $state, $stateParams, Log, OnlineReservationContext) {

        var vm = this;
        vm.type = OnlineReservationContext.getReference();
        vm.locationId = OnlineReservationContext.getLocationId();
        vm.settings = OnlineReservationContext.getSettings();

        if(!vm.locationId) vm.errorCode=1;
        else vm.errorCode=99;

        Log.debug("OnlineErrorController", "Reference value is " + vm.reference);

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online.reserve', {
            parent: 'public.online',
            url: '/reservation/reserve',
            data: {
                authorities: [],
                bodyClass: " transparent-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.online.reserve': {
                    templateUrl: 'app/public/online/reservation/reserve/create.html',
                    controller: 'OnlineReserveController',
                    controllerAs: 'vm'
                },
                'navbar@public.online.reserve': {},
                'topnavbar@public.online.reserve': {}
            },
            params: {
            },

            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('seatonApp').controller('OnlineReserveController', OnlineReserveController);

    OnlineReserveController.$inject = ['$rootScope', '$scope', '$state', '$document', '$stateParams', '$sce', 'Log', 'PublicResource',
        'OnlineReservationContext'];

    // required to whitelist the Google Mpas URL to use in the iFrame
    angular.module('seatonApp').filter('trustAsResourceUrl', ['$sce', function ($sce) {
        return function (val) {
            return $sce.trustAsResourceUrl(val);
        };
    }]);

    function OnlineReserveController($rootScope, $scope, $state, $document, $stateParams, $sce, Log, PublicResource,
                                     OnlineReservationContext) {

        // INITIALIZE
        var vm = this;

        vm.DATE_FORMAT = 'YYYY-MM-DD';
        vm.DATE_PICKER_FORMAT = 'MMM D, YYYY';
        vm.TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
        vm.TIME_DISPLAY_FORMAT = 'hh:mmA';
        vm.MINMAX_PICKER_DATE_FORMAT = 'MM/DD/YYYY';
        vm.moment = moment;

        vm.productNotSelectedError = false;
        vm.todayPicker = vm.moment().format(vm.MINMAX_PICKER_DATE_FORMAT);
        vm.maxReservationDatePicker = "12/31/9999";
        vm.settings = null;
        vm.minPartySize = 1;
        vm.maxPartySize = 6;
        vm.seatOptions = [];
        vm.additionalSeatOptions = null;

        vm.selectedDay = vm.moment().format(vm.DATE_FORMAT);
        vm.selectedProductId = null;
        vm.availability = null;
        vm.datePicker = null;
        vm.productAlertDate = null;

        // function definition
        vm.init = init;
        vm.getReserveSettings = getReserveSettings;
        vm.initPicker = initPicker;
        vm.getAvailability = getAvailability;
        vm.filterByParams = filterByParams;
        vm.filterAvailability = filterAvailability;
        vm.calculateButtonColor = calculateButtonColor;
        vm.alternativeProduct = alternativeProduct;
        vm.onParametersChange = onParametersChange;
        vm.findProductById = findProductById;
        vm.proceedToContactPage = proceedToContactPage;
        vm.pickAPartySizeText = pickAPartySizeText;

        // initialize online reserve page
        vm.init();

        function init() {

            // check if location id parameter is present
            vm.hashedLocationId = OnlineReservationContext.getLocationId();
            Log.debug("OnlineReserveController", "Hashed locationId id is '" + vm.hashedLocationId + "'");
            if (!vm.hashedLocationId) {
                // if location id not defined abort and show fatal error message
                onError();
            } else {
                vm.request = OnlineReservationContext.getRequest(); // reservation request -> date, time & party_size, productId
                vm.channel = OnlineReservationContext.getChannel(); // channel

                //Log.debug("OnlineReserveController", "Params: locationId:" + vm.hashedLocationId +
                //    ", resRequest {date:" + vm.request.date + ", time:" + vm.request.time + ", party_size:" + vm.request.party_size +
                //", productId:" + vm.request.productId +" }, reference:"+vm.reference+", channel:" + vm.channel + ".");

                vm.numberOfPersons = vm.request.party_size;

                // if location id defined proceed with initialization
                getReserveSettings();
            }
        }


        function getReserveSettings() {

            PublicResource.getReserveSettings({
                hashedLocationId: vm.hashedLocationId,
                productId: vm.request.productId
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.settings = data;

                vm.formattedWebPageLink = addHttpPrefix(vm.settings.businessWebPage); // adds http: prefix if missing

                vm.settings.coordinate = encodeURIComponent(vm.settings.coordinate);
                OnlineReservationContext.storeSettings(vm.settings);

                if (vm.settings.maxReservationDate) {
                    vm.maxReservationDatePicker = moment(vm.settings.maxReservationDate, vm.DATE_FORMAT).format(vm.MINMAX_PICKER_DATE_FORMAT);
                }

                // generate party size list
                vm.minPartySize = vm.settings.minSeats;
                if ((vm.settings.maxSeats - vm.settings.minSeats + 1) > 8) {
                    vm.maxPartySize = vm.minPartySize + 7; /// 7 button fit on list
                    vm.additionalSeatOptions = [];
                    for (i = vm.maxPartySize + 1; i <= vm.settings.maxSeats; i++) {
                        vm.additionalSeatOptions.push({
                            id: i,
                            label: isBamboo() ? i + " BAMBOO BIRYANI" : i + " Persons"
                        });
                    }
                } else {
                    vm.maxPartySize = vm.settings.maxSeats;
                }

                for (var i = vm.minPartySize; i <= vm.maxPartySize; i++) {
                    vm.seatOptions.push(i);
                }

                // DEFAULT VALUES
                // date
                if (vm.request.date) {
                    vm.selectedDay = vm.request.date;
                } else {
                    vm.selectedDay = moment().format(vm.DATE_FORMAT); // today, always by default today will be choose as reservation date
                }
                vm.selectedDayFormatted = moment(vm.selectedDay, vm.DATE_FORMAT).format(vm.MINMAX_PICKER_DATE_FORMAT); // format to match date picker

                // time
                if (vm.request.time) {
                    vm.selectedTime = vm.request.time;
                } else {
                    vm.selectedTime = null;
                }

                // party size
                if (!vm.request.party_size) { // if party size not received outside
                    if (vm.settings.minSeats > vm.numberOfPersons) vm.numberOfPersons = vm.settings.minSeats;
                    else vm.numberOfPersons = 2;
                } else {
                    vm.numberOfPersons = parseInt(vm.request.party_size);
                }

                // default selected product id
                if (vm.settings.productChosenByGuest && vm.settings.productList) { // productList sent from server .. product activated
                    if (vm.request.productId) {
                        // productId received through input parameters
                        vm.selectedProductId = findProductById(vm.request.productId).id;
                    } else if (vm.settings.productType == 'PRODUCT' && vm.settings.productList.length > 0) {
                        vm.selectedProductId = vm.settings.productList[0].id;
                    } else if (vm.settings.productType == 'DURATION') {
                        // select third from the list if available, if not second, if not first, if not leave empty
                        if (vm.settings.productList.length > 2) {
                            vm.selectedProductId = vm.settings.productList[2].id;
                        } else if (vm.settings.productList.length > 1) {
                            vm.selectedProductId = vm.settings.productList[1].id;
                        } else if (vm.settings.productList.length > 0) {
                            vm.selectedProductId = vm.settings.productList[0].id;
                        }
                    }
                } else { // product not activated
                    vm.selectedProductId = null; // if product null server will decide about reservation product
                }
                vm.productNotSelectedError = false;

                //Log.debug("OnlineReserveController", " After initialization -> selectedDay:" + vm.selectedDay + ", selectedTime:" + vm.selectedTime
                //    + ", numberOfPersons:" + vm.numberOfPersons + ", selectedProductId:" + vm.selectedProductId +".");

                getAvailability();

                $document.ready(
                    function () {
                        //console.log('prije vm.initPicker(): ' + vm.selectedDay);
                        vm.selectedDayFormatted = moment(vm.selectedDay, vm.DATE_FORMAT).format(vm.MINMAX_PICKER_DATE_FORMAT);
                        vm.initPicker();
                    }
                );


            }
        }

        function onParametersChange() {
            getAvailability();
            vm.selectedDayFormatted = moment(vm.selectedDay, vm.DATE_FORMAT).format(vm.MINMAX_PICKER_DATE_FORMAT);
            //console.log('onParametersChange() vm.selectedDayFormatted: ' + vm.selectedDayFormatted);
            //vm.datePicker.val(vm.selectedDayFormatted);
            vm.initPicker();
        }

        function getAvailability() {

            vm.product = null; // if duration null server choose duration
            vm.productNotSelectedError = false;
            vm.productAlertDate = null;

            if (vm.settings.productChosenByGuest) {
                // product chosen by guest
                vm.product = findProductById(vm.selectedProductId);
                //Log.debug("OnlineReserveController", "Product found:" + JSON.stringify(vm.product));
                if (!vm.product) { // product not found report error
                    vm.productNotSelectedError = true;
                    return;
                }
                OnlineReservationContext.clearModifiers();
            }
            //console.log(vm.selectedDay + '  ' + vm.product.startDate + '  ' + vm.product.endDate);

            //check if selected date is between product start and end date - if it is not, change selected date to product start date and show alert
            if (vm.product != null && vm.product.startDate != null && vm.product.endDate != null) {
                if (moment(vm.selectedDay).isSameOrAfter(vm.product.startDate) && moment(vm.selectedDay).isSameOrBefore(vm.product.endDate)) {
                    //console.log('BETWEEN');
                    vm.productAlertDate = null;
                } else {
                    //console.log('NOT BETWEEN');
                    vm.productAlertDate = 'Date changed to ' + moment(vm.product.startDate).format('dddd, Do MMMM YYYY') + ' !';
                    if (!moment(vm.product.startDate).isSame(moment(vm.product.endDate)))
                        vm.productAlertDate += ' Available date range is from: ' + moment(vm.product.startDate).format('MMMM Do YYYY') + ' to ' + moment(vm.product.endDate).format('MMMM Do YYYY') + '.';
                    else vm.productAlertDate += ' Selected product available only at that date.';
                    vm.selectedDay = moment(vm.product.startDate).format(vm.DATE_FORMAT);

                }
            }

            /*if (vm.product != null) {
                Log.debug("OnlineReserveController", "Selected date:" + vm.selectedDay + ", selected number of persons:" + vm.numberOfPersons +
                    ", selected product {id:" + vm.product.id + ", name:"+vm.product.name+"}.");
            }else {
                Log.debug("OnlineReserveController","Selected date:" + vm.selectedDay + ", selected number of persons:" + vm.numberOfPersons + ", product: null.");
            }*/

            PublicResource.getReserveAvailability(
                {
                    hashedLocationId: vm.hashedLocationId
                }, {
                    requestedDate: vm.selectedDay,
                    requestedPerson: vm.numberOfPersons,
                    product: vm.product
                }, onSuccess, onError);


            function onSuccess(data, headers) {
                if (vm.product != null)
                    vm.seatingOptionIds = vm.product.seatingOptionIds;
                vm.availability = data;
            }

        }

        function checkIsDateInsideProductInterval(date, product) {
            if (date == null) return false;
            if (product != null && product.startDate != null && product.endDate != null) {
                if (moment(date).isSameOrAfter(product.startDate) && moment(date).isSameOrBefore(product.endDate)) {
                    //console.log('BETWEEN');
                    return true;
                }
            }
            return false;
        }

        function proceedToContactPage(containerId, selectedTime, containerName) {

            //Log.debug("OnlineCreateLegacyController",
            //    "Selected container id is " + containerId + ". selected timeslot is " + selectedTime);

            vm.selectedTime = selectedTime;
            vm.actionSubmitted = true;
            vm.inputErrorOccured = false;

            if (!vm.selectedTime || !vm.selectedDay) { // if time not selected report error
                vm.inputErrorOccured = true;
                vm.actionSubmitted = false;
                return;
            }

            vm.product = null; // if duration null server choose duration
            if (vm.settings.productChosenByGuest) {
                // product chosen by guest
                vm.product = findProductById(vm.selectedProductId);
                //Log.debug("OnlineCreateLegacyController", "Product found:"+JSON.stringify(vm.product));
                if (!vm.product) { // product not found report error
                    vm.actionSubmitted = false;
                    vm.inputErrorOccured = true;
                    return;
                }
            }

            var request = {
                date: vm.selectedDay,
                time: vm.selectedTime,
                containerId: containerId,
                containerName: containerName,
                party_size: vm.numberOfPersons,
                product: vm.product
            }
            OnlineReservationContext.storeRequest(request);
            OnlineReservationContext.storeReference("RESERVE");

            // if modifiers enabled on product open modifer screen, if not open contact details screen
            if (vm.product && vm.product.modifierEnabled) {
                $state.go("public.online.modifier");
            } else {
                $state.go("public.online.contact");
            }
        }


        function onError(error) {
            Log.debug("OnlineResereCreateController", "Unexpected error:" + error + ".");
            vm.actionSubmitted = false;
            OnlineReservationContext.storeReference("RESERVE");

            $state.go("public.online.error");
        };

        // initialize date & time picker
        function initPicker() {
            // init daterangepicker
            vm.datePicker = $('#daterangepicker1').daterangepicker({
                singleDatePicker: true,
                parentEl: "#daterangepicker1-container",
                autoApply: true,
                minDate: vm.todayPicker,
                maxDate: vm.maxReservationDatePicker,
                startDate: vm.selectedDayFormatted,
                locale: {
                    format: vm.MINMAX_PICKER_DATE_FORMAT
                }
            });

            // range update listener
            vm.datePicker.on('apply.daterangepicker', function (ev, picker) {
                vm.selectedDay = picker.startDate.format(vm.DATE_FORMAT);
                onParametersChange();
            });

            // prevent hide after range selection
            vm.datePicker.data('daterangepicker').hide = function () {
            };
            // show picker on load
            vm.datePicker.data('daterangepicker').show();

            // define value
            //TODO naci nacin kako pridodjeliti datum an daterangepicker
            //vm.datePicker.data('daterangepicker').setStartDate(vm.selectedDayFormatted);

        };

        function filterByParams(timeSlot) {

            // do not display if event exceed closing business hours
            if (vm.settings.productType != 'MEAL') {
                var selectedProduct = vm.product;
                if (!selectedProduct) selectedProduct = findProductById(vm.selectedProductId);
                //Log.debug("OnlineReserveCreateController", "Selected product:" + JSON.stringify(selectedProduct) + ".");
                if (selectedProduct && timeSlot.endWorkingTime) {

                    var endWorkingTime = moment(timeSlot.endWorkingTime, vm.TIME_SERVER_FORMAT);
                    var chosenTimeSlot = moment(timeSlot.time, vm.TIME_SERVER_FORMAT);
                    var endEventTime = moment(chosenTimeSlot).add(selectedProduct.duration - 1, 'minutes');
                    //Log.debug("OnlineReserveCreateController", "End time:" + endWorkingTime + ", chosen time slot:" + chosenTimeSlot + ", end event time:" + endEventTime + ".");

                    if (endEventTime.isAfter(endWorkingTime)) {
                        return false;
                    }
                }
            }

            if (timeSlot.availableCapacity >= vm.numberOfPersons && //  if available cover capacity greater than requested number of persons and
                (timeSlot.limit == -1 ||  // max allowed reservation per time slot not activated or
                    timeSlot.limit > timeSlot.actualAmount)) { //  number of event equal or higher then maximum allowed

                return true;
            }
            return false;
        }

        function filterAvailability(availability) {
            //console.log("filterAvailability:" + JSON.stringify(availability));
            if (vm.product == null) return true;

            //filtering of seating areas which have active DATES in OTHER products and have DEFINED AREAS
            if (vm.settings.productList) {
                for (var i = 0; i < vm.settings.productList.length; i++) {
                    if (vm.settings.productList[i].id != vm.product.id) {   //check only other products than selected
                        if (checkIsDateInsideProductInterval(vm.selectedDay, vm.settings.productList[i])) {
                            //check if selected seating area is in other product
                            if (vm.settings.productList[i].seatingOptionIds != null) {
                                var IdsArray = vm.settings.productList[i].seatingOptionIds.split(",");
                                if (IdsArray.includes('' + availability.id)) {
                                    //console.log("blocking by other product:" + vm.settings.productList[i].name + 'availability: ' + availability.name);
                                    return false;
                                }
                            }
                        }
                    }
                }
            }

            //filtering of seating areas which are NOT DEFINED in current product (if list of areas is empty show all)
            if (vm.product.seatingOptionIds == null) return true;
            if (vm.product.seatingOptionIds == '') return true; // if no seating areas are defined -> show all
            var IdsArray = vm.product.seatingOptionIds.split(",");
            if (IdsArray.includes('' + availability.id))
                return true;
            else {
                //console.log("blocking by SELECTED product: availability: " + availability.name);
                return false;
            }
        }

        function calculateButtonColor(treshold, timeSlot) {
            if ((timeSlot.availableCapacity / timeSlot.capacity * 100) < treshold) {
                return "btn-warning"
            }
            return "btn-success";
        }

        function alternativeProduct(productType) {
            if (productType == 'DURATION') {
                return " or duration"
            } else if (productType == 'PRODUCT') {
                return " or product"
            }
        }

        function findProductById(productId) {
            if (vm.settings.productList) {
                for (var i = 0; i < vm.settings.productList.length; i++) {
                    if (vm.settings.productList[i].id == productId)
                        return vm.settings.productList[i];
                }
            }
            // product not found for product id
            return null;
        }

        vm.encodeURL = function () {
            return encode
        }

        function pickAPartySizeText() {
            if (isBamboo()) return "NUMBER OF BAMBOO BIRYANI";
            return "PICK A PARTY SIZE";
        }

        function isBamboo() {
            if (vm.hashedLocationId == "7EDE32B8") return true;
            //if(vm.hashedLocationId=="7653B6E8") return true; // local test
            return false;
        }

        // if the web site does not start with 'http(s)' this function will add the prefix http://
        function addHttpPrefix(originalLink) {
            if (originalLink) {
                if (originalLink.startsWith('http')) {
                    return originalLink;
                } else {
                    return "http://" + originalLink;
                }
            } else {
                return originalLink;
            }
        }

    }

})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online.reservation', {
            parent: 'public.online',
            url: '/reservation/:locationId',
            data: {
                authorities: [],
                bodyClass: " transparent-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.online.reservation': {
                    templateUrl: 'app/public/online/reservation/proxy.html',
                    controller: 'OnlineProxyReservationController',
                    controllerAs: 'vm'
                },
                'navbar@public.online.reservation': {},
                'topnavbar@public.online.reservation': {}
            },
            params: {
            },

            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('seatonApp').controller('OnlineProxyReservationController', OnlineProxyReservationController);

    OnlineProxyReservationController.$inject = ['$state', '$stateParams', 'Log', 'PublicResource', 'OnlineReservationContext'];

    function OnlineProxyReservationController($state, $stateParams, Log, PublicResource, OnlineReservationContext) {

    // INITIALIZE
        var vm = this;

        OnlineReservationContext.clear();
        vm.locationId = $stateParams.locationId;
        Log.debug("OnlineProxyReservationController", "Hashed locationId id is '" + vm.locationId + "'");
        if (!vm.locationId) {
            // if location not defined abort and show fatal error message
            onError();
        } else {
            // if location id defined proceed with proxy initialization
            vm.queryParams = getQueryParams();
            PublicResource.getReservationPage({
                hashedLocationId: vm.locationId
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.reservationPage = data.reservationPage;
            vm.channel = getChannel();
            OnlineReservationContext.storeLocationChannelPage(vm.locationId, vm.channel, vm.reservationPage);

            var request = {
                date: vm.queryParams.date,
                time: vm.queryParams.time,
                party_size: vm.queryParams.party_size,
                productId: vm.queryParams.productId
            }
            OnlineReservationContext.storeRequest(request);
            OnlineReservationContext.storeReference("PROXY");

            Log.debug("OnlineProxyReservationController", "Page: " + vm.reservationPage + ", Params: locationId:" + vm.locationId +
                ", resRequest {date:" + request.date + ", time:" + request.time + ", party_size:" + request.party_size +
                ", productId:" + request.productId +" }, reference: PROXY, channel:" + vm.channel + ".");

            Log.debug("Local storage:"+OnlineReservationContext.getChannel());

            if("LEGACY" == vm.reservationPage) {
                $state.go("public.online.legacy");
            } else if ("RESERVE" == vm.reservationPage) {
                $state.go("public.online.reserve");
            } else {
                onError("Not recognized reservation page :"+vm.reservationPage+":");
            }
        }

        function onError(error) {
            Log.debug("OnlineProxyReservationController", "Unexpected error:" + error + ".");
            vm.actionSubmitted = false;

            $state.go("public.online.error");
        }

        //parse query parameters from URL (when coming from reservation widget)
        function getQueryParams() {
            var queryParams = {};
            var pairs = window.location.search.substring(1).split(/[&?]/);
            var i, pair;

            for (i = 0; i < pairs.length; i++) {
                pair = pairs[i].split('=');
                if (pair[1])
                    queryParams[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            }

            Log.debug("OnlineReservationCreate","Query params, date:"+queryParams.date+", time:"+queryParams.time
                +", party_size:"+queryParams.party_size+".");
            return queryParams;
        }

        // fetch reservation channel
        function getChannel() {
            var channel = vm.queryParams.channel;
            if (channel) {
                var channelUpper = channel.toUpperCase();
                if (channelUpper == "FACEBOOK" || channelUpper == "GOOGLE" || channelUpper == "MERCHANT_WEB") {
                    return channelUpper;
                }
            } else {
                var referrer = document.referrer;
                if (referrer) {
                    if (referrer.toUpperCase().indexOf("FACEBOOK") != -1) {
                        return "FACEBOOK";
                    } else if (referrer.toUpperCase().indexOf("GOOGLE") != -1) {
                        return "GOOGLE";
                    }
                }
            }
            return "MERCHANT_WEB"; // default
        }


    }

})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online.contact', {
            parent: 'public.online',
            url: '/contact',
            data: {
                authorities: [],
                bodyClass: " transparent-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.online.contact': {
                    templateUrl: 'app/public/online/contact/contact.html',
                    controller: 'OnlineContactController',
                    controllerAs: 'vm'
                },
                'navbar@public.online.contact': {},
                'topnavbar@public.online.contact': {}
            },
            params: {
            },

            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('seatonApp').controller('OnlineContactController', OnlineContactController);

    OnlineContactController.$inject = ['$rootScope', '$scope', '$state', '$document', '$stateParams', 'Log', 'PublicResource',
                                        'OnlineReservationContext', 'TextUtil'];

    function OnlineContactController($rootScope, $scope, $state, $document, $stateParams, Log, PublicResource,
                                     OnlineReservationContext, TextUtil) {

    // INITIALIZE
        var vm = this;
        vm.allowSMS = true;

        vm.DATE_FORMAT = 'YYYY-MM-DD';
        vm.TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
        vm.TIME_DISPLAY_FORMAT = 'hh:mmA';
        vm.moment = moment;

        vm.inputErrorOccured = false;
        vm.actionSubmitted = false;

        vm.resourceNotAvailableAnymore = false;
        vm.productChosenByGuest = false;
        vm.productList = [];

        vm.resourceText = TextUtil.translate("resource","s");

        // function definition
        vm.makeReservation = makeReservation;
        vm.inputNOK = inputNOK;
        vm.resetSecondPage = resetSecondPage;
        vm.secondPageActionButtonText = secondPageActionButtonText;
        vm.inputErrorOccurs = inputErrorOccurs;
        vm.reformatPhone = reformatPhone;
        vm.reschedule = reschedule;
        vm.setAndValidateParameters = setAndValidateParameters;

        // PARAMETERS AND SETTINGS
        vm.locationId = OnlineReservationContext.getLocationId();
        Log.debug("OnlineContactController", "Hashed locationId id is '" + vm.locationId + "'");
        if (!vm.locationId) {
            // if location id not return to reservation proxy
            $state.go("public.online.reservation");
        }
        vm.request = OnlineReservationContext.getRequest();
        vm.customer = OnlineReservationContext.getCustomer();
        vm.channel = OnlineReservationContext.getChannel();
        vm.reference = OnlineReservationContext.getReference();
        vm.reservationPage = OnlineReservationContext.getReservationPage();
        vm.settings = OnlineReservationContext.getSettings();
        vm.productModifiers = OnlineReservationContext.getProductModifiers();
        vm.fees = OnlineReservationContext.getFees();

        Log.debug("OnlineContactController",
            "Input params. Location id:" + vm.locationId
            + "; Request: " + JSON.stringify(vm.request)
            + "; Customer: " + JSON.stringify(vm.customer)
            + "; Channel: " + vm.channel
            + "; Reference: " + vm.reference
            + "; ReservationPage: " + vm.reservationPage
            + "; Settings: " + JSON.stringify(vm.settings)
        );

        vm.setAndValidateParameters();

        // set parameters
        function setAndValidateParameters() {

            if(!vm.channel || !vm.request || !vm.reference || !vm.settings || !vm.reservationPage) {
                Log.debug("OnlineContactController","One of parameter is not defined, go to first step in process.");

                // store new reference
                OnlineReservationContext.storeReference("CONTACT");

                $state.go("public.online.reservation");
                return;
            }

            vm.phoneRegion = vm.settings.phoneRegion;
            vm.phonePrefix = vm.settings.phonePrefix;
            vm.productChosenByGuest = vm.settings.productChosenByGuest;

            if(!vm.customer) vm.customer = {};

            var localeApp = 'en';
            if (vm.phoneRegion == 'US') {
                localeApp = 'en';
                $rootScope.currencyIcon = 'fa fa-dollar';
            } else if (vm.phoneRegion == 'GB') {
                localeApp = 'en-gb';
                $rootScope.currencyIcon = 'fa fa-gbp';
            } else if (vm.phoneRegion == 'IE') {
                localeApp = 'en-ie';
                $rootScope.currencyIcon = 'fa fa-euro';
            } else if (vm.phoneRegion == 'CA') {
                localeApp = 'en-ca';
                $rootScope.currencyIcon = 'fa fa-money';
            }

        };

        // make reservation or proceed to payment page if payment enabled
        function makeReservation(phoneValid) {

            if (vm.inputNOK(phoneValid)) {
                vm.inputErrorOccured = true;
                Log.debug("Input not ok");
                return;
            } else {
                vm.inputErrorOccured = false;
            }

            // disable create button, so that the user does not accidentally send two requests
            vm.actionSubmitted = true;

            Log.debug("OnlineContactController: Payment required " + paymentRequired() + ".","ONLINE Reservation");
            if(paymentRequired()) {

                var productId = null;
                if(vm.request.product) {
                    productId = vm.request.product.id;
                }
                PublicResource.getPaymentSettings(
                    {
                        hashedLocationId: vm.locationId
                    },
                    {
                        // reservation requested params
                        requestedDate: vm.request.date,
                        requestedTime: vm.request.time,
                        numberOfPersons: vm.request.party_size,
                        containerId: vm.request.containerId,
                        productId: productId,
                        productType: vm.settings.productType,
                        productModifierList: vm.productModifiers,
                        onlineFee: vm.fees
                    },
                    function (data) {
                        Log.debug("OnlineContactController","Public key fetch, status="+ data.status +": key="+data.key+":");
                        vm.actionSubmitted = false;
                        if(data.status<0) {
                            onError("Public key not fetched from Clover.");
                        } else {
                            vm.customer.occasion = 1;
                            OnlineReservationContext.storeCustomer(vm.customer);
                            OnlineReservationContext.storePaymentSettings(data);

                            // store new reference
                            OnlineReservationContext.storeReference("CONTACT");

                            if(!vm.fees) {
                                vm.fees = {
                                    serviceCharge: 0,
                                    reservation: data.totalAmount,
                                    totalWithoutServiceCharge: data.totalAmount,
                                    serviceChargeFee:0,
                                    total: data.totalAmount
                                };
                                OnlineReservationContext.storeFees(vm.fees);
                            }

                            // if payment enabled go to payment page
                            $state.go("public.online.payment");
                        }
                    },
                    onError
                );

            } else {
                // if payment not enabled complete reservation at this step
                PublicResource.prereserve(
                    {
                        hashedLocationId: vm.locationId
                    },
                    {
                        // reservation requested params
                        requestedDate: vm.request.date,
                        requestedTime: vm.request.time,
                        containerId: vm.request.containerId,
                        containerName: vm.request.containerName,
                        numberOfPersons: vm.request.party_size,
                        product: vm.request.product,
                        // other
                        productChosenByGuest: vm.settings.productChosenByGuest,
                        productType: vm.settings.productType,
                        // customer details
                        firstName: vm.customer.firstName,
                        lastName: vm.customer.lastName,
                        email: vm.customer.primaryEmail,
                        phone: vm.customer.primaryPhone,
                        note: vm.customer.note,
                        // other
                        channel: vm.channel,
                        occasion: 1
                    },
                    function (data) {

                        vm.resourceNotAvailableAnymore = data.resourceNotAvailable;
                        vm.actionSubmitted = false;

                        if (vm.resourceNotAvailableAnymore == false) {
                            OnlineReservationContext.storeCustomer(vm.customer);
                            OnlineReservationContext.storeVerificationSent(data.verificationSent);

                            // store new reference
                            OnlineReservationContext.storeReference("CONTACT");

                            $state.go("public.online.success");
                        }
                    },
                    onError
                );
            }
        };

        // validate second screen input
        function inputNOK (phoneValid) {
            var input =
                !(vm.request.party_size > 0) ||
                !vm.customer ||
                !vm.customer.firstName ||
                !vm.customer.lastName ||
                !vm.customer.primaryEmail ||
                !(vm.customer.primaryPhone && phoneValid);

            return input;
        };

        // reset second page form
        function resetSecondPage () {
            // workaround for https://github.com/angular/angular.js/issues/2743
            jQuery("input[name='primaryEmail']").val("");
            jQuery("input[name='primaryPhone']").val("");
            vm.customer = null;
            vm.inputErrorOccured = false;
        };

        // action button text depends on payment enabled
        function secondPageActionButtonText() {
            if(paymentRequired()) {
                return "Proceed to payment page";
            } else {
                return "Complete reservation";
            }
        };

        function paymentRequired() {
            if(vm.settings.enablePayment) {
                if(vm.settings.productType!='PRODUCT') return true;
                if(vm.request.product) {
                    var total = vm.request.product.fee;
                    if(vm.fees) {
                        total += vm.fees.total;
                    }
                    if(total>0) {
                        return true;
                    }
                } else {
                    return true;
                }
            }
            return false;
        }


    // HANDLE ERRORS

        function inputErrorOccurs () {
            return vm.inputErrorOccured;
        };

        function onError(error) {
            Log.debug("OnlineCreateLegacyController", "Unexpected error:" + error + ".");
            vm.actionSubmitted = false;

            // store new reference
            OnlineReservationContext.storeReference("CONTACT");

            $state.go("public.online.error");
        };


    // UTILS

        // format phone number
        function reformatPhone () {
            $scope.numInput = $document.find('#primaryPhone');
            if (typeof intlTelInputUtils !== 'undefined') {
                var currentText = $scope.numInput.intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
                if (typeof currentText === 'string') {
                    $scope.numInput.intlTelInput('setNumber', currentText);
                }
            }
        };

        function reschedule() {

            // store customer in case of any input
            OnlineReservationContext.storeCustomer(vm.customer);

            // store new reference
            OnlineReservationContext.storeReference("CONTACT");

            if("LEGACY" == vm.reservationPage) {
                $state.go("public.online.legacy");
            } else if("RESERVE" == vm.reservationPage){
                $state.go("public.online.reserve");
            } else {
                onError("Unknown reference value, expected LEGACY OR RESERVE, found:" + vm.reservationPage + ".")
            }
        }

    }

})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.online.modifier', {
            parent: 'public.online',
            url: '/modifier',
            data: {
                authorities: [],
                bodyClass: " transparent-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.online.modifier': {
                    templateUrl: 'app/public/online/modifier/modifier.html',
                    controller: 'OnlineModifierController',
                    controllerAs: 'vm'
                },
                'navbar@public.online.modifier': {},
                'topnavbar@public.online.modifier': {}
            },
            params: {
            },

            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('seatonApp').controller('OnlineModifierController', OnlineModifierController);

    OnlineModifierController.$inject = ['$rootScope', '$scope', '$state', '$document', '$stateParams', '$filter',
        'Log', 'PublicResource','OnlineReservationContext', 'TextUtil', 'Utils'];

    function OnlineModifierController($rootScope, $scope, $state, $document, $stateParams, $filter,
                                      Log, PublicResource, OnlineReservationContext, TextUtil, Utils) {

    // INITIALIZE
        var vm = this;
        vm.fees = {};
        vm.fees.serviceCharge = 20; // default service charge / tip fee
        vm.minimumModiferAmountError=false;

        vm.DATE_FORMAT = 'YYYY-MM-DD';
        vm.TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
        vm.TIME_DISPLAY_FORMAT = 'hh:mmA';
        vm.moment = moment;

        vm.inputErrorOccured = false;
        vm.actionSubmitted = false;

        //vm.resourceNotAvailableAnymore = false;
        //vm.productChosenByGuest = false;
        //vm.productList = [];

        vm.resourceText = TextUtil.translate("resource","s");

        // FUNCTIONS definition
        vm.minimumModifierAmountDefined = minimumModifierAmountDefined;
        vm.formatAmount = formatAmount;
        vm.reschedule = reschedule;
        vm.adjustModifierNumber = adjustModifierNumber;
        vm.isModifierListWithAddedNumberIsEmpty = isModifierListWithAddedNumberIsEmpty;
        vm.calculateReservationFee = calculateReservationFee;
        vm.calculateTotalModifierFee = calculateTotalModifierFee;
        vm.calculateServiceChargeFee = calculateServiceChargeFee;
        vm.calculateTotalFee = calculateTotalFee;
        vm.setServiceCharge = setServiceCharge;
        vm.clear = clear;
        vm.proceedToContactPage = proceedToContactPage;
        vm.serviceChargeAllowed = serviceChargeAllowed;
        vm.isBamboo = isBamboo;

        //vm.makeReservation = makeReservation;
        //vm.inputNOK = inputNOK;
        //vm.resetSecondPage = resetSecondPage;
        //vm.secondPageActionButtonText = secondPageActionButtonText;
        //vm.inputErrorOccurs = inputErrorOccurs;
        //vm.reformatPhone = reformatPhone;
        //vm.setAndValidateParameters = setAndValidateParameters;

        // PARAMETERS AND SETTINGS
        vm.locationId = OnlineReservationContext.getLocationId();
        Log.debug("OnlineContactController", "Hashed locationId id is '" + vm.locationId + "'");

        //if (!vm.locationId) {
        //    // if location id not return to reservation proxy
        //    $state.go("public.online.reservation");
        //}
        vm.request = OnlineReservationContext.getRequest();
        //vm.customer = OnlineReservationContext.getCustomer();
        //vm.channel = OnlineReservationContext.getChannel();
        vm.reference = OnlineReservationContext.getReference();
        vm.reservationPage = OnlineReservationContext.getReservationPage();
        vm.settings = OnlineReservationContext.getSettings();

        if(!serviceChargeAllowed()) vm.fees.serviceCharge = 0; // if service charge not allowed for product, set it to 0


        // fetch modifiers for chosen product
        PublicResource.getProductModifiers(
            {
                hashedLocationId: vm.locationId,
                productId: vm.request.product.id
            },
            function (data) {
                Log.debug("OnlineModifierController","ModifierList="+ JSON.stringify(data) + ":");
                vm.modifierList = data;
            },
            onError
        );

        // FUNCTIONS
        function proceedToContactPage() {

            // Bamboo specific, if number of party size not equals to number of specified modifiers
            if(isBamboo()) {
                if(vm.modifierList && calculateTotalModifierNumber()!=vm.request.party_size) {
                    return;
                }
            }

            if (vm.request.product.minModifierAmount > vm.fees.totalModifiers) {
                vm.minimumModiferAmountError=true;
            } else {
                vm.minimumModiferAmountError=false;
                // store data to context
                OnlineReservationContext.storeProductModifiers(vm.modifierList);
                OnlineReservationContext.storeFees(vm.fees);

                // go to state contact
                $state.go("public.online.contact");
            }
        }

        function adjustModifierNumber(index, number) {
            if(index>-1) {
                vm.modifierList[index].number += number;
                if(vm.modifierList[index].number<0) vm.modifierList[index].number = 0;
            }
        }

        function minimumModifierAmountDefined() {
            if(vm.request && vm.request.product) {
                if(vm.request.product.minModifierAmount > 0) {
                    return true;
                }
            }
            return false;
        }

        function serviceChargeAllowed() {
            if(vm.request && vm.request.product) {
                return vm.request.product.allowServiceCharge;

            }
            return false;
        }

        function formatAmount(amount) {
            if(!amount) amount = 0;
            return Utils.formatAmount(amount);
        }

        function isModifierListWithAddedNumberIsEmpty() {
            var found = false;
            if(vm.modifierList) {
                for(var i = 0; i < vm.modifierList.length; i++) {
                    if(vm.modifierList[i].number > 0) {
                        found = true; break;
                    }
                }
            }
            return found;
        }

        function findModifier(modifierId) {
            if(vm.modifierList) {
                for(var i = 0; i < vm.modifierList.length; i++) {
                    if(vm.modifierList[i].id === modifierId) {
                        return i;
                    }
                }
            }
            return -1;
        }

        function calculateReservationFee() {
            vm.fees.reservation = 0;
            if(vm.request.product.rule=="COVER") {
                vm.fees.reservation = vm.request.party_size * vm.request.product.fee;
            } else {
                vm.fees.reservation = vm.request.product.fee;
            }
            return vm.fees.reservation;
        }

        function calculateTotalModifierFee() {
            vm.fees.totalModifiers = 0;
            if(vm.modifierList) {
                for (var i = 0; i < vm.modifierList.length; i++) {
                    vm.fees.totalModifiers+= vm.modifierList[i].fee * vm.modifierList[i].number;
                }
            }
            if(vm.minimumModiferAmountError) {
                if(vm.request.product.minModifierAmount <= vm.fees.totalModifiers) {
                    vm.minimumModiferAmountError = false;
                }
            }
            return vm.fees.totalModifiers;
        }

        function calculateTotalWithoutServiceChargeFee() {
            vm.fees.totalWithoutServiceCharge = 0;
            if(vm.fees.reservation) vm.fees.totalWithoutServiceCharge+=vm.fees.reservation;
            if(vm.fees.totalModifiers) vm.fees.totalWithoutServiceCharge+=vm.fees.totalModifiers;
            return vm.fees.totalWithoutServiceCharge;
        }

        function calculateServiceChargeFee() {
            vm.fees.serviceChargeFee = calculateTotalWithoutServiceChargeFee() * vm.fees.serviceCharge/100;
            return vm.fees.serviceChargeFee;
        }

        function calculateTotalFee() {
            vm.fees.total = calculateTotalWithoutServiceChargeFee() + calculateServiceChargeFee();
            return vm.fees.total;
        }

        function setServiceCharge(serviceCharge) {
            vm.fees.serviceCharge = serviceCharge;
            Log.debug("","vm.fees.serviceCharge = "+vm.fees.serviceCharge+", serviceCharge="+serviceCharge);
        }

        function calculateTotalModifierNumber() {
            vm.totalModifiersNumber = 0;
            if(vm.modifierList) {
                for (var i = 0; i < vm.modifierList.length; i++) {
                    vm.totalModifiersNumber+=vm.modifierList[i].number;
                }
            }
            return vm.totalModifiersNumber;
        }

        function clear() {
            if(vm.modifierList) {
                for (var i = 0; i < vm.modifierList.length; i++) {
                    vm.modifierList[i].number = 0;
                }
            }
        }

        vm.serviceChargeOtherList = [
            {name: '50%', value: 50},
            {name: '45%', value: 45},
            {name: '40%', value: 40},
            {name: '35%', value: 35},
            {name: '30%', value: 30},
            {name: '10%', value: 10},
            {name: '5%', value: 5},
            {name: '0%', value: 0}
        ];

        function isBamboo() {
            if(vm.locationId=="7EDE32B8") return true;
            return false;
        }


        //vm.setAndValidateParameters();

        // set parameters
        function setAndValidateParameters() {

            if(!vm.channel || !vm.request || !vm.reference || !vm.settings || !vm.reservationPage) {
                Log.debug("OnlineContactController","One of parameter is not defined, go to first step in process.");

                // store new reference
                OnlineReservationContext.storeReference("CONTACT");

                $state.go("public.online.reservation");
                return;
            }

            vm.phoneRegion = vm.settings.phoneRegion;
            vm.phonePrefix = vm.settings.phonePrefix;
            vm.productChosenByGuest = vm.settings.productChosenByGuest;

            if(!vm.customer) vm.customer = {};

            var localeApp = 'en';
            if (vm.phoneRegion == 'US') {
                localeApp = 'en';
                $rootScope.currencyIcon = 'fa fa-dollar';
            } else if (vm.phoneRegion == 'GB') {
                localeApp = 'en-gb';
                $rootScope.currencyIcon = 'fa fa-gbp';
            } else if (vm.phoneRegion == 'IE') {
                localeApp = 'en-ie';
                $rootScope.currencyIcon = 'fa fa-euro';
            } else if (vm.phoneRegion == 'CA') {
                localeApp = 'en-ca';
                $rootScope.currencyIcon = 'fa fa-money';
            }

        };

        // make reservation or proceed to payment page if payment enabled
        function makeReservation(phoneValid) {

            if (vm.inputNOK(phoneValid)) {
                vm.inputErrorOccured = true;
                Log.debug("Input not ok");
                return;
            } else {
                vm.inputErrorOccured = false;
            }

            // disable create button, so that the user does not accidentally send two requests
            vm.actionSubmitted = true;

            Log.debug("OnlineContactController: Payment enabled " +vm.settings.enablePayment+ ".","ONLINE Reservation");
            if(vm.settings.enablePayment) {

                var productId = null;
                if(vm.request.product) {
                    productId = vm.request.product.id;
                }
                PublicResource.getPaymentSettings(
                    {
                        hashedLocationId: vm.locationId
                    },
                    {
                        // reservation requested params
                        requestedDate: vm.request.date,
                        requestedTime: vm.request.time,
                        numberOfPersons: vm.request.party_size,
                        containerId: vm.request.containerId,
                        productId: productId,
                        productType: vm.settings.productType
                    },
                    function (data) {
                        Log.debug("OnlineContactController","Public key fetch, status="+ data.status +": key="+data.key+":");
                        vm.actionSubmitted = false;
                        if(data.status<0) {
                            onError("Public key not fetched from Clover.");
                        } else {
                            vm.customer.occasion = 1;
                            OnlineReservationContext.storeCustomer(vm.customer);
                            OnlineReservationContext.storePaymentSettings(data);

                            // store new reference
                            OnlineReservationContext.storeReference("CONTACT");

                            // if payment enabled go to payment page
                            $state.go("public.online.payment");
                        }
                    },
                    onError
                );

            } else {
                // if payment not enabled complete reservation at this step
                PublicResource.prereserve(
                    {
                        hashedLocationId: vm.locationId
                    },
                    {
                        // reservation requested params
                        requestedDate: vm.request.date,
                        requestedTime: vm.request.time,
                        containerId: vm.request.containerId,
                        containerName: vm.request.containerName,
                        numberOfPersons: vm.request.party_size,
                        product: vm.request.product,
                        // other
                        productChosenByGuest: vm.settings.productChosenByGuest,
                        productType: vm.settings.productType,
                        // customer details
                        firstName: vm.customer.firstName,
                        lastName: vm.customer.lastName,
                        email: vm.customer.primaryEmail,
                        phone: vm.customer.primaryPhone,
                        note: vm.customer.note,
                        // other
                        channel: vm.channel,
                        occasion: 1
                    },
                    function (data) {

                        vm.resourceNotAvailableAnymore = data.resourceNotAvailable;
                        vm.actionSubmitted = false;

                        if (vm.resourceNotAvailableAnymore == false) {
                            OnlineReservationContext.storeCustomer(vm.customer);
                            OnlineReservationContext.storeVerificationSent(data.verificationSent);

                            // store new reference
                            OnlineReservationContext.storeReference("CONTACT");

                            $state.go("public.online.success");
                        }
                    },
                    onError
                );
            }
        };

        // validate second screen input
        function inputNOK (phoneValid) {
            var input =
                !(vm.request.party_size > 0) ||
                !vm.customer ||
                !vm.customer.firstName ||
                !vm.customer.lastName ||
                !vm.customer.primaryEmail ||
                !(vm.customer.primaryPhone && phoneValid);

            return input;
        };

        // reset second page form
        function resetSecondPage () {
            // workaround for https://github.com/angular/angular.js/issues/2743
            jQuery("input[name='primaryEmail']").val("");
            jQuery("input[name='primaryPhone']").val("");
            vm.customer = null;
            vm.inputErrorOccured = false;
        };

        // action button text depends on payment enabled
        function secondPageActionButtonText() {
            if(vm.settings.enablePayment) {
                return "Proceed to payment page"
            } else {
                return "Complete reservation";
            }
        };


    // HANDLE ERRORS

        function inputErrorOccurs () {
            return vm.inputErrorOccured;
        };

        function onError(error) {
            Log.debug("OnlineCreateLegacyController", "Unexpected error:" + error + ".");
            vm.actionSubmitted = false;

            // store new reference
            OnlineReservationContext.storeReference("CONTACT");

            $state.go("public.online.error");
        };


    // UTILS

        // format phone number
        function reformatPhone () {
            $scope.numInput = $document.find('#primaryPhone');
            if (typeof intlTelInputUtils !== 'undefined') {
                var currentText = $scope.numInput.intlTelInput("getNumber", intlTelInputUtils.numberFormat.INTERNATIONAL);
                if (typeof currentText === 'string') {
                    $scope.numInput.intlTelInput('setNumber', currentText);
                }
            }
        };

        function reschedule() {

            // store customer in case of any input
            OnlineReservationContext.storeCustomer(vm.customer);

            // store new reference
            OnlineReservationContext.storeReference("CONTACT");

            if("LEGACY" == vm.reservationPage) {
                $state.go("public.online.legacy");
            } else if("RESERVE" == vm.reservationPage){
                $state.go("public.online.reserve");
            } else {
                onError("Unknown reference value, expected LEGACY OR RESERVE, found:" + vm.reservationPage + ".")
            }
        }

    }

})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.setup', {
            parent: 'public',
            url: '/setup/:merchantId',
            data: {
                authorities: [],
                specialClass: " white-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.setup': {
                    templateUrl: 'app/public/setup/setup.html',
                    controller: 'SetupController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@public.cancel': {}
                //'footer@app': {
                //    templateUrl: 'app/layouts/footer/footer.html'
                //}

            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('public.setup');
                    //return $translate.refresh();
                }]
            }

        });
    }
})();

(function () {
    'use strict';
    angular.module('seatonApp').controller('SetupController', SetupController);

    SetupController.$inject = ['$rootScope', '$scope', '$state', '$document', '$stateParams', 'Log', 'PublicResource', 'TextUtil', 'ListUtils', 'SweetAlert'];

    function SetupController($rootScope, $scope, $state, $document, $stateParams, Log, PublicResource, TextUtil, ListUtils, SweetAlert) {

    // INITIALIZE
        var vm = this;

        vm.DATE_FORMAT = 'YYYY-MM-DD';
        vm.TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
        vm.TIME_DISPLAY_FORMAT = 'hh:mmA';
        vm.moment = moment;

        vm.availableTimes = ListUtils.getAvailableTimesForDay30MinStep();
        vm.availableTimesForDuration = ListUtils.getAvailableTimesForEventDuration();

        vm.setup = {};
        vm.setup.timeStep=30;
        vm.setup.minParty=1;
        vm.setup.maxParty=6;
        vm.setup.automationPolicy='PERFECT_MATCH_ONLY';
        vm.setup.reservationPage="RESERVE";
        vm.setup.breakfastName="Breakfast";
        vm.setup.breakfastEnd="11:00";
        vm.setup.breakfastDuration=45;
        vm.setup.lunchName="Lunch";
        vm.setup.lunchEnd="17:00";
        vm.setup.lunchDuration=90;
        vm.setup.dinnerName="Dinner";
        vm.setup.dinnerDuration=120;
        vm.setup.minDuration=30;
        vm.setup.maxDuration=4;
        vm.setup.timeSlotOption='SIMPLE';
        vm.setup.floorPlanOption='PICTURE';
        vm.setup.durationOption='MEAL';

        vm.setup.merchantId = $stateParams.merchantId;
        Log.debug("Setup", "merchantId:"+vm.setup.merchantId);

        vm.merchantNotDefined = function() {
            if(vm.setup.merchantId) return false;
            return true;
        }

        vm.submitQ = function() {

            PublicResource.submitQuestionnaire(
                {
                    setup: vm.setup
                }, onSuccess, onError);


            function onSuccess() {
                $state.go("public.setup.success")
            }

            function onError() {
                /*SweetAlert.swal({
                    html: true,
                    title: null,
                    text: "Error occurred. Please try again in few minutes or send us this questionnaire on email: support@seaton.site",
                    type: "error",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Close",
                    closeOnConfirm: false
                });*/

            }


        }

        vm.timeStepList = [
            {id: 15, name: '15 min'},
            {id: 30, name: '30 min'},
            {id: 60, name: '1 hour'},
            {id: 90, name: '1 hour 30 min'},
            {id: 120, name: '2 hours'}
        ];

        vm.partySize = [
            {id: 1, name: '1 persons'},
            {id: 2, name: '2 persons'},
            {id: 3, name: '3 persons'},
            {id: 4, name: '4 persons'},
            {id: 5, name: '5 persons'},
            {id: 6, name: '6 persons'},
            {id: 8, name: '8 persons'},
            {id: 10, name: '10 persons'},
            {id: 12, name: '12 persons'},
            {id: 14, name: '14 persons'},
            {id: 16, name: '16 persons'},
            {id: 20, name: '20 persons'},
            {id: 30, name: '30 persons'},
            {id: 40, name: '40 persons'},
            {id: 50, name: '50 persons'},
            {id: 100, name: '100 persons'}
        ];

        vm.automationStrategyList = [
            {id: 'NO_ASSIGNMENT', name: 'Manual assignment'},
            {id: 'PERFECT_MATCH_ONLY', name: 'Automatic assignment: Assign one table with matched number of seats, if not found leave unassigned.'},
            {id: 'PERFECT_MATCH_OR_BIGGER', name: 'Automatic assignment: Assign any table to accommodate request, if not found leave unassigned.'},
            {id: 'PERFECT_MATCH_OR_BIGGER_THEN_MERGE_ALL', name: 'Automatic assignment: Assign any table to accommodate request, if one is not sufficient merge more tables (in all Areas).'},
            {id: 'PERFECT_MATCH_OR_BIGGER_THEN_MERGE_SAME_AREA', name: 'Automatic assignment: Assign any table to accommodate request, if one is not sufficient merge more tables (only within same Area).'}
        ];

        vm.maxDurationList = [
            {id: 1, name: '1 hour'},
            {id: 2, name: '2 hours'},
            {id: 3, name: '3 hours'},
            {id: 4, name: '4 hours'},
            {id: 6, name: '6 hours'},
            {id: 12, name: '12 hours'},
            {id: 14, name: '24 hours'}
        ];

        vm.minDurationList = [
            {id: 15, name: '15 min'},
            {id: 30, name: '30 min'},
            {id: 60, name: '1 hour'},
            {id: 120, name: '2 hours'}
        ];



    }

})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public.setup.success', {
            parent: 'public.setup',
            url: '/success',
            data: {
                authorities: [],
                specialClass: " white-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/public_layout.html'
                },
                'content@public.setup.success': {
                    templateUrl: 'app/public/setup/success/success.html',
                    controller: 'SetupSuccessController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@public.cancel': {}
                //'footer@app': {
                //    templateUrl: 'app/layouts/footer/footer.html'
                //}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('SetupSuccessController', SetupSuccessController);

    SetupSuccessController.$inject = ['$scope', '$state', '$stateParams', 'Log', 'PublicResource'];

    function SetupSuccessController($scope, $state, $stateParams, Log, PublicResource) {

        var vm = this;

    }
})();




(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            abstract: true,
            parent: 'app',
            url: '/settings',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_OWNER', 'ROLE_MANAGER']
            },
            resolve: {
                googleChartApi: function (googleChartApiPromise) {
                    return googleChartApiPromise;
                }
            }
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.application', {
            parent: 'settings',
            url: '/application',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/application/application.html',
                    controller: 'ApplicationController',
                    controllerAs: 'vm'
                },
                'company@settings.application': {
                    templateUrl: 'app/settings/application/partials/company-view.html'
                },
                'general@settings.application': {
                    templateUrl: 'app/settings/application/partials/general.html'
                },
                'tables@settings.application': {
                    templateUrl: 'app/settings/application/partials/tables.html'
                },
                'notifications@settings.application': {
                    templateUrl: 'app/settings/application/partials/notifications.html'
                },
                'members@settings.application': {
                    templateUrl: 'app/settings/application/partials/members.html'
                },
                'meals@settings.application': {
                    templateUrl: 'app/settings/application/partials/meals.html'
                },
                'widget@settings.application': {
                    templateUrl: 'app/settings/application/partials/widget.html'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.application');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('ApplicationController', ApplicationController);

    ApplicationController.$inject = ['$scope', '$state'];

    function ApplicationController($scope, $state) {

        var vm = this;

        // slider
        $("#slider_meals").ionRangeSlider({
            type: 'double',
            min: 7,
            max: 23,
            from: 11.50,
            to: 18.00,
            postfix: "pm",
            prettify: true,
            grid: true,
            decorate_both: true,
            grid_snap: true
        });

        $("#slider_duration_breakfast").ionRangeSlider({
            min: 0,
            max: 240,
            step: 5,
            from: 45,
            grid: false,
            decorate_both: true,
            grid_snap: true,

            prettify: function (num) {
                return ((num/60) | 0) + ':' + num%60 +'h';
            }
        });

        $("#slider_duration_lunch").ionRangeSlider({
            min: 0,
            max: 240,
            step: 5,
            from: 75,
            grid: false,
            decorate_both: true,
            grid_snap: true,

            prettify: function (num) {
                return ((num/60) | 0) + ':' + num%60 +'h';
            }
        });

        $("#slider_duration_dinner").ionRangeSlider({
            min: 0,
            max: 240,
            step: 5,
            from: 120,
            grid: false,
            decorate_both: true,
            grid_snap: true,

            prettify: function (num) {
                return ((num/60) | 0) + ':' + num%60 +'h';
            }
        });

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.general', {
            parent: 'settings',
            url: '/general',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/general/general.html',
                    controller: 'GeneralController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('GeneralController', GeneralController);

    GeneralController.$inject = ['$scope', '$state', 'SettingsResource', 'Log', '$location', '$uibModal', '$document',
        'ApplicationContext', 'ListUtils', 'SweetAlert', 'Utils'];

    var DATE_FORMAT = 'YYYY-MM-DD';
    var TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
    var TIME_DISPLAY_FORMAT = 'HH:mm';
    var DATE_PICKER_FORMAT = 'MMM D, YYYY';

    function GeneralController($scope, $state, SettingsResource, Log, $location, $uibModal, $document,
                               ApplicationContext, ListUtils, SweetAlert, Utils) {

        var vm = this;
        vm.formatMinutes = Utils.formatMinutes;
        vm.formatAmount = Utils.formatAmount;
        vm.getAreasForProduct = getAreasForProduct;

        vm.currencySymbol = ApplicationContext.getCurrencySym();
        vm.ruleList = ListUtils.getPaymentRuleList();
        vm.availableTimes = ListUtils.getAvailableTimesForDay30MinStep();
        vm.availableTimesForDuration = ListUtils.getAvailableTimesForEventDuration();
        vm.maxDurationList = ListUtils.getMaxSimpleDurationList();
        vm.minDurationList = ListUtils.getMinSimpleDurationList();

        vm.meals = {};
        vm.productType = "DURATION";
        vm.productTypeOriginal = vm.productType;

        vm.isTableManaged = ApplicationContext.isTableManaged();

        vm.seatingOptionList = {};
        vm.timeSlotSetList = {};

        vm.filterFrom = null;
        vm.filterTo = null;
        vm.pickerModel = null;
        vm.custo = null;

        // get data
        //SettingsResource.getGeneralSettings({}, onSuccessGetData, onErrorGetData);

        SettingsResource.getProductSettings({}, onSuccessGetProductData);
        loadProductOptions();

        function onSuccessGetProductData(data, headers) {
            vm.productType = data.type;
            vm.productTypeOriginal = vm.productType;
            vm.meals = data.meal;
            vm.duration = data.duration;
            vm.productList = data.productList;
        }

        SettingsResource.getOnlineReservationCustomization({}, onSuccessCustomisationDto);

        function onSuccessCustomisationDto(data) {
            vm.custo = data;
            vm.custo.baseUrl = getBaseURL();
            //vm.hashedLocationId = data.hashedLocationId;
        }

        function getBaseURL() {
            var baseUrl = window.location.protocol + '//' + window.location.hostname;
            if (window.location.port) {
                baseUrl += ':' + window.location.port;
            }
            return baseUrl;
        }

        // change product type
        vm.changeProductType = function () {
            SweetAlert.swal({
                    title: "Confirm action",
                    text: "Do you want to change product definition to " + vm.productTypeDesc(vm.productType) + ".",
                    type: "warning",
                    showCancelButton: true,
                    cancelButtonColor: "#ec4758",
                    confirmButtonColor: "#1ab394",
                    cancelButtonText: "No",
                    confirmButtonText: "Yes",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        SettingsResource.changeProductType({productType: vm.productType}, onSuccessChange, onErrorChange);
                    } else {
                        vm.productType = vm.productTypeOriginal;
                    }
                });

            function onSuccessChange() {
                vm.productTypeOriginal = vm.productType;
                ApplicationContext.setProductType(vm.productType);
            }

            function onErrorChange() {
                vm.productType = vm.productTypeOriginal;
            }
        }

        // save meals settings
        vm.saveMealSettings = function () {
            SettingsResource.saveMealSettings(vm.meals);
        }

        // save meals settings
        vm.saveProduct = function () {
            vm.product.seatingOptionList = getSelectedSeatingOptions();
            if (vm.filterFrom != null) vm.product.startDate = moment(vm.filterFrom).format("YYYY-MM-DD");
            else vm.product.startDate = null;
            if (vm.filterTo != null) vm.product.endDate = moment(vm.filterTo).format("YYYY-MM-DD");
            else vm.product.endDate = null;
            SettingsResource.saveProduct(vm.product, onProductSaveSuccess);

            function onProductSaveSuccess(data) {
                vm.productList = data;
                vm.product = {};
                vm.filterFrom = null;
                vm.filterTo = null;
                vm.pickerDates.val('');
                vm.product.modifierEnabled = false;
                for (var i = 0; i < vm.seatingOptionList.length; i++)
                    vm.seatingOptionList[i].selected = false;
            }
        }

        function getSelectedSeatingOptions() {
            var selectedSeatingOptionList = [];

            if (vm.seatingOptionList) {
                for (var i = 0; i < vm.seatingOptionList.length; i++) {
                    if (vm.seatingOptionList[i].selected === true) {
                        selectedSeatingOptionList.push(vm.seatingOptionList[i]);
                    }
                }
            }
            return selectedSeatingOptionList;
        }

        function getAreasForProduct(seatingOptionIds) {
            var IdsArray = [];
            if (seatingOptionIds != null && seatingOptionIds != '')
                IdsArray = seatingOptionIds.split(",");

            var areas = '';
            for (var i = 0; i < vm.seatingOptionList.length; i++) {
                if (IdsArray.includes('' + vm.seatingOptionList[i].id))
                    areas = areas + ' ' + vm.seatingOptionList[i].name;
            }
            return areas;
        }

        vm.editProduct = function (product) {

            Log.debug("Product controller", "Product id " + product.id + ", production location_id " + product.locationId);

            var IdsArray = [];
            if (product.seatingOptionIds != null && product.seatingOptionIds != '')
                IdsArray = product.seatingOptionIds.split(",");

            for (var i = 0; i < vm.seatingOptionList.length; i++) {
                if (IdsArray.includes('' + vm.seatingOptionList[i].id))
                    vm.seatingOptionList[i].selected = true;
                else
                    vm.seatingOptionList[i].selected = false;
            }
            vm.product = product;
            vm.pickerDates.val('');
            if (vm.product.startDate != null) vm.filterFrom = moment(vm.product.startDate).startOf('day').toISOString();
            else vm.filterFrom = null;
            if (vm.product.endDate != null) vm.filterTo = moment(vm.product.endDate).startOf('day').toISOString();
            else vm.filterTo = null;
            updateDatePickerText();
        }

        //foreach seatingOptionList set attribute to selected if it is present in seatingOptionIds


        vm.deleteProduct = function (id) {
            SweetAlert.swal({
                    title: "Confirm product deletion",
                    text: "Do you want to delete product from settings?",
                    type: "warning",
                    showCancelButton: true,
                    cancelButtonColor: "#ec4758",
                    confirmButtonColor: "#1ab394",
                    cancelButtonText: "No",
                    confirmButtonText: "Yes",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        SettingsResource.deleteProduct({'id': id}, productListUpdate);
                    }
                });

        }

        function productListUpdate(data) {
            vm.productList = data;
        }

        // fetch areas and time set list
        function loadProductOptions() {
            SettingsResource.getSeatingOptionSettings({}, setPproductOptions);

            function setPproductOptions(data) {
                vm.seatingOptionList = data.seatingOptionList;
                vm.timeSlotSetList = data.timeSlotSetList;
            }
        }


        vm.saveDurationSettings = function () {
            SettingsResource.saveDurationSettings(vm.duration);
        }

        vm.reOrderProduct = function (sourceId, destinationId) {
            SettingsResource.reOrderProduct(
                {
                    sourceId: sourceId,
                    destinationId: destinationId
                }
                , productListUpdate
            )
        }

        // save meal duration data
        $scope.saveData = function () {

            if (angular.isDefined($scope.data.breakfastStart)) {

                if ($scope.data.breakfastStart.substring($scope.data.breakfastStart.length - 2, $scope.data.breakfastStart.length) == "am") {
                    if ($scope.data.breakfastStart == "12am") {
                        $scope.data.breakfastStart = "00:00";
                    } else if ($scope.data.breakfastStart == "12:30am") {
                        $scope.data.breakfastStart = "00:30";
                    } else {
                        $scope.data.breakfastStart = $scope.data.breakfastStart.substring(0, $scope.data.breakfastStart.length - 2);
                    }
                } else {
                    if ($scope.data.breakfastStart == "12pm") {
                        $scope.data.breakfastStart = "12:00";
                    } else if ($scope.data.breakfastStart == "12:30pm") {
                        $scope.data.breakfastStart = "12:30";
                    } else {
                        if ($scope.data.breakfastStart.substring(1, 3) == "pm") {
                            // 1pm
                            $scope.breakfastStart_temp = Number($scope.data.breakfastStart.substring(0, 1));
                            $scope.breakfastStart_temp = $scope.breakfastStart_temp + 12;
                            $scope.data.breakfastStart = $scope.breakfastStart_temp.toString() + ":00";
                        } else if ($scope.data.breakfastStart.substring(4, 6) == "pm") {
                            // 1:30pm
                            $scope.breakfastStart_temp = Number($scope.data.breakfastStart.substring(0, 1));
                            $scope.breakfastStart_temp = $scope.breakfastStart_temp + 12;
                            $scope.data.breakfastStart = $scope.breakfastStart_temp.toString() + ":30";
                        } else if ($scope.data.breakfastStart.substring(2, 4) == "pm") {
                            // 10pm
                            $scope.breakfastStart_temp = Number($scope.data.breakfastStart.substring(0, 2));
                            $scope.breakfastStart_temp = $scope.breakfastStart_temp + 12;
                            $scope.data.breakfastStart = $scope.breakfastStart_temp.toString() + ":00";
                        } else if ($scope.data.breakfastStart.substring(5, 7) == "pm") {
                            // 10:30pm
                            $scope.breakfastStart_temp = Number($scope.data.breakfastStart.substring(0, 2));
                            $scope.breakfastStart_temp = $scope.breakfastStart_temp + 12;
                            $scope.data.breakfastStart = $scope.breakfastStart_temp.toString() + ":30";
                        }
                    }
                }

            }
            if (angular.isDefined($scope.data.lunchStart)) {

                if ($scope.data.lunchStart.substring($scope.data.lunchStart.length - 2, $scope.data.lunchStart.length) == "am") {
                    if ($scope.data.lunchStart == "12am") {
                        $scope.data.lunchStart = "00:00";
                    } else if ($scope.data.lunchStart == "12:30am") {
                        $scope.data.lunchStart = "00:30";
                    } else {
                        $scope.data.lunchStart = $scope.data.lunchStart.substring(0, $scope.data.lunchStart.length - 2);
                    }
                } else {
                    if ($scope.data.lunchStart == "12pm") {
                        $scope.data.lunchStart = "12:00";
                    } else if ($scope.data.lunchStart == "12:30pm") {
                        $scope.data.lunchStart = "12:30";
                    } else {
                        if ($scope.data.lunchStart.substring(1, 3) == "pm") {
                            // 1pm
                            $scope.lunchStart_temp = Number($scope.data.lunchStart.substring(0, 1));
                            $scope.lunchStart_temp = $scope.lunchStart_temp + 12;
                            $scope.data.lunchStart = $scope.lunchStart_temp.toString() + ":00";
                        } else if ($scope.data.lunchStart.substring(4, 6) == "pm") {
                            // 1:30pm
                            $scope.lunchStart_temp = Number($scope.data.lunchStart.substring(0, 1));
                            $scope.lunchStart_temp = $scope.lunchStart_temp + 12;
                            $scope.data.lunchStart = $scope.lunchStart_temp.toString() + ":30";
                        } else if ($scope.data.lunchStart.substring(2, 4) == "pm") {
                            // 10pm
                            $scope.lunchStart_temp = Number($scope.data.lunchStart.substring(0, 2));
                            $scope.lunchStart_temp = $scope.lunchStart_temp + 12;
                            $scope.data.lunchStart = $scope.lunchStart_temp.toString() + ":00";
                        } else if ($scope.data.lunchStart.substring(5, 7) == "pm") {
                            // 10:30pm
                            $scope.lunchStart_temp = Number($scope.data.lunchStart.substring(0, 2));
                            $scope.lunchStart_temp = $scope.lunchStart_temp + 12;
                            $scope.data.lunchStart = $scope.lunchStart_temp.toString() + ":30";
                        }
                    }
                }

            }
            if (angular.isDefined($scope.data.dinnerStart)) {

                if ($scope.data.dinnerStart.substring($scope.data.dinnerStart.length - 2, $scope.data.dinnerStart.length) == "am") {
                    if ($scope.data.dinnerStart == "12am") {
                        $scope.data.dinnerStart = "00:00";
                    } else if ($scope.data.dinnerStart == "12:30am") {
                        $scope.data.dinnerStart = "00:30";
                    } else {
                        $scope.data.dinnerStart = $scope.data.dinnerStart.substring(0, $scope.data.dinnerStart.length - 2);
                    }
                } else {
                    if ($scope.data.dinnerStart == "12pm") {
                        $scope.data.dinnerStart = "12:00";
                    } else if ($scope.data.dinnerStart == "12:30pm") {
                        $scope.data.dinnerStart = "12:30";
                    } else {
                        if ($scope.data.dinnerStart.substring(1, 3) == "pm") {
                            // 1pm
                            $scope.dinnerStart_temp = Number($scope.data.dinnerStart.substring(0, 1));
                            $scope.dinnerStart_temp = $scope.dinnerStart_temp + 12;
                            $scope.data.dinnerStart = $scope.dinnerStart_temp.toString() + ":00";
                        } else if ($scope.data.dinnerStart.substring(4, 6) == "pm") {
                            // 1:30pm
                            $scope.dinnerStart_temp = Number($scope.data.dinnerStart.substring(0, 1));
                            $scope.dinnerStart_temp = $scope.dinnerStart_temp + 12;
                            $scope.data.dinnerStart = $scope.dinnerStart_temp.toString() + ":30";
                        } else if ($scope.data.dinnerStart.substring(2, 4) == "pm") {
                            // 10pm
                            $scope.dinnerStart_temp = Number($scope.data.dinnerStart.substring(0, 2));
                            $scope.dinnerStart_temp = $scope.dinnerStart_temp + 12;
                            $scope.data.dinnerStart = $scope.dinnerStart_temp.toString() + ":00";
                        } else if ($scope.data.dinnerStart.substring(5, 7) == "pm") {
                            // 10:30pm
                            $scope.dinnerStart_temp = Number($scope.data.dinnerStart.substring(0, 2));
                            $scope.dinnerStart_temp = $scope.dinnerStart_temp + 12;
                            $scope.data.dinnerStart = $scope.dinnerStart_temp.toString() + ":30";
                        }
                    }
                }

            }
            if (angular.isDefined($scope.data.dinnerEnd)) {

                if ($scope.data.dinnerEnd.substring($scope.data.dinnerEnd.length - 2, $scope.data.dinnerEnd.length) == "am") {
                    if ($scope.data.dinnerEnd == "12am") {
                        $scope.data.dinnerEnd = "00:00";
                    } else if ($scope.data.dinnerEnd == "12:30am") {
                        $scope.data.dinnerEnd = "00:30";
                    } else {
                        $scope.data.dinnerEnd = $scope.data.dinnerEnd.substring(0, $scope.data.dinnerEnd.length - 2);
                    }
                } else {
                    if ($scope.data.dinnerEnd == "12pm") {
                        $scope.data.dinnerEnd = "12:00";
                    } else if ($scope.data.dinnerEnd == "12:30pm") {
                        $scope.data.dinnerEnd = "12:30";
                    } else {
                        if ($scope.data.dinnerEnd.substring(1, 3) == "pm") {
                            // 1pm
                            $scope.dinnerEnd_temp = Number($scope.data.dinnerEnd.substring(0, 1));
                            $scope.dinnerEnd_temp = $scope.dinnerEnd_temp + 12;
                            $scope.data.dinnerEnd = $scope.dinnerEnd_temp.toString() + ":00";
                        } else if ($scope.data.dinnerEnd.substring(4, 6) == "pm") {
                            // 1:30pm
                            $scope.dinnerEnd_temp = Number($scope.data.dinnerEnd.substring(0, 1));
                            $scope.dinnerEnd_temp = $scope.dinnerEnd_temp + 12;
                            $scope.data.dinnerEnd = $scope.dinnerEnd_temp.toString() + ":30";
                        } else if ($scope.data.dinnerEnd.substring(2, 4) == "pm") {
                            // 10pm
                            $scope.dinnerEnd_temp = Number($scope.data.dinnerEnd.substring(0, 2));
                            $scope.dinnerEnd_temp = $scope.dinnerEnd_temp + 12;
                            $scope.data.dinnerEnd = $scope.dinnerEnd_temp.toString() + ":00";
                        } else if ($scope.data.dinnerEnd.substring(5, 7) == "pm") {
                            // 10:30pm
                            $scope.dinnerEnd_temp = Number($scope.data.dinnerEnd.substring(0, 2));
                            $scope.dinnerEnd_temp = $scope.dinnerEnd_temp + 12;
                            $scope.data.dinnerEnd = $scope.dinnerEnd_temp.toString() + ":30";
                        }
                    }
                }

            }

            console.log('save data', $scope.data);

            SettingsResource.saveGeneralSettings($scope.data, onSuccessGetData, onErrorGetData);
        }

        $scope.endTimeChanged = function (type) {
            if (moment(vm.meals.lunchEnd, TIME_DISPLAY_FORMAT).isBefore(moment(vm.meals.breakfastEnd, TIME_DISPLAY_FORMAT))) {
                Log.debug("ProductController", "Lunch end " + vm.meals.lunchEnd + " is before lunch start " + vm.meals.breakfastEnd + ".");
                vm.meals.lunchEnd = vm.meals.breakfastEnd;
            }
        }

        vm.productTypeDesc = function (type) {
            if (type == "MEAL") return "Standard products depending on time of day (e.g. Breakfast, Lunch, Dinner)";
            else if (type == "DURATION") return "Simple duration list";
            else if (type == "PRODUCT") return "Product list";
            else return "Undefined";
        }

        $scope.availablePeriods = [
            {period: "1 day", periodForDB: 1},
            {period: "2 days", periodForDB: 2},
            {period: "3 days", periodForDB: 3},
            {period: "5 days", periodForDB: 5},
            {period: "1 week", periodForDB: 7},
            {period: "2 weeks", periodForDB: 14},
            {period: "3 weeks", periodForDB: 21},
            {period: "1 month", periodForDB: 30},
            {period: "2 months", periodForDB: 60},
            {period: "3 months", periodForDB: 90},
            {period: "6 months", periodForDB: 180}
        ];


        vm.showProductModifers = function (product) {
            vm.selectedProduct = product; // save product

            vm.modifier = {};
            vm.modifier.productId = vm.selectedProduct.id;
            vm.minModifierAmount = product.minModifierAmount;
            vm.allowServiceCharge = product.allowServiceCharge;

            SettingsResource.getProductModifierList({productId: vm.modifier.productId}, productModifierListUpdate);

            vm.productModifers = $uibModal.open({
                templateUrl: 'app/settings/general/product_modifiers.html',
                scope: $scope,
                size: 'lg'
            });
        }

        $scope.closeProductModifersDialog = function () {
            vm.productModifers.dismiss('cancel');
            vm.modifier = {};
            vm.minModifierAmount = 0;
        }

        $scope.saveModifierSettings = function (productId, minModifierAmount, allowServiceCharge) {
            SettingsResource.saveModifierSettings(
                {
                    productId: vm.selectedProduct.id,
                    minModifierAmount: minModifierAmount,
                    allowServiceCharge: allowServiceCharge
                },
                productListUpdate);
        }

        $scope.saveProductModifier = function () {
            vm.modifier.productId = vm.selectedProduct.id;
            SettingsResource.saveProductModifier(vm.modifier, productModifierListUpdate);
            vm.modifier = {};
        }

        $scope.reOrderProductModifiers = function (sourceId, destinationId) {
            SettingsResource.reOrderProductModifier(
                {
                    sourceId: sourceId,
                    destinationId: destinationId
                }
                , productModifierListUpdate
            )
        }

        $scope.editProductModifier = function (modifier) {
            vm.modifier = modifier;
        }

        $scope.deleteProductModifier = function (productModifierId) {
            SweetAlert.swal({
                    title: "Confirm product modifier deletion",
                    text: "Do you want to delete product modifier?",
                    type: "warning",
                    showCancelButton: true,
                    cancelButtonColor: "#ec4758",
                    confirmButtonColor: "#1ab394",
                    cancelButtonText: "No",
                    confirmButtonText: "Yes",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        SettingsResource.deleteProductModifier({'productModifierId': productModifierId}, productModifierListUpdate);
                    }
                });

        }

        function productModifierListUpdate(data) {
            vm.productModifierList = data;
        }


        // initialize date picker
        $document.ready(
            function () {
                vm.pickerDates = $document.find('input[name="pickerDates"]');
                vm.pickerDates.daterangepicker(
                    {
                        showDropdowns: true,
                        autoApply: true,
                        autoUpdateInput: false,
                        alwaysShowCalendars: true,
                        locale: {format: 'MMM D, YYYY'}
                    },
                    function (start, end, label) {
                        vm.filterFrom = moment(start).toISOString();
                        vm.filterTo = moment(end).toISOString();
                        updateDatePickerText();
                        $scope.$apply(); // to propagate model changes to angular
                    }
                );
                updateDatePickerText();
            }
        );

        vm.openPicker = function () {
            vm.pickerDates.focus();
        }

        vm.checkPicker = function () {
            if (vm.pickerModel == null || vm.pickerModel == '') {
                console.log('checkPicker - clear');
                vm.filterFrom = null;
                vm.filterTo = null;
                updateDatePickerText();
            }
        }

        function updateDatePickerText() {
            if (vm.filterFrom && vm.filterTo) {
                vm.pickerDates.val(moment(vm.filterFrom).format('MMM D, YYYY') + ' - ' + moment(vm.filterTo).format('MMM D, YYYY'));
            } else {
                vm.pickerDates.val('');
            }
        }

        vm.copyToClipboard = function (elementId) {
            var copyText = document.getElementById(elementId);
            copyText.disabled = false;
            copyText.select();
            document.execCommand("Copy");
            copyText.disabled = true;
        }

        vm.copyToClipboardNavigator = function (startDate, productId) {
            var datePar = 'date=' + startDate + '&';
            if(startDate =='' || startDate == null) datePar='';
            var text = vm.custo.baseUrl + '?'+datePar+'productId=' + productId + '&channel=merchant_web#/public/online/reservation/' + vm.custo.hashedLocationId;
            console.log('url:' + text);

            navigator.clipboard.writeText(text).then(function () {
                console.log('Text successfully copied to clipboard');
            })
                .catch(function (err) {
                    console.error('Failed to copy text: ', err);
                });
        }


    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.worktime', {
            parent: 'settings',
            url: '/worktime',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/worktime/worktime.html',
                    controller: 'WorkTimeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.worktime');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('WorkTimeController', WorkTimeController);

    WorkTimeController.$inject = ['$scope', '$state', 'SettingsResource', 'Log', '$location', '$uibModal', '$document',
        'Notification', 'SweetAlert'];

    var DATE_FORMAT = 'YYYY-MM-DD';
    var TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
    var TIME_DISPLAY_FORMAT = 'hh:mmA';
    var DATE_PICKER_FORMAT = 'MMM D, YYYY';

    function WorkTimeController($scope, $state, SettingsResource, Log, $location, $uibModal, $document, Notification, SweetAlert) {

        var vm = this;
        vm.synchronizeWithClover = true;
        vm.monday = null;
        vm.tuesday = null;
        vm.wednesday = null;
        vm.thursday = null;
        vm.friday = null;
        vm.saturday = null;
        vm.sunday = null;
        vm.nonworkingDays = null;

        vm.fromTime = -1;
        vm.toTime=-1;
        vm.specialDateFromTime = -1;
        vm.specialDateToTime = -1;

        vm.selectedDay = moment.now();
        vm.bookingTime = -1;


        // initialize date & time picker
        $document.ready(
            function () {
                // date picker
                vm.datePicker = $document.find('input[name="datePicker"]');
                vm.datePicker.daterangepicker(
                    {
                        singleDatePicker: true,
                        showDropdowns: true,
                        locale: {format: DATE_PICKER_FORMAT}
                    },
                    function (start, end, label) {
                        vm.selectedDay = start.format(DATE_FORMAT);
                        vm.selectedDayFormatted = moment(vm.selectedDay, DATE_FORMAT).format(DATE_PICKER_FORMAT);
                    }
                );
                vm.datePicker.val(vm.selectedDayFormatted);
            }
        );

        $scope.openDatePicker = function () {
            vm.datePicker.focus();
        }


        // get data
        SettingsResource.getWorkTimeSettings({}, onSuccessGetData, onErrorGetData);

        function onSuccessGetData(data, headers) {

            $scope.data = data;
            vm.synchronizeWithClover = data.syncWithClover;

            vm.monday = data.monday;
            vm.tuesday = data.tuesday;
            vm.wednesday = data.wednesday;
            vm.thursday = data.thursday;
            vm.friday = data.friday;
            vm.saturday = data.saturday;
            vm.sunday = data.sunday;
            vm.nonworkingDays = data.nonWorkingDays;
            vm.enableTimeSlots = data.enableTimeSlots;
            vm.sameForAllWeekDays = data.sameForAllWeekDays;
            vm.mondaySlots = data.mondaySlots;
            vm.tuesdaySlots = data.tuesdaySlots;
            vm.wednesdaySlots = data.wednesdaySlots;
            vm.thursdaySlots = data.thursdaySlots;
            vm.fridaySlots = data.fridaySlots;
            vm.saturdaySlots = data.saturdaySlots;
            vm.sundaySlots = data.sundaySlots;
            vm.weekSlots = data.weekSlots;
            vm.specialDays = data.specialDays;

            Log.debug("WorkTimeController", "HTTP request succeed.");
        }

        function onErrorGetData(error) {
            Log.debug("WorkTimeController", "HTTP request error." + error);
        }


        // sync Clover changed
        $scope.syncCloverChanged = function() {
            if(vm.synchronizeWithClover) {
                vm.warningText = "Do you want to enable synchronization with Clover and use business hours defined in Clover system?"
            } else {
                vm.warningText = "Do you want to disable business hours synchronization with Clover?"
            }
            SweetAlert.swal({
                    title: "Confirm action",
                    text: vm.warningText,
                    type: "warning",
                    showCancelButton: true,
                    cancelButtonColor: "#ec4758",
                    confirmButtonColor: "#1ab394",
                    cancelButtonText: "No",
                    confirmButtonText: "Yes",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        SettingsResource.syncWithClover({syncClover: vm.synchronizeWithClover}, onSuccessGetData, onErrorGetData);
                    } else {
                        vm.synchronizeWithClover = !vm.synchronizeWithClover;
                    }
                });

        }

        // add working hours
        $scope.addWorkingHours = function(dayOfTheWeek) {
            Log.debug("WorkTimeController", " Adding business hours with parameters:" + "Day="+dayOfTheWeek+" from="+vm.fromTime+" to="+vm.toTime);

            var valid = validateBusinessHourInput(dayOfTheWeek, vm.fromTime, vm.toTime);
            if(valid) {
                var business_hours = {
                    day: dayOfTheWeek,
                    fromHour: vm.fromTime,
                    endHour: vm.toTime
                }

                SettingsResource.addBusinessHours(business_hours, onSuccessGetData, onErrorGetData);

                vm.fromTime = -1;
                vm.toTime = -1;
            }
        }


        // add special day working hours
        $scope.addSpecialDayWorkingHours = function(dayOfTheWeek) {
            Log.debug("WorkTimeController", " Adding special date business hours with parameters:" +
                "Date="+vm.selectedDay+" from="+vm.specialDateFromTime+" to="+vm.specialDateToTime+" description="+vm.specialDateDescription);

            var valid = validateBusinessHourInput(dayOfTheWeek, vm.specialDateFromTime, vm.specialDateToTime);
            if(valid) {
                var business_hours = {
                    day: dayOfTheWeek,
                    specialDate: vm.selectedDay,
                    description: vm.specialDateDescription,
                    fromHour: vm.specialDateFromTime,
                    endHour: vm.specialDateToTime
                }

                SettingsResource.addSpecialDayWorkingHours(business_hours, onSuccessGetData, onErrorGetData);

                vm.specialDateFromTime = -1;
                vm.specialDateToTime = -1;
            }
        }


        // add non working day
        $scope.addNonWorkingDay = function() {
            console.log("Day="+vm.selectedDay+" description="+vm.description);

            var non_working_day = {
                nonWorkingDay: vm.selectedDay,
                description: vm.description
            }

                SettingsResource.addNonWorkingDay(non_working_day, onSuccessGetData, onErrorGetData);

                vm.description = null;
                vm.selectedDay = moment.now();
                vm.selectedDayFormatted = moment(vm.selectedDay).format(DATE_PICKER_FORMAT);
                vm.datePicker.val(vm.selectedDayFormatted);

        }

        function validateBusinessHourInput(dayOfTheWeek, fromTime, toTime) {
            var a_start = moment(fromTime, "HH:mm");
            if(toTime=='00:00') toTime='23:59';
            var a_end = moment(toTime, "HH:mm");
            if (a_start >= a_end) { // from has to smaller than to
                //vm.fromHigher = true;
                Notification.showAlert("error", "End (field To) of business hours is before or same as start (field From)!");
                return false;
            }

            /*var overlap = false;
            if (dayOfTheWeek == 1) {
                overlaps = overlaps(a_start, a_end, vm.monday);
            }

            if(overlap) {
                vm.overlaps = true;
                return false;
            }*/

            return true;
        }

        function overlaps(a_start, a_end, day) {
            // check overlap times
            for(var busHours in day) {
                console.log("BusHours from:"+busHours.fromHour+" to:"+busHours.endHour);
                var b_start = moment(busHours.fromHour12, "hh:mm a");
                var b_end = moment(busHours.endHour12, "hh:mm a")-1;
                console.log("Range Defined b_start:"+b_start+" b_end:"+b_end);

                if ((a_start<=b_start && b_start<= a_end) ||  // b starts in a
                        (a_start<=b_end && b_end<= a_end) || // b ends in a
                            (b_start<a_start && a_end<b_end)) {
                    return true;
                }
            }

            return false;
        }

        // deleteBusinessHours
        $scope.deleteWorkingHours = function(businessHourId) {
            console.log("Delete business hours with id:"+businessHourId);
            SettingsResource.deleteBusinessHours({id: businessHourId}, onSuccessGetData, onErrorGetData);
        }

        $scope.deleteNonWorkingDay = function(nonWorkingDayId) {
            console.log("Delete non working day with id:"+nonWorkingDayId);
            SettingsResource.deleteNonWorkingDay({id: nonWorkingDayId}, onSuccessGetData, onErrorGetData);

        }

        $scope.isClosed = function(day) {
            if(Array.isArray(day) && day.length) return false;
            else return true;
        }

        $scope.formatDateForDisplay = function(dateToFormat) {
            return moment(dateToFormat, DATE_FORMAT).format(DATE_PICKER_FORMAT);
        }

        $scope.availableTimes = [
            {time: "12:00 AM", timeForDB: "00:00"},
            {time: "12:15 AM", timeForDB: "00:15"},
            {time: "12:30 AM", timeForDB: "00:30"},
            {time: "12:45 AM", timeForDB: "00:45"},
            {time: "1:00 AM", timeForDB: "01:00"},
            {time: "1:15 AM", timeForDB: "01:15"},
            {time: "1:30 AM", timeForDB: "01:30"},
            {time: "1:45 AM", timeForDB: "01:45"},
            {time: "2:00 AM", timeForDB: "02:00"},
            {time: "2:15 AM", timeForDB: "02:15"},
            {time: "2:30 AM", timeForDB: "02:30"},
            {time: "2:45 AM", timeForDB: "02:45"},
            {time: "3:00 AM", timeForDB: "03:00"},
            {time: "3:15 AM", timeForDB: "03:15"},
            {time: "3:30 AM", timeForDB: "03:30"},
            {time: "3:45 AM", timeForDB: "03:45"},
            {time: "4:00 AM", timeForDB: "04:00"},
            {time: "4:15 AM", timeForDB: "04:15"},
            {time: "4:30 AM", timeForDB: "04:30"},
            {time: "4:45 AM", timeForDB: "04:45"},
            {time: "5:00 AM", timeForDB: "05:00"},
            {time: "5:15 AM", timeForDB: "05:15"},
            {time: "5:30 AM", timeForDB: "05:30"},
            {time: "5:45 AM", timeForDB: "05:45"},
            {time: "6:00 AM", timeForDB: "06:00"},
            {time: "6:15 AM", timeForDB: "06:15"},
            {time: "6:30 AM", timeForDB: "06:30"},
            {time: "6:45 AM", timeForDB: "06:45"},
            {time: "7:00 AM", timeForDB: "07:00"},
            {time: "7:15 AM", timeForDB: "07:15"},
            {time: "7:30 AM", timeForDB: "07:30"},
            {time: "7:45 AM", timeForDB: "07:45"},
            {time: "8:00 AM", timeForDB: "08:00"},
            {time: "8:15 AM", timeForDB: "08:15"},
            {time: "8:30 AM", timeForDB: "08:30"},
            {time: "8:45 AM", timeForDB: "08:45"},
            {time: "9:00 AM", timeForDB: "09:00"},
            {time: "9:15 AM", timeForDB: "09:15"},
            {time: "9:30 AM", timeForDB: "09:30"},
            {time: "9:45 AM", timeForDB: "09:45"},
            {time: "10:00 AM", timeForDB: "10:00"},
            {time: "10:15 AM", timeForDB: "10:15"},
            {time: "10:30 AM", timeForDB: "10:30"},
            {time: "10:45 AM", timeForDB: "10:45"},
            {time: "11:00 AM", timeForDB: "11:00"},
            {time: "11:15 AM", timeForDB: "11:15"},
            {time: "11:30 AM", timeForDB: "11:30"},
            {time: "11:45 AM", timeForDB: "11:45"},
            {time: "12:00 PM", timeForDB: "12:00"},
            {time: "12:15 PM", timeForDB: "12:15"},
            {time: "12:30 PM", timeForDB: "12:30"},
            {time: "12:45 PM", timeForDB: "12:45"},
            {time: "1:00 PM", timeForDB: "13:00"},
            {time: "1:15 PM", timeForDB: "13:15"},
            {time: "1:30 PM", timeForDB: "13:30"},
            {time: "1:45 PM", timeForDB: "13:45"},
            {time: "2:00 PM", timeForDB: "14:00"},
            {time: "2:15 PM", timeForDB: "14:15"},
            {time: "2:30 PM", timeForDB: "14:30"},
            {time: "2:45 PM", timeForDB: "14:45"},
            {time: "3:00 PM", timeForDB: "15:00"},
            {time: "3:15 PM", timeForDB: "15:15"},
            {time: "3:30 PM", timeForDB: "15:30"},
            {time: "3:45 PM", timeForDB: "15:45"},
            {time: "4:00 PM", timeForDB: "16:00"},
            {time: "4:15 PM", timeForDB: "16:15"},
            {time: "4:30 PM", timeForDB: "16:30"},
            {time: "4:45 PM", timeForDB: "16:45"},
            {time: "5:00 PM", timeForDB: "17:00"},
            {time: "5:15 PM", timeForDB: "17:15"},
            {time: "5:30 PM", timeForDB: "17:30"},
            {time: "5:45 PM", timeForDB: "17:45"},
            {time: "6:00 PM", timeForDB: "18:00"},
            {time: "6:15 PM", timeForDB: "18:15"},
            {time: "6:30 PM", timeForDB: "18:30"},
            {time: "6:45 PM", timeForDB: "18:45"},
            {time: "7:00 PM", timeForDB: "19:00"},
            {time: "7:15 PM", timeForDB: "19:15"},
            {time: "7:30 PM", timeForDB: "19:30"},
            {time: "7:45 PM", timeForDB: "19:45"},
            {time: "8:00 PM", timeForDB: "20:00"},
            {time: "8:15 PM", timeForDB: "20:15"},
            {time: "8:30 PM", timeForDB: "20:30"},
            {time: "8:45 PM", timeForDB: "20:45"},
            {time: "9:00 PM", timeForDB: "21:00"},
            {time: "9:15 PM", timeForDB: "21:15"},
            {time: "9:30 PM", timeForDB: "21:30"},
            {time: "9:45 PM", timeForDB: "21:45"},
            {time: "10:00 PM", timeForDB: "22:00"},
            {time: "10:15 PM", timeForDB: "22:15"},
            {time: "10:30 PM", timeForDB: "22:30"},
            {time: "10:45 PM", timeForDB: "22:45"},
            {time: "11:00 PM", timeForDB: "23:00"},
            {time: "11:15 PM", timeForDB: "23:15"},
            {time: "11:30 PM", timeForDB: "23:30"},
            {time: "11:45 PM", timeForDB: "23:45"},
            {time: "12:00 AM", timeForDB: "00:00"}
        ];


        // Predfined time slots - moved to Settings/Time Slots
        /*
        $scope.enableTimeSlots = function() {
            console.log("Enable predefined booking time.");

            SweetAlert.swal({
                    title: "Confirm action",
                    text: vm.warningText,
                    type: "warning",
                    showCancelButton: true,
                    cancelButtonColor: "#ec4758",
                    confirmButtonColor: "#1ab394",
                    cancelButtonText: "No",
                    confirmButtonText: "Yes",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        SettingsResource.enableTimeSlots({enableTimeSlots: vm.enableTimeSlots}, onSuccessGetData, onErrorGetData);
                    } else {
                        vm.enableTimeSlots = !vm.enableTimeSlots;
                    }
                });
        }

        $scope.sameForAllDays = function() {
            console.log("Set if predefined time slot same for all day in the week or not.");
            SettingsResource.sameForAllDeysInWeek({useSame: vm.sameForAllWeekDays}, onSuccessGetData, onErrorGetData);

        }

        // add predefined bookin slot
        $scope.addPredefinedBookingTime = function(dayOfTheWeek) {
            console.log("Day="+dayOfTheWeek+" booking time="+vm.bookingTime);

            if(vm.bookingTime!=-1) {
                var predefined_booking_times = {
                    dayInWeek: dayOfTheWeek,
                    bookingTime: vm.bookingTime
                }

                SettingsResource.addPredefinedBookingTime(predefined_booking_times, onSuccessGetData, onErrorGetData);
            }

            vm.bookingTime = -1;
        }

        $scope.deleteTimeSlot = function(onlineTimeSlotId) {
            console.log("Delete online predefined time slot with id:"+onlineTimeSlotId);
            SettingsResource.deletePredefinedBookingTime({id: onlineTimeSlotId}, onSuccessGetData, onErrorGetData);
        }

        */

        /* $scope.availableTimes = [
            {time: "12:00 AM", timeForDB: "00:00"},
            {time: "12:30 AM", timeForDB: "00:30"},
            {time: "1:00 AM", timeForDB: "01:00"},
            {time: "1:30 AM", timeForDB: "01:30"},
            {time: "2:00 AM", timeForDB: "02:00"},
            {time: "2:30 AM", timeForDB: "02:30"},
            {time: "3:00 AM", timeForDB: "03:00"},
            {time: "3:30 AM", timeForDB: "03:30"},
            {time: "4:00 AM", timeForDB: "04:00"},
            {time: "4:30 AM", timeForDB: "04:30"},
            {time: "5:00 AM", timeForDB: "05:00"},
            {time: "5:30 AM", timeForDB: "05:30"},
            {time: "6:00 AM", timeForDB: "06:00"},
            {time: "6:30 AM", timeForDB: "06:30"},
            {time: "7:00 AM", timeForDB: "07:00"},
            {time: "7:30 AM", timeForDB: "07:30"},
            {time: "8:00 AM", timeForDB: "08:00"},
            {time: "8:30 AM", timeForDB: "08:30"},
            {time: "9:00 AM", timeForDB: "09:00"},
            {time: "9:30 AM", timeForDB: "09:30"},
            {time: "10:00 AM", timeForDB: "10:00"},
            {time: "10:30 AM", timeForDB: "10:30"},
            {time: "11:00 AM", timeForDB: "11:00"},
            {time: "11:30 AM", timeForDB: "11:30"},
            {time: "12:00 PM", timeForDB: "12:00"},
            {time: "12:30 PM", timeForDB: "12:30"},
            {time: "1:00 PM", timeForDB: "13:00"},
            {time: "1:30 PM", timeForDB: "13:30"},
            {time: "2:00 PM", timeForDB: "14:00"},
            {time: "2:30 PM", timeForDB: "14:30"},
            {time: "3:00 PM", timeForDB: "15:00"},
            {time: "3:30 PM", timeForDB: "15:30"},
            {time: "4:00 PM", timeForDB: "16:00"},
            {time: "4:30 PM", timeForDB: "16:30"},
            {time: "5:00 PM", timeForDB: "17:00"},
            {time: "5:30 PM", timeForDB: "17:30"},
            {time: "6:00 PM", timeForDB: "18:00"},
            {time: "6:30 PM", timeForDB: "18:30"},
            {time: "7:00 PM", timeForDB: "19:00"},
            {time: "7:30 PM", timeForDB: "19:30"},
            {time: "8:00 PM", timeForDB: "20:00"},
            {time: "8:30 PM", timeForDB: "20:30"},
            {time: "9:00 PM", timeForDB: "21:00"},
            {time: "9:30 PM", timeForDB: "21:30"},
            {time: "10:00 PM", timeForDB: "22:00"},
            {time: "10:30 PM", timeForDB: "22:30"},
            {time: "11:00 PM", timeForDB: "23:00"},
            {time: "11:30 PM", timeForDB: "23:30"},
            {time: "12:00 AM", timeForDB: "00:00"}
        ]; */

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.floor', {
            parent: 'settings',
            url: '/floor',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/floor/floor.html',
                    controller: 'FloorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('FloorController', FloorController);

    FloorController.$inject = ['$rootScope', '$scope', '$state', '$timeout', '$document', 'SettingsResource', 'Log',
                                'ApplicationContext', 'TextUtil', 'SweetAlert'];

    function FloorController($rootScope, $scope, $state, $timeout, $document, SettingsResource, Log,
                             ApplicationContext, TextUtil, SweetAlert) {

        var vm = this;
        vm.isTableManaged = ApplicationContext.isTableManaged();
        var capacityText =  TextUtil.translate('capacity');

            SettingsResource.getAreasAndTables({
        }, onSuccess, onError);

        if ($rootScope.configNotCompleted == true) {
            $scope.showIntroFloor = true;
            $rootScope.configNotCompleted = false;
            Log.debug("Flor settings", "Show floor settings intro.");
        }


        function onSuccess(data, headers) {
            data.sort(function(a, b){return a.id - b.id});
            $scope.data = data;

            angular.forEach($scope.data, function (area){
                area.statusData = [];
                angular.forEach(area.resources, function (table){
                    var count = 0;
                    var nadeno = 0;

                    $scope.capacity = "";
                    $scope.capacity = table.capacity + " " + capacityText;

                    if(table.vip == true){
                        $scope.vip = 1;
                    }
                    else {
                       $scope.vip = 0;
                    }

                    if (table.name.length > 16) {
                        if(vm.isTableManaged) {
                            table.nameToShow = table.name.substring(0, 16) + "...";
                        } else {
                            table.nameToShow = table.name;
                        }
                    }
                    else {
                        table.nameToShow = table.name;
                    }

                    if (area.statusData.length == 0) {
                        area.statusData.push({seats: $scope.capacity, tables: 1, vipTables: $scope.vip, capacity: table.capacity});
                    } else {
                        angular.forEach(area.statusData, function (searchTables) {
                            count++;
                            if (searchTables.seats == $scope.capacity) {
                                nadeno++
                                searchTables.tables++;
                                searchTables.vipTables += $scope.vip;
                            } else if (count == area.statusData.length && $scope.capacity && nadeno == 0) {
                                area.statusData.push({seats: $scope.capacity, tables: 1, vipTables: $scope.vip, capacity: table.capacity});
                            }
                        });
                    }

                });
            });

            console.log('$scope.data', $scope.data);
            Log.debug("TablesController", "HTTP request succeed. Data=" + data.id);
        }

        function onError(error) {
            Log.debug("settings.tables", "HTTP request error." + error);
        }

        function onSuccessRefreshArea() {
            //console.log('tu sam');
            SettingsResource.getAreasAndTables({
            }, onSuccess, onError);
        }

        $scope.anyPopupVisible = false;

        $scope.availableSigns = [
            {signDB: "A", sign: "A"},
            {signDB: "B", sign: "B"},
            {signDB: "C", sign: "C"},
            {signDB: "D", sign: "D"},
            {signDB: "E", sign: "E"},
            {signDB: "F", sign: "F"},
            {signDB: "G", sign: "G"},
            {signDB: "H", sign: "H"},
            {signDB: "I", sign: "I"},
            {signDB: "J", sign: "J"},
            {signDB: "K", sign: "K"},
            {signDB: "L", sign: "L"},
            {signDB: "M", sign: "M"},
            {signDB: "N", sign: "N"},
            {signDB: "O", sign: "O"},
            {signDB: "P", sign: "P"},
            {signDB: "Q", sign: "Q"},
            {signDB: "R", sign: "R"},
            {signDB: "S", sign: "S"},
            {signDB: "T", sign: "T"},
            {signDB: "U", sign: "U"},
            {signDB: "V", sign: "V"},
            {signDB: "W", sign: "W"},
            {signDB: "X", sign: "X"},
            {signDB: "Y", sign: "Y"},
            {signDB: "Z", sign: "Z"}
        ];

        $scope.capacityButtonColor = function(capacity) {
            switch(capacity) {
                case 1: return 'btn-info';
                case 2: return 'btn-primary';
                case 4: return 'btn-success';
                case 6: return 'btn-warning';
                default: return 'btn-danger';
            }
        }


        // ADD NEW AREA

        $scope.showPopupAddNewArea = function(){
            $scope.anyPopupVisible = true;
            $scope.popupNewAreaVisible = true;
            $scope.newArea={name: "", sign: "", color: "#1c84c6", vip: false}
        }

        $scope.newAreaVipChanged = function(){
            if ($scope.newArea.vip == false) {
                $scope.newArea.vip = true
            } else {
                $scope.newArea.vip = false
            }
        }

        $scope.saveNewArea = function () {
            $scope.nameExist = false;
            $scope.signExist = false;
            var broji = 0;
            var nadeno = 0;
            var nadenaOznaka = 0;

            angular.forEach($scope.data, function (item) {
                broji++
                if (item.name == $scope.newArea.name) {
                    nadeno++;
                }
                if(item.sign == $scope.newArea.sign){
                    nadenaOznaka ++;
                }
            });

            if (broji == $scope.data.length && nadeno == 0 && nadenaOznaka == 0) {
                SettingsResource.createArea($scope.newArea, onSuccessRefreshArea, onError);
                $scope.popupNewAreaVisible = false;
                $scope.anyPopupVisible = false;
            }
            else if(broji == $scope.data.length && nadeno > 0){
                $scope.nameExist = true;
            }
            else if(broji == $scope.data.length && nadenaOznaka > 0){
                $scope.signExist = true;
            }

        }



        // EDIT AREA

        $scope.showPopupEditArea = function(index){
//            console.log($scope.data[index]);
            $scope.editArea = {
                id: $scope.data[index].id,
                locationId: $scope.data[index].locationId,
                name: $scope.data[index].name,
                vip: $scope.data[index].vip,
                color: $scope.data[index].color,
                sign: $scope.data[index].sign
            };
            $scope.anyPopupVisible = true;
            $scope.popupEditAreaVisible = true;
        }

        $scope.editAreaVipChanged = function(){
            if ($scope.editArea.vip == false) {
                $scope.editArea.vip = true
            } else {
                $scope.editArea.vip = false
            }
        }

        $scope.saveEditedArea = function () {
            $scope.editedAreaNameExist = false;
            $scope.editedAreaSignExist = false;
            var broji = 0;
            var nadeno = 0;
            var nadenaOznaka = 0;

            angular.forEach($scope.data, function (item) {
                broji++;
                if (item.name == $scope.editArea.name && item.id !=$scope.editArea.id) {
                    nadeno++;
                }
                if (item.sign == $scope.editArea.sign && item.id !=$scope.editArea.id) {
                    nadenaOznaka++;
                }
            });

            if (broji == $scope.data.length && nadeno == 0 && nadenaOznaka == 0) {
                SettingsResource.updateArea($scope.editArea, onSuccessRefreshArea, onError);
                $scope.popupEditAreaVisible = false;
                $scope.anyPopupVisible = false;
            }
            else if (broji == $scope.data.length && nadeno > 0) {
                $scope.editedAreaNameExist = true;
            } else if (broji == $scope.data.length && nadenaOznaka > 0) {
                $scope.editedAreaSignExist = true;
            }

        }


        // DELETE AREA

        $scope.showPopupDeleteArea = function(index){
            $scope.areaIdForDelete = 0;
//            console.log($scope.data[index]);

            $scope.areaIdForDelete = {id: $scope.data[index].id};

            $scope.anyPopupVisible = true;
            $scope.popupDeleteAreaVisible = true;

            $scope.deleteAreaShowOkDeleteAreaButton = false;

            if ($scope.data[index].resources.length > 0) {
                $scope.deleteAreaMessage = "You can not delete " + TextUtil.translate('category', 's') +
                    " with " + TextUtil.translate('resource','p') + " in it. " +
                    "Please delete all "+ TextUtil.translate('resource','p') +" from this " +
                    TextUtil.translate('category','s') +" to proceed.";
                $scope.deleteAreaShowOkDeleteAreaButton = false;
            } else {
                $scope.deleteAreaMessage = "Are you sure you want to delete " + $scope.data[index].name + " area?";
                $scope.deleteAreaShowOkDeleteAreaButton = true;
            }
        }

        $scope.deleteArea = function () {
            SettingsResource.deleteArea($scope.areaIdForDelete, onSuccessRefreshArea, onError);
            $scope.popupDeleteAreaVisible = false;
            $scope.anyPopupVisible = false;
            $scope.areaIdForDelete = 0;
        }


        // ADD TABLE

        $scope.generateTableName = function (index, actionType) {
            $scope.broj++;

            if ($scope.broj < 10) {
                $scope.newTableName = $scope.data[index].sign + "0" + $scope.broj;
            } else {
                $scope.newTableName = $scope.data[index].sign + $scope.broj;
            }

            $scope.checkTableName($scope.newTableName, actionType);
        }

        $scope.checkTableName = function (nameToCheck, actionType) {
            var nadeno = 0;
            var countArea = 0;

            angular.forEach($scope.data, function (area) {
                var brojiStolove = 0;
                countArea++;

                if (area.resources.length > 0) {
                    angular.forEach(area.resources, function (item) {
                        brojiStolove++;
                        if (item.name == nameToCheck) {
                            nadeno++;
                        }

                        if (actionType == "addNewCustTable") {
                            if (nadeno > 0 && brojiStolove == area.resources.length && countArea == $scope.data.length) {
                                $scope.generateTableName($scope.areaIndex, "addNewCustTable");
                            } else if (brojiStolove == area.resources.length && countArea == $scope.data.length && nadeno == 0) {
                                $scope.newCustomTable.name = $scope.newTableName;
                            }
                        }

                        if (actionType == "addNewDefaultTable") {
                            if (nadeno > 0 && brojiStolove == area.resources.length && countArea == $scope.data.length) {
                                $scope.generateTableName($scope.areaIndex, "addNewDefaultTable");
                            } else if (brojiStolove == area.resources.length && countArea == $scope.data.length && nadeno == 0) {
                                $scope.newTable.name = $scope.newTableName;
                                SettingsResource.createTable($scope.newTable, onSuccessRefreshArea, onError);
                                $scope.areaIndex = -1;
                            }
                        }

                        if (actionType == "editedTable") {
                            if (nadeno > 0) {
                                $scope.editedTableNameExist = true;
                            } else if (brojiStolove == area.resources.length && countArea == $scope.data.length && nadeno == 0) {

                                SettingsResource.updateTable($scope.editTable, onSuccessRefreshArea, onError);
                                $scope.anyPopupVisible = false;
                                $scope.popupEditTableVisible = false;
                                $scope.editedTableNameExist = false;
                                $scope.areaIndex = -1;
                            }
                        }

                    });
                }
                else {

                    if (actionType == "addNewCustTable") {
                        if (nadeno > 0 && countArea == $scope.data.length) {
                            $scope.generateTableName($scope.areaIndex, "addNewCustTable");
                        } else if (countArea == $scope.data.length && nadeno == 0) {
                            $scope.newCustomTable.name = $scope.newTableName;
                            $scope.areaIndex = -1;
                        }
                    }

                    if (actionType == "addNewDefaultTable") {
                        if (nadeno > 0 && countArea == $scope.data.length) {
                            $scope.generateTableName($scope.areaIndex, "addNewDefaultTable");
                        } else if (countArea == $scope.data.length && nadeno == 0) {
                            $scope.newTable.name = $scope.newTableName;
                            SettingsResource.createTable($scope.newTable, onSuccessRefreshArea, onError);
                        }
                    }

                    if (actionType == "editedTable") {
                        if (nadeno > 0) {
                            $scope.editedTableNameExist = true;
                        } else if (countArea == $scope.data.length && nadeno == 0) {

                            SettingsResource.updateTable($scope.editTable, onSuccessRefreshArea, onError);
                            $scope.anyPopupVisible = false;
                            $scope.popupEditTableVisible = false;
                            $scope.editedTableNameExist = false;
                            $scope.areaIndex = -1;
                        }
                    }
                }

            });
        }

        $scope.addNewTable = function (index, type){

            $scope.newTable = {
                vip: false,
                areaId: $scope.data[index].id,
                type: "TABLE",
                locationId: $scope.data[index].locationId
            };

            if (type == "twoSeats") {
                $scope.newTable.capacity = 2;
            }
            if (type == "fourSeats") {
                $scope.newTable.capacity = 4;
            }
            if (type == "sixSeats") {
                $scope.newTable.capacity = 6;
            }
            if(type == "oneSeat") {
                $scope.newTable.capacity = 1;
            }

            $scope.newTableName = "";
            $scope.broj = $scope.data[index].resources.length;
            $scope.areaIndex = index;

            $scope.generateTableName($scope.areaIndex, "addNewDefaultTable");

        }

        $scope.addNewCustomTable = function(index){
            $scope.anyPopupVisible = true;
            $scope.popupAddCustomTableVisible = true;

            $scope.newCustomTable = {
                locationId: $scope.data[index].locationId,
                capacity: 0,
                vip: false,
                type: "TABLE",
                areaId: $scope.data[index].id
            };

            $scope.broj = $scope.data[index].resources.length;
            $scope.areaIndex = index;

            $scope.generateTableName($scope.areaIndex, "addNewCustTable");
        }

        $scope.newCustomTableVipChanged = function () {
            if ($scope.newCustomTable.vip == false) {
                $scope.newCustomTable.vip = true;
            } else {
                $scope.newCustomTable.vip = false;
            }
        }

        $scope.saveNewCustomTable = function () {
            SettingsResource.createTable($scope.newCustomTable, onSuccessRefreshArea, onError);
            $scope.anyPopupVisible = false;
            $scope.popupAddCustomTableVisible = false;
            $scope.areaIndex = -1;
        }

        // EDIT TABLE
        $scope.showPopupEditTable = function (areaIndex, tableIndex){

            $scope.editTableAreaIndex = areaIndex;

            $scope.tableNameBeforeEditing = $scope.data[areaIndex].resources[tableIndex].name;
            $scope.tableCapacityBeforeEditing = $scope.data[areaIndex].resources[tableIndex].capacity;

            $scope.editTable = {
                id: $scope.data[areaIndex].resources[tableIndex].id,
                locationId: $scope.data[areaIndex].resources[tableIndex].locationId,
                name: $scope.data[areaIndex].resources[tableIndex].name,
                vip: $scope.data[areaIndex].resources[tableIndex].vip,
                disabled: $scope.data[areaIndex].resources[tableIndex].disabled,
                disabledForOnline: $scope.data[areaIndex].resources[tableIndex].disabledForOnline,
                capacity: $scope.data[areaIndex].resources[tableIndex].capacity,
                cloverResourceId: $scope.data[areaIndex].resources[tableIndex].cloverResourceId,
                type: $scope.data[areaIndex].resources[tableIndex].type,
                areaId: $scope.data[areaIndex].resources[tableIndex].areaId,
            }

            console.log($scope.editTable);
            $scope.anyPopupVisible = true;
            $scope.popupEditTableVisible = true;
            $scope.editedTableNameExist = false;

        }

        $scope.editTableVipChanged = function () {
            if ($scope.editTable.vip == false) {
                $scope.editTable.vip = true
            } else {
                $scope.editTable.vip = false
            }
        }

        $scope.editTableDisabledChanged = function () {
            if ($scope.editTable.disabled == false) {
                $scope.editTable.disabled = true;
                $scope.editTable.disabledForOnline = true;
            } else {
                $scope.editTable.disabled = false
            }
        }

        $scope.editTableDisabledForOnlineChanged = function () {
            if ($scope.editTable.disabledForOnline == false) {
                $scope.editTable.disabledForOnline = true
            } else {
                $scope.editTable.disabledForOnline = false
            }
        }

        $scope.saveEditedTable = function (dirty) {
            $scope.editedTableNameExist = false;
            //TODO check if there are open events!!
            console.log("New capacity: " + $scope.editTable.capacity + "    Old capacity:"+$scope.tableCapacityBeforeEditing);
            var dialogMsg= "<br><br>  Please note that changing capacity may result with inadequate capacity for existing events.";
            if($scope.tableCapacityBeforeEditing > $scope.editTable.capacity)
                dialogMsg=  "<br><br>  Please note that decreasing capacity may cause insufficient capacity for existing events!";


            if($scope.tableCapacityBeforeEditing != $scope.editTable.capacity) {
                SweetAlert.swal({
                        html: true,
                        title: "Confirm action",
                        text: "Do you want to change capacity from "+$scope.tableCapacityBeforeEditing+" to " + $scope.editTable.capacity + " ?"+ dialogMsg,
                        type: "warning",
                        showCancelButton: true,
                        cancelButtonColor: "#ec4758",
                        confirmButtonColor: "#1ab394",
                        cancelButtonText: "No",
                        confirmButtonText: "Yes",
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            if (dirty == true && $scope.editTable.name != $scope.tableNameBeforeEditing) {
                                $scope.checkTableName($scope.editTable.name, "editedTable");
                            } else {
                                SettingsResource.updateTable($scope.editTable, onSuccessRefreshArea, onError);
                                $scope.anyPopupVisible = false;
                                $scope.popupEditTableVisible = false;
                            }

                            $scope.tableNameBeforeEditing = "";
                        } else {
                            $scope.editTable.capacity = $scope.tableCapacityBeforeEditing;
                        }
                    });
            } else {
                if (dirty == true && $scope.editTable.name != $scope.tableNameBeforeEditing) {
                    $scope.checkTableName($scope.editTable.name, "editedTable");
                } else {
                    SettingsResource.updateTable($scope.editTable, onSuccessRefreshArea, onError);
                    $scope.anyPopupVisible = false;
                    $scope.popupEditTableVisible = false;
                }

                $scope.tableNameBeforeEditing = "";
            }
        }

        // DELETE TABLE

        $scope.showPopupDeleteTable = function(areaIndex, tableIndex){
            $scope.tableIdForDelete = 0;
            console.log($scope.data[areaIndex].resources[tableIndex]);

            $scope.tableIdForDelete = {id: $scope.data[areaIndex].resources[tableIndex].id};

            $scope.anyPopupVisible = true;
            $scope.popupDeleteTableVisible = true;

            $scope.deleteTableMessage = "Are you sure you want to delete " + $scope.data[areaIndex].resources[tableIndex].name +
                " " + TextUtil.translate('resource', 's') + "?";
        };

        $scope.deleteTable = function () {
            console.log($scope.tableIdForDelete);
            SettingsResource.deleteTable($scope.tableIdForDelete, onSuccessRefreshArea, onError);
            $scope.popupDeleteTableVisible = false;
            $scope.anyPopupVisible = false;
            $scope.tableIdForDelete = 0;
        };


        // close popup

        $scope.closePopup = function (type) {

            $scope.popupNewAreaVisible = false;
            $scope.popupEditAreaVisible = false;
            $scope.popupDeleteAreaVisible = false;

            $scope.popupAddCustomTableVisible = false;
            $scope.popupEditTableVisible = false;
            $scope.popupDeleteTableVisible = false;

            $scope.anyPopupVisible = false;

            $scope.nameExist = false;
            $scope.editedAreaNameExist = false;
            $scope.signExist = false;
            $scope.editedAreaSignExist = false;
        };


        $scope.IntroOptionsFloor = {
            steps:[
                {
                    intro: '<h3 align="center">Welcome to SeatOn Reservations</h3>' +
                    '<p>' +
                    '<strong>Dear Customer</strong>,<br/><br/>' + getCategoryFloorText("FIRST") +
                    '<p>' +
                    "<code>SeatOn Reservations, All rights reserved &copy; since 2018</code>" +
                    '</p>'
                },
                {
                    element: '#floor',
                    intro: getCategoryFloorText("SECOND") +
                    '<p>' +
                    '<span class="font-bold">We strongly recommend to visit <a href="http://support.seaton.site" taget="_blank">SeatOn support center</a> and ' +
                    'find out more about how to customize SeatOn to match your needs.</span><br/>' +
                    '</p>' +
                    '<p class="text-navy font-bold">' +
                    'Enjoy using SeatOn!<br/>' +
                    '<small>Please share your feedback, lets us to know what you like and dont like, and new functionality you would like to see in SeatOn.</small>' +
                    '<p>' +
                    '<code>SeatOn Next Generation Table Management System, All rights reserved &copy; since 2018</code>' +
                    '</p>',
                    position: 'left'
                }
            ],
            showStepNumbers: true,
            showBullets: true,
            exitOnOverlayClick: false,
            exitOnEsc:true,
            nextLabel: '<strong>Next</strong>',
            prevLabel: '<strong>Previous</strong>',
            skipLabel: 'Exit',
            doneLabel: "Let's start"
        };

        function getCategoryFloorText(page) {
            if(page=='FIRST') {
                if(vm.isTableManaged) {
                    return  'Before you start to explore possibilities of the SeatOn system, first you need to define your restaurant areas and tables.<br/>' +
                            'SeatOn allows you to define up to 26 <strong>areas</strong> and an unlimited number of <strong>tables</strong> for each area.<br/>' +
                            '</p>' +
                            '<p>' +
                            '<strong>Area</strong> - represents part of your restaurant floor. You can define the area for specific part ' +
                            'of your restaurant like main room, VIP room, balcony, etc. <br/>' +
                            '</p>' +
                            '<p>' +
                            '<strong>Table</strong> - represents a table in the defined restaurant area.<br/><br/> ' +
                            'To make the table definition process easier, we have created predefined tables with the capacity of 1, 2, 4 and 6 chairs. ' +
                            'Additionally, you can create a table with the custom definition.' +
                            '</p>';

                } else {
                    return  'Before you start to explore possibilities of the SeatOn system, first you need to define your business resources.<br/>' +
                            'SeatOn allows you to define up to 26 <strong>categories</strong> and an unlimited number of <strong>resources</strong> for each category.<br/>' +
                            '</p>' +
                            '<p>' +
                            '<strong>Category</strong> - you can split resource in the categories which represent different type of services you provide or to reflect your internal organisation. <br/>' +
                            '</p>' +
                            '<p>' +
                            '<strong>Resource</strong> - represents a resource of your business which SeatOn will manage.<br/><br/> ' +
                            'To make the table definition process easier, we have created predefined resources with the capacity of 1, 2, 4 and 6. ' +
                            'Additionally, you can create a resource with the custom definition.' +
                            '</p>';
                }
            } else if ("SECOND"){
                if(vm.isTableManaged) {
                    return '<h3 align="center">Define your first area</h3>' +
                            '<p>' +
                            'To start with area and table definition click on the "Add area" button on the right side.<br/>' +
                            'Once you define at least one area and one table, you are ready to use SeatOn.' +
                            '</p>';
                } else {
                    return '<h3 align="center">Define your first category</h3>' +
                            '<p>' +
                            'To start with category and resource definition click on the "Add category" button on the right side.<br/>' +
                            'Once you define at least one category and one resource, you are ready to use SeatOn.' +
                            '</p>';
                }
            }
        }

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.ivr', {
            parent: 'settings',
            url: '/ivr',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/ivr/ivr.html',
                    controller: 'IVRController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.ivr');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('IVRController', IVRController);

    IVRController.$inject = ['$rootScope', '$scope', '$state', 'Log', 'ApplicationProfile', 'LocationResource', 'SweetAlert', 'Principal'];

    function IVRController($rootScope, $scope, $state, Log, ApplicationProfile, LocationResource, SweetAlert, Principal) {

        var vm = this;

        vm.IVRReservationEnabled = ApplicationProfile.isIVRReservationEnabled();
        vm.IVRReservationText = ApplicationProfile.upgradeTierText("IVRReservation");
        vm.openWindow = ApplicationProfile.openAppCloverPage;

        vm.requestIVR = requestIVR;
        vm.activatePhone = activatePhone;
        vm.newPhone = null;

        loadLocation();

        function loadLocation() {
            return LocationResource.getLocation({}, function (location) {
                vm.location = location;
                vm.newPhone = vm.location.smsPhoneNumber;
            }).$promise;
        }

        function requestIVR() {

            LocationResource.requestIVR(
                {}
                ,
                function onSuccess(data) {
                    vm.location = data;
                    vm.newPhone = vm.location.smsPhoneNumber;
                    console.log("success:" + data);
                    SweetAlert.swal("Request sent successfully", "IVR activation in progress, within 24 hours dedicated phone number for IVR reservations will be assigned.", "success");
                }
                ,
                function onError(data) {
                    SweetAlert.swal("Unable to send request", "There was issue with sending request. Please try again or contact support. (email: support@seaton.site)", "error");
                    console.log("error:" + data);
                }
            );
        }

        function activatePhone() {

            LocationResource.activateIvrPhone(
                {smsPhone: vm.newPhone}
                ,
                function onSuccess(data) {
                    vm.location = data;
                    vm.newPhone = vm.location.smsPhoneNumber;
                    console.log("success:" + data);
                    SweetAlert.swal("SmsPhoneNumber changed", "", "success");
                }
                ,
                function onError(data) {
                    SweetAlert.swal("Error occured", "", "error");
                    console.log("error:" + data);
                }
            );
        }


        vm.account = null;

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.notification', {
            parent: 'settings',
            url: '/notification',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/notification/notification.html',
                    controller: 'NotificationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('NotificationController', NotificationController);

    NotificationController.$inject = ['$scope', '$state', 'SettingsResource', 'Log', '$uibModal', 'ApplicationContext', 'ApplicationProfile', '$http', 'SweetAlert'];

    function NotificationController($scope, $state, SettingsResource, Log, $uibModal, ApplicationContext, ApplicationProfile, $http, SweetAlert) {

        var vm = this;

        SettingsResource.getEmailLookAndFeel(
            {},
            function (data) {
                vm.lnf = data;
                Log.info("NotificationController", "Fetched email settings: " + JSON.stringify(data));
            },
            function (error) {
                Log.debug("NotificationController", "Error while fetching email look and feel settings: " + error);
            }
        );

        vm.subscription = ApplicationContext.getLocation().subscription;
        vm.openWindow = ApplicationProfile.openAppCloverPage;
        vm.locationId = ApplicationContext.getLocationID();
        vm.uploadUrl = '/api/v1/merchants/' + vm.locationId + '/emailLookAndFeel/upload';
        vm.imageCacheBuster = new Date().getTime();

        $scope.textSizes = [
            {value: 0, text: "0px"},
            {value: 8, text: "8px"},   {value: 10, text: "10px"}, {value: 12, text: "12px"},
            {value: 14, text: "14px"}, {value: 16, text: "16px"}, {value: 18, text: "18px"},
            {value: 20, text: "20px"}, {value: 22, text: "22px"}, {value: 24, text: "24px"},
            {value: 26, text: "26px"}, {value: 28, text: "28px"}, {value: 30, text: "30px"},
            {value: 32, text: "32px"}, {value: 34, text: "34px"}, {value: 36, text: "36px"},
            {value: 38, text: "38px"}, {value: 40, text: "40px"}, {value: 42, text: "42px"}
        ];

        $scope.fonts = [
            {value: "Helvetica,Arial,sans-serif", text: "Helvetica"},
            {value: "Arial,Helvetica,sans-serif", text: "Arial"},
            {value: "Verdana,sans-serif", text: "Verdana"},
            {value: "Tahoma,sans-serif", text: "Tahoma"},
            {value: "Times New Roman, serif", text: "Times New Roman"},
            {value: "monospace", text: "monospace"},
            {value: "cursive", text: "cursive"},
            {value: "fantasy", text: "fantasy"}
        ];


        SettingsResource.getNotificationSettings({
        }, onSuccessGetData, onErrorGetData);

        function onSuccessGetData(data, headers) {

            $scope.data = data;
            console.log('$scope.data', $scope.data);

            Log.debug("NotificationController", "HTTP request succeed. Data=" + data.id);
        }

        function onErrorGetData(error) {
            Log.debug("NotificationController", "HTTP request error." + error);
        }


        // save data
        $scope.saveData = function () {
            console.log('save data', $scope.data);
            SettingsResource.saveNotificationSettings($scope.data, onSuccessGetData, onErrorGetData);
            SettingsResource.updateEmailLookAndFeel(vm.lnf);

        }

        // restore default values for email notification look and feel
        $scope.restoreLnfSettings = function () {
            vm.lnf.headerNameFontSize=32;
            vm.lnf.headerAddressFontSize=16;
            vm.lnf.headerTextColor="#ffffff";
            vm.lnf.headerFontFamily="Helvetica,Arial,sans-serif";
            vm.lnf.headerBackgroundImage="/content/email/images/mail-header-bg.jpg";
            vm.lnf.bodyTextColor="#444444";
            vm.lnf.bodyBackgroundColor="#ffffff";
            vm.lnf.bodyFontFamily="Helvetica,Arial,sans-serif";
            vm.lnf.bodyTitleFontSize=18;
            vm.lnf.bodyMsgFontSize=14;
            vm.lnf.bodyReservationDetailsImage="/content/email/images/visit-details.jpg";
            vm.lnf.bodyCancelImage="/content/email/images/visit-cancel.jpg";
            vm.lnf.bodyContactImage="/content/email/images/contact-us.jpg";
            vm.lnf.bodyFeedbackImage="/content/email/images/feedback.jpg";

            // important since old values would stay, and upload would not be triggered if the user
            // selected the exact same image
            document.getElementById("headerBkgImage").value = "";
            document.getElementById("resDetailsImage").value = "";
            document.getElementById("cancelImage").value = "";
            document.getElementById("feedbackImage").value = "";
            document.getElementById("contactImage").value = "";

            // triggers image refresh on the live preview
            vm.imageCacheBuster = new Date().getTime();
        }

        $scope.availableTimesForReservationReminder = [
            {time: "1 hour", timeForDB: 1},
            {time: "2 hours", timeForDB: 2},
            {time: "3 hours", timeForDB: 3},
            {time: "4 hours", timeForDB: 4},
            {time: "5 hours", timeForDB: 5},
            {time: "6 hours", timeForDB: 6},
            {time: "7 hours", timeForDB: 7},
            {time: "8 hours", timeForDB: 8},
            {time: "12 hours", timeForDB: 12},
            {time: "1 day", timeForDB: 24},
            {time: "2 days", timeForDB: 48}
        ];

        $scope.verificationCondition = [
            {text: "Always send verification email.", value: 1},
            {text: "Send verification email only if customer email is not verified before.", value: 2},
            {text: "Never send verification email.", value: 3}
        ]

        vm.isFree = vm.subscription=='FREE';
        vm.isStandard = vm.subscription=='STANDARD';
        vm.isProfessional = vm.subscription=='PROFESSIONAL';
        $scope.reminderChannels = [
            {text: "E-mail only.", value: "EMAIL"}
        ]
        if(!vm.isFree) {
            $scope.reminderChannels.push({text: "Text message if phone defined, otherwise via e-mail.", value: "SMS"});
        }
        $scope.confirmationChannels = [
            {text: "E-mail only.", value: "EMAIL"}
        ]
        if(!vm.isFree) {
            $scope.confirmationChannels.push({text: "Text message if phone defined, otherwise via e-mail.", value: "SMS"});
        }
        $scope.closeReservationVerificationDialog = function() {
            vm.reservationVerificationPreview.dismiss('cancel');
        }

        vm.reminderSubscribeText = function() {
            if (vm.isFree) {
                return "Upgrade to PAY_AS_YOU_GO, STANDARD to enable text or to PROFESSIONAL subscription to enable voice reminders as well.";
            }
        }

        vm.confirmationSubscribeText = function() {
            if(vm.isFree) {
                return "Upgrade to PAY_AS_YOU_GO, STANDARD to enable text or to PROFESSIONAL subscription to enable voice confirmation messages as well.";
            }
        }

        $scope.showReservationVerificationDialog = function() {
            vm.reservationVerificationPreview = $uibModal.open({
                templateUrl: 'app/settings/notification/reservation.verification.preview.html',
                scope: $scope
            });
        }

        $scope.closeReservationConfirmationDialog = function() {
            vm.reservationConfirmationPreview.dismiss('cancel');
        }

        $scope.showReservationConfirmDialog = function() {
            vm.reservationConfirmationPreview = $uibModal.open({
                templateUrl: 'app/settings/notification/reservation.confirm.preview.html',
                scope: $scope
            });
        }

        $scope.closeReservationReminderDialog = function() {
            vm.reservationReminderPreview.dismiss('cancel');
        }

        $scope.showReservationReminderDialog = function() {
            vm.reservationReminderPreview = $uibModal.open({
                templateUrl: 'app/settings/notification/reservation.reminder.preview.html',
                scope: $scope
            });
        }

        $scope.closeReservationCancelDialog = function() {
            vm.reservationCancelPreview.dismiss('cancel');
        }

        $scope.showReservationCancelDialog = function() {
            vm.reservationCancelPreview = $uibModal.open({
                templateUrl: 'app/settings/notification/reservation.cancel.preview.html',
                scope: $scope
            });
        }

        $scope.closeReservationUpdateDialog = function() {
            vm.reservationUpdatePreview.dismiss('cancel');
        }

        $scope.showReservationUpdateDialog = function() {
            vm.reservationUpdatePreview = $uibModal.open({
                templateUrl: 'app/settings/notification/reservation.update.preview.html',
                scope: $scope
            });
        }


        $scope.closeReservationThankYouDialog = function() {
            vm.reservationThankYouPreview.dismiss('cancel');
        }

        $scope.showReservationThankYouDialog = function() {
            vm.reservationThankYouPreview = $uibModal.open({
                templateUrl: 'app/settings/notification/reservation.thankyou.preview.html',
                scope: $scope
            });
        }

        $scope.closeWaitlistAddToDialog = function() {
            vm.waitlistAddToDialog.dismiss('cancel');
        }

        $scope.showWaitlistAddToDialog = function() {
            vm.waitlistAddToDialog = $uibModal.open({
                templateUrl: 'app/settings/notification/waitlist.addto.preview.html',
                scope: $scope
            });
        }

        $scope.closeWaitlistNotifyDialog = function() {
            vm.waitlistNotifyDialog.dismiss('cancel');
        }

        $scope.showWaitlistNotifyDialog = function() {
            vm.waitlistNotifyDialog = $uibModal.open({
                templateUrl: 'app/settings/notification/waitlist.notify.preview.html',
                scope: $scope
            });
        }

        $scope.closeWaitlistThankYouDialog = function() {
            vm.waitlistThankYouDialog.dismiss('cancel');
        }

        $scope.showWaitlistThankYouDialog = function() {
            vm.waitlistThankYouDialog = $uibModal.open({
                templateUrl: 'app/settings/notification/waitlist.thankyou.preview.html',
                scope: $scope
            });
        }

        $scope.getDate = function(offset) {
            var monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            var date = new Date(Date.now() + (offset * 24 * 60 * 60 * 1000));
            return monthNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
        }

        $scope.getLocationName = function() {
            return ApplicationContext.getLocation().name;
        }

        $scope.getLocationAddress = function() {

            var fullAddress =
                ((ApplicationContext.getLocation().address1==null)?"":ApplicationContext.getLocation().address1)
                + ((ApplicationContext.getLocation().address2==null)?"":" " + ApplicationContext.getLocation().address2)
                + ((ApplicationContext.getLocation().address3==null)?"":" " + ApplicationContext.getLocation().address3) + ", "
                + ((ApplicationContext.getLocation().zipcode==null)?"":ApplicationContext.getLocation().zipcode) + " "
                + ((ApplicationContext.getLocation().city==null)?"":ApplicationContext.getLocation().city) + ", "
                + ((ApplicationContext.getLocation().countryState==null)?"":ApplicationContext.getLocation().countryState) + ", "
                + ((ApplicationContext.getLocation().country==null)?"":ApplicationContext.getLocation().country);

            return fullAddress;
        }

        $scope.getContactPhoneNumber = function() {
            return (ApplicationContext.getLocation().phone==null?"":ApplicationContext.getLocation().phone);
        }

        $scope.getContactEmail = function() {
            return (ApplicationContext.getLocation().email==null?"":ApplicationContext.getLocation().email);
        }

        $scope.fileSelected = function(elementId, type) {
            console.log('File selected: ' + elementId + " - " + type);
        }

        $scope.upload = function(elementId, type) {
            var file = document.getElementById(elementId).files[0];
            var size = file.size;
            if (size > 512000) {
                SweetAlert.swal("File too large", "Maximum allowed file size is 500 kB.", "error");
                return;
            }

            var r = new FileReader();
            r.onloadend = function(e) {
                var formData = new FormData();
                formData.append('file', file);

                $http.post(vm.uploadUrl + '?type=' + type, formData, {
                        transformRequest: angular.identity,
                        headers: {'Content-Type': undefined}
                })
                .success(function(data){
                    vm.imageCacheBuster = new Date().getTime(); // triggers refresh
                    if (type === 'HEADER_BKG') {
                        vm.lnf.headerBackgroundImage = data.url;
                    } else if (type === 'RES_DETAILS') {
                        vm.lnf.bodyReservationDetailsImage = data.url;
                    } else if (type === 'CANCEL') {
                        vm.lnf.bodyCancelImage = data.url;
                    } else if (type === 'CONTACT') {
                        vm.lnf.bodyContactImage = data.url;
                    } else if (type === 'FEEDBACK') {
                        vm.lnf.bodyFeedbackImage = data.url;
                    }
                })
                .error(function(){
                    SweetAlert.swal("Error during upload", "Please contact support support@seaton site for help.", "error");
                });
            }
            r.readAsArrayBuffer(file);
        }
    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.membership', {
            parent: 'settings',
            url: '/membership',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/membership/membership.html',
                    controller: 'MembershipController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('MembershipController', MembershipController);

    MembershipController.$inject = ['$scope', '$state', 'SettingsResource', 'Log', 'SweetAlert'];

    function MembershipController($scope, $state, SettingsResource, Log, SweetAlert) {
        
        $scope.bronzeMemberThresholdProblem = false;
        
        SettingsResource.getMemberStatusSettings({
        }, onSuccessGetData, onErrorGetData);

//        SettingsResource.getAreasAndTables({
//        }, onSuccess, onError);

        /*SettingsResource.createArea({
            locationId: 1,
            name: 'Test',
            vip: false

        }, onSuccess, onError);*/

        /*SettingsResource.updateArea({
            id: 1013,
            locationId: 1,
            name: 'Test123',
            vip: true

         }, onSuccess, onError);*/

        /*SettingsResource.deleteArea({
            id: 2
        }, onSuccess, onError);*/


        function onSuccessGetData(data, headers) {
            $scope.data = data;
            console.log('$scope.data', $scope.data);
            
            $scope.beginnerMemberBenefitVipTable = false;
            $scope.beginnerMemberBenefitFavoriteTable = false;
            $scope.beginnerMemberBenefitWaitPriority = false;
            
            $scope.bronzeMemberBenefitVipTable = false;
            $scope.bronzeMemberBenefitFavoriteTable = false;
            $scope.bronzeMemberBenefitWaitPriority = false;
            
            $scope.silverMemberBenefitVipTable = false;
            $scope.silverMemberBenefitFavoriteTable = false;
            $scope.silverMemberBenefitWaitPriority = false;
            
            $scope.goldMemberBenefitVipTable = false;
            $scope.goldMemberBenefitFavoriteTable = false;
            $scope.goldMemberBenefitWaitPriority = false;
            
            $scope.platinumMemberBenefitVipTable = false;
            $scope.platinumMemberBenefitFavoriteTable = false;
            $scope.platinumMemberBenefitWaitPriority = false;
   
            $scope.beginnerMember = $scope.data.beginnerMember.benefits.split(","); // comma splitting
            angular.forEach($scope.beginnerMember, function (item) {
                    if (item == "VIP_TABLE") {
                        $scope.beginnerMemberBenefitVipTable = true;
                    }
                    if (item == "FAVORITE_TABLE") {
                        $scope.beginnerMemberBenefitFavoriteTable = true;
                    }
                    if (item == "WAIT_PRIORITY") {
                        $scope.beginnerMemberBenefitWaitPriority = true;
                    };
            });
            
            $scope.bronzeMember = $scope.data.bronzeMember.benefits.split(","); // comma splitting
            angular.forEach($scope.bronzeMember, function (item) {
                    if (item == "VIP_TABLE") {
                        $scope.bronzeMemberBenefitVipTable = true;
                    }
                    if (item == "FAVORITE_TABLE") {
                        $scope.bronzeMemberBenefitFavoriteTable = true;
                    }
                    if (item == "WAIT_PRIORITY") {
                        $scope.bronzeMemberBenefitWaitPriority = true;
                    };
            });
            
            $scope.silverMember = $scope.data.silverMember.benefits.split(","); // comma splitting
            angular.forEach($scope.silverMember, function (item) {
                    if (item == "VIP_TABLE") {
                        $scope.silverMemberBenefitVipTable = true;
                    }
                    if (item == "FAVORITE_TABLE") {
                        $scope.silverMemberBenefitFavoriteTable = true;
                    }
                    if (item == "WAIT_PRIORITY") {
                        $scope.silverMemberBenefitWaitPriority = true;
                    };
            });
            
            $scope.goldMember = $scope.data.goldMember.benefits.split(","); // comma splitting
            angular.forEach($scope.goldMember, function (item) {
                    if (item == "VIP_TABLE") {
                        $scope.goldMemberBenefitVipTable = true;
                    }
                    if (item == "FAVORITE_TABLE") {
                        $scope.goldMemberBenefitFavoriteTable = true;
                    }
                    if (item == "WAIT_PRIORITY") {
                        $scope.goldMemberBenefitWaitPriority = true;
                    };
            });                        
            
            $scope.platinumMember = $scope.data.platinumMember.benefits.split(","); // comma splitting
            angular.forEach($scope.platinumMember, function (item) {
                    if (item == "VIP_TABLE") {
                        $scope.platinumMemberBenefitVipTable = true;
                    }
                    if (item == "FAVORITE_TABLE") {
                        $scope.platinumMemberBenefitFavoriteTable = true;
                    }
                    if (item == "WAIT_PRIORITY") {
                        $scope.platinumMemberBenefitWaitPriority = true;
                    };
            });            
            
            // threshold check (or else $dirty will repeat warning if user change anything after save of threshold)
            $scope.bronzeMemberThresholdStart = data.bronzeMember.threshold;
            $scope.silverMemberThresholdStart = data.silverMember.threshold;
            $scope.goldMemberThresholdStart = data.goldMember.threshold;
            $scope.platinumMemberThresholdStart = data.platinumMember.threshold;
            

            Log.debug("MembershipController", "HTTP request succeed. Data=" + data.id);
        }

        function onErrorGetData(error) {
            Log.debug("MembershipController", "HTTP request error." + error);
        }
        
        // save data
        $scope.saveData = function (bronzeThresholdDirty, silverMemberThresholdDirty, goldMemberThresholdDirty, platinumMemberThresholdDirty) {
            
            if ($scope.data.bronzeMember.threshold != $scope.bronzeMemberThresholdStart || $scope.data.silverMember.threshold != $scope.silverMemberThresholdStart || $scope.data.goldMember.threshold != $scope.goldMemberThresholdStart || $scope.data.platinumMember.threshold != $scope.platinumMemberThresholdStart) {
                
                $scope.thresholdDirtyChangedList = "You have changed threshold for: ";
                var memberNameAdded = 0;                
                    
                if(bronzeThresholdDirty == true && $scope.data.bronzeMember.threshold != $scope.bronzeMemberThresholdStart){
                    memberNameAdded++;
                    $scope.thresholdDirtyChangedList += $scope.data.bronzeMember.name;
                }
                
                if(memberNameAdded > 0 && silverMemberThresholdDirty == true && $scope.data.silverMember.threshold != $scope.silverMemberThresholdStart){
                    memberNameAdded++;
                    $scope.thresholdDirtyChangedList += ", " + $scope.data.silverMember.name;
                }
                else if(silverMemberThresholdDirty == true && $scope.data.silverMember.threshold != $scope.silverMemberThresholdStart){
                    memberNameAdded++;
                    $scope.thresholdDirtyChangedList += $scope.data.silverMember.name;                    
                }
                
                if(memberNameAdded > 0 && goldMemberThresholdDirty == true && $scope.data.goldMember.threshold != $scope.goldMemberThresholdStart){
                    memberNameAdded++;
                    $scope.thresholdDirtyChangedList += ", " + $scope.data.goldMember.name;
                }
                else if(goldMemberThresholdDirty == true && $scope.data.goldMember.threshold != $scope.goldMemberThresholdStart){
                    memberNameAdded++;
                    $scope.thresholdDirtyChangedList += $scope.data.goldMember.name;                    
                }
                
                if(memberNameAdded > 0 && platinumMemberThresholdDirty == true && $scope.data.platinumMember.threshold != $scope.platinumMemberThresholdStart){
                    memberNameAdded++;
                    $scope.thresholdDirtyChangedList += ", " + $scope.data.platinumMember.name;
                }
                else if(platinumMemberThresholdDirty == true && $scope.data.platinumMember.threshold != $scope.platinumMemberThresholdStart){
                    memberNameAdded++;
                    $scope.thresholdDirtyChangedList += $scope.data.platinumMember.name;                    
                }

                SweetAlert.swal({
                    title: "Are you sure?",
                    text: $scope.thresholdDirtyChangedList,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#AEDEF4", confirmButtonText: "Save everything",
                    cancelButtonText: "Recover old threshold data and save",
                    closeOnConfirm: true,
                    closeOnCancel: false
                },
                        function (isConfirm) {
                            if (isConfirm) {
                                SettingsResource.saveMemberStatusSettings($scope.data, onSuccessGetData, onErrorGetData);
                            }
                            else {
                                $scope.data.bronzeMember.threshold = $scope.bronzeMemberThresholdStart
                                $scope.data.silverMember.threshold = $scope.silverMemberThresholdStart;
                                $scope.data.goldMember.threshold = $scope.goldMemberThresholdStart;
                                $scope.data.platinumMember.threshold = $scope.platinumMemberThresholdStart;
                                
                                SettingsResource.saveMemberStatusSettings($scope.data, onSuccessGetData, onErrorGetData);
                                swal("Threshold data recovered", "Data is saved, but with old threshold data", "success");
                            }
                        }
                );

            } else {
                SettingsResource.saveMemberStatusSettings($scope.data, onSuccessGetData, onErrorGetData);
            }

        }
        
        // beginner benefitsChanged
        $scope.beginnerMemberBenefitsChanged = function(type){
            var count = 0;
            var found = 0;
            $scope.beginnerMemberBenefits = "";
            
            if ($scope.beginnerMember.length == 0) {
                $scope.beginnerMember.push(type);
            } else {
                angular.forEach($scope.beginnerMember, function (item) {
                    count++;
                    if (item == type) {
                        found++;
                        $scope.beginnerMember.splice(count - 1, 1);
                    } else if (found == 0 && $scope.beginnerMember.length == count) {
                        $scope.beginnerMember.push(type);
                    }
                });
            }
            
            angular.forEach($scope.beginnerMember, function(item){
                $scope.beginnerMemberBenefits += "," + item;
            });            
            $scope.data.beginnerMember.benefits = $scope.beginnerMemberBenefits.substring(1, $scope.beginnerMemberBenefits.length);
            
            onSuccessGetData($scope.data);
        }
        
        // bronze benefitsChanged
        $scope.bronzeMemberBenefitsChanged = function(type){
            var count = 0;
            var found = 0;
            $scope.bronzeMemberBenefits = "";
            
            if ($scope.bronzeMember.length == 0) {
                $scope.bronzeMember.push(type);
            } else {
                angular.forEach($scope.bronzeMember, function (item) {
                    count++;
                    if (item == type) {
                        found++;
                        $scope.bronzeMember.splice(count - 1, 1);
                    } else if (found == 0 && $scope.bronzeMember.length == count) {
                        $scope.bronzeMember.push(type);
                    }
                });
            }
            
            angular.forEach($scope.bronzeMember, function(item){
                $scope.bronzeMemberBenefits += "," + item;
            });            
            $scope.data.bronzeMember.benefits = $scope.bronzeMemberBenefits.substring(1, $scope.bronzeMemberBenefits.length);
            
            onSuccessGetData($scope.data);
        }
        
        // silver benefitsChanged
        $scope.silverMemberBenefitsChanged = function(type){
            var count = 0;
            var found = 0;
            $scope.silverMemberBenefits = "";
            
            if ($scope.silverMember.length == 0) {
                $scope.silverMember.push(type);
            } else {
                angular.forEach($scope.silverMember, function (item) {
                    count++;
                    if (item == type) {
                        found++;
                        $scope.silverMember.splice(count - 1, 1);
                    } else if (found == 0 && $scope.silverMember.length == count) {
                        $scope.silverMember.push(type);
                    }
                });
            }
            
            angular.forEach($scope.silverMember, function(item){
                $scope.silverMemberBenefits += "," + item;
            });            
            $scope.data.silverMember.benefits = $scope.silverMemberBenefits.substring(1, $scope.silverMemberBenefits.length);
            
            onSuccessGetData($scope.data);
        }
        
        // gold benefitsChanged
        $scope.goldMemberBenefitsChanged = function(type){
            var count = 0;
            var found = 0;
            $scope.goldMemberBenefits = "";
            
            if ($scope.goldMember.length == 0) {
                $scope.goldMember.push(type);
            } else {
                angular.forEach($scope.goldMember, function (item) {
                    count++;
                    if (item == type) {
                        found++;
                        $scope.goldMember.splice(count - 1, 1);
                    } else if (found == 0 && $scope.goldMember.length == count) {
                        $scope.goldMember.push(type);
                    }
                });
            }
            
            angular.forEach($scope.goldMember, function(item){
                $scope.goldMemberBenefits += "," + item;
            });            
            $scope.data.goldMember.benefits = $scope.goldMemberBenefits.substring(1, $scope.goldMemberBenefits.length);
            
            onSuccessGetData($scope.data);
        }
        
        // platinum benefitsChanged
        $scope.platinumMemberBenefitsChanged = function(type){
            var count = 0;
            var found = 0;
            $scope.platinumMemberBenefits = "";
            
            if ($scope.platinumMember.length == 0) {
                $scope.platinumMember.push(type);
            } else {
                angular.forEach($scope.platinumMember, function (item) {
                    count++;
                    if (item == type) {
                        found++;
                        $scope.platinumMember.splice(count - 1, 1);
                    } else if (found == 0 && $scope.platinumMember.length == count) {
                        $scope.platinumMember.push(type);
                    }
                });
            }
            
            angular.forEach($scope.platinumMember, function(item){
                $scope.platinumMemberBenefits += "," + item;
            });            
            $scope.data.platinumMember.benefits = $scope.platinumMemberBenefits.substring(1, $scope.platinumMemberBenefits.length);
            
            onSuccessGetData($scope.data);
        }
        
        $scope.beginnerActive = true;
        $scope.activeTab = function (type) {
            $scope.beginnerActive = false;
            $scope.bronzeActive = false;
            $scope.silverActive = false;
            $scope.goldActive = false;
            $scope.platinumActive = false;

            if (type == "beginner") {
                $scope.beginnerActive = true;
            }
            if (type == "bronze") {
                $scope.bronzeActive = true;
            }
            if (type == "silver") {
                $scope.silverActive = true;
            }
            if (type == "gold") {
                $scope.goldActive = true;
            }
            if (type == "platinum") {
                $scope.platinumActive = true;
            }
        }
        
        $scope.thresholdChanged = function (type) {

            $scope.saveButtonDisabled = false;       
            
            if (angular.isDefined($scope.data.bronzeMember.threshold)) {
                $scope.data.bronzeMember.threshold = Math.round($scope.data.bronzeMember.threshold);
            }
            if (angular.isDefined($scope.data.silverMember.threshold)) {
                $scope.data.silverMember.threshold = Math.round($scope.data.silverMember.threshold);
            }
            if (angular.isDefined($scope.data.goldMember.threshold)) {
                $scope.data.goldMember.threshold = Math.round($scope.data.goldMember.threshold);
            }
            if (angular.isDefined($scope.data.platinumMember.threshold)) {
                $scope.data.platinumMember.threshold = Math.round($scope.data.platinumMember.threshold);
            }
                
            if (angular.isUndefined($scope.data.bronzeMember.threshold) || $scope.data.bronzeMember.threshold <= 0 || $scope.data.bronzeMember.threshold >= $scope.data.silverMember.threshold) {
                $scope.bronzeMemberThresholdProblem = true;
            } else {
                $scope.bronzeMemberThresholdProblem = false;
            }

            if (angular.isUndefined($scope.data.silverMember.threshold) || $scope.data.silverMember.threshold <= $scope.data.bronzeMember.threshold || $scope.data.silverMember.threshold >= $scope.data.goldMember.threshold) {
                $scope.silverMemberThresholdProblem = true;
            } else {
                $scope.silverMemberThresholdProblem = false;
            }
            if (angular.isUndefined($scope.data.goldMember.threshold) || $scope.data.goldMember.threshold <= $scope.data.silverMember.threshold || $scope.data.goldMember.threshold >= $scope.data.platinumMember.threshold) {
                $scope.goldMemberThresholdProblem = true;
            } else {
                $scope.goldMemberThresholdProblem = false;
            }
            if (angular.isUndefined($scope.data.platinumMember.threshold) || $scope.data.platinumMember.threshold <= $scope.data.goldMember.threshold) {
                $scope.platinumMemberThresholdProblem = true;
            } else {
                $scope.platinumMemberThresholdProblem = false;
            }
            
            if (angular.isUndefined($scope.data.bronzeMember.threshold) || $scope.data.bronzeMember.threshold <= 0 || $scope.data.bronzeMember.threshold >= $scope.data.silverMember.threshold
                    || angular.isUndefined($scope.data.silverMember.threshold) || $scope.data.silverMember.threshold <= $scope.data.bronzeMember.threshold || $scope.data.silverMember.threshold >= $scope.data.goldMember.threshold
                    || angular.isUndefined($scope.data.goldMember.threshold) || $scope.data.goldMember.threshold <= $scope.data.silverMember.threshold || $scope.data.goldMember.threshold >= $scope.data.platinumMember.threshold
                    || angular.isUndefined($scope.data.platinumMember.threshold) || $scope.data.platinumMember.threshold <= $scope.data.goldMember.threshold) {
                $scope.saveButtonDisabled = true;
            }
            
        }

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.widget', {
            parent: 'settings',
            url: '/widget',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/widget/widget.html',
                    controller: 'WidgetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('WidgetController', WidgetController);

    WidgetController.$inject = ['$scope', '$state', 'SettingsResource', 'Log'];

    function WidgetController($scope, $state, SettingsResource, Log) {

        var vm = this;

        SettingsResource.getAreasAndTables({
        }, onSuccess, onError);

        /*SettingsResource.createArea({
            locationId: 1,
            name: 'Test',
            vip: false

        }, onSuccess, onError);*/

        /*SettingsResource.updateArea({
            id: 1013,
            locationId: 1,
            name: 'Test123',
            vip: true

         }, onSuccess, onError);*/

        /*SettingsResource.deleteArea({
            id: 2
        }, onSuccess, onError);*/


        function onSuccess(data, headers) {
            Log.debug("WidgetController", "HTTP request succeed. Data=" + data.id);
        }

        function onError(error) {
            Log.debug("WidgetController", "HTTP request error." + error);
        }

    }
})();




(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('settings.employees', {
                parent: 'settings',
                url: '/employees',
                data: {
                    authorities: ['ROLE_USER']
                    //,pageTitle: 'seatonApp.allergy.home.title'
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/settings/employees/employees.html',
                        controller: 'SettingsEmployeesController',
                        controllerAs: 'employeesCtrl'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('allergy');
                        $translatePartialLoader.addPart('global');
                        //$translatePartialLoader.addPart('reporting.aggregated');
                        return $translate.refresh();
                    }],
                    locations: function ($q, LocationResource) {
                        return LocationResource.getLocation({}, function (data) {
                            return data;
                        });
                    }
                }
            })
            .state('settings.employees.view', {
                parent: 'settings.employees',
                url: '/view/{id}',
                views: {
                    'content@app': {
                        controller: 'SettingsEmployeeDetailController',
                        controllerAs: 'employeeCtrl',
                        templateUrl: 'app/settings/employees/employee-details.html'
                    }
                }
            });
    }
})();

'use strict';

angular.module('seatonApp').controller('SettingsEmployeesController', SettingsEmployeesController);

SettingsEmployeesController.$inject = ['$q', '$state', '$stateParams', 'EmployeeResource', 'EmployeeService', 'locations', 'LocationResource', 'NgTableParams'];

function SettingsEmployeesController($q, $state, $stateParams, EmployeeResource, EmployeeService, locations, LocationResource, NgTableParams) {
    var vm = this;
    vm.view_mode = 'list'; // 'list', 'box'

    vm.filter = vm.currentFilter = {};
    vm.employee = {};
    vm.locations = locations;
    vm.employees = [];
    vm.selectedAuthority = {
        authority: null
    };
    vm.password_reset = {
        password: '',
        confirm_password: '',
        reset_password: false,
        show_password: false
    };
    vm.loaded = false;

    vm.queries = [
        {name: 'name', direction: 'asc', sort: 'name,desc', filter: {}, desc: 'Sort by name'},
        {
            name: 'avgRevenuePerCover',
            direction: 'desc',
            sort: 'avgRevenuePerCover,desc',
            filter: {},
            desc: 'Sort by average revenue per cover'
        },
        {name: 'noShowRate', direction: 'desc', sort: 'noShowRate,desc', filter: {}, desc: 'Sort by no show rate'},
        {name: 'rating', direction: 'desc', sort: 'rating,desc', filter: {}, desc: 'Sort by ratings'}
    ];
    vm.selectedQuery = getSelectedQuery();

    vm.tableParams = new NgTableParams({
        sorting: {
            name: 'asc',
            avg_revenue_per_cover: 'desc'
        }
    }, {
        counts: [], // disable pagination
        defaultSort: 'asc',
        getData: function (params) {
            var data = vm.employees;
            if (vm.selectedQuery) {
                data = _.sortBy(vm.employees, vm.selectedQuery.name);
                if (vm.selectedQuery.direction === 'desc') {
                    data = data.reverse();
                }
            }
            return data;
        }
    });

    function loadEmployees(locations) {
        return EmployeeResource.getAllEmployees({}, function (data) {
            var enriched = _(data).map(function (emp) {
                return EmployeeService.enrichEmployee(emp, locations);
            });
            vm.employees = enriched;
            vm.loaded = true;
            return enriched;
        }).$promise;
    }

    vm.load = function () {
        loadEmployees(locations);
    };

    vm.load();

    function _getById(id) {
        return _.find(vm.employees, function (employee) {
            return employee.id === id;
        });
    }

    function getSelectedQuery() {
        return _.find(vm.queries, function (q) {
            //return q.name === ($stateParams.query || ViewState.get());
            //TODO CHECK!!
            return q.name === ($stateParams.query );
        }) || vm.queries[0];
    }

    vm.reload = function () {
        vm.tableParams.sorting(vm.selectedQuery.name, vm.selectedQuery.direction);
    };

    vm.back = function () {
        $state.go('^');
    };

    vm.edit = function (id) {
        vm.password_reset.password = "";
        vm.password_reset.confirm_password = "";
        vm.password_reset.resetpassword = false;
        if (id) {
            vm.employee = angular.copy(_getById(id));
            delete vm.employee.role;
            delete vm.employee.location;
            vm.selectedAuthority.authority = vm.employee.authorities[0];
        } else {
            vm.employee = {};
        }
        $state.go('settings.employees.edit', {id: id});
    };

    vm.view = function (id) {
        $state.go('settings.employees.view', {id: id});
    };

    //TODO branimir check
    vm.save = function () {
        vm.employee.authorities = [vm.selectedAuthority.authority];
        if (vm.password_reset.resetpassword && vm.password_reset.password && vm.password_reset.password === vm.password_reset.confirm_password) {
            vm.employee.password = vm.password_reset.password;
        }
        EmployeeResource.save(vm.employee, function () {
            vm.load();
            $state.go('^');
        });
    };


}

'use strict';

angular.module('seatonApp').controller('SettingsEmployeeDetailController', SettingsEmployeeDetailController);

SettingsEmployeeDetailController.$inject = ['$q', '$state', '$document', '$stateParams', '$filter',
    'googleChartApiPromise', 'EmployeeResource', 'EventResource', 'EmployeeService', 'locations', 'NgTableParams',
    'Statistics', 'Reporting', 'Utils', 'ApplicationContext', 'ApplicationProfile'];

function SettingsEmployeeDetailController($q, $state, $document, $stateParams, $filter, googleChartApiPromise,
                                          EmployeeResource, EventResource, EmployeeService, locations, NgTableParams,
                                          Statistics, Reporting, Utils, ApplicationContext, ApplicationProfile) {
    var vm = this;
    vm.tabChange = tabChange;
    vm.employee = {};
    vm.employeeStats = {};
    vm.changedSelectedInterval = changedSelectedInterval;
    vm.openPicker = openPicker;
    vm.viewEvent = viewEvent;
    vm.utils = Utils;

    vm.weeklyPerformance = ApplicationProfile.isEmployeeWeeklyPerformanceEnabled();
    vm.weeklyPerformanceText = ApplicationProfile.upgradeTierText("EmployeeWeeklyPerformance");
    vm.monthlyPerformance = ApplicationProfile.isEmployeeMonthlyPerformanceEnabled();
    vm.monthlyPerformanceText = ApplicationProfile.upgradeTierText("EmployeeMonthlyPerformance");
    vm.openWindow = ApplicationProfile.openAppCloverPage;

    function viewEvent(id) {
        $state.go('reservations.details', {eventId: id});
    }

    vm.dateRanges = {
        'lastWeek': [moment().subtract(1, 'weeks').startOf('week').startOf('day'), moment().subtract(1, 'weeks').endOf('week').endOf('day')],
        'currentWeek': [moment().startOf('week').startOf('day'), moment().endOf('week').endOf('day')]
    };

    vm.selectedInterval = 'currentWeek';
    vm.pickerDate = null;

    vm.filterStartDate = vm.dateRanges[vm.selectedInterval][0].startOf('day');
    vm.filterEndDate = vm.dateRanges[vm.selectedInterval][1].endOf('day');

    vm.order = {field: 'amountSum', reverse: true};

    vm.dynamicOrder = function (item) {
        return item[vm.order.field];
    }

    function changedSelectedInterval() {
        vm.filterStartDate = vm.dateRanges[vm.selectedInterval][0].startOf('day');
        vm.filterEndDate = vm.dateRanges[vm.selectedInterval][1].endOf('day');
        vm.pickerDate = null;
        clearPicker('pickerDate');
        reloadWeeklyPerformance();
    }

    function reloadWeeklyPerformance() {
        var selectedFilter = vm.filterStartDate.toISOString() + vm.filterEndDate.toISOString();
        if (vm.currentFilter != selectedFilter) {
            loadAggregatedByWeekdayData().then(loadWeeklyPerformanceChart).then(windowResize);
        }
    }

    function loadEmployee() {
        return EmployeeResource.getEmployeeWithStats({id: $stateParams.id}, function (employeeData) {
            vm.employee = EmployeeService.enrichEmployee(employeeData.employee, locations);
            vm.employeeStats = employeeData.employeeStats;
            getEmployeeLastActivity();
        }).$promise;
    }

    vm.load = function () {
        $q.all([
            loadEmployee(),
            loadLocationStats(),
            loadEmployees()  //TODO 4 performance optimization - put to global variable?
        ]).then(loadVisitsCharts);
    };

    vm.updateAttribute = function (attribute) {
        EmployeeResource.updateAttribute(
            {
                id: vm.employee.id,
                attribute: attribute,
                value: vm.employee[attribute]
            });
    };

    vm.load();

    //datepicker code
    function getPicker(inputName) {
        return $document.find('input[name="' + inputName + '"]');
    }

    function openPicker(inputName) {
        getPicker(inputName).focus();
    }

    function clearPicker(inputName) {
        getPicker(inputName).val('');
    }

    function dPickerInit(inputName, initDate) {
        var pickerObj
        pickerObj = getPicker(inputName);
        pickerObj.daterangepicker(
            {
                //configuration parameters
                autoUpdateInput: false,
                singleDatePicker: true,
                showDropdowns: true,
                locale: {format: 'MMM D, YYYY'}
            },
            function (start, end, label) {
                //callback function - called on picker value change - dates sent in callback
                if (start != vm.pickerDate) {
                    vm.pickerDate = start;
                    changedPickerDate();
                } else {
                    console.log("Selected date same as existing - no need for reload")
                }
            }
        );

        pickerObj.on('apply.daterangepicker', function (ev, picker) {
            $(this).val(picker.startDate.format('MMM D, YYYY'));
        });

        pickerObj.on('cancel.daterangepicker', function (ev, picker) {
            $(this).val('');
        });

        //initial datepicker values
        //console.log('dPickerInit   2:' + inputName + '   :' + initDate);
        if (initDate != null) {
            pickerObj.data('daterangepicker').setStartDate(moment(initDate));
            pickerObj.data('daterangepicker').setEndDate(moment(initDate));
            pickerObj.val(moment(initDate).format('MMM D, YYYY'));
        }
    }

    function changedPickerDate() {
        if ((typeof vm.pickerDate) != 'string' && vm.pickerDate != null) {
            vm.selectedInterval = '';
            vm.filterStartDate = vm.pickerDate.clone().startOf('week');
            vm.filterEndDate = vm.pickerDate.clone().endOf('week');
            reloadWeeklyPerformance();
        }
    }

    function tabChange(tab) {
        switch (tab) {
            case 'visitStatisticTab':
                $(window).resize();
                break;
            case 'weeklyPerformanceTab':
                if (vm.weeklyPerformance) {
                    vm.order = {field: 'amountSum', reverse: true};
                    loadAggregatedByWeekdayData().then(loadWeeklyPerformanceChart).then(windowResize);
                    $document.ready(
                        function () {
                            dPickerInit('pickerDate', vm.pickerDate);
                        }
                    );
                }
                break;
            case 'monthlyPerformanceTab':
                if (vm.monthlyPerformance) {
                    vm.order = {field: 'amountSum', reverse: true};
                    loadMonthlyPerformanceData().then(loadMonthlyPerformanceChart).then(windowResize);
                }
                break;
        }
    }

    function windowResize() {
        var deferred = $q.defer();
        $(window).resize();
        deferred.resolve(true);
        return deferred.promise;
    }

    function loadLocationStats() {
        //return Statistics.getLocationRegularsStats({}, function (data) {  //use this if regulars only stats are needed
        return Statistics.getCustomerLocationAllVisitsStats({}, function (data) {
            vm.locationStats = data;
            vm.avgSpendPerCover = vm.locationStats.avgSpendByCover;
        }).$promise;
    }

    function loadEmployees() {
        return EmployeeResource.getAllEmployees({}, function (data) {
            vm.employees = data;
            vm.numberOfEmployees = 0;
            _.each(vm.employees, function (item) {
                if (item.active) vm.numberOfEmployees++;
            });
        }).$promise;
    }

    function getEmployeeLastActivity() {
        return EventResource.getEmployeeLastActivity({employeeLogin: vm.employee.cloverId}, function (data) {
            vm.employeeChangeHistory = data;
            console.log('vm.employeeChangeHistory');
            console.log(vm.employeeChangeHistory);

        }).$promise;
    }

    function loadAggregatedByWeekdayData() {
        return EmployeeResource.weeklyPerformance({
            id: vm.employee.id,
            employeeLogin: vm.employee.cloverId,
            startDate: vm.filterStartDate.toISOString(),
            endDate: vm.filterEndDate.toISOString()
        }, function (data) {
            vm.currentFilter = vm.filterStartDate.toISOString() + vm.filterEndDate.toISOString();
            vm.aggrByWeekdayData = data;
            vm.aggrByWeekdayDetailData = vm.aggrByWeekdayData.detailData;
            vm.weeklyStatsTotal = vm.aggrByWeekdayData.statsTotal;

            //console.log("(vm.filterEndDate.diff(vm.filterStartDate, 'days')" + (vm.filterEndDate.diff(vm.filterStartDate, 'days')));
            //console.log(vm.filterStartDate.toISOString());
            //console.log(vm.filterEndDate.toISOString());
            vm.averageRevenuePerDay = vm.aggrByWeekdayData.statsTotal.amountSum / (vm.filterEndDate.diff(vm.filterStartDate, 'days') + 1);

            vm.averageTipsPerDay = vm.aggrByWeekdayData.statsTotal.tipSum / (vm.filterEndDate.diff(vm.filterStartDate, 'days') + 1);
            vm.avgTipsVsRevenuePct = Reporting.divide(vm.averageTipsPerDay, vm.averageRevenuePerDay);

            //calc stat pcts. vs location stats
            for (var i = 0; i < vm.aggrByWeekdayData.detailData.length; i++)
                Reporting.calcAggrByWeekdayDataItem(vm.aggrByWeekdayData.detailData[i], vm.locationStats);
        }).$promise;
    }

    function loadMonthlyPerformanceData() {
        return EmployeeResource.monthlyPerformance({
            id: vm.employee.id,
            employeeLogin: vm.employee.cloverId,
            startDate: moment().subtract(1, 'year').startOf('month').toISOString(),
            endDate: moment().endOf('month').toISOString()
        }, function (data) {
            vm.currentFilter = vm.filterStartDate.toISOString() + vm.filterEndDate.toISOString();
            vm.aggrByMonthData = data.statsByGroup;
            vm.monthlyStatsTotal = data.statsTotal

            vm.averageRevenuePerMonth = vm.monthlyStatsTotal.amountSum / 13;
            vm.averageTipsPerMonth = vm.monthlyStatsTotal.tipSum / 13;
            vm.avgTipsVsRevenuePct_monthly = Reporting.divide(vm.averageTipsPerMonth, vm.averageRevenuePerMonth);

            //calc stat pcts. vs location stats
            for (var i = 0; i < vm.aggrByMonthData.length; i++)
                Reporting.calcAggrByWeekdayDataItem(vm.aggrByMonthData[i], vm.locationStats);
        }).$promise;
    }

    function loadMonthlyPerformanceChart() {
        var deferred = $q.defer();

        // Spend trend

        var dataTrend = new google.visualization.DataTable();
        dataTrend.addColumn('string', 'Month');
        dataTrend.addColumn('number', 'Revenue');
        dataTrend.addColumn('number', 'Tips');
        dataTrend.addColumn({type: 'string', role: 'annotation'});

        for (var i = 0; i < vm.aggrByMonthData.length; i++) {
            var item = vm.aggrByMonthData[i];
            dataTrend.addRow(
                [
                    item.groupedItemShortDisplayName,
                    {
                        v: item.amountSum,
                        f: $filter('currency')(item.amountSum)
                    },
                    {
                        v: item.tipSum,
                        f: $filter('currency')(item.tipSum)
                    },
                    $filter('currency')(item.amountSum + item.tipSum)
                ]);
        }

        /*
         dataTrend.addRows([
         ['Jun 14', 50000, 6500, '$56.500'],
         ['Jul 14', 47500, 5500, '$53.000'],
         ['Aug 14', 42500, 4500, '$47.000'],
         ['Sep 14', 72500, 9500, '$82.000'],
         ['Oct 14', 82500, 10000, '$92.500'],
         ['Nov 14', 87500, 11000, '$98.500'],
         ['Dec 14', 83500, 10500, '$84.000'],
         ['Jan 15', 107500, 12500, '$120.000'],
         ['Feb 15', 62500, 9500, '$72.000'],
         ['Mar 15', 80000, 11000, '$91.000'],
         ['Apr 15', 90000, 13500, '$103.500'],
         ['May 15', 60000, 8000, '$68.000']
         ]);
         */

        var optionsTrend = {
            isStacked: 'true',
            //width: 1050,
            height: 425,
            vAxis: {
                title: 'Revenue in ' + ApplicationContext.getCurrencySym(),
                textPosition: 'none',
                gridlines: {count: 13}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },
            hAxis: {
                title: 'Month',
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },
            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            chartArea: {width: '85%', height: '65%'},
            formatters: {},
            colors: ['#1ABC9C', '#3399CC'],
            legend: {position: 'top', alignment: 'end'}
        };

        vm.chartObjectTrend = {
            type: "ColumnChart",
            options: optionsTrend,
            data: dataTrend
        };

        deferred.resolve(true);
        return deferred.promise;
    }

    function loadWeeklyPerformanceChart() {
        var deferred = $q.defer();

        // Week performance statistics
        var dataDays = new google.visualization.DataTable();
        dataDays.addColumn('string', 'Day');
        dataDays.addColumn('number', 'Revenue');
        dataDays.addColumn('number', 'Tips');
        dataDays.addColumn({type: 'string', role: 'annotation'});


        for (var i = 0; i < vm.aggrByWeekdayData.chartData.length; i++) {
            var item = vm.aggrByWeekdayData.chartData[i];
            var detailDataItem = vm.aggrByWeekdayData.detailData[i];
            dataDays.addRow(
                [
                    item.intervalUnit,
                    {
                        v: item.sumTotal,
                        f: $filter('currency')(item.sumTotal)
                    },
                    {
                        v: detailDataItem.tipSum,
                        f: $filter('currency')(detailDataItem.tipSum)
                    },
                    $filter('currency')(item.sumTotal + detailDataItem.tipSum)
                ]);
        }

        var optionsDays = {
            isStacked: 'true',
            //width: 1000,
            height: 400,
            vAxis: {
                title: 'Revenue in ' + ApplicationContext.getCurrencySym(),
                textPosition: 'none',
                gridlines: {count: 13}, viewWindow: {min: 0},
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },
            hAxis: {
                title: 'Days of the Week',
                titleTextStyle: {color: '#1ab394', fontSize: 14, bold: true}
            },

            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 11,
                    bold: 'true',
                    color: '#000',
                    auraColor: 'none'
                }
            },
            chartArea: {width: '80%', height: '65%'},
            colors: ['#1ABC9C', '#3399CC'],
            formatters: {},
            legend: {position: 'top', alignment: 'end'}
        };

        vm.chartObjectWeekPerf = {
            type: 'ColumnChart',
            options: optionsDays,
            data: dataDays
        };
        deferred.resolve(true);
        return deferred.promise;
    }


    function loadVisitsCharts() {
        var deferred = $q.defer();

        //vistis - general pie chart
        vm.chartObjectVisitGeneral = {};
        vm.chartObjectVisitGeneral.type = "PieChart";

        vm.chartObjectVisitGeneral.options = {
            title: 'Visit statistics',
            legend: {position: 'right'},
            //width: 450,
            height: 350,

            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#3399CC'},
                2: {color: '#996699'},
            },
            chartArea: {width: '85%', height: '65%'}
        };

        vm.chartObjectVisitGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Reservation"},
                        {v: vm.employee.totalReservationShow},
                    ]
                },
                {
                    c: [
                        {v: "Walk-In Seated"},
                        {v: vm.employee.totalWalkinSeated}
                    ]
                },
                {
                    c: [
                        {v: "Walk-In Waitlist"},
                        {v: vm.employee.totalWaitlistShow},
                    ]
                }
            ]
        };

        //reservation - general pie chart
        vm.chartObjectReservationGeneral = {};
        vm.chartObjectReservationGeneral.type = "PieChart";

        vm.chartObjectReservationGeneral.options = {
            title: 'Reservation statistics',
            legend: {position: 'right'},
            //width: 450,
            height: 350,

            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#FF3333'},
                2: {color: '#FFCC33'},
            },
            chartArea: {width: '85%', height: '65%'}
        };

        vm.chartObjectReservationGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Show"},
                        {v: vm.employee.totalReservationShow},
                    ]
                },
                {
                    c: [
                        {v: "No Show"},
                        {v: vm.employee.totalReservationNoShow}
                    ]
                },
                {
                    c: [
                        {v: "Canceled"},
                        {v: vm.employee.totalReservationCanceled},
                    ]
                }
            ]
        };


        //waitlist - general pie chart
        vm.chartObjectWaitlistGeneral = {};
        vm.chartObjectWaitlistGeneral.type = "PieChart";

        vm.chartObjectWaitlistGeneral.options = {
            title: 'Waitlist statistics',
            legend: {position: 'right'},
            //width: 450,
            height: 350,

            slices: {
                0: {color: '#1ABC9C'},
                1: {color: '#FF3333'},
                2: {color: '#FFCC33'},
            },
            chartArea: {width: '85%', height: '65%'}

        };

        vm.chartObjectWaitlistGeneral.data = {
            "cols": [
                {id: "t", label: "Type", type: "string"},
                {id: "s", label: "Number", type: "number"}
            ], "rows": [
                {
                    c: [
                        {v: "Show"},
                        {v: vm.employee.totalWaitlistShow},
                    ]
                },
                {
                    c: [
                        {v: "No Show"},
                        {v: vm.employee.totalWaitlistNoShow}
                    ]
                },
                {
                    c: [
                        {v: "Canceled"},
                        {v: vm.employee.totalWaitlistCanceled},
                    ]
                }
            ]
        };
        deferred.resolve(true);
        return deferred.promise;
    }
}

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.online', {
            abstract: true,
            parent: 'settings',
            url: '/online',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_OWNER', 'ROLE_MANAGER']
            },
            resolve: {
                googleChartApi: function (googleChartApiPromise) {
                    return googleChartApiPromise;
                }
            }
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.online.waitlist', {
            parent: 'settings.online',
            url: '/waitlist',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/online/availability/availability.html',
                    controller: 'OnlineWaitlistController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('OnlineWaitlistController', OnlineWaitlistController);

    OnlineWaitlistController.$inject = ['$scope', '$state', '$document', 'SettingsResource', 'Log', '$uibModal', 'ApplicationContext', '$timeout'];

    function OnlineWaitlistController($scope, $state, $document, SettingsResource, Log, $uibModal, ApplicationContext, $timeout) {

        var vm = this;
        vm.position_options = [
            {id: 1, name: 'left page edge'},
            {id: 2, name: 'right page edge'},
            {id: 3, name: 'bottom page edge'},
            {id: 4, name: 'top page edge'}
        ];

        vm.padding_options = [
            {id: 0, name: 'start of window'},
            {id: 25, name: '1/4 of window'},
            {id: 33, name: '1/3 of window'},
            {id: 50, name: '1/2 of window'},
            {id: 66, name: '2/3 of window'},
            {id: 75, name: '3/4 of window'},
            {id: 100, name: 'end of window'}
        ];

        vm.font_size = [
            {id: 8, name: '8px'},
            {id: 9, name: '9px'},
            {id: 10, name: '10px'},
            {id: 11, name: '11px'},
            {id: 12, name: '12px'},
            {id: 14, name: '14px'},
            {id: 16, name: '16px'},
            {id: 18, name: '18px'},
            {id: 20, name: '20px'},
            {id: 22, name: '22px'},
            {id: 24, name: '24px'}
        ];

        vm.threshold_options = [
            {id: 10, name: '10%'},
            {id: 20, name: '20%'},
            {id: 30, name: '30%'},
            {id: 40, name: '40%'},
            {id: 50, name: '50%'},
            {id: 60, name: '60%'},
            {id: 70, name: '70%'},
            {id: 80, name: '80%'},
            {id: 90, name: '90%'}
        ];


        $document.ready(
            function () {

                vm.div_slider_transparency = $document.find('#slider_transparency');
                vm.div_slider_transparency.ionRangeSlider({
                    min: 0,
                    max: 90,
                    step: 1.00,
                    from: 0,
                    postfix: "%",
                    prettify: true,
                    grid: true,
                    decorate_both: true,
                    onChange: function (data) {
                        //vm.transparency = vm.slider_transparency.result.from;
                        vm.custo.transparency = data.from;
                        vm.updatePreview();
                    }
                });
                vm.slider_transparency = vm.div_slider_transparency.data("ionRangeSlider");
                load();
            }
        );

        function load() {
            SettingsResource.getOnlineWaitlistCustomization({}, onSuccessCustomisationDto, onErrorGetData);
            SettingsResource.getAvailabilityIntegrationScript({}, onIntegrationScriptFetched, onErrorGetData);
        }

        function onSuccessCustomisationDto(data) {
            vm.custo = data;
            vm.custo.transparency = vm.custo.transparency != null ? vm.custo.transparency : 0;
            vm.slider_transparency.update({from: vm.custo.transparency});
            $timeout(function(){
                // ugly workaround since ng-change does not work with the chosen color picker
                $scope.$watch('[vm.custo.backgroundColor, vm.custo.textColor, vm.custo.backgroundColorHover, vm.custo.textColorHover, vm.custo.buttonLineColor]',
                    function () {
                        vm.updatePreview();
                    }, true);
            }, 500);
        }

        function onIntegrationScriptFetched(data) {
            vm.integrationScript = data.content
            // insertin teh script tag to the preview iframe
            var doc = document.getElementById('previewFrame').contentWindow.document;
            doc.open();
            doc.write(vm.integrationScript);
            doc.close();
        }

        function onErrorGetData(error) {
            console.log("HTTP request error." + error);
        }

        vm.save = function () {
            console.log('vm.custo', vm.custo);
            SettingsResource.saveOnlineWaitlistCustomization(
                vm.custo,
                function (data) {
                    console.log("Updates success");
                    console.log(data);
                    //SweetAlert.swal("Updated", "", "success");
                }
            )
        }

        vm.updatePreview = function() {
            document.getElementById("previewFrame").contentWindow["SeatOn" + ApplicationContext.getLocationID()].updatePreview('availability', vm.custo);
        }

        //var iframe = $document.find('preview');
        //console.log(iframe);
        //var innerDoc = (iframe.contentDocument) ? iframe.contentDocument : iframe.contentWindow.document;

        //var ulObj = innerDoc.getElementById("buton");


        //$scope.closeAvailabilityStatusDialog = function() {
        //    vm.availbilityDialog.dismiss('cancel');
        //}

        $scope.showAvailabilityStatusDialog = function (type) {
            vm.type = type;
            vm.availbilityDialog = $uibModal.open({
                templateUrl: 'app/settings/online/availability/preview.status.message.html',
                scope: this
            });
        }

        //$scope.showAvailabilityStatusDialog = function on() {
        //    document.getElementById("overlay").style.display = "block";
        //}

        //function off() {
        //    document.getElementById("overlay").style.display = "none";
        //}

        vm.copyToClipboard = function() {
            var copyText = document.getElementById("onlineWaitlistCode");
            copyText.disabled = false;
            copyText.select();
            document.execCommand("Copy");
            copyText.disabled = true;
        }

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.timeslot', {
            parent: 'settings',
            url: '/timeslot',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/timeslot/timeslot.html',
                    controller: 'TimeSlotController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('TimeSlotController', TimeSlotController);

    TimeSlotController.$inject = ['$scope', '$state', 'SettingsResource', 'Log', '$location', '$uibModal', '$document',
                                'ApplicationContext', 'ListUtils', 'SweetAlert', 'Utils'];

    var DATE_FORMAT = 'YYYY-MM-DD';
    var TIME_SERVER_FORMAT = 'HH:mm:ss.SSS';
    var TIME_DISPLAY_FORMAT = 'HH:mm';
    var DATE_PICKER_FORMAT = 'MMM D, YYYY';

    function TimeSlotController($scope, $state, SettingsResource, Log, $location, $uibModal, $document,
                               ApplicationContext, ListUtils, SweetAlert, Utils) {

        var vm = this;
        vm.formatMinutes = Utils.formatMinutes;
        vm.formatAmount = Utils.formatAmount;

        vm.timeStepList = ListUtils.getTimeStepList();
        $scope.createTimeslotListModelVisible = false;


        SettingsResource.getTimeSlotSetList({}, onLoadSuccess, onError);

        function onLoadSuccess(data, headers) {
            vm.timeSlotSetList = data;
        }

        SettingsResource.getTimeSlotSettings({}, onSuccess, onError);


        function onSuccess(data, headers) {
            vm.data = data;
        }

        function onError(error) {
            Log.debug("settings.timeslot", "HTTP request error." + error);
        }


        vm.saveOfflineSettings = function() {
            SettingsResource.saveOfflineTimeSlotSettings(vm.data);
        }

        vm.saveOnlineSettings = function() {
            SettingsResource.saveOnlineTimeSlotSettings(vm.data);
        }

        vm.saveLimitationTimeSlotSettings = function() {
            SettingsResource.saveLimitationTimeSlotSettings(vm.data);
        }

        $scope.showCreateTimeSlotList = function(){
            vm.newTimeSlotList = {
                limitPolicy: 'NONE',
                    limitScope: 'ONLINE_ONLY'
            }
            $scope.createTimeslotListModelVisible = true;
        }

        $scope.showUpdateTimeSlotList = function(timeSlotSet){
            vm.newTimeSlotList = timeSlotSet;
            $scope.createTimeslotListModelVisible = true;
        }

        $scope.hideCreateTimeSlotList = function(){
            $scope.createTimeslotListModelVisible = false;
        }

        $scope.createTimeSlotList = function(){
            SettingsResource.saveTimeSlotSet(vm.newTimeSlotList, onSuccessRefresh);

            function onSuccessRefresh(data, headers) {
                vm.timeSlotSetList = data;
                $scope.createTimeslotListModelVisible = false;
            }

        }


        vm.manageTimeSlotSet = function (timeSlotSet) {

            SettingsResource.timeSlotSetDetails({'timeSlotSetId': timeSlotSet.id}, onSuccessModal, onError);

            vm.manageTimeSlotModal = $uibModal.open({
                templateUrl: 'app/settings/timeslot/timeslot_manage.html',
                scope: $scope,
                size: 'lg'
            });
        }

        vm.addTimeSlot = function(setId, dayId, lim, hours, mins, amPm) {
            var definedTime = hours + ':' + mins + ' '+ amPm;
            var slotToAdd = {
                timeSlotSetId: setId,
                dayInWeek: dayId,
                slotTime: definedTime,
                slotLimit: lim
            }

            SettingsResource.saveTimeSlot(slotToAdd, onSuccessModal, onError);

        }

        vm.deleteTimeSlotSet = function(timeSlotSetId) {
            SweetAlert.swal({
                    title: "Confirm action",
                    text: "Do you want to delete time slot set?",
                    type: "warning",
                    showCancelButton: true,
                    cancelButtonColor: "#ec4758",
                    confirmButtonColor: "#1ab394",
                    cancelButtonText: "No",
                    confirmButtonText: "Yes",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        SettingsResource.deleteTimeSlotSet({'timeSlotSetId': timeSlotSetId}, onSuccessDelete, onError);
                    }
                });

            function onSuccessDelete(data, headers) {
                if(data) onLoadSuccess(data, headers);
            }

        }

        vm.deleteTimeSlot = function(timeSlot) {

            SettingsResource.deleteTimeSlot(timeSlot, onSuccessModal, onError);

        }

        function onSuccessModal(data, headers) {
            vm.newSlot = {
                maxReservationsSlot: -1
            };
            vm.timeSlotSetModal = data;
        }


        $scope.closeTimeSlotManageModal = function() {
            vm.manageTimeSlotModal.dismiss('cancel');
        }

        vm.validTimeSlotEntry = function() {
            if(vm.newSlot) {
                if(vm.newSlot.hour && vm.newSlot.mins && vm.newSlot.amPm) return false;
            }
            return true;
        }

        vm.definitionDesc = function(scope) {
            if(scope) return "Same for each day in week";
            else return "Different for each day in week";
        }

        vm.limitPolicyDesc = function(limitPolicy) {
            if(limitPolicy=='PERSON') return "Per person";
            else if (limitPolicy=='PERSON') return "Per event";
            else return "None";
        }

        vm.limitScopeDesc = function(limitScope) {
            if(limitScope=='ONLINE_ONLY') return "Consider only online reservations";
            else return "Consider all reservations";
        }


        vm.maxReservationSlotList = [
            {id: -1, name: 'No restriction'},
            {id: 1, name: '1 per time slot'},
            {id: 2, name: '2 per time slot'},
            {id: 3, name: '3 per time slot'},
            {id: 4, name: '4 per time slot'},
            {id: 5, name: '5 per time slot'},
            {id: 6, name: '6 per time slot'},
            {id: 7, name: '7 per time slot'},
            {id: 8, name: '8 per time slot'},
            {id: 9, name: '9 per time slot'},
            {id: 10, name: '10 per time slot'},
            {id: 11, name: '11 per time slot'},
            {id: 12, name: '12 per time slot'},
            {id: 13, name: '13 per time slot'},
            {id: 14, name: '14 per time slot'},
            {id: 15, name: '15 per time slot'},
            {id: 16, name: '16 per time slot'},
            {id: 17, name: '17 per time slot'},
            {id: 18, name: '18 per time slot'},
            {id: 19, name: '19 per time slot'},
            {id: 20, name: '20 per time slot'},
            {id: 25, name: '25 per time slot'},
            {id: 30, name: '30 per time slot'},
            {id: 35, name: '35 per time slot'},
            {id: 40, name: '40 per time slot'},
            {id: 45, name: '45 per time slot'},
            {id: 50, name: '50 per time slot'},
            {id: 55, name: '55 per time slot'},
            {id: 60, name: '60 per time slot'},
            {id: 65, name: '65 per time slot'},
            {id: 70, name: '70 per time slot'},
            {id: 75, name: '75 per time slot'},
            {id: 80, name: '80 per time slot'},
            {id: 85, name: '85 per time slot'},
            {id: 90, name: '90 per time slot'},
            {id: 95, name: '95 per time slot'},
            {id: 100, name: '100 per time slot'},
            {id: 125, name: '125 per time slot'},
            {id: 150, name: '150 per time slot'},
            {id: 175, name: '175 per time slot'},
            {id: 200, name: '200 per time slot'}
        ];

        vm.maxReservationsSlotScopeList = [
            {id: 'ALL', name: 'consider all reservations.'},
            {id: 'ONLINE_ONLY', name: 'consider only online reservations.'}
        ];

        vm.maxReservationsSlotScopeListOnline = [
            {id: 'ONLINE_ONLY', name: 'consider only online reservations.'}
        ];


        vm.timeSlotScopeTypes = [
            {id: 'ALL', name: 'All channels'},
            {id: 'ONLINE', name: 'Online channel only'},
            {id: 'NON_ONLINE', name: 'Non-online channels'}
        ];

        vm.limitationPolicyType = [
            {id: 'NONE', name: 'No limitation'},
            {id: 'EVENT', name: 'Limit per number of reservation events'},
            {id: 'PERSON', name: 'Limit per number of persons'}
        ];

        vm.getLimitPolicyDesc = function(policy) {
            var find = vm.limitationPolicyType.find(function(element, index) {
               if(element.id == policy) return true;
            });

            if(find) return find.name;
            return "No policy";
        }

        vm.daysInWeek = [
            {id: 1, name: 'Monday'},
            {id: 2, name: 'Tuesday'},
            {id: 3, name: 'Wednesday'},
            {id: 4, name: 'Thursday'},
            {id: 5, name: 'Friday'},
            {id: 6, name: 'Saturday'},
            {id: 7, name: 'Sunday'}
        ];

        vm.minBeforeList  = [
            {id: -1, name: 'meal duration before (*)'},
            {id: 0, name: 'same as'},
            {id: 15, name: '15 minutes before'},
            {id: 30, name: '30 minutes before'},
            {id: 45, name: '45 minutes before'},
            {id: 60, name: '1 hour before'},
            {id: 75, name: '1 hour 15 minutes before'},
            {id: 90, name: '1 hour 30 minutes before'},
            {id: 105, name: '1 hour 45 minutes before'},
            {id: 120, name: '2 hours before'},
            {id: 150, name: '2 hours 30 minutes before'},
            {id: 180, name: '3 hours before'},
            {id: 240, name: '4 hours before'}
        ];

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.online.reservation', {
            abstract: true,
            parent: 'settings.online',
            url: '/reservation',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_OWNER', 'ROLE_MANAGER']
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.online.reservation.settings', {
            parent: 'settings.online.reservation',
            url: '/settings',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/online/reservation/settings/settings.html',
                    controller: 'OnlineReservationSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('OnlineReservationSettingsController', OnlineReservationSettingsController);

    OnlineReservationSettingsController.$inject = ['$scope', '$state', '$document', 'SettingsResource', 'Log', '$uibModal', 'ApplicationContext', '$timeout', 'SweetAlert'];

    var DATE_FORMAT = 'YYYY-MM-DD';
    var DATE_PICKER_FORMAT = 'MMM D, YYYY';

    function OnlineReservationSettingsController($scope, $state, $document, SettingsResource, Log, $uibModal, ApplicationContext, $timeout, SweetAlert) {

        var vm = this;
        vm.currencySymbol = ApplicationContext.getCurrencySym();
        vm.option = {};
        vm.locationId = ApplicationContext.getLocationID();

        $document.ready(
            function () {

                // date picker settings
                vm.datePicker = $document.find('input[name="datePicker"]');
                vm.datePicker.daterangepicker(
                    {
                        singleDatePicker: true,
                        showDropdowns: true,
                        locale: {format: DATE_PICKER_FORMAT}
                    },
                    function (start, end, label) {
                        vm.selectedDay = start.format(DATE_FORMAT);
                        vm.disableUntil = moment(vm.selectedDay, DATE_FORMAT).format(DATE_PICKER_FORMAT);
                    }
                );
                vm.datePicker.val(vm.disableUntil);

                // slider settings
                vm.div_slider_transparency = $document.find('#slider_transparency');
                vm.div_slider_transparency.ionRangeSlider({
                    min: 0,
                    max: 90,
                    step: 1.00,
                    from: 0,
                    postfix: "%",
                    prettify: true,
                    grid: true,
                    decorate_both: true,
                    onChange: function (data) {
                        //vm.transparency = vm.slider_transparency.result.from;
                        vm.custo.transparency = data.from;
                        vm.updateBtnPreview();
                    }
                });
                vm.slider_transparency = vm.div_slider_transparency.data("ionRangeSlider");
                load();
            }
        );

        vm.openDatePicker = function () {
            vm.datePicker.focus();
        }

        function getBaseURL() {
            var baseUrl = window.location.protocol + '//' + window.location.hostname;
            if (window.location.port) {
                baseUrl += ':' + window.location.port;
            }
            return baseUrl;
        }

        function load() {
            SettingsResource.getOnlineReservationCustomization({}, onSuccessCustomisationDto, onErrorGetData);
            SettingsResource.getAvailabilityIntegrationScript({}, onIntegrationScriptFetched, onErrorGetData);
        }

        function onSuccessCustomisationDto(data) {
            vm.custo = data;
            vm.custo.transparency = vm.custo.transparency != null ? vm.custo.transparency : 0;
            if(vm.slider_transparency!=null) vm.slider_transparency.update({from: vm.custo.transparency});
            $timeout(function () {
                // ugly workaround since ng-change does not work with the chosen color picker
                $scope.$watch('[vm.custo.backgroundColor, vm.custo.textColor, vm.custo.backgroundColorHover, vm.custo.textColorHover, vm.custo.buttonLineColor]',
                    function () {
                        vm.updateBtnPreview();
                    }, true);
            }, 500);

            var baseUrl = getBaseURL();
            vm.hashedLocationId = data.hashedLocationId;
            vm.onlineResAnchor = baseUrl + '?channel=merchant_web#/public/online/reservation/' + data.hashedLocationId;
            vm.onlineResButton = '<button onClick="' + baseUrl + '?channel=merchant_web#/public/online/reservation/' + data.hashedLocationId + '" target="_blank" >MAKE A RESERVATION</button>';
            vm.onlineResLocal = '?channel=merchant_web#/public/online/reservation/' + data.hashedLocationId;
            vm.onlineResGoogleAnchor = baseUrl + '?channel=google#/public/online/reservation/' + data.hashedLocationId;
            vm.onlineResFacebookAnchor = baseUrl + '?channel=facebook#/public/online/reservation/' + data.hashedLocationId;
            vm.onlineResFacebookPost = "Book now using the following link: " + vm.onlineResFacebookAnchor;
            vm.updateWidgetPreview();
        }

        function onIntegrationScriptFetched(data) {
            vm.integrationScript = data.content;
            // inserting the script tag to the preview the floating button iframe
            if(document.getElementById('btnPreviewFrame')!=null) {
                var doc = document.getElementById('btnPreviewFrame').contentWindow.document;
                doc.open();
                doc.write(vm.integrationScript);
                doc.close();
            }
        }

        function onErrorGetData(error) {
            console.log("HTTP request error." + error);
        }

        vm.save = function () {
            // check if temporary disabled date and time are defined
            if(vm.custo.status=="1" && (vm.custo.disableUntilDate == undefined || vm.custo.disableUntilTime == undefined)) {
                SweetAlert.swal({
                        title: "Online reservation settings not saved.",
                        text: "Please define date and time until online reservation is disabled!",
                        type: "error",
                        showCancelButton: false,
                        confirmButtonColor: "#1ab394",
                        confirmButtonText: "OK",
                        closeOnConfirm: true
                    },
                    function (isConfirm) {
                    });
            } else {
                SettingsResource.saveOnlineReservationCustomization(
                    vm.custo,
                    function (data) {
                    }
                )
            }

        }


        vm.changeReservationPage = function() {
            if(vm.custo.reservationPage =="RESERVE") {
                SettingsResource.canActivateReservePage(
                    {},
                    function (data) {
                        var message = "";
                        var canSwitch = true;
                        if(data.seatingOptionExist==false) {
                            canSwitch = false;
                            message = "Please define at least one seating option before switching to NEW online reservation page!"
                        }
                        if(data.noOpenPreReservation==false) {
                            canSwitch = false;
                            message = message + "Please assign table or cancel all open pre-reservation event before switching to NEW online reservation page! "
                        }
                        if(!canSwitch) {
                            vm.custo.reservationPage="LEGACY"
                            SweetAlert.swal({
                                    title: "Switch to new reservation page not possible!",
                                    text: message,
                                    type: "warning",
                                    showCancelButton: false,
                                    confirmButtonColor: "#1ab394",
                                    confirmButtonText: "OK",
                                    closeOnConfirm: true
                                },
                                function (isConfirm) {
                                });
                        }
                    }
                );
            }

        }

        vm.loadSeatingOptions = function () {
            Log.debug("OnlineReservationSettingsController","enter seating option tab");
            SettingsResource.getSeatingOptionSettings({}, updateSeatingOptionSettings);
        }

        vm.saveSeatingOption = function() {
            vm.option.areaList = getSelectedAreas();
            SettingsResource.saveSeatingOption(vm.option, updateSeatingOptionSettings);
        }

        vm.editSeatingOption = function(option) {
            Log.debug("Seating controller","Seating option id "+option.id);
            vm.option = option;
            vm.option.areaList.forEach(
                function(area) {
                    area.selected = true;
                }
            );
            if(!vm.availableAreasOriginal) vm.availableAreasOriginal = [];
            vm.availableAreas = vm.availableAreasOriginal.concat(vm.option.areaList);
        }

        vm.deleteSeatingOption = function(option) {
            SweetAlert.swal({
                    title: "Confirm seating option deletion",
                    text: "Do you want to delete seating option from settings?",
                    type: "warning",
                    showCancelButton: true,
                    cancelButtonColor: "#ec4758",
                    confirmButtonColor: "#1ab394",
                    cancelButtonText: "No",
                    confirmButtonText: "Yes",
                    closeOnConfirm: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        SettingsResource.deleteSeatingOption({'id': option.id}, updateSeatingOptionSettings);
                    }
                });

        }

        vm.reOrderOption = function(sourceId, destinationId) {
            var reOrderIds = {
                'sourceId': sourceId,
                'destinationId': destinationId
            }

            SettingsResource.reOrderSeatingOption(reOrderIds, updateSeatingOptionSettings);

        }

        vm.validateInput = function() {
            if(!vm.option || !vm.option.name || !vm.option.label) return true;
            if (vm.availableAreas) {
                for (var i = 0; i < vm.availableAreas.length; i++) {
                    if (vm.availableAreas[i].selected === true) {
                        return false
                    }
                }
            }
            return true;
        }

        function updateSeatingOptionSettings(data) {
            vm.seatingOptions = data.seatingOptionList;
            vm.availableAreas = data.areas;
            vm.availableAreasOriginal = data.areas;
            vm.timeSlotSetList = data.timeSlotSetList;
            vm.option = {};
        }

        function getSelectedAreas() {
            var selectedAreaList = [];

            if (vm.availableAreas) {
                for (var i = 0; i < vm.availableAreas.length; i++) {
                    if (vm.availableAreas[i].selected === true) {
                        selectedAreaList.push(vm.availableAreas[i]);
                    }
                }
            }
            return selectedAreaList;
        }

        function setSelectedAreas(selectedAreaList) {

            if (vm.availableAreas) {
                for (var i = 0; i < vm.availableAreas.length; i++) {
                    if (vm.availableAreas[i].selected === true) {
                        areaIdList.push(vm.availableAreas[i]);
                    }
                }
            } else {
                vm.availableAreas =  selectedAreaList;
            }
            return areaIdList;
        }



        vm.updateBtnPreview = function () {
            if(document.getElementById("btnPreviewFrame")!=null) {
                document.getElementById("btnPreviewFrame").
                    contentWindow["SeatOn" + ApplicationContext.getLocationID()].updatePreview('reservations', vm.custo);
            }
        }

        vm.updateWidgetPreview = function () {

            if (!vm.hashedLocationId) return;

            var baseUrl = getBaseURL();
            vm.widgetFrameSrc = baseUrl + "/content/widgets/widget.html?loc=" + vm.hashedLocationId + "&type=" + vm.custo.widgetType + "&bkg=" + vm.custo.widgetBackground;
            var width, height;
            if (vm.custo.widgetType === 'HORIZONTAL') {
                var width = vm.custo.enableManualDuration ? 1000 : 820;
                var height = 335;
                vm.inlineWidgetCode = '<iframe frameBorder="0" scrolling="no" width="' + width + '" height="' + height + '" src="' + baseUrl + '/content/widgets/widget.html?loc=' + vm.hashedLocationId + '&type=' + vm.custo.widgetType + '&bkg=' + vm.custo.widgetBackground + '"></iframe>';
            } else {  // vertical
                var width = 235;
                var height = vm.custo.enableManualDuration ? 350 : 335;
                vm.inlineWidgetCode = '<iframe frameBorder="0" scrolling="no" width="' + width + '" height="' + height + '" src="' + baseUrl + '/content/widgets/widget.html?loc=' + vm.hashedLocationId + '&type=' + vm.custo.widgetType + '&bkg=' + vm.custo.widgetBackground + '"></iframe>';
            }

            vm.widgetTypeHorizontalDesc = 'Horizontal (' + width + ' x ' + height + ' px)';
            vm.widgetTypeVerticalDesc = 'Vertical (' + width + ' x ' + height + ' px)';
        }

        vm.copyToClipboard = function (elementId) {
            var copyText = document.getElementById(elementId);
            copyText.disabled = false;
            copyText.select();
            document.execCommand("Copy");
            copyText.disabled = true;
        }

        vm.testAreas = [
            {id: 1, name: 'Jako dugi naziv area koji nece ...'},
            {id: 2, name: '2 hours'},
            {id: 3, name: '3 hours'},
            {id: 4, name: '4 hours'},
            {id: 6, name: '6 hours'},
            {id: 12, name: '12 hours'},
            {id: 14, name: '24 hours'}
        ];

        vm.maxDurationList = [
            {id: 1, name: '1 hour'},
            {id: 2, name: '2 hours'},
            {id: 3, name: '3 hours'},
            {id: 4, name: '4 hours'},
            {id: 6, name: '6 hours'},
            {id: 12, name: '12 hours'},
            {id: 14, name: '24 hours'}
        ];

        vm.minDurationList = [
            {id: 15, name: '15 min'},
            {id: 30, name: '30 min'},
            {id: 60, name: '1 hour'},
            {id: 120, name: '2 hours'}
        ];

        vm.timeStepList = [
            {id: 15, name: '15 min'},
            {id: 30, name: '30 min'},
            {id: 60, name: '1 hour'},
            {id: 90, name: '1 hour 30 min'},
            {id: 120, name: '2 hours'}
        ];

        vm.timeBetweenEventsist = [
            {id: 0, name: '0 min'},
            {id: 5, name: '5 min'},
            {id: 10, name: '10 min'},
            {id: 15, name: '15 min'},
            {id: 20, name: '20 min'},
            {id: 25, name: '25 min'},
            {id: 30, name: '30 min'},
            {id: 45, name: '45 min'},
            {id: 60, name: '1 hour'},
            {id: 90, name: '1 hour 30 min'},
            {id: 120, name: '2 hours'}
        ];


        vm.cancelTimeList = [
            {id: 0, name: 'any time'},
            {id: 30, name: '30 min'},
            {id: 60, name: '1 hour'},
            {id: 90, name: '1 hour 30 min'},
            {id: 120, name: '2 hours'},
            {id: 180, name: '3 hours'},
            {id: 240, name: '4 hours'},
            {id: 360, name: '6 hours'},
            {id: 720, name: '12 hours'},
            {id: 1440, name: '1 day'},
            {id: 2880, name: '2 days'},
            {id: 4320, name: '3 days'},
            {id: 5760, name: '4 days'},
            {id: 7200, name: '5 days'},
            {id: 8640, name: '6 days'},
            {id: 10080, name: '7 days'}
        ];

        vm.leadTime = [
            {id: 0, name: 'No lead time'},
            {id: 15, name: '15 min'},
            {id: 30, name: '30 min'},
            {id: 30, name: '45 min'},
            {id: 60, name: '1 hour'},
            {id: 90, name: '1 hour 30 min'},
            {id: 120, name: '2 hours'},
            {id: 150, name: '2 hours 30 min'},
            {id: 180, name: '3 hours'},
            {id: 240, name: '4 hours'},
            {id: 360, name: '6 hours'},
            {id: 480, name: '8 hours'},
            {id: 600, name: '10 hours'},
            {id: 720, name: '12 hours'},
            {id: 1440, name: '1 day'},
            {id: 2880, name: '2 days'}
        ];

        vm.maxReservationSlotList = [
            {id: -1, name: 'No restriction while available resources exist'},
            {id: 1, name: '1 reservation per time slot'},
            {id: 2, name: '2 reservations per time slot'},
            {id: 3, name: '3 reservations per time slot'},
            {id: 4, name: '4 reservations per time slot'},
            {id: 5, name: '5 reservations per time slot'},
            {id: 6, name: '6 reservations per time slot'},
            {id: 7, name: '7 reservations per time slot'},
            {id: 8, name: '8 reservations per time slot'},
            {id: 9, name: '9 reservations per time slot'},
            {id: 10, name: '10 reservations per time slot'},
            {id: 11, name: '11 reservations per time slot'},
            {id: 12, name: '12 reservations per time slot'},
            {id: 13, name: '13 reservations per time slot'},
            {id: 14, name: '14 reservations per time slot'},
            {id: 15, name: '15 reservations per time slot'},
            {id: 16, name: '16 reservations per time slot'},
            {id: 17, name: '17 reservations per time slot'},
            {id: 18, name: '18 reservations per time slot'},
            {id: 19, name: '19 reservations per time slot'},
            {id: 20, name: '20 reservations per time slot'},
            {id: 25, name: '25 reservations per time slot'},
            {id: 30, name: '30 reservations per time slot'},
            {id: 40, name: '40 reservations per time slot'},
            {id: 50, name: '50 reservations per time slot'},
            {id: 60, name: '60 reservations per time slot'},
            {id: 70, name: '70 reservations per time slot'},
            {id: 80, name: '80 reservations per time slot'},
            {id: 90, name: '90 reservations per time slot'},
            {id: 100, name: '100 reservations per time slot'}
        ];

        vm.maxReservationsSlotScopeList = [
            {id: 'ALL', name: 'consider all reservations.'},
            {id: 'CREATED_BY_CUSTOMER', name: 'consider only reservations created by customer online. '}
        ];

        vm.position_options = [
            {id: 1, name: 'left page edge'},
            {id: 2, name: 'right page edge'},
            {id: 3, name: 'bottom page edge'},
            {id: 4, name: 'top page edge'}
        ];

        vm.padding_options = [
            {id: 0, name: 'start of window'},
            {id: 25, name: '1/4 of window'},
            {id: 33, name: '1/3 of window'},
            {id: 50, name: '1/2 of window'},
            {id: 66, name: '2/3 of window'},
            {id: 75, name: '3/4 of window'},
            {id: 100, name: 'end of window'}
        ];

        vm.font_size = [
            {id: 8, name: '8px'},
            {id: 9, name: '9px'},
            {id: 10, name: '10px'},
            {id: 11, name: '11px'},
            {id: 12, name: '12px'},
            {id: 14, name: '14px'},
            {id: 16, name: '16px'},
            {id: 18, name: '18px'},
            {id: 20, name: '20px'},
            {id: 22, name: '22px'},
            {id: 24, name: '24px'}
        ];

        vm.maxSeats = [
            {id: 1, name: '1 persons'},
            {id: 2, name: '2 persons'},
            {id: 3, name: '3 persons'},
            {id: 4, name: '4 persons'},
            {id: 5, name: '5 persons'},
            {id: 6, name: '6 persons'},
            {id: 8, name: '8 persons'},
            {id: 10, name: '10 persons'},
            {id: 12, name: '12 persons'},
            {id: 14, name: '14 persons'},
            {id: 16, name: '16 persons'},
            {id: 20, name: '20 persons'},
            {id: 22, name: '22 persons'},
            {id: 24, name: '24 persons'},
            {id: 26, name: '26 persons'},
            {id: 28, name: '28 persons'},
            {id: 30, name: '30 persons'},
            {id: 40, name: '40 persons'},
            {id: 50, name: '50 persons'},
            {id: 75, name: '75 persons'},
            {id: 100, name: '100 persons'},
            {id: 150, name: '150 persons'}
        ];

        vm.status_options = [
            {id: 0, name: 'enabled.'},
            {id: 1, name: 'disabled until defined date and time.'},
            {id: 2, name: 'disabled.'}
        ];

        $scope.availableTimes = [
            {time: "End of day", timeForDB: "23:59"},
            {time: "12:00 AM", timeForDB: "00:00"},
            {time: "12:15 AM", timeForDB: "00:15"},
            {time: "12:30 AM", timeForDB: "00:30"},
            {time: "12:45 AM", timeForDB: "00:45"},
            {time: "1:00 AM", timeForDB: "01:00"},
            {time: "1:15 AM", timeForDB: "01:15"},
            {time: "1:30 AM", timeForDB: "01:30"},
            {time: "1:45 AM", timeForDB: "01:45"},
            {time: "2:00 AM", timeForDB: "02:00"},
            {time: "2:15 AM", timeForDB: "02:15"},
            {time: "2:30 AM", timeForDB: "02:30"},
            {time: "2:45 AM", timeForDB: "02:45"},
            {time: "3:00 AM", timeForDB: "03:00"},
            {time: "3:15 AM", timeForDB: "03:15"},
            {time: "3:30 AM", timeForDB: "03:30"},
            {time: "3:45 AM", timeForDB: "03:45"},
            {time: "4:00 AM", timeForDB: "04:00"},
            {time: "4:15 AM", timeForDB: "04:15"},
            {time: "4:30 AM", timeForDB: "04:30"},
            {time: "4:45 AM", timeForDB: "04:45"},
            {time: "5:00 AM", timeForDB: "05:00"},
            {time: "5:15 AM", timeForDB: "05:15"},
            {time: "5:30 AM", timeForDB: "05:30"},
            {time: "5:45 AM", timeForDB: "05:45"},
            {time: "6:00 AM", timeForDB: "06:00"},
            {time: "6:15 AM", timeForDB: "06:15"},
            {time: "6:30 AM", timeForDB: "06:30"},
            {time: "6:45 AM", timeForDB: "06:45"},
            {time: "7:00 AM", timeForDB: "07:00"},
            {time: "7:15 AM", timeForDB: "07:15"},
            {time: "7:30 AM", timeForDB: "07:30"},
            {time: "7:45 AM", timeForDB: "07:45"},
            {time: "8:00 AM", timeForDB: "08:00"},
            {time: "8:15 AM", timeForDB: "08:15"},
            {time: "8:30 AM", timeForDB: "08:30"},
            {time: "8:45 AM", timeForDB: "08:45"},
            {time: "9:00 AM", timeForDB: "09:00"},
            {time: "9:15 AM", timeForDB: "09:15"},
            {time: "9:30 AM", timeForDB: "09:30"},
            {time: "9:45 AM", timeForDB: "09:45"},
            {time: "10:00 AM", timeForDB: "10:00"},
            {time: "10:15 AM", timeForDB: "10:15"},
            {time: "10:30 AM", timeForDB: "10:30"},
            {time: "10:45 AM", timeForDB: "10:45"},
            {time: "11:00 AM", timeForDB: "11:00"},
            {time: "11:15 AM", timeForDB: "11:15"},
            {time: "11:30 AM", timeForDB: "11:30"},
            {time: "11:45 AM", timeForDB: "11:45"},
            {time: "12:00 PM", timeForDB: "12:00"},
            {time: "12:15 PM", timeForDB: "12:15"},
            {time: "12:30 PM", timeForDB: "12:30"},
            {time: "12:45 PM", timeForDB: "12:45"},
            {time: "1:00 PM", timeForDB: "13:00"},
            {time: "1:15 PM", timeForDB: "13:15"},
            {time: "1:30 PM", timeForDB: "13:30"},
            {time: "1:45 PM", timeForDB: "13:45"},
            {time: "2:00 PM", timeForDB: "14:00"},
            {time: "2:15 PM", timeForDB: "14:15"},
            {time: "2:30 PM", timeForDB: "14:30"},
            {time: "2:45 PM", timeForDB: "14:45"},
            {time: "3:00 PM", timeForDB: "15:00"},
            {time: "3:15 PM", timeForDB: "15:15"},
            {time: "3:30 PM", timeForDB: "15:30"},
            {time: "3:45 PM", timeForDB: "15:45"},
            {time: "4:00 PM", timeForDB: "16:00"},
            {time: "4:15 PM", timeForDB: "16:15"},
            {time: "4:30 PM", timeForDB: "16:30"},
            {time: "4:45 PM", timeForDB: "16:45"},
            {time: "5:00 PM", timeForDB: "17:00"},
            {time: "5:15 PM", timeForDB: "17:15"},
            {time: "5:30 PM", timeForDB: "17:30"},
            {time: "5:45 PM", timeForDB: "17:45"},
            {time: "6:00 PM", timeForDB: "18:00"},
            {time: "6:15 PM", timeForDB: "18:15"},
            {time: "6:30 PM", timeForDB: "18:30"},
            {time: "6:45 PM", timeForDB: "18:45"},
            {time: "7:00 PM", timeForDB: "19:00"},
            {time: "7:15 PM", timeForDB: "19:15"},
            {time: "7:30 PM", timeForDB: "19:30"},
            {time: "7:45 PM", timeForDB: "19:45"},
            {time: "8:00 PM", timeForDB: "20:00"},
            {time: "8:15 PM", timeForDB: "20:15"},
            {time: "8:30 PM", timeForDB: "20:30"},
            {time: "8:45 PM", timeForDB: "20:45"},
            {time: "9:00 PM", timeForDB: "21:00"},
            {time: "9:15 PM", timeForDB: "21:15"},
            {time: "9:30 PM", timeForDB: "21:30"},
            {time: "9:45 PM", timeForDB: "21:45"},
            {time: "10:00 PM", timeForDB: "22:00"},
            {time: "10:15 PM", timeForDB: "22:15"},
            {time: "10:30 PM", timeForDB: "22:30"},
            {time: "10:45 PM", timeForDB: "22:45"},
            {time: "11:00 PM", timeForDB: "23:00"},
            {time: "11:15 PM", timeForDB: "23:15"},
            {time: "11:30 PM", timeForDB: "23:30"},
            {time: "11:45 PM", timeForDB: "23:45"}
        ];

        vm.automationStrategyList = [
            {id: 'PERFECT_MATCH_ONLY', name: 'Assign one table with matched number of seats, if not found leave unassigned.'},
            {id: 'PERFECT_MATCH_OR_BIGGER', name: 'Assign any table to accommodate request, if not found leave unassigned.'},
            {id: 'PERFECT_MATCH_OR_BIGGER_THEN_MERGE_ALL', name: 'Assign any table to accommodate request, if one is not sufficient merge more tables (in all Areas).'},
            {id: 'PERFECT_MATCH_OR_BIGGER_THEN_MERGE_SAME_AREA', name: 'Assign any table to accommodate request, if one is not sufficient merge more tables (only within same Area).'}
        ];

        vm.paymentBehaviorList = [
            {id: 'RESERVATION', name: 'Fee per reservation'},
            {id: 'COVER', name: 'Fee per person'}
        ];

        vm.reservationDateLimit = [
            {id: -1, name: 'no limitation'},
            {id: 3, name: '3 days'},
            {id: 7, name: '1 week'},
            {id: 10, name: '10 days'},
            {id: 14, name: '2 weeks'},
            {id: 20, name: '3 weeks'},
            {id: 30, name: '1 month'},
            {id: 60, name: '2 months'},
            {id: 90, name: '3 months'},
            {id: 120, name: '4 months'},
            {id: 180, name: '6 months'},
            {id: 365, name: '1 year'}
        ];


        $scope.closeReservationDetailDialog = function () {
            vm.reservationPreview.dismiss('cancel');
        }

        $scope.showReservationDetailDialog = function () {
            vm.reservationPreview = $uibModal.open({
                templateUrl: 'app/settings/online/reservation/preview.details.preview.html',
                scope: $scope,
                size: 'lg'
            });
        }

        $scope.closeReservationRequestDialog = function () {
            vm.reservationPreview.dismiss('cancel');
        }

        $scope.showReservationRequestDialog = function () {
            vm.reservationPreview = $uibModal.open({
                templateUrl: 'app/settings/online/reservation/preview.request.preview.html',
                scope: $scope,
                size: 'lg'
            });
        }

        $scope.closeReservationPaymentDialog = function () {
            vm.reservationPreview.dismiss('cancel');
        }

        $scope.showReservationPaymentDialog = function () {
            vm.reservationPreview = $uibModal.open({
                templateUrl: 'app/settings/online/reservation/preview.payment.preview.html',
                scope: $scope,
                size: 'lg'
            });
        }

        $scope.closeReservationCompletedDialog = function () {
            vm.reservationPreview.dismiss('cancel');
        }

        $scope.showReservationCompletedDialog = function () {
            vm.reservationPreview = $uibModal.open({
                templateUrl: 'app/settings/online/reservation/preview.completed.preview.html',
                scope: $scope,
                size: 'lg'
            });
        }

        // When the user clicks on the button, scroll to the top of the document
        vm.scrollToTop = function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }


    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.online.reservation.facebook', {
            parent: 'settings.online.reservation',
            url: '/facebook',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/online/reservation/facebook/facebook.html',
                    controller: 'OnlineReservationSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('FacebookIntegrationController', FacebookIntegrationController);

    FacebookIntegrationController.$inject = ['$scope', 'SettingsResource', 'Log', 'ApplicationContext'];

    function FacebookIntegrationController($scope, SettingsResource, Log, ApplicationContext) {

        var vm = this;
        vm.scrollToTop = scrollToTop;

        vm.onlineResFacebookUrl = getBaseURL() + '?channel=facebook#/public/online/reservation/' + data.hashedLocationId;

        function getBaseURL() {
            var baseUrl = window.location.protocol + '//' + window.location.hostname;
            if (window.location.port) {
                baseUrl += ':' + window.location.port;
            }
            return baseUrl;
        }

        // When the user clicks on the button, scroll to the top of the document
        function scrollToTop() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.online.reservation.google', {
            parent: 'settings.online.reservation',
            url: '/google',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/online/reservation/google/google.html',
                    controller: 'OnlineReservationSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('GoogleIntegrationController', GoogleIntegrationController);

    GoogleIntegrationController.$inject = ['$scope', 'SettingsResource', 'Log', 'ApplicationContext'];

    function GoogleIntegrationController($scope, SettingsResource, Log, ApplicationContext) {

        var vm = this;
        vm.scrollToTop = scrollToTop;

        vm.onlineResGoogleUrl = getBaseURL() + '?channel=google#/public/online/reservation/' + data.hashedLocationId;

        function getBaseURL() {
            var baseUrl = window.location.protocol + '//' + window.location.hostname;
            if (window.location.port) {
                baseUrl += ':' + window.location.port;
            }
            return baseUrl;
        }

        // When the user clicks on the button, scroll to the top of the document
        function scrollToTop() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }

    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.online.reservation.web', {
            parent: 'settings.online.reservation',
            url: '/web',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/online/reservation/web/web.html',
                    controller: 'OnlineReservationSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.alerts', {
            parent: 'settings',
            url: '/alerts',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/alerts/alerts.html',
                    controller: 'AlertsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.tables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('AlertsController', AlertsController);

    AlertsController.$inject = ['$scope', '$state', 'SettingsResource', 'Log', '$location', '$uibModal', '$document',
        'ApplicationContext','ApplicationProfile'];

    function AlertsController($scope, $state, SettingsResource, Log, $location, $uibModal, $document,
                              ApplicationContext, ApplicationProfile) {

        var vm = this;
        vm.subscription = ApplicationContext.getLocation().subscription;
        vm.isFree = vm.subscription=='FREE';
        vm.openWindow = ApplicationProfile.openAppCloverPage;

        SettingsResource.getAlertsSettings({}, onSuccessGetData);

        function onSuccessGetData(data) {
            vm.data = data;
            Log.debug("NotificationController", "HTTP request succeed.");
        }

        function onErrorGetData(error) {
            Log.debug("NotificationController", "HTTP request error." + error);
        }

        $scope.saveData = function () {
            console.log('save data', $scope.data);
            SettingsResource.saveAlertsSettings(vm.data, onSuccessGetData, onErrorGetData);
        };


    }
})();




(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app',
            url: '/account',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_OWNER', 'ROLE_MANAGER']
            }

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account.login', {
            parent: 'account',
            url: '/login',
            data: {
                authorities: [],
                specialClass: " gray-bg"
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/login_layout.html'
                },
                'content@account.login': {
                    templateUrl: 'app/account/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'topnavbar@account.login': {
                    templateUrl: 'app/layouts/topnavbar/login_topnavbar.html'
                },
                'footer@app': {}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('account.login');
                    return $translate.refresh();
                }]
            },
            onEnter: ['Auth', function (Auth) {
                Auth.logout(true);
            }]

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', 'ApplicationContext'];

    function LoginController ($rootScope, $state, $timeout, Auth, ApplicationContext) {
        var vm = this;

        vm.login = login;
        vm.cancel = cancel;

        vm.authenticationError = false;
        vm.credentials = {};
        vm.password = null;
        vm.rememberMe = true;
        vm.username = null;

        ApplicationContext.storeAppContext("ADMIN","ADMIN ACCESS","ADMIN ACCESS","ADMIN ACCESS");

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
        }

        function login (event) {
            event.preventDefault();

            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $state.go('account.locations');
            }).catch(function () {
                vm.authenticationError = true;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('LocationsController', LocationsController);

    LocationsController.$inject = ['$rootScope', '$state', 'Locations', 'ParseLinks', 'Notification', 'ApplicationContext', 'Auth', '$window', '$http', '$localStorage'];

    function LocationsController($rootScope, $state, Locations, ParseLinks, Notification, ApplicationContext, Auth, $window, $http, $localStorage) {
        var vm = this;

        vm.showEmployees = showEmployees;
        vm.logAs = logAs;
        vm.logout = logout;
        vm.getLocations = getLocations;
        vm.searchTerm = '';

        vm.getLocations();

        function getLocations() {
            Locations.query({
                page: 0,
                size: 2000,
                search: vm.searchTerm
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.locations = data;
            }

            function onError(error) {
                Notification.error(error.data.message);
            }
        }

        function showEmployees(location) {
            vm.selectedLocation = location;

            Locations.employees({
                id: location.id
            }, onSuccessEmployee, onErrorEmployee);

            function onSuccessEmployee(data, headers) {
                vm.employees = data;
            }

            function onErrorEmployee(error) {
                Notification.error(error.data.message);
            }
        }

        function logAs(employee, asAdmin) {

            ApplicationContext.storeLocation(vm.selectedLocation);
            ApplicationContext.storeAppContext("ADMIN",vm.selectedLocation.cloverId, employee.cloverId,"ADMIN ACCESS");
            //moment.tz.setDefault(vm.selectedLocation.timezone);
            ApplicationContext.setLanguageAndLocale();

            console.log("Log as employee :"+ employee.name +": with employee cloverID :" + employee.cloverId +": for location with id :"
                + vm.selectedLocation.id+":");

            Notification.info("Log as " + ApplicationContext.getEmployeeID() + " for location with id :"
                + ApplicationContext.getLocationID() + ":. Timezone is:" + ApplicationContext.getTimeZone()+":");

            if(asAdmin) {
                console.log("Login with ADMIN role.");
                $http.get('api/auth/admin/log-as/' + vm.selectedLocation.id + '/employee/' + employee.cloverId + '?asAdmin=true', {}).success(authenticateSuccess);
            } else {
                console.log("Login using user role.")
                $http.get('api/auth/admin/log-as/' + vm.selectedLocation.id + '/employee/' + employee.cloverId + '?asAdmin=false', {}).success(authenticateSuccess);
            }

            // on success update token in local storage and go to home state
            // new token contain location details of location with which admin user will work
            function authenticateSuccess(data, status, headers) {

                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);

                    $rootScope.$broadcast('authenticationSuccess'); // listener for this event is defined in app.module.js

                    $localStorage.authenticationToken = jwt;
                    ApplicationContext.storeWarnings(false, data.openingHourWarn);
                    $state.go("home");

                    return jwt;
                }
            }
        }

        function logout() {
            Auth.logout();
            $state.go('account.login');
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account.locations', {
            parent: 'account',
            url: '/locations',
            data: {
                authorities: [],
            },
            views: {
                'layout@': {
                    templateUrl: 'app/layouts/login_layout.html'
                },
                'content@account.locations': {
                    templateUrl: 'app/account/locations/locations.html',
                    controller: 'LocationsController',
                    controllerAs: 'vm'
                },
                'navbar@app': {},
                'footer@app': {}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('account.locations');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('seatonApp')
        .factory('Locations', Locations);

    Locations.$inject = ['$resource'];

    function Locations($resource) {
        var resourceUrl = 'api/auth/admin/locations';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'employees': { method:'GET', url: 'api/auth/admin/employees/:id', isArray: true }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('account.clover', {
                parent: 'account',
                url: '/clover??merchant_id&employee_id&client_id&code',
                data: {
                    authorities: [],
                    specialClass: " gray-bg"
                },
                views: {
                    'layout@': {
                        templateUrl: 'app/layouts/clover_layout.html'
                    },
                    'content@account.clover': {
                        templateUrl: 'app/account/clover/clover.html',
                        controller: 'CloverController',
                        controllerAs: 'vm'
                    },
                    'navbar@app': {},
                    'topnavbar@app': {},
                    //'footer@app': {
                    //    templateUrl: 'app/layouts/footer/footer.html'
                    //}

                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('account.clover');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

CloverController.$inject = ['$rootScope', '$scope','$q', '$state', '$stateParams', 'CloverResource', 'AuthServerProvider',
    'ApplicationContext', 'Principal', 'Log'];

function CloverController($rootScope, $scope, $q, $state, $stateParams, CloverResource, AuthServerProvider,
                          ApplicationContext, Principal, Log) {
    var vm = this;

    vm.merchant_id = $stateParams.merchant_id;
    vm.employee_id = $stateParams.employee_id;
    vm.client_id = $stateParams.client_id;
    vm.code = $stateParams.code;

    ApplicationContext.storeAppContext("CLOVER", vm.merchant_id, vm.employee_id, vm.client_id);

    vm.syncNeeded = false;
    vm.configNeeded = false;
    vm.appStarting = true;
    vm.syncStarted = false;
    vm.syncCompleted = false;
    vm.openingHourWarn = false;
    vm.reactivated = false;
    vm.hasWarning = false;

    Log.info("CloverAccess","CLOVER access with MERCHANT_ID:" + vm.merchant_id + ": and EMPLOYEE_ID:" + vm.employee_id +
    ": and CLIENT_ID:" + vm.client_id + ": and CODE:" + vm.code);

    if (vm.merchant_id == undefined || vm.employee_id == undefined || vm.client_id == undefined || vm.code == undefined) {

        Log.error("CloverAccess", "CLOVER access bad url!");
        var errorMsg = "CLOVER access bad url! " + "CLOVER access with MERCHANT_ID:" + vm.merchant_id +
            ": and EMPLOYEE_ID:" + vm.employee_id + ": and CLIENT_ID:" + vm.client_id;

        var params = { 'errorCode': 'S001', 'errorMessage': errorMsg, 'contExec': false};
        $state.go("account.error", params)

    } else {
        authorizeClover();
    }


    // check if this is first access to Clover, if yes synchronize
    // authorize employee
    // if authorization ok go to state "home"
    function authorizeClover() {

        $q.all([
            executeAuthQuery()
        ]).then(authThen);

        function executeAuthQuery() {
            return CloverResource.cloverAuthorization({
                merchant_id: vm.merchant_id,
                employee_id: vm.employee_id,
                client_id: vm.client_id,
                code: vm.code
            }, function (data) {
                vm.cloverAuthData = data;
                vm.syncNeeded = vm.cloverAuthData.syncNeeded;
                vm.configNeeded = !vm.cloverAuthData.setupCompleted;
                vm.openingHourWarn = vm.cloverAuthData.openingHourWarn;
                vm.reactivated = vm.cloverAuthData.reactivated;
                if(vm.reactivated) {
                    $rootScope.initialStart = true;
                }
                vm.hasWarning = (vm.configNeeded || vm.openingHourWarn);
            }).$promise;
        }

        function authThen (data) {
            var deferred = $q.defer();
            Log.debug("CloverAccess", "Clover Auth Data jwt=" + vm.cloverAuthData.jwt +": authorized:"+ vm.cloverAuthData.authorized
                +": syncNeded:"+ vm.cloverAuthData.syncNeeded+": setupCompleted:"+ vm.cloverAuthData.setupCompleted);

            if (vm.cloverAuthData.authorized) {
                // authorization succeed
                Log.info("CloverAccess", "Successful authorization!");
                accessGranted();
                if(!vm.hasWarning && !vm.reactivated) {
                    $state.go("home");
                } else {
                    if(vm.configNeeded) $rootScope.configNotCompleted = true;
                    vm.appStarting = false;
                }

            } else if (vm.cloverAuthData.syncNeeded) {
                // authorization failed, sync needed, call sync function
                Log.info("CloverAccess", "Sync needed!");
                executeSync();
            } else {
                Log.error("CloverAccess", "Authorization failed.");
            }

            return deferred.promise;
        }
    }

    function executeSync() {
        vm.appStarting = false;
        vm.syncStarted = true;

        $q.all([
            executeSyncQuery()
        ]).then(syncThen);

        function executeSyncQuery() {
            return CloverResource.cloverSync({
                merchant_id: vm.merchant_id,
                employee_id: vm.employee_id,
                client_id: vm.client_id,
                code: vm.code
            }, function (data) {
                vm.cloverAuthData = data;
            }).$promise;
        }

        function syncThen (data) {
            var deferred = $q.defer();
            Log.debug("CloverAccess", "Successful authorization!");
            Log.debug("CloverAccess", "Clover Auth Data jwt=" + vm.cloverAuthData.jwt +": authorization:"+ vm.cloverAuthData.authorization
                +": needSync:"+ vm.cloverAuthData.needSync+": needSetupCompleted:"+ vm.cloverAuthData.needSetupCompleted);

            vm.syncStarted = false;
            vm.syncCompleted = true;
            vm.openingHourWarn = vm.cloverAuthData.openingHourWarn;
            Log.error("CloverAccess", "Opening hours not defined = "+vm.openingHourWarn);

            $rootScope.initialStart = true;
            vm.configNeeded = true;

            accessGranted();

            return deferred.promise;
        }

    }

    function accessGranted() {
        // set context, token and location in local storage
        AuthServerProvider.storeAuthenticationToken(vm.cloverAuthData.jwt, true);
        ApplicationContext.storeLocation(vm.cloverAuthData.location);

        Log.info("CloverAccess", "Timezone set to "+vm.cloverAuthData.location.timezone);
        //moment.tz.setDefault(vm.cloverAuthData.location.timezone);
        ApplicationContext.setLanguageAndLocale();
        ApplicationContext.storeWarnings(vm.configNeeded, vm.openingHourWarn);
        $rootScope.configNotCompleted = vm.configNeeded;

        moment.tz.setDefault(vm.cloverAuthData.location.timezone);

        // define principal
        Principal.identity();

    }

    // redirects
    $scope.configure = function() {
        $state.go("settings.floor");
    };

    $scope.home = function() {
        $state.go("home");
    };



    $scope.setResourceTypeAndOpenApp = function(resourceTypeValue) {

        CloverResource.setResourceType({resourceType: resourceTypeValue}, openApp);

        function openApp() {
            ApplicationContext.setResourceType(resourceTypeValue);
            $state.go("home");
        }
    };

    // content controllers
    $scope.starting = function() {
        return vm.appStarting;
    };

    $scope.syncStarted = function() {
        return (vm.syncNeeded && vm.syncStarted);
    };

    $scope.syncCompleted = function() {
        return ((vm.syncNeeded && vm.syncCompleted) || vm.reactivated);
    };

    $scope.hasWarning = function() {
        return (!vm.syncNeeded && vm.hasWarning && !vm.reactivated);
    };

    $scope.configNotCompleted = function() {
        return (vm.configNeeded);
    };

    $scope.openingHoursWarning = function() {
        return (vm.openingHourWarn);
    }

}

angular.module('seatonApp').controller('CloverController', CloverController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('account.error', {
                parent: 'account',
                url: '/error',
                data: {
                    authorities: [],
                    specialClass: " gray-bg"
                },
                views: {
                    'layout@': {
                        templateUrl: 'app/layouts/clover_layout.html'
                    },
                    'content@account.error': {
                        templateUrl: 'app/account/error/error.html',
                        controller: 'ErrorController',
                        controllerAs: 'vm'
                    },
                    'navbar@app': {},
                    'topnavbar@app': {}
                    //'footer@app': {
                    //    templateUrl: 'app/layouts/footer/footer.html'
                    //}

                },
                params: {
                    "errorCode": '',
                    "errorMessage": '',
                    "contExec": ''
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('account.clover.error');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

ErrorController.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'ApplicationContext', 'Auth'];

function ErrorController($rootScope, $scope, $state, $stateParams, ApplicationContext, Auth) {
    var vm = this;

    vm.errorCode = $stateParams.errorCode;
    vm.errorMessage = $stateParams.errorMessage;
    vm.contExec = $stateParams.contExec;
    if(vm.errorMessage!=undefined && (vm.errorMessage.length>350)) {
        vm.errorMessage = vm.errorMessage.substr(0,350);
    }
    vm.merchant_id = ApplicationContext.getMerchantID();
    vm.employee_id = ApplicationContext.getEmployeeID();
    vm.client_id = ApplicationContext.getClientID();
    vm.errorTime = moment.now();

    vm.authType = ApplicationContext.getAuthType();

    vm.cloverEnvUrl= "https://www.clover.com/oauth/v2/authorize?client_id=VW368JQ4FJ6SY&redirect_uri=https://getseat.net/clover/login/callback";
    if (window.location.href.indexOf("//eu.getseat.net") != -1) vm.cloverEnvUrl= "https://eu.clover.com/oauth/authorize?client_id=N4XXKPTCDBQN6&redirect_uri=https://eu.getseat.net/clover/login/callback";
    else if (window.location.href.indexOf("//test.getseat.net") != -1) vm.cloverEnvUrl= "https://apisandbox.dev.clover.com/oauth/authorize?client_id=7V7HJJKFXWZ1A&redirect_uri=https://test.getseat.net/clover/login/callback";
    else if(window.location.href.indexOf("//localhost") != -1) vm.cloverEnvUrl= "https://apisandbox.dev.clover.com/oauth/authorize?client_id=P85VA1VZSHDYY&redirect_uri=http://localhost:8080/clover/login/callback";// test purpose

    console.log("AuthType is "+vm.authType+" Is Recoverable error "+vm.contExec+" ErrorCode is "+vm.errorCode
        +" ErrorMessage is "+vm.errorMessage+" ErrorTime is "+vm.errorTime);
    console.log("MerchantId is "+vm.merchantId+" EmployeeId is "+vm.employeeId+" ClientId is "+vm.client_id);

    $scope.isGeneralError = function() {
        return (vm.errorCode != 401);
    };

    $scope.is401Error = function() {
        return (vm.errorCode == 401);
    };

    $scope.canRecover = function() {
        if(vm.contExec) {
            if(vm.errorCode==401 && vm.authType=="CLOVER") {
                return false;
            } else {
                return true;
            }
        }
        return false;
    };

    $scope.recoverButtonText = function() {
        if (vm.errorCode==401 && vm.authType=="ADMIN") {
            return "Login again";
        } else {
            return "Continue using SeatOn application";
        }
    };

    $scope.recoverState = function() {
        if(vm.authType=="CLOVER") { // authType="CLOVER"
            $state.go("home");
        } else { // authType="ADMIN";
            if (vm.errorCode==401) {
                $state.go("account.login");
            } else {
                $state.go("home");
            }
        }
    }

}

angular.module('seatonApp').controller('ErrorController', ErrorController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('account.clover.logout', {
                parent: 'account.clover',
                url: '/logout',
                data: {
                    authorities: [],
                    specialClass: " gray-bg"
                },
                views: {
                    'layout@': {
                        templateUrl: 'app/layouts/clover_layout.html'
                    },
                    'content@account.clover.logout': {
                        templateUrl: 'app/account/clover/logout/logout.html',
                        controller: 'CloverLogoutController',
                        controllerAs: 'vm'
                    },
                    'navbar@app': {},
                    'topnavbar@app': {}
                    //'footer@app': {
                    //    templateUrl: 'app/layouts/footer/footer.html'
                    //}

                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('account.clover.error');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

CloverLogoutController.$inject = ['$rootScope', '$scope', '$state'];

function CloverLogoutController($rootScope, $scope, $state) {
    var vm = this;

}

angular.module('seatonApp').controller('CloverLogoutController', CloverLogoutController);

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('ApplicationController', ApplicationController);

    ApplicationController.$inject = ['$rootScope', '$state', 'AppService', 'Notification', 'ParseLinks'];

    function ApplicationController($rootScope, $state, AppService, Notification, ParseLinks) {
        var vm = this;

        vm.showLocation = showLocation;
        vm.searchByEmployee = searchByEmployee;
        vm.searchTerm = '';
        vm.getLocations = getLocations;

        vm.getLocations();


        function getLocations() {
            AppService.query({
                page: 0,
                size: 2000,
                search: vm.searchTerm
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.locations = data;
            }

            function onError(error) {
                Notification.error(error.data.message);
            }
        }

        function showLocation(location) {
            var params = {
                location: location
            };

            $state.go("admin.location", params);
        }

        function searchByEmployee() {
            console.log("Search param "+vm.searchParam);

            var params = {
                'searchParam': vm.searchParam
            };

            AppService.searchByEmployeeOnServer(params, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.locations = data;
            }

            function onError(error) {
                Notification.error(error.data.message);
            }

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.application', {
            parent: 'admin',
            url: '/application',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/application/application.html',
                    controller: 'ApplicationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('admin.application');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('seatonApp')
        .factory('AppService', AppService);

    AppService.$inject = ['$resource'];

    function AppService($resource) {
        var resourceUrl = 'api/auth/admin/locations';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'applications': { method:'GET', url: 'api/admin/applications/:cloverId', isArray: true },
            'clearServerCache': { method:'GET', url: 'api/admin/clearServerCache', isArray: false },
            'threadPoolsStatus': { method:'GET', url: 'api/admin/threadPoolsStatus', isArray: false },
            'searchByEmployeeOnServer': { method:'GET', url: 'api/admin/searchByEmployee/:searchParam', isArray: true},
            'resetCounter': { method:'POST', url: 'api/admin/resetCounter'},
            'changeSubscription': { method:'POST', url: 'api/admin/changeSubscription', isArray: true},
            'refreshToken': { method:'GET', url: 'api/admin/refreshToken/:locationId'},
            'migrateToken': { method:'GET', url: 'api/admin/migrateToken/:locationId'},
            'refreshOnLogin': { method:'GET', url: 'api/admin/refreshOnLogin/:locationId'},
            'accessTokenLocationList': { method:'GET', url: 'api/admin/accessTokenLocationList', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('AccessTokenController', AccessTokenController);

    AccessTokenController.$inject = ['$rootScope', '$state', 'AppService', 'Notification', 'ParseLinks', 'Log'];

    function AccessTokenController($rootScope, $state, AppService, Notification, ParseLinks, Log) {
        var vm = this;

        vm.getAllLocations = getAllLocations;
        vm.refreshToken = refreshToken;
        vm.migrateToken = migrateToken;
        vm.getDateFromUnixEpoch = getDateFromUnixEpoch;
        vm.refreshOnLogin = refreshOnLogin;

        getAllLocations();

        function getAllLocations() {
            AppService.accessTokenLocationList({}, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.locations = data;
            }

            function onError(error) {
                Notification.error(error.data.message);
            }
        }

        function refreshToken(locationId) {
            var params = {
                'locationId': locationId
            };

            AppService.refreshToken(params, onSuccess, onError);

            function onSuccess(data, headers) {
                if(data.id) {
                    Notification.info("Token refresh successfully completed!");
                } else {
                    Notification.error("Token refresh failed. Look into server log file for more details.");
                }

                getAllLocations();
            }

            function onError(error) {
                Notification.error("Token refresh failed. Look into server log file for more details.");
            }
        }

        function migrateToken(locationId) {
            var params = {
                'locationId': locationId
            };
            AppService.migrateToken(params, onSuccess, onError);

            function onSuccess(data, headers) {
                if(data.id) {
                    Notification.info("Migration successfully completed. ");
                } else {
                    Notification.error("Migration failed. Look into server log file for more details.");
                }
                getAllLocations();
            }

            function onError(error) {
                Notification.error("Token refresh failed. Look into server log file for more details.");
            }
        }

        function refreshOnLogin(locationId) {
            var params = {
                'locationId': locationId
            };
            AppService.refreshOnLogin(params, onSuccess, onError);

            function onSuccess(data, headers) {
                if(data.id) {
                    Notification.info("Refresh on login requested successfully. ");
                } else {
                    Notification.error("Token refresh request on login failed. Look into server log file for more details.");
                }
                getAllLocations();
            }

            function onError(error) {
                Notification.error("Token refresh request on login failed. Look into server log file for more details.");
            }

        }

        function getDateFromUnixEpoch(epoch) {
            if(epoch) return new Date(epoch * 1000);
            else return "";
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.accesstoken', {
            parent: 'admin',
            url: '/accesstoken',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/accesstoken/accesstoken.html',
                    controller: 'AccessTokenController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('admin.application');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.import', {
            parent: 'admin',
            url: '/import',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@app': {
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('admin.application');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('seatonApp')
        .factory('ImportService', ImportService);

    ImportService.$inject = ['$resource'];

    function ImportService($resource) {
        var resourceUrl = 'api/auth/admin/import';

        return $resource(resourceUrl, {}, {
            'importAllEvents': { method:'POST', url: 'api/admin/importAllEvents'},
            'importOneEvent': { method:'POST', url: 'api/admin/importOneEvent'},
            'importAllCustomers': { method:'POST', url: 'api/admin/importAllCustomers'},
            'importOneCustomer': { method:'POST', url: 'api/admin/importOneCustomer'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('ImportEventController', ImportEventController);

    ImportEventController.$inject = ['$rootScope', '$state', 'ImportService', 'Notification', 'ParseLinks'];

    function ImportEventController($rootScope, $state, ImportService, Notification, ParseLinks) {
        var vm = this;


        vm.importAllEvents = function() {

            var params = {
                'dataToImport': vm.dataToImport
            };

            ImportService.importAllEvents(params, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.importResult = data;
                Notification.info("Import finished, please check result below on the page.");
            }

            function onError(error) {
                Notification.error("Import request failed. Error = " + error.data.message);
            }


        }

        vm.importOneEvent = function(event) {

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.import.event', {
            parent: 'admin.import',
            url: '/event',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/import/event/import.html',
                    controller: 'ImportEventController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('admin.application');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('ImportCustomerController', ImportCustomerController);

    ImportCustomerController.$inject = ['$rootScope', '$state', 'ImportService', 'Notification', 'ParseLinks'];

    function ImportCustomerController($rootScope, $state, ImportService, Notification, ParseLinks) {
        var vm = this;


        vm.importAllCustomers = function() {

            var params = {
                'dataToImport': vm.dataToImport
            };

            ImportService.importAllCustomers(params, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.importResult = data;
                Notification.info("Import finished, please check result below on the page.");
            }

            function onError(error) {
                Notification.error("Import request failed. Error = " + error.data.message);
            }


        }

        vm.importOneCustomer = function(event) {

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.import.customer', {
            parent: 'admin.import',
            url: '/customer',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/import/customer/import.html',
                    controller: 'ImportCustomerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('admin.application');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('TimeSlotMigrationController', TimeSlotMigrationController);

    TimeSlotMigrationController.$inject = ['$rootScope', '$state', 'MigrationService', 'Notification', 'ParseLinks'];

    function TimeSlotMigrationController($rootScope, $state, MigrationService, Notification, ParseLinks) {
        var vm = this;

        vm.migrateOne = function(id) {
            if(id) vm.locationIdToMigrate = id;
            if(vm.locationIdToMigrate) {

                var params = {
                    'locationId': vm.locationIdToMigrate
                };

                MigrationService.migrateOneTimeSlot(params, onOneMigrateSuccess, onError);

            } else {
                Notification.warning("Please define location id to migrate.");
            }

            function onOneMigrateSuccess(data, headers) {
                //Notification.info("Migration finished successfully, please check time slot definition.");
            }
        }

        vm.migrateAll = function() {

            var params = {
                'locationId': vm.locationIdToMigrate
            };

            MigrationService.migrateAllTimeSlot(params, onAllMigrateSuccess, onError);

            function onAllMigrateSuccess(data, headers) {
                    vm.resultList = data;
                    Notification.info("Migration finished. Please check migration result table.");
            }

        }

        function onError(error) {
            Notification.error("Migration failed. Error = " + error.data.message);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.migration.timeslot', {
            parent: 'admin.migration',
            url: '/timeslot',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/migration/timeslot/migration.html',
                    controller: 'TimeSlotMigrationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('admin.application');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('seatonApp')
        .factory('MigrationService', MigrationService);

    MigrationService.$inject = ['$resource'];

    function MigrationService($resource) {
        var resourceUrl = 'api/auth/admin/migrate';

        return $resource(resourceUrl, {}, {
            'migrateOneTimeSlot': {method: 'GET', url: 'api/admin/migration/oneTimeSlot/:locationId'},
            'migrateAllTimeSlot': { method:'GET', url: 'api/admin/migration/allTimeSlot', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.migration', {
            parent: 'admin',
            url: '/migration',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@app': {
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('admin.application');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('AdminLocationController', AdminLocationController);

    AdminLocationController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'AppService', 'Notification', 'ParseLinks', '$uibModal'];

    function AdminLocationController($scope, $rootScope, $state, $stateParams, AppService, Notification, ParseLinks, $uibModal) {
        var vm = this;

        vm.returnToList = returnToList;
        vm.showCounterDialog = showCounterDialog;
        vm.closeResetCounterDialog = closeResetCounterDialog;
        vm.resetCounter = resetCounter;
        vm.showSubscriptionDialog = showSubscriptionDialog;
        vm.closeSubscriptionDialog = closeSubscriptionDialog;
        vm.changeSubscription = changeSubscription;

        vm.validMonth=1;
        vm.validYear=2021;

        vm.location = $stateParams.location;
        if(!vm.location.id) {
            vm.returnToList();
        } else {
            showApplication(vm.location);
        }

        function showApplication(location) {
            vm.selectedLocation = location;
            if(vm.selectedLocation.cloverId != "") {
                AppService.applications({
                    cloverId: location.cloverId
                }, onSuccessApplication, onErrorApplication);
            } else {
                vm.applications = null;
            }

            function onSuccessApplication(data, headers) {
                vm.applications = data;
            }

            function onErrorApplication(error) {
                Notification.error(error.data.message);
            }
        }

        function returnToList() {
            $state.go("admin.application")
        }

        function showCounterDialog() {
            vm.resetCounterDialog = $uibModal.open({
                templateUrl: 'app/admin/location/reset.dialog.html',
                scope: $scope
            });
        }

        function closeResetCounterDialog() {
            vm.resetCounterDialog.dismiss('cancel');
        }

        function resetCounter() {

            var params = {
                'locationId': vm.location.id,
                'counterId': vm.counterId
            };

            AppService.resetCounter(params, onSuccess, onError);

            function onSuccess(data, headers) {
                Notification.success("Counter successfully reset!");
                vm.closeResetCounterDialog();
                vm.location = data;
            }

            function onError(error) {
                Notification.error(error.data.message);
            }

        }

        function showSubscriptionDialog() {
            vm.changeSubscriptionDialog = $uibModal.open({
                templateUrl: 'app/admin/location/subscription.dialog.html',
                scope: $scope
            });
        }

        function closeSubscriptionDialog() {
            vm.changeSubscriptionDialog.dismiss('cancel');
        }

        function changeSubscription(){

            var params = {
                'locationId': vm.location.id,
                'subscriptionType': vm.subscriptionType,
                'validMonth': vm.validMonth,
                'validYear': vm.validYear
            };

            console.log("New subscriptionType ="+JSON.stringify(params)+'');

            AppService.changeSubscription(params, onSuccess, onError);

            function onSuccess(data, headers) {
                Notification.success("Subscription successfully changed!");
                vm.closeSubscriptionDialog();
                vm.applications = data;
            }

            function onError(error) {
                Notification.error(error.data.message);
            }

        }


    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.location', {
            parent: 'admin',
            url: '/location',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/location/location.html',
                    controller: 'AdminLocationController',
                    controllerAs: 'vm'
                }
            }, params: {
                location: {}
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('admin.application');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('MeteredController', MeteredController);

    MeteredController.$inject = ['$rootScope', '$state', '$document','MeteredService', 'AppService', 'Notification', 'ParseLinks'];

    function MeteredController($rootScope, $state, $document, MeteredService, AppService, Notification, ParseLinks) {
        var vm = this;

        vm.showMetered = showMetered;
        vm.meteredType = 1;
        vm.selectedMonth = moment().format("YYYY-MM-DD");

        $document.ready(
            function () {
                vm.selectedDate = $document.find('input[name="selectedDate"]');
                vm.selectedDate.daterangepicker(
                    {
                        //configuration parameters
                        singleDatePicker: true,
                        showDropdowns: true,
                        locale: {format: 'MMM YYYY'}
                    },
                    function (start, end, label) {
                        //callback function - called on picker value change - dates sent in callback parameters
                        vm.selectedMonth = start.format("YYYY-MM-DD");
                    }
                );
            }
        );

        vm.openPicker = openPicker;
        function openPicker() {
            vm.selectedDate.focus();
        }

        getAllLocations();

        function getAllLocations() {
            AppService.query({
                page: 0,
                size: 2000
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.locations = data;
            }

            function onError(error) {
                Notification.error(error.data.message);
            }
        }

        function showMetered(location) {
            vm.cloverList = null;
            vm.seatonList - null;
            vm.selectedLocation = location;
            //if(vm.selectedLocation.cloverId != "") {
                MeteredService.metered({
                    locationId: location.id,
                    meteredType: vm.meteredType,
                    selectedMonth: vm.selectedMonth
                }, onSuccessMetered, onErrorMetered);
            //} else {
                //vm.cloverList = null;
                //vm.seatonList - null;
            //}

            function onSuccessMetered(data, headers) {
                vm.cloverList = data.clover;
                vm.seatonList = data.seaton;
            }

            function onErrorMetered(error) {
                Notification.error(error.data.message);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.metered', {
            parent: 'admin',
            url: '/metered',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/metered/metered.html',
                    controller: 'MeteredController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('admin.application');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('seatonApp')
        .factory('MeteredService', MeteredService);

    MeteredService.$inject = ['$resource'];

    function MeteredService($resource) {
        var resourceUrl = 'api/admin/metered/';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'metered': { method:'GET', url: 'api/admin/metered/:locationId?meteredType=:meteredType&selectedMonth=:selectedMonth', isArray: false }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('PaymentController', PaymentController);

    PaymentController.$inject = ['$rootScope', '$state', '$document', 'Notification', 'PaymentService'];

    function PaymentController($rootScope, $state, $document, Notification, PaymentService) {
        var vm = this;


        const clover = new Clover('e1ab02b0377aa83c0f9fa57b13a289e7');
        const elements = clover.elements();
        const styles = {
            body: {
                fontFamily: 'Roboto, Open Sans, sans-serif',
                fontSize: '16px',
            },
            input: {
                fontSize: '16px',
            },
        };
        const cardNumber = elements.create('CARD_NUMBER', styles);
        const cardDate = elements.create('CARD_DATE', styles);
        const cardCvv = elements.create('CARD_CVV', styles);
        const cardPostalCode = elements.create('CARD_POSTAL_CODE', styles);

        cardNumber.mount('#card-number');
        cardDate.mount('#card-date');
        cardCvv.mount('#card-cvv');
        cardPostalCode.mount('#card-postal-code');

        const cardResponse = document.getElementById('card-response');

        const displayCardNumberError = document.getElementById('card-number-errors');
        const displayCardDateError = document.getElementById('card-date-errors');
        const displayCardCvvError = document.getElementById('card-cvv-errors');
        const displayCardPostalCodeError = document.getElementById('card-postal-code-errors');

        // Handle real-time validation errors from the card Element.
        cardNumber.addEventListener('change', function(event) {
            console.log("cardNumber changed ${JSON.stringify(event)}");
        });

        cardNumber.addEventListener('blur', function(event) {
            console.log("cardNumber blur ${JSON.stringify(event)}");
        });

        cardDate.addEventListener('change', function(event) {
            console.log("cardDate changed ${JSON.stringify(event)}");
        });

        cardDate.addEventListener('blur', function(event) {
            console.log("cardDate blur ${JSON.stringify(event)}");
        });

        cardCvv.addEventListener('change', function(event) {
            console.log("cardCvv changed ${JSON.stringify(event)}");
        });

        cardCvv.addEventListener('blur', function(event) {
            console.log("cardCvv blur ${JSON.stringify(event)}");
        });

        cardPostalCode.addEventListener('change', function(event) {
            console.log("cardPostalCode changed ${JSON.stringify(event)}");
        });

        cardPostalCode.addEventListener('blur', function(event) {
            console.log("cardPostalCode blur ${JSON.stringify(event)}");
        });

        // TODO: Register event handlers
        const form = document.getElementById('payment-form');
        form.addEventListener('submit', function(event) {
            event.preventDefault();

            clover.createToken()
                .then(function(result) {
                    if (result.errors) {
                        Object.values(result.errors).forEach(function (value) {
                            cardDataDisplayError.textContent = value;
                        });
                    } else {
                        alert(result.token);
                        var params = {
                            'token': result.token
                        }
                        PaymentService.testPayment(result.token, onSuccess, onError);

                    }
                }).catch(function(data){
                console.log(data);
            });
        });

        function onSuccess(data, headers) {
            vm.locations = data;
        }

        function onError(error) {
            Notification.error(error.data.message);
        }


        // Submit the form with the token ID.
        function cloverTokenHandler(token) {
            // Insert the token ID into the form so it gets submitted to the server
            var form = document.getElementById('payment-form');
            var hiddenInput = document.createElement('input');
            hiddenInput.setAttribute('type', 'hidden');
            hiddenInput.setAttribute('name', 'cloverToken');
            hiddenInput.setAttribute('value', token);
            form.appendChild(hiddenInput);
            alert(token);
            // Submit the form
            // form.submit();
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.payment', {
            parent: 'admin',
            url: '/payment',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/payment/payment.html',
                    controller: 'PaymentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('admin.application');
                    return $translate.refresh();
                }]
            },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('seatonApp')
        .factory('PaymentService', PaymentService);

    PaymentService.$inject = ['$resource'];

    function PaymentService($resource) {
        var resourceUrl = 'api/admin/payment/';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'getPublicKey': { method:'GET', url: 'api/admin/payment/:locationId?meteredType=:meteredType&selectedMonth=:selectedMonth', isArray: false },
            'testPayment': { method:'POST', url: 'api/admin/testPayment'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('admin.user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('admin.user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('admin.user-management.new', {
            parent: 'admin.user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('admin.user-management', null, { reload: true });
                }, function() {
                    $state.go('admin.user-management');
                });
            }]
        })
        .state('admin.user-management.edit', {
            parent: 'admin.user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('admin.user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('admin.user-management.delete', {
            parent: 'admin.user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('admin.user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope', 'JhiMetricsService', '$uibModal', 'AppService', '$http'];

    function JhiMetricsMonitoringController($scope, JhiMetricsService, $uibModal, AppService, $http) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;
        vm.clearServerCache = clearServerCache;

        $http.get('api/admin/threadPoolsStatus').then(function (result) {
            vm.threadPoolsStatusData = result;
        });

        //AppService.threadPoolsStatus();

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh() {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function clearServerCache() {
            AppService.clearServerCache();
        }

        function refreshThreadDumpData() {
            JhiMetricsService.threadDump().then(function (data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function () {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('seatonApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin.docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin.audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('seatonApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.test', {
                parent: 'admin',
                url: '/test',
                data: {
                    authorities: []
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/admin/test/test.html',
                        controller: 'TestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //$translatePartialLoader.addPart('account.clover');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

'use strict';

TestController.$inject = ['$rootScope', '$scope','$q', '$state', '$stateParams', 'CloverResource', 'Notification'];

function TestController($rootScope, $scope, $q, $state, $stateParams, CloverResource, Notification) {
    var vm = this;

    CloverResource.cloverTest();
    //CloverResource.healthCheck();

}

angular.module('seatonApp').controller('TestController', TestController);
(function(){angular.module('seatonApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="home.title">Welcome, Java Hipster!</h1><p class="lead" data-translate="home.subtitle">This is your homepage</p><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a></div></div><p data-translate="home.question">If you have any question on JHipster:</p><ul><li><a href="http://jhipster.github.io/" target="_blank" data-translate="home.link.homepage">JHipster homepage</a></li><li><a href="http://stackoverflow.com/tags/jhipster/info" target="_blank" data-translate="home.link.stackoverflow">JHipster on Stack Overflow</a></li><li><a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" data-translate="home.link.bugtracker">JHipster bug tracker</a></li><li><a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" data-translate="home.link.chat">JHipster public chat room</a></li><li><a href="https://twitter.com/java_hipster" target="_blank" data-translate="home.link.follow">follow @java_hipster on Twitter</a></li></ul><p><span data-translate="home.like">If you like JHipster, don\'t forget to give us a star on </span>&nbsp;<a href="https://github.com/jhipster/generator-jhipster" target="_blank" data-translate="home.github">Github</a>!</p></div></div></div>');
$templateCache.put('app/home.dashboard/homedashboard.html','<div class="wrapper wrapper-content" ng-intro-options="IntroOptions" ng-intro-method="CallMe" ng-intro-autostart="showIntro"><div class="row" ng-show="openingHourNotDefined()"><div class="col-lg-12"><div class="widget yellow-bg text-center"><h4>WARNING: Business hours not defined. Occupancy rate calculation might be wrong. Please define business hours through Clover Setup and restart application.</h4></div></div></div><div class="row"><div class="col-lg-10"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div id="performance" class="ibox-content"><div class="row"><div class="col-lg-12"><h3 class="font-bold no-margins">Today\'s performance</h3><small>Compared to last {{homeCtrl.timeNow | amDateFormat: \'dddd\' }}.</small> <span class="pull-right text-success"><span><button class="btn-xs btn-outline btn-default text-muted" type="button" ng-click="homeCtrl.changeHome()">Switch to new home</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="text-bold">{{homeCtrl.timeNow | amDateFormat: \'dddd, Do MMM YY\' }} <i class="fa fa-clock-o"></i> {{homeCtrl.timeNow | amDateFormat: \'H:mm:ss a\' }} <i>{{ homeCtrl.timeDebugNotification }}</i></span></span></span></div></div><div class="m-t-sm"><div class="row"><div class="col-md-9"><div class="dashboard-chart"><div google-chart chart="homeCtrl.chartComboObjectHours"></div></div></div><div class="col-md-3"><table class="table"><thead><tr><th colspan="3"><h3>Today</h3></th></tr></thead><tbody><tr><td class="text-right"><span class="text-warning font-bold"><small>OCCUPANCY<br>RATE</small></span></td><td><h3>{{ homeCtrl.todayData.totalDayOccupancy.occupancyPct | percentage:2}}</h3><small>#<stran stext="person" type="c"></stran>{{ homeCtrl.todayData.totalDayOccupancy.totalCovers | number}}</small></td></tr><tr><td><i class="{{currencyIcon}} fa-2x text-navy pull-right"></i></td><td><h3>{{ homeCtrl.todayData.totalDayOccupancy.revenue | currency}}</h3><small>Avg per<stran stext="person" type="s"></stran>{{ homeCtrl.todayData.totalDayOccupancy.avgRevenuePerCover | currency}}</small></td></tr><tr><td class="text-right"><span class="text-navy font-bold"><small>TIPS</small></span></td><td><h3>{{ homeCtrl.todayData.totalDayOccupancy.tips | currency}}</h3><small>Avg per<stran stext="person" type="s"></stran>{{ homeCtrl.todayData.totalDayOccupancy.avgTipPerCover | currency}}</small></td></tr><tr><td class="text-right"><span class="text-danger font-bold"><small>NO<br>SHOW</small></span></td><td><h3>{{ homeCtrl.todayData.totalDayOccupancy.noShowVisits | number}} ({{ homeCtrl.todayData.totalDayOccupancy.noShowPct | percentage:2}})</h3></td></tr></tbody></table></div></div></div></div></div></div></div><div class="row" id="modules"><div class="col-lg-3 col-md-6"><div class="ibox float-e-margins"><div class="ibox-title"><h5><a ui-sref="tables.dashboard"><stran stext="resource" type="sc"></stran>management <i class="fa fa-chevron-circle-right"></i></a></h5></div><div><div class="ibox-content no-padding border-left-right"><a ui-sref="tables.dashboard"><img alt="image" class="img-responsive" src="content/images/table_mngt.png"></a></div><div class="ibox-content profile-content"><h4>Current status</h4><p><i class="fa fa-circle text-navy"></i> <b>{{ homeCtrl.todayData.locationCapacity.totalTables - homeCtrl.todayData.countStats.occupiedTables | number}}</b><stran stext="resource"></stran>available</p><p><i class="fa fa-circle text-danger"></i> <b>{{ homeCtrl.todayData.countStats.occupiedTables | number}}</b><stran stext="resource"></stran>occupied ({{ homeCtrl.todayData.countStats.occupiedSeats | number}} covers)</p><p><i class="fa fa-calendar text-info"></i> <b>{{ homeCtrl.todayData.countStats.expectedVisits | number}}</b> expected arrivals ({{ homeCtrl.todayData.countStats.expectedCovers | number}} covers)</p><p><i class="fa fa-undo text-warning"></i> <b>{{ homeCtrl.todayData.countStats.waitlistNumber | number}}</b> waitlist entries ({{ homeCtrl.todayData.countStats.waitListCovers | number}} covers)</p><br><div class="user-button"><div class="row"><div class="col-md-12"><button ui-sref="tables.dashboard" type="button" class="btn btn-primary btn-sm btn-block"><i class="fa fa-dashboard"></i><stran stext="resource" type="sc"></stran>management dashboard</button></div></div></div></div></div></div></div><div class="col-lg-3 col-md-6"><div class="ibox float-e-margins"><div class="ibox-title"><h5><a ui-sref="customers.dashboard">Customer management <i class="fa fa-chevron-circle-right"></i></a></h5></div><div><div class="ibox-content no-padding border-left-right"><a ui-sref="customers.dashboard"><img alt="image" class="img-responsive" src="content/images/customer_mngt.png"></a></div><div class="ibox-content profile-content"><h4><strong>Customers</strong></h4><p><i class="fa fa-users text-navy"></i> <b>{{ homeCtrl.numberOfCustomers | number}}</b> customer(s) registered</p><p><i class="fa fa-coffee text-info"></i> <b>{{ homeCtrl.visitsPct | percentage:2}}</b> of overall visits</p><p><i class="fa fa-money text-navy"></i> <b>{{ homeCtrl.revenuePct | percentage:2}}</b> of revenue generated</p><p><i class="fa fa-money text-navy"></i> <b>{{ homeCtrl.avgSpendPerCover | currency}}</b> avg spend per<stran stext="person" tyep="s"></stran><small><level-pct class="font-bold pull-right text-navy" display="right" val1="homeCtrl.avgSpendPerCover" val2="homeCtrl.avgSpendPerCoverNonRegulars" desc="Average spend per cover for regulars compared to average spend per cover for non-regulars." desc1="regulars" desc2="non-regulars"></level-pct></small></p><br><div class="user-button"><div class="row"><div class="col-md-12"><button ui-sref="customers.dashboard" type="button" class="btn btn-primary btn-sm btn-block"><i class="fa fa-dashboard"></i> Customer dashboard</button></div></div></div></div></div></div></div><div class="col-lg-3 col-md-6" ng-show="managerAccess"><div class="ibox float-e-margins"><div class="ibox-title"><h5><a ui-sref="reporting">Reporting <i class="fa fa-chevron-circle-right"></i></a></h5></div><div><div class="ibox-content no-padding border-left-right"><a ui-sref="reporting"><img alt="image" class="img-responsive" src="content/images/reports.png"></a></div><div class="ibox-content profile-content"><h4><strong>Reports list</strong></h4><p><a ui-sref="reporting.revenuetrend"><i class="fa fa-tachometer text-navy"></i> Daily performance</a></p><p><a ui-sref="reporting.revenuetrend"><i class="fa fa-line-chart text-navy"></i> Revenue trend</a></p><p><a ui-sref="reporting.employees"><i class="fa fa-tachometer text-navy"></i> Employees performance</a></p><p><a ui-sref="reporting.aggregated"><i class="fa fa-bar-chart-o text-info"></i> Aggregated revenue</a></p><p><a ui-sref="reporting.occupancy"><i class="fa fa-area-chart text-navy"></i> Occupancy report</a></p><br><div class="user-button"><div class="row"><div class="col-md-12"><button ui-sref="reporting" type="button" class="btn btn-primary btn-sm btn-block"><i class="fa fa-dashboard"></i> Reports dashboard</button></div></div></div></div></div></div></div><div class="col-lg-3 col-md-6"><div class="ibox float-e-margins"><div class="ibox-title"><h5><a ui-sref="settings.general">Settings <i class="fa fa-chevron-circle-right"></i></a></h5></div><div><div class="ibox-content no-padding border-left-right"><a ui-sref="settings.general"><img alt="image" class="img-responsive" src="content/images/settings.png"></a></div><div class="ibox-content profile-content"><h4>System settings</h4><p><i class="fa fa-user text-navy"></i> <b>{{ homeCtrl.numberOfEmployees }}</b> employee(s)</p><p><i class="fa fa-circle text-navy"></i> <b>{{ homeCtrl.todayData.locationCapacity.totalTables }}</b><stran stext="resource"></stran>in <b>{{ homeCtrl.numberOfAreas }}</b><stran stext="category"></stran>defined (<b>{{ homeCtrl.todayData.locationCapacity.totalSeatCapacity}}</b> total<stran stext="capacity" type="p"></stran>)</p><p><a ui-sref="settings.employees"><i class="fa fa-cogs text-info"></i> Employee(s) settings</a></p><p><a ui-sref="settings.floor"><i class="fa fa-cogs text-info"></i> Floor settings</a></p><br><div class="user-button"><div class="row"><div class="col-md-12"><button ui-sref="settings.general" type="button" class="btn btn-primary btn-sm btn-block"><i class="fa fa-dashboard"></i> Settings overview</button></div></div></div></div></div></div></div></div></div><div class="col-lg-2 grey-bg"><div class="row"><div id="lastlogin" class="col-lg-12"><table class="table"><thead><tr><th colspan="2"><h4>Since last login</h4></th></tr></thead><tbody><tr ng-show="(homeCtrl.counters.customers.count+homeCtrl.counters.feedbacks.count+homeCtrl.counters.events.count+homeCtrl.counters.prereserved.count+homeCtrl.counters.cancelled.count>0)==0"><td></td><td><b>No changes since last login.</b></td></tr><tr ng-show="homeCtrl.counters.customers.count>0"><td><button ui-sref="customers.list({listType: \'newSinceLastLogin\'})" class="btn btn-outline btn-primary dim" type="button">{{homeCtrl.counters.customers.count}}</button></td><td>New customers registered<div ng-if="homeCtrl.counters.customers.lastCreateTime" class="text-muted small" title="{{homeCtrl.counters.customers.lastCreateTime | amDateFormat: \'lll\'}}">Last: {{homeCtrl.counters.customers.lastCreateTime | amTimeAgo}}</div></td></tr><tr ng-show="homeCtrl.counters.feedbacks.count>0"><td><button ui-sref="customers.feedback" class="btn btn-outline btn-warning dim" type="button">{{homeCtrl.counters.feedbacks.count}}</button></td><td>New customer feedbacks received<div ng-if="homeCtrl.counters.feedbacks.lastCreateTime" class="text-muted small" title="{{homeCtrl.counters.feedbacks.lastCreateTime | amDateFormat: \'lll\'}}">Last: {{homeCtrl.counters.feedbacks.lastCreateTime | amTimeAgo}}</div></td></tr><tr ng-show="homeCtrl.counters.events.count>0"><td><button ui-sref="tables.overview" class="btn btn-outline btn-success dim" type="button">{{homeCtrl.counters.events.count}}</button></td><td>New reservations created<div ng-if="homeCtrl.counters.events.lastCreateTime" class="text-muted small" title="{{homeCtrl.counters.events.lastCreateTime | amDateFormat: \'lll\'}}">Last: {{homeCtrl.counters.events.lastCreateTime | amTimeAgo}}</div></td></tr><tr ng-show="homeCtrl.counters.prereserved.count>0"><td><button ui-sref="tables.management({tab: \'online-res\'})" class="btn btn-outline btn-success dim" type="button">{{homeCtrl.counters.prereserved.count}}</button></td><td>New pre-reservation created<div ng-if="homeCtrl.counters.prereserved.lastCreateTime" class="text-muted small" title="{{homeCtrl.counters.prereserved.lastCreateTime | amDateFormat: \'lll\'}}">Last: {{homeCtrl.counters.prereserved.lastCreateTime | amTimeAgo}}</div></td></tr><tr ng-show="homeCtrl.counters.cancelled.count>0"><td><button ui-sref="tables.search({keyword: \'cancelled:\'})" class="btn btn-outline btn-danger dim" type="button">{{homeCtrl.counters.cancelled.count}}</button></td><td>New cancellation received<div ng-if="homeCtrl.counters.cancelled.lastCreateTime" class="text-muted small" title="{{homeCtrl.counters.cancelled.lastCreateTime | amDateFormat: \'lll\'}}">Last: {{homeCtrl.counters.cancelled.lastCreateTime | amTimeAgo}}</div></td></tr></tbody></table></div></div><br><div class="row"><div id="arrivals" class="col-lg-12"><table class="table"><thead><tr><th colspan="2"><h4>Today\'s expected arrivals</h4><small class="pull-right">{{ homeCtrl.todayData.countStats.expectedVisits | number}} arrival(s) expected ({{ homeCtrl.todayData.countStats.expectedCovers | number}} covers)</small></th></tr></thead><tbody><tr ng-repeat="event in homeCtrl.todayData.expectedArrivalEvents | orderBy:\'expectedStartTime\' "><td><button ng-click="homeCtrl.viewEvent(event.id)" class="btn btn-info btn-circle" type="button"><i class="fa fa-calendar"></i></button></td><td>Arrive in <span time-diff start-time="event.expectedStartTime"></span>. Reserved<stran stext="resource"></stran><span ng-repeat-start="table in event.resources" ng-if="$first" class="text-navy">{{table.name}}</span><span ng-repeat-end="table in event.resources" ng-if="!$first" class="text-navy">, {{table.name}}</span> for {{event.numberOfPersons}} persons.<br><small class="text-muted">{{event.customer.firstName}} {{event.customer.lastName}}, {{event.customer.primaryPhone}}</small></td></tr><tr><td colspan="2"><button ui-sref="tables.management" class="btn btn-primary btn-block m-t"><i class="fa fa-arrow-down"></i> All expected arrivals</button></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/home.new/homenew.html','<div class="wrapper wrapper-content" ng-intro-options="IntroOptions" ng-intro-method="CallMe" ng-intro-autostart="showIntro"><div class="row" ng-show="openingHourNotDefined()"><div class="col-lg-12"><div class="widget yellow-bg text-center"><h4>WARNING: Business hours not defined. Occupancy rate calculation might be wrong. Please define business hours through Clover dashboard or in Settings/Business hours.</h4></div></div></div><div class="row"><div class="col-lg-10"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content" id="performance"><div class="row"><div class="col-lg-12"><span class="pull-right text-success"><span><button class="btn-xs btn-outline btn-default text-muted" type="button" ng-click="homeCtrl.changeHome()">Switch to old home</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="text-bold">{{homeCtrl.timeNow | amDateFormat: \'dddd, Do MMM YY\' }} <i class="fa fa-clock-o"></i> {{homeCtrl.timeNow | amDateFormat: \'H:mm:ss a\' }} <i>{{ homeCtrl.timeDebugNotification }}</i></span></span></span><h3 class="text-navy">Current week overview ({{homeCtrl.weekStart | amDateFormat: \'Do MMM\' }} - {{homeCtrl.weekEnd | amDateFormat: \'Do MMM\' }})</h3></div></div><div class="row"><div class="col-lg-9"><div class="row"><div class="col-lg-12"><br><h4 class="no-margins">Occupancy rate</h4><small>Compared to the previous week ({{homeCtrl.lastWeekStart | amDateFormat: \'Do MMM\' }} - {{homeCtrl.lastWeekEnd | amDateFormat: \'Do MMM\' }}).</small><div class="dashboard-chart"><div google-chart chart="chartComboObjectOccupancyDay"></div></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><table class="table"><thead><tr><th></th><th class=""><span class="text-navy font-bold"><small>CURRENT WEEK<br></small></span></th><th class=""><span class="text-danger font-bold"><small>PREVIOUS WEEK<br></small></span></th></tr></thead><tbody><tr><td><span class="font-bold">Occupancy rate</span></td><td><h3>{{ homeCtrl.data.totalWeekOccupancy.occupancyPct | percentage:2}}</h3></td><td><h3>{{ homeCtrl.lastWeekData.totalWeekOccupancy.occupancyPct | percentage:2}}</h3></td></tr></tbody></table></div></div></div><div class="col-lg-3"><div class="row"><div class="col-lg-12"><br><h4>Completed visits</h4><small class="font-bold">Reservation visits: {{homeCtrl.data.totalWeekOccupancy.reservationEventsCount}} ({{homeCtrl.data.totalWeekOccupancy.reservationCoversCount}}<stran stext="person"></stran>)<br>Wait list visits: {{homeCtrl.data.totalWeekOccupancy.waitlistEventsCount}} ({{homeCtrl.data.totalWeekOccupancy.waitlistCoversCount}}<stran stext="person"></stran>)<br>Walk-in visits: {{homeCtrl.data.walkinseatedEventsCount}} ({{homeCtrl.data.walkinseatedCoversCount}}<stran stext="person"></stran>)</small><br><br><div class=""><div ng-show="showChart>0" google-chart chart="chartPieDonutVisitStat"></div><div ng-show="showChart==0" class="col-lg-11 text-center"><img src="content\\images\\NoDataPieChart.png" style="width: 80%; height: 80%"></div></div></div></div><div class="row"><div class="col-lg-12" s><br><h5>Upcoming visits for current week:</h5>{{homeCtrl.data.countStats.expectedVisits}} visit(s) - {{homeCtrl.data.countStats.expectedCovers}}<stran stext="person"></stran><br><br><br><a ui-sref="tables.overview" href="#/tables/overview/"><button class="btn-sm btn-outline btn-default pull-right">Open reservation center</button></a></div></div></div></div></div></div></div></div></div><div class="col-lg-2 grey-bg" id="lastlogin"><div class="row" ng-if="showSubscriptionInfo()"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-12"><strong>SUBSCRIPTION: <span class="text-navy">FREE</span></strong><br><small class="text-info">100 covers monthly included</small><br><span class="">Reservation counter: {{homeCtrl.subscriptionInfo.reservationCounter}}</span><br><span>Waitlist counter: {{homeCtrl.subscriptionInfo.waitlistCounter}}</span><br><br><a href="https://support.seaton.site/228060-How-do-I-change-my-subscription-plan-" target="_blank"><button class="btn btn-xs btn-outline btn-default">CHANGE SUBSCRIPTION</button></a></div></div></div></div></div><div class="row" ng-show="openingHourNotDefined() || configNotCompleted() || homeCtrl.totalPreReservations >1 "><div class="widget red-bg"><ul class="list-unstyled m-t-md"><li ng-show="configNotCompleted()"><a ui-sref="settings.floor" class="text-white"><span class="fa fa-warning m-r-xs"></span> Floor plan not defined</a></li><li ng-show="openingHourNotDefined()"><a ui-sref="settings.worktime" class="text-white"><span class="fa fa-warning m-r-xs"></span> Business hours not defined</a></li><li ng-show="homeCtrl.totalPreReservations > 0"><a ui-sref="tables.management({tab: \'online-res\'})" class="text-white"><span class="fa fa-warning m-r-xs"></span> Pre-reservations not completed.</a></li></ul></div></div><div class="row"><div class="col-lg-12"><table class="table"><thead><tr><th colspan="2"><h4>Since last login</h4></th></tr></thead><tbody><tr ng-show="(homeCtrl.counters.customers.count+homeCtrl.counters.feedbacks.count+homeCtrl.counters.events.count+homeCtrl.counters.prereserved.count+homeCtrl.counters.cancelled.count>0)==0"><td></td><td><b>No changes since last login.</b></td></tr><tr ng-show="homeCtrl.counters.customers.count>0"><td><button ui-sref="customers.list({listType: \'newSinceLastLogin\'})" class="btn btn-outline btn-primary dim" type="button">{{homeCtrl.counters.customers.count}}</button></td><td>New customers registered<div ng-if="homeCtrl.counters.customers.lastCreateTime" class="text-muted small" title="{{homeCtrl.counters.customers.lastCreateTime | amDateFormat: \'lll\'}}">Last: {{homeCtrl.counters.customers.lastCreateTime | amTimeAgo}}</div></td></tr><tr ng-show="homeCtrl.counters.feedbacks.count>0"><td><button ui-sref="customers.feedback" class="btn btn-outline btn-warning dim" type="button">{{homeCtrl.counters.feedbacks.count}}</button></td><td>New customer feedbacks received<div ng-if="homeCtrl.counters.feedbacks.lastCreateTime" class="text-muted small" title="{{homeCtrl.counters.feedbacks.lastCreateTime | amDateFormat: \'lll\'}}">Last: {{homeCtrl.counters.feedbacks.lastCreateTime | amTimeAgo}}</div></td></tr><tr ng-show="homeCtrl.counters.events.count>0"><td><button ui-sref="tables.overview" class="btn btn-outline btn-success dim" type="button">{{homeCtrl.counters.events.count}}</button></td><td>New reservations created<div ng-if="homeCtrl.counters.events.lastCreateTime" class="text-muted small" title="{{homeCtrl.counters.events.lastCreateTime | amDateFormat: \'lll\'}}">Last: {{homeCtrl.counters.events.lastCreateTime | amTimeAgo}}</div></td></tr><tr ng-show="homeCtrl.counters.prereserved.count>0"><td><button ui-sref="tables.management({tab: \'online-res\'})" class="btn btn-outline btn-success dim" type="button">{{homeCtrl.counters.prereserved.count}}</button></td><td>New pre-reservation created<div ng-if="homeCtrl.counters.prereserved.lastCreateTime" class="text-muted small" title="{{homeCtrl.counters.prereserved.lastCreateTime | amDateFormat: \'lll\'}}">Last: {{homeCtrl.counters.prereserved.lastCreateTime | amTimeAgo}}</div></td></tr><tr ng-show="homeCtrl.counters.cancelled.count>0"><td><button ui-sref="tables.search({keyword: \'cancelled:\'})" class="btn btn-outline btn-danger dim" type="button">{{homeCtrl.counters.cancelled.count}}</button></td><td>New cancellation received<div ng-if="homeCtrl.counters.cancelled.lastCreateTime" class="text-muted small" title="{{homeCtrl.counters.cancelled.lastCreateTime | amDateFormat: \'lll\'}}">Last: {{homeCtrl.counters.cancelled.lastCreateTime | amTimeAgo}}</div></td></tr></tbody></table></div></div></div></div><div class="row" id="events"><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><h5><a ui-sref="tables.management({tab: \'arrivals\'})">Upcoming reservation list for current week &nbsp;&nbsp;<i class="fa fa-chevron-circle-right"></i></a></h5><span class="label label-success pull-right">{{homeCtrl.data.countStats.expectedVisits}} reservations</span></div><div class="ibox-content"><h3 class="text-danger text-center font-bold" ng-if="homeCtrl.data.expected.length == 0">No upcoming reservations for current week.</h3><div ng-show="homeCtrl.data.expected.length != 0"><div class="feed-activity-list"><span ng-repeat="arrival in homeCtrl.data.expected"><div class="feed-element"><span href="" class="pull-left"><i class="fa fa-3x {{channelIcon(arrival.channel)}}" data-toggle="tooltip" data-placement="bottom" title="{{channelToolTipText(arrival.channel)}}"></i></span><div class="media-body"><small class="pull-right"><time am-time-ago="arrival.expectedStartTime"></time> @ {{arrival.expectedStartTime | amDateFormat: \'LT\'}}<br><br><button type="submit" class="btn btn-xs btn-outline btn-default" ui-sref="tables.eventDetails({eventId: arrival.id})">DETAILS</button> </small><strong><a ui-sref="customers.profile({customerId: arrival.customer.id})">{{arrival.customer.fullName}}&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></strong> {{arrival.description}}<br>At <span class="text-success">{{arrival.expectedStartTime | amDateFormat: \'D MMM YYYY @ h:mm A\'}}</span>.<br><small class="text-muted"><i ng-show="arrival.customer.primaryEmail" class="fa fa-envelope-o text-success"></i> <a href="mailto:{{arrival.customer.primaryEmail}}">{{arrival.customer.primaryEmail}}</a> &nbsp;&nbsp; <i ng-show="arrival.customer.primaryPhone" class="fa fa-phone text-success"></i><a href="tel:{{arrival.customer.primaryPhone}}">{{arrival.customer.primaryPhone}}</a></small></div></div></span></div><a ui-sref="tables.management({tab: \'arrivals\'})"><button class="btn btn-primary btn-outline btn-block m-t"><i class="fa fa-calendar"></i>&nbsp;&nbsp;Show all today reservations</button></a></div></div></div></div><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><h5><a ui-sref="tables.management({tab: \'online-res\'})">Open pre-reservation list &nbsp;&nbsp;<i class="fa fa-chevron-circle-right"></i></a></h5><span class="label label-danger pull-right">{{homeCtrl.totalPreReservations}} pre-reservations</span></div><div class="ibox-content"><h3 class="text-danger text-center font-bold" ng-if="homeCtrl.preReservations.length == 0">No open pre-reservations.</h3><div ng-show="homeCtrl.preReservations.length != 0"><div class="feed-activity-list"><span ng-repeat="arrival in homeCtrl.preReservations"><div class="feed-element"><span href="" class="pull-left"><i class="fa fa-3x {{channelIcon(arrival.channel)}}" data-toggle="tooltip" data-placement="bottom" title="{{channelToolTipText(arrival.channel)}}"></i></span><div class="media-body"><small class="pull-right"><time am-time-ago="arrival.expectedStartTime"></time> @ {{arrival.expectedStartTime | amDateFormat: \'LT\'}}<br><br><button type="submit" class="btn btn-xs btn-outline btn-default" ui-sref="tables.eventDetails({eventId: arrival.id})">DETAILS</button> </small><strong><a ui-sref="customers.profile({customerId: arrival.customer.id})">{{arrival.customer.firstName}} {{arrival.customer.lastName}} &nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></strong> {{arrival.description}}<br>At <span class="text-success">{{arrival.expectedStartTime | amDateFormat: \'D MMM YYYY @ h:mm A\'}}</span>.<br><small class="text-muted"><i ng-show="arrival.customer.primaryEmail" class="fa fa-envelope-o text-success"></i> <a href="mailto:{{arrival.customer.primaryEmail}}">{{arrival.customer.primaryEmail}}</a> &nbsp;&nbsp; <i ng-show="arrival.customer.primaryPhone" class="fa fa-phone text-success"></i> <a href="tel:{{arrival.customer.primaryPhone}}">{{arrival.customer.primaryPhone}}</a></small></div></div></span></div><a ui-sref="tables.management({tab: \'online-res\'})"><button class="btn btn-primary btn-outline btn-block m-t"><i class="fa fa-calendar-o"></i>&nbsp;&nbsp;Manage pre-reservations</button></a></div></div></div></div><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><h5><a ui-sref="tables.management({tab: \'waitlist\'})">Wait list &nbsp;&nbsp;<i class="fa fa-chevron-circle-right"></i></a></h5><span class="label label-warning pull-right">{{homeCtrl.waitlistQueues.waitQueue.length}} wait list entries</span></div><div class="ibox-content inspinia-timeline"><h3 class="text-danger text-center font-bold" ng-if="homeCtrl.waitlistQueues.waitQueue.length == 0">No entries in wait list.</h3><span ng-repeat="entry in homeCtrl.waitlistQueues.waitQueue" ng-if="homeCtrl.waitlistQueues.waitQueue.length != 0"><div class="timeline-item"><div class="row"><div class="col-lg-3 date"><span class="pull-right">{{entry.quotedTime}} min <i class="fa fa-clock-o"></i><br></span><span class="pull-right"><small class="text-navy">{{entry.waitingTime}} min ago</small></span></div><div class="col-lg-9 content no-top-border"><p class="m-b-xs"><strong><a ui-sref="customers.profile({customerId: entry.customerId})">{{entry.customerName}}&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></strong> for {{entry.numberOfPersons}} persons</p><p><span class="pull-right"><button type="submit" class="btn btn-xs btn-outline btn-default" ui-sref="tables.eventDetails({eventId: entry.eventId})">DETAILS</button> </span>Added to wait list at {{entry.waitListedDateTime | amDateFormat: \'h:mm A\'}}.<br><small class="text-muted"><i ng-show="entry.customerPhone" class="fa fa-phone text-success"></i> <a href="tel:{{entry.customerPhone}}">{{entry.customerPhone}}</a> &nbsp; &nbsp; <i ng-show="entry.customerEmail" class="fa fa-envelope-o text-success"></i> <a href="mailto:{{entry.customerEmail}}">{{entry.customerEmail}}</a></small></p></div></div></div></span><a ui-sref="tables.management({tab: \'waitlist\'})" ng-if="homeCtrl.waitlistQueues.waitQueue.length != 0"><button class="btn btn-primary btn-outline btn-block m-t"><i class="fa fa-list"></i>&nbsp;&nbsp;Manage wait list</button></a></div></div></div></div></div>');
$templateCache.put('app/layouts/app_layout.html','<div ng-show="show_loading" class="loading-bg modal-dialog"><div class="loading-text"><img src="content/images/spinner.gif"><span class="fa fa-2x" style="vertical-align:middle">&nbsp;&nbsp;{{LoadingMessage || "Processing ..."}}</span></div></div><div ui-view="navbar"></div><div id="page-wrapper" class="gray-bg {{$state.current.name}}"><div ui-view="topnavbar"></div><div ui-view="content"></div><div ui-view="footer"></div></div>');
$templateCache.put('app/layouts/clover_layout.html','<div class="text-white"><nav class="navbar navbar-static-top" role="navigation" style="background: #2f4050; margin-bottom: 0"><div class="navbar-header"><a class="navbar-minimalize minimalize-styl-2" href="#"><span style="font-size: 18px; font-weight: 800; color: white">SeatOn</span></a></div></nav></div><div class="row animated fadeInDown"><div class="col-lg-12"><div ui-view="content"></div></div></div>');
$templateCache.put('app/layouts/login_layout.html','<div class="text-white"><nav class="navbar navbar-static-top" role="navigation" style="background: #2f4050; margin-bottom: 0"><div class="navbar-header"><a class="navbar-minimalize minimalize-styl-2" href="#"><span style="font-size: 18px; font-weight: 800; color: white">SeatOn</span></a></div><ul class="nav navbar-top-links navbar-right"><li><a target="_blank" href="http://www.seaton.site">Product Info</a></li><li><a target="_blank" href="http://support.seaton.site">Support</a></li></ul></nav></div><div class="row animated fadeInDown"><div class="col-lg-12"><div ui-view="content"></div></div></div>');
$templateCache.put('app/layouts/public_layout.html','<div class="text-white"><nav class="navbar navbar-static-top" role="navigation" style="background: #F8F8F8; margin-bottom: 0"><div class="navbar-header"></div><ul class="nav navbar-top-links navbar-right"></ul></nav></div><div class="row animated fadeInDown"><div class="col-lg-12"><div ui-view="content"></div></div></div><div class="row" style="position:relative; margin-bottom: 0; height:60px; background: #ed5666; text-align: center"><div class="col-lg-12"><br><span style="text-align: center"><small style="vertical-align: middle; color: white">POWERED BY SEATON PLATFORM</small></span></div></div>');
$templateCache.put('app/layouts/widget_layout.html','<div class="row animated fadeInDown"><div class="col-lg-12"><div ui-view="content"></div></div></div>');
$templateCache.put('app/reporting/reporting.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox-content"><div><h3 class="font-bold no-margins">Report dashboard</h3><small>Open the report from the list by clicking on one of the pictures below.</small></div><div class="m-t-sm"><div class="row"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-5 col-lg-offset-1"><center><b>Revenue trend report</b><br><small>Track you revenue trend and view all revenue performance details for last 12 months.</small><br><br><a ui-sref="reporting.revenuetrend"><img alt="image" class="img-responsive" src="content/images/revenue_trend_report.png"></a></center></div><div class="col-lg-5"><center><b>Employee performance report</b><br><small>Do you know your employees performance? Details statistics for all employees one click away.</small><br><br><a ui-sref="reporting.employees"><img alt="image" class="img-responsive" src="content/images/employee_performance_report.png"></a></center></div><div class="col-lg-1"></div></div><div class="row"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-md-5 col-lg-offset-1"><center><b>Aggregated reports</b><br><small>Aggregated time of day or day in the week performance now revealed.</small><br><br><a ui-sref="reporting.aggregated"><img alt="image" class="img-responsive" src="content/images/aggregate_report.png"></a></center></div><div class="col-md-5"><center><b>Occupancy report</b><br><small>Optimize your business by knowing occupancy rate on weekly basis.</small><br><br><a ui-sref="reporting.occupancy"><img alt="image" class="img-responsive" src="content/images/occupancy_report.png"></a></center></div></div></div></div></div></div></div>');
$templateCache.put('app/account/clover/clover.html','<div class=""><div class="row"><div class="col-md-10 text-center col-md-offset-1"><br><br><br><h1 class="font-bold text-navy">Welcome to SeatOn Application</h1><h3 class="">Thank you for choosing us.</h3><br><br><div ng-show="starting()"><img src="content/images/spinner.gif"><span class="fa fa-2x text-success" style="vertical-align:middle">&nbsp;&nbsp; Starting application ...</span></div><div ng-show="syncStarted()" class="first-run"><img src="content/images/spinner.gif"><span class="fa fa-2x text-success" style="vertical-align:middle">&nbsp;&nbsp;Please wait while we prepare application for the first use ...</span></div><div ng-show="syncCompleted()"><div class="row"><div class="col-md-12"><span class="fa fa-2x text-success" style="vertical-align:middle">&nbsp;&nbsp;Application is ready for use.</span><br><br></div></div><br><br><div class="row"><div class="col-md-6"><div class="row"><div class="col-lg-12"><h3 class="text-navy">To make it easier to get started with the SeatOn, please check the following</h3></div></div><div class="row"><div class="col-lg-12"><br><br><table class="table table-hover"><tbody><tr ng-show="openingHoursWarning()"><td class="project-status"><span class="fa fa-2x fa-warning text-warning"></span></td><td class="project-title text-left"><h3 class="text-warning">Business hours not defined</h3>Don\'t forget to define business hours using Clover Setup application. SeatOn application will leverage business hours defined in Clover system. As alternative you can set up business hours in SeatOn directly.</td><td class="project-actions"></td></tr><tr><td class="project-status"><span class="fa fa-2x fa-support text-navy"></span></td><td class="project-title text-left"><h3 class="text-navy">Getting Started with SeatOn</h3>Learn in just few minutes how to configure and efficiently use SeatOn application. We recommend this tutorial for new clients.</td><td class="project-actions"><a href="http://support.seaton.site/669145-Getting-started-guide" target="_blank" class="btn btn-white btn-sm">Visit page</a></td></tr><tr><td class="project-status"><span class="fa fa-2x fa-book text-navy"></span></td><td class="project-title text-left"><h3 class="text-navy">SeatOn Support Center</h3>Explore SeatOn Support Center to find details about SeatOn application, ask for help, and report any issues.</td><td class="project-actions"><a href="http://support.seaton.site/" target="_blank" class="btn btn-white btn-sm">Visit page</a></td></tr></tbody></table></div></div></div><div class="col-md-4 col-md-offset-1" style="background-color: #F8F8F8; padding: 30px"><div class="row"><div class="col-lg-12 text-center"><h3 class="text-success">Click on resource type you want to manage using SeatOn</h3></div></div><div class="row"><div class="col-lg-12"><br><br><button class="btn btn-lg btn-success btn-rounded btn-block btn-outline" ng-click="setResourceTypeAndOpenApp(1)">I manage tables. Let\'s start!</button><br>(Restaurants, Wineries, Bars, Pubs, etc.)</div></div><div class="row"><div class="col-lg-12"><br><br><button class="btn btn-lg btn-success btn-rounded btn-block btn-outline" ng-click="setResourceTypeAndOpenApp(100)">I manage other resources. Let\'s start!</button><br>(Beauty Salon, Barber Shop, Salon & Spa, Bowling, and anywhere were resources management is needed)</div></div></div></div></div><div ng-show="hasWarning()"><div class="row"><div class="col-lg-12"><span class="fa fa-2x text-warning" style="vertical-align:middle">&nbsp;&nbsp;Configuration not completed.</span></div></div><br><br><div class="row"><div class="col-lg-12"><div class="project-list"><table class="table table-hover"><tbody><tr ng-show="openingHoursWarning()"><td class="project-status"><span class="fa fa-2x fa-warning text-warning"></span></td><td class="project-title text-left"><h3 class="text-warning">Business hours not defined</h3>Don\'t forget to define business hours using Clover Setup application. SeatOn application will leverage business hours defined in Clover system. As alternative you can set up business hours in SeatOn directly.</td><td class="project-actions"></td></tr><tr ng-show="configNotCompleted()"><td class="project-status"><span class="fa fa-2x fa-warning text-warning"></span></td><td class="project-title text-left"><h3 class="text-warning">Configure SeatOn application</h3>Customize SeatOn application for your needs. To use SeatOn application on Clover devices at least information about resources/floor set up needs to be defined.</td><td class="project-actions"></td></tr><tr><td class="project-status" colspan="3"><br></td></tr><tr ng-show="configNotCompleted()"><td class="project-status" colspan="3"><button class="btn btn-success btn-lg text-white" ng-click="configure()"><i class="fa fa-cogs"></i> &nbsp;Start customizing SeatOn for your needs</button> <button class="btn btn-lg" ng-click="home()">Skip customization</button></td></tr><tr ng-show="!configNotCompleted()"><td class="project-status" colspan="3"><button class="btn btn-info btn-lg text-white" ng-click="home()">Continue to SeatOn application</button></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/account/error/error.html','<div class="loginColumns animated fadeInDown"><div class="row"><div class="col-md-12" ng-show="is401Error()"><div class="row"><div class="col-md-12"><br><br><h2 class="text-center">Please sign in to access SeatOn application</h2><br><br></div></div><div class="row"><div class="col-md-6 col-md-offset-3"><a href="{{vm.cloverEnvUrl}}" class="btn btn-lg btn-primary btn-outline text-center font-bold col-md-12"><i class="fa fa-clover"></i> Sign in with Clover</a></div></div><div class="row"><div class="col-md-12"><br><br><br><br><br><br><p class="text-center">Note: If you experience issue while sign in to the SeatOn application, please report error to SeatOn support team via <a href="http://support.seaton.site" target="_blank">SeatOn Support Portal</a> or on support mail <a href="mailto:support@seaton.site" class="email">support@seaton.site</a><br><br></p></div></div></div><div class="col-md-12" ng-show="isGeneralError()"><h1 class="font-bold text-danger text-center">Error using SeatOn Application has occurred</h1><h4 class="text-center">We apologize for inconvenience caused by this error.</h4><br><br><br><h2 class="text-center">Please report this error to SeatOn support team via <a href="http://support.seaton.site" target="_blank">SeatOn Support Portal</a> or on support mail <a href="mailto:support@seaton.site" class="email">support@seaton.site</a></h2><br><br><br><p>When reporting error, please send us following information:<ul><li>Error code: {{vm.errorCode}}</li><li>Error message: {{vm.errorMessage}}</li><li>MerchantId: {{vm.merchant_id}}</li><li>EmployeeId: {{vm.employee_id}}</li><li>ClientId: {{vm.client_id}}</li><li>Time: {{vm.errorTime}}</li></ul></p><br><br></div><div ng-show="canRecover()" class="text-center"><button class="btn btn-success btn-lg text-white" ng-click="recoverState()">{{recoverButtonText()}}</button></div></div></div>');
$templateCache.put('app/account/login/login.html','<div class="loginColumns animated fadeInDown"><div class="row"><div class="col-md-6"><h1 class="font-bold">Welcome to SeatOn</h1><p>Reinventing resource management. Fully integrated with Clover platform.</p><p>SeatOn modules:<ul><li>Resource management - manage your resources easily and efficiently with integrated and flexible solution.</li><li>Customer management - keep track of your customers\' profiles to provide them with the best dining experience.</li><li>Performance reporting - increase profits by studying your guests\' spending habits.</li></ul></p></div><div class="col-md-6"><div class="ibox-content"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><button type="submit" class="btn btn-primary block full-width m-b" data-translate="login.form.button">Sign in</button><p class="font-bold text-danger text-center">Admin access only.</p><p class="text-muted text-center">In case of any issue contact our support.</p></form></div></div></div><hr><div class="row"><div class="col-md-6">SeatOn Company</div><div class="col-md-6 text-right"><small>\xA9 2015-2020</small></div></div></div>');
$templateCache.put('app/account/locations/locations.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-lg-6 col-sm-12"><h4 class="no-margins">List of merchant locations</h4><small>Please select merchant location to work with.</small></div><div class="row"><div class="col-lg-6 text-right col-sm-12"><a ng-click="vm.logout()"><i class="fa fa-sign-out"></i> Log out</a></div></div></div></div><div class="ibox-content"><div class="row"><div class="col-lg-5 col-sm-12"><input ng-model="vm.searchTerm" ng-change="vm.getLocations()" placeholder="Filter by location name" class="form-control search-query" style="margin-bottom: 20px"></div><div class="col-lg-7 col-sm-12 text-center"><h2>Location selected <span class="text-danger">{{vm.selectedLocation.name}}</span></h2></div></div><div class="row"><div class="col-lg-6 col-md-12 col-sm-12 col-xs-12"><table class="table table-hover" ng-table="list.tableParams55"><thead><tr><th>Name</th><th class="hidden-sm hidden-xs">Address</th><th>Setup</th><th class="hidden-sm hidden-xs">Timezone</th><th class="hidden-sm hidden-xs">Installation</th><th>Subscription</th><th>Action</th></tr></thead><tbody><tr ng-repeat="location in vm.locations"><td class="font-bold"><strong>{{::location.name}}</strong></td><td class="hidden-sm hidden-xs">{{::location.address1}} {{::location.address2}} {{::location.address3}} {{::location.zipcode}} {{::location.city}} {{::location.countryState}} {{::location.country}}</td><td>{{location.initialSetupCompleted}}</td><td class="hidden-sm hidden-xs">{{location.timezone}}</td><td class="hidden-sm hidden-xs">{{location.createdDate | date: \'dd-MM-yyyy HH:mm\'}}</td><td>{{location.subscription}}</td><td><button type="submit" ng-click="vm.showEmployees(location)" class="btn btn-info btn-xs btn-outline">SELECT</button>&nbsp;</td></tr></tbody></table></div><div class="col-lg-6 col-sm-12"><table class="table table-hover" ng-table="list.tableParams55"><thead><tr><th class="text-danger">Name</th><th class="hidden-sm hidden-xs">Login</th><th>Role</th><th class="hidden-sm hidden-xs">Owner</th><th>Action</th></tr></thead><tbody><tr ng-repeat="employee in vm.employees"><td class="font-bold"><strong>{{::employee.name}}</strong></td><td class="hidden-sm hidden-xs">{{::employee.login}}</td><td>{{::employee.role}}</td><td class="hidden-sm hidden-xs">{{::employee.owner}}</td><td><button type="submit" ng-click="vm.logAs(employee)" class="btn btn-info btn-xs btn-outline">LOG AS</button>&nbsp; <button type="submit" ng-click="vm.logAs(employee, true)" class="btn btn-info btn-xs btn-outline">LOG AS ADMIN</button>&nbsp;</td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/accesstoken/accesstoken.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-lg-12"><h4 class="no-margins">List of merchant locations</h4><small>Press refresh button to refresh access token of selected merchant.</small></div></div></div><div class="ibox-content"><div class="row"><div class="col-lg-6"><h4>Filter location by location name</h4><input ng-model="search.name" placeholder="Filter by location name" class="form-control search-query" style="margin-bottom: 20px"></div></div><div class="row"><div class="col-lg-12"><table class="table table-hover" ng-table="list.tableParams55"><thead><tr><th>ID / MID</th><th>Name</th><th>Active</th><th>Subscription</th><th>Access token<br><small>(first 15 chars)</small></th><th>Access token valid until</th><th>Refresh token<br><small>(first 15 chars)</small></th><th>Refresh token valid until</th><th>Action</th></tr></thead><tbody><tr ng-repeat="location in vm.locations | filter: {name: search.name}"><td class="font-bold"><strong>{{::location.locationId}}<br><small>{{::location.cloverId}}</small></strong></td><td class="font-bold"><strong>{{::location.name}}</strong></td><td><strong>{{location.active}}</strong></td><td><small><strong>{{location.subscription}}</strong></small></td><td><small>Token length {{location.accessToken.length}}<br>{{location.accessToken.substring(0,15)}}...</small></td><td><small>{{location.accessTokenExpiration}}<br>{{vm.getDateFromUnixEpoch(location.accessTokenExpiration)}}</small></td><td><small>Token length {{location.refreshToken.length}}<br>{{location.refreshToken.substring(0,15)}}</small></td><td><small>{{location.refreshTokenExpiration}}<br>{{vm.getDateFromUnixEpoch(location.refreshTokenExpiration)}}</small></td><td><button type="submit" ng-show="location.cloverId && location.active" ng-click="vm.refreshToken(location.locationId)" class="btn btn-info btn-xs btn-outline">REFRESH</button> &nbsp;<button type="submit" ng-show="location.cloverId && location.active && !location.refreshToken" ng-click="vm.migrateToken(location.locationId)" class="btn btn-info btn-xs btn-outline">MIGRATE</button>&nbsp; &nbsp;<button type="submit" ng-show="location.cloverId && location.active" ng-click="vm.refreshOnLogin(location.locationId)" class="btn btn-info btn-xs btn-outline">REFRESH ON LOGIN</button>&nbsp;</td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/application/application.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-lg-12"><h4 class="no-margins">List of merchant locations</h4><small>Please select merchant location for application change history.</small></div></div></div><div class="ibox-content"><div class="row"><div class="col-lg-6"><h4>Filter location by location name</h4><input ng-model="vm.searchTerm" ng-change="vm.getLocations()" placeholder="Filter by location name" class="form-control search-query" style="margin-bottom: 20px"></div><div class="col-lg-6"><div class="row"><div class="col-lg-12"><h4 class="text-navy">Search location by employee first or last name, or email</h4></div></div><div class="row"><div class="col-lg-7"><input ng-model="vm.searchParam" placeholder="Search by employee first or last name, and email" class="form-control col-lg-8" style="margin-bottom: 20px"></div><div class="col-lg-5"><button class="btn btn-outline btn-primary" ng-click="vm.searchByEmployee()">Search</button> <button class="btn btn-outline btn-danger" ng-click="vm.getAllLocations()">Show all</button></div></div></div></div><div class="row"><div class="col-lg-12"><table class="table table-hover" ng-table="list.tableParams55"><thead><tr><th>ID / MID</th><th>Name</th><th>Address</th><th>Initial setup completed</th><th>Locale</th><th>Timezone</th><th>Subscription</th><th>Managed resource</th><th>Product type</th><th>Action</th></tr></thead><tbody><tr ng-repeat="location in vm.locations"><td class="font-bold"><strong>{{::location.id}}<br>{{::location.cloverId}}</strong></td><td class="font-bold"><strong>{{::location.name}}</strong></td><td>{{::location.address1}} {{::location.address2}} {{::location.address3}} {{::location.zipcode}} {{::location.city}} {{::location.countryState}} {{::location.country}}</td><td>{{location.initialSetupCompleted}}</td><td>{{location.locale}}</td><td>{{location.timezone}}</td><td><strong>{{location.subscription}}</strong></td><td>{{location.managedResourceType}}</td><td>{{location.productType}}</td><td><button type="submit" ng-click="vm.showLocation(location)" class="btn btn-info btn-xs btn-outline">SELECT</button>&nbsp;</td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/location/location.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-lg-12"><h4 class="no-margins">Location details</h4><button class="btn btn-xs btn-outline btn-primary pull-right" ng-click="vm.returnToList()">Return to location list</button></div></div></div><div class="ibox-content"><div class="row"><div class="col-lg-6"><div class="panel panel-default"><div class="panel-heading">General information\'s</div><div class="panel-body"><div clas="row"><div class="col-lg-6"><strong>Business Name</strong>: {{vm.location.name}}<br><strong>Country</strong>: {{vm.location.country}}<br><strong>Country state</strong>: {{vm.location.countryState}}<br><strong>Address</strong>: {{vm.location.address1}} {{vm.location.address2}} {{vm.location.address3}}<br><strong>City</strong>: {{vm.location.city}}<br><strong>Zipcode</strong>: {{vm.location.zipcode}}<br><br><strong>Email contact</strong>: {{vm.location.emailContact}}<br><strong>Phone contact</strong>: {{vm.location.phoneContact}}<br><strong>Web contact</strong>: {{vm.location.webContact}}<br><strong>Coordinate</strong>: {{vm.location.coordinate}}<br></div></div><div clas="row"><div class="col-lg-6"><strong>Id</strong>: {{vm.location.id}}<br><strong>Clover id</strong>: {{vm.location.cloverId}}<br><br><strong>Initial setup completed</strong>: <strong>{{vm.location.initialSetupCompleted}}</strong><br><strong>Locale</strong>: {{vm.location.locale}}<br><strong>Timezone</strong>: {{vm.location.timezone}}<br><strong>Sms phone number</strong>: {{vm.location.smsPhoneNumber}}</div></div></div></div><div class="panel panel-default"><div class="panel-heading">Current month counters <button class="btn btn-xs btn-outline btn-danger pull-right" ng-click="vm.showCounterDialog()">Reset counters</button></div><div class="panel-body"><div class="row"><div class="col-lg-9"><table class="table table-hover" ng-table="list.tableParams33"><thead><tr><th>Counter</th><th>Value</th></tr></thead><tbody><tr><td><strong>Reservation count</strong></td><td>{{vm.location.reservationCount}}</td></tr><tr><td><strong>Reservation count cover</strong></td><td>{{vm.location.reservationCoverCount}}</td></tr><tr><td><strong>Online reservation count</strong></td><td>{{vm.location.onlineReservationCount}}</td></tr><tr><td><strong>Online reservation count cover</strong></td><td>{{vm.location.onlineReservationCoverCount}}</td></tr><tr><td><strong>IVR reservation count</strong></td><td>{{vm.location.ivrReservationCount}}</td></tr><tr><td><strong>IVR reservation count cover</strong></td><td>{{vm.location.ivrReservationCoverCount}}</td></tr><tr><td><strong>Wait list count</strong></td><td>{{vm.location.waitlistCount}}</td></tr><tr><td><strong>Wait list count cover</strong></td><td>{{vm.location.waitlistCoverCount}}</td></tr><tr><td><strong>Online wait list count</strong></td><td>{{vm.location.onlineWaitlistCount}}</td></tr><tr><td><strong>Onlinw wait list count cover</strong></td><td>{{vm.location.onlineWaitlistCoverCount}}</td></tr></tbody></table></div></div></div></div></div><div class="col-lg-6"><div class="panel panel-default"><div class="panel-heading">Current subscription: <span class="text-danger">{{vm.selectedLocation.subscription}}</span> <button class="btn btn-xs btn-outline btn-danger pull-right" ng-click="vm.showSubscriptionDialog()">Change subscription</button></div><div class="panel-body"><table class="table table-hover" ng-table="list.tableParams33"><thead><tr><th class="text-danger">Change</th><th class="text-danger">Date of change</th><th>Old subscription</th><th>New subscription</th><th>Valid until</th></tr></thead><tbody><tr ng-repeat="application in vm.applications"><td class="font-bold"><strong>{{::application.change}}</strong></td><td>{{::application.changeDatetime}}</td><td>{{::application.oldSubscription}}</td><td>{{::application.newSubscription}}</td><td>{{::application.validUntil}}</td></tr></tbody></table></div></div><div class="panel panel-default"><div class="panel-heading">Statistics</div><div class="panel-body"><div class="row"><div class="col-lg-9"><table class="table table-hover" ng-table="list.tableParams33"><thead><tr><th>Item</th><th>Value</th></tr></thead><tbody><tr><td><strong>Total revenue</strong></td><td>{{vm.location.totalUnknownCustomerRevenue + vm.location.totalCustomerRevenue}}</td></tr><tr><td><strong>Total tips</strong></td><td>{{vm.location.totalTips}}</td></tr><tr><td><span>Total visit with tips</span></td><td>{{vm.location.totalVisitsWithTip}}</td></tr><tr><td><span>Non regular revenue</span></td><td>{{vm.location.totalUnknownCustomerRevenue}}</td></tr><tr><td><span>Non regular tips</span></td><td>{{vm.location.totalUnknownCustomerTip}}</td></tr><tr><td><span>Non regular visit</span></td><td>{{vm.location.totalUnknownCustomerVisit}}</td></tr><tr><td><span>Non regular covers</span></td><td>{{vm.location.totalUnknownCustomerCover}}</td></tr><tr><td><span>Regular revenue</span></td><td>{{vm.location.totalCustomerRevenue}}</td></tr><tr><td><span>Number of canceled reservations</span></td><td>{{vm.location.totalReservationCanceled}}</td></tr><tr><td><span>Number of confirmed reservations</span></td><td>{{vm.location.totalReservationConfirmed}}</td></tr><tr><td><span>Number of reservation no-shows</span></td><td>{{vm.location.totalReservationNoShow}}</td></tr><tr><td><span>Number of reservation shows</span></td><td>{{vm.location.totalReservationShow}}</td></tr><tr><td><strong>Total reservation covers</strong></td><td>{{vm.location.totalReservationCover}}</td></tr><tr><td><span>Total wait list cenceled</span></td><td>{{vm.location.totalWaitlistCanceled}}</td></tr><tr><td><span>Total wait ist confirmed</span></td><td>{{vm.location.totalWaitlistConfirmed}}</td></tr><tr><td><span>Total wait list no shows</span></td><td>{{vm.location.totalWaitlistNoShow}}</td></tr><tr><td><span>Total wait list shows</span></td><td>{{vm.location.totalWaitlistShow}}</td></tr><tr><td><strong>Total wait list cover</strong></td><td>{{vm.location.totalWaitlistCover}}</td></tr><tr><td><span>Total walk-ins</span></td><td>{{vm.location.totalWalkinSeated}}</td></tr><tr><td><strong>Total walk-in covers</strong></td><td>{{vm.location.totalWalkinSeatedCover}}</td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div></div><div class="modal inmodal in" id="myModal" tabindex="-1" role="dialog" ng-if="popupDeleteAreaVisible" style="display: block; padding-right: 16px"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><i class="fa fa-cutlery modal-icon"></i><h4 class="modal-title">Delete<stran stext="category" type="s"></stran></h4></div><div class="modal-body"><label style="margin-right: 25px">{{deleteAreaMessage}}</label></div><div class="modal-footer"><button type="button" class="btn btn-white" data-dismiss="modal" ng-click="closePopup()">Close</button> <button type="button" class="btn btn-primary" ng-if="deleteAreaShowOkDeleteAreaButton" ng-click="deleteArea()">Delete<stran stext="category" type="s"></stran></button></div></div></div></div>');
$templateCache.put('app/admin/location/reset.dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeResetCounterDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title" id="myModalLabel">Select counter to reset</h3></div><div class="modal-body"><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label uib-btn-radio="1" ng-model="vm.counterId" class="btn btn-sm btn-danger btn-outline col-lg-4" style="margin: 2px">All</label></div></div><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label uib-btn-radio="2" ng-model="vm.counterId" class="btn btn-sm btn-primary btn-outline col-lg-4" style="margin: 2px">All reservation</label></div></div><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label uib-btn-radio="3" ng-model="vm.counterId" class="btn btn-sm btn-primary btn-outline col-lg-4" style="margin: 2px">Online reservation only</label></div></div><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label uib-btn-radio="4" ng-model="vm.counterId" class="btn btn-sm btn-primary btn-outline col-lg-4" style="margin: 2px">IVR reservation only</label></div></div><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label uib-btn-radio="5" ng-model="vm.counterId" class="btn btn-sm btn-primary btn-outline col-lg-4" style="margin: 2px">Wait list</label></div></div><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label uib-btn-radio="6" ng-model="vm.counterId" class="btn btn-sm btn-primary btn-outline col-lg-4" style="margin: 2px">Online wait list only</label></div></div><br></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeResetCounterDialog()">Close</button> <button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.resetCounter()">Reset</button></div>');
$templateCache.put('app/admin/location/subscription.dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeSubscriptionDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title" id="myModalLabel">Select new subscription</h3></div><div class="modal-body"><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label uib-btn-radio="1" ng-model="vm.subscriptionType" class="btn btn-sm btn-primary btn-outline col-lg-4" style="margin: 2px">FREE</label></div></div><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label uib-btn-radio="5" ng-model="vm.subscriptionType" class="btn btn-sm btn-primary btn-outline col-lg-4" style="margin: 2px">PAY AS YOU GO</label></div></div><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label uib-btn-radio="2" ng-model="vm.subscriptionType" class="btn btn-sm btn-primary btn-outline col-lg-4" style="margin: 2px">STANDARD</label></div></div><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label uib-btn-radio="3" ng-model="vm.subscriptionType" class="btn btn-sm btn-primary btn-outline col-lg-4" style="margin: 2px">PROFESSIONAL</label></div></div><br><div class="row"><div class="col-lg-12">Valid until:&nbsp;&nbsp;<select ng-model="vm.validMonth"><option value="1">Jan</option><option value="2">Feb</option><option value="3">Mar</option><option value="4">Apr</option><option value="5">May</option><option value="6">Jun</option><option value="7">Jul</option><option value="8">Aug</option><option value="9">Sep</option><option value="10">Oct</option><option value="11">Nov</option><option value="12">Dec</option></select>&nbsp;&nbsp;<select ng-model="vm.validYear"><option value="2021">2021</option><option value="2022">2022</option><option value="2023">2023</option><option value="2024">2024</option><option value="2025">2025</option><option value="2026">2026</option><option value="2027">2027</option><option value="2028">2028</option><option value="2029">2029</option><option value="2030">2030</option><option value="2031">2031</option><option value="2032">2032</option></select>&nbsp;&nbsp;</div></div><br><div class="row"><div class="col-lg-12">Your choice: 1.{{vm.validMonth}}.{{vm.validYear}}</div></div><br></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeSubscriptionDialog()">Close</button> <button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.changeSubscription()">Change</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metered/metered.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-lg-12"><h4 class="no-margins">Merchant metered event log</h4><small>Please define metered event type and month, than select merchant to view metered log.</small></div></div></div><div class="ibox-content"><div class="row"><div class="col-lg-3"><input ng-model="search.name" placeholder="Filter by location name" class="form-control search-query" style="margin-bottom: 20px"></div><div class="col-lg-9 text-center"><div class="row"><div class="col-lg-9 col-md-8"><div class="btn-group"><label ng-model="vm.meteredType" uib-btn-radio="1" class="btn btn-primary btn-outline" ng-change="vm.changeMeteredType()" required><span>Reservation Created</span><br></label><label ng-model="vm.meteredType" uib-btn-radio="6" class="btn btn-primary btn-outline" ng-change="vm.changeMeteredType()" required><span>Reservation Seated</span><br></label><label ng-model="vm.meteredType" uib-btn-radio="2" class="btn btn-primary btn-outline" ng-change="vm.changeMeteredType()" required><span>Waitlist Added</span><br></label><label ng-model="vm.meteredType" uib-btn-radio="3" class="btn btn-primary btn-outline" ng-change="vm.changeMeteredType()" required><span>Waitlist Notified</span><br></label></div></div><div class="col-lg-3 col-md-4 pull-right"><br><br><div class="form-group"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openPicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="select month" type="text" class="form-control" name="selectedDate" style="background-color: #FFF"></div></div></div></div></div></div><div class="row"><div class="col-lg-6"><table class="table table-hover" ng-table="list.tableParams55"><thead><tr><th>Name</th><th>Subscription</th></tr></thead><tbody><tr ng-repeat="location in vm.locations | filter: {name: search.name}"><td class="font-bold"><strong>{{::location.name}}</strong></td><td>{{location.subscription}}</td><td><button type="submit" ng-click="vm.showMetered(location)" class="btn btn-info btn-xs btn-outline">SELECT</button>&nbsp;</td></tr></tbody></table></div><div class="col-lg-6"><div class="row"><div class="col-lg-12 text-center"><h2>Location selected <span class="text-danger">{{vm.selectedLocation.name}}</span></h2></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12 text-center"><h3>Metered log</h3></div></div><div class="row"><div class="col-lg-12"><table class="table table-hover" ng-table="list.tableParams33"><thead><tr><th class="text-danger">Date</th><th>Clover metered event id</th><th>Count</th></tr></thead><tbody><tr ng-repeat="seatonMetered in vm.seatonList"><td class="font-bold text-center"><strong>{{::seatonMetered.createdTime | amDateFormat: \'D MMM YYYY @ H:mm:ss.SSS\'}}</strong></td><td class="text-center">{{::seatonMetered.id}}</td><td class="text-center">{{::seatonMetered.count}}</td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button> <button type="button" class="btn btn-primary" ng-click="vm.clearServerCache()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Clear hibernate cache</span></button><br>Thread pools data:<br></p><p ng-bind-html="vm.threadPoolsStatusData.data"></p><p></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/payment/payment.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-lg-12"><h4 class="no-margins">Payment demo</h4></div></div></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><div class="container"><form action="/charge" method="post" id="payment-form"><div class="form-row top-row"><div id="card-number" class="field card-number"></div><div class="input-errors" id="card-number-errors" role="alert"></div></div><div class="form-row"><div id="card-date" class="field third-width"></div><div class="input-errors" id="card-date-errors" role="alert"></div></div><div class="form-row"><div id="card-cvv" class="field third-width"></div><div class="input-errors" id="card-cvv-errors" role="alert"></div></div><div class="form-row"><div id="card-postal-code" class="field third-width"></div><div class="input-errors" id="card-postal-code-errors" role="alert"></div></div><div id="card-errors" role="alert"></div><div id="card-response" role="alert"></div><div class="button-container"><button>Submit Payment</button></div></form></div></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/test/test.html','<div class="loginColumns animated fadeInDown"><div class="row"><div class="col-md-12 text-center"><h1 class="font-bold text-navy">Test Test</h1></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="admin.user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="admin.user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="admin.user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="admin.user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="admin.user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="admin.user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/customer/create/create.html','<div class="wrapper wrapper-content ng-scope"><form role="form" name="customerForm" class="form-horizontal" on-navigate-away-strategy="none" novalidate><div class="row"><div class="col-lg-6"><div class="ibox"><div class="ibox-title"><h3>Customer details</h3></div><div class="ibox-content"><style>.toggle.ios, .toggle-on.ios, .toggle-off.ios {\n                            border-radius: 17px;\n                        }\n                        .toggle.ios .toggle-handle {\n                            border-radius: 17px;\n                        }</style><div class="form-group" ng-class="{ \'has-error\': customerForm.firstName.$invalid}"><label for="firstName" class="control-label col-sm-3">First name *</label><div class="col-sm-9"><input id="firstName" name="firstName" class="form-control" type="text" ng-model="customer.firstName" placeholder="Please enter first name" required ng-maxlength="64"><div class="validation-error" ng-show="customerForm.firstName.$invalid"><div ng-messages="customerForm.firstName.$error" role="alert"><div ng-message="required">First name is required.</div><div ng-message="maxlength">First name cannot exceed 64 characters.</div></div></div></div></div><div class="form-group" ng-class="{ \'has-error\': customerForm.lastName.$invalid}"><label for="lastName" class="control-label col-sm-3">Last name</label><div class="col-sm-9"><input type="text" class="form-control" id="lastName" name="lastName" ng-model="customer.lastName" placeholder="Please enter last name" ng-maxlength="128"><div class="validation-error" ng-show="customerForm.lastName.$invalid"><div ng-messages="customerForm.lastName.$error" role="alert"><div ng-message="required">Last name is required.</div><div ng-message="maxlength">Last name cannot exceed 128 characters.</div></div></div></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><label for="optForMarketingBtn" class="control-label" style="font-weight: normal">Opted for marketing&nbsp;</label><toggle id="optForMarketingBtn" size="btn-sm" ng-model="customer.marketingAllowed" on="Yes" off="No" offstyle="btn-danger" style="ios" ng-checked="false"></toggle></div></div><div class="hr-line-dashed"></div><span ng-if="dataIsloaded"><important-dates-list debug="false" model="customer.importantDates"></important-dates-list></span><div class="hr-line-dashed"></div><favorite-table debug="false" model="customer.favoriteTable" areas="areas"></favorite-table><div class="hr-line-dashed"></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><label for="reservationAllowedBtn" class="control-label" style="font-weight: normal">Reservation allowed&nbsp;</label><toggle id="reservationAllowedBtn" size="btn-sm" ng-model="customer.reservationAllowed" on="Yes" off="No" offstyle="btn-danger" style="ios" ng-checked="false"></toggle></div></div><div class="form-group"><div class="col-sm-2"></div><div class="col-sm-10"><label id="waitlistAllowedBtn" for="waitlistAllowedBtn" class="control-label" style="font-weight: normal">Waitlist allowed&nbsp;</label><toggle size="btn-sm" ng-model="customer.waitlistAllowed" on="Yes" off="No" offstyle="btn-danger" style="ios" ng-checked="false"></toggle></div></div><div class="hr-line-dashed"></div><div class="form-group"><allergy-list model="customer.allergies"></allergy-list></div><div class="hr-line-dashed"></div><div class="form-group"><label class="col-sm-2 control-label">Note</label><div class="col-sm-10"><textarea rows="6" placeholder="Customer note" class="form-control" ng-maxlength="512" ng-model="customer.note"></textarea></div></div></div></div></div><div class="col-lg-6"><div><addr-list debug="false" model="customer.addresses"></addr-list></div><div ng-class="{\'has-error\': customerForm.emailAddressses.$invalid}"><email-list name="emailAddressses" ng-model-options="{allowInvalid:true}" ng-model="customer.emailAddresses" ui-validate="{ noEmailAddress:\'nonEmpty($value)\' }"><div class="validation-error" ng-show="customerForm.emailAddressses.$invalid"><div ng-messages="customerForm.emailAddressses.$error" role="alert"><div ng-message="noEmailAddress">At least one email address is required.</div></div></div></email-list></div><div ng-class="{\'has-error\': customerForm.phoneNumbers.$invalid}"><phone-list name="phoneNumbers" ng-model="customer.phoneNumbers" ng-model-options="{allowInvalid:true}" ui-validate="{ noPhone:\'nonEmpty($value)\' }"><div class="validation-error" ng-show="customerForm.phoneNumbers.$invalid"><div ng-messages="customerForm.phoneNumbers.$error" role="alert"><div ng-message="noPhone">At least one phone number is required.</div></div></div></phone-list></div></div></div><div class="row"><div class="col-lg-12"><div class="float-e-margins"><div class="row"><div class="col-lg-offset-1 col-lg-11"><div class="form-group"><div class="col-lg-12 text-center"><br><button class="btn btn-white" ng-click="back()" type="reset">Cancel</button> &nbsp; <button ng-disabled="customerForm.$invalid" class="btn btn-primary" ng-click="save()" type="button">Save customer data</button></div></div></div></div></div></div></div></form></div>');
$templateCache.put('app/customer/dashboard/dashboard.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="" row><div class="col-lg-9"><div class="row"><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Total</span><h5 class="text-navy"># Customers</h5></div><div class="ibox-content"><h1 class="no-margins">{{dashboard.generalData.regulars.totalCustomers | number}}</h1><br>New this month <span class="text-danger">{{dashboard.generalData.newCustomersThisMonth}}</span></div></div></div><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Total</span><h5 class="">Revenue from regulars</h5></div><div class="ibox-content"><h1 class="no-margins">{{dashboard.generalData.regulars.totalSpend | currency}}</h1><br>Avg revenue per regular <span class="text-danger">{{dashboard.generalData.regulars.avgSpendByCustomer | currency}}</span></div></div></div><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Total</span><h5 class=""># regulars visit</h5></div><div class="ibox-content"><h1 class="no-margins">{{dashboard.generalData.regulars.totalVisits | number}} visits</h1><br>Avg visits per regular <span class="text-danger">{{dashboard.generalData.regulars.avgVisitsByCustomer | number : 2 }}</span></div></div></div></div><div class="row"><div class="col-lg-12"><div class="panel white-panel"><div class="panel-body"><uib-tabset><uib-tab select="dashboard.tabChange(\'generalStatsTab\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-dashboard"></span> General statistics</uib-tab-heading><div ng-include="\'app/customer/dashboard/partials/general_statistic_tab.html\'"></div></uib-tab><uib-tab select="dashboard.tabChange(\'visitTab\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-pie-chart"></span> Visit statistics</uib-tab-heading><div ng-include="\'app/customer/dashboard/partials/visit_statistic_tab.html\'"></div></uib-tab><uib-tab select="dashboard.tabChange(\'growthTrendTab\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-line-chart"></span> Growth trend</uib-tab-heading><div ng-include="\'app/customer/dashboard/partials/growth_trend_tab.html\'"></div></uib-tab><uib-tab select="dashboard.tabChange(\'memberTypeTab\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-bar-chart"></span> Member type statistics</uib-tab-heading><div ng-include="\'app/customer/dashboard/partials/member_type_stats_tab.html\'"></div></uib-tab></uib-tabset></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><h3 class="text-navy"><i class="fa fa-wifi"></i> Latest customer registrations</h3><hr style="margin-top: 0"></div><div class="ibox-content"><div ng-if="dashboard.customers.length > 0"><table class="table table-striped"><thead><tr><th class="col-md-3">Registered</th><th class="col-md-3">Name</th><th class="col-lg-4 col-md-3 hidden-sm hidden-xs">Contact</th><th class="col-lg-2 col-md-3"></th></tr></thead><tbody><tr ng-repeat="customer in dashboard.customers"><td><i class="fa fa-clock-o"></i> {{customer.createdDate | amCalendar}}</td><td>{{customer.name}}</td><td>{{customer.primaryEmail}}<br>{{customer.primaryPhone}}</td><td><button type="submit" ui-sref="customers.profile({customerId: customer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="customers.create({customerId: customer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button></td></tr></tbody></table></div><div ng-if="dashboard.customers.length === 0"><span>No customer registrations found</span></div><a class="btn btn-primary btn-block m-t" ui-sref="customers.list({listType: \'createdDate\'})"><i class="fa fa-arrow-down"></i> Show all registered customers</a></div></div></div></div></div><div class="col-lg-3 grey-bg"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h5 class="">Quick Search Customer Database</h5></div><div class="ibox-content"><div class="row"><form name="searchForm" role="form" novalidate ng-submit="dashboard.search()" show-validation><div class="col-lg-8"><input ng-model="dashboard.searchKeyword" name="dashboard.searchKeyword" id="dashboard.searchKeyword" placeholder="Please enter search criteria" class="form-control" type="text" ng-minlength="3"></div><div class="col-lg-3"><button ng-click="dashboard.search()" class="btn btn-primary btn-outline" type="submit"><i class="fa fa-search-plus">Search</i></button>&nbsp;</div></form></div></div></div></div><div class="row"><div class="col-lg-12"><table class="table"><thead><tr><th><h4 class="text-navy"><i class="fa fa-link"></i> Quick links</h4></th></tr></thead><tbody><tr><td>&nbsp;&nbsp;<a class="" ui-sref="customers.create"><i class="fa fa-plus-square text-success"></i>&nbsp;&nbsp;Add new customer</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref="customers.list({listType: \'totalSpend\'})"><i class="fa fa-info-circle text-info"></i>&nbsp;&nbsp;Top regulars by spending</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref="customers.list({listType: \'avgSpendPerVisit\'})"><i class="fa fa-info-circle text-info"></i>&nbsp;&nbsp;Top regulars by spend per visit</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref="customers.list({listType: \'totalVisits\'})"><i class="fa fa-info-circle text-info"></i>&nbsp;&nbsp;Top regulars by number of visits</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref="customers.list({listType: \'totalReservation\'})"><i class="fa fa-info-circle text-info"></i>&nbsp;&nbsp;Top regulars by number of reservations</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref="customers.list({listType: \'totalNoShow\'})"><i class="fa fa-info-circle text-danger"></i>&nbsp;&nbsp;Top regulars by no-show number</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref="customers.list({listType: \'totalCanceled\'})"><i class="fa fa-info-circle text-danger"></i>&nbsp;&nbsp;Top regulars by cancelled reservations</a></td></tr></tbody></table></div></div><div class="row"><div class="col-lg-12"><div feedbacks-widget list-scope="location" title="Latest customer feedback" size="5"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/customer/list/list.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="panel white-panel"><div ng-show="vm.listType!=\'basicSearch\'" class="panel-body"><form><div class="form-group"><label class="col-lg-2 control-label">Show customers list sorted by</label><div class="col-lg-8"><div class="input-group"><select data-placeholder="Choose criteria" class="form-control" data-ng-model="vm.listType" ng-change="vm.reload()"><option value="newSinceLastLogin">New since last login</option><option value="createdDate">Registration date</option><option value="totalSpend" selected="selected">Total spend</option><option value="avgSpendPerVisit">Avarage spend per visit</option><option value="totalVisits">Total visit number</option><option value="totalReservation">Number of reservations</option><option value="totalNoShow">Number of no-shows</option><option value="totalCanceled">Number of cancellations</option></select></div><button class="btn btn-primary btn-sm pull-right" type="submit" ng-click="vm.exportCSV()"><i class="glyphicon glyphicon-eye-open"></i>&nbsp;EXPORT to CSV</button></div></div></form></div><div ng-show="vm.listType==\'basicSearch\'" class="panel-body"><div class="ibox-title"><h4 class="no-margins"><i class="fa fa-search-plus"></i>&nbsp;Customer search</h4><small>Please define search criteria (first name, last name, email address or phone number)</small></div><form class=""><div class="col-lg-9"><input ng-model="vm.searchKeyword" name="vm.searchKeyword" ng-minlength="3" placeholder="Search your customer by first name, last name, email address or phone number" class="form-control" type="text"></div><div class="col-lg-3"><button ng-click="vm.search()" class="btn btn-primary btn-outline" type="submit"><i class="fa fa-search-plus">Search</i></button></div></form></div></div></div></div><div class="row"><div class="col-lg-12"><div class="panel white-panel"><div class="panel-heading"><div class="panel-options"><ul class="nav nav-tabs"><li class="active"><h3 class="text-navy"><i class="fa fa-wifi"></i> {{vm.listName}}</h3></li></ul></div></div><div class="panel-body"><div class="tab-content"><span ng-if="vm.errorMsg">{{vm.errorMsg}}</span><div class="tab-pane active" id="tab-activity" ng-if="vm.customers.length>0"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="createdDate"><span>Registered</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name">Name</th><th><i class="fa fa-phone"></i>&nbsp;Contact(s)</th><th jh-sort-by="totalSpend"><span>Total Spend</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="avgSpendPerVisit"><span>Avg. spend per visit</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="totalVisits"><span>Total visits</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="totalReservation"><span>Total Reservation</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="totalNoShow"><span>Total No Show</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="totalCanceled"><span>Total Cancelled</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="customer in vm.customers track by customer.id"><td><i class="fa fa-clock-o"></i> {{customer.createdDate | amCalendar}}</td><td>{{customer.name}}</td><td><a href="mailto:{{customer.primaryEmail}}">{{customer.primaryEmail}}</a><br><a href="tel:{{customer.primaryPhone}}">{{customer.primaryPhone}}</a></td><td class="font-bold text-danger">{{customer.totalSpend | currency}}</td><td>{{customer.avgSpendPerVisit | currency}}</td><td>{{customer.totalVisits}}</td><td>{{customer.totalReservation}} ({{customer.totalReservationShowPerTotalVisitsPct | percentage:2}})</td><td>{{customer.totalNoShow}} ({{customer.noShowPct | percentage:2}})</td><td>{{customer.totalCanceled}} ({{customer.canceledPct | percentage:2}})</td><td class="text-right"><button type="submit" ui-sref="customers.profile({customerId: customer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="customers.create({customerId: customer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div></div></div></div></div></div>');
$templateCache.put('app/customer/feedback/feedback.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3><i class="fa fa-filter"></i>&nbsp;Filter customer feedback <span ng-show="vm.employeeName">- for employee: <b>{{vm.employeeName}}</b></span></h3></div><div class="ibox-content" style="display: block"><form class="form-horizontal"><br><div class="form-group"><label class="col-lg-4 control-label">Feedback rated between</label><div class="col-lg-5"><div id="slider_stars"></div></div></div><div class="form-group" id="dateRange"><label class="col-lg-4 control-label">Feedback posted between</label><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openPicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="select time period" type="text" class="form-control" name="pickerDates" style="background-color: #FFF"></div></div><br><div class="form-group"><div class="col-lg-offset-4 col-lg-9"><button class="btn btn-primary" type="submit" ng-click="vm.searchFeedbacks()">Filter customer feedbacks</button> &nbsp;<button class="btn btn-default btn-outline" type="submit" ng-click="vm.reset()">Clear filter criteria</button></div></div></form></div></div></div></div><div class="row"><div class="col-lg-12"><div class="panel white-panel"><div class="panel-heading"><h3 class=""><i class="fa fa-bullhorn"></i> Customer feedbacks matching defined criteria</h3>Total {{vm.dto.totalFeedbacks}} feedbacks for defined criteria <span class="pull-right"><h3>Rated {{vm.dto.avgRatingWithoutZeros | number : 2}} out of 5 stars</h3><span ng-repeat="rating in vm.dto.ratingsByGroup | reverse"><span uib-rating ng-model="rating.groupIntegerId" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="text-warning"></span> <span class="">{{rating.count }} ({{rating.count/vm.dto.totalFeedbacks | percentage : 2 }})</span><br></span></span></div><div class="panel-body"></div></div></div></div><div class="row" ng-repeat="feedback in vm.feedbacks"><div class="col-lg-12"><div class="panel"><div class="panel-body"><strong><a ng-if="feedback.customerName" ui-sref="customers.profile({customerId: feedback.customerId})" class="text-navy">&nbsp{{feedback.customerName}}</a> <span ng-if="!feedback.customerName" class="text-navy">Customer (walk-in)</span> </strong>posted feedback on <strong><a ui-sref="tables.eventDetails({eventId: feedback.eventId})" class="text-success">{{feedback.eventDescription}}</a></strong>. <span ng-show="vm.moment(vm.dto.employeeLastLoginDate).diff(vm.moment(feedback.createdTime))<0" class="badge badge-danger pull-right">NEW</span><br><span class="text-muted"><small>posted @ {{feedback.createdTime | amTimeAgo}}</small></span><br><br><div class="panel"><div class="panel-body" style="background-color:#F3F5F7">{{feedback.feedback}}</div></div><p class="pull-right"></p><h5><span class="pull-right">Rated &nbsp;&nbsp; <span uib-rating ng-model="feedback.rating" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="text-warning"><span></span></span></h5><p></p></div></div></div></div><div class="row"><div class="col-lg-12"><div class="panel"><div class="panel-body"><span class="text-muted">Displaying maximum 10 feedbacks per page.</span> <span class="pull-right"><div class="text-center" ng-if="vm.totalItems > 0"><div class="info font-bold">Showing {{((vm.currentPage-1)*vm.itemsPerPage) + 1}} - {{((vm.currentPage-1)*vm.itemsPerPage)+vm.feedbacks.length}} of {{vm.totalItems}} items.</div><ul uib-pagination boundary-links="true" direction-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" ng-change="vm.pageChanged()"></ul></div></span></div></div></div></div></div>');
$templateCache.put('app/customer/feedback/feedbacks.directive.html','<div class="ibox float-e-margins"><div class="ibox-title"><h3 class="text-info"><i class="fa fa-comments-o"></i>&nbsp;{{vm.title}} <span ng-if="vm.feedbacks.length > 0" class="small">(showing last {{vm.feedbackLimit }} feedbacks)</span></h3><br></div><div class="ibox-content" ng-if="vm.feedbacks.length > 0"><div class="pull-right m-b-md">Average rating of last {{vm.feedbacks.length}} feedbacks ({{vm.feedbackAverage| number : 2 }}):&nbsp; <span uib-rating style="font-size: 1.2em" ng-model="vm.feedbackAverage" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="text-warning pull-right"></span></div><div class="clearfix"></div><ul class="list-group"><li class="list-group-item" ng-repeat="feedback in vm.feedbacks | limitTo: vm.feedbackLimit as feedbackList"><p class=""><small><a ui-sref="tables.eventDetails({eventId: feedback.eventId})" class="text-success" ng-if="feedback.eventId">{{::feedback.eventDescription}}</a> <a href="" class="text-success" ng-if="!feedback.eventId">General</a></small> <span ng-show="feedback.new" class="badge badge-danger pull-right">NEW</span></p><p class="">{{ feedback.feedback }}</p><small class="block text-muted"><i class="fa fa-clock-o"></i> {{ feedback.createdTime | amTimeAgo }} <span uib-rating style="font-size: 1.2em" ng-model="feedback.rating" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="text-warning pull-right"></span></small></li><button ng-hide="(feedbackList.length == vm.feedbacks.length)" class="btn btn-w-m btn-primary btn-outline" ng-click="vm.feedbackLimit = vm.feedbacks.length">Show all</button> <button ng-hide="(feedbackList.length <= vm.feedbackLimitInitial)" class="btn btn-w-m btn-primary btn-outline" ng-click="vm.feedbackLimit = vm.feedbackLimitInitial">Hide</button> <button ng-hide="vm.listScope==\'employee\' || vm.listScope==\'customer\'" style="width: 100%" class="btn btn-primary btn-block m-t" ui-sref="customers.feedback"><i class="fa fa-arrow-down"></i> Show More</button></ul></div><div class="ibox-content" ng-if="vm.feedbacks.length === 0"><span>No feedbacks provided.</span></div></div>');
$templateCache.put('app/customer/profile/profile.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-3"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row text-center"><div class="col-lg-12"><div class="widget style1 navy-bg"><div class="row"><div class="col-lg-12"><h2>{{ customer.profile.firstName}} {{ customer.profile.lastName}}</h2><br><p class="">Member since: {{::customer.profile.createdDate | date:\'longDate\' }}</p></div></div></div><h2 class="text-warning" style="font-weight: 400">{{customer.stats.memberStatus.name}}</h2><span uib-rating ng-model="customer.profile.customerLevel" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="text-warning" style="font-size: 2em"></span><h3 class="text-warning font-bold">{{ customer.profile.totalPoints }} point(s) collected</h3></div></div><hr><div class="row"><div class="col-lg-12"><table><tr><td class="font-bold text-right" valign="top">Favorite<stran stext="resource" type="s"></stran>:&nbsp;&nbsp;</td><td><span class="badge badge-success">{{customer.profile.favoriteTable ? customer.profile.favoriteTable.name : \'Not defined\'}}</span></td></tr><tr><td class="font-bold text-right" valign="top">Marketing allowed:&nbsp;&nbsp;</td><td><span class="badge badge-warning">{{ customer.profile.marketingAllowed? \'Yes\' : \'No\'}}</span></td></tr><tr><td class="font-bold text-right" valign="top">Allergies:&nbsp;&nbsp;</td><td><span ng-repeat="allergy in customer.profile.allergies" class="badge badge-danger m-r-xs text-capitalize">{{ allergy.allergyType == \'OTHER\' ? allergy.otherName : allergy.allergyType | lowercase}}</span> <span ng-if="!customer.profile.allergies || customer.profile.allergies.length == 0" class="badge badge-danger m-r-xs">No known allergies</span></td></tr></table></div></div><div class="row"><div class="col-lg-12"><br><p class="font-bold">Customer notes:</p><p>{{customer.profile.note}}</p></div></div></div></div><div class="ibox float-e-margins"><div class="ibox-content"><div class="row text-center"><div class="col-lg-12"><button type="button" class="btn btn-w-m btn-primary btn-outline" ng-click="customer.edit(customer.profile.id)">Edit customer</button></div></div><hr><div class="row"><div class="col-lg-12"><table><style>.toggle.ios, .toggle-on.ios, .toggle-off.ios {\n                                        border-radius: 17px;\n                                    }\n                                    .toggle.ios .toggle-handle {\n                                        border-radius: 17px;\n                                    }</style><tr><td class="font-bold text-right" valign="top">Allow reservation:&nbsp;&nbsp;</td><td><toggle size="btn-sm" ng-model="customer.profile.reservationAllowed" on="Yes" off="No" offstyle="btn-danger" style="ios" ng-change="customer.updateAttribute(\'reservationAllowed\')"></toggle></td></tr><tr><td class="font-bold text-right" valign="top">Allow waitlist:&nbsp;&nbsp;</td><td><toggle size="btn-sm" ng-model="customer.profile.waitlistAllowed" on="Yes" off="No" offstyle="btn-danger" style="ios" ng-change="customer.updateAttribute(\'waitlistAllowed\')"></toggle></td></tr></table></div></div></div></div><div ng-if="customer.profile.id"><div feedbacks-widget list-scope="customer" scope-id="customer.profile.id" title="Customer feedback" size="25"></div></div></div><div class="col-lg-9"><div class="row"><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Overall</span><h5 class="text-danger">Total spend</h5></div><div class="ibox-content"><h1 class="no-margins">{{ customer.profile.totalSpend | currency }}</h1><br>Avg per visit <span class="text-danger">{{ customer.profile.avgSpendPerVisit | currency }}</span> &nbsp;<span class="font-bold pull-right"><level value="customer.cstats.totalSpendPct" display="right">{{ customer.cstats.totalSpendPct | percentage:2 }}</level></span></div></div></div><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Overall</span><h5 class="text-danger">Total tips</h5></div><div class="ibox-content"><h1 class="no-margins">{{ customer.profile.totalTips| currency }}</h1><br>Avg per visit <span class="text-danger">{{ customer.profile.avgTipPerVisit | currency }} ({{ customer.oneCustomerStats.tipsPct | percentage:2}})</span> &nbsp;<span class="font-bold pull-right"><level value="customer.cstats.totalTipsPct" display="right">{{ customer.cstats.totalTipsPct | percentage:2 }}</level></span></div></div></div><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span ng-if="customer.oneCustomerStats.noShowPct>customer.locationStats.totalNoShowRatio" class="label label-danger pull-right">High</span> <span ng-if="customer.oneCustomerStats.noShowPct<=customer.locationStats.totalNoShowRatio" class="label label-info pull-right">Low</span><h5 class="text-danger">No show rate</h5></div><div class="ibox-content"><h1 class="no-margins">{{ customer.oneCustomerStats.noShowPct | percentage:2}}</h1><br>Total no show events <span class="text-danger">{{::customer.profile.totalNoShow}}</span></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-4"><table class="table"><thead><tr><th class="text-navy">Contacts <span class="pull-right fa fa-phone-square"></span></th></tr></thead><tbody><tr ng-repeat="phone in customer.profile.phoneNumbers"><td><span class="fa fa-phone m-r-xs"></span> <a ng-class="phone.primaryPhone ? \'font-bold\' : \'\'" href="tel:{{phone.phoneNumber}}">{{ phone.phoneNumber }}</a></td></tr><tr ng-repeat="email in customer.profile.emailAddresses"><td><span class="fa fa-envelope m-r-xs"></span> <a ng-class="email.primaryEmail  ? \'font-bold\' : \'\'" href="mailto:{{email.email}}">{{::email.email}}</a></td></tr></tbody></table></div><div class="col-lg-4"><table class="table"><thead><tr><th class="text-navy">Addresses <span class="pull-right fa fa-home"></span></th></tr></thead><tbody><tr ng-repeat="address in customer.profile.addresses"><td><span class="fa fa-home m-r-xs" style=""></span> {{ customer.formatAddress(address) }}</td></tr></tbody></table></div><div class="col-lg-4"><table class="table"><thead><tr><th class="text-navy">Important dates <span class="pull-right fa fa-calendar"></span></th></tr></thead><tbody><tr ng-repeat="importantDate in customer.profile.importantDates"><td><span ng-if="importantDate.dateType == \'ANNIVERSARY\'" class="fa fa-heart"></span> <span ng-if="importantDate.dateType == \'BIRTHDAY\'" class="fa fa-birthday-cake m-r-xs"></span> <span ng-if="importantDate.dateType == \'OTHER\'" class="fa fa-calendar m-r-xs"></span><label class="text-capitalize">{{ importantDate.dateType == \'OTHER\' ? importantDate.otherName : importantDate.dateType | lowercase }}:</label>&nbsp;{{ importantDate.value | date:\'mediumDate\' }} <span ng-if="customer.isNearDate(importantDate.value)" class="pull-right fa fa-warning text-danger blink" title="Event upcoming soon"></span></td></tr></tbody></table></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><uib-tabset><uib-tab select="customer.tabChange(\'visit\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-pie-chart"></span> Visit statistics</uib-tab-heading><div class="row"><div class="col-lg-12"><div class="panel white-panel"><div class="panel-body"><div class="row"><div class="col-lg-6"><br><br><h3><span class="text-navy font-bold">General visit statistics</span></h3><span class="label label-info pull-right">Overall</span><br><br><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th><th>% diff</th><th># covers</th></thead><tbody><tr><td>Reservation</td><td>{{::customer.profile.totalReservationShow | number}}</td><td>{{ customer.oneCustomerStats.totalReservationShowPerTotalVisitsPct | percentage:2}}</td><td class="text-navy"><level-pct val1="customer.oneCustomerStats.totalReservationShowPerTotalVisitsPct" val2="customer.locationStats.totalReservationShowGenaralRatio"></level-pct></td><td>{{::customer.profile.totalReservationCover}}</td></tr><tr><td>Walk-in seated</td><td>{{customer.profile.totalWalkinSeated}}</td><td>{{ customer.oneCustomerStats.walkinSeatedPerTotalVisitsPct | percentage:2}}</td><td class="text-navy"><level-pct val1="customer.oneCustomerStats.walkinSeatedPerTotalVisitsPct" val2="customer.locationStats.totalWalkinSeatedGenaralRatio"></level-pct></td><td>{{::customer.profile.totalWalkinSeatedCover}}</td></tr><tr><td>Walk-in waitlisted</td><td>{{customer.profile.totalWaitlistShow}}</td><td>{{ customer.oneCustomerStats.totalWaitlistShowPerTotalVisitsPct | percentage:2}}</td><td class="text-danger"><level-pct val1="customer.oneCustomerStats.totalWaitlistShowPerTotalVisitsPct" val2="customer.locationStats.totalWaitlistShowGenaralRatio"></level-pct></td><td>{{::customer.profile.totalWaitlistCover}}</td></tr><tr><th>Totals</th><th>{{customer.profile.totalVisits}}</th><th>100%</th><th><level value="customer.cstats.totalVisitsPct" display="right">{{customer.cstats.totalVisitsPct | percentage:2 }}</level>({{ customer.locationStats.avgVisitsByCustomer | number : 2}})</th><th>{{customer.profile.totalCovers}}</th></tr></tbody></table></div><div class="col-lg-6 -align-center borders"><span ng-if="customer.chartObjectVisitGeneral"><include-pie-chart piechartdata="customer.chartObjectVisitGeneral"></span></div></div></div></div></div></div><div class="row"><div class="col-lg-6"><div class="panel white-panel"><div class="panel-heading"><h3><span class="font-bold text-navy">Reservation statistics</span></h3><span class="label label-info pull-right">Overall</span></div><div class="panel-body"><div class="row"><div class="col-lg-12"><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th><th>% diff</th></thead><tbody><tr><td>Show</td><td>{{customer.profile.totalReservationShow}}</td><td>{{customer.oneCustomerStats.totalReservationShowPct | percentage:2 }}</td><td class="text-navy"><level value="customer.calcPct(customer.oneCustomerStats.totalReservationShowPct , customer.locationStats.totalReservationShowRatio)" display="right">{{ customer.calcPct(customer.oneCustomerStats.totalReservationShowPct , customer.locationStats.totalReservationShowRatio) | percentage:2}}</level></td></tr><tr><td>No Show</td><td>{{customer.profile.totalReservationNoShow}}</td><td>{{customer.oneCustomerStats.totalReservationNoShowPct | percentage:2 }}</td><td class="text-danger"><level value="customer.calcPct(customer.oneCustomerStats.totalReservationNoShowPct , customer.locationStats.totalReservationNoShowRatio)" display="right" invert="true">{{ customer.calcPct(customer.oneCustomerStats.totalReservationNoShowPct , customer.locationStats.totalReservationNoShowRatio) | percentage:2}}</level></td></tr><tr><td>Cancelation</td><td>{{customer.profile.totalReservationCanceled}}</td><td>{{customer.oneCustomerStats.totalReservationCanceledPct | percentage:2 }}</td><td class="text-danger"><level value="customer.calcPct(customer.oneCustomerStats.totalReservationCanceledPct , customer.locationStats.totalReservationCanceledRatio)" display="right" invert="true">{{ customer.calcPct(customer.oneCustomerStats.totalReservationCanceledPct , customer.locationStats.totalReservationCanceledRatio) | percentage:2}}</level></td></tr><tr><th>Totals</th><th>{{customer.profile.totalReservation}}</th><th>100%</th><th><level value="customer.cstats.totalReservationsPct" display="right">{{customer.cstats.totalReservationsPct | percentage:2 }}</level>({{ customer.locationStats.avgReservationByCustomer | number : 2}})</th></tr></tbody></table></div></div><div class="row"><div class="col-lg-12"><span ng-if="customer.chartObjectReservationGeneral"><include-pie-chart piechartdata="customer.chartObjectReservationGeneral"></span></div></div></div></div></div><div class="col-lg-6"><div class="panel white-panel"><div class="panel-heading"><h3><span class="font-bold text-navy">Waitlist statistics</span></h3><span class="label label-info pull-right">Overall</span></div><div class="panel-body"><div class="row"><div class="col-lg-12"><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th><th>% diff</th></thead><tbody><tr><td>Show</td><td>{{customer.profile.totalWaitlistShow}}</td><td>{{customer.oneCustomerStats.totalWaitlistShowPct | percentage:2 }}</td><td class="text-navy"><level value="customer.calcPct(customer.oneCustomerStats.totalWaitlistShowPct , customer.locationStats.totalWaitlistShowRatio)" display="right">{{ customer.calcPct(customer.oneCustomerStats.totalWaitlistShowPct , customer.locationStats.totalWaitlistShowRatio) | percentage:2}}</level></td></tr><tr><td>No Show</td><td>{{customer.profile.totalWaitlistNoShow}}</td><td>{{customer.oneCustomerStats.totalWaitlistNoShowPct | percentage:2 }}</td><td class="text-danger"><level value="customer.calcPct(customer.oneCustomerStats.totalWaitlistNoShowPct , customer.locationStats.totalWaitlistNoShowRatio)" display="right" invert="true">{{ customer.calcPct(customer.oneCustomerStats.totalWaitlistNoShowPct , customer.locationStats.totalWaitlistNoShowRatio) | percentage:2}}</level></td></tr><tr><td>Cancelation</td><td>{{customer.profile.totalWaitlistCanceled}}</td><td>{{customer.oneCustomerStats.totalWaitlistCanceledPct | percentage:2 }}</td><td class="text-danger"><level value="customer.calcPct(customer.oneCustomerStats.totalWaitlistCanceledPct , customer.locationStats.totalWaitlistCanceledRatio)" display="right" invert="true">{{ customer.calcPct(customer.oneCustomerStats.totalWaitlistCanceledPct , customer.locationStats.totalWaitlistCanceledRatio) | percentage:2}}</level></td></tr><tr><th>Totals</th><th>{{customer.profile.totalWaitlist}}</th><th>100%</th><th><level value="customer.cstats.totalWaitlistsPct" display="right">{{customer.cstats.totalWaitlistsPct | percentage:2 }}</level>({{ customer.locationStats.avgWaitlistByCustomer | number : 2}})</th></tr></tbody></table></div></div><div class="row"><div class="col-lg-12"><span ng-if="customer.chartObjectWaitlistGeneral"><include-pie-chart piechartdata="customer.chartObjectWaitlistGeneral"></span></div></div></div></div></div></div></uib-tab><uib-tab select="customer.tabChange(\'spendTrend\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-bar-chart"></span> Spend trend</uib-tab-heading><div class="row" ng-show="!customer.profileSpendTrend"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Analyse customer spend behavior month by month and personalize you approach towards each customer.<br>Check customer habits in the context of the way of arrivals.<br><br><small>Follow this link to find more information about <a href="https://support.seaton.site/781216-Customer-details#SpendTrend" target="_blank">Customer spend trend report</a>.</small><br><br><button class="btn btn-danger" ng-click="customer.openWindow()" target="_blank">{{::customer.profileSpendTrendText}}</button><br><br><small><span class="text-success">Below you can see an example of the Customer sprend trend report.</span></small></div></div></div><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/CustomerProfileSpendTrend.png" class="img-responsive"></div></div></div></div><div class="row" ng-show="customer.profileSpendTrend"><div class="col-lg-12" style="overflow-x: auto; overflow-y: hidden"><div google-chart chart="customer.chartObjectTrend" style="width: 100%"></div></div></div><div class="row" ng-show="customer.profileSpendTrend"><div class="col-lg-10 col-lg-offset-1"><br><div ng-include-template="app/customer/profile/partials/spendTrendByMonth.html" ng-include-variables="{ vm: customer, currencyIcon: currencyIcon, data: \'customerSpendTrendData\', avgSpendPerCover: \'avgSpendPerCover\', lossLabel: \'*\', param1:\'templateParam1\', param2:\'templateParam2\', param3:\'templateParam3\', param4:\'templateParam4\'  }"></div></div></div></uib-tab><uib-tab select="customer.tabChange(\'aggregatedSpend\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-bar-chart"></span> Aggregated spend</uib-tab-heading><div class="row" ng-show="!customer.profileAggregatedSpendTrend"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Check customer spend habits for each day in the week or hour in a day.<br>Found out when customer visit restaurant most often and customer spending averages.<br><br><small>Follow this link to find more information about <a href="https://support.seaton.site/781216-Customer-details#AggregatedSpend" target="_blank">Customer aggregated spend report</a>.</small><br><br><button class="btn btn-danger" ng-click="customer.openWindow()" target="_blank">{{::customer.profileAggregatedSpendTrendText}}</button><br><br><small><span class="text-success">Below you can see an example of the Customer aggregated sprend report.</span></small></div></div></div><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/CustomerProfileAggregatedSpendTrend.png" class="img-responsive"></div></div></div></div><span ng-show="customer.profileAggregatedSpendTrend"><div class="row"><div class="col-lg-12"><div class="btn-group pull-left"><br><br><label ng-model="customer.aggrSpendType" uib-btn-radio="\'byhour\'" class="btn btn-danger btn-outline" ng-change="customer.tabChange(\'aggregatedSpend\')" required><span>Time of Day</span><br></label><label ng-model="customer.aggrSpendType" uib-btn-radio="\'byday\'" class="btn btn-danger btn-outline" ng-change="customer.tabChange(\'aggregatedSpend\')" required><span>Days of the Week</span><br></label></div><div class="btn-group pull-right"><br><br><label ng-model="customer.aggrSpendInterval" uib-btn-radio="3" class="btn btn-primary btn-outline" ng-change="customer.tabChange(\'aggregatedSpend\')" required><span>Last 3 months</span><br></label><label ng-model="customer.aggrSpendInterval" uib-btn-radio="12" class="btn btn-primary btn-outline" ng-change="customer.tabChange(\'aggregatedSpend\')" required><span>Last 12 months</span><br></label></div></div></div><span ng-show="customer.aggrSpendType==\'byhour\'"><div class="row"><div class="col-lg-12"><div google-chart chart="customer.chartObjectHours"></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><div ng-include-template="app/customer/profile/partials/aggrSpendByHour.html" ng-include-variables="{ isMeal: vm.isMeal, vm: customer, currencyIcon: currencyIcon, data: \'aggrByHourData\', avgSpendPerCover: \'avgSpendPerCover\', lossLabel: \'*\' }"></div></div></div></span><span ng-show="customer.aggrSpendType==\'byday\'"><div class="row"><div class="col-lg-12" style="overflow-x: auto; overflow-y: hidden"><div google-chart chart="customer.chartObjectDays" style="width: 95%"></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><div ng-include-template="app/customer/profile/partials/aggrSpendByWeekday.html" ng-include-variables="{ vm: customer, currencyIcon: currencyIcon, data: \'aggrByWeekdayDetailData\', avgSpendPerCover: \'avgSpendPerCover\', lossLabel: \'*\' }"></div></div></div></span></span></uib-tab></uib-tabset></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3 class="text-navy"><i class="fa fa-wifi"></i> Recent visits</h3><hr></div><div class="ibox-content"><div class="tab-content"><div class="tab-pane active" id="tab-activity"><table class="table table-striped"><thead><tr><th><i class="fa fa-calendar"></i>&nbsp;Date</th><th><i class="fa fa-info-circle"></i>&nbsp;Type</th><th><i class="fa fa-info-circle"></i>&nbsp;Status</th><th><i class="fa fa-calendar"></i>&nbsp;Event</th><th><i class="fa fa-money"></i>&nbsp;Spend</th><th><i class="fa fa-gears"></i>&nbsp;Action</th></tr></thead><tbody><tr ng-repeat="event in customer.events track by event.id"><td>{{event.dateTime | amDateFormat: \'lll\'}}</td><td><span ng-class="customer.utils.getEventTypeBkg(event.type)">{{customer.utils.formatEventType(event.type)}}</span></td><td><span ng-class="customer.utils.prettyStatusBkg(event.state, event.status)" class="label">{{customer.utils.prettyStatus(event.state, event.status)}}</span></td><td>{{event.description}}</td><td class="font-bold">{{event.amount | currency}}</td><td><button type="submit" class="btn btn-success btn-sm btn-outline" ui-sref="tables.eventDetails({eventId: event.id})">Details</button></td></tr></tbody></table></div><button class="btn btn-primary btn-block m-t" ng-click="customer.viewAllEvents(customer.profile.id)"><i class="fa fa-arrow-down"></i> Show All Customer Visits (total number: {{customer.eventTotalItems}})</button></div></div></div></div></div></div></div></div>');
$templateCache.put('app/customer/search/customer.search.html','<div ng-init="vm.refreshList();" class="modal-header"><div class="row"><div class="col-lg-12"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()"><span aria-hidden="true">&times;</span></button><h3 class="text-navy"><i class="fa fa-search"></i>&nbsp; Search customers</h3></div></div></div><div class="modal-body"><div class="row"><div class="col-lg-9"><form name="form" ng-submit="vm.refreshList()"><div class="input-group"><span class="input-group-addon"><i class="fa fa-search"></i></span> <input name="keyword" class="form-control" ng-model="customerSearchKeyword" ng-required="true" ng-minlength="3" type="text" placeholder="...search customer by name, phone or email..."></div><p ng-if="form.keyword.$error.minlength" class="text-warning text-small">&nbsp;* at least 3 characters required</p><p ng-if="customerSearchKeyword || form.keyword.$error.required" style="color: white">_</p></form></div><div class="col-lg-3 input-group pull-right"><div class="btn-group btn-block"><button ng-disabled="!customerSearchKeyword" type="submit" class="btn-block btn btn-default btn-outline" ng-click="vm.refreshList()"><i class="fa fa-search"></i>&nbsp;Search</button></div></div></div><div class="row"><div class="col-lg-12"><h4 class="text-danger text-center font-bold" ng-if="vm.customers && vm.totalItems === 0">No customers match the search term.</h4><table ng-if="vm.customers.length > 0" class="table table-striped"><thead><tr><th class="font-bold"><i class="fa fa-user"></i>&nbsp;Customer</th><th class="font-bold"><i class="fa fa-phone"></i>&nbsp;Phone</th><th class="font-bold"><i class="fa fa-envelope"></i>&nbsp;Email</th><th></th></tr></thead><tbody><tr ng-repeat="customer in vm.customers"><td>{{customer.name}}</td><td>{{customer.primaryPhone}}</td><td>{{customer.primaryEmail}}</td><td><button type="submit" class="btn btn-success btn-sm btn-outline" ng-click="vm.customerSelected(customer)">Select</button></td></tr></tbody></table><div class="text-center" ng-if="vm.totalItems > 0"><div class="info font-bold">Showing {{((vm.currentPage-1)*vm.itemsPerPage) + 1}} - {{((vm.currentPage-1)*vm.itemsPerPage)+vm.customers.length}} of {{vm.totalItems}} items.</div><ul uib-pagination boundary-links="true" direction-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" ng-change="vm.pageChanged()"></ul></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default btn-outline" data-dismiss="modal" ng-click="vm.close()">Close</button></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/footer/footer.html','<div class="footer"><div class="pull-right"><a href="https://www.seaton.site" target="_blank">SeatOn Reservations</a></div><div><strong>Copyright</strong> Syngenic.Net &copy; Since 2018 on Clover App Market</div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav id="menu" class="navbar-default navbar-static-side" style="z-index: 1" role="navigation"><div class="sidebar-collapse"><ul side-navigation class="nav metismenu" id="side-menu"><li class="nav-header"><div class=""><h3 class="text-white font-bold">SeatOn</h3></div><div class="profile-element"><span class="clear"><span class="block m-t-xs"><strong class="font-bold">{{vm.account.firstName}} {{vm.account.lastName}}</strong> </span><span class="text-muted text-xs block">{{vm.account.email}}</span></span></div></li><li class="active" ui-sref-active="active"><a ui-sref="home"><i class="fa fa-home"></i> <span class="nav-label">Home</span></a></li><br><li ui-sref-active="active"><a ui-sref="tables.management({tab: \'arrivals\'})"><i class="fa fa-calendar"></i> <span class="nav-label">Today reservations</span></a></li><li ui-sref-active="active"><a ui-sref="tables.management({tab: \'online-res\'})"><i class="fa fa-calendar-o"></i> <span class="nav-label">Open pre-reservations</span></a></li><li ui-sref-active="active"><a ui-sref="tables.management({tab: \'waitlist\'})"><i class="fa fa-list"></i> <span class="nav-label">Wait list</span></a></li><li ui-sref-active="active"><a ui-sref="tables.management({tab: \'walkin\'})"><i class="fa fa-chevron-circle-right"></i> <span class="nav-label">Walk-in</span></a></li><li ui-sref-active="active"><a ui-sref="tables.management({tab: \'active\'})"><i class="fa fa-smile-o"></i> <span class="nav-label">Active visits</span></a></li><li ui-sref-active="active"><a ui-sref="tables.block"><i class="fa fa-step-forward"></i> <span class="nav-label">Block</span></a></li><br><li ui-sref-active="active"><a ui-sref="tables.yearview"><i class="fa fa-calendar"></i> <span class="nav-label">Reservation overview</span></a></li><li ui-sref-active="active"><a ui-sref="tables.overview"><i class="fa fa-university"></i> <span class="nav-label">Reservation center</span></a></li><li ui-sref-active="active"><a ui-sref="tables.timeline"><i class="fa fa-clock-o"></i> <span class="nav-label">Timeline</span></a></li><li ui-sref-active="active"><a ui-sref="tables.search"><i class="fa fa-search-plus"></i> <span class="nav-label">Search</span></a></li><br><li ui-sref-active="active"><a ui-sref-active="customer"><i class="fa fa-users"></i> <span class="nav-label">Customers</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li ui-sref-active="active"><a ui-sref="customers.dashboard">Dashboard</a></li><li ui-sref-active="active"><a ui-sref="customers.create">Add new customer</a></li><li ui-sref-active="active"><a ui-sref="customers.list({listType: \'basicSearch\'})">Customer search</a></li><li ui-sref-active="active"><a ui-sref="customers.list({listType: \'totalSpend\'})">Customer list<span ng-if="counters.numberOfNewCustomers" class="label label-warning pull-right" data-toggle="tooltip" data-placement="right" title="{{counters.numberOfNewCustomers}} new customer(s) since last login">{{counters.numberOfNewCustomers}}</span></a></li><li ui-sref-active="active"><a ui-sref="customers.feedback">Customer feedback<span ng-if="counters.numberOfNewFeedbacks" class="label label-danger pull-right" data-toggle="tooltip" data-placement="right" title="{{counters.numberOfNewFeedbacks}} new customer feedback(s) since last login">{{counters.numberOfNewFeedbacks}}</span></a></li></ul></li><li ui-sref-active="active" ng-show="vm.account.authorities.includes(\'ROLE_MANAGER\') || vm.account.authorities.includes(\'ROLE_OWNER\') || vm.account.authorities.includes(\'ROLE_ADMIN\')"><a ui-sref-active="reportings"><i class="fa fa-line-chart"></i> <span class="nav-label">Reports</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li ui-sref-active="active"><a ui-sref="tables.dashboard">Today statistics</a></li><li ui-sref-active="active"><a ui-sref="reporting.performance">Daily performance</a></li><li ui-sref-active="active"><a ui-sref="reporting.revenuetrend">Revenue trend</a></li><li ui-sref-active="active"><a ui-sref="reporting.employees">Employees performance</a></li><li ui-sref-active="active"><a ui-sref="reporting.aggregated">Aggregated revenue</a></li><li ui-sref-active="active"><a ui-sref="reporting.occupancy">Occupancy</a></li></ul></li><li ui-sref-active="active"><a ui-sref-active="settings_sref"><i class="fa fa-gears"></i> <span class="nav-label">Settings</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li ui-sref-active="active"><a ui-sref="settings.floor">{{vm.isTableManaged?\'Floor plan\':\'Resources\';}}</a></li><li ui-sref-active="active"><a ui-sref="settings.worktime">Business hours</a></li><li ui-sref-active="active"><a ui-sref="settings.general">Products</a></li><li ui-sref-active="active"><a ui-sref="settings.timeslot">Time slots</a></li><li ui-sref-active="active"><a ui-sref="settings.notification">Notifications</a></li><li ui-sref-active="active"><a ui-sref-active="online_sref">Online Reservation <span class="fa arrow"></span></a><ul class="nav nav-third-level"><li ui-sref-active="active"><a ui-sref="settings.online.reservation.settings">Settings</a></li><li ui-sref-active="active"><a ui-sref="settings.online.reservation.web">Web page integration</a></li><li ui-sref-active="active"><a ui-sref="settings.online.reservation.facebook">Facebook integration</a></li><li ui-sref-active="active"><a ui-sref="settings.online.reservation.google">Google integration</a></li></ul></li><li ng-show="vm.isTableManaged && isEU!=true" ui-sref-active="active"><a ui-sref="settings.ivr">IVR Reservation</a></li><li ui-sref-active="active"><a ui-sref="settings.online.waitlist">Online Waitlist</a></li><li ui-sref-active="active"><a ui-sref="settings.alerts">Alerts</a></li><li ui-sref-active="active"><a ui-sref="settings.membership">Membership</a></li><li ui-sref-active="active"><a ui-sref="settings.employees">Employees</a></li></ul></li><br><li ui-sref-active="active"><a href="http://support.seaton.site" target="_blank"><i class="fa fa-life-ring"></i> <span class="nav-label">Support</span></a></li><li ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\')"><br></li><li ui-sref-active="active" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\')"><a ui-sref="public"><i class="glyphicon glyphicon-tower text-danger"></i> <span class="nav-label text-danger" data-translate="global.menu.admin.main">Administration</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level"><li ui-sref-active="active"><a ui-sref="admin.application" ng-click="vm.collapseNavbar()"><span class="fa fa-database"></span>&nbsp; Applications</a></li><li ui-sref-active="active"><a ui-sref="admin.accesstoken" ng-click="vm.collapseNavbar()"><span class="fa fa-database"></span>&nbsp; Access tokens</a></li><li ui-sref-active="active"><a ui-sref-active="online_sref"><span class="fa fa-arrow-circle-o-up"></span>&nbsp; Import <span class="fa arrow"></span></a><ul class="nav nav-third-level"><li ui-sref-active="active"><a ui-sref="admin.import.customer">Customer</a></li><li ui-sref-active="active"><a ui-sref="admin.import.event">Event</a></li></ul></li><li ui-sref-active="active"><a ui-sref-active="online_sref"><span class="fa fa-arrow-circle-o-up"></span>&nbsp; Migration <span class="fa arrow"></span></a><ul class="nav nav-third-level"><li ui-sref-active="active"><a ui-sref="admin.migration.timeslot">Time Slot</a></li></ul></li><li ui-sref-active="active"><a ui-sref="admin.metered" ng-click="vm.collapseNavbar()"><span class="fa fa-database"></span>&nbsp; Metered events</a></li><li ui-sref-active="active"><a ui-sref="admin.payment" ng-click="vm.collapseNavbar()"><span class="fa fa-database"></span>&nbsp; Payment</a></li><li ui-sref-active="active"><a ui-sref="admin.user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="admin.jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="admin.jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="admin.jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="admin.audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="admin.logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="admin.docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="admin.test" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="">Test</span></a></li></ul></li></ul></div></nav>');
$templateCache.put('app/layouts/topnavbar/login_topnavbar.html','<div class="row border-bottom"><nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0"><div class="navbar-header"><a class="navbar-minimalize minimalize-styl-2" href="#"><span style="font-size: 18px; font-weight: 800">SeatOn</span></a></div><ul class="nav navbar-top-links navbar-right"><li><a href="#/tour">Product info</a></li><li><a href="#/blog">Support</a></li></ul></nav></div>');
$templateCache.put('app/layouts/topnavbar/topnavbar.html','<div class="row border-bottom"><nav class="navbar navbar-static-top white-bg" role="navigation" style="margin-bottom: 0"><div class="navbar-header"><span minimaliza-sidebar></span><form role="search" class="navbar-form-custom"><div class="form-group"><input name="keyword" ng-enter="vm.searchEvent()" ng-model="vm.keyword" ng-required="true" ng-minlength="3" placeholder="Search event by code, name, email or phone" class="form-control" type="text" size="40"></div></form></div><ul class="nav navbar-top-links navbar-left"></ul><ul class="nav navbar-top-links navbar-right"><li><a ui-sref="tables.overview"><i class="fa fa-list text-success"></i> Reservation center</a></li><li><a ui-sref="tables.newreservation()" ui-sref-opts="{reload: true}"><i class="fa fa-calendar text-navy"></i> <span class="">Create new reservation</span></a></li><li class="dropdown"><a ui-sref="tables.addtowaitlist()" aria-expanded="false" class="dropdown-toggle count-info" data-toggle="dropdown" class="text-success"><i class="fa fa-plus-square text-navy"></i> Add to waitlist&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a></li><li><a ng-click="vm.logout()"><i class="fa fa-sign-out text-danger"></i>Log out</a></li><li><a ng-click="vm.showHelp()" ng-show="true"><i class="fa fa-life-ring text-warning seaton-tooltip"><span class="seaton-tooltiptext-warning seaton-tooltip-bottom">Show help for current screen.</span></i></a></li><li><a href="http://support.seaton.site" target="_blank"><i class="fa fa-question-circle text-success seaton-tooltip"><span class="seaton-tooltiptext-success seaton-tooltip-bottom">SeatOn Support Center</span></i></a></li><li><a href="http://www.seaton.site" target="_blank"><i class="fa fa-info-circle text-info seaton-tooltip"><span class="seaton-tooltiptext-info seaton-tooltip-left">SeatOn Product Page</span></i></a></li><li><a ng-href="/#/public/online/reservation/{{vm.hashedLocationId}}?channel=merchant_web" target="_target"><i class="fa fa-globe text-danger seaton-tooltip"><span class="seaton-tooltiptext-info seaton-tooltip-left">Open online reservation page</span></i></a></li></ul></nav></div>');
$templateCache.put('app/public/cancel/cancel.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-10"><h1 class="font-bold">{{vm.data.locationName}}</h1><strong>{{vm.data.locationAddress}}</strong><hr></div></div><div class="row"><div class="col-md-10 col-md-offset-1 co-xs-12"><br><h3 class="font-bold" ng-show="vm.data.customerName.indexOf(\'IVR\')==-1">Dear {{vm.data.customerName}},</h3><h3 class="font-bold" ng-show="vm.data.customerName.indexOf(\'IVR\')!=-1">Dear customer,</h3><br></div></div><div ng-show="!vm.canceled && vm.data.visitDate" class="row"><div class="col-md-10 col-md-offset-1 co-xs-12"><div class="row"><div class="col-xs-12"><span style="font-size:120%">Your table is waiting for you!<br>We have your reservation for <strong>{{vm.data.numberOfPersons}} person(s)</strong> on <strong>{{vm.data.visitDate}}</strong>.<br><br></span><span ng-show="vm.data.cancelCutOffTime!=null" style="font-size:120%">If you will not be able to arrive, please let us know and cancel your reservation (click on button "Cancel reservation").<br><br></span><span ng-show="vm.data.cancelCutOffTime!=null && !vm.cancelFailed" style="font-size:150%"><button class="btn btn-lg public-button-logo" ng-click="cancelEvent()" ng-disabled="vm.data.cancelCutOffTime==null">Cancel reservation</button> </span><span class="text-danger" style="font-size:120%" ng-show="vm.data.cancelCutOffTime==null || vm.cancelFailed"><br><br>Cancellation is not possible at this time, as cancellation policy requires cancel action at latest {{vm.data.cancelPolicy}} before event start. Please contact us in case of any inquiry. </span><span style="font-size:120%" ng-show="vm.data.cancelCutOffTime!=null && !vm.cancelFailed && vm.data.cancelCutOffTime!=vm.data.visitDate"><br><br>Please note, cancellation is possible until <strong>{{vm.data.cancelCutOffTime}}</strong> ({{vm.data.cancelPolicy}} before event start) </span><span style="font-size:120%"><br><br>{{vm.data.locationName}}</span><br><br><br></div></div></div></div><div ng-show="!vm.data.visitDate" class="row"><div class="col-md-10 col-md-offset-1 co-xs-12"><span style="font-size:120%">Reservation is not active anymore.<br><br></span></div></div><div ng-show="vm.canceled" class="row"><div class="col-md-10 col-md-offset-1 co-xs-12"><span style="font-size:120%">Your reservation for <strong>{{vm.data.numberOfPersons}} person(s)</strong> on <strong>{{vm.data.visitDate}}</strong> has been <span class="font-bold text-danger">cancelled successfully</span>.<br>Thank you for letting us know that you will not be able to join us at the reserved time.<br><br>We hope you will be able to join us at another time!<br><br>{{vm.data.locationName}}<br><br><br></span></div></div><div class="row" ng-if="vm.data.locationContactPhone || vm.data.locationContactEmail"><div class="col-md-2 col-md-offset-1"><img src="content/email/images/contact-us.jpg" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-4"><h3>Contact us</h3>In case of any inquiry please contact us.<br><span ng-if="vm.data.locationContactPhone"><a href="tel:{{vm.data.locationContactPhone}}"><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{vm.data.locationContactPhone}}</a><br></span><span ng-if="vm.data.locationContactEmail"><a href="mailto:{{vm.data.locationContactEmail}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{vm.data.locationContactEmail}}</a><br></span></div></div><br><br><br><br><br></div></div></div></div></div>');
$templateCache.put('app/public/confirm/confirm.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-10"><h1 class="font-bold">{{vm.data.locationName}}</h1><strong>{{vm.data.locationAddress}}</strong><hr></div></div><div class="row"><br><div class="col-md-10 col-md-offset-1 col-xs-12"><h3 class="font-bold">Dear {{vm.data.customerName}},</h3><br></div></div><div class="row"><div class="col-md-8 col-md-offset-1 col-xs-12"><span style="font-size: 120%">Thank you for verifying your email address and request details for <strong>{{vm.data.numberOfPersons}} person(s)</strong> on <strong>{{vm.data.visitDate}}</strong>.<br><br>Your reservation is being processed and you will receive a separate email to confirm that we are able to accommodate your reservation request.<br><br><i>Please note, your reservation is not confirmed until you receive your confirmation email.</i><br><br>We look forward to welcoming you soon!<br>{{vm.data.locationName}}<br><br><br></span></div></div><div class="row" ng-if="vm.data.locationContactPhone || vm.data.locationContactEmail"><div class="col-md-2 col-md-offset-1"><img src="content/email/images/contact-us.jpg" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-4"><h3>Contact us</h3>In case of any inquiry please contact us.<br><span ng-if="vm.data.locationContactPhone"><a href="tel:{{vm.data.locationContactPhone}}"><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{vm.data.locationContactPhone}}</a><br></span><span ng-if="vm.data.locationContactEmail"><a href="mailto:{{vm.data.locationContactEmail}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{vm.data.locationContactEmail}}</a><br></span></div></div><br><br><br><br><br></div></div></div></div></div>');
$templateCache.put('app/public/feedback/feedback.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="row"><div class="col-md-10"><h1 class="font-bold">{{vm.data.locationName}}</h1><strong>{{vm.data.locationAddress}}</strong><hr></div></div><div ng-show="!vm.submitted"><div class="row"><div class="col-md-6 col-md-offset-1 text-center font-bold"><h2 class="text-center font-bold">WE LOVE FEEDBACK</h2><br></div></div><div class="row"><div class="col-md-6 col-md-offset-1 col-xs-12"><h3 class="font-bold" ng-show="vm.data.customerName.indexOf(\'IVR\')==-1">Dear {{vm.data.customerName}},</h3><h3 class="font-bold" ng-show="vm.data.customerName.indexOf(\'IVR\')!=-1">Dear customer,</h3><br><span style="font-size:120%">Thank you for your recent visit<span ng-if="vm.data.visitDate && vm.data.numberOfPersons"> ({{vm.data.visitDate}}{{vm.data.numberOfPersons}})</span>.<br>We will greatly appreciate if you would rate your experience and leave feedback. Tell us what we do well, and what could be improved.<br>Help us make our service better.</span></div></div><div class="row"><div class="col-md-6 col-md-offset-1 col-xs-12"><div class="text-center"><br><span uib-rating ng-model="vm.rating" max="5" on-hover="hoveringOver(value)" on-leave="overStar = null" titles="[\'one\',\'two\',\'three\']" aria-labelledby="default-rating" style="color:gold; font-size: 400%"></span></div></div></div><div class="row"><div class="col-md-6 col-md-offset-1 col-xs-12"><br><textarea class="col-lg-12 col-xs-12" ng-model="vm.feedback" maxlength="2048" rows="6" placeholder="Your feedback here (2048 characters max)"></textarea></div></div><div class="row"><div class="col-md-6 col-md-offset-1 col-xs-12"><br><button class="btn-block btn-lg public-button-logo" ng-click="submitFeedback()">Send feedback</button></div></div></div><div ng-show="vm.submitted"><div class="row"><div class="col-md-6 col-md-offset-1 col-xs-12"><h3 class="font-bold">Dear {{vm.data.customerName}},</h3><br><span style="font-size:120%">Thank you for your feedback. Hope to see you again soon.</span><br><br><br><span style="font-size:120%">{{vm.data.locationName}}<br></span><br><br><br></div></div><div class="row" ng-if="vm.data.locationContactPhone || vm.data.locationContactEmail"><div class="col-md-2 col-md-offset-1"><img src="content/email/images/contact-us.jpg" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-4"><h3>Contact us</h3>In case of any inquiry please contact us.<br><span ng-if="vm.data.locationContactPhone"><a href="tel:{{vm.data.locationContactPhone}}"><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{vm.data.locationContactPhone}}</a><br></span><span ng-if="vm.data.locationContactEmail"><a href="mailto:{{vm.data.locationContactEmail}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{vm.data.locationContactEmail}}</a><br></span><br><br><br></div></div></div><br><br></div></div></div>');
$templateCache.put('app/public/error/error.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="row"><div class="col-md-10"><h1 class="font-bold">Oops, something\'s gone wrong!</h1><hr></div></div><div class="row"><div class="col-xs-10 col-xs-offset-1"><h2 class="font-bold">Dear visitor,</h2><br><div ng-show="!vm.eventClosed"><span style="font-size: 120%">We apologize for any inconvenience this may caused to you.<br><br>Please try again using link already communicated to you.<br>Take care to copy full link as is.</span></div><div ng-show="vm.eventClosed"><span style="font-size: 120%">Event with this reference number is closed.</span></div><br><span style="font-size: 120%">If the error persists, please report this error to us on email <a href="mailto:support@seaton.site">support@seaton.site</a>.</span><br><br><br><span style="font-size: 150%">SeatOn team</span></div></div><br><br><br><br><br></div></div></div>');
$templateCache.put('app/public/queue/queue.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1 col-xs-12"><div class="ibox"><div ng-show="vm.data.locationName" class="ibox-content"><div class="row"><div class="col-md-10"><h1 class="font-bold">{{vm.data.locationName}}</h1><strong>{{vm.data.locationAddress}}</strong><hr></div></div><div class="row"><div class="col-md-6 col-md-offset-1 col-xs-12"><br><h3 class="font-bold">Dear {{vm.data.customerName}},</h3><br></div></div><div ng-show="vm.data.eventStatus==\'WAITLISTED\'" class="row"><div class="col-md-6 col-md-offset-1 col-xs-12"><h3 class="text-success" ng-show="vm.data.numberInQueue<=5">Hooray, you are the {{vm.queueText}} in line.</h3><span ng-show="!vm.isEU">When your table is ready you will receive text (SMS) notification on phone number <strong>{{vm.data.customerPrimaryPhone}}</strong>.<br><br></span><span ng-show="vm.isEU">When your table is ready you will receive notification on email address <strong>{{vm.data.customerPrimaryEmail}}</strong>.<br><br></span><h3 class="" ng-show="vm.expectedIn>0">Your table is expected to be available within <span class="text-bold text-navy">{{vm.expectedIn}} min</span>.</h3><h3 class="" ng-show="vm.expectedIn<=0">Your table will be ready soon.</h3></div></div><div ng-show="vm.data.eventStatus==\'WAITLISTED\'" class="row"><div class="col-md-6 col-md-offset-1 col-xs-12"><br><img ng-show="vm.picNumber==1" class="img-responsive" src="content/images/queue/wts_1.png" style="display: block; margin-left: auto; margin-right: auto"> <img ng-show="vm.picNumber==2" class="img-responsive" src="content/images/queue/wts_2.png" style="display: block; margin-left: auto; margin-right: auto"> <img ng-show="vm.picNumber==3" class="img-responsive" src="content/images/queue/wts_3.png" style="display: block; margin-left: auto; margin-right: auto"> <img ng-show="vm.picNumber==4" class="img-responsive" src="content/images/queue/wts_4.png" style="display: block; margin-left: auto; margin-right: auto"> <img ng-show="vm.picNumber==5" class="img-responsive" src="content/images/queue/wts_5.png" style="display: block; margin-left: auto; margin-right: auto"> <img ng-show="vm.picNumber==6" class="img-responsive" src="content/images/queue/wts_5plus.png" style="display: block; margin-left: auto; margin-right: auto"><br></div></div><div ng-show="vm.data.eventStatus==\'NOTIFIED\' || vm.data.eventStatus==\'CONFIRMED\'" class="row"><div class="col-md-6 col-md-offset-1 col-xs-12"><h3 class="text-success" ng-show="vm.data.numberInQueue<=5">Your table is waiting for you!</h3><br></div></div><div ng-show="vm.data.eventStatus==\'SHOW\' || vm.data.eventStatus==\'NO_SHOW\' || vm.data.eventStatus==\'CANCEL\'" class="row"><div class="col-md-6 col-md-offset-1 col-xs-12"><h3 class="text-success" ng-show="vm.data.numberInQueue<=5">Your waitlist entry is closed.</h3><h3 class="text-success" ng-show="vm.data.numberInQueue<=5">Please contact the restaurant for more information.</h3><br></div></div><div class="row"><div class="col-md-6 col-md-offset-1 col-xs-12"><br><span>{{vm.data.locationName}}<br>{{vm.data.locationAddress}}</span><br><br><br></div></div><div class="row"><div class="col-md-2 col-md-offset-1"><img src="content/email/images/visit-details.jpg" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-4"><h3>Event details</h3>Addedd to waitlist at <span class="text-bold text-success">{{vm.data.addedToWaitList}}.</span><br>Number of persons <span class="text-bold text-success">{{vm.data.numberOfPersons}} x <i class="fa fa-user"></i></span><br><span ng-show="vm.data.eventStatus==\'WAITLISTED\'">Quoted time <span class="text-bold text-success">{{vm.data.quotedTime}} min</span><br></span></div></div><div class="row"><div class="col-xs-12"><br><br></div></div><div class="row" ng-if="vm.data.locationContactPhone || vm.data.locationContactEmail"><div class="col-md-2 col-md-offset-1"><img src="content/email/images/contact-us.jpg" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-md-4"><h3>Contact us</h3>In case of any inquiry please contact us.<br><span ng-if="vm.data.locationContactPhone"><a href="tel:{{vm.data.locationContactPhone}}"><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{vm.data.locationContactPhone}}</a><br></span><span ng-if="vm.data.locationContactEmail"><a href="mailto:{{vm.data.locationContactEmail}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{vm.data.locationContactEmail}}</a><br></span></div></div></div></div></div></div></div>');
$templateCache.put('app/public/setup/setup.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1 col-xs-10 col-xs-offset-1"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-10"><h1 class="font-bold">SeatOn Customization Questionnaire</h1><strong>Share with us your customization requirements and we will setup SeatOn for you.</strong><hr></div></div><form name="setupForm" class="form-horizontal" method="post" enctype="multipart/form-data"><div class="row"><div class="col-lg-10"><div class="form-group col-lg-8"><h2 class="text-success font-bold">General information</h2></div><div class="form-group col-lg-8" ng-class="{ \'has-error\': setupForm.merchantName.$invalid}"><input autofocus name="merchantName" ng-model="vm.setup.merchantName" class="form-control" placeholder="Your business name" type="text" tabindex="1" style="background-color: rgba(0,0,0,0)"></div><div class="form-group col-lg-8" ng-class="{ \'has-error\': setupForm.contactEmail.$invalid || setupForm.contactEmail.$error.email}"><input autofocus name="contactEmail" ng-model="vm.setup.contactEmail" class="form-control" placeholder="Your contact email in case additional clarification required" type="email" validate-email style="background-color: rgba(0,0,0,0)"></div></div></div><div class="row"><div class="col-lg-12"><hr class="col-lg-10"><div class="form-group col-lg-10"><h2 class="text-success font-bold">Floor plan</h2><br><h3>Two option to share your floor plan with us.</h3><input class="radio-primary" ng-model="vm.setup.floorPlanOption" type="radio" name="floorPlan" id="radio_floorPlan_1" value="PICTURE" checked=""><label for="radio_floorPlan_1"><strong class="text-danger">Option 1:</strong> Send us picture of each section of floor plan defined in Clover Dining application or any other application you currently use.</label><br><br>Send pictures of your floor plan on email: <a href="mailto:support@seaton.site">support@seaton.site</a> with subject <strong>Floor plan for "your business name"</strong><br><br><input class="radio-primary" ng-model="vm.setup.floorPlanOption" type="radio" name="floorPlan" id="radio_floorPlan_2" value="DESCRIPTION" checked=""><label for="radio_floorPlan_2"><strong class="text-danger">Option 2:</strong> Share with us a description of your floor plan, sections and tables details.</label><br><br><strong>Example:</strong>:<br>Area(Section) "Main dining room": T01 (4 seats), T02 (4 seats), T03(6 seats), T04(2 seats), ...<br>Area(Section) "Patio": P01 (4 seats), P02(4 seats), P03 (2 seats), ....<br>You can define up to 26 areas(sections) and unlimited number of tables. Tables can be named according to your standard, no limitation.<br><br><div class="form-group"><textarea rows="8" ng-model="vm.setup.resources" placeholder="Please share description of your floor plan." class="form-control" ng-maxlength="10000" ng-disabled="vm.setup.floorPlanOption!=\'DESCRIPTION\'"></textarea></div></div></div></div><div class="row"><div class="col-lg-12"><hr class="col-lg-10"><div class="form-group col-lg-10"><h2 class="text-success font-bold">Business hours</h2><br><h3>Upon installation of SeatOn app, business hours are synced with business hours as defined in your Clover system.</h3>In case you want different business hours then they are defined in Clover system, please share your business hours details you want to use in SeatOn.<br><br><strong>Example</strong>:<br>Monday: Closed<br>Tuesday: from 10am to 11pm<br>Wednesday: from 9:30am to 2pm and from 5:15pm to 11pm<br>etc.<br><br><div class="form-group"><textarea rows="7" ng-model="vm.setup.businessHours" placeholder="Please share business hours you want to use in SeatOn if different then one defined in Clover system." class="form-control" ng-maxlength="10000"></textarea></div></div></div></div><div class="row"><div class="col-lg-12"><hr class="col-lg-10"><div class="form-group col-lg-10"><h2 class="text-success font-bold">Reservation time slots</h2><br><h3>Please define reservation time slots you want to offer to your guest when they are making online reservations.</h3>Please note, when a reservation is created by your staff it will be possible to pick any date and time.<br><br><h3>There are two options how to define time slots:</h3><input class="radio-primary" ng-model="vm.setup.timeSlotOption" type="radio" name="timeSlot" id="radio_timeslot_1" value="SIMPLE" checked=""><label for="radio_timeslot_1"><strong class="text-danger">Option 1:</strong> Define interval between reservations and system will create time slots within your business hours.</label><br><br>Create time slots list with<select ng-model="vm.setup.timeStep" ng-required="true" ng-options="item.id as item.name for item in vm.timeStepList" ng-disabled="vm.setup.timeSlotOption!=\'SIMPLE\'"></select>intervals between time slots.<br><strong>Example:</strong> if you choose 30 min, reservation time slot list will look like .., 1:30pm, 2pm, 2:30pm, ..., etc within you business hours.<br><br><input class="radio-primary" ng-model="vm.setup.timeSlotOption" type="radio" name="timeSlot" id="radio_timeslot_2" value="MANUAL" checked=""><label for="radio_timeslot_2"><strong class="text-danger">Option 2:</strong> Define time slot list manually, same for all days in week or for each day in week different list.</label><br><br><strong>Example:</strong><br>Same for each day in week: 11:00am, 11:15am, 12:00pm, 12:30pm, 1:00pm, 1:15pm, 2:00pm, 3:00pm, etc<br>Different time slot list for each day in week:<br>Monday - Closed,<br>Tuesday - 10am, 11am, 12pm, 1pm, 2pm, 3pm, 4pm, 5pm, 5:30pm, 6pm, ... etc<br>Wednesday - 9:30am, 10am, 11am, 12pm, 1pm, 5:15pm, 5:30pm, 6pm, 7pm, 8pm, etc<br>... other days in week<br><br><div class="form-group"><textarea rows="7" ng-model="vm.setup.timeSlotList" placeholder="Please define reservation time slots." class="form-control" ng-maxlength="10000" ng-disabled="vm.setup.timeSlotOption!=\'MANUAL\'"></textarea></div></div></div></div><div class="row"><div class="col-lg-12"><hr class="col-lg-10"><div class="form-group col-lg-10"><h2 class="text-success font-bold">Event duration</h2><br><h3>Please define duration of the events (valid for all events type - reservation, walk-ins, waitlist).</h3>Please note, when reservation is created by your staff it will be possible to pick any duration when creating event.<br><br><h3>You can chose your set up from following options:</h3><input class="radio-primary" ng-model="vm.setup.durationOption" type="radio" name="duration" id="radio_duration_1" value="MEAL" checked=""><label for="radio_duration_1"><strong class="text-danger">Option 1:</strong> Standard duration for breakfast, lunch and dinner. System will automatically assign duration to event.</label><br><small>Please note, you can define meal name which fit better your business.</small><br><br><div class="row"><div class="col-lg-2 col-sm-4"><input placeholder="Breakfast" type="text" ng-model="vm.setup.breakfastName" size="12" maxlength="32" ng-disabled="vm.setup.durationOption!=\'MEAL\'"></div><div class="col-lg-3 col-sm-8"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.setup.breakfastNotServed" ng-disabled="vm.setup.durationOption!=\'MEAL\'"></checkbox>&nbsp;&nbsp;We do not serve {{vm.setup.breakfastName}}.</div><div class="col-sm-4">From&nbsp;&nbsp; <strong>Beginning of day</strong>&nbsp;&nbsp; to&nbsp;&nbsp;<select ng-model="vm.setup.breakfastEnd" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimes" ng-disabled="vm.setup.breakfastNotServed || vm.setup.durationOption!=\'MEAL\'"></select></div><div class="col-sm-2">Duration<select ng-model="vm.setup.breakfastDuration" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimesForDuration" ng-disabled="vm.setup.breakfastNotServed || vm.setup.durationOption!=\'MEAL\'"></select></div></div><br><div class="row"><div class="col-lg-2 col-sm-4"><input placeholder="Lunch" type="text" ng-model="vm.setup.lunchName" size="12" maxlength="32" ng-disabled="vm.setup.durationOption!=\'MEAL\'"></div><div class="col-lg-3 col-sm-8"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.setup.lunchNotServed" ng-disabled="vm.setup.durationOption!=\'MEAL\'"></checkbox>&nbsp;&nbsp;We do not serve {{vm.setup.lunchName}}.</div><div class="col-sm-4">From&nbsp;&nbsp;<select ng-model="vm.setup.breakfastEnd" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimes" ng-disabled="vm.setup.lunchNotServed || vm.setup.durationOption!=\'MEAL\'"></select>&nbsp;&nbsp; to&nbsp;&nbsp;<select ng-model="vm.setup.lunchEnd" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimes" ng-disabled="vm.setup.lunchNotServed || vm.setup.durationOption!=\'MEAL\'"></select></div><div class="col-sm-2">Duration<select ng-model="vm.setup.lunchDuration" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimesForDuration" ng-disabled="vm.setup.lunchNotServed || vm.setup.durationOption!=\'MEAL\'"></select></div></div><br><div class="row"><div class="col-lg-2 col-sm-4"><input placeholder="Dinner" type="text" ng-model="vm.setup.dinnerName" size="12" maxlength="32" ng-disabled="vm.setup.durationOption!=\'MEAL\'"></div><div class="col-lg-3 col-sm-8"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.setup.dinnerNotServed" ng-disabled="vm.setup.durationOption!=\'MEAL\'"></checkbox>&nbsp;&nbsp;We do not serve {{vm.setup.dinnerName}}.</div><div class="col-sm-4">From&nbsp;&nbsp;<select ng-model="vm.setup.lunchEnd" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimes" ng-disabled="vm.setup.dinnerNotServed || vm.setup.durationOption!=\'MEAL\'"></select>&nbsp;&nbsp; to&nbsp;&nbsp; <strong>End of day</strong></div><div class="col-sm-2">Duration<select ng-model="vm.setup.dinnerDuration" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimesForDuration" ng-disabled="vm.setup.dinnerNotServed || vm.setup.durationOption!=\'MEAL\'"></select></div></div><br><br><input class="radio-primary" ng-model="vm.setup.durationOption" type="radio" name="duration" id="radio_duration_2" value="DURATION" checked=""><label for="radio_duration_2"><strong class="text-danger">Option 2:</strong> Let your guests to choose duration in hours and minutes when creating a reservation.</label><br><br>&nbsp;&nbsp;&nbsp;&nbsp;Minimum reservation duration is<select ng-model="vm.setup.minDuration" ng-required="true" ng-options="item.id as item.name for item in vm.minDurationList" ng-disabled="vm.setup.durationOption!=\'DURATION\'"></select>, maximum allowed duration of reservation is<select ng-model="vm.setup.maxDuration" ng-required="true" ng-options="item.id as item.name for item in vm.maxDurationList" ng-disabled="vm.setup.durationOption!=\'DURATION\'"></select><br>&nbsp;&nbsp;&nbsp;&nbsp;<strong>Example:</strong> if you select minimum 30min and maximum 2h, duration list would be 30min, 1hour, 1hour 30min, 2 hours<br><br><input class="radio-primary" ng-model="vm.setup.durationOption" type="radio" name="duration" id="radio_duration_3" value="PRODUCT" checked=""><label for="radio_duration_3"><strong class="text-danger">Option 3:</strong> Let your guest to choose product for which they want to make an reservation. Product define duration of event.</label><br><br><strong>Product list definition - Example 1:</strong><br>"3 course meal" - 2 hours<br>"5 course meal" - 3 hours<br>"House special" - 3 hours 30 minutes<br>etc.<br><strong>Example 2:</strong><br>"Standard wine tasting" - 1hours 30 minutes<br>"Wine tasting with cellar visit" - 3 hours<br>etc.<br><br><div class="form-group"><textarea rows="8" ng-model="vm.setup.product" placeholder="Please define duration / product target set up for your business." class="form-control" ng-maxlength="10000" ng-disabled="vm.setup.durationOption!=\'PRODUCT\'"></textarea></div></div></div></div><div class="row"><div class="col-lg-12"><hr class="col-lg-10"><div class="form-group col-lg-10"><h2 class="text-success font-bold">Online reservation settings</h2><br><h3>Please define settings for online reservation.</h3>Party size from minimum<select ng-model="vm.setup.minParty" ng-required="true" ng-options="item.id as item.name for item in vm.partySize"></select>to maximum<select ng-model="vm.setup.maxParty" ng-required="true" ng-options="item.id as item.name for item in vm.partySize"></select><br><br><strong>Table assignment policy</strong><br>SeatOn can automatically assign table to online reservation (please choose preffered algorithm for table assignemnt), or you can assign table manually.<br><br><select ng-model="vm.setup.automationPolicy" ng-required="true" ng-options="item.id as item.name for item in vm.automationStrategyList"></select><br><br><div class="row"><div class="col-md-5"><div class="radio"><input class="radio-primary" ng-model="vm.setup.reservationPage" type="radio" name="radio1" id="radio_legacy" value="LEGACY" checked=""><label for="radio_legacy"><strong>Basic online reservation page</strong><br><small>Simple look and field for simple and fast reservation.</small></label></div><br><a href="content/images/legacy_reservation_page.png" target="_blank"><img class="img-responsive col-md-12" src="content/images/legacy_reservation_page.png" alt="Click on image to enlarge."></a><br><br></div><div class="col-md-5"><div class="radio"><input class="radio-primary" ng-model="vm.setup.reservationPage" type="radio" name="radio1" id="radio_new" value="RESERVE" checked=""><label for="radio_new"><strong>Advance reservation page with seating options support</strong><br><small>New and modern look and feel with support for seating options.</small></label></div><br><a href="content/images/new_reservation_page.png" target="_blank"><img class="img-responsive col-md-12" src="content/images/new_reservation_page.png" alt="Click on image to enlarge."></a><br><h4>Please define seating options you want ot offer to your guests.</h4><strong>Example:</strong> - list of options with assigned areas from you floor plan<br>Inside - Areas(Main Room, Back Room, etc)<br>Outside - Areas(Front Patio, Back Patio, etc)<br>Igloo - Areas (garden Igloo)<br>Please note, you can define unlimited number of options with any name you like.<br><br><div class="form-group"><textarea rows="8" ng-model="vm.setup.seatingOption" placeholder="Please define seating options set up." class="form-control" ng-maxlength="10000" ng-disabled="vm.setup.reservationPage!=\'RESERVE\'"></textarea></div></div></div><br><br><strong>Integration with your web page, Facebook and Google pages</strong><br>Please share email contact of persons who manage your web page, Facebook or Google Business page.<br>We will contact this person and share details o how to integrate SeatOn to your web page, Facebook or Google Business page.<br><br><div class="form-group col-lg-8" ng-class="{ \'has-error\': setupForm.intContact.$invalid || setupForm.intContact.$error.email}"><input autofocus name="intContact" ng-model="vm.setup.integrationContact" class="form-control" placeholder="Email of web administrator or email of responsible for online channels" type="email" validate-email style="background-color: rgba(0,0,0,0)"></div></div></div></div><div class="row"><div class="col-lg-12"><hr class="col-lg-10"><div class="form-group col-lg-10"><h2 class="text-success font-bold">Other</h2><br><h3>Please share other requirements not covered by questionnaire.</h3>SeatOn has many different settings that can support your business needs. Share any additional requirements not covered by this questionnaire, there is good chance that we already support it or we can support it in short time.<br><br><div class="form-group"><textarea rows="5" ng-model="vm.setup.otherReq" placeholder="Please share any other requirements not covered by this questionnaire" class="form-control" ng-maxlength="10000"></textarea></div></div></div></div><div class="row text-center"><div class="col-lg-12"><hr class="col-lg-10"><br><br><br><h5 class="text-danger">Please note: All settings defined here can be later changed through SeatOn Web Dashboard.</h5><br><button class="btn-success" ng-click="vm.submitQ()">Submit questionnaire</button></div></div></form></div></div></div></div><div class="row"><div class="col-md-12"><br><br><br><br></div></div></div>');
$templateCache.put('app/reporting/employees/employees.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-12"><h3 class="font-bold no-margins">Employees performance</h3><small>Select period for performance calculation.</small><br><br></div></div><div class="row" ng-show="!employees.reportEmployeePerformance"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Employee performance report provides detail insight into your employees performance on weekly, monthly or annual basis.<br>You can even define custom period for performance analysis.<br>Report includes information about sales, tips and visits for each employee.<br><br><small>Follow this link to find more information about <a href="https://support.seaton.site/182749-Employees-performance" target="_blank">Employees performance report</a>.</small><br><br><button class="btn btn-danger" ng-click="employees.openWindow()" target="_blank">{{::employees.reportEmployeePerformanceText}}</button><br><br><small><span class="text-success">Below you can see an example of the Employee performance report.</span></small></div></div></div><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/ReportEmployeePerformance.png" class="img-responsive"></div></div></div></div></div></div><div class="row" ng-show="employees.reportEmployeePerformance"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="btn-group col-lg-8 col-md-12"><label ng-model="employees.selectedInterval" uib-btn-radio="\'last12Months\'" class="btn btn-primary btn-outline" ng-change="employees.changedSelectedInterval()" required><span>Last 12 months</span></label><label ng-model="employees.selectedInterval" uib-btn-radio="\'lastMonth\'" class="btn btn-primary btn-outline" ng-change="employees.changedSelectedInterval()" required><span>Last month</span></label><label ng-model="employees.selectedInterval" uib-btn-radio="\'lastWeek\'" class="btn btn-primary btn-outline" ng-change="employees.changedSelectedInterval()" required><span>Last week</span></label><label ng-model="employees.selectedInterval" uib-btn-radio="\'yesterday\'" class="btn btn-primary btn-outline" ng-change="employees.changedSelectedInterval()" required><span>Yesterday</span></label><label ng-model="employees.selectedInterval" uib-btn-radio="\'today\'" class="btn btn-primary btn-outline" ng-change="employees.changedSelectedInterval()" required><span>Today</span></label><label ng-model="employees.selectedInterval" uib-btn-radio="\'currentWeek\'" class="btn btn-primary btn-outline" ng-change="employees.changedSelectedInterval()" required><span>Current Week</span></label><label ng-model="employees.selectedInterval" uib-btn-radio="\'currentMonth\'" class="btn btn-primary btn-outline" ng-change="employees.changedSelectedInterval()" required><span>Current Month</span></label></div><div class="col-lg-4 col-md-12 pull-right"><div class="form-group"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="employees.openPicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="Or define custom period" type="text" class="form-control" name="pickerDates" style="background-color: #FFF"></div></div></div></div></div><div class="row"><div class="col-lg-12"><br><div google-chart chart="employees.chartObjectEmployees"></div></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-6 col-lg-offset-1"><span class="h4">Show inactive employees &nbsp;<toggle ng-model="employees.show.not.active" on="Yes" off="No" offstyle="btn-danger" style="ios"></toggle></span></div><div class="col-lg-4 pull-right"><select class="h4" data-ng-model="employees.order.field"><option value="amountSum">Sort by revenue</option><option value="amountAvgPerCover">Sort by average revenue per<stran stext="person" type="s"></stran></option><option value="tipSum">Sort by tips revenue</option><option value="tipAvg">Sort by average tips revenue</option><option value="tipAvgPct">Sort by average tips in percentage</option><option value="visitsCount">Sort by number of visits</option><option value="covers">Sort by number of<stran stext="person" type="p"></stran></option><option value="noShowPct">Sort by no show rate</option><option value="reservationRatio">Sort by reservation ratio</option></select>&nbsp;<style>.toggle.ios, .toggle-on.ios, .toggle-off.ios {\n                                            border-radius: 20px;\n                                        }\n                                        .toggle.ios .toggle-handle {\n                                            border-radius: 20px;\n                                        }</style><toggle ng-model="employees.order.reverse" on="<i class=\'fa fa-sort-amount-desc\'></i>" off="<i class=\'fa fa-sort-amount-asc\'></i>" onstyle="btn-primary" offstyle="btn-info" style="ios"></toggle></div><div class="col-lg-1"></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><table class="table table-hover"><thead><tr><th align="center"><span class="text-info">EMPLOYEE</span></th><th align="center"><i class="{{currencyIcon}} fa-2x text-navy"></i></th><th align="center"><span class="text-navy font-bold">TIPS</span></th><th align="center"><i class="fa fa-user fa-2x text-success"></i></th><th align="center"><span class="text-danger font-bold"><small>NO<br>SHOW</small></span></th><th align="center"><span class="text-navy font-bold"><small>RESERVATION<br>RATIO</small></span></th><th></th></tr></thead><tbody><tr ng-repeat="dayData in employees.employeesDetails.detailData | orderBy:employees.dynamicOrder:employees.order.reverse" ng-show="dayData.active || employees.show.not.active"><th><h3>{{ dayData.firstName ? dayData.firstName : \'\' }} {{ dayData.lastName ? dayData.lastName : \'\' }}</h3><small ng-show="dayData.active" class="text-navy">ACTIVE</small><small ng-show="!dayData.active" class="text-danger">NOT ACTIVE</small></th><td><h3>{{ dayData.amountSum | currency }}</h3>{{ dayData.amountTotalPct | percentage: 2 }}<br><small>Avg per visit {{ dayData.amountAvgPerVisit | currency }}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{ dayData.amountAvgPerCover | currency }} </small><small>&nbsp;<level value="dayData.calcAmountAvgPerCoverPct" display="right">{{ dayData.calcAmountAvgPerCoverPct | percentage:2 }}</level></small></td><td><h3>{{ dayData.tipSum | currency }}</h3>{{ dayData.tipsTotalPct | percentage: 2 }}<br><small>Avg per visit {{ dayData.tipAvg | currency }} ({{ dayData.tipAvgPct | percentage:2 }})</small> <small>&nbsp;<level value="dayData.calcTipAvgPct" display="right">{{ dayData.calcTipAvgPct | percentage:2 }}</level></small></td><td><h3>{{ dayData.visitsCount | number }} visit(s)</h3>{{ dayData.visitsTotalPct | percentage: 2 }}<br><small>Total<stran stext="person"></stran>{{ dayData.covers | number }}</small><br><small>Avg<stran stext="person"></stran>per visit {{ dayData.coversPerVisit | number: 2 }}</small></td><td><h3>{{ dayData.noShowPct | percentage: 2 }}</h3><small>Visit(s) {{ dayData.noShowVisits | number }}</small><br><small><stran stext="person" type="c"></stran>{{ dayData.noShowCovers | number }}</small><br><small class="text-danger">Loss {{ dayData.noShowCovers * dayData.amountAvgPerCover | currency }}</small></td><td><h3>{{ dayData.reservationRatio | percentage: 2 }}</h3></td><td><button class="btn btn-info btn-outline" type="button" ng-click="employees.viewEmployeeDetails(dayData.employeeId)">Details</button></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/reporting/aggregated/aggregated.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-6"><h3 class="font-bold no-margins">Aggregated revenue per arrival type</h3><small>Select aggregation by hours of day or day or week, time period and type of customers.</small></div></div><div class="row" ng-show="!aggregated.reportAggregatedRevenue"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="row">f<div class="col-lg-12"><div class="widget gray-bg text-center">Aggregated performance report enables you to explore performance for each day in a week or hour in a day.<br>Reveal day or hour where you perform best or worst and find space for improvement. Find when average sales (per<stran stext="person" type="s"></stran>/per visit) are lowest or highest.<br>This report will help you to create your marketing strategy.<br><br><small>Follow this link to find more information about <a href="https://support.seaton.site/940183-Aggregated-revenue" target="_blank">Aggregated performance report</a>.</small><br><br><button class="btn btn-danger" ng-click="aggregated.openWindow()" target="_blank">{{::aggregated.reportAggregatedRevenueText}}</button><br><br><small><span class="text-success">Below you can see an example of the Aggregated performance report.</span></small></div></div></div><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/ReportAggregatedRevenueDayInWeek.png" class="img-responsive"></div></div></div></div></div></div><div class="row" ng-show="aggregated.reportAggregatedRevenue"><div class="col-lg-12"><div class="row"><div class="col-lg-4"><div class="btn-group pull-left"><br><br><label ng-model="aggregated.aggrSpendType" uib-btn-radio="\'byhour\'" class="btn btn-danger btn-outline" ng-change="aggregated.reload()" required><span>Time of Day</span><br></label><label ng-model="aggregated.aggrSpendType" uib-btn-radio="\'byday\'" class="btn btn-danger btn-outline" ng-change="aggregated.reload()" required><span>Days of the Week</span><br></label></div></div><div class="col-lg-4"><div class="btn-group"><br><br><label ng-model="aggregated.aggrSpendInterval" uib-btn-radio="3" class="btn btn-primary btn-outline" ng-change="aggregated.reload()" required><span>Last 3 months</span><br></label><label ng-model="aggregated.aggrSpendInterval" uib-btn-radio="12" class="btn btn-primary btn-outline" ng-change="aggregated.reload()" required><span>Last 12 months</span><br></label></div></div><div class="col-lg-4"><div class="btn-group pull-right"><br><br><label ng-model="aggregated.aggrCustomerType" uib-btn-radio="\'all\'" class="btn btn-danger btn-outline" ng-change="aggregated.reload()" required><span>All customers</span><br></label><label ng-model="aggregated.aggrCustomerType" uib-btn-radio="\'only_regulars\'" class="btn btn-danger btn-outline" ng-change="aggregated.reload()" required><span>Only regulars</span><br></label><label ng-model="aggregated.aggrCustomerType" uib-btn-radio="\'only_non_regulars\'" class="btn btn-danger btn-outline" ng-change="aggregated.reload()" required><span>Only non-regulars</span><br></label>&nbsp;</div></div></div><span ng-show="aggregated.aggrSpendType==\'byhour\'"><div class="row"><div class="col-lg-12"><br><div google-chart chart="aggregated.chartObjectHours"></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><div ng-include-template="app/customer/profile/partials/aggrSpendByHour.html" ng-include-variables="{ isMeal: vm.isMeal, vm: aggregated, currencyIcon: currencyIcon, data: \'aggrByHourData\', avgSpendPerCover: \'NA\' }"></div></div></div></span><span ng-show="aggregated.aggrSpendType==\'byday\'"><div class="row"><div class="col-lg-12"><br><div google-chart chart="aggregated.chartObjectDays"></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><div ng-include-template="app/customer/profile/partials/aggrSpendByWeekday.html" ng-include-variables="{ vm: aggregated, currencyIcon: currencyIcon, data: \'aggrByWeekdayDetailData\', avgSpendPerCover: \'NA\', lossLabel: \'NA\' }"></div></div></div></span></div></div></div></div></div></div></div>');
$templateCache.put('app/reporting/occupancy/occupancy.html','<div class="wrapper wrapper-content"><div class="row" ng-show="openingHourNotDefined()"><div class="col-lg-12"><div class="widget yellow-bg text-center"><h4>WARNING: Business hours not defined. Occupancy rate calculation might be wrong. Please define business hours through Clover Setup and restart SeatOn app.</h4></div></div></div><div class="row"><div class="col-lg-9"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-8"><h3 class="font-bold no-margins">Occupancy report</h3><small>Select day in week for details.</small></div><div class="col-lg-4 pull-right"><div class="form-group"><div class="input-group"><input id="field_pickerDate" type="text" class="form-control" name="pickerDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="occupancy.openPicker(\'pickerDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row" ng-show="!occupancy.reportOccupancyRate"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Find out your occupancy rate on weekly basis and for each day in a selected week.<br>Explore how occupancy rate is connected to sales performance and averages per<stran stext="person" type="s"></stran>.<br>Additionaly, here you can find simulator which helps you to calculate your sales performance changing key parmeters, occupancy rate, average sale per<stran stext="person" type="s"></stran>and no show rate.<br><br><small>Follow this link to find more information about <a href="https://support.seaton.site/540061-Occupancy-report" target="_blank">Occupancy rate report</a>.</small><br><br><button class="btn btn-danger" ng-click="occupancy.openWindow()" target="_blank">{{::occupancy.reportOccupancyRateText}}</button><br><br><small><span class="text-success">Below you can see an example of the Occupancy rate report.</span></small></div></div></div><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/ReportOccupancyGraph.png" class="img-responsive"></div></div></div></div><div class="row" ng-show="occupancy.reportOccupancyRate"><div class="col-lg-9"><div class="dashboard-chart"><div google-chart chart="chartComboObjectOccupancyWeek" agc-on-select="occupancy.onChartSelect(selectedItem)"></div></div></div><div class="col-lg-3"><br><table class="table"><thead><tr><th colspan="2"><h3>Week: {{occupancy.selectedDate | amDateFormat: \'Do MMM YY\' }} - {{occupancy.endDate | amDateFormat: \'Do MMM YY\'}}</h3></th></tr></thead><tbody><tr><td class="text-right"><span class="text-warning font-bold"><small>OCCUPANCY<br>RATE</small></span></td><td><h3>{{occupancy.data.totalWeekOccupancy.occupancyPct | percentage:2 }}</h3><small># visit(s) {{occupancy.data.totalWeekOccupancy.totalVisits | number }}</small><br><small>#<stran stext="person"></stran>{{occupancy.data.totalWeekOccupancy.totalCovers | number }}</small></td></tr><tr><td><i class="{{currencyIcon}} fa-2x text-navy pull-right"></i></td><td><h3>{{occupancy.data.totalWeekOccupancy.revenue | currency }}</h3><small>Avg per<stran stext="person" type="s"></stran>{{occupancy.data.totalWeekOccupancy.avgRevenuePerCover | currency }}</small></td></tr><tr><td class="text-right"><span class="text-navy font-bold"><small>TIPS</small></span></td><td><h3>{{occupancy.data.totalWeekOccupancy.tips | currency }}</h3><small>Avg per visit {{occupancy.data.totalWeekOccupancy.avgTipPerVisit | currency }} ({{occupancy.data.totalWeekOccupancy.avgTipPct | percentage:2 }})</small></td></tr><tr><td class="text-right"><span class="text-danger font-bold"><small>NO<br>SHOW</small></span></td><td><h3>{{occupancy.data.totalWeekOccupancy.noShowPct | percentage:2 }}</h3><small># visit(s) {{occupancy.data.totalWeekOccupancy.noShowVisits | number }}</small><br><small>#<stran stext="person"></stran>{{occupancy.data.totalWeekOccupancy.noShowCovers | number }}</small><br><small class="text-danger">Loss {{occupancy.data.totalWeekOccupancy.noShowLoss | currency }}</small></td></tr></tbody></table></div></div><div class="row" ng-show="occupancy.reportOccupancyRate"><div class="col-lg-10 col-lg-offset-1"><table class="table"><thead><tr><th></th><th><h3 ng-if="occupancy.isMeal">Breakfast (Start of day - {{occupancy.data.mealTimes.breakfestEnd}})</h3><h3 ng-if="!occupancy.isMeal">Start of day - {{occupancy.data.mealTimes.breakfestEnd}}</h3></th><th><h3 ng-if="occupancy.isMeal">Lunch ({{occupancy.data.mealTimes.lunchStart}} - {{occupancy.data.mealTimes.lunchEnd}})</h3><h3 ng-if="!occupancy.isMeal">{{occupancy.data.mealTimes.lunchStart}} - {{occupancy.data.mealTimes.lunchEnd}}</h3></th><th><h3 ng-if="occupancy.isMeal">Dinner ({{occupancy.data.mealTimes.dinnerStart}} - End of day)</h3><h3 ng-if="!occupancy.isMeal">{{occupancy.data.mealTimes.dinnerStart}} - End of day</h3></th></tr></thead><tbody><tr><td class="text-right"><span class="text-warning font-bold"><small>OCCUPANCY<br>RATE</small></span></td><td><h3>{{occupancy.data.occupancyBreakfast.occupancyPct | percentage:2 }}</h3></td><td><h3>{{occupancy.data.occupancyLunch.occupancyPct | percentage:2 }}</h3></td><td><h3>{{occupancy.data.occupancyDinner.occupancyPct | percentage:2 }}</h3></td></tr><tr><td align="center"><i class="{{currencyIcon}} fa-2x text-navy"></i></td><td><h3>{{occupancy.data.occupancyBreakfast.revenue | currency }}</h3><small>Avg per<stran stext="person" type="s"></stran>{{occupancy.data.occupancyBreakfast.avgRevenuePerCover | currency }}</small><br><small>Avg tip per<stran stext="person" type="s"></stran>{{occupancy.data.occupancyBreakfast.avgTipPerCover | currency }}</small><br><small>Avg visit duration {{ occupancy.calculateAvgDuration (occupancy.data.occupancyBreakfast) }}</small></td><td><h3>{{occupancy.data.occupancyLunch.revenue | currency }}</h3><small>Avg per<stran stext="person" type="s"></stran>{{occupancy.data.occupancyLunch.avgRevenuePerCover | currency }}</small><br><small>Avg tip per<stran stext="person" type="s"></stran>{{occupancy.data.occupancyLunch.avgTipPerCover | currency }}</small><br><small>Avg visit duration {{ occupancy.calculateAvgDuration (occupancy.data.occupancyLunch) }}</small></td><td><h3>{{occupancy.data.occupancyDinner.revenue | currency }}</h3><small>Avg per<stran stext="person" type="s"></stran>{{occupancy.data.occupancyDinner.avgRevenuePerCover | currency }}</small><br><small>Avg tip per<stran stext="person" type="s"></stran>{{occupancy.data.occupancyDinner.avgTipPerCover | currency }}</small><br><small>Avg visit duration {{ occupancy.calculateAvgDuration (occupancy.data.occupancyDinner) }}</small></td></tr></tbody></table></div></div></div></div></div></div></div><div class="col-lg-3 grey-bg" ng-show="!occupancy.reportOccupancyRate"><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/ReportOccupancySimulation.png" class="img-responsive"></div></div></div><div class="col-lg-3 grey-bg" ng-show="occupancy.reportOccupancyRate"><div class="row"><div class="col-lg-12"><h4 class="text-navy"><i class="fa fa-calculator"></i> Simulation for selected week</h4><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h4>Define parameters</h4></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1">Occupancy rate<br><input id="slider_occupancy_week"><br>Average revenue per person<br><input id="slider_avgrevenuepercover_week"><br>No show rate<br><input id="slider_noshow_week"></div></div></div></div><div class="row"><br><button ng-click="occupancy.setSimulationToActuals(\'week\')" class="btn btn-default btn-outline col-lg-10 col-lg-offset-1" type="button">Set actuals</button>&nbsp;</div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><br><h4>Simulated results</h4></div></div><div class="row"><div class="col-lg-11 col-lg-offset-1"><div class="row"><div class="col-lg-4">Revenue:</div><div class="col-lg-8"><span class="font-bold">{{occupancy.week_calc.revenue | currency }}</span> <small><span class="font-bold text-navy pull-right"><level value="occupancy.week_calc.revenue-occupancy.data.totalWeekOccupancy.revenue" display="right">{{ occupancy.calcPct(occupancy.week_calc.revenue, occupancy.data.totalWeekOccupancy.revenue) | percentage:2 }}</level></span></small></div></div><div class="row"><div class="col-lg-4">Tips:</div><div class="col-lg-8"><span class="font-bold">{{occupancy.week_calc.tips | currency }}</span> <small><span class="font-bold text-navy pull-right"><level value="occupancy.week_calc.tips-occupancy.data.totalWeekOccupancy.tips" display="right">{{ occupancy.calcPct(occupancy.week_calc.tips, occupancy.data.totalWeekOccupancy.tips) | percentage:2 }}</level></span></small></div></div><div class="row"><div class="col-lg-4">Loss due no show: {{vm.isTableManaged}}</div><div class="col-lg-8"><span class="text-danger">{{occupancy.week_calc.noShowLoss | currency }}</span> <small><span class="font-bold text-navy pull-right"><level invert="true" value="occupancy.week_calc.noShowLoss-occupancy.data.totalWeekOccupancy.noShowLoss" display="right">{{ occupancy.calcPct(occupancy.week_calc.noShowLoss, occupancy.data.totalWeekOccupancy.noShowLoss) | percentage:2 }}</level></span></small></div></div></div></div></div></div></div></div><div class="row" ng-show="occupancy.reportOccupancyRate && occupancy.isTableManaged"><div class="col-lg-9"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-9"><h4 class="font-bold no-margins">Occupancy details for selected day</h4></div><div class="col-lg-3 pull-right"><h4 class="text-navy">{{occupancy.hourData.dayNameFormatted }}</h4></div></div><div class="row"><div class="col-lg-12"><div class="dashboard-chart"><div google-chart chart="chartComboObjectOccupancyDay"></div></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><table class="table"><thead><tr><th></th><th><span class="text-warning font-bold"><small>SEAT OCCUPANCY<br>RATE</small></span></th><th><span class="text-danger font-bold"><small>TABLE OCCUPANCY<br>RATE</small></span></th><th><i class="{{currencyIcon}} fa-2x text-navy"></i></th><th><span class="text-navy font-bold"><small>TIPS</small></span></th><th><span class="text-danger font-bold"><small>NO<br>SHOW</small></span></th></tr></thead><tbody><tr><td><span class="text-navy font-bold">{{occupancy.hourData.dayNameFormatted }}</span></td><td><h3>{{occupancy.hourData.totalDayOccupancy.occupancyPct | percentage:2 }}</h3><small># visit(s) {{occupancy.hourData.totalDayOccupancy.totalVisits | number }}</small><br><small>#<stran stext="person"></stran>{{occupancy.hourData.totalDayOccupancy.totalCovers | number }}</small></td><td><h3>{{occupancy.hourData.totalDayOccupancy.occupancyTablePct | percentage:2 }}</h3></td><td><h3>{{occupancy.hourData.totalDayOccupancy.revenue | currency }}</h3><small>Avg per<stran stext="person" type="s"></stran>{{occupancy.hourData.totalDayOccupancy.avgRevenuePerCover | currency }}</small></td><td><h3>{{occupancy.hourData.totalDayOccupancy.tips | currency }}</h3><small>Avg per visit {{occupancy.hourData.totalDayOccupancy.avgTipPerVisit | currency }} ({{occupancy.hourData.totalDayOccupancy.avgTipPct | percentage }})</small></td><td><h3>{{occupancy.hourData.totalDayOccupancy.noShowPct | percentage:2 }}</h3><small># visit(s) {{occupancy.hourData.totalDayOccupancy.noShowVisits | number }}</small><br><small>#<stran stext="person"></stran>{{occupancy.hourData.totalDayOccupancy.noShowCovers | number }}</small><br><small class="text-danger">Loss {{occupancy.hourData.totalDayOccupancy.noShowLoss | currency }}</small></td></tr></tbody></table></div></div></div></div></div></div></div><div class="col-lg-3 grey-bg"><div class="row"><div class="col-lg-12"><h4 class="text-navy"><i class="fa fa-calculator"></i> Simulation for selected day</h4><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h4>Define parameters</h4></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1">Occupancy rate<br><input id="slider_occupancy_day"><br>Average revenue per cover<br><input id="slider_avgrevenuepercover_day"><br>No show rate<br><input id="slider_noshow_day"></div></div></div></div><div class="row"><br><button ng-click="occupancy.setSimulationToActuals(\'day\')" class="btn btn-default btn-outline col-lg-10 col-lg-offset-1" type="button">Set actuals</button>&nbsp;</div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><br><h4>Simulated results</h4></div></div><div class="row"><div class="col-lg-11 col-lg-offset-1"><div class="row"><div class="col-lg-4">Revenue:</div><div class="col-lg-8"><span class="font-bold">{{occupancy.day_calc.revenue | currency }}</span> <small><span class="font-bold text-navy pull-right"><level value="occupancy.day_calc.revenue-occupancy.hourData.totalDayOccupancy.revenue" display="right">{{ occupancy.calcPct(occupancy.day_calc.revenue, occupancy.hourData.totalDayOccupancy.revenue) | percentage:2 }}</level></span></small></div></div><div class="row"><div class="col-lg-4">Tips:</div><div class="col-lg-8"><span class="font-bold">{{occupancy.day_calc.tips | currency }}</span> <small><span class="font-bold text-navy pull-right"><level value="occupancy.day_calc.tips-occupancy.hourData.totalDayOccupancy.tips" display="right">{{ occupancy.calcPct(occupancy.day_calc.tips, occupancy.hourData.totalDayOccupancy.tips) | percentage:2 }}</level></span></small></div></div><div class="row"><div class="col-lg-4">Loss due no show:</div><div class="col-lg-8"><span class="text-danger">{{occupancy.day_calc.noShowLoss | currency }}</span> <small><span class="font-bold text-navy pull-right"><level invert="true" value="occupancy.day_calc.noShowLoss-occupancy.hourData.totalDayOccupancy.noShowLoss" display="right">{{ occupancy.calcPct(occupancy.day_calc.noShowLoss, occupancy.hourData.totalDayOccupancy.noShowLoss) | percentage:2 }}</level></span></small></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/reporting/performance/performance.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-6"><h3 class="font-bold no-margins">Last 30 days performance</h3><small>Select day for details.</small></div><div class="col-lg-6"><div class="btn-group pull-right"><label ng-model="performance.customerFilter" uib-btn-radio="\'all\'" class="btn btn-primary btn-outline" ng-change="performance.reload()" required><span>All customers</span><br></label><label ng-model="performance.customerFilter" uib-btn-radio="\'only_regulars\'" class="btn btn-primary btn-outline" ng-change="performance.reload()" required><span>Only regulars</span><br></label><label ng-model="performance.customerFilter" uib-btn-radio="\'only_non_regulars\'" class="btn btn-primary btn-outline" ng-change="performance.reload()" required><span>Only non-regulars</span><br></label></div></div></div><div class="row"><div class="col-md-12"><div class="dashboard-chart"><div google-chart chart="chartObjectTrend" agc-on-select="performance.onChartSelect(selectedItem)"></div></div></div></div><div class="row"><div class="col-md-10 col-lg-offset-1"><br><div ng-include-template="app/reporting/performance/partials/PerformanceEventsStatsTotal.html" ng-include-variables="{vm: performance, currencyIcon: currencyIcon, data: \'total\', title: \'Totals\' }"></div></div><div class="col-md-1"></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-12"><h4 class="font-bold no-margins">Statistics details for <span class="text-danger">{{ performance.revenueDayDetailsData.name }}</span></h4></div></div><div class="row"><div class="col-lg-5"><span ng-if="chartObjectVisitGeneral"><include-pie-chart piechartdata="chartObjectVisitGeneral"></span></div><div class="col-lg-7"><br><div ng-include-template="app/customer/profile/partials/spendTrendByMonth.html" ng-include-variables="{ vm: performance, currencyIcon: currencyIcon, data: \'visitTypeData\', avgSpendPerCover: \'NA\', param1:\'templateParam1\', param2:\'templateParam2\', param3:\'templateParam3\', param4:\'templateParam4\' }"></div></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-5"><span ng-if="chartObjectMealGeneral"><include-pie-chart piechartdata="chartObjectMealGeneral"></span></div><div class="col-lg-7"><br><div ng-include-template="app/customer/profile/partials/aggrSpendByHour.html" ng-include-variables="{  isMeal: vm.isMeal, vm: performance, currencyIcon: currencyIcon, data: \'mealData\', avgSpendPerCover: \'NA\' }"></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/reporting/revenuetrend/revenuetrend.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-6"><h3 class="font-bold no-margins">Last 12 months revenue statistics</h3><small>Select month for details.</small></div><div class="col-lg-6"><div class="btn-group pull-right"><label ng-model="revenuetrend.customerFilter" uib-btn-radio="\'all\'" class="btn btn-primary btn-outline" ng-change="revenuetrend.reload()" required><span>All customers</span><br></label><label ng-model="revenuetrend.customerFilter" uib-btn-radio="\'only_regulars\'" class="btn btn-primary btn-outline" ng-change="revenuetrend.reload()" required><span>Only regulars</span><br></label><label ng-model="revenuetrend.customerFilter" uib-btn-radio="\'only_non_regulars\'" class="btn btn-primary btn-outline" ng-change="revenuetrend.reload()" required><span>Only non-regulars</span><br></label></div></div></div><div class="row"><div class="col-md-9"><div class="dashboard-chart"><div google-chart chart="chartObjectTrend" agc-on-select="revenuetrend.onChartSelect(selectedItem)"></div></div></div><div class="col-md-2"><br><div ng-include-template="app/reporting/revenuetrend/partials/SpendTrendEventsStatsTotal.html" ng-include-variables="{vm: revenuetrend, currencyIcon: currencyIcon, data: \'total\', title: \'Totals\' }"></div></div><div class="col-md-1"></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-12"><h4 class="font-bold no-margins">Statistics details for <span class="text-danger">{{ revenuetrend.revenueMonthDetailsData.name }}</span></h4></div></div><div class="row"><div class="col-lg-5"><span ng-if="chartObjectVisitGeneral"><include-pie-chart piechartdata="chartObjectVisitGeneral"></span></div><div class="col-lg-7"><br><div ng-include-template="app/customer/profile/partials/spendTrendByMonth.html" ng-include-variables="{ vm: revenuetrend, currencyIcon: currencyIcon, data: \'visitTypeData\', avgSpendPerCover: \'NA\', param1:\'templateParam1\', param2:\'templateParam2\', param3:\'templateParam3\', param4:\'templateParam4\' }"></div></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-5"><span ng-if="chartObjectMealGeneral"><include-pie-chart piechartdata="chartObjectMealGeneral"></span></div><div class="col-lg-7"><br><div ng-include-template="app/customer/profile/partials/aggrSpendByHour.html" ng-include-variables="{ vm: revenuetrend, currencyIcon: currencyIcon, data: \'mealData\', avgSpendPerCover: \'NA\' }"></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/settings/application/application.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12 col-md-10"><div class="row"><div class="col-lg-3 col-md-12"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-lg-12"><div class="widget"><div class="row"><div class="col-lg-12 text-center"><p></p><h1>Penelope Restaurant</h1><p></p><p class="ng-binding"><small>Using app since <span class="font-bold">October 18, 2015</span></small></p></div></div></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><table><tr><td class="font-bold text-right" valign="top">Status:&nbsp;&nbsp;</td><td><span class="label label-primary">Active</span></td></tr></table></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 font-bold"><br>Address:&nbsp;&nbsp;</div></div><div class="row"><div class="col-lg-10 col-lg-offset-2">23rd Street, New York, New York 1000, US</div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 font-bold"><br>Contact:&nbsp;&nbsp;</div></div><div class="row"><div class="col-lg-10 col-lg-offset-2">Phone: +1 435 675 435<br>E-Mail: <a href="mailto:company@gmail.com" class="text-navy">company@gmail.com</a><br>Web: <a href="www.company.com" class="text-navy" target="_blank">www.company.com</a></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 font-bold"><br>Note:&nbsp;&nbsp;</div></div><div class="row"><div class="col-lg-10 col-lg-offset-2"><p>Some note about location/company</p></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 font-bold text-danger"><br>Last update of application settings:&nbsp;&nbsp;</div></div><div class="row"><div class="col-lg-10 col-lg-offset-2">Date: 12th Oct 2015 @ 12:32pm<br>By: Admin</div></div></div></div></div><div class="col-lg-9 col-md-12"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">System settings</h2>Fine tune system parameters to fit your needs.</div><div class="panel-body"><div class="row"><div class="col-lg-offset-9 col-lg-3"><button aria-pressed="false" data-toggle="button" class="btn btn-primary" type="button">Save application settings</button></div></div><div class="row"><div class="col-lg-12"><uib-tabset><uib-tab><uib-tab-heading class="bold text-navy"><span class="fa fa-gears"></span> General</uib-tab-heading><div class="row"><div class="col-lg-12"><div ui-view="general"></div></div></div></uib-tab><uib-tab><uib-tab-heading class="bold text-navy"><span class="fa fa-table"></span> Floor</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="text-navy">Floor setup</h4><small>Please define area(s) and table(s) of your restaurant.</small><br><br><br></div></div><div class="row"><div class="col-lg-12"><div ui-view="tables"></div></div></div><div class="row"><br><div class="col-lg-12"><small><span class="font-bold">Please note:</span> Only area(s) and table(s) defined here will be subject to table management system.</small></div></div></uib-tab><uib-tab><uib-tab-heading class="bold text-navy"><span class="fa fa-envelope"></span> Notification</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="text-navy">Notification message customization</h4><small>Customize notification messages to better reflect your style of communication with your customers.</small></div></div><div class="row"><div class="col-lg-12"><br><div ui-view="notifications"></div></div></div></uib-tab><uib-tab><uib-tab-heading class="bold text-navy"><span class="fa fa-users"></span> Membership</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="text-navy">Membership customization</h4><small>Customize membership parameters to meet your requirements..</small></div></div><div class="row"><div class="col-lg-12"><br><div ui-view="members"></div></div></div></uib-tab><uib-tab><uib-tab-heading class="bold text-navy"><span class="fa fa-cutlery"></span> Meals</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="text-navy">Meal type setup</h4><small>Please define duration and start-end time of day for each meal type</small></div></div><br><div class="row"><div class="col-lg-12"><div class="dashboard-chart"><div google-chart chart="chartObjectHours"></div></div></div></div><div class="row"><div class="col-lg-12"><br><table class="table table-hover"><thead><tr><th></th><th><h4>Start</h4></th><th><h4>End</h4></th><th><h4>Average duration</h4></th></tr></thead><tbody><tr><td class="text-right"><span class="text-navy font-bold">BREAKFAST</span></td><td>7:00pm</td><td><select><option>1am</option><option>2am</option><option>3am</option><option>4am</option><option>5am</option><option>6am</option><option>7am</option><option>8am</option><option>9am</option><option>10am</option><option selected="selected">11am</option><option>12pm</option><option>1pm</option><option>2pm</option><option>3pm</option><option>4pm</option><option>5pm</option><option>6pm</option><option>7pm</option><option>8pm</option><option>9pm</option><option>10pm</option><option>11\u0161m</option><option>12pm</option></select></td><td><select><option>0:15h</option><option>0:30h</option><option selected="selected">0:45h</option><option>1:00h</option><option>1:15h</option><option>1:30h</option><option>1:45h</option><option>2:00</option><option>2:15h</option><option>2:30h</option><option>2:45h</option><option>3:00h</option><option>3:30h</option><option>4:00h</option><option>5:00h</option></select><br><small>Average duration in last 30 days <span class="text-danger">0:32h</span></small></td></tr><tr><td class="text-right"><span class="font-bold text-success">LUNCH</span></td><td>11:00pm</td><td><select><option>1am</option><option>2am</option><option>3am</option><option>4am</option><option>5am</option><option>6am</option><option>7am</option><option>8am</option><option>9am</option><option>10am</option><option>11am</option><option>12pm</option><option>1pm</option><option>2pm</option><option>3pm</option><option>4pm</option><option>5pm</option><option selected="selected">6pm</option><option>7pm</option><option>8pm</option><option>9pm</option><option>10pm</option><option>11\u0161m</option><option>12pm</option></select></td><td><select><option>0:15h</option><option>0:30h</option><option>0:45h</option><option>1:00h</option><option>1:15h</option><option>1:30h</option><option selected="selected">1:45h</option><option>2:00</option><option>2:15h</option><option>2:30h</option><option>2:45h</option><option>3:00h</option><option>3:30h</option><option>4:00h</option><option>5:00h</option></select><br><small>Average duration in last 30 days <span class="text-danger">1:32h</span></small></td></tr><tr><td class="text-right"><span class="text-danger font-bold">DINNER</span></td><td>6:00pm</td><td>11:00pm</td><td><select><option>0:15h</option><option>0:30h</option><option>0:45h</option><option>1:00h</option><option>1:15h</option><option>1:30h</option><option selected="selected">1:45h</option><option>2:00</option><option>2:15h</option><option>2:30h</option><option>2:45h</option><option>3:00h</option><option>3:30h</option><option>4:00h</option><option>5:00h</option></select><br><small>Average duration in last 30 days <span class="text-danger">1:32h</span></small></td></tr></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading class="bold text-navy"><span class="fa fa-users"></span> Widget</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="text-navy">Online reservation widget</h4><small>Customize online widget reservation component and place it on your web site.</small></div></div><div class="row"><div class="col-lg-12"><div ui-view="widget"></div></div></div></uib-tab></uib-tabset></div></div></div></div><div class="panel white-panel"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><br><h4 class="text-navy">Meal type setup</h4><small>Please define duration and start-end time of day for each meal type</small></div></div><br><div class="row"><div class="col-lg-10 col-lg-offset-1"><div id="slider_meals"></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><table class="table table-hover"><thead><tr><th></th><th><h4>Start</h4></th><th><h4>End</h4></th><th><h4>Average duration</h4></th></tr></thead><tbody><tr><td class="text-right"><span class="text-navy font-bold">BREAKFAST</span></td><td>7:00pm</td><td>11:00pm</td><td><div id="slider_duration_breakfast"></div><small>Average duration in last 30 days <span class="text-danger">0:32h</span></small></td></tr><tr><td class="text-right"><span class="font-bold text-success">LUNCH</span></td><td>11:00pm</td><td>18:00pm</td><td><div id="slider_duration_lunch"></div><small>Average duration in last 30 days <span class="text-danger">1:32h</span></small></td></tr><tr><td class="text-right"><span class="text-danger font-bold">DINNER</span></td><td>6:00pm</td><td>11:00pm</td><td><div id="slider_duration_dinner"></div><small>Average duration in last 30 days <span class="text-danger">1:32h</span></small></td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div><div class="row"><div class="col-md-12"><div ui-view="locations"></div></div><div class="col-md-12"><div ui-view="employees"></div></div></div></div>');
$templateCache.put('app/settings/alerts/alerts.html','<div class="wrapper wrapper-content"><div class="row"><form name="alertForm"><div class="col-lg-12"><div class="row" ng-if="vm.isFree"><div class="col-md-12 col-xs-12"><div class="panel white-panel"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Don\'t miss any event change in the application.<br>Activate alert you want to receive on your email to keep you informed about changes happened in system.<br><br><br><button class="btn btn-danger" ng-click="vm.openWindow()" target="_blank">Upgrade to PAY AS YOU GO, STANDARD or PROFESSIONAL subscription to activate this functionality.</button><br><br><br></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center"><img src="/content/images/profile/alerts.png" class="img-responsive"></div></div></div></div></div></div></div><div class="row" ng-show="!vm.isFree"><div class="col-lg-12 col-md-12"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Alerts</h2>Receive information triggered by event changes in SeatOn system.<br><span class="pull-right"><button ng-disabled="alertForm.alertEmail.$invalid" aria-pressed="false" data-toggle="button" class="btn btn-primary" type="button" ng-click="saveData()">Save alerts settings</button></span></div><div class="panel-body"><div class="row"><div class="col-lg-4"><div class="input-group m-b" ng-class="{ \'has-error\': alertForm.alertEmail.$invalid }"><label class="input-group-addon" for="alertEmail">@</label><input id="alertEmail" name="alertEmail" ng-model="vm.data.alertEmail" class="form-control" placeholder="Enter email address where alerts will be sent" type="email" validate-email required></div><small ng-if="alertForm.alertEmail.$invalid" class="text-danger">Please specify email address where alerts will be sent. Only one email allowed.</small></div></div></div></div></div></div><div class="row" ng-if="!vm.isFree"><div class="col-md-6 col-xs-12"><div class="panel white-panel"><div class="panel-heading"><h4 class="text-navy">Reservation Alerts</h4><small>Check to receive reservation alerts.</small></div><div class="panel-body"><div class="row"><div class="col-lg-10 col-lg-offset-1" style="background-color: #EEEEEE"><div class="row"><div class="col-lg-12"><br><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.data.onReservationCreatedAnyChannel"></checkbox>&nbsp;&nbsp;send an alert when a new reservation is created through any channel</div></div><div class="row"><div class="col-lg-12"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.data.onReservationCreatedByGuests"></checkbox>&nbsp;&nbsp;send an alert when a new reservation is created by guests (Online or IVR channel)</div></div><div class="row"><div class="col-lg-12"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.data.onReservationCreatedByGuestAndTableNotAssigned"></checkbox>&nbsp;&nbsp;send an alert when a new online reservation is created by guests and a<stran stext="resource"></stran>&nbsp; is not assigned</div></div><div class="row"><div class="col-lg-12"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.data.onReservationCancelledByStaff"></checkbox>&nbsp;&nbsp;send an alert when a reservation is canceled (by a guest or staff)</div></div><div class="row"><div class="col-lg-12"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.data.onReservationCancelledByGuest"></checkbox>&nbsp;&nbsp;send an alert when a reservation is canceled by a guest<br><br></div></div></div></div></div></div></div><div class="col-md-6 col-xs-12"><div class="panel white-panel"><div class="panel-heading"><h4 class="text-navy">Waitlist Alerts</h4><small>Check to receive waitlist alerts.</small></div><div class="panel-body"><div class="row"><div class="col-lg-10 col-lg-offset-1" style="background-color: #EEEEEE"><div class="row"><div class="col-lg-12"><br><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.data.onWaitlistCreatedAnyChannel"></checkbox>&nbsp;&nbsp;send an alert when a new entry added to a waitlist through any channel</div></div><div class="row"><div class="col-lg-12"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.data.onWaitlistCreatedByGuest"></checkbox>&nbsp;&nbsp;send and alert when a new entry added to a waitlist by a guest (online waitlist channel)</div></div><div class="row"><div class="col-lg-12"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.data.onWaitlistNotificationTableAvailable"></checkbox>&nbsp;&nbsp;send and alert when a quest is notified that a<stran stext="resource" type="s"></stran>is available</div></div><div class="row"><div class="col-lg-12"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.data.onWaitlistArrivalConfirmedByGuest"></checkbox>&nbsp;&nbsp;send an alert when arrival is confirmed by a guest</div></div><div class="row"><div class="col-lg-12"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.data.onWaitlistCancelledByGuest"></checkbox>&nbsp;&nbsp;send an alert when arrival is canceled by a guest<br><br></div></div></div></div></div></div></div><div class="col-md-6 col-xs-12"><div class="panel white-panel"><div class="panel-heading"><h4 class="text-navy">Feedback Alerts</h4><small>Check to receive feedback alerts.</small></div><div class="panel-body"><div class="row"><div class="col-lg-10 col-lg-offset-1" style="background-color: #EEEEEE"><div class="row"><div class="col-lg-12"><br><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.data.onFeedbackReceived"></checkbox>&nbsp;&nbsp;send an alert when a feedback is received from guest<br><br></div></div></div></div></div></div></div></div></div></form></div></div>');
$templateCache.put('app/settings/employees/employee-details.html','<div class="row wrapper wrapper-content ng-scope"><div class="col-lg-3"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row text-center"><div class="col-lg-12"><div class="widget style1"><div class="row"><div class="col-lg-12"><h2>{{employeeCtrl.employee.firstName}} {{employeeCtrl.employee.lastName}}</h2><br><p class="">Employed since: {{employeeCtrl.employee.createdDate | date : yyyy-MM-dd }} (<span am-time-ago="employeeCtrl.employee.createdDate"></span>)</p></div></div></div></div></div><div class="row"><div class="col-lg-12"><p align="center"><span><span class="font-bold">Rated: </span><span uib-rating style="font-size: 1.2em" ng-model="employeeCtrl.employee.rating" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="text-warning"><span>({{employeeCtrl.employee.rating | number: 2 }})</span></span></p></div></div><hr><div class="row"><div class="col-lg-10 col-lg-offset-1"><table><tbody><tr><td class="font-bold text-right" valign="top">Nickname:&nbsp;&nbsp;</td><td>{{employeeCtrl.employee.login}}</td></tr><tr><td class="font-bold text-right" valign="top">Role:&nbsp;&nbsp;</td><td><span class="label label-success">{{employeeCtrl.employee.role}}</span></td></tr></tbody></table></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 font-bold"><br>Contacts:&nbsp;&nbsp;</div></div><div class="row"><div class="col-lg-10 col-lg-offset-2"><i class="fa fa-phone"></i> {{employeeCtrl.employee.phone}}<br><i class="fa fa-envelope"></i><a class="text-navy" href="mailto:{{employeeCtrl.employee.email}}"> {{employeeCtrl.employee.email}}</a><br></div></div><hr><div class="row"><div class="col-lg-12"><table><tbody><style>.toggle.ios, .toggle-on.ios, .toggle-off.ios {\n                                    border-radius: 17px;\n                                }\n                                .toggle.ios .toggle-handle {\n                                    border-radius: 17px;\n                                }</style><tr valign="center"><td class="font-bold text-right"><label>Can create reservation: &nbsp;</label></td><td><toggle size="btn-sm" ng-model="employeeCtrl.employee.canReserve" on="Yes" off="No" offstyle="btn-danger" style="ios" ng-change="employeeCtrl.updateAttribute(\'canReserve\')"></toggle></td></tr><tr><td class="font-bold text-right"><label>Can add to waitlist: &nbsp;</label></td><td><toggle size="btn-sm" ng-model="employeeCtrl.employee.canWaitlist" on="Yes" off="No" offstyle="btn-danger" style="ios" ng-change="employeeCtrl.updateAttribute(\'canWaitlist\')"></toggle></td></tr><tr><td class="font-bold text-right"><label>Is active: &nbsp;</label></td><td><toggle size="btn-sm" ng-model="employeeCtrl.employee.active" on="Yes" off="No" offstyle="btn-danger" style="ios" ng-change="employeeCtrl.updateAttribute(\'active\')"></toggle></td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-lg-12"><div ng-if="employeeCtrl.employee.login"><div feedbacks-widget list-scope="employee" scope-id="employeeCtrl.employee.cloverId" title="Customer feedback" size="5"></div><button style="width: 100%" class="btn btn-primary btn-block m-t" ui-sref="customers.feedback({employeeLogin: employeeCtrl.employee.cloverId, employeeName: employeeCtrl.employee.name, employees:employeeCtrl.employees })"><i class="fa fa-arrow-down"></i> Show More</button></div></div></div></div><div class="col-lg-9 col-md-12"><div ng-include="\'app/settings/employees/partials/general.employee.stats.html\'"></div><div class="row"><div class="col-lg-12"><div class="ibox-content"><div class="row"><div class="col-lg-12"><div class="panel white-panel"><div class="panel-body"><uib-tabset><uib-tab select="employeeCtrl.tabChange(\'visitStatisticTab\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-pie-chart"></span> Visit statistics</uib-tab-heading><div ng-include="\'app/settings/employees/partials/visit_statisitic_tab.html\'"></div></uib-tab><uib-tab select="employeeCtrl.tabChange(\'weeklyPerformanceTab\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-line-chart"></span> Weekly Performance</uib-tab-heading><div ng-include="\'app/settings/employees/partials/weekly_performance_tab.html\'"></div></uib-tab><uib-tab select="employeeCtrl.tabChange(\'monthlyPerformanceTab\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-line-chart"></span> Monthly Performance</uib-tab-heading><div ng-include="\'app/settings/employees/partials/monthly_performance_tab.html\'"></div></uib-tab></uib-tabset></div></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div ng-include="\'app/settings/employees/partials/employee.history.html\'"></div></div></div></div></div>');
$templateCache.put('app/settings/employees/employees-box.html','<div class="row" class="hide" id="blockView" ng-if="employeesCtrl.loaded"><div ng-repeat="employee in employeesCtrl.employees | filterBy: [\'role\', \'location.name\', \'firstName\', \'lastName\', \'firstname + lastName\', \'login\', \'email\']: employeesCtrl.search"><div class="col-lg-4 col-md-6 col-xs-12"><div class="contact-box"><div class="row vertical-align"><div class="col-sm-3"><div class="row"><i class="fa fa-lg fa-file-image-o fa-5x"></i></div></div><div class="col-sm-9"><h3 class="text-navy"><a ng-click="view(employee.id)"><strong>{{employee.firstName}} {{employee.lastName}}</strong></a></h3><br><span class="badge badge-outline" style="padding: 5px">{{employee.authorities[0].name}}</span><br><br><p><span><span class="font-bold">Rated: </span><span uib-rating style="font-size: 1.2em" ng-model="employee.rating" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="rating-stars"><span>({{employee.rating | number: 2 }})</span></span></p><p><strong>Contacts:</strong></p><email><i class="fa fa-envelope m-r-xs"></i> <a class="text-navy" href="mailto:{{employee.email}}">{{employee.email}}</a></email><br><abbr title="Phone"></abbr> <i class="fa fa-phone m-r-xs"></i> {{employee.phone}}<br><br></div></div><div class="row"><span class="pull-right"><a type="submit" ui-sref="settings.employees.view({id: employee.id})" class="btn btn-primary btn-xs btn-outline">DETAILS</a></span></div></div></div></div></div>');
$templateCache.put('app/settings/employees/employees-list.html','<div class="row" id="listView" ng-if="employeesCtrl.loaded"><div class="col-lg-12"><div ng-form="queryForm" class="form-horizontal" on-navigate-away-strategy="none" novalidate><div class="form-group"><div class="col-sm-4 pull-right"><select id="selectQuery" class="form-control" ng-model="employeesCtrl.selectedQuery" ng-options="query.desc for query in employeesCtrl.queries track by query.name" ng-change="employeesCtrl.reload()"></select></div></div></div></div><div class="col-lg-12"><table class="table table-hover" ng-table="employeesCtrl.tableParams"><thead><tr><th><span class="text-success"><i class="fa fa-user"></i> EMPLOYEE NAME</span></th><th><span class="text-success">ROLE</span></th><th><span class="text-success">CONTACT(S)</span></th><th><span class="text-warning"><i class="fa fa-star"></i> RATED</span></th><th><span class="text-navy"><i class="{{currencyIcon}}"></i> AVG REVENUE PER<stran stext="person" type="SC"></stran></span></th><th><span class="text-navy"><i class="{{currencyIcon}}"></i> AVG TIP PER<stran stext="person" type="SC"></stran></span></th><th><span class="text-danger">NO SHOW RATE</span></th><th><span class="text-danger">ACTIVE</span></th><th></th></tr></thead><tbody><tr ng-repeat="employee in $data | filterBy: [\'role\', \'location.name\', \'firstName\', \'lastName\', \'name\', \'login\', \'email\']: employeesCtrl.search"><td><a ng-click="employeesCtrl.view(employee.id)"><strong>{{employee.name}}</strong></a></td><td><span class="badge badge-outline" style="padding: 5px">{{employee.role}}</span></td><td><email><i class="fa fa-envelope m-r-xs"></i> <a class="text-navy" href="mailto:{{employee.email}}">{{employee.email}}</a></email><br><abbr title="Phone"></abbr> <i class="fa fa-phone m-r-xs"></i> {{employee.phone}}</td><td><span uib-rating style="font-size: 1.2em" ng-model="employee.rating" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="text-warning"><span>({{employee.rating | number: 2 }})</span></td><td><span>{{employee.avgRevenuePerCover | currency }}</span></td><td>{{employee.avgTipPerCover | currency }} ({{employee.avgTipPercentage | number: 2}}%)</td><td>{{employee.noShowRate | percentage : 2}} ({{employee.totalNoShows | number}})</td><td>{{employee.active ? \'YES\': \'NO\'}}</td><td><a type="submit" ui-sref="settings.employees.view({id: employee.id})" class="btn btn-primary btn-xs btn-outline">DETAILS</a></td></tr></tbody></table></div></div>');
$templateCache.put('app/settings/employees/employees.html','<div class="wrapper wrapper-content"><div class="ibox"><div class="ibox-title"><h3>Employees list</h3><small>List of all employees in the system. Select employee for more details.</small></div><div class="ibox-content"><div class="row"><br><div class="col-md-8"><input ng-model="employeesCtrl.search" placeholder="Filter employees list by name, role, email, phone ..." class="form-control search-query" style="margin-bottom: 20px"></div><div class="col-md-4"><span class="pull-right"><button id="blockButton" type="button" ng-click="employeesCtrl.view_mode=\'box\'" ng-class="{active: employeesCtrl.view_mode===\'box\'}" class="btn btn-outline btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" data-original-title="Box view"><i class="fa fa-th fa-2x"></i></button> <button id="listButton" type="button" ng-click="employeesCtrl.view_mode=\'list\'" ng-class="{active: employeesCtrl.view_mode===\'list\'}" class="btn btn-outline btn-primary btn-sm" data-toggle="tooltip" data-placement="bottom" data-original-title="List view"><i class="fa fa-th-list fa-2x"></i></button></span></div></div><br><div ng-if="employeesCtrl.view_mode ==\'list\'" ng-include="\'app/settings/employees/employees-list.html\'"></div><div ng-if="employeesCtrl.view_mode ==\'box\'" ng-include="\'app/settings/employees/employees-box.html\'"></div></div></div></div>');
$templateCache.put('app/settings/floor/floor.html','<div class="wrapper wrapper-content" ng-intro-options="IntroOptionsFloor" ng-intro-method="CallMeFloor" ng-intro-autostart="showIntroFloor"><div class="row"><div class="col-lg-12 col-md-10"><div class="panel white-panel"><div class="panel-heading"><h2 ng-if="vm.isTableManaged" class="text-navy">Floor definition</h2><h2 ng-if="!vm.isTableManaged" class="text-navy">Define your business resources</h2><span ng-if="vm.isTableManaged" class="text-navy">Define areas and tables on your premises.<br><span class="text-warning">Please note: At the moment, it is not possible to copy floor definition from Clover Dining application due to lack of API on Clover Dining side for 3rd party applications.</span> </span><span ng-if="!vm.isTableManaged" class="text-navy">Define categories and resources. Resources can be employees or anything else related to your business.</span> <button id="floor" aria-pressed="false" style="float: right" data-toggle="button" class="btn btn-primary" type="button" ng-click="showPopupAddNewArea()">Add<stran stext="category" type="s"></stran></button></div><div class="panel-body" style="margin-top: 15px"><div class="row"><div class="col-sm-12"><uib-tabset><uib-tab ng-repeat="floor in data track by floor.name"><uib-tab-heading class="text-center"><div style="margin-left: auto; margin-right: auto"><i class="fa fa-edit text-navy" ng-click="showPopupEditArea($index)"></i> <i class="fa fa-remove text-navy" ng-click="showPopupDeleteArea($index)"></i></div><div class="col-lg-12">{{floor.name}}</div><div class="profile-stars"><span><div ng-show="floor.vip">VIP</div><div ng-show="!floor.vip">&nbsp</div></span></div></uib-tab-heading><div class="row"><br><br><div style="width: 75%; float:left"><div class="col-lg-offset-1"><div ng-repeat="table in floor.resources"><div ng-class="vm.isTableManaged ? \'col-lg-2\' : \'col-lg-3\'" ng-if="table.capacity == 1"><div class="widget col-lg-12 btn btn-outline" ng-class="table.disabled ? \'btn-default\' : \'btn-info\'" style="padding: 5px"><div style="float: left" ng-if="table.disabled"><small>Disabled</small></div><div style="float: left" ng-if="!table.disabled && table.disabledForOnline"><small style="font-size: x-small">Disabled (online)</small></div><div style="float: right"><i class="fa fa-edit" style="width: 20px" ng-click="showPopupEditTable($parent.$parent.$index, $index)"></i> <i class="fa fa-remove" ng-click="showPopupDeleteTable($parent.$parent.$index, $index)"></i></div><div class="row" style="margin: 10px 5px"><div class="col-xs-12 text-center" style="padding: 10px"><small ng-style="{color: table.disabled ? \'grey\' : floor.color}" style="font-weight: 600">{{table.nameToShow}}</small></div></div><div style="float: left"><i class="fa fa-group">&nbsp<font style="color: black; font-weight: 600">{{table.capacity}}</font></i></div><div style="float: right"><i class="fa fa-star" style="float: right" ng-if="table.vip"></i></div></div></div><div ng-class="vm.isTableManaged ? \'col-lg-2\' : \'col-lg-3\'" ng-if="table.capacity == 2"><div class="widget col-lg-12 btn btn-outline" ng-class="table.disabled ? \'btn-default\' :\'btn-primary\'" style="padding: 5px"><div style="float: left" ng-if="table.disabled"><small>Disabled</small></div><div style="float: left" ng-if="!table.disabled && table.disabledForOnline"><small style="font-size: x-small">Disabled (online)</small></div><div style="float: right"><i class="fa fa-edit" style="width: 20px" ng-click="showPopupEditTable($parent.$parent.$index, $index)"></i> <i class="fa fa-remove" ng-click="showPopupDeleteTable($parent.$parent.$index, $index)"></i></div><div class="row" style="margin: 10px 5px"><div class="col-xs-12 text-center" style="padding: 10px"><small ng-style="{color: table.disabled ? \'grey\' : floor.color}" style="font-weight: 600">{{table.nameToShow}}</small></div></div><div style="float: left"><i class="fa fa-group">&nbsp<font style="color: black; font-weight: 600">{{table.capacity}}</font></i></div><div style="float: right"><i class="fa fa-star" style="float: right" ng-if="table.vip"></i></div></div></div><div ng-class="vm.isTableManaged ? \'col-lg-2\' : \'col-lg-3\'" ng-if="table.capacity == 4"><div class="widget col-lg-12 btn btn-outline" ng-class="table.disabled ? \'btn-default\' : \'btn-success\'" style="padding: 5px"><div style="float: left" ng-if="table.disabled"><small>Disabled</small></div><div style="float: left" ng-if="!table.disabled && table.disabledForOnline"><small style="font-size: x-small">Disabled (online)</small></div><div style="float: right"><i class="fa fa-edit" style="width: 20px" ng-click="showPopupEditTable($parent.$parent.$index, $index)"></i> <i class="fa fa-remove" ng-click="showPopupDeleteTable($parent.$parent.$index, $index)"></i></div><div class="row" style="margin: 10px 5px"><div class="col-xs-12 text-center" style="padding: 10px"><small ng-style="{color: table.disabled  ? \'grey\' : floor.color}" style="font-weight: 600">{{table.nameToShow}}</small></div></div><div style="float: left"><i class="fa fa-group">&nbsp<font style="color: black; font-weight: 600">{{table.capacity}}</font></i></div><div style="float: right"><i class="fa fa-star" style="float: right" ng-if="table.vip"></i></div></div></div><div ng-class="vm.isTableManaged ? \'col-lg-2\' : \'col-lg-3\'" ng-if="table.capacity == 6"><div class="widget col-lg-12 btn btn-outline" ng-class="table.disabled ? \'btn-default\' : \'btn-warning\'" style="padding: 5px"><div style="float: left" ng-if="table.disabled"><small>Disabled</small></div><div style="float: left" ng-if="!table.disabled && table.disabledForOnline"><small style="font-size: x-small">Disabled (online)</small></div><div style="float: right"><i class="fa fa-edit" style="width: 20px" ng-click="showPopupEditTable($parent.$parent.$index, $index)"></i> <i class="fa fa-remove" ng-click="showPopupDeleteTable($parent.$parent.$index, $index)"></i></div><div class="row" style="margin: 10px 5px"><div class="col-xs-12 text-center" style="padding: 10px"><small ng-style="{color: table.disabled ? \'grey\' : floor.color}" style="font-weight: 600">{{table.nameToShow}}</small></div></div><div style="float: left"><i class="fa fa-group">&nbsp<font style="color: black; font-weight: 600">{{table.capacity}}</font></i></div><div style="float: right"><i class="fa fa-star" style="float: right" ng-if="table.vip"></i></div></div></div><div ng-class="vm.isTableManaged ? \'col-lg-2\' : \'col-lg-3\'" ng-if="table.capacity == 3 || table.capacity == 5 || table.capacity > 6"><div class="widget col-lg-12 btn btn-outline" ng-class="table.disabled ? \'btn-default\' : \' btn-danger\'" style="padding: 5px"><div style="float: left" ng-if="table.disabled"><small>Disabled</small></div><div style="float: left" ng-if="!table.disabled && table.disabledForOnline"><small style="font-size: x-small">Disabled (online)</small></div><div style="float: right"><i class="fa fa-edit" style="width: 20px" ng-click="showPopupEditTable($parent.$parent.$index, $index)"></i> <i class="fa fa-remove" ng-click="showPopupDeleteTable($parent.$parent.$index, $index)"></i></div><div class="row" style="margin: 10px 5px"><div class="col-xs-12 text-center" style="padding: 10px"><small ng-style="{color: table.disabled ? \'grey\' : floor.color}" style="font-weight: 600">{{table.nameToShow}}</small></div></div><div style="float: left"><i class="fa fa-group">&nbsp<font style="color: black; font-weight: 600">{{table.capacity}}</font></i></div><div style="float: right"><i class="fa fa-star" style="float: right" ng-if="table.vip"></i></div></div></div></div></div></div><div style="width: 25%; float: right"><div class="col-lg-9" style="margin-left: auto; margin-right: auto; margin-top: 7px"><button ng-is="!vm.isTableManaged" type="button" class="col-lg-12 btn btn-outline btn-info" style="margin: 2px auto" ng-click="addNewTable($index, \'oneSeat\')">Add 1<stran stext="capacity" type="p"></stran><stran stext="resource" type="s"></stran></button> <button type="button" class="col-lg-12 btn btn-outline btn-primary" style="margin: 2px auto" ng-click="addNewTable($index, \'twoSeats\')">Add 2<stran stext="capacity" type="p"></stran><stran stext="resource" type="s"></stran></button> <button type="button" class="col-lg-12 btn btn-outline btn-success" style="margin: 2px auto" ng-click="addNewTable($index, \'fourSeats\')">Add 4<stran stext="capacity" type="p"></stran><stran stext="resource" type="s"></stran></button> <button type="button" class="col-lg-12 btn btn-outline btn-warning" style="margin: 2px auto" ng-click="addNewTable($index, \'sixSeats\')">Add 6<stran stext="capacity" type="p"></stran><stran stext="resource" type="s"></stran></button> <button type="button" class="col-lg-12 btn btn-outline btn-danger" style="margin: 2px auto" ng-click="addNewCustomTable($index)">Add custom<stran stext="resource" type="s"></stran></button></div><div class="col-lg-9" style="margin-left: auto; margin-right: auto"><div class="widget style1 text-center" style="border: 2px solid #812890; padding: 5px 5px 20px 5px"><h3 style="float: left"><stran stext="category" type="sc"></stran>color code</h3><br><br><input ng-disabled="true" ng-style="{background:floor.color}" style="color:white; border: 0px"><br><small>Color used to mark<stran stext="resource" type="p"></stran>from this<stran stext="category" type="s"></stran>.</small></div></div></div></div></uib-tab></uib-tabset></div></div><div class="row m-b-md"><div class="col-sm-12"></div></div></div></div></div></div><div class="modal-backdrop fade in" ng-if="anyPopupVisible"></div></div><div class="modal inmodal in" id="myModal" tabindex="-1" role="dialog" ng-if="popupNewAreaVisible" style="display: block; padding-right: 16px"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><i class="fa fa-cutlery modal-icon"></i><h4 class="modal-title">Add<stran stext="category" type="s"></stran></h4></div><div class="modal-body"><form name="formGroups"><div class="form-group" ng-class="{ \'has-error\': formGroups.addNewAreaNameCheck.$invalid}"><label><stran stext="category" type="sc"></stran>Name</label><input type="text" placeholder="Enter area name" class="form-control" name="addNewAreaNameCheck" ng-model="newArea.name" required ng-maxlength="64" maxlength="64"><div class="validation-error" ng-show="formGroups.addNewAreaNameCheck.$invalid"><div ng-messages="formGroups.addNewAreaNameCheck.$error" role="alert" class="text-danger"><div ng-message="required">Name is required.</div><div ng-message="maxlength">Name cannot exceed 64 characters.</div></div></div></div><div class="form-group" ng-class="{ \'has-error\': formGroups.addNewAreaSignCheck.$invalid}"><label><stran stext="category" type="sc"></stran>Sign</label><select placeholder="Select area sign" class="form-control" name="addNewAreaSignCheck" ng-model="newArea.sign" ng-options="obj.signDB as obj.sign for obj in availableSigns" required></select><div class="validation-error" ng-show="formGroups.addNewAreaSignCheck.$invalid"><div ng-messages="formGroups.addNewAreaSignCheck.$error" role="alert" class="text-danger"><div ng-message="required">Sign is required.</div></div></div></div><div class="form-group" ng-class="{ \'has-error\': formGroups.addNewAreaColorCheck.$invalid}"><label><stran stext="category" type="sc"></stran>Color</label><input type="text" color-picker color-picker-model="newArea.color" ng-model="newArea.color" class="form-control" name="addNewAreaColorCheck" required color-picker-show-cancel-button="true" color-picker-position="right" color-picker-output-format="\'hex\'" ng-style="{background:newArea.color}" style="color: lightgray" readonly="readonly"> <small>Color used to mark<stran stext="resource" type="p">from this<stran stext="category" type="s"></stran>.</stran></small><div class="validation-error" ng-show="formGroups.addNewAreaColorCheck.$invalid"><div ng-messages="formGroups.addNewAreaColorCheck.$error" role="alert" class="text-danger"><div ng-message="required">Color is required.</div></div></div></div><div class="form-group"><label style="margin-right: 25px">VIP<stran stext="category" type="s"></stran></label><button type="checkbox" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="newArea.vip" ng-click="newAreaVipChanged()" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': newArea.vip === true}" style="width: 10px; left: -1px"></span></button></div></form></div><div class="modal-footer"><div ng-if="nameExist" class="text-danger" style="float: left">This<stran stext="category" type="s"></stran>name already exist on this location. Please change it and press "Save<stran stext="category" type="s"></stran>" again.</div><div ng-if="signExist" class="text-danger" style="float: left">This<stran stext="category" type="s"></stran>sign already exist on this location. Please change it and press "Save<stran stext="category" type="s"></stran>" again.</div><button type="button" class="btn btn-white" data-dismiss="modal" ng-click="closePopup()">Close</button> <button type="button" class="btn btn-primary" ng-disabled="formGroups.$invalid" ng-click="saveNewArea()">Save<stran stext="category" type="s"></stran></button></div></div></div></div><div class="modal inmodal in" id="myModal" tabindex="-1" role="dialog" ng-if="popupEditAreaVisible" style="display: block; padding-right: 16px"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><i class="fa fa-cutlery modal-icon"></i><h4 class="modal-title">Edit<stran stext="category" type="sc"></stran></h4></div><div class="modal-body"><form name="formGroups"><div class="form-group" ng-class="{ \'has-error\': formGroups.editAreaNameCheck.$invalid}"><label><stran stext="category" type="sc"></stran>Name</label><input type="text" placeholder="Enter area name" class="form-control" name="editAreaNameCheck" ng-model="editArea.name" required ng-maxlength="64" maxlength="64"><div class="validation-error" ng-show="formGroups.editAreaNameCheck.$invalid"><div ng-messages="formGroups.editAreaNameCheck.$error" role="alert" class="text-danger"><div ng-message="required">Name is required.</div><div ng-message="maxlength">Name cannot exceed 64 characters.</div></div></div></div><div class="form-group" ng-class="{ \'has-error\': formGroups.editAreaColorCheck.$invalid}"><label><stran stext="category" type="sc"></stran>Color</label><input color-picker color-picker-model="editArea.color" ng-model="editArea.color" class="form-control" name="editAreaColorCheck" required color-picker-show-cancel-button="true" color-picker-position="right" color-picker-output-format="\'hex\'" ng-style="{background:editArea.color}" style="color: lightgray" readonly="readonly"> <small>Color used to mark<stran stext="resource" type="p"></stran>from this<stran stext="category" type="s"></stran>.</small><div class="validation-error" ng-show="formGroups.editAreaColorCheck.$invalid"><div ng-messages="formGroups.editAreaColorCheck.$error" role="alert" class="text-danger"><div ng-message="required">Color is required.</div></div></div></div><div class="form-group"><label style="margin-right: 25px">Mark as VIP</label><button type="checkbox" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="editArea.vip" ng-click="editAreaVipChanged()" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': editArea.vip === true}" style="width: 10px; left: -1px"></span></button></div></form></div><div class="modal-footer"><div ng-if="editedAreaNameExist" class="text-danger" style="float: left">This<stran stext="category" type="s"></stran>name already exist on this location. Please change it and press "Save<stran stext="category" type="s"></stran>" again.</div><div ng-if="editedAreaSignExist" class="text-danger" style="float: left">This<stran stext="category" type="s"></stran>sign already exist on this location. Please change it and press "Save<stran stext="category" type="s"></stran>" again.</div><button type="button" class="btn btn-white" data-dismiss="modal" ng-click="closePopup()">Close</button> <button type="button" class="btn btn-primary" ng-disabled="formGroups.$invalid" ng-click="saveEditedArea()">Save<stran stext="category" type="s"></stran></button></div></div></div></div><div class="modal inmodal in" id="myModal" tabindex="-1" role="dialog" ng-if="popupDeleteAreaVisible" style="display: block; padding-right: 16px"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><i class="fa fa-cutlery modal-icon"></i><h4 class="modal-title">Delete<stran stext="category" type="s"></stran></h4></div><div class="modal-body"><label style="margin-right: 25px">{{deleteAreaMessage}}</label></div><div class="modal-footer"><button type="button" class="btn btn-white" data-dismiss="modal" ng-click="closePopup()">Close</button> <button type="button" class="btn btn-primary" ng-if="deleteAreaShowOkDeleteAreaButton" ng-click="deleteArea()">Delete<stran stext="category" type="s"></stran></button></div></div></div></div><div class="modal inmodal in" id="myModal" tabindex="-1" role="dialog" ng-if="popupAddCustomTableVisible" style="display: block; padding-right: 16px"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><i class="fa fa-users modal-icon"></i><h4 class="modal-title">Add custom<stran stext="resource" type="s"></stran></h4></div><div class="modal-body"><form name="formGroups"><div class="form-group" ng-class="{ \'has-error\': formGroups.newTableCapacityCheck.$invalid}"><label>Capacity</label><input name="newTableCapacityCheck" ng-model="newCustomTable.capacity" class="form-control input-sm ng-pristine ng-untouched ng-valid ng-valid-min ng-valid-required" required="" ng-min="1" ng-max="9999" type="number"><div class="validation-error" ng-show="formGroups.newTableCapacityCheck.$invalid"><div ng-messages="formGroups.newTableCapacityCheck.$error" role="alert" class="text-danger"><div ng-message="required">Capacity is required.</div><div ng-message="min">Minimum capacity is 1</div><div ng-message="max">Maximum capacity is 9999</div></div></div></div><div class="form-group"><label style="margin-right: 25px">Mark as VIP</label><button type="checkbox" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="newCustomTable.vip" ng-click="newCustomTableVipChanged()" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': newCustomTable.vip === true}" style="width: 10px; left: -1px"></span></button></div></form></div><div class="modal-footer"><button type="button" class="btn btn-white" data-dismiss="modal" ng-click="closePopup()">Close</button> <button type="button" class="btn btn-primary" ng-disabled="formGroups.$invalid" ng-click="saveNewCustomTable()">Add<stran stext="resource" type="s"></stran></button></div></div></div></div><div class="modal inmodal in" id="myModal" tabindex="-1" role="dialog" ng-if="popupEditTableVisible" style="display: block; padding-right: 16px"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><h4 class="modal-title">Edit<stran stext="resource" type="s"></stran></h4></div><div class="modal-body"><form name="formGroups"><div class="form-group" ng-class="{ \'has-error\': formGroups.editTableNameCheck.$invalid}"><label><stran stext="resource" type="sc"></stran>Name</label><input type="text" placeholder="Enter name" class="form-control" name="editTableNameCheck" ng-model="editTable.name" required ng-maxlength="32" maxlength="32"><div class="validation-error" ng-show="formGroups.editTableNameCheck.$invalid"><div ng-messages="formGroups.editTableNameCheck.$error" role="alert" class="text-danger"><div ng-message="required">Name is required.</div><div ng-message="maxlength">Name cannot exceed 32 characters.</div></div></div></div><div class="form-group"><label style="margin-right: 25px">Mark as VIP</label><button type="checkbox" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="editTable.vip" ng-click="editTableVipChanged()" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': editTable.vip === true}" style="width: 10px; left: -1px"></span></button></div><div class="form-group"><label style="margin-right: 25px">Disabled (for all reservations)</label><button type="checkbox" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="editTable.disabled" ng-click="editTableDisabledChanged()" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': editTable.disabled === true}" style="width: 10px; left: -1px"></span></button></div><div class="form-group"><label style="margin-right: 25px">Disabled (only for online reservations)</label><button type="checkbox" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="editTable.disabledForOnline" ng-click="editTableDisabledForOnlineChanged()" ng-model-options="{getterSetter: true}" ng-disabled="editTable.disabled"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': editTable.disabledForOnline === true}" style="width: 10px; left: -1px"></span></button></div><div class="form-group" ng-class="{ \'has-error\': formGroups.newTableCapacityCheck.$invalid}"><label>Capacity</label><input name="newTableCapacityCheck" ng-model="editTable.capacity" class="form-control input-sm ng-pristine ng-untouched ng-valid ng-valid-min ng-valid-required" required="" ng-min="1" ng-max="9999" type="number"><div class="validation-error" ng-show="formGroups.newTableCapacityCheck.$invalid"><div ng-messages="formGroups.newTableCapacityCheck.$error" role="alert" class="text-danger"><div ng-message="required">Capacity is required.</div><div ng-message="min">Minimum capacity is 1</div><div ng-message="max">Maximum capacity is 9999</div></div></div></div><div class="form-group"><label><stran stext="category" type="sc"></stran></label><select class="form-control" ng-model="editTable.areaId" ng-options="area.id as area.name for area in data"></select></div></form></div><div class="modal-footer"><div ng-if="editedTableNameExist" class="text-danger" style="float: left">This<stran stext="resource" type="s"></stran>name already exist on this location. Please change it and press "Save<stran stext="resource" type="s"></stran>" again.</div><button type="button" class="btn btn-white" data-dismiss="modal" ng-click="closePopup()">Close</button> <button type="button" class="btn btn-primary" ng-disabled="formGroups.$invalid" ng-click="saveEditedTable(formGroups.editTableNameCheck.$dirty)">Save<stran stext="resource" type="s"></stran></button></div></div></div></div><div class="modal inmodal in" id="myModal" tabindex="-1" role="dialog" ng-if="popupDeleteTableVisible" style="display: block; padding-right: 16px"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><i class="fa fa-users modal-icon"></i><h4 class="modal-title">Delete<stran stext="resource" type="s"></stran></h4></div><div class="modal-body"><label style="margin-right: 25px">{{deleteTableMessage}}</label></div><div class="modal-footer"><button type="button" class="btn btn-white" data-dismiss="modal" ng-click="closePopup()">Close</button> <button type="button" class="btn btn-primary" ng-click="deleteTable()">Delete<stran stext="resource" type="s"></stran></button></div></div></div></div>');
$templateCache.put('app/settings/general/general.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12 col-md-12"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Product definition</h2>Define products for which your guest can make a reservation.<br>Product can be <span ng-if="vm.isTableManaged">standard meals (breakfast, lunch and dinner), </span>simple duration in minutes & hours or custom defined products.<br><br><strong>Current choice: <span class="text-navy">{{vm.productTypeDesc(vm.productType)}}</span></strong></div><div class="panel-body"><div ng-if="vm.isTableManaged" class="row"><div class="col-lg-10 col-lg-offset-1"><div class="radio"><input class="radio-primary" ng-model="vm.productType" ng-change="vm.changeProductType()" type="radio" name="radio1" id="radio1" value="MEAL" checked=""><label for="radio1"><strong ng-class="vm.productType==\'MEAL\'?\'text-navy\':\'text-muted\'">{{vm.productTypeDesc(\'MEAL\')}}</strong><br><small>System will automatically assign meal to event depending on time for which reservation/event is requested.</small></label></div></div></div><div ng-if="vm.isTableManaged" class="row"><div class="col-lg-8 col-lg-offset-2"><br><table class="table table-hover"><thead><tr><th><h4>Name</h4></th><th><h4>From</h4></th><th><h4>To</h4></th><th><h4>Default duration</h4></th><th></th></tr></thead><tbody><tr><td class="text-right"><input placeholder="Breakfast" type="text" ng-model="vm.meals.breakfastName" size="12" maxlength="32" ng-disabled="(vm.meals.breakfastNotServed || vm.productType!=\'MEAL\')"></td><td><span ng-class="(vm.meals.breakfastNotServed || vm.productType!=\'MEAL\') ? \'text-muted\' : \'\'">Beginning of day</span></td><td><select ng-model="vm.meals.breakfastEnd" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimes" ng-disabled="(vm.meals.breakfastNotServed || vm.productType!=\'MEAL\')"></select></td><td><select ng-model="vm.meals.breakfastDuration" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimesForDuration" ng-disabled="(vm.meals.breakfastNotServed || vm.productType!=\'MEAL\')"></select><br><small>Average duration in last 30 days <span class="text-danger">{{vm.meals.averageBreakfastDuration}}</span></small></td><td><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.meals.breakfastNotServed" ng-disabled="vm.productType!=\'MEAL\'"></checkbox>&nbsp;&nbsp;We do not serve {{vm.meals.breakfastName}}.</td></tr><tr><td class="text-right"><input placeholder="Lunch" type="text" ng-model="vm.meals.lunchName" size="12" maxlength="32" ng-disabled="(vm.meals.lunchNotServed || vm.productType!=\'MEAL\')"></td><td><select ng-model="vm.meals.breakfastEnd" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimes" ng-disabled="(vm.meals.lunchNotServed || vm.productType!=\'MEAL\')"></select></td><td><select ng-model="vm.meals.lunchEnd" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimes" ng-change="endTimeChanged(\'lunchEnd\')" ng-disabled="(vm.meals.lunchNotServed || vm.productType!=\'MEAL\')"></select></td><td><select ng-model="vm.meals.lunchDuration" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimesForDuration" ng-disabled="(vm.meals.lunchNotServed || vm.productType!=\'MEAL\')"></select><br><small>Average duration in last 30 days <span class="text-danger">{{vm.meals.averageLunchDuration}}</span></small></td><td><checkbox style="margin-bottom: 5px" type="checkbox" ng-disabled="vm.productType!=\'MEAL\'" class="btn-primary btn" ng-model="vm.meals.lunchNotServed"></checkbox>&nbsp;&nbsp;We do not serve {{vm.meals.lunchName}}.</td></tr><tr><td class="text-right"><input placeholder="Dinner" type="text" ng-model="vm.meals.dinnerName" size="12" maxlength="32" ng-disabled="(vm.meals.dinnerNotServed || vm.productType!=\'MEAL\')"></td><td><select ng-model="vm.meals.lunchEnd" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimes" ng-disabled="(vm.meals.dinnerNotServed || vm.productType!=\'MEAL\')"></select></td><td><span ng-class="(vm.meals.dinnerNotServed || vm.productType!=\'MEAL\') ? \'text-muted\' : \'\'">End of day</span></td><td><select ng-model="vm.meals.dinnerDuration" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimesForDuration" ng-disabled="(vm.meals.dinnerNotServed || vm.productType!=\'MEAL\')"></select><br><small>Average duration in last 30 days <span class="text-danger">{{vm.meals.averageDinnerDuration}}</span></small></td><td><checkbox style="margin-bottom: 5px" ng-disabled="vm.productType!=\'MEAL\'" type="checkbox" class="btn-primary btn" ng-model="vm.meals.dinnerNotServed"></checkbox>&nbsp;&nbsp;We do not serve {{vm.meals.dinnerName}}.</td></tr></tbody></table><button aria-pressed="false" data-toggle="button" class="btn btn-primary" type="button" ng-disabled="vm.productType!=\'MEAL\'" ng-click="vm.saveMealSettings()">Save meals settings</button><br><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="radio"><input class="radio-primary" ng-model="vm.productType" ng-change="vm.changeProductType()" type="radio" name="radio1" id="radio2" value="DURATION" checked=""><label for="radio1"><strong ng-class="vm.productType==\'DURATION\'?\'text-navy\':\'text-muted\'">{{vm.productTypeDesc(\'DURATION\')}}</strong><br><small>System will offer simple duration list for guests to choose from.<br>Example: If you choose minimum 30 min and maximum 2 hours, system will offer to guest following list 30 minutes, 1 hour, 1 hour 30 minutes and 2 hour.</small></label></div></div></div><div class="row"><div class="col-lg-8 col-lg-offset-2"><br>Minimum reservation duration is<select ng-model="vm.duration.minDuration" ng-required="true" ng-options="item.id as item.name for item in vm.minDurationList" ng-disabled="vm.productType!=\'DURATION\'"></select>, maximum allowed duration of reservation is<select ng-model="vm.duration.maxDuration" ng-required="true" ng-options="item.id as item.name for item in vm.maxDurationList" ng-disabled="vm.productType!=\'DURATION\'"></select><br><br><button aria-pressed="false" data-toggle="button" class="btn btn-primary" type="button" ng-disabled="vm.productType!=\'DURATION\'" ng-click="vm.saveDurationSettings()">Save simple duration settings</button><br><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="radio"><input class="radio-primary" ng-model="vm.productType" ng-change="vm.changeProductType()" type="radio" name="radio1" id="radio3" value="PRODUCT" checked=""><label for="radio1"><strong ng-class="vm.productType==\'PRODUCT\'?\'text-navy\':\'text-muted\'">{{vm.productTypeDesc(\'PRODUCT\')}}</strong><br><small>System will offer product list for guests to choose from when creating a reservation.</small></label></div></div></div><div class="row"><div class="col-lg-5 col-lg-offset-1"><form name="productForm" class="form-horizontal"><div class="form-group"><label class="col-sm-3 control-label">Product name</label><div class="col-sm-6"><input placeholder="" type="text" class="form-control" ng-model="vm.product.name" maxlength="32" ng-disabled="vm.productType!=\'PRODUCT\'"></div></div><div class="form-group"><label class="col-sm-3 control-label">Product description</label><div class="col-sm-8"><textarea placeholder="" type="text" class="form-control" ng-model="vm.product.description" maxlength="256" ng-disabled="vm.productType!=\'PRODUCT\'" rows="3"></textarea></div></div><div class="form-group"><label class="col-sm-3 control-label">Duration</label><div class="col-sm-4"><select ng-model="vm.product.duration" class="form-control" ng-options="obj.timeForDB as obj.time for obj in vm.availableTimesForDuration" ng-disabled="vm.productType!=\'PRODUCT\'"><option value="" disabled="disabled" selected="selected">Select duration</option></select></div></div><hr><div class="form-group"><label class="col-sm-5 control-label">Reservation fee (optional):</label></div><div class="form-group"><label class="col-sm-3 control-label">Rule</label><div class="col-sm-4"><select ng-model="vm.product.rule" class="form-control" ng-disabled="vm.productType!=\'PRODUCT\'" ng-options="item.id as item.name for item in vm.ruleList"></select></div></div><div class="form-group"><label class="col-sm-3 control-label">Fee</label><div class="col-sm-5"><div class="input-group m-b"><span class="input-group-addon">{{vm.currencySymbol}}</span> <input ng-model="vm.product.fee" class="form-control" ng-disabled="vm.productType!=\'PRODUCT\'" min="0" max="9999" type="number" step="0.01" ng-pattern="/^[0-9]+\\.?[0-9]*/"></div></div></div><div class="form-group"><label class="col-sm-3 control-label">Tax (included)</label><div class="col-sm-5"><div class="input-group m-b"><span class="input-group-addon">%</span> <input ng-model="vm.product.tax" class="form-control" ng-disabled="vm.productType!=\'PRODUCT\'" type="number" min="0" max="100" step="0.01" ng-pattern="/^[0-9]+\\.?[0-9]*$/"></div></div></div><hr><div class="form-group"><label class="col-sm-3 control-label">Time slot set</label><div class="col-sm-6"><select ng-model="vm.product.timeSlotSetId" class="form-control" ng-disabled="vm.productType!=\'PRODUCT\'" ng-options="item.id as item.name for item in vm.timeSlotSetList"><option value="" disabled="disabled" selected="selected">Use standard</option></select>Override time slot set, if not defined here standard will be used.</div></div><div class="form-group"><label class="col-sm-3 control-label">Seating Options</label><div class="col-sm-9 btn-group"><span ng-if="vm.seatingOptionList && vm.seatingOptionList.length>0"><label ng-repeat="seatingOption in vm.seatingOptionList" ng-model="seatingOption.selected" uib-btn-checkbox class="btn btn-primary btn-outline" style="margin: 2px; overflow:auto"><span class="font-bold">{{seatingOption.name}}</span></label></span><span ng-if="vm.seatingOptionList && vm.seatingOptionList.length==0" class="text-danger text-center">No available Seating Option(s).</span></div></div><div class="form-group"><label class="col-sm-3 control-label">Dates active</label><div class="col-sm-9 input-group date"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker()"><i class="fa fa-calendar"></i></button> </span><input ng-change="vm.checkPicker()" ng-model="vm.pickerModel" placeholder="select time period" type="text" class="form-control" name="pickerDates" style="background-color: #FFF"></div></div><div ng-if="vm.filterFrom!=null && vm.product.id!=null" class="form-group"><label class="col-sm-3 control-label">Public link for event</label><div class="col-sm-8"><textarea id="publicProductUrl" width="200px" class="col-md-12 col-sm-12" disabled="true" rows="3">{{vm.custo.baseUrl}}?date={{ vm.filterFrom | date: \'yyyy-MM-dd\'  }}&productId={{vm.product.id}}&channel=merchant_web#/public/online/reservation/{{vm.custo.hashedLocationId}}</textarea><br><a type="button" ng-click="vm.copyToClipboard(\'publicProductUrl\')" class="btn btn-w-m btn-primary">Copy Link to Clipboard</a></div></div><div class="form-group"><label class="col-sm-3 control-label">Private</label><div class="col-sm-8"><checkbox style="margin-bottom: 5px" type="checkbox" ng-disabled="vm.productType!=\'PRODUCT\'" class="btn-primary btn" ng-model="vm.product.privateProduct"></checkbox>&nbsp;&nbsp;<small>(if checked, product will not be visible to customers)</small><br></div></div><div class="form-group"><label class="col-sm-3 control-label">Enable modifiers</label><div class="col-sm-5"><checkbox style="margin-bottom: 5px" type="checkbox" ng-disabled="vm.productType!=\'PRODUCT\'" class="btn-primary btn" ng-model="vm.product.modifierEnabled"></checkbox><br><br></div></div><button type="button" class="btn btn-primary col-lg-4 col-lg-offset-3" ng-click="vm.saveProduct()" ng-disabled=" !vm.product.name || !vm.product.description || !vm.product.duration">Save Product</button></form></div><div class="col-lg-6 col-md-6"><ul class="todo-list m-t ui-sortable"><li><span class="text-danger font-bold"><i class="fa fa-list"></i>&nbsp; Product list</span><table class="table table-hover"><thead><tr><th>Name</th><th>Duration</th><th>Seating options</th><th>Dates</th><th>Fee</th><th>Rule</th><th>Action</th><th colspan="2">Reorder</th></tr></thead><tbody><tr ng-repeat="(key, product) in vm.productList"><td>{{product.name}}</td><td>{{vm.formatMinutes(product.duration)}}</td><td>{{vm.getAreasForProduct(product.seatingOptionIds) }}</td><td><span ng-if="product.startDate!=null && product.id!=null" class="form-group">{{product.startDate}}<br>-{{product.endDate}}<br><a type="button" ng-click="vm.copyToClipboardNavigator(product.startDate,product.id)" class="btn btn-xs btn-info">Copy Link</a> </span><span ng-if="product.startDate==null && product.id!=null" class="form-group"><a type="button" ng-click="vm.copyToClipboardNavigator(\'\',product.id)" class="btn btn-xs btn-info">Copy Link</a></span></td><td ng-if="!product.fee" class="font-italic">No fee</td><td ng-if="product.fee">{{product.fee | currency}}</td><td ng-if="!product.rule" class="font-italic">No rule</td><td ng-if="product.rule">{{product.rule}}</td><td class="text-danger"><button type="button" class="btn btn-xs btn-info" ng-disabled="vm.productType!=\'PRODUCT\'" ng-click="vm.editProduct(product)"><i class="fa fa-edit"></i><small> EDIT</small></button> <button type="button" class="btn btn-xs btn-danger" ng-disabled="vm.productType!=\'PRODUCT\'" ng-click="vm.deleteProduct(product.id)"><i class="fa fa-times"></i><small> DELETE</small></button> <button ng-show="product.modifierEnabled" type="button" class="btn btn-xs btn-info" ng-disabled="vm.productType!=\'PRODUCT\'" ng-click="vm.showProductModifers(product)"><i class="fa fa-plus-square-o"></i><small> MODIFIERS</small></button></td><td><a ng-if="key<(vm.productList.length-1)" class="fa fa-arrow-circle-down text-success" ng-click="vm.reOrderProduct(product.id, vm.productList[key+1].id)"></a></td><td><a ng-if="key>0" class="fa fa-arrow-circle-up text-info" ng-click="vm.reOrderProduct(product.id, vm.productList[key-1].id)"></a></td></tr></tbody></table></li></ul></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/settings/general/product_modifiers.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeProductModifersDialog()"><span aria-hidden="true">&times;</span></button><h2 class="text-navy">Product modifiers definition</h2>Define various modifiers which guest can add to reservation.</div><div class="modal-body"><div class="row"><div class="col-lg-12"><div class="form-group"><label class="col-sm-7 control-label text-right">Define minimum total modifiers amount (optional):<br><small>Customer will be required to select modifiers in total amount defined here.</small></label><div class="col-sm-3"><div class="input-group m-b"><span class="input-group-addon">{{vm.currencySymbol}}</span> <input ng-model="vm.minModifierAmount" class="form-control" min="0" max="9999" type="number" step="0.01" ng-pattern="/^[0-9]+\\.?[0-9]*/"></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label class="col-sm-7 control-label text-right">Allow service charge (tips):</label><div class="col-sm-3"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.allowServiceCharge"></checkbox></div></div><button ng-disabled="vm.minModifierAmount==undefined || vm.minModifierAmount<0" type="button" class="btn btn-primary col-sm-2 pull-right" ng-click="saveModifierSettings(vm.modifier.productId,vm.minModifierAmount, vm.allowServiceCharge)">Save</button></div></div><hr><div class="row"><div class="col-lg-5"><form name="productModifierForm" class="form-horizontal"><div class="form-group"><label class="col-sm-8">Define modifier:</label></div><div class="form-group"><label class="col-sm-3 control-label">Name</label><div class="col-sm-9"><input placeholder="" type="text" class="form-control" ng-model="vm.modifier.name" maxlength="32"></div></div><div class="form-group"><label class="col-sm-3 control-label">Description</label><div class="col-sm-9"><textarea placeholder="" type="text" class="form-control" ng-model="vm.modifier.description" maxlength="265" rows="3"></textarea></div></div><div class="form-group"><label class="col-sm-5 control-label">Fee (optional):</label></div><div class="form-group"><label class="col-sm-3 control-label">Fee</label><div class="col-sm-7"><div class="input-group m-b"><span class="input-group-addon">{{vm.currencySymbol}}</span> <input ng-model="vm.modifier.fee" class="form-control" min="0" max="9999" type="number" step="0.01" ng-pattern="/^[0-9]+\\.?[0-9]*/"></div></div></div><div class="form-group"><label class="col-sm-3 control-label">Tax (included)</label><div class="col-sm-7"><div class="input-group m-b"><span class="input-group-addon">%</span> <input ng-model="vm.modifier.tax" class="form-control" type="number" min="0" max="100" step="0.01" ng-pattern="/^[0-9]+\\.?[0-9]*/"></div></div></div><button type="button" class="btn btn-primary col-lg-4 col-lg-offset-3" ng-click="saveProductModifier()" ng-disabled=" !vm.modifier.name || !vm.modifier.description">Save Modifier</button></form></div><div class="col-lg-7"><ul class="todo-list m-t ui-sortable"><li><span class="text-danger font-bold"><i class="fa fa-plus-square-o"></i>&nbsp; Modifier list</span><table class="table table-hover"><thead><tr><th>Name</th><th>Fee</th><th>Action</th><th colspan="2">Reorder</th></tr></thead><tbody><tr ng-repeat="(key, productModifier) in vm.productModifierList"><td>{{productModifier.name}}</td><td>{{vm.formatAmount(productModifier.fee)}}</td><td class="text-danger"><button type="button" class="btn btn-xs btn-info" ng-disabled="vm.productType!=\'PRODUCT\'" ng-click="editProductModifier(productModifier)"><i class="fa fa-edit"></i><small> EDIT</small></button> <button type="button" class="btn btn-xs btn-danger" ng-disabled="vm.productType!=\'PRODUCT\'" ng-click="deleteProductModifier(productModifier.id)"><i class="fa fa-times"></i><small> DELETE</small></button></td><td><a ng-if="key<(vm.productModifierList.length-1)" class="fa fa-arrow-circle-down text-success" ng-click="reOrderProductModifiers(productModifier.id, vm.productModifierList[key+1].id)"></a></td><td><a ng-if="key>0" class="fa fa-arrow-circle-up text-info" ng-click="reOrderProductModifiers(productModifier.id, vm.productModifierList[key-1].id)"></a></td></tr></tbody></table></li></ul></div></div><br><br><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeProductModifersDialog()">Close</button></div></div>');
$templateCache.put('app/settings/ivr/ivr.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12 col-md-10"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">IVR Reservation Settings</h2>Don\'t miss a single reservation, activate the IVR Reservation functionality.</div><div class="panel-body"><div class="row" ng-show="!vm.IVRReservationEnabled"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Don\'t miss any reservation anymore. Allow your customer to make reservation even when you don\'t have time to pick up the phone.<br>SeatOn IVR Reservation functionality will be available 24/7 for your customer to make reservations.<br><br><small>Follow this link to find more information about <a href="https://support.seaton.site/049804-IVR-reservations" target="_blank">IVR Reservation</a>.</small><br><br><button class="btn btn-danger" ng-click="vm.openWindow()" target="_blank">{{::vm.IVRReservationText}}</button><br><br><br></div></div></div></div></div><div class="row" ng-show="vm.IVRReservationEnabled"><div class="col-sm-12"><button ng-show="vm.location.smsPhoneNumber==null || vm.location.smsPhoneNumber==\'\'" ng-disabled="formGroups.$invalid" aria-pressed="false" data-toggle="button" class="btn btn-primary" type="button" ng-click="vm.requestIVR()">Activate IVR Reservations</button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong class="text-danger" ng-show="vm.location.smsPhoneNumber==\'SETUP\'">IVR activation in progress, within 24 hours you will find here your dedicated phone number for IVR reservations.</strong> <strong class="text-navy" ng-show="vm.location.smsPhoneNumber!=null && vm.location.smsPhoneNumber!=\'SETUP\'">IVR setup completed. Your dedicated IVR phone number is <b>{{vm.location.smsPhoneNumber}}</b></strong> <span ng-show="vm.location.smsPhoneNumber!=null && vm.location.smsPhoneNumber!=\'SETUP\'"><br><br>If you want to cancel IVR reservation service, please send an email to support@seaton.site </span><span ng-show="vm.location.smsPhoneNumber==\'SETUP\'"><br><br>Once you activate IVR Reservation, within 24 hours IVR Reservations will be set up for you.<br>On this page you will find IVR phone number dedicated for your restaurant.</span><br><br>Follow this link to find more information about <a href="https://support.seaton.site/049804-IVR-reservations" target="_blank">IVR Reservation</a> functionality.<br><br><br><span ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\')">ADMIN<br>Enter IVR phone number: <input ng-model="vm.newPhone" ng-maxlength="64" type="text"> <button type="button" ng-click="vm.activatePhone()">Activate IVR number</button></span></div></div></div></div></div></div></div>');
$templateCache.put('app/settings/membership/membership.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12 col-md-10"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Membership customization</h2>Customize membership parameters to meet your requirements.</div><div class="panel-body"><div class="row"><div class="col-lg-12 text-right"><button ng-disabled="saveButtonDisabled || formGroups.$invalid" aria-pressed="false" data-toggle="button" class="btn btn-primary" type="button" ng-click="saveData(\n                                        formGroups.bronzeMemberThresholdDirty.$dirty,\n                                        formGroups.silverMemberThresholdDirty.$dirty,\n                                        formGroups.goldMemberThresholdDirty.$dirty,\n                                        formGroups.platinumMemberThresholdDirty.$dirty\n                                        )">Save membership settings</button></div></div><div class="row"><form name="formGroups"><div class="col-sm-12"><uib-tabset><uib-tab ng-click="activeTab(\'beginner\')"><uib-tab-heading class="text-center">Beginner member<div class="profile-stars"><span ng-if="!beginnerActive"><i class="fa fa-star"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i> </span><span ng-if="beginnerActive"><i class="fa fa-star text-warning"></i><i class="fa fa-star-o text-warning"></i><i class="fa fa-star-o text-warning"></i><i class="fa fa-star-o text-warning"></i><i class="fa fa-star-o text-warning"></i></span></div></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><br><p>Beginner member membership will be assigned to all new customers automatically when account is created.<br>Please define parameters for "Beginner member" membership type.</p><br></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Status name</label><div class="col-md-4" ng-class="{ \'has-error\': formGroups.beginnerMemberName.$invalid}"><input class="form-control" required ng-maxlength="32" type="text" ng-model="data.beginnerMember.name" name="beginnerMemberName"></div><div class="validation-error" ng-show="formGroups.beginnerMemberName.$invalid"><div ng-messages="formGroups.beginnerMemberName.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 32 characters.</div></div></div></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Benefits</label><div class="col-md-4"><ul class="todo-list ui-sortable"><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(beginnerMember.benefits, VIP_TABLE)" ng-click="beginnerMemberBenefitsChanged(\'VIP_TABLE\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': beginnerMemberBenefitVipTable === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Can book VIP<stran stext="resource" type="p"></stran></span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(beginnerMember.benefits, WAIT_PRIORITY)" ng-click="beginnerMemberBenefitsChanged(\'WAIT_PRIORITY\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': beginnerMemberBenefitWaitPriority === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has priority on waiting list</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(beginnerMember.benefits, FAVORITE_TABLE)" ng-click="beginnerMemberBenefitsChanged(\'FAVORITE_TABLE\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': beginnerMemberBenefitFavoriteTable === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has favorite<stran stext="resource" type="s"></stran>&nbsp;available</span></li></ul></div></div></div></div></div></uib-tab><uib-tab ng-click="activeTab(\'bronze\')"><uib-tab-heading class="text-center">Bronze member<div class="profile-stars"><span ng-if="!bronzeActive"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i> </span><span ng-if="bronzeActive"><i class="fa fa-star text-warning"></i><i class="fa fa-star text-warning"></i><i class="fa fa-star-o text-warning"></i><i class="fa fa-star-o text-warning"></i><i class="fa fa-star-o text-warning"></i></span></div></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><br><p>Bronze member membership will be assigned to customers automatically when defined threshold is reached.<br>Please define parameters for "Bronze member" membership type.</p><br></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Status name</label><div class="col-md-4" ng-class="{ \'has-error\': formGroups.bronzeMemberName.$invalid}"><input class="form-control" required ng-maxlength="32" type="text" ng-model="data.bronzeMember.name" name="bronzeMemberName"></div><div class="validation-error" ng-show="formGroups.bronzeMemberName.$invalid"><div ng-messages="formGroups.bronzeMemberName.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 32 characters.</div></div></div></div></div><div class="row"><div class="form-group m-t-lg ng-scope"><label class="col-lg-2 col-md-3 control-label">Points threshold</label><div class="col-md-4" ng-class="{ \'has-error\': bronzeMemberThresholdProblem}"><input name="bronzeMemberThresholdDirty" ng-model="data.bronzeMember.threshold" class="form-control input-sm ng-pristine ng-untouched ng-valid ng-valid-min ng-valid-required" required ng-min="1" type="number" ng-change="thresholdChanged(\'bronzeMember\')"><div ng-if="bronzeMemberThresholdProblem" class="text-danger">Bronze member threshold should be bigger than 0 and smaller than Silver member threshold ({{data.silverMember.threshold}}).</div></div></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Benefits</label><div class="col-md-4"><ul class="todo-list ui-sortable"><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(bronzeMember.benefits, VIP_TABLE)" ng-click="bronzeMemberBenefitsChanged(\'VIP_TABLE\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': bronzeMemberBenefitVipTable === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Can book VIP<stran stext="resource" type="p"></stran></span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(bronzeMember.benefits, WAIT_PRIORITY)" ng-click="bronzeMemberBenefitsChanged(\'WAIT_PRIORITY\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': bronzeMemberBenefitWaitPriority === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has priority on waiting list</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(bronzeMember.benefits, FAVORITE_TABLE)" ng-click="bronzeMemberBenefitsChanged(\'FAVORITE_TABLE\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': bronzeMemberBenefitFavoriteTable === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has favorite<stran stext="resource" type="s"></stran>&nbsp;available</span></li></ul></div></div></div></div></div></uib-tab><uib-tab ng-click="activeTab(\'silver\')"><uib-tab-heading class="text-center">Silver member<div class="profile-stars"><span ng-if="!silverActive"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i> </span><span ng-if="silverActive"><i class="fa fa-star text-warning"></i><i class="fa fa-star text-warning"></i><i class="fa fa-star text-warning"></i><i class="fa fa-star-o text-warning"></i><i class="fa fa-star-o text-warning"></i></span></div></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><br><p>Silver member membership will be assigned to customers automatically when defined threshold is reached.<br>Please define parameters for "Silver member" membership type.</p><br></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Status name</label><div class="col-md-4" ng-class="{ \'has-error\': formGroups.silverMemberName.$invalid}"><input class="form-control" required ng-maxlength="32" type="text" ng-model="data.silverMember.name" name="silverMemberName"></div><div class="validation-error" ng-show="formGroups.silverMemberName.$invalid"><div ng-messages="formGroups.silverMemberName.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 32 characters.</div></div></div></div></div><div class="row"><div class="form-group m-t-lg ng-scope"><label class="col-lg-2 col-md-3 control-label">Points threshold</label><div class="col-md-4" ng-class="{ \'has-error\': silverMemberThresholdProblem}"><input name="silverMemberThresholdDirty" ng-model="data.silverMember.threshold" class="form-control input-sm ng-pristine ng-untouched ng-valid ng-valid-min ng-valid-required" required ng-min="0" type="number" ng-change="thresholdChanged(\'silverMember\')"><div ng-if="silverMemberThresholdProblem" class="text-danger">Silver member threshold should be bigger than Bronze member threshold ({{data.bronzeMember.threshold}}) and smaller than Gold member threshold ({{data.goldMember.threshold}}).</div></div></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Benefits</label><div class="col-md-4"><ul class="todo-list ui-sortable"><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(silverMember.benefits, VIP_TABLE)" ng-click="silverMemberBenefitsChanged(\'VIP_TABLE\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': silverMemberBenefitVipTable === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Can book VIP<stran stext="resource" type="p"></stran></span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(silverMember.benefits, WAIT_PRIORITY)" ng-click="silverMemberBenefitsChanged(\'WAIT_PRIORITY\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': silverMemberBenefitWaitPriority === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has priority on waiting list</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(silverMember.benefits, FAVORITE_TABLE)" ng-click="silverMemberBenefitsChanged(\'FAVORITE_TABLE\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': silverMemberBenefitFavoriteTable === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has favorite<stran stext="resource" type="s"></stran>&nbsp;available</span></li></ul></div></div></div></div></div></uib-tab><uib-tab ng-click="activeTab(\'gold\')"><uib-tab-heading class="text-center">Gold member<div class="profile-stars"><span ng-if="!goldActive"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star-o"></i> </span><span ng-if="goldActive"><i class="fa fa-star text-warning"></i><i class="fa fa-star text-warning"></i><i class="fa fa-star text-warning"></i><i class="fa fa-star text-warning"></i><i class="fa fa-star-o text-warning"></i></span></div></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><br><p>Gold member membership will be assigned to customers automatically when defined threshold is reached.<br>Please define parameters for "Gold member" membership type.</p><br></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Status name</label><div class="col-md-4" ng-class="{ \'has-error\': formGroups.goldMemberName.$invalid}"><input class="form-control" required ng-maxlength="32" type="text" ng-model="data.goldMember.name" name="goldMemberName"></div><div class="validation-error" ng-show="formGroups.goldMemberName.$invalid"><div ng-messages="formGroups.goldMemberName.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 32 characters.</div></div></div></div></div><div class="row"><div class="form-group m-t-lg ng-scope"><label class="col-lg-2 col-md-3 control-label">Points threshold</label><div class="col-md-4" ng-class="{ \'has-error\': goldMemberThresholdProblem}"><input name="goldMemberThresholdDirty" ng-model="data.goldMember.threshold" class="form-control input-sm ng-pristine ng-untouched ng-valid ng-valid-min ng-valid-required" required ng-min="0" type="number" ng-change="thresholdChanged(\'goldMember\')"><div ng-if="goldMemberThresholdProblem" class="text-danger">Gold member threshold should be bigger than Silver member threshold ({{data.silverMember.threshold}}) and smaller than Platinum member threshold ({{data.platinumMember.threshold}}).</div></div></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Benefits</label><div class="col-md-4"><ul class="todo-list ui-sortable"><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(goldMember.benefits, VIP_TABLE)" ng-click="goldMemberBenefitsChanged(\'VIP_TABLE\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': goldMemberBenefitVipTable === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Can book VIP<stran stext="resource" type="p"></stran></span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(goldMember.benefits, WAIT_PRIORITY)" ng-click="goldMemberBenefitsChanged(\'WAIT_PRIORITY\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': goldMemberBenefitWaitPriority === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has priority on waiting list</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(goldMember.benefits, FAVORITE_TABLE)" ng-click="goldMemberBenefitsChanged(\'FAVORITE_TABLE\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': goldMemberBenefitFavoriteTable === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has favorite<stran stext="resource" type="s"></stran>&nbsp;available</span></li></ul></div></div></div></div></div></uib-tab><uib-tab ng-click="activeTab(\'platinum\')"><uib-tab-heading class="text-center">Platinum member<div class="profile-stars"><span ng-if="!platinumActive"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i> </span><span ng-if="platinumActive"><i class="fa fa-star text-warning"></i><i class="fa fa-star text-warning"></i><i class="fa fa-star text-warning"></i><i class="fa fa-star text-warning"></i><i class="fa fa-star text-warning"></i></span></div></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><br><p>Platinum member membership will be assigned to customers automatically when defined threshold is reached.<br>Please define parameters for "Platinum member" membership type.</p><br></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Status name</label><div class="col-md-4" ng-class="{ \'has-error\': formGroups.platinumMemberName.$invalid}"><input class="form-control" required ng-maxlength="32" type="text" ng-model="data.platinumMember.name" name="platinumMemberName"></div><div class="validation-error" ng-show="formGroups.platinumMemberName.$invalid"><div ng-messages="formGroups.platinumMemberName.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 32 characters.</div></div></div></div></div><div class="row"><div class="form-group m-t-lg ng-scope"><label class="col-lg-2 col-md-3 control-label">Points threshold</label><div class="col-md-4" ng-class="{ \'has-error\': platinumMemberThresholdProblem}"><input name="platinumMemberThresholdDirty" ng-model="data.platinumMember.threshold" class="form-control input-sm ng-pristine ng-untouched ng-valid ng-valid-min ng-valid-required" required ng-min="0" type="number" ng-change="thresholdChanged(\'platinumMember\')"><div ng-if="platinumMemberThresholdProblem" class="text-danger">Platinum member threshold should be bigger than Gold member threshold ({{data.goldMember.threshold}}).</div></div></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Benefits</label><div class="col-md-4"><ul class="todo-list ui-sortable"><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(platinumMember.benefits, VIP_TABLE)" ng-click="platinumMemberBenefitsChanged(\'VIP_TABLE\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': platinumMemberBenefitVipTable === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Can book VIP<stran stext="resource" type="p"></stran></span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(platinumMember.benefits, WAIT_PRIORITY)" ng-click="platinumMemberBenefitsChanged(\'WAIT_PRIORITY\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': platinumMemberBenefitWaitPriority === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has priority on waiting list</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size === \'default\', \'btn-sm\': size === \'large\', \'btn-lg\': size === \'largest\'}" ng-model="data.multiselect(platinumMember.benefits, FAVORITE_TABLE)" ng-click="platinumMemberBenefitsChanged(\'FAVORITE_TABLE\')" ng-model-options="{getterSetter: true}"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': platinumMemberBenefitFavoriteTable === true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has favorite<stran stext="resource" type="s"></stran>&nbsp;available</span></li></ul></div></div></div></div></div></uib-tab></uib-tabset></div></form></div></div></div></div></div></div>');
$templateCache.put('app/settings/notification/notification.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12 col-md-10"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Notification messages customization</h2>Customize notification messages to better reflect your style of communication with your customers.</div><div class="panel-body"><div class="row"><div class="col-lg-12 text-right"><button ng-disabled="formGroups.emailContact.$error.email" aria-pressed="false" data-toggle="button" class="btn btn-primary btn-lg" type="button" ng-click="saveData()">Save notification settings</button></div></div><div class="row"><div class="col-lg-12"><h4>Contact details</h4><small>Contact detail\'s defined here will be displayed in notification messages sent to your customers.</small><br><br></div></div><form name="formGroups"><div class="row"><div class="col-lg-4"><div class="input-group m-b" ng-class="{ \'has-error\': formGroups.emailContact.$error.email}"><label class="input-group-addon" for="emailContact">@</label><input id="emailContact" name="emailContact" ng-model="data.emailContact" ng-maxlength="128" maxlength="128" class="form-control" placeholder="Enter contact email address" type="email" validate-email></div></div></div><div class="row"><div class="col-lg-4"><div class="input-group m-b"><label class="input-group-addon" for="phoneContact"><i class="fa fa-phone"></i></label><input id="phoneContact" name="phoneContact" ng-model="data.phoneContact" class="form-control" ng-maxlength="20" maxlength="20" ui-options="{clearOnBlur: true}" model-view-value="true" placeholder="Enter contact phone number" type="text"></div></div></div><div class="row"><div class="col-lg-4"><div class="input-group m-b"><label class="input-group-addon" for="phoneContact"><i class="fa fa-globe"></i></label><input id="webContact" name="webContact" ng-model="data.webContact" ng-maxlength="128" maxlength="128" class="form-control" placeholder="Enter your web page address" type="text"></div></div></div><br><div class="row"><div class="col-sm-12"><uib-tabset><uib-tab><uib-tab-heading class="text-center">Reservation</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-bolt text-warning"></i>&nbsp;Verification message</h5><small>This message will be sent to customer email to verify online reservation request.</small><small ng-show="isEU!=true">&nbsp;Please note, in case of IVR reservation standard text message will be sent to customer phone to verify reservation request.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1"><span class="text-success">Please note: verification message will not be sent if automatic<stran stext="resource" type="s"></stran>&nbsp;assignment is activated and the<stran stext="resource" type="s"></stran>&nbsp;is assigned to the reservation. In this case, the system will send a confirmation message to a customer.</span><br><br></div></div><div class="row"><div class="col-lg-offset-1"><select ng-model="data.reservationVerification.messageCondition" ng-options="obj.value as obj.text for obj in verificationCondition"></select></div></div><br><div class="row"><div class="col-lg-offset-1"><checkbox type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.reservationVerification.allowCancelButton"></checkbox>&nbsp;&nbsp;Allow customer to cancel reservation via cancel button in verification email.</div></div><br><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.reservationVerification.$invalid}"><textarea name="reservationVerification" class="form-control" type="text" rows="6" style="width: 80%" ng-model="data.reservationVerification.messageText" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.reservationVerification.$invalid"><div ng-messages="formGroups.reservationVerification.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="data.reservationVerification.messageText == \'\' || !data.reservationVerification.messageText">0/2048</div><div ng-if="data.reservationVerification.messageText != \'\' && data.reservationVerification.messageText">{{data.reservationVerification.messageText.length}}/2048</div><div><button type="submit" class="btn btn-sm btn-success btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showReservationVerificationDialog()"><i class="fa fa-external-link"></i> Preview reservation verification email</button></div></div></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-check text-navy"></i>&nbsp;Confirmation message</h5><small>This message will be sent to the customer email as a confirmation that a reservation is processed successfully, and<stran stext="resource"></stran>&nbsp;reserved as requested.</small><small ng-show="isEU!=true"> Please note, in case of IVR reservation, a standard text message will be sent to customer phone to confirm reservation.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1"><checkbox type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.reservationConfirmation.messageAllowed"></checkbox>&nbsp;&nbsp;Enable confirmation messages.</div></div><div class="row" ng-show="isEU!=true"><br><div class="col-lg-offset-1">Confirmation to be sent via:<select ng-model="data.reservationConfirmation.messageChannel" ng-options="obj.value as obj.text disable when obj.disabled for obj in confirmationChannels"></select><button ng-show="vm.isFree" class="btn btn-xs btn-danger" ng-click="vm.openWindow()" target="_blank">{{::vm.confirmationSubscribeText()}}</button><br><small class="text-info" ng-show="data.reservationConfirmation.messageChannel==\'EMAIL\' && (vm.isStandard || vm.isProfessional)">Note: Text confirmation will be sent for IVR reservations even if you choose to send reminders via email.</small></div></div><br><div class="row"><div class="col-lg-offset-1"><checkbox type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.reservationConfirmation.allowCancelButton"></checkbox>&nbsp;&nbsp;Allow customer to cancel reservation via cancel button in confirmation email.</div></div><br><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.reservationConfirmation.$invalid}"><textarea name="reservationConfirmation" class="form-control" type="text" rows="6" style="width: 80%" ng-model="data.reservationConfirmation.messageText" ng-required="data.reservationConfirmation.messageAllowed" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.reservationConfirmation.$invalid"><div ng-messages="formGroups.reservationConfirmation.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="data.reservationConfirmation.messageText == \'\' || !data.reservationConfirmation.messageText">0/2048</div><div ng-if="data.reservationConfirmation.messageText != \'\' && data.reservationConfirmation.messageText">{{data.reservationConfirmation.messageText.length}}/2048</div><div><button type="submit" class="btn btn-sm btn-success btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showReservationConfirmDialog()"><i class="fa fa-external-link"></i> Preview reservation confirmation email</button></div></div></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-bell text-warning"></i>&nbsp;Reminder message</h5><small ng-show="isEU!=true">This message will be sent to remind a customer about an upcoming reservation. Communication channel (email or text) depends on your choice and subscription tier.</small> <small ng-show="isEU==true">This e-mail message will be sent to remind customer on about upcoming reservation.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.reservationReminder.messageAllowed"></checkbox>&nbsp;&nbsp;Enable reminder messages.</div></div><div class="row" ng-show="isEU!=true || (isEU && vm.locationId==\'100053\') || (isEU && vm.locationId==\'1\')"><br><div class="col-lg-offset-1">Reminder to be sent via:<select ng-model="data.reservationReminder.messageChannel" ng-options="obj.value as obj.text disable when obj.disabled for obj in reminderChannels"></select><button ng-show="vm.isFree" class="btn btn-xs btn-danger" ng-click="vm.openWindow()" target="_blank">{{::vm.reminderSubscribeText()}}</button><br><small class="text-info" ng-show="data.reservationReminder.messageChannel==\'EMAIL\' && (vm.isStandard || vm.isProfessional)">Note: Text reminder will be sent for IVR reservations even you choose to send reminders via email.</small></div></div><div class="row"><br><div class="col-lg-offset-1">Send reminder to a customer<select ng-model="data.reservationReminder.messageTime" ng-options="obj.timeForDB as obj.time for obj in availableTimesForReservationReminder"></select>&nbsp;&nbsp;before the event.</div></div><br><div class="row"><div class="col-lg-offset-1"><checkbox type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.reservationReminder.allowCancelButton"></checkbox>&nbsp;&nbsp;Allow customer to cancel reservation via cancel button in reminder email.</div></div><br><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.reservationReminder.$invalid}"><textarea name="reservationReminder" class="form-control" type="text" rows="6" style="width: 80%" ng-model="data.reservationReminder.messageText" ng-required="data.reservationReminder.messageAllowed" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.reservationReminder.$invalid"><div ng-messages="formGroups.reservationReminder.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="data.reservationReminder.messageText == \'\' || !data.reservationReminder.messageText">0/2048</div><div ng-if="data.reservationReminder.messageText != \'\' && data.reservationReminder.messageText">{{data.reservationReminder.messageText.length}}/2048</div><div><button type="submit" class="btn btn-sm btn-success btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showReservationReminderDialog()"><i class="fa fa-external-link"></i> Preview reservation reminder email</button></div></div></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-bell text-warning"></i>&nbsp;Cancellation message</h5><small>This message will be sent to customer when you or your employees cancel a reservation.</small><small ng-show="isEU!=true"> Please note, in case of IVR reservation, due to limited message size, standard cancellation text message will be sent to the customer phone.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.reservationCancel.messageAllowed"></checkbox>&nbsp;&nbsp;Enable cancellation messages.</div></div><div class="row"><div class="col-lg-offset-1"><checkbox type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.reservationCancel.askFeedback"></checkbox>&nbsp;&nbsp;Enable message personalization before sending (Pop up window will be displayed when cancel action is activated).</div></div><br><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.reservationCancel.$invalid}"><textarea name="reservationCancel`" class="form-control" type="text" rows="6" style="width: 80%" ng-model="data.reservationCancel.messageText" ng-required="data.reservationCancel.messageAllowed" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.reservationCancel.$invalid"><div ng-messages="formGroups.reservationCancel.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="data.reservationCancel.messageText == \'\' || !data.reservationCancel.messageText">0/2048</div><div ng-if="data.reservationCancel.messageText != \'\' && data.reservationCancel.messageText">{{data.reservationCancel.messageText.length}}/2048</div><div><button type="submit" class="btn btn-sm btn-success btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showReservationCancelDialog()"><i class="fa fa-external-link"></i> Preview reservation cancel email</button></div></div></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-pencil text-warning"></i>&nbsp;Update message</h5><small>This message will be sent to customer if one of the employees updates an existing reservation.</small><small ng-show="isEU!=true"> Please note, in case of IVR reservation, due to limited message size, standard update message will be sent to the customer phone.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.reservationUpdate.messageAllowed"></checkbox>&nbsp;&nbsp;Enable update messages.</div></div><div class="row"><div class="col-lg-offset-1"><checkbox type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.reservationUpdate.askFeedback"></checkbox>&nbsp;&nbsp;Enable message personalization before sending (Pop up window will be displayed when you update a reservation).</div></div><br><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.reservationUpdate.$invalid}"><textarea name="reservationUpdate`" class="form-control" type="text" rows="6" style="width: 80%" ng-model="data.reservationUpdate.messageText" ng-required="data.reservationUpdate.messageAllowed" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.reservationUpdate.$invalid"><div ng-messages="formGroups.reservationUpdate.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="data.reservationUpdate.messageText == \'\' || !data.reservationUpdate.messageText">0/2048</div><div ng-if="data.reservationUpdate.messageText != \'\' && data.reservationUpdate.messageText">{{data.reservationUpdate.messageText.length}}/2048</div><div><button type="submit" class="btn btn-sm btn-success btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showReservationUpdateDialog()"><i class="fa fa-external-link"></i> Preview reservation update email</button></div></div></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-heart text-danger"></i>&nbsp;Thank you email message</h5><small>This message will be sent to a customer next day after customer\'s visit ends.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.reservationThankYou.messageAllowed"></checkbox>&nbsp;&nbsp;Enable thank you messages.</div></div><div class="row"><div class="col-lg-offset-1"><checkbox type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.reservationThankYou.askFeedback"></checkbox>&nbsp;&nbsp;Ask customer to provide feedback for visit.</div></div><br><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.reservationThankYou.$invalid}"><textarea name="reservationThankYou" class="form-control" type="text" rows="6" style="width: 80%" ng-model="data.reservationThankYou.messageText" ng-required="data.reservationThankYou.messageAllowed" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.reservationThankYou.$invalid"><div ng-messages="formGroups.reservationThankYou.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="data.reservationThankYou.messageText == \'\' || !data.reservationThankYou.messageText">0/2048</div><div ng-if="data.reservationThankYou.messageText != \'\' && data.reservationThankYou.messageText">{{data.reservationThankYou.messageText.length}}/2048</div><div><button type="submit" class="btn btn-sm btn-success btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showReservationThankYouDialog()"><i class="fa fa-external-link"></i> Preview reservation thank you email</button></div></div></div></div></div></div></div></div><br></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Waitlist</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-check text-navy"></i>&nbsp;Added to waitlist<span ng-show="!isEU"> text</span> message</h5><small ng-show="!isEU">Phone text message will be sent when a customer is added to a waitlist.</small> <small ng-show="isEU">Message will be sent when customer is added to waitlist.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.waitlistAdded.$invalid}"><textarea name="waitlistAdded" class="form-control" type="text" rows="6" style="width: 80%" ng-model="data.waitlistAdded.messageText" required ng-maxlength="80" maxlength="80"></textarea><div class="validation-error" ng-show="formGroups.waitlistAdded.$invalid"><div ng-messages="formGroups.waitlistAdded.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 80 characters.</div></div></div><div ng-if="data.waitlistAdded.messageText == \'\' || !data.waitlistAdded.messageText">0/80</div><div ng-if="data.waitlistAdded.messageText != \'\' && data.waitlistAdded.messageText">{{data.waitlistAdded.messageText.length}}/80</div><div><button type="submit" class="btn btn-sm btn-info btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showWaitlistAddToDialog()"><i class="fa fa-external-link"></i> Preview added to waitlist<span ng-show="!isEU"> text</span> message</button></div></div></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-bell text-success"></i>&nbsp;<stran stext="resource" type="sc"></stran>&nbsp;is available<span ng-show="!isEU"> text</span> message</h5><small ng-show="!isEU">A phone text message will be sent to notify a customer that a<stran stext="resource" type="s"></stran>&nbsp;is waiting.</small> <small ng-show="isEU">Message will be sent to notify customer that<stran stext="resource" type="s"></stran>&nbsp;is waiting.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.waitlistTableAvailable.$invalid}"><textarea name="waitlistTableAvailable" class="form-control" type="text" rows="6" style="width: 80%" ng-model="data.waitlistTableAvailable.messageText" required ng-maxlength="80" maxlength="80"></textarea><div class="validation-error" ng-show="formGroups.waitlistTableAvailable.$invalid"><div ng-messages="formGroups.waitlistTableAvailable.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 80 characters.</div></div></div><div ng-if="data.waitlistTableAvailable.messageText == \'\' || !data.waitlistTableAvailable.messageText">0/80</div><div ng-if="data.waitlistTableAvailable.messageText != \'\' && data.waitlistTableAvailable.messageText">{{data.waitlistTableAvailable.messageText.length}}/80</div><div><button type="submit" class="btn btn-sm btn-info btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showWaitlistNotifyDialog()"><i class="fa fa-external-link"></i> Preview waitlist<stran stext="resource" type="s"></stran>&nbsp;is available<span ng-show="!isEU"> text</span> message</button></div></div></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-heart text-danger"></i>&nbsp;Thank you email message</h5><small>This message will be sent to a customer email some time after the customer\'s visit ends.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.waitlistThankYou.messageAllowed"></checkbox>&nbsp;&nbsp;Send thank you message to customer.</div></div><div class="row"><div class="col-lg-offset-1"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="$parent.$parent.data.waitlistThankYou.askFeedback"></checkbox>&nbsp;&nbsp;Ask customer to provide feedback for visit.</div></div><br><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.waitlistThankYou.$invalid}"><textarea name="waitlistThankYou" class="form-control" type="text" rows="6" style="width: 80%" ng-model="data.waitlistThankYou.messageText" ng-required="data.waitlistThankYou.messageAllowed" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.waitlistThankYou.$invalid"><div ng-messages="formGroups.waitlistThankYou.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="data.waitlistThankYou.messageText == \'\' || !data.waitlistThankYou.messageText">0/2048</div><div ng-if="data.waitlistThankYou.messageText != \'\' && data.waitlistThankYou.messageText">{{data.waitlistThankYou.messageText.length}}/2048</div><div><button type="submit" class="btn btn-sm btn-success btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showWaitlistThankYouDialog()"><i class="fa fa-external-link"></i> Preview waitlist thank you message</button></div></div></div></div></div></div></div></div><br></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Look and Feel</uib-tab-heading><div class="panel panel-default"><div class="panel-body" style="background-color: #efefef; padding-top:25px"><div class="row" ng-if="!vm.isProfessional"><div class="col-lg-12"><div class="widget gray-bg text-center"><h4 class="text-bold">Customize the look and feel of email notifications that are sent to customers. Edit fonts, colors and upload your custom images.</h4><br><button class="btn btn-danger" ng-click="vm.openWindow()" target="_blank">Upgrade to PROFESSIONAL plan to activate this functionality.</button><br><img src="content/images/email_customization_locked.png" class="img-responsive"></div></div></div><div class="row" ng-if="vm.isProfessional"><div class="col-lg-4 col-lg-offset-1" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="row" style="color: {{vm.lnf.headerTextColor}}; font-family:{{vm.lnf.headerFontFamily}}"><div class="col-lg-12 text-center" style="background-image: url(\'{{vm.lnf.headerBackgroundImage}}?cacheBuster={{vm.imageCacheBuster}}\')"><h1 class="font-bold" style="font-size: {{vm.lnf.headerNameFontSize}}px">{{getLocationName()}}</h1><span style="font-size : {{vm.lnf.headerAddressFontSize}}px">{{getLocationAddress()}}</span><br><br></div></div><div class="row"><div class="col-lg-12"><br><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Your reservation is confirmed!</strong></span><br><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Dear John Doe,<br><br><span>{{data.reservationConfirmation.messageText}}</span></span><br><br></div></div><div class="row"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyReservationDetailsImage}}?cacheBuster={{vm.imageCacheBuster}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Reservation details</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Reservation code: <strong>8EDB3927</strong><br>Visit date: <strong>{{getDate(-1)}} 11:00:00 AM</strong><br>Party size: <strong>4 person(s)</strong><br></span></div></div><div class="row"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyCancelImage}}?cacheBuster={{vm.imageCacheBuster}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Cancel Reservation</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Please press the cancel button if you want to cancel the reservation.<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="background-color: #b72c32; border: none; color: #FFF; padding: 4px; font-size: 12px; text-align: center; text-decoration: none; display: inline-block; border-radius: 8px">CANCEL RESERVATION</span></span></div></div><div class="row"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyFeedbackImage}}?cacheBuster={{vm.imageCacheBuster}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>We love feedback</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Share your experience with us. Help us find out what we do well, and what could be improved.</span><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="background-color: #70b755; border: none; color: #FFF; padding: 10px; font-size: 14px; text-align: center; text-decoration: none; display: inline-block; border-radius: 8px">LEAVE FEEDBACK</span></div></div><div class="row"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyContactImage}}?cacheBuster={{vm.imageCacheBuster}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Contact Us</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Please contact us in case of any other modification of the reservation.<br><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.phoneContact}}<br><a href="mailto:{{data.emailContact}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.emailContact}}</a><br></span></div></div><div class="row"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-12 text-center preview-footer"><a href="https://www.seaton.site" target="_blank"><small class="text-white font-bold text-center">Powered by SeatOn platform</small></a></div></div></div><div class="col-lg-4"><h3 class="font-bold">Customize email header</h3><br><div class="row"><div class="col-lg-6"><h4>Title font size</h4><select class="form-control" ng-model="vm.lnf.headerNameFontSize" ng-options="size.value as size.text for size in textSizes"></select></div><div class="col-lg-6"><h4>Subtitle font size</h4><select class="form-control" ng-model="vm.lnf.headerAddressFontSize" ng-options="size.value as size.text for size in textSizes"></select></div></div><br><div class="row"><div class="col-lg-6"><h4>Text color</h4><input type="text" color-picker color-picker-model="vm.lnf.headerTextColor" ng-model="vm.lnf.headerTextColor" class="form-control" name="lnf.headerTextColor" required color-picker-show-cancel-button="true" color-picker-position="right" color-picker-output-format="\'hex\'" ng-style="{background:vm.lnf.headerTextColor}" style="color: lightgray" readonly="readonly"></div><div class="col-lg-6"><h4>Font</h4><select class="form-control" ng-model="vm.lnf.headerFontFamily" ng-options="font.value as font.text for font in fonts"></select></div></div><br><h4>Background image (PNG, JPG, GIF)</h4><p>Recommended width and height: 600 x 130 pixels (max file size: 500 kB)<br></p><div class="row"><div class="col-lg-12"><input class="form-control" type="file" id="headerBkgImage" onchange="document.querySelector(\'#headerBkgImageUploadBtn\').click();" name="file" accept="image/jpeg, image/gif, image/png"> <button ng-show="false" id="headerBkgImageUploadBtn" class="btn btn-success" ng-click="upload(\'headerBkgImage\', \'HEADER_BKG\')"></button></div></div><br><br><h3 class="font-bold">Customize email body</h3><br><div class="row"><div class="col-lg-6"><h4>Title font size</h4><select class="form-control" ng-model="vm.lnf.bodyTitleFontSize" ng-options="size.value as size.text for size in textSizes"></select></div><div class="col-lg-6"><h4>Body font size</h4><select class="form-control" ng-model="vm.lnf.bodyMsgFontSize" ng-options="size.value as size.text for size in textSizes"></select></div></div><div class="row"><div class="col-lg-6"><h4>Text color</h4><input type="text" color-picker color-picker-model="vm.lnf.bodyTextColor" ng-model="vm.lnf.bodyTextColor" class="form-control" name="lnf.bodyTextColor" required color-picker-show-cancel-button="true" color-picker-position="right" color-picker-output-format="\'hex\'" ng-style="{background:vm.lnf.bodyTextColor}" style="color: lightgray" readonly="readonly"></div><div class="col-lg-6"><h4>Background color</h4><input type="text" color-picker color-picker-model="vm.lnf.bodyBackgroundColor" ng-model="vm.lnf.bodyBackgroundColor" class="form-control" name="lnf.bodyBackgroundColor" required color-picker-show-cancel-button="true" color-picker-position="right" color-picker-output-format="\'hex\'" ng-style="{background:vm.lnf.bodyBackgroundColor}" style="color: lightgray" readonly="readonly"></div></div><div class="row"><div class="col-lg-6"><h4>Font</h4><select class="form-control" ng-model="vm.lnf.bodyFontFamily" ng-options="font.value as font.text for font in fonts"></select></div></div><br><h4>Reservation details image (PNG, JPG, GIF)</h4><p>Recommended width and height: 170 x 90 pixels (max file size: 500 kB)<br></p><div class="row"><div class="col-lg-12"><input class="form-control" type="file" id="resDetailsImage" onchange="document.querySelector(\'#resDetailsImageUploadBtn\').click();" name="file" accept="image/jpeg, image/gif, image/png"> <button ng-show="false" id="resDetailsImageUploadBtn" class="btn btn-success" ng-click="upload(\'resDetailsImage\', \'RES_DETAILS\')"></button></div></div><br><h4>Cancel image (PNG, JPG, GIF)</h4><p>Recommended width and height: 170 x 90 pixels (max file size: 500 kB)<br></p><div class="row"><div class="col-lg-12"><input class="form-control" type="file" id="cancelImage" onchange="document.querySelector(\'#cancelImageUploadBtn\').click();" name="file" accept="image/jpeg, image/gif, image/png"> <button ng-show="false" id="cancelImageUploadBtn" class="btn btn-success" ng-click="upload(\'cancelImage\', \'CANCEL\')"></button></div></div><br><h4>Feedback image (PNG, JPG, GIF)</h4><p>Recommended width and height: 170 x 90 pixels (max file size: 500 kB)<br></p><div class="row"><div class="col-lg-12"><input class="form-control" type="file" id="feedbackImage" onchange="document.querySelector(\'#feedbackImageUploadBtn\').click();" name="file" accept="image/jpeg, image/gif, image/png"> <button ng-show="false" id="feedbackImageUploadBtn" class="btn btn-success" ng-click="upload(\'feedbackImage\', \'FEEDBACK\')"></button></div></div><br><h4>Contact image (PNG, JPG, GIF)</h4><p>Recommended width and height: 170 x 90 pixels (max file size: 500 kB)<br></p><div class="row"><div class="col-lg-12"><input class="form-control" type="file" id="contactImage" onchange="document.querySelector(\'#contactImageUploadBtn\').click();" name="file" accept="image/jpeg, image/gif, image/png"> <button ng-show="false" id="contactImageUploadBtn" class="btn btn-success" ng-click="upload(\'contactImage\', \'CONTACT\')"></button></div></div><br><div class="row"><div class="col-lg-12"><br><button aria-pressed="false" data-toggle="button" class="btn btn-warning btn-lg btn-block" type="button" ng-click="restoreLnfSettings()">Restore default settings</button></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></form></div></div></div></div></div>');
$templateCache.put('app/settings/notification/reservation.cancel.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeReservationCancelDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Reservation cancellation email preview</h3></div><div class="modal-body" style="background-color: #efefef"><div class="row" style="color: {{vm.lnf.headerTextColor}}; font-family:{{vm.lnf.headerFontFamily}}"><div class="col-lg-12 text-center" style="background-image: url(\'{{vm.lnf.headerBackgroundImage}}\')"><h1 class="font-bold" style="font-size: {{vm.lnf.headerNameFontSize}}px">{{getLocationName()}}</h1><span style="font-size : {{vm.lnf.headerAddressFontSize}}px">{{getLocationAddress()}}</span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>We cannot accommodate your reservation request.</strong></span><br><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Dear John Doe,<br><br><span ng-bind-html="data.reservationCancel.messageText"></span></span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyReservationDetailsImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Reservation details</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Reservation code: <strong>8EDB3927</strong><br>Visit date: <strong>{{getDate(-1)}} 11:00:00 AM</strong><br>Party size: <strong>4 person(s)</strong><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyContactImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Contact us</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Please contact us in case of any questions.<br><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.phoneContact}}<br><a href="mailto:{{data.emailContact}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.emailContact}}</a><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-12 text-center preview-footer"><a href="https://www.seaton.site" target="_blank"><small class="text-white font-bold text-center">Powered by SeatOn platform</small></a></div></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeReservationCancelDialog()">Close</button></div>');
$templateCache.put('app/settings/notification/reservation.confirm.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeReservationConfirmationDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Reservation confirmation email preview</h3></div><div class="modal-body" style="background-color: #efefef"><div class="row" style="color: {{vm.lnf.headerTextColor}}; font-family:{{vm.lnf.headerFontFamily}}"><div class="col-lg-12 text-center" style="background-image: url(\'{{vm.lnf.headerBackgroundImage}}\')"><h1 class="font-bold" style="font-size: {{vm.lnf.headerNameFontSize}}px">{{getLocationName()}}</h1><span style="font-size : {{vm.lnf.headerAddressFontSize}}px">{{getLocationAddress()}}</span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Your reservation is confirmed!</strong></span><br><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Dear John Doe,<br><br><span ng-bind-html="data.reservationConfirmation.messageText"></span></span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyReservationDetailsImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Reservation details</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Reservation code: <strong>8EDB3927</strong><br>Visit date: <strong>{{getDate(-1)}} 11:00:00 AM</strong><br>Party size: <strong>4 person(s)</strong><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}" ng-show="data.reservationConfirmation.allowCancelButton"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyCancelImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Cancel Reservation</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Please press the cancel button if you want to cancel the reservation<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="background-color: #b72c32; border: none; color: #FFF; padding: 4px; font-size: 12px; text-align: center; text-decoration: none; display: inline-block; border-radius: 8px"> CANCEL RESERVATION</span></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}" ng-show="data.reservationConfirmation.allowCancelButton"><div class="col-lg-12"><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyContactImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Contact us</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Please contact us in case of any other modification of the reservation.<br><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.phoneContact}}<br><a href="mailto:{{data.emailContact}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.emailContact}}</a><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-12 text-center preview-footer"><a href="https://www.seaton.site" target="_blank"><small class="text-white font-bold text-center">Powered by SeatOn platform</small></a></div></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeReservationConfirmationDialog()">Close</button></div>');
$templateCache.put('app/settings/notification/reservation.reminder.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeReservationReminderDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Reservation reminder email preview</h3></div><div class="modal-body" style="background-color: #efefef"><div class="row" style="color: {{vm.lnf.headerTextColor}}; font-family:{{vm.lnf.headerFontFamily}}"><div class="col-lg-12 text-center" style="background-image: url(\'{{vm.lnf.headerBackgroundImage}}\')"><h1 class="font-bold" style="font-size: {{vm.lnf.headerNameFontSize}}px">{{getLocationName()}}</h1><span style="font-size : {{vm.lnf.headerAddressFontSize}}px">{{getLocationAddress()}}</span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Your table is waiting for you!</strong></span><br><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Dear John Doe,<br><br><span ng-bind-html="data.reservationReminder.messageText"></span></span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyReservationDetailsImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Reservation details</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Reservation code: <strong>8EDB3927</strong><br>Visit date: <strong>{{getDate(-1)}} 11:00:00 AM</strong><br>Party size: <strong>4 person(s)</strong><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}" ng-show="data.reservationReminder.allowCancelButton"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyCancelImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Cancel Reservation</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Please press the cancel button if you want to cancel the reservation<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="background-color: #b72c32; border: none; color: #FFF; padding: 4px; font-size: 12px; text-align: center; text-decoration: none; display: inline-block; border-radius: 8px"> CANCEL RESERVATION</span></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}" ng-show="data.reservationReminder.allowCancelButton"><div class="col-lg-12"><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyContactImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Contact us</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Please contact us in case of any other modification of the reservation.<br><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.phoneContact}}<br><a href="mailto:{{data.emailContact}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.emailContact}}</a><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-12 text-center preview-footer"><a href="https://www.seaton.site" target="_blank"><small class="text-white font-bold text-center">Powered by SeatOn platform</small></a></div></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeReservationReminderDialog()">Close</button></div>');
$templateCache.put('app/settings/notification/reservation.thankyou.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeReservationThankYouDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Reservation thank you email preview</h3></div><div class="modal-body" style="background-color: #efefef"><div class="row" style="color: {{vm.lnf.headerTextColor}}; font-family:{{vm.lnf.headerFontFamily}}"><div class="col-lg-12 text-center" style="background-image: url(\'{{vm.lnf.headerBackgroundImage}}\')"><h1 class="font-bold" style="font-size: {{vm.lnf.headerNameFontSize}}px">{{getLocationName()}}</h1><span style="font-size : {{vm.lnf.headerAddressFontSize}}px">{{getLocationAddress()}}</span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Thank you for your recent visit!</strong></span><br><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Dear John Doe,<br><br><span ng-bind-html="data.reservationThankYou.messageText"></span></span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}" ng-show="data.reservationThankYou.askFeedback"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyFeedbackImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>We love feedback</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Share your experience with us. Help us find out what we do well, and what could be improved.<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="background-color: #70b755; border: none; color: #FFF; padding: 10px; font-size: 14px; text-align: center; text-decoration: none; display: inline-block; border-radius: 8px"> LEAVE FEEDBACK</span></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}" ng-show="data.reservationThankYou.askFeedback"><div class="col-lg-12"><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyReservationDetailsImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Visit details</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Visit date: <strong>{{getDate(-1)}} 11:00:00 AM</strong><br>Party size: <strong>4 person(s)</strong><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyContactImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Contact us</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Please contact us if case of any question.<br><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.phoneContact}}<br><a href="mailto:{{data.emailContact}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.emailContact}}</a><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-12 text-center preview-footer"><a href="https://www.seaton.site" target="_blank"><small class="text-white font-bold text-center">Powered by SeatOn platform</small></a></div></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeReservationThankYouDialog()">Close</button></div>');
$templateCache.put('app/settings/notification/reservation.update.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeReservationUpdateDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Reservation update email preview</h3></div><div class="modal-body" style="background-color: #efefef"><div class="row" style="color: {{vm.lnf.headerTextColor}}; font-family:{{vm.lnf.headerFontFamily}}"><div class="col-lg-12 text-center" style="background-image: url(\'{{vm.lnf.headerBackgroundImage}}\')"><h1 class="font-bold" style="font-size: {{vm.lnf.headerNameFontSize}}px">{{getLocationName()}}</h1><span style="font-size : {{vm.lnf.headerAddressFontSize}}px">{{getLocationAddress()}}</span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Your reservation has been updated.</strong></span><br><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Dear John Doe,<br><br><span ng-bind-html="data.reservationUpdate.messageText"></span></span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyReservationDetailsImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Reservation details</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Reservation code: <strong>8EDB3927</strong><br><br>Original visit date: <strong>{{getDate(-1)}} 11:00:00 AM</strong><br>Original party size: <strong>4 person(s)</strong><br><br>New visit date: <strong>{{getDate(0)}} 01:00:00 PM</strong><br>New party size: <strong>5 person(s)</strong><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyContactImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Contact us</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Please contact us in case of any questions.<br><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.phoneContact}}<br><a href="mailto:{{data.emailContact}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.emailContact}}</a><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-12 text-center preview-footer"><a href="https://www.seaton.site" target="_blank"><small class="text-white font-bold text-center">Powered by SeatOn platform</small></a></div></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeReservationUpdateDialog()">Close</button></div>');
$templateCache.put('app/settings/notification/reservation.verification.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeReservationVerificationDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Online reservation verification email preview</h3></div><div class="modal-body" style="background-color: #efefef"><div class="row" style="color: {{vm.lnf.headerTextColor}}; font-family:{{vm.lnf.headerFontFamily}}"><div class="col-lg-12 text-center" style="background-image: url(\'{{vm.lnf.headerBackgroundImage}}\')"><h1 class="font-bold" style="font-size: {{vm.lnf.headerNameFontSize}}px">{{getLocationName()}}</h1><span style="font-size : {{vm.lnf.headerAddressFontSize}}px">{{getLocationAddress()}}</span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>We have received your reservation request!</strong></span><br><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Dear John Doe,<br><br><span ng-bind-html="data.reservationVerification.messageText"></span><br><br>Please press the following button to verify the reservation details are correct for your request.<br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="background-color: #8FB73C; border: none; color: #FFF; padding: 10px; font-size: 14px; text-align: center; text-decoration: none; display: inline-block; border-radius: 8px">VERIFY</span></span><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyReservationDetailsImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Reservation details</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Reservation code: <strong>8EDB3927</strong><br>Visit date: <strong>{{getDate(-1)}} 11:00:00 AM</strong><br>Party size: <strong>4 person(s)</strong><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}" ng-show="data.reservationVerification.allowCancelButton"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyCancelImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Cancel Reservation</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Please press the cancel button if you want to cancel reservation<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="background-color: #b72c32; border: none; color: #FFF; padding: 4px; font-size: 12px; text-align: center; text-decoration: none; display: inline-block; border-radius: 8px"> CANCEL RESERVATION</span></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}" ng-show="data.reservationVerification.allowCancelButton"><div class="col-lg-12"><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-4"><img ng-src="{{vm.lnf.bodyContactImage}}" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><span style="font-size:{{vm.lnf.bodyTitleFontSize}}px"><strong>Contact us</strong></span><br><span style="font-size:{{vm.lnf.bodyMsgFontSize}}px">Please contact us in case of any other modification of the reservation.<br><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.phoneContact}}<br><a href="mailto:{{data.emailContact}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.emailContact}}</a><br></span></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12"><br><br></div></div><div class="row" style="background-color: {{vm.lnf.bodyBackgroundColor}}; color: {{vm.lnf.bodyTextColor}}; font-family:{{vm.lnf.bodyFontFamily}}"><div class="col-lg-12 text-center preview-footer"><a href="https://www.seaton.site" target="_blank"><small class="text-white font-bold text-center">Powered by SeatOn platform</small></a></div></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeReservationVerificationDialog()">Close</button></div>');
$templateCache.put('app/settings/notification/waitlist.addto.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeWaitlistAddToDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Added to waitlist text message preview</h3></div><div class="modal-body"><div class="row"><div class="col-lg-12"><br><code>{{data.waitlistAdded.messageText}}<br>Track your status at https://getseat.net//#/public/queue/8EDB3927</code><br></div></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeWaitlistAddToDialog()">Close</button></div>');
$templateCache.put('app/settings/notification/waitlist.notify.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeWaitlistNotifyDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Table is available text message preview</h3></div><div class="modal-body"><div class="row"><div class="col-lg-12"><br><code>{{data.waitlistTableAvailable.messageText}}<br>Please reply with YES to confirm your arrival or with NO to cancel.</code><br></div></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeWaitlistNotifyDialog()">Close</button></div>');
$templateCache.put('app/settings/notification/waitlist.thankyou.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeWaitlistThankYouDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Waitlist thank you email preview</h3></div><div class="modal-body"><div class="row"><div class="col-lg-12 text-center preview-header"><h1 class="text-white font-bold">{{getLocationName()}}</h1><span class="text-white">{{getLocationAddress()}}</span><br><br></div></div><div class="row"><div class="col-lg-12"><br><h3 class="font-bold text-black">Thank you for your recent visit!</h3><br>Dear John Doe,<br><br>{{data.waitlistThankYou.messageText}}<br><br>{{getLocationName()}}<br>{{getDate(0)}}<br><br><br></div></div><div class="row" ng-show="data.waitlistThankYou.askFeedback"><div class="col-lg-4"><img src="content/images/feedback.jpg" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><h3>We love feedback</h3>Share your experience with us. We\'d love to find out what we do well, and what could be improved.<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="background-color: #70b755; border: none; color: #FFF; padding: 10px; font-size: 14px; text-align: center; text-decoration: none; display: inline-block; border-radius: 8px"> LEAVE FEEDBACK</span></div></div><div class="row" ng-show="data.waitlistThankYou.askFeedback"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-4"><img src="content/email/images/visit-details.jpg" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><h3>Visit details</h3>Visit date: <strong>{{getDate(-1)}} 11:00:00 AM</strong><br>Party size: <strong>4 person(s)</strong><br></div></div><div class="row"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-4"><img src="content/email/images/contact-us.jpg" style="border-width: 0px; border-style: none; max-width: 170px; width: 100%" width="170"></div><div class="col-lg-8"><h3>Contact us</h3>Please contact us in case of any questions.<br><img src="content/images/phone-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.phoneContact}}<br><a href="mailto:{{data.emailContact}}"><img src="content/images/email-us.jpg" style="border-width: 0px; border-style: none; max-width: 16px; width: 100%"> {{data.emailContact}}</a><br></div></div><div class="row"><div class="col-lg-12"><br><br></div></div><div class="row"><div class="col-lg-12 text-center preview-footer"><a href="https://www.seaton.site" target="_blank"><small class="text-white font-bold text-center">Powered by SeatOn platform</small></a></div></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeWaitlistThankYouDialog()">Close</button></div>');
$templateCache.put('app/settings/timeslot/timeslot.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12 col-md-12"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Time slots definition</h2>Define time slots list available when creating reservations.<br><br>(*) if chosen, last available time slot will be calculated depending on meal duration setup, and the end of business hours, so the whole meal can fit within business hours</div></div></div></div><div class="row"><div class="col-lg-6 col-sm-12"><div class="panel white-panel"><div class="panel-heading"><h3 class="text-danger">Offline reservations - created by staff</h3>Define time slots which will be offered when your staff is creating a reservation<br>Staff will always have the option to select different times not defined here.<br><br><strong>Current choice: <span class="text-navy" ng-if="vm.data.offlineTimeSlotType==\'STEP\'">Generated time slots</span> <span class="text-navy" ng-if="vm.data.offlineTimeSlotType==\'LIST\'">Pre-defined time slots</span></strong></div><div class="panel-body"><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="radio"><input class="radio-primary" ng-model="vm.data.offlineTimeSlotType" type="radio" name="radio_offline" id="radio_offline_1" value="STEP" checked=""><label for="radio_offline_1"><strong ng-class="vm.data.timeSlotType==\'STEP\'?\'text-navy\':\'text-muted\'">Generated time slots</strong><br><small>Define step between time slots and system will automatically generate time slots. All generated time slots will be within business hours defined on Business hours settings page.</small></label></div></div></div><div class="row" ng-show="vm.data.offlineTimeSlotType==\'STEP\'"><div class="col-lg-10 col-lg-offset-2"><br><div class="row"><div class="col-lg-12"><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong><br><br>&nbsp;&nbsp;&nbsp;&nbsp;Reservation can be created every &nbsp;&nbsp;<select ng-model="vm.data.offlineTimeSlotStep" ng-required="true" ng-disabled="vm.data.offlineTimeSlotType!=\'STEP\'" ng-options="item.id as item.name for item in vm.timeStepList"></select>&nbsp;&nbsp;&nbsp;<br>&nbsp;&nbsp;&nbsp;&nbsp;<small>(For example: if you choose 30 min, available time list will look like .., 1:30pm, 2pm, 2:30pm, ..., etc.)</small></div></div><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="radio"><input class="radio-primary" ng-model="vm.data.offlineTimeSlotType" type="radio" name="radio_offline" id="radio_offline_2" value="LIST" checked=""><label for="radio_offline_2"><strong ng-class="vm.data.offlineTimeSlotType==\'LIST\'?\'text-navy\':\'text-muted\'">Pre-defined time slots</strong><br><small>Choose from pre-defined time slot list.</small></label></div></div></div><div class="row" ng-show="vm.data.offlineTimeSlotType==\'LIST\'"><div class="col-lg-8 col-lg-offset-2"><br><div class="row"><div class="col-lg-12" ng-if="vm.timeSlotSetList && vm.timeSlotSetList.length>0"><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong><br><br>&nbsp;&nbsp;&nbsp;&nbsp;Choose pre-defined time slot list &nbsp;&nbsp;<select ng-model="vm.data.offlineTimeSlotSetId" ng-required="true" ng-disabled="vm.data.offlineTimeSlotType!=\'LIST\'" ng-options="item.id as item.name for item in vm.timeSlotSetList"></select>&nbsp;&nbsp;&nbsp;</div><div class="col-lg-12" ng-if="!vm.timeSlotSetList || vm.timeSlotSetList.length<=0"><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong><br><br>Define time slot list by clicking on <span class="text-navy">Create time slot list</span> button below on this page.</div></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 col-sm-12"><br><br>Last time slot &nbsp;<select ng-model="vm.data.offlineTimeBefore" ng-required="true" ng-options="item.id as item.name for item in vm.minBeforeList"></select>&nbsp; end business hours.</div></div><div class="row"><div class="col-lg-8 col-lg-offset-1 col-sm-12"><br><br><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-sm-12" type="button" ng-click="vm.saveOfflineSettings()">Save offline settings</button><br><br></div></div></div></div></div><div class="col-lg-6 col-sm-12"><div class="panel white-panel"><div class="panel-heading"><h3 class="text-danger">Online reservations - created by guest through online channels</h3>Define time slots which will be offered when your guests are creating reservations through online channels.<br><br><strong>Current choice: <span class="text-navy" ng-if="vm.data.onlineTimeSlotType==\'SAME_AS_OFFLINE\'">Offline time slot definition will be used</span> <span class="text-navy" ng-if="vm.data.onlineTimeSlotType==\'STEP\'">Generated time slots</span> <span class="text-navy" ng-if="vm.data.onlineTimeSlotType==\'LIST\'">Pre-defined time slots</span></strong></div><div class="panel-body"><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="radio"><input class="radio-primary" ng-model="vm.data.onlineTimeSlotType" type="radio" name="radio_online" id="radio_online_1" value="SAME_AS_OFFLINE" checked=""><label for="radio_online_1"><strong ng-class="vm.data.onlineTimeSlotType==\'SAME_AS_OFFLINE\'?\'text-navy\':\'text-muted\'">Use offline time slots definition</strong></label></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="radio"><input class="radio-primary" ng-model="vm.data.onlineTimeSlotType" type="radio" name="radio_online" id="radio_online_2" value="STEP" checked=""><label for="radio_online_2"><strong ng-class="vm.data.onlineTimeSlotType==\'STEP\'?\'text-navy\':\'text-muted\'">Generated time slots</strong><br><small>Define step between time slots and system will automatically generate time slots. All generated time slots will be within business hours defined on Business hours settings page.</small></label></div></div></div><div class="row" ng-if="vm.data.onlineTimeSlotType==\'STEP\'"><div class="col-lg-10 col-lg-offset-2"><br><div class="row"><div class="col-lg-12"><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong><br><br>&nbsp;&nbsp;&nbsp;&nbsp;Reservation can be created every &nbsp;&nbsp;<select ng-model="vm.data.onlineTimeSlotStep" ng-required="true" ng-disabled="vm.data.onlineTimeSlotType!=\'STEP\'" ng-options="item.id as item.name for item in vm.timeStepList"></select>&nbsp;&nbsp;&nbsp;<br>&nbsp;&nbsp;&nbsp;&nbsp;<small>(For example: if you choose 30 min, available time list will look like .., 1:30pm, 2pm, 2:30pm, ..., etc.)</small></div></div><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="radio"><input class="radio-primary" ng-model="vm.data.onlineTimeSlotType" type="radio" name="radio_online" id="radio_online_3" value="LIST" checked=""><label for="radio_online_3"><strong ng-class="vm.data.onlineTimeSlotType==\'LIST\'?\'text-navy\':\'text-muted\'">Pre-defined time slots</strong><br><small>Choose from pre-defined time slot list.</small></label></div></div></div><div class="row" ng-if="vm.data.onlineTimeSlotType==\'LIST\'"><div class="col-lg-8 col-lg-offset-2"><br><div class="row"><div class="col-lg-12" ng-if="vm.timeSlotSetList  && vm.timeSlotSetList.length>0"><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot list</strong><br><br>&nbsp;&nbsp;&nbsp;&nbsp;Choose pre-defined time slot list &nbsp;&nbsp;<select ng-model="vm.data.onlineTimeSlotSetId " ng-required="true" ng-disabled="vm.data.onlineTimeSlotType!=\'LIST\'" ng-options="item.id as item.name for item in vm.timeSlotSetList"></select>&nbsp;&nbsp;&nbsp;</div><div class="col-lg-12" ng-if="!vm.timeSlotSetList || vm.timeSlotSetList.length<=0"><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong><br><br>Define time slot list by clicking on <span class="text-navy">Create time slot list</span> button below on this page.</div></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 col-sm-12"><br><br>Last time slot &nbsp;<select ng-model="vm.data.onlineTimeBefore" ng-required="true" ng-options="item.id as item.name for item in vm.minBeforeList"></select>&nbsp; end business hours.</div></div><div class="row"><div class="col-lg-8 col-lg-offset-1 col-sm-12"><br><br><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-sm-12" type="button" ng-click="vm.saveOnlineSettings()">Save online settings</button><br><br></div></div></div></div></div></div><div class="row"><div class="col-lg-12 col-sm-12"><div class="panel white-panel"><div class="panel-heading"><h3 class="text-navy">Limitation policy</h3>Define limitations for <b>online</b> reservations.</div><div class="panel-body"><div class="row"><div class="col-lg-1"></div><div class="col-lg-2 col-sm-12"><div class="radio"><input class="radio-primary" ng-model="vm.data.onlineLimitType" type="radio" name="radio_limitation" id="limitation_type_1" value="NO_LIMITATION" checked=""><label for="limitation_type_1"><strong ng-class="vm.data.onlineLimitType==\'NO_LIMITATION\'?\'text-navy\':\'text-muted\'">No limitation</strong></label></div></div><div class="col-lg-4 col-sm-12"><div class="row"><div class="col-sm-12"><div class="radio"><input class="radio-primary" ng-model="vm.data.onlineLimitType" type="radio" name="radio_limitation" id="limitation_type_2" value="LOCATION" checked=""><label for="limitation_type_2"><strong ng-class="vm.data.onlineLimitType==\'LOCATION\'?\'text-navy\':\'text-muted\'">General limitation</strong><br><small>Limitation valid on restaurant level, same for all time slots.</small></label></div></div></div><div class="row" ng-if="vm.data.onlineLimitType==\'LOCATION\'"><div class="col-lg-11 col-lg-offset-1"><br><div class="row"><div class="col-lg-12"><table class="table"><tbody><tr><td class="">Policy type</td><td><select ng-model="vm.data.onlineLimitPolicy " ng-required="true" ng-disabled="vm.data.onlineLimitType!=\'LOCATION\'" ng-options="item.id as item.name for item in vm.limitationPolicyType"></select></td></tr><tr><td class="">Max # per time slot</td><td><select ng-model="vm.data.onlineLimit" ng-required="true" ng-disabled="vm.data.onlineLimitType!=\'LOCATION\'" ng-options="item.id as item.name for item in vm.maxReservationSlotList"></select></td></tr><tr><td class="">Scope of limitation</td><td><select ng-model="vm.data.onlineLimitScope" ng-required="true" ng-disabled="vm.data.onlineLimitType!=\'LOCATION\'" ng-options="item.id as item.name for item in vm.maxReservationsSlotScopeList"></select></td></tr></tbody></table><br></div></div></div></div></div><div class="col-lg-3 col-sm-12"><div class="radio"><input class="radio-primary" ng-model="vm.data.onlineLimitType" type="radio" name="radio_limitation" id="limitation_type_3" value="TIME_SLOT" checked=""><label for="limitation_type_3"><strong ng-class="vm.data.onlineLimitType==\'TIME_SLOT\'?\'text-navy\':\'text-muted\'">Time slot based limitation</strong><br><small>Limitation defined at time slot level. Can be different for each time slot.</small></label></div></div><div class="col-lg-2 col-sm-12"><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-sm-12" type="button" ng-click="vm.saveLimitationTimeSlotSettings()">Save limitation settings</button></div></div><div class="row"><div class="col-lg-12"><div class="text-success">Important note:<br><ul><li>This section only limits the number of reservations that can be created by guests <b>online</b>.</li><li>You will still be able to create reservations using the SeatOn web or mobile/POS application, so the final number of reservations may be higher than the limitation set here.</li></ul></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12 col-sm-12"><div class="panel white-panel"><div class="panel-heading"><h3 class="text-navy">Predefined time slots</h3>Define time slots list available when creating reservations.<br></div><div class="panel-body"><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><button id="floor" aria-pressed="false" style="float: right" data-toggle="button" class="btn btn-primary" type="button" ng-click="showCreateTimeSlotList()">Create time slot list</button><br><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><table class="table table-hover"><thead><tr><th>Name</th><th>Definition</th><th>Limitation policy</th><th>Scope of limitation</th><th></th></tr></thead><tbody><tr ng-repeat="timeSlotSet in vm.timeSlotSetList"><td>{{timeSlotSet.name}}</td><td>{{vm.definitionDesc(timeSlotSet.scope)}}</td><td>{{vm.limitPolicyDesc(timeSlotSet.limitPolicy)}}</td><td>{{vm.limitScopeDesc(timeSlotSet.limitScope)}}</td><td class="text-danger"><button type="button" class="btn btn-xs btn-info" ng-click="showUpdateTimeSlotList(timeSlotSet)"><i class="fa fa-edit"></i><small> EDIT</small></button> <button type="button" class="btn btn-xs btn-success" ng-click="vm.manageTimeSlotSet(timeSlotSet)"><i class="fa fa-list"></i><small> MANAGE TIME SLOTS</small></button> <button type="button" class="btn btn-xs btn-danger" ng-click="vm.deleteTimeSlotSet(timeSlotSet.id)"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table></div></div></div></div></div></div></div></div></div><div class="modal inmodal in" id="createTimeSlotlist" tabindex="-1" role="dialog" style="display: block; padding-right: 16px" ng-if="createTimeslotListModelVisible"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><i class="fa fa-calendar modal-icon"></i><h4 class="modal-title">Create time slot list</h4></div><div class="modal-body"><form name="formGroups"><div class="form-group" ng-class="{ \'has-error\': formGroups.name.$invalid}"><label>Name</label><input name="name" ng-model="vm.newTimeSlotList.name" class="form-control input-sm ng-pristine ng-untouched ng-valid ng-valid-required" required="" type="text"><div class="validation-error" ng-show="formGroups.name.$invalid"><div ng-messages="formGroups.name.$error" role="alert" class="text-danger"><div ng-message="required">Please define name.</div></div></div></div><div class="form-group"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.newTimeSlotList.scope"></checkbox>&nbsp;&nbsp; same time slots for all days in a week.</div><div class="form-group"><label>Limitation policy</label><select ng-model="vm.newTimeSlotList.limitPolicy " ng-required="true" ng-options="item.id as item.name for item in vm.limitationPolicyType"></select></div><div class="form-group"><label>Scope of limitation</label><select ng-model="vm.newTimeSlotList.limitScope" ng-required="true" ng-options="item.id as item.name for item in vm.maxReservationsSlotScopeListOnline" ng-disabled="true"></select></div></form></div><div class="modal-footer"><button type="button" class="btn btn-white" data-dismiss="modal" ng-click="hideCreateTimeSlotList()">Close</button> <button type="button" class="btn btn-primary" ng-disabled="formGroups.$invalid" ng-click="createTimeSlotList()">Save</button></div></div></div></div>');
$templateCache.put('app/settings/timeslot/timeslot_manage.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeTimeSlotManageModal()"><span aria-hidden="true">&times;</span></button><h3 class="text-navy">ADD/REMOVE TIME SLOTS FROM PREDEFINED SET</h3></div><div class="modal-body"><div class="row"><div class="col-sm-12" ng-if="!vm.timeSlotSetModal.scope"><h3 class="font-bold">Time slot list name:<span class="text-navy"> {{vm.timeSlotSetModal.name}}</span></h3><span>Limitation policy: <span class="font-bold">{{vm.getLimitPolicyDesc(vm.timeSlotSetModal.limitPolicy)}}</span></span><br><span>Different time slots for each day of the week</span><br><br><uib-tabset><uib-tab><uib-tab-heading class="text-center"><div class="col-lg-10">Mon</div><div class="profile-stars"><span>&nbsp</span></div></uib-tab-heading><div class="row"><div class="col-lg-7"><br><br><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong> chosen time <span class="text-success">{{vm.newSlot.hour}}:{{vm.newSlot.mins}} {{vm.newSlot.amPm}}</span><br><br><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.newSlot.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.newSlot.mins" title="Select minutes" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.newSlot.amPm" title="Select AM or PM" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table><br><div ng-if="vm.timeSlotSetModal.limitPolicy!=\'NONE\'"><strong class="text-navy"><i class="fa fa-step-forward"></i> Limitation</strong><br><br><table class="table"><tr><td class="text-right">Max # per time slot &nbsp;</td><td><div data-toggle="buttons"><label ng-repeat="limitation in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]" uib-btn-radio="limitation" ng-model="vm.newSlot.maxReservationsSlot" title="Select limit" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{limitation}}" checked="checked"> {{limitation}}</label></div><select ng-model="vm.newSlot.maxReservationsSlot" ng-required="true" style="border-color: #1ab394; color: #1ab394" ng-options="item.id as item.name for item in vm.maxReservationSlotList"></select></td></tr></table></div><br><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-lg-8 col-lg-offset-2" type="button" ng-disabled="vm.validTimeSlotEntry()" ng-click="vm.addTimeSlot(vm.timeSlotSetModal.id, 1, vm.newSlot.maxReservationsSlot, vm.newSlot.hour, vm.newSlot.mins, vm.newSlot.amPm)">Add time slot</button><br></div><div class="col-lg-5"><br><br><span class="text-danger font-bold"><i class="fa fa-clock-o"></i>&nbsp; Time slot list</span><table class="table table-hover"><thead><tr><th>Time slot</th><th>Max # per time slot</th><th>Action</th></tr></thead><tbody><tr ng-repeat="timeSlot in vm.timeSlotSetModal.monday"><td>{{timeSlot.slotTime}}</td><td ng-if="timeSlot.slotLimit>0">{{timeSlot.slotLimit}}</td><td ng-if="timeSlot.slotLimit<=0">No restriction</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="vm.deleteTimeSlot(timeSlot)"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center"><div class="col-lg-10">Tue</div><div class="profile-stars"><span>&nbsp</span></div></uib-tab-heading><div class="row"><div class="col-lg-7"><br><br><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong> chosen time <span class="text-success">{{vm.newSlot.hour}}:{{vm.newSlot.mins}} {{vm.newSlot.amPm}}</span><br><br><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.newSlot.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.newSlot.mins" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.newSlot.amPm" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table><br><div ng-if="vm.timeSlotSetModal.limitPolicy!=\'NONE\'"><strong class="text-navy"><i class="fa fa-step-forward"></i> Limitation</strong><br><br><table class="table"><tr><td class="text-right">Max # per time slot &nbsp;</td><td><div data-toggle="buttons"><label ng-repeat="limitation in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]" uib-btn-radio="limitation" ng-model="vm.newSlot.maxReservationsSlot" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{limitation}}" checked="checked"> {{limitation}}</label></div><select ng-model="vm.newSlot.maxReservationsSlot" ng-required="true" style="border-color: #1ab394; color: #1ab394" ng-options="item.id as item.name for item in vm.maxReservationSlotList"></select></td></tr></table></div><br><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-lg-8 col-lg-offset-2" type="button" ng-disabled="vm.validTimeSlotEntry()" ng-click="vm.addTimeSlot(vm.timeSlotSetModal.id, 2, vm.newSlot.maxReservationsSlot, vm.newSlot.hour, vm.newSlot.mins, vm.newSlot.amPm)">Add time slot</button><br></div><div class="col-lg-5"><br><br><span class="text-danger font-bold"><i class="fa fa-clock-o"></i>&nbsp; Time slot list</span><table class="table table-hover"><thead><tr><th>Time slot</th><th>Max # per time slot</th><th>Action</th></tr></thead><tbody><tr ng-repeat="timeSlot in vm.timeSlotSetModal.tuesday"><td>{{timeSlot.slotTime}}</td><td ng-if="timeSlot.slotLimit>0">{{timeSlot.slotLimit}}</td><td ng-if="timeSlot.slotLimit<=0">No restriction</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="vm.deleteTimeSlot(timeSlot)"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center"><div class="col-lg-10">Wed</div><div class="profile-stars"><span>&nbsp</span></div></uib-tab-heading><div class="row"><div class="col-lg-7"><br><br><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong> chosen time <span class="text-success">{{vm.newSlot.hour}}:{{vm.newSlot.mins}} {{vm.newSlot.amPm}}</span><br><br><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.newSlot.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.newSlot.mins" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.newSlot.amPm" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table><br><div ng-if="vm.timeSlotSetModal.limitPolicy!=\'NONE\'"><strong class="text-navy"><i class="fa fa-step-forward"></i> Limitation</strong><br><br><table class="table"><tr><td class="text-right">Max # per time slot &nbsp;</td><td><div data-toggle="buttons"><label ng-repeat="limitation in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]" uib-btn-radio="limitation" ng-model="vm.newSlot.maxReservationsSlot" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{limitation}}" checked="checked"> {{limitation}}</label></div><select ng-model="vm.newSlot.maxReservationsSlot" ng-required="true" style="border-color: #1ab394; color: #1ab394" ng-options="item.id as item.name for item in vm.maxReservationSlotList"></select></td></tr></table></div><br><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-lg-8 col-lg-offset-2" type="button" ng-disabled="vm.validTimeSlotEntry()" ng-click="vm.addTimeSlot(vm.timeSlotSetModal.id, 3, vm.newSlot.maxReservationsSlot, vm.newSlot.hour, vm.newSlot.mins, vm.newSlot.amPm)">Add time slot</button><br></div><div class="col-lg-5"><br><br><span class="text-danger font-bold"><i class="fa fa-clock-o"></i>&nbsp; Time slot list</span><table class="table table-hover"><thead><tr><th>Time slot</th><th>Max # per time slot</th><th>Action</th></tr></thead><tbody><tr ng-repeat="timeSlot in vm.timeSlotSetModal.wednesday"><td>{{timeSlot.slotTime}}</td><td ng-if="timeSlot.slotLimit>0">{{timeSlot.slotLimit}}</td><td ng-if="timeSlot.slotLimit<=0">No restriction</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="vm.deleteTimeSlot(timeSlot)"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center"><div class="col-lg-10">Thu</div><div class="profile-stars"><span>&nbsp</span></div></uib-tab-heading><div class="row"><div class="col-lg-7"><br><br><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong> chosen time <span class="text-success">{{vm.newSlot.hour}}:{{vm.newSlot.mins}} {{vm.newSlot.amPm}}</span><br><br><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.newSlot.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.newSlot.mins" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.newSlot.amPm" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table><br><div ng-if="vm.timeSlotSetModal.limitPolicy!=\'NONE\'"><strong class="text-navy"><i class="fa fa-step-forward"></i> Limitation</strong><br><br><table class="table"><tr><td class="text-right">Max # per time slot &nbsp;</td><td><div data-toggle="buttons"><label ng-repeat="limitation in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]" uib-btn-radio="limitation" ng-model="vm.newSlot.maxReservationsSlot" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{limitation}}" checked="checked"> {{limitation}}</label></div><select ng-model="vm.newSlot.maxReservationsSlot" ng-required="true" style="border-color: #1ab394; color: #1ab394" ng-options="item.id as item.name for item in vm.maxReservationSlotList"></select></td></tr></table></div><br><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-lg-8 col-lg-offset-2" type="button" ng-disabled="vm.validTimeSlotEntry()" ng-click="vm.addTimeSlot(vm.timeSlotSetModal.id, 4, vm.newSlot.maxReservationsSlot, vm.newSlot.hour, vm.newSlot.mins, vm.newSlot.amPm)">Add time slot</button><br></div><div class="col-lg-5"><br><br><span class="text-danger font-bold"><i class="fa fa-clock-o"></i>&nbsp; Time slot list</span><table class="table table-hover"><thead><tr><th>Time slot</th><th>Max # per time slot</th><th>Action</th></tr></thead><tbody><tr ng-repeat="timeSlot in vm.timeSlotSetModal.thursday"><td>{{timeSlot.slotTime}}</td><td ng-if="timeSlot.slotLimit>0">{{timeSlot.slotLimit}}</td><td ng-if="timeSlot.slotLimit<=0">No restriction</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="vm.deleteTimeSlot(timeSlot)"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center"><div class="col-lg-10">Fri</div><div class="profile-stars"><span>&nbsp</span></div></uib-tab-heading><div class="row"><div class="col-lg-7"><br><br><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong> chosen time <span class="text-success">{{vm.newSlot.hour}}:{{vm.newSlot.mins}} {{vm.newSlot.amPm}}</span><br><br><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.newSlot.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.newSlot.mins" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.newSlot.amPm" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table><br><div ng-if="vm.timeSlotSetModal.limitPolicy!=\'NONE\'"><strong class="text-navy"><i class="fa fa-step-forward"></i> Limitation</strong><br><br><table class="table"><tr><td class="text-right">Max # per time slot &nbsp;</td><td><div data-toggle="buttons"><label ng-repeat="limitation in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]" uib-btn-radio="limitation" ng-model="vm.newSlot.maxReservationsSlot" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{limitation}}" checked="checked"> {{limitation}}</label></div><select ng-model="vm.newSlot.maxReservationsSlot" ng-required="true" style="border-color: #1ab394; color: #1ab394" ng-options="item.id as item.name for item in vm.maxReservationSlotList"></select></td></tr></table></div><br><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-lg-8 col-lg-offset-2" type="button" ng-disabled="vm.validTimeSlotEntry()" ng-click="vm.addTimeSlot(vm.timeSlotSetModal.id, 5, vm.newSlot.maxReservationsSlot, vm.newSlot.hour, vm.newSlot.mins, vm.newSlot.amPm)">Add time slot</button><br></div><div class="col-lg-5"><br><br><span class="text-danger font-bold"><i class="fa fa-clock-o"></i>&nbsp; Time slot list</span><table class="table table-hover"><thead><tr><th>Time slot</th><th>Max # per time slot</th><th>Action</th></tr></thead><tbody><tr ng-repeat="timeSlot in vm.timeSlotSetModal.friday"><td>{{timeSlot.slotTime}}</td><td ng-if="timeSlot.slotLimit>0">{{timeSlot.slotLimit}}</td><td ng-if="timeSlot.slotLimit<=0">No restriction</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="vm.deleteTimeSlot(timeSlot)"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center"><div class="col-lg-10">Sat</div><div class="profile-stars"><span>&nbsp</span></div></uib-tab-heading><div class="row"><div class="col-lg-7"><br><br><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong> chosen time <span class="text-success">{{vm.newSlot.hour}}:{{vm.newSlot.mins}} {{vm.newSlot.amPm}}</span><br><br><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.newSlot.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.newSlot.mins" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.newSlot.amPm" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table><br><div ng-if="vm.timeSlotSetModal.limitPolicy!=\'NONE\'"><strong class="text-navy"><i class="fa fa-step-forward"></i> Limitation</strong><br><br><table class="table"><tr><td class="text-right">Max # per time slot &nbsp;</td><td><div data-toggle="buttons"><label ng-repeat="limitation in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]" uib-btn-radio="limitation" ng-model="vm.newSlot.maxReservationsSlot" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{limitation}}" checked="checked"> {{limitation}}</label></div><select ng-model="vm.newSlot.maxReservationsSlot" ng-required="true" style="border-color: #1ab394; color: #1ab394" ng-options="item.id as item.name for item in vm.maxReservationSlotList"></select></td></tr></table></div><br><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-lg-8 col-lg-offset-2" type="button" ng-disabled="vm.validTimeSlotEntry()" ng-click="vm.addTimeSlot(vm.timeSlotSetModal.id, 6, vm.newSlot.maxReservationsSlot, vm.newSlot.hour, vm.newSlot.mins, vm.newSlot.amPm)">Add time slot</button><br></div><div class="col-lg-5"><br><br><span class="text-danger font-bold"><i class="fa fa-clock-o"></i>&nbsp; Time slot list</span><table class="table table-hover"><thead><tr><th>Time slot</th><th>Max # per time slot</th><th>Action</th></tr></thead><tbody><tr ng-repeat="timeSlot in vm.timeSlotSetModal.saturday"><td>{{timeSlot.slotTime}}</td><td ng-if="timeSlot.slotLimit>0">{{timeSlot.slotLimit}}</td><td ng-if="timeSlot.slotLimit<=0">No restriction</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="vm.deleteTimeSlot(timeSlot)"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center"><div class="col-lg-10">Sun</div><div class="profile-stars"><span>&nbsp</span></div></uib-tab-heading><div class="row"><div class="col-lg-7"><br><br><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong> chosen time <span class="text-success">{{vm.newSlot.hour}}:{{vm.newSlot.mins}} {{vm.newSlot.amPm}}</span><br><br><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.newSlot.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.newSlot.mins" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.newSlot.amPm" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table><br><div ng-if="vm.timeSlotSetModal.limitPolicy!=\'NONE\'"><strong class="text-navy"><i class="fa fa-step-forward"></i> Limitation</strong><br><br><table class="table"><tr><td class="text-right">Max # per time slot &nbsp;</td><td><div data-toggle="buttons"><label ng-repeat="limitation in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]" uib-btn-radio="limitation" ng-model="vm.newSlot.maxReservationsSlot" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{limitation}}" checked="checked"> {{limitation}}</label></div><select ng-model="vm.newSlot.maxReservationsSlot" ng-required="true" style="border-color: #1ab394; color: #1ab394" ng-options="item.id as item.name for item in vm.maxReservationSlotList"></select></td></tr></table></div><br><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-lg-8 col-lg-offset-2" type="button" ng-disabled="vm.validTimeSlotEntry()" ng-click="vm.addTimeSlot(vm.timeSlotSetModal.id, 7, vm.newSlot.maxReservationsSlot, vm.newSlot.hour, vm.newSlot.mins, vm.newSlot.amPm)">Add time slot</button><br></div><div class="col-lg-5"><br><br><span class="text-danger font-bold"><i class="fa fa-clock-o"></i>&nbsp; Time slot list</span><table class="table table-hover"><thead><tr><th>Time slot</th><th>Max # per time slot</th><th>Action</th></tr></thead><tbody><tr ng-repeat="timeSlot in vm.timeSlotSetModal.sunday"><td>{{timeSlot.slotTime}}</td><td ng-if="timeSlot.slotLimit>0">{{timeSlot.slotLimit}}</td><td ng-if="timeSlot.slotLimit<=0">No restriction</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="vm.deleteTimeSlot(timeSlot)"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table></div></div></uib-tab></uib-tabset></div><div class="col-sm-12" ng-if="vm.timeSlotSetModal.scope"><h3 class="font-bold">Time slot list name:<span class="text-navy"> {{vm.timeSlotSetModal.name}}</span></h3><span>Limitation policy: <span class="font-bold">{{vm.getLimitPolicyDesc(vm.timeSlotSetModal.limitPolicy)}}</span></span><br><span>Same time slots for each day in week</span><br><br><div class="row"><div class="col-lg-7"><br><br><strong class="text-navy"><i class="fa fa-clock-o"></i> Time slot definition</strong> chosen time <span class="text-success">{{vm.newSlot.hour}}:{{vm.newSlot.mins}} {{vm.newSlot.amPm}}</span><br><br><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.newSlot.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.newSlot.mins" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.newSlot.amPm" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table><br><div ng-if="vm.timeSlotSetModal.limitPolicy!=\'NONE\'"><strong class="text-navy"><i class="fa fa-step-forward"></i> Limitation</strong><br><br><table class="table"><tr><td class="text-right">Max # per time slot &nbsp;</td><td><div data-toggle="buttons"><label ng-repeat="limitation in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]" uib-btn-radio="limitation" ng-model="vm.newSlot.maxReservationsSlot" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{limitation}}" checked="checked"> {{limitation}}</label></div><select ng-model="vm.newSlot.maxReservationsSlot" ng-required="true" style="border-color: #1ab394; color: #1ab394" ng-options="item.id as item.name for item in vm.maxReservationSlotList"></select></td></tr></table></div><br><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-lg-8 col-lg-offset-2" type="button" ng-disabled="vm.validTimeSlotEntry()" ng-click="vm.addTimeSlot(vm.timeSlotSetModal.id, 0, vm.newSlot.maxReservationsSlot, vm.newSlot.hour, vm.newSlot.mins, vm.newSlot.amPm)">Add time slot</button><br></div><div class="col-lg-5"><br><br><span class="text-danger font-bold"><i class="fa fa-clock-o"></i>&nbsp; Time slot list</span><table class="table table-hover"><thead><tr><th>Time slot</th><th>Max # per time slot</th><th>Action</th></tr></thead><tbody><tr ng-repeat="timeSlot in vm.timeSlotSetModal.allDays"><td>{{timeSlot.slotTime}}</td><td ng-if="timeSlot.slotLimit>0">{{timeSlot.slotLimit}}</td><td ng-if="timeSlot.slotLimit<=0">No restriction</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="vm.deleteTimeSlot(timeSlot)"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeTimeSlotManageModal()">Close</button></div>');
$templateCache.put('app/settings/widget/widget.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12 col-md-10"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Online reservation widget customization</h2>Customize online widget reservation component to match your needs and place it on your web site.</div><div class="panel-body"><div class="row"><div class="col-lg-12 text-right"><button aria-pressed="false" data-toggle="button" class="btn btn-primary" type="button">Save notification messages</button><br><br></div></div><div class="row"><div class="col-lg-7"><div class="row"><div class="col-lg-12"><p>Choose reservation widget theme:</p><button class="btn btn-primary dim btn-large-dim btn_outline active" type="button"></button> <button class="btn btn-warning dim btn-large-dim btn-outline" type="button"></button> <button class="btn btn-danger dim btn-large-dim btn-outline" type="button"></button> <button class="btn btn-info dim btn-large-dim btn-outline" type="button"></button> <button class="btn btn-success dim btn-large-dim btn-outline" type="button"></button></div></div><div class="row"><div class="col-lg-12"><br><p>Customize reservation widget text:</p></div></div><div class="row"><form class="form-horizontal"><div class="form-group"><label class="col-sm-3 control-label">Widget title</label><div class="col-sm-7"><input class="form-control" type="text" value="Book a table"></div></div></form></div><div class="row"><div class="col-lg-12"><br><p>Widget position in browser window:</p></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><button aria-pressed="false" data-toggle="button" class="btn btn-primary btn-outline" type="button">Top left</button>&nbsp; <button aria-pressed="false" data-toggle="button" class="btn btn-primary btn-outline" type="button">Top right</button>&nbsp; <button aria-pressed="false" data-toggle="button" class="btn btn-primary btn-outline" type="button">Bottom left</button>&nbsp; <button aria-pressed="false" data-toggle="button" class="btn btn-primary btn-outline active" type="button">Bottom right</button>&nbsp;</div></div></div><div class="col-lg-5"><div class="ibox float-e-margins"><div class="ibox-title text-center"><h4 class="">Preview reservation widget</h4></div><div class="ibox-content ibox-heading"><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="row"><div class="col-lg-12"><br><a class="btn btn-primary btn-rounded btn-block" href="#"><i class="fa fa-calendar"></i> Book a table</a></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-4"><div class="widget navy-bg"><div class="row"><div class="col-xs-12 font-bold"><span>FIND<br>TABLE</span></div></div></div></div><div class="col-lg-4"><div class="widget"><div class="row"><div class="col-xs-12 font-bold"><span>CONTACT<br>DETAILS</span></div></div></div></div><div class="col-lg-4"><div class="widget"><div class="row"><div class="col-xs-12 font-bold"><span>BOOK<br>TABLE</span></div></div></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><h4>Find a table for desired time and date.</h4></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><form class=""><div class="row"><div class="col-lg-12"><div class="input-group m-b"><span class="input-group-addon"><i class="fa fa-calendar text-navy"></i></span> <input placeholder="Choose date" class="form-control" type="text"></div></div></div><div class="row"><div class="col-lg-12"><div class="input-group m-b"><span class="input-group-addon"><i class="fa fa-clock-o text-navy"></i></span> <input placeholder="Choose time" class="form-control" type="text"></div></div></div><div class="row"><div class="col-lg-12"><div class="input-group m-b"><span class="input-group-addon"><i class="fa fa-users text-navy"></i></span> <input placeholder="# of people" class="form-control" type="text"></div></div></div><div class="row"><div class="col-lg-12"><button class="btn btn-primary col-lg-12" type="button"><i class="fa fa-search-plus"></i>&nbsp;&nbsp;Find available table</button></div></div></form></div></div></div></div></div></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><br><p>To enable visitors of your website to make reservation please add below code to your website pages.</p><small>More information on how to integrate reservation widget in your website you can found in <a href="" class="text-success">help pages</a>.</small><br><br><div class="panel panel-default"><div class="panel-heading">Please copy the below code and paste it in your webpages just before &lt;/body&gt; tag</div><div class="panel-body"><div class="row"><div class="" col-lg-12><pre>\n                                                &lt;!-- Reservation widget for websites --&gt;\n                                                &lt;script type=\'text/javascript\'&gt;\n                                                var _glc =_glc || []; _glc.push(\'all_ag9zfmNsaWNrZGVza2NoYXRyDwsSBXVzZXJzGJDXn70NDA\');\n                                                var glcpath = ((\'https:\' == document.location.protocol) ? \'https://my.clickdesk.com/clickdesk-ui/browser/\' :\n                                                \'http://my.clickdesk.com/clickdesk-ui/browser/\');\n                                                var glcp = ((\'https:\' == document.location.protocol) ? \'https://\' : \'http://\');\n                                                var glcspt = document.createElement(\'script\'); glcspt.type = \'text/javascript\';\n                                                glcspt.async = true; glcspt.src = glcpath + \'livechat-new.js\';\n                                                var s = document.getElementsByTagName(\'script\')[0];s.parentNode.insertBefore(glcspt, s);\n                                                &lt;/script&gt;\n                                                &lt;!-- End of reservation widget --&gt;\n                                            </pre></div></div><div class="row"><div class="col-lg-12"><a type="button" class="btn btn-w-m btn-primary col-lg-12">Copy Code to Clipboard</a></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/tables/block/block.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12 col-md-12"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Reservation block event</h2>Block reservations for the specific time period<br><br></div></div></div></div><div class="row"><div class="col-sm-12"><div class="panel white-panel"><div class="panel-heading"><h3 class="text-danger">Create block for specific period</h3>It will not be possible to create any reservations for the blocked period through offline and/or online channels.<br></div><div class="panel-body"><div class="row"><div class="col-sm-12"><h4>Choose scope and define block for reservations.</h4><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="radio"><input class="radio-primary" ng-model="vm.block.type" type="radio" name="radio_offline" id="radio_offline_1" value="LOCATION" checked=""><label for="radio_offline_1"><strong ng-class="vm.block.type==\'LOCATION\'?\'text-navy\':\'text-muted\'">Location</strong><br><small>Block all resources for all channels (offline and online).</small></label></div></div></div><div class="row" ng-show="vm.block.type==\'LOCATION\'"><div class="col-lg-10 col-lg-offset-2"><br><div class="row"><div class="col-lg-10"><table class="table table-hover"><thead><tr><th>Option</th><th>Description</th><th></th></tr></thead><tbody><tr><td><strong class="text-navy">Non working day</strong></td><td>Define specific day as non working date.</td><td><button type="button" class="btn btn-xs btn-info" ng-click="vm.openLink(\'NON\')"><i class="fa fa-external-link"></i><small> Open</small></button></td></tr><tr><td><strong class="text-navy">Special working day</strong></td><td>Define special working day which is different than standard business hours.</td><td><button type="button" class="btn btn-xs btn-info" ng-click="vm.openLink(\'SPECIAL\')"><i class="fa fa-external-link"></i><small> Open</small></button></td></tr><tr><td><strong class="text-navy">Disable online reservation</strong></td><td>Disable online reservation permanently or until specific date and time.</td><td><button type="button" class="btn btn-xs btn-info" ng-click="vm.openLink(\'DISABLE\')"><i class="fa fa-external-link"></i><small> Open</small></button></td></tr></tbody></table></div></div><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="radio"><input class="radio-primary" ng-model="vm.block.type" type="radio" name="radio_offline" id="radio_offline_2" value="SECTION" checked="" ng-click="vm.onSection()"><label for="radio_offline_2"><strong ng-class="vm.block.type==\'SECTION\'?\'text-navy\':\'text-muted\'">Sections (Areas)</strong><br><small>Block all resources in one or more section(s) / area(s).</small></label></div></div></div><div class="row" ng-show="vm.block.type==\'SECTION\'"><div class="col-lg-10 col-lg-offset-2"><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-calendar"></i> Date</label>&nbsp;(select date for which you want to create block)</div></div><br><div class="row"><div class="col-lg-4 col-lg-offset-1"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openDatePickerSection()"><i class="fa fa-calendar"></i></button> </span><input placeholder="select date for block" name="datePickerSection" type="text" class="form-control" ng-model="vm.selectedDayFormatted" close-text="Close"></div><br></div></div></div></div><div class="row"><div class="col-lg-6"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-clock-o"></i> From</label>&nbsp;chosen time <span class="text-success font-bold">{{vm.block.from.hour}}:{{vm.block.from.mins}} {{vm.block.from.amPm}}</span><br><br></div></div><div class="row"><div class="col-lg-12"><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.block.from.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.block.from.mins" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.block.from.amPm" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table></div></div></div><div class="col-lg-6"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-clock-o"></i> To</label>&nbsp;chosen time <span class="text-success font-bold">{{vm.block.to.hour}}:{{vm.block.to.mins}} {{vm.block.to.amPm}}</span><br><br></div></div><div class="row"><div class="col-lg-12"><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.block.to.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.block.to.mins" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.block.to.amPm" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="form-group"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-th-large"></i> Sections</label>&nbsp;(choose one or more section(s) / area(s))<br><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 btn-group"><span ng-if="vm.availableAreas && vm.availableAreas.length>0"><label ng-repeat="area in vm.availableAreas" ng-model="area.selected" uib-btn-checkbox class="btn btn-primary btn-outline" style="margin: 2px; overflow:auto"><span class="font-bold">{{area.name}}</span></label></span><span ng-if="vm.availableAreas && vm.availableAreas.length==0" class="text-danger text-center">No available Area(s).</span></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-hand-o-right"></i> Scope of block</label>&nbsp;(specify type of reservations for which you want to apply the block)</div></div><br><div class="row"><div class="col-lg-4 col-lg-offset-1"><select class="form-control" ng-model="vm.block.scope" ng-options="obj.value as obj.name for obj in blockScope" ng-change=""></select></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-align-justify"></i> Block description</label></div></div><br><div class="row"><div class="col-lg-4 col-lg-offset-1"><input placeholder="Add block description" class="form-control" name="descriptionSection" ng-model="vm.block.description"></div></div></div></div><br><br><div class="row"><div class="col-lg-12"><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-lg-4" type="button" ng-disabled="!vm.inputOk(\'SECTION\')" ng-click="vm.saveBlockEvent()">Create block</button></div></div><br><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="radio"><input class="radio-primary" ng-model="vm.block.type" type="radio" name="radio_offline" id="radio_offline_3" value="RESOURCE" checked="" ng-click="vm.onResource()"><label for="radio_offline_3"><strong ng-class="vm.block.type==\'RESOURCE\'?\'text-navy\':\'text-muted\'">Resources (Tables)</strong><br><small>Block selected resources on the specific day and time.</small></label></div></div></div><div class="row" ng-show="vm.block.type==\'RESOURCE\'"><div class="col-lg-10 col-lg-offset-2"><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-calendar"></i> Date</label>&nbsp;(select date for which you want to create block)</div></div><br><div class="row"><div class="col-lg-4 col-lg-offset-1"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openDatePickerSection()"><i class="fa fa-calendar"></i></button> </span><input placeholder="select date for block" name="datePickerSection" type="text" class="form-control" ng-model="vm.selectedDayFormatted" close-text="Close"></div><br></div></div></div></div><div class="row"><div class="col-lg-6"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-clock-o"></i> From</label>&nbsp;chosen time <span class="text-success font-bold">{{vm.block.from.hour}}:{{vm.block.from.mins}} {{vm.block.from.amPm}}</span><br><br></div></div><div class="row"><div class="col-lg-12"><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.block.from.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.block.from.mins" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.block.from.amPm" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table></div></div></div><div class="col-lg-6"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-clock-o"></i> To</label>&nbsp;chosen time <span class="text-success font-bold">{{vm.block.to.hour}}:{{vm.block.to.mins}} {{vm.block.to.amPm}}</span><br><br></div></div><div class="row"><div class="col-lg-12"><table><tr><td class="text-right">Hours:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="hour in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" uib-btn-radio="hour" ng-model="vm.block.to.hour" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{hour}}" checked="checked"> {{hour}}</label></td></tr><tr><td class="text-right">Minutes:&nbsp;&nbsp;</td><td data-toggle="buttons"><label ng-repeat="mins in [\'00\', \'15\', \'30\', \'45\']" uib-btn-radio="mins" ng-model="vm.block.to.mins" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{mins}}" checked="checked"> {{mins}}</label></td></tr><tr><td class="text-right"></td><td data-toggle="buttons"><label ng-repeat="amPm in [\'AM\', \'PM\']" uib-btn-radio="amPm" ng-model="vm.block.to.amPm" title="Select hour" class="btn btn-sm btn-outline btn-primary" style="margin: 1px"><input type="radio" name="timeSlot" value="{{amPm}}" checked="checked"> {{amPm}}</label></td></tr></table></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="form-group"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-th-large"></i> Resources</label>&nbsp;(choose one or more resource(s) / table(s))<br><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 btn-group"><span ng-if="vm.availableResources && vm.availableResources.length>0"><table><tr ng-repeat="areaRes in vm.availableResources"><td style="vertical-align: middle"><span style="color:{{areaRes.color}}" class="font-bold">{{areaRes.name}}</span> &nbsp;&nbsp;</td><td><label ng-repeat="resource in areaRes.resources" ng-model="resource.selected" uib-btn-checkbox class="btn btn-primary btn-outline" style="margin: 2px; overflow:auto"><span class="" style="color:{{areaRes.color}}">{{resource.name}}</span></label></td></tr></table></span><span ng-if="vm.availableResources && vm.availableResources.length==0" class="text-danger text-center">No available Tables(s).</span></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-hand-o-right"></i> Scope of block</label>&nbsp;(specify type of reservations for which you want to apply the block)</div></div><br><div class="row"><div class="col-lg-4 col-lg-offset-1"><select class="form-control" ng-model="vm.block.scope" ng-options="obj.value as obj.name for obj in blockScope" ng-change=""></select></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><label class="control-label text-navy"><i class="fa fa-align-justify"></i> Block description</label></div></div><br><div class="row"><div class="col-lg-4 col-lg-offset-1"><input placeholder="Add block description" class="form-control" name="descriptionSection" ng-model="vm.block.description"></div></div></div></div><br><br><div class="row"><div class="col-lg-12"><button aria-pressed="false" data-toggle="button" class="btn btn-primary col-lg-4" type="button" ng-disabled="!vm.inputOk(\'RESOURCE\')" ng-click="vm.saveBlockEvent()">Create block</button></div></div><br><br></div></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12 col-sm-12"><div class="panel white-panel"><div class="panel-heading"><h3 class="text-navy">Block list</h3>List of created blocks for specific date and section(s)/tables(s).<br></div><div class="panel-body"><div class="row"><div class="col-lg-12"><table class="table table-hover"><thead><tr><th>Date</th><th>Blocked interval</th><th>Description</th><th>Resource Type</th><th>Resources blocked</th><th>Valid for channels</th><th>Created by</th><th>Active</th><th></th></tr></thead><tbody><tr ng-repeat="block in vm.blockEvents"><td><strong>{{vm.formatDate(block.startTime)}}</strong></td><td><strong>{{vm.formatTime(block.startTime)}}</strong> to <strong>{{vm.formatTime(block.endTime)}}</strong></td><td>{{block.description}}</td><td>{{block.type}}</td><td>{{vm.listResourceOrSection(block)}}</td><td>{{block.scope}}</td><td>{{block.createdBy}}</td><td ng-if="vm.isActive(block.endTime)" class="text-navy font-bold">YES</td><td ng-if="!vm.isActive(block.endTime)" class="text-danger font-bold">NO</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="vm.deleteBlockEvent(block.id)"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/settings/worktime/worktime.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12 col-md-10"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-danger">Business Hours</h2><div class="pull-right"><label for="syncWithClover" class="control-label" style="font-weight: normal">Synchronize with Clover&nbsp;</label><toggle id="syncWithClover" size="btn-sm" ng-model="vm.synchronizeWithClover" on="Yes" off="No" offstyle="btn-danger" style="ios" ng-checked="true" ng-click="syncCloverChanged()"></toggle></div></div><div class="panel-body"><div class="row"><div class="col-lg-12 col-sm-12"><b>SeatOn uses the Business Hours defined in the Clover system.</b><br>Each time Business Hours are changed, the change will be automatically updated in SeatOn system as well.<br><br><i class="text-danger">If you want to have different business hours defined in SeatOn than in Clover, please disable Clover synchronization and redefine business hours below.<br></i><br><h3>Current choice: SeatOn will use Business Hours defined <span class="text-danger" ng-show="vm.synchronizeWithClover">in Clover.</span> <span class="text-danger" ng-show="!vm.synchronizeWithClover">manually on this page.</span></h3></div></div></div></div></div></div><div class="row"><div class="col-lg-7 col-md-7 col-sm-12"><div class="row"><div class="col-md-12"><div class="ibox-content"><h3>Business Hours</h3><small>Define your business hours for each day of the week.</small><br><br><uib-tabset active=""><uib-tab select=""><uib-tab-heading class="text-primary">Monday</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="">Business hours for <span class="text-danger">Monday</span></h4></div></div><div class="row"><br><div class="col-lg-4"><form name="customerForm" class="form-horizontal"><div class="col-lg-12"><div class="form-group"><label class="col-sm-3 control-label">From</label><div class="col-sm-9"><select class="form-control" ng-model="vm.fromTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><div class="form-group"><label class="col-sm-3 control-label">To</label><div class="col-sm-9"><select class="form-control" ng-model="vm.toTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><button type="button" class="btn btn-primary col-lg-12" ng-click="addWorkingHours(1)" ng-disabled="vm.synchronizeWithClover || !(vm.fromTime!=\'-1\') || !(vm.toTime!=\'-1\')">ADD</button></div></form></div><div class="col-lg-6 col-lg-offset-1"><table class="table table-hover" ng-show="!isClosed(vm.monday)"><thead><tr><th>From</th><th>To</th><th>Action</th></tr></thead><tbody><tr ng-repeat="day in vm.monday"><td>{{day.fromHour12}}</td><td>{{day.endHour12}}</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="deleteWorkingHours(day.id)" ng-disabled="vm.synchronizeWithClover"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table><h4 class="text-danger text-center lg-col-12" ng-show="isClosed(vm.monday)">CLOSED</h4></div></div></uib-tab><uib-tab select=""><uib-tab-heading class="text-primary">Tuesday</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="">Business hours for <span class="text-danger">Tuesday</span></h4></div></div><div class="row"><br><div class="col-lg-4"><form name="customerForm" class="form-horizontal"><div class="col-lg-12"><div class="form-group"><label class="col-sm-3 control-label">From</label><div class="col-sm-9"><select class="form-control" ng-model="vm.fromTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><div class="form-group"><label class="col-sm-3 control-label">To</label><div class="col-sm-9"><select class="form-control" ng-model="vm.toTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><button type="button" class="btn btn-primary col-lg-12" ng-click="addWorkingHours(2)" ng-disabled="vm.synchronizeWithClover || !(vm.fromTime!=\'-1\') || !(vm.toTime!=\'-1\')">ADD</button></div></form></div><div class="col-lg-6 col-lg-offset-1"><table class="table table-hover" ng-show="!isClosed(vm.tuesday)"><thead><tr><th>From</th><th>To</th><th>Action</th></tr></thead><tbody><tr ng-repeat="day in vm.tuesday"><td>{{day.fromHour12}}</td><td>{{day.endHour12}}</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="deleteWorkingHours(day.id)" ng-disabled="vm.synchronizeWithClover"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table><h4 class="text-danger text-center lg-col-12" ng-show="isClosed(vm.tuesday)">CLOSED</h4></div></div></uib-tab><uib-tab select=""><uib-tab-heading class="text-primary">Wednesday</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="">Business hours for <span class="text-danger">Wednesday</span></h4></div></div><div class="row"><br><div class="col-lg-4"><form name="customerForm" class="form-horizontal"><div class="col-lg-12"><div class="form-group"><label class="col-sm-3 control-label">From</label><div class="col-sm-9"><select class="form-control" ng-model="vm.fromTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><div class="form-group"><label class="col-sm-3 control-label">To</label><div class="col-sm-9"><select class="form-control" ng-model="vm.toTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><button type="button" class="btn btn-primary col-lg-12" ng-click="addWorkingHours(3)" ng-disabled="vm.synchronizeWithClover || !(vm.fromTime!=\'-1\') || !(vm.toTime!=\'-1\')">ADD</button></div></form></div><div class="col-lg-6 col-lg-offset-1"><table class="table table-hover" ng-show="!isClosed(vm.wednesday)"><thead><tr><th>From</th><th>To</th><th>Action</th></tr></thead><tbody><tr ng-repeat="day in vm.wednesday"><td>{{day.fromHour12}}</td><td>{{day.endHour12}}</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="deleteWorkingHours(day.id)" ng-disabled="vm.synchronizeWithClover"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table><h4 class="text-danger text-center lg-col-12" ng-show="isClosed(vm.wednesday)">CLOSED</h4></div></div></uib-tab><uib-tab select=""><uib-tab-heading class="text-primary">Thursday</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="">Business hours for <span class="text-danger">Thursday</span></h4></div></div><div class="row"><br><div class="col-lg-4"><form name="customerForm" class="form-horizontal"><div class="col-lg-12"><div class="form-group"><label class="col-sm-3 control-label">From</label><div class="col-sm-9"><select class="form-control" ng-model="vm.fromTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><div class="form-group"><label class="col-sm-3 control-label">To</label><div class="col-sm-9"><select class="form-control" ng-model="vm.toTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><button type="button" class="btn btn-primary col-lg-12" ng-click="addWorkingHours(4)" ng-disabled="vm.synchronizeWithClover || !(vm.fromTime!=\'-1\') || !(vm.toTime!=\'-1\')">ADD</button></div></form></div><div class="col-lg-6 col-lg-offset-1"><table class="table table-hover" ng-show="!isClosed(vm.thursday)"><thead><tr><th>From</th><th>To</th><th>Action</th></tr></thead><tbody><tr ng-repeat="day in vm.thursday"><td>{{day.fromHour12}}</td><td>{{day.endHour12}}</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="deleteWorkingHours(day.id)" ng-disabled="vm.synchronizeWithClover"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table><h4 class="text-danger text-center lg-col-12" ng-show="isClosed(vm.thursday)">CLOSED</h4></div></div></uib-tab><uib-tab select=""><uib-tab-heading class="text-primary">Friday</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="">Business hours for <span class="text-danger">Friday</span></h4></div></div><div class="row"><br><div class="col-lg-4"><form name="customerForm" class="form-horizontal"><div class="col-lg-12"><div class="form-group"><label class="col-sm-3 control-label">From</label><div class="col-sm-9"><select class="form-control" ng-model="vm.fromTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><div class="form-group"><label class="col-sm-3 control-label">To</label><div class="col-sm-9"><select class="form-control" ng-model="vm.toTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><button type="button" class="btn btn-primary col-lg-12" ng-click="addWorkingHours(5)" ng-disabled="vm.synchronizeWithClover || !(vm.fromTime!=\'-1\') || !(vm.toTime!=\'-1\')">ADD</button></div></form></div><div class="col-lg-6 col-lg-offset-1"><table class="table table-hover" ng-show="!isClosed(vm.friday)"><thead><tr><th>From</th><th>To</th><th>Action</th></tr></thead><tbody><tr ng-repeat="day in vm.friday"><td>{{day.fromHour12}}</td><td>{{day.endHour12}}</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="deleteWorkingHours(day.id)" ng-disabled="vm.synchronizeWithClover"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table><h4 class="text-danger text-center lg-col-12" ng-show="isClosed(vm.friday)">CLOSED</h4></div></div></uib-tab><uib-tab select=""><uib-tab-heading class="text-primary">Saturday</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="">Business hours for <span class="text-danger">Saturday</span></h4></div></div><div class="row"><br><div class="col-lg-4"><form name="customerForm" class="form-horizontal"><div class="col-lg-12"><div class="form-group"><label class="col-sm-3 control-label">From</label><div class="col-sm-9"><select class="form-control" ng-model="vm.fromTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><div class="form-group"><label class="col-sm-3 control-label">To</label><div class="col-sm-9"><select class="form-control" ng-model="vm.toTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><button type="button" class="btn btn-primary col-lg-12" ng-click="addWorkingHours(6)" ng-disabled="vm.synchronizeWithClover || !(vm.fromTime!=\'-1\') || !(vm.toTime!=\'-1\')">ADD</button></div></form></div><div class="col-lg-6 col-lg-offset-1"><table class="table table-hover" ng-show="!isClosed(vm.saturday)"><thead><tr><th>From</th><th>To</th><th>Action</th></tr></thead><tbody><tr ng-repeat="day in vm.saturday"><td>{{day.fromHour12}}</td><td>{{day.endHour12}}</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="deleteWorkingHours(day.id)" ng-disabled="vm.synchronizeWithClover"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table><h4 class="text-danger text-center lg-col-12" ng-show="isClosed(vm.saturday)">CLOSED</h4></div></div></uib-tab><uib-tab select=""><uib-tab-heading class="text-primary">Sunday</uib-tab-heading><div class="row"><div class="col-lg-12"><br><h4 class="">Business hours for <span class="text-danger">Sunday</span></h4></div></div><div class="row"><br><div class="col-lg-4"><form name="customerForm" class="form-horizontal"><div class="col-lg-12"><div class="form-group"><label class="col-sm-3 control-label">From</label><div class="col-sm-9"><select class="form-control" ng-model="vm.fromTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><div class="form-group"><label class="col-sm-3 control-label">To</label><div class="col-sm-9"><select class="form-control" ng-model="vm.toTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change="" ng-disabled="vm.synchronizeWithClover"><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><button type="button" class="btn btn-primary col-lg-12" ng-click="addWorkingHours(7)" ng-disabled="vm.synchronizeWithClover || !(vm.fromTime!=\'-1\') || !(vm.toTime!=\'-1\')">ADD</button></div></form></div><div class="col-lg-6 col-lg-offset-1"><table class="table table-hover" ng-show="!isClosed(vm.sunday)"><thead><tr><th>From</th><th>To</th><th>Action</th></tr></thead><tbody><tr ng-repeat="day in vm.sunday"><td>{{day.fromHour12}}</td><td>{{day.endHour12}}</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="deleteWorkingHours(day.id)" ng-disabled="vm.synchronizeWithClover"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table><h4 class="text-danger text-center lg-col-12" ng-show="isClosed(vm.sunday)">CLOSED</h4></div></div></uib-tab></uib-tabset></div></div></div><br><div class="row"><div class="col-md-12"><div class="ibox-content"><div class="row"><div class="col-lg-12"><h3>Special working days</h3><small>Day(s) with business hours different from normal working days.</small><br><br></div></div><div class="row"><div class="col-lg-5"><form name="specialWorkingDay" class="form-horizontal"><div class="row"><div class="col-lg-12"><div class="form-group"><label class="col-sm-3 control-label">Date</label><div class="col-sm-9"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openDatePicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="select date" name="datePicker" type="text" class="form-control" ng-model="vm.selectedDayFormatted" close-text="Close"></div></div></div><div class="form-group"><label class="col-sm-3 control-label">Description</label><div class="col-sm-9"><input placeholder="e.g. Christmas Eve" type="text" class="form-control" ng-model="vm.specialDateDescription" maxlength="64"></div></div><div class="form-group"><label class="col-sm-3 control-label">From</label><div class="col-sm-9"><select class="form-control" ng-model="vm.specialDateFromTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change=""><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><div class="form-group"><label class="col-sm-3 control-label">To</label><div class="col-sm-9"><select class="form-control" ng-model="vm.specialDateToTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change=""><option value="" disabled="disabled" selected="selected">Select time</option></select></div></div><button type="button" class="btn btn-primary col-lg-6 col-lg-offset-3" ng-click="addSpecialDayWorkingHours(8)" ng-disabled=" !vm.specialDateDescription || !(vm.specialDateFromTime!=\'-1\') || !(vm.specialDateToTime!=\'-1\')">ADD</button></div></div></form></div><div class="col-lg-7"><ul class="todo-list m-t ui-sortable"><li ng-repeat="specialDay in vm.specialDays"><span class="text-danger font-bold"><i class="fa fa-calendar"></i>&nbsp; {{formatDateForDisplay(specialDay.specialDate)}}</span> - {{specialDay.description}}<br><table class="table table-hover"><thead><tr><th>From</th><th>To</th><th>Action</th></tr></thead><tbody><tr ng-repeat="day in specialDay.businessHoursDTOList"><td>{{day.fromHour12}}</td><td>{{day.endHour12}}</td><td class="text-danger"><button type="button" class="btn btn-xs btn-danger" ng-click="deleteWorkingHours(day.id)"><i class="fa fa-times"></i><small> DELETE</small></button></td></tr></tbody></table></li></ul></div></div></div></div></div></div><div class="col-lg-5 col-md-5 col-sm-12"><div class="ibox-content"><h3>Non working days</h3><small>Day(s) when it will not be possible to create reservations.</small><br><br><div class="row"><div class="col-lg-4"><div class="form-group"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openDatePicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="select date" name="datePicker" type="text" class="form-control" ng-model="vm.selectedDayFormatted" close-text="Close"></div></div></div><div class="col-lg-6"><div class="form-group"><input placeholder="description, e.g. New Year\'s Day" type="text" class="form-control" ng-model="vm.description" maxlength="64"></div></div><div class="col-lg-2"><button type="button" class="btn btn-primary" ng-click="addNonWorkingDay()" ng-disabled="!vm.description">ADD</button></div></div><ul class="todo-list m-t ui-sortable"><li ng-repeat="nonWorking in vm.nonworkingDays"><span class="text-danger font-bold"><i class="fa fa-calendar"></i>&nbsp; {{formatDateForDisplay(nonWorking.nonWorkingDay)}}</span> - {{nonWorking.description}} <button type="button" class="btn btn-xs btn-danger pull-right" ng-click="deleteNonWorkingDay(nonWorking.id)"><i class="fa fa-times"></i><small> DELETE</small></button></li></ul></div><br></div></div></div></div></div>');
$templateCache.put('app/tables/dashboard/dashboard.html','<div class="wrapper wrapper-content"><div class="row" ng-show="openingHourNotDefined()"><div class="col-lg-12"><div class="widget yellow-bg text-center"><h4>WARNING: Business hours not defined. Occupancy rate calculation might be wrong. Please define business hours through Clover Setup and restart SeatOn app.</h4></div></div></div><div class="row"><div class="col-lg-12"><div class="" row><div class="col-lg-9"><div class="row"><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">TODAY</span><h5 class="text-navy">Revenue</h5></div><div class="ibox-content"><h1 class="no-margins">{{ dashboard.todayData.totalDayOccupancy.revenue | currency}}</h1><br>Avg revenue per visit <span class="text-danger">{{ dashboard.todayData.totalDayOccupancy.avgRevenuePerVisit | currency}}</span><level-pct class="font-bold pull-right text-navy" val1="dashboard.todayData.totalDayOccupancy.avgRevenuePerVisit" val2="dashboard.lastWeekDayData.totalDayOccupancy.avgRevenuePerVisit" desc="Today avg revenue per visit compared to avg revenue per visit before 7 days."></level-pct></div></div></div><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">TODAY</span><h5 class="">Visits</h5></div><div class="ibox-content"><h1 class="no-margins">{{ dashboard.todayData.totalDayOccupancy.totalVisits + dashboard.todayData.countStats.activeVisits | number}} ({{ dashboard.todayData.totalDayOccupancy.totalCovers + dashboard.todayData.countStats.occupiedSeats | number}}<stran stext="person" type="p"></stran>)</h1><br># of currently occupied tables <span class="text-danger">{{ dashboard.todayData.countStats.occupiedTables | number}}</span> ({{ dashboard.todayData.countStats.occupiedSeats | number}}<stran stext="person" type="p"></stran>)</div></div></div><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">TODAY</span><h5 class="">Expected visits</h5></div><div class="ibox-content"><h1 class="no-margins">{{ dashboard.todayData.countStats.expectedVisits | number}} ({{ dashboard.todayData.countStats.expectedCovers | number}}<stran stext="person" type="p"></stran>)</h1><br><span class="text-danger">{{ dashboard.todayData.countStats.waitlistNumber | number}}</span> ({{ dashboard.todayData.countStats.waitListCovers | number}}<stran stext="person" type="p"></stran>) waitlisted</div></div></div></div><div class="row"><div class="col-lg-12"><div class="panel white-panel"><div class="panel-body"><uib-tabset><uib-tab select="dashboard.tabChange(\'todayTab\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-pie-chart"></span> Today\'s performance</uib-tab-heading><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div google-chart chart="dashboard.chartObjectHours"></div></div></div><br><div class="row"><div class="col-lg-12"><h3 class="text-navy">Today\'s performance details</h3><br><table class="table table-hover"><thead><tr><th></th><th><h3 ng-if="dashboard.isMeal">Breakfast (Start of day - {{dashboard.todayData.mealTimes.breakfestEnd}})</h3><h3 ng-if="!dashboard.isMeal">Start of day - {{dashboard.todayData.mealTimes.breakfestEnd}}</h3></th><th><h3 ng-if="dashboard.isMeal">Lunch ({{dashboard.todayData.mealTimes.lunchStart}} - {{dashboard.todayData.mealTimes.lunchEnd}})</h3><h3 ng-if="!dashboard.isMeal">{{dashboard.todayData.mealTimes.lunchStart}} - {{dashboard.todayData.mealTimes.lunchEnd}}</h3></th><th><h3 ng-if="dashboard.isMeal">Dinner ({{dashboard.todayData.mealTimes.dinnerStart}} - End of day)</h3><h3 ng-if="!dashboard.isMeal">{{dashboard.todayData.mealTimes.dinnerStart}} - End of day</h3></th><th bgcolor="#f0ffff"><h3 class="text-danger">Total (*)</h3></th></tr></thead><tbody><tr><td class="text-right"><span class="text-warning font-bold"><small>OCCUPANCY<br>RATE</small></span></td><td><h3>{{ dashboard.todayData.occupancyBreakfast.occupancyPct | percentage:2}}</h3><small>#<stran stext="person"></stran>{{ dashboard.todayData.occupancyBreakfast.totalCovers | number}}</small><br></td><td><h3>{{ dashboard.todayData.occupancyLunch.occupancyPct | percentage:2}}</h3><small>#<stran stext="person"></stran>{{ dashboard.todayData.occupancyLunch.totalCovers | number}}</small><br></td><td><h3>{{ dashboard.todayData.occupancyDinner.occupancyPct | percentage:2}}</h3><small>#<stran stext="person"></stran>{{ dashboard.todayData.occupancyDinner.totalCovers | number}}</small><br></td><td bgcolor="#f0ffff"><h3>{{ dashboard.todayData.totalDayOccupancy.occupancyPct | percentage:2}}</h3><small>#<stran stext="person"></stran>{{ dashboard.todayData.totalDayOccupancy.totalCovers | number}} </small><small><level-pct class="font-bold pull-right text-danger" display="right" val1="dashboard.todayData.totalDayOccupancy.totalCovers" val2="dashboard.lastWeekDayData.totalDayOccupancy.totalCovers" desc="Today total compared to total before 7 days."></level-pct></small></td></tr><tr><td align="center"><i class="{{currencyIcon}} fa-2x text-navy"></i></td><td><h3>{{ dashboard.todayData.occupancyBreakfast.revenue | currency}}</h3><small>Avg per<stran stext="person" type="s"></stran>{{ dashboard.todayData.occupancyBreakfast.avgRevenuePerCover | currency}}</small></td><td><h3>{{ dashboard.todayData.occupancyLunch.revenue | currency}}</h3><small>Avg per<stran stext="person" type="s"></stran>{{ dashboard.todayData.occupancyLunch.avgRevenuePerCover | currency}}</small></td><td><h3>{{ dashboard.todayData.occupancyDinner.revenue | currency}}</h3><small>Avg per<stran stext="person" type="s"></stran>{{ dashboard.todayData.occupancyDinner.avgRevenuePerCover | currency}}</small></td><td bgcolor="#f0ffff"><h3>{{ dashboard.todayData.totalDayOccupancy.revenue | currency}}</h3><small>Avg per<stran stext="person" type="s"></stran>{{ dashboard.todayData.totalDayOccupancy.avgRevenuePerCover | currency}} </small><small><level-pct class="font-bold pull-right text-danger" display="right" val1="dashboard.todayData.totalDayOccupancy.avgRevenuePerCover" val2="dashboard.lastWeekDayData.totalDayOccupancy.avgRevenuePerCover" desc="Today avg revenue per person compared to avg revenue per person before 7 days."></level-pct></small></td></tr><tr><td align="center"><span class="text-navy font-bold"><small>TIPS</small></span></td><td><h3>{{ dashboard.todayData.occupancyBreakfast.tips | currency}}</h3><small>Avg per visit {{ dashboard.todayData.occupancyBreakfast.avgTipPerVisit | currency}} ({{ dashboard.todayData.occupancyBreakfast.avgTipPct | percentage:2}})</small></td><td><h3>{{ dashboard.todayData.occupancyLunch.tips | currency}}</h3><small>Avg per visit {{ dashboard.todayData.occupancyLunch.avgTipPerVisit | currency}} ({{ dashboard.todayData.occupancyLunch.avgTipPct | percentage:2}})</small></td><td><h3>{{ dashboard.todayData.occupancyDinner.tips | currency}}</h3><small>Avg per visit {{ dashboard.todayData.occupancyDinner.avgTipPerVisit | currency}} ({{ dashboard.todayData.occupancyDinner.avgTipPct | percentage:2}})</small></td><td bgcolor="#f0ffff"><h3>{{ dashboard.todayData.totalDayOccupancy.tips | currency}}</h3><small>Avg per visit {{ dashboard.todayData.totalDayOccupancy.avgTipPerVisit | currency}} ({{ dashboard.todayData.totalDayOccupancy.avgTipPct | percentage:2}}) </small><small><level-pct class="font-bold pull-right text-danger" display="right" val1="dashboard.todayData.totalDayOccupancy.avgTipPerVisit" val2="dashboard.lastWeekDayData.totalDayOccupancy.avgTipPerVisit" desc="Today avg tip per visit compared to avg tip per visit before 7 days."></level-pct></small></td></tr><tr><td align="center"><span class="text-danger font-bold"><small>NO<br>SHOW</small></span></td><td><h3>{{ dashboard.todayData.occupancyBreakfast.noShowPct | percentage:2}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.occupancyBreakfast.noShowCovers | number}}</small></td><td><h3>{{ dashboard.todayData.occupancyLunch.noShowPct | percentage:2}}</h3><small><stran stext="person" type="c"></stran>) {{ dashboard.todayData.occupancyLunch.noShowCovers | number}}</small></td><td><h3>{{ dashboard.todayData.occupancyDinner.noShowPct | percentage:2}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.occupancyDinner.noShowCovers | number}}</small></td><td bgcolor="#f0ffff"><h3>{{ dashboard.todayData.totalDayOccupancy.noShowPct | percentage:2}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.totalDayOccupancy.noShowCovers | number}} </small><small><level-pct invert="true" class="font-bold pull-right text-danger" display="right" val1="dashboard.todayData.totalDayOccupancy.noShowCovers" val2="dashboard.lastWeekDayData.totalDayOccupancy.noShowCovers" desc="Today No Show persons compared to No Show persons before 7 days."></level-pct></small></td></tr><tr><td align="center"><span class="text-navy font-bold"><small>RESERVATION<br>RATIO</small></span></td><td><h3>{{ dashboard.todayData.occupancyBreakfast.reservationRatio | percentage:2}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.occupancyBreakfast.reservationCoversCount | number}}</small></td><td><h3>{{ dashboard.todayData.occupancyLunch.reservationRatio | percentage:2}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.occupancyLunch.reservationCoversCount | number}}</small></td><td><h3>{{ dashboard.todayData.occupancyDinner.reservationRatio | percentage:2}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.occupancyDinner.reservationCoversCount | number}}</small></td><td bgcolor="#f0ffff"><h3>{{ dashboard.todayData.totalDayOccupancy.reservationRatio | percentage:2}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.totalDayOccupancy.reservationCoversCount | number}} </small><small><level-pct class="font-bold pull-right text-danger" display="right" val1="dashboard.todayData.totalDayOccupancy.reservationCoversCount" val2="dashboard.lastWeekDayData.totalDayOccupancy.reservationCoversCount" desc="Today number of persons through reservations compared to 7 days before ."></level-pct></small></td></tr><tr><td align="center"><span class="text-warning font-bold"><small>WAIT LIST</small></span></td><td><h3>{{ dashboard.todayData.occupancyBreakfast.waitlistEventsCount | number}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.occupancyBreakfast.waitlistCoversCount | number}}</small></td><td><h3>{{ dashboard.todayData.occupancyLunch.waitlistEventsCount | number}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.occupancyLunch.waitlistCoversCount | number}}</small></td><td><h3>{{ dashboard.todayData.occupancyDinner.waitlistEventsCount | number}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.occupancyDinner.waitlistCoversCount | number}}</small></td><td bgcolor="#f0ffff"><h3>{{ dashboard.todayData.totalDayOccupancy.waitlistEventsCount | number}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.totalDayOccupancy.waitlistCoversCount | number}} </small><small><level-pct class="font-bold pull-right text-danger" display="right" val1="dashboard.todayData.totalDayOccupancy.waitlistCoversCount" val2="dashboard.lastWeekDayData.totalDayOccupancy.waitlistCoversCount" desc="Today number of persons through waitlists compared to 7 days before ."></level-pct></small></td></tr></tbody></table><small class="pull-right text-danger">(*) compared to the last {{dashboard.lastWeekDay | amDateFormat: \'dddd\' }}</small></div></div><br><div class="row"><div class="col-lg-4"><div class="widget style1 navy-bg"><div class="row"><div class="col-xs-3"><i class="fa fa-group fa-3x"></i></div><div class="col-xs-9 text-right"><h2>{{ dashboard.todayData.regularsVisitsPct | percentage:2}}</h2><span class="font-bold">of today\'s visit(s) made by regulars</span></div></div></div></div><div class="col-lg-4"><div class="widget style1 navy-bg"><div class="row"><div class="col-xs-3"><i class="{{currencyIcon}} fa-3x"></i></div><div class="col-xs-9 text-right"><h2>{{ dashboard.todayData.regularsRevenuePct | percentage:2}}</h2><span class="font-bold">of today\'s revenue from regulars</span></div></div></div></div><div class="col-lg-4"><div class="widget style1 navy-bg"><div class="row"><div class="col-xs-3"><i class="fa fa-gittip fa-3x"></i></div><div class="col-xs-9 text-right"><h2>{{ dashboard.todayData.customersWithTipPct | percentage:2}}</h2><span class="font-bold">of today\'s customers left a tip</span></div></div></div></div></div><br></div></div></uib-tab><uib-tab select="dashboard.tabChange(\'visitTab\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-pie-chart"></span> Today\'s visit statistics</uib-tab-heading><div class="row"><div class="col-lg-12"><div class="panel white-panel"><div class="panel-body"><div class="row"><div class="col-lg-7"><br><br><h3><span class="text-navy font-bold">General visit statistics</span></h3><span class="label label-info pull-right">Overall</span><br><br><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th><th>#<stran stext="person" type="p"></stran></th><th>revenue</th><th>avg per visit</th></thead><tbody><tr><td>Reservation</td><td>{{dashboard.todayData.todayVisitStats.totalReservationShow | number}}</td><td>{{dashboard.todayData.todayVisitStatsPcts.totalReservationShowPerTotalVisitsPct | percentage:2}}</td><td>{{dashboard.todayData.todayVisitStats.totalReservationCover | number}}</td><td class="text-danger">{{dashboard.todayData.todayVisitStats.totalReservationSpend | currency}}</td><td>{{dashboard.todayData.todayVisitStats.avgReservationSpendPerVisit | currency}}</td></tr><tr><td>Walk-in seated</td><td>{{dashboard.todayData.todayVisitStats.totalWalkinSeated | number}}</td><td>{{dashboard.todayData.todayVisitStatsPcts.walkinSeatedPerTotalVisitsPct | percentage:2}}</td><td>{{dashboard.todayData.todayVisitStats.totalWalkinSeatedCover | number}}</td><td class="text-danger">{{dashboard.todayData.todayVisitStats.totalWalkinSeatedSpend | currency}}</td><td>{{dashboard.todayData.todayVisitStats.avgWalkinSeatedSpendPerVisit | currency}}</td></tr><tr><td>Walk-in wait listed</td><td>{{dashboard.todayData.todayVisitStats.totalWaitlistShow | number}}</td><td>{{dashboard.todayData.todayVisitStatsPcts.totalWaitlistShowPerTotalVisitsPct | percentage:2}}</td><td>{{dashboard.todayData.todayVisitStats.totalWaitlistCover | number}}</td><td class="text-danger">{{dashboard.todayData.todayVisitStats.totalWaitlistSpend | currency}}</td><td>{{dashboard.todayData.todayVisitStats.avgWaitlistSpendPerVisit | currency}}</td></tr><tr><th>Totals</th><th>{{dashboard.todayData.todayVisitStats.totalVisits | number}}</th><th>100%</th><th>{{dashboard.todayData.todayVisitStats.totalCovers | number}}</th><th class="text-danger">{{dashboard.todayData.todayVisitStats.totalSpend | currency}}</th><th>{{dashboard.todayData.todayVisitStats.avgSpendByVisit | currency}}</th></tr></tbody></table></div><div class="col-lg-5 -align-center borders" style="overflow-x: auto; overflow-y: hidden"><span ng-if="dashboard.chartObjectVisitGeneral"><include-pie-chart piechartdata="dashboard.chartObjectVisitGeneral"></span></div></div></div></div></div></div><div class="row"><div class="col-lg-6"><div class="panel white-panel"><div class="panel-heading"><h3><span class="font-bold text-navy">Reservation statistics</span></h3><span class="label label-info pull-right">Overall</span></div><div class="panel-body"><div class="row"><div class="col-lg-12"><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th></thead><tbody><tr><td>Show</td><td>{{dashboard.todayData.todayVisitStats.totalReservationShow | number}}</td><td>{{dashboard.todayData.todayVisitStatsPcts.totalReservationShowPct | percentage:2}}</td></tr><tr><td>No Show</td><td>{{dashboard.todayData.todayVisitStats.totalReservationNoShow | number}}</td><td>{{dashboard.todayData.todayVisitStatsPcts.totalReservationNoShowPct | percentage:2}}</td></tr><tr><td>Cancelation</td><td>{{dashboard.todayData.todayVisitStats.totalReservationCanceled | number}}</td><td>{{dashboard.todayData.todayVisitStatsPcts.totalReservationCanceledPct | percentage:2}}</td></tr><tr><th>Totals</th><th>{{dashboard.todayData.todayVisitStats.totalReservation}}</th><th>100%</th></tr></tbody></table></div></div><div class="row"><div class="col-lg-12"><span ng-if="dashboard.chartObjectReservationGeneral"><include-pie-chart piechartdata="dashboard.chartObjectReservationGeneral"></span></div></div></div></div></div><div class="col-lg-6"><div class="panel white-panel"><div class="panel-heading"><h3><span class="font-bold text-navy">Wait list statistics</span></h3><span class="label label-info pull-right">Overall</span></div><div class="panel-body"><div class="row"><div class="col-lg-12"><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th></thead><tbody><tr><td>Show</td><td>{{dashboard.todayData.todayVisitStats.totalWaitlistShow | number}}</td><td>{{dashboard.todayData.todayVisitStatsPcts.totalWaitlistShowPct | percentage:2}}</td></tr><tr><td>No Show</td><td>{{dashboard.todayData.todayVisitStats.totalWaitlistNoShow | number}}</td><td>{{dashboard.todayData.todayVisitStatsPcts.totalWaitlistNoShowPct | percentage:2}}</td></tr><tr><td>Cancelation</td><td>{{dashboard.todayData.todayVisitStats.totalWaitlistCanceled | number}}</td><td>{{dashboard.todayData.todayVisitStatsPcts.totalWaitlistCanceledPct | percentage:2}}</td></tr><tr><th>Totals</th><th>{{dashboard.todayData.todayVisitStats.totalWaitlist}}</th><th>100%</th></tr></tbody></table></div></div><div class="row"><div class="col-lg-12"><span ng-if="dashboard.chartObjectWaitlistGeneral"><include-pie-chart piechartdata="dashboard.chartObjectWaitlistGeneral"></span></div></div></div></div></div></div></uib-tab><uib-tab select="dashboard.tabChange(\'todayVsTab\')"><uib-tab-heading class="bold text-navy"><span class="fa fa-bar-chart"></span> Today Vs. ...</uib-tab-heading><div class="row" ng-show="!dashboard.todayVsEnabled"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Performance details comparison of today versus the day of your choice in the past (yesterday, same day last week or any other day of your choice).<br><br><small>Follow this link to find more information about <a href="https://support.seaton.site/551222-Tables-Dashboard#TodaysPerformance" target="_blank">today performance comparison</a>.</small><br><br><button class="btn btn-danger" ng-click="dashboard.openWindow()" target="_blank">{{::dashboard.todayVsText}}</button><br><br><small></small><span class="text-success">Below you can see an example of the report.</span></div></div></div><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/TablesTodayVs.png" class="img-responsive"></div></div></div></div><div class="row" ng-show="dashboard.todayVsEnabled"><div class="col-lg-12"><div class="row"><div class="col-lg-8 col-md-6"><div class="btn-group"><br><br><label ng-model="dashboard.compareDaysBeforeButton" uib-btn-radio="1" class="btn btn-primary btn-outline" ng-change="dashboard.changedCompareDaysBeforeButton()" required><span>Yesterday</span><br></label><label ng-model="dashboard.compareDaysBeforeButton" uib-btn-radio="7" class="btn btn-primary btn-outline" ng-change="dashboard.changedCompareDaysBeforeButton()" required><span>Last {{dashboard.lastWeekDay | amDateFormat: \'dddd\' }}</span><br></label></div></div><div class="col-lg-4 col-md-6 pull-right"><br><br><div class="form-group"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="dashboard.openPicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="Or choose date to compare" type="text" class="form-control" name="comparedate" style="background-color: #FFF"></div></div></div></div><div class="row"><div class="col-lg-12"><div google-chart chart="dashboard.chartObjectCompare"></div></div></div><div class="row"><div class="col-lg-12"><br><h4 class="text-navy">Today vs {{dashboard.comparedDay | amDateFormat: \'dddd (Do MMM YY)\' }} comparison at {{dashboard.comparedDay | amDateFormat: \'h:mm a\' }}</h4></div></div><div class="row"><div class="col-lg-9 col-lg-offset-1"><table class="table table-hover"><thead><tr><th></th><th><h3>Today</h3></th><th><h3>{{dashboard.comparedDay | amDateFormat: \'dddd (Do MMM YY)\' }}</h3></th><th></th></tr></thead><tbody><tr><td class="text-right"><span class="text-warning font-bold"><small>OCCUPANCY<br>RATE</small></span></td><td><h3>{{ dashboard.todayData.totalDayOccupancy.occupancyPct | percentage:2}}</h3><small>#<stran stext="person"></stran>{{ dashboard.todayData.totalDayOccupancy.totalCovers | number}}</small><br></td><td><h3>{{ dashboard.comparedDayData.totalDayOccupancy.occupancyPct | percentage:2}}</h3><small>#<stran stext="person"></stran>{{ dashboard.comparedDayData.totalDayOccupancy.totalCovers | number}}</small><br></td><td><h3><level class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.occupancyPct-dashboard.comparedDayData.totalDayOccupancy.occupancyPct" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.occupancyPct,dashboard.comparedDayData.totalDayOccupancy.occupancyPct) | percentage:2 }}</level></h3><small><level class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.totalCovers-dashboard.comparedDayData.totalDayOccupancy.totalCovers" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.totalCovers,dashboard.comparedDayData.totalDayOccupancy.totalCovers) | percentage:2 }}</level></small></td></tr><tr><td align="center"><i class="{{currencyIcon}} fa-2x text-navy"></i></td><td><h3>{{ dashboard.todayData.totalDayOccupancy.revenue | currency}}</h3><small>Avg per<stran stext="person" type="s"></stran>{{ dashboard.todayData.totalDayOccupancy.avgRevenuePerCover | currency}}</small></td><td><h3>{{ dashboard.comparedDayData.totalDayOccupancy.revenue | currency}}</h3><small>Avg per<stran stext="person" type="s"></stran>{{ dashboard.comparedDayData.totalDayOccupancy.avgRevenuePerCover | currency}}</small></td><td><h3><level class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.revenue-dashboard.comparedDayData.totalDayOccupancy.revenue" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.revenue,dashboard.comparedDayData.totalDayOccupancy.revenue) | percentage:2 }}</level></h3><small><level class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.avgRevenuePerCover-dashboard.comparedDayData.totalDayOccupancy.avgRevenuePerCover" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.avgRevenuePerCover,dashboard.comparedDayData.totalDayOccupancy.avgRevenuePerCover) | percentage:2 }}</level></small></td></tr><tr><td align="center"><span class="text-navy font-bold"><small>TIPS</small></span></td><td><h3>{{ dashboard.todayData.totalDayOccupancy.tips | currency}}</h3><small>Avg per visit {{ dashboard.todayData.totalDayOccupancy.avgTipPerVisit | currency}} ({{ dashboard.todayData.totalDayOccupancy.avgTipPct | percentage:2}})</small></td><td><h3>{{ dashboard.comparedDayData.totalDayOccupancy.tips | currency}}</h3><small>Avg per visit {{ dashboard.comparedDayData.totalDayOccupancy.avgTipPerVisit | currency}} ({{ dashboard.comparedDayData.totalDayOccupancy.avgTipPct | percentage:2}})</small></td><td><h3><level class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.tips-dashboard.comparedDayData.totalDayOccupancy.tips" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.tips,dashboard.comparedDayData.totalDayOccupancy.tips) | percentage:2 }}</level></h3><small><level class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.avgTipPerVisit-dashboard.comparedDayData.totalDayOccupancy.avgTipPerVisit" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.avgTipPerVisit,dashboard.comparedDayData.totalDayOccupancy.avgTipPerVisit) | percentage:2 }}</level></small></td></tr><tr><td align="center"><span class="text-danger font-bold"><small>NO<br>SHOW</small></span></td><td><h3>{{ dashboard.todayData.totalDayOccupancy.noShowPct | percentage:2}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.totalDayOccupancy.noShowCovers | number}}</small></td><td><h3>{{ dashboard.comparedDayData.totalDayOccupancy.noShowPct | percentage:2}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.comparedDayData.totalDayOccupancy.noShowCovers | number}}</small></td><td><h3><level invert="true" class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.noShowPct-dashboard.comparedDayData.totalDayOccupancy.noShowPct" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.noShowPct,dashboard.comparedDayData.totalDayOccupancy.noShowPct) | percentage:2 }}</level></h3><small><level invert="true" class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.noShowCovers-dashboard.comparedDayData.totalDayOccupancy.noShowCovers" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.noShowCovers,dashboard.comparedDayData.totalDayOccupancy.noShowCovers) | percentage:2 }}</level></small></td></tr><tr><td align="center"><span class="text-navy font-bold"><small>RESERVATION<br>RATIO</small></span></td><td><h3>{{ dashboard.todayData.totalDayOccupancy.reservationRatio | percentage:2}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.totalDayOccupancy.reservationCoversCount | number}}</small></td><td><h3>{{ dashboard.comparedDayData.totalDayOccupancy.reservationRatio | percentage:2}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.comparedDayData.totalDayOccupancy.reservationCoversCount | number}}</small></td><td><h3><level class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.reservationRatio-dashboard.comparedDayData.totalDayOccupancy.reservationRatio" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.reservationRatio,dashboard.comparedDayData.totalDayOccupancy.reservationRatio) | percentage:2 }}</level></h3><small><level class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.reservationCoversCount-dashboard.comparedDayData.totalDayOccupancy.reservationCoversCount" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.reservationCoversCount,dashboard.comparedDayData.totalDayOccupancy.reservationCoversCount) | percentage:2 }}</level></small></td></tr><tr><td align="center"><span class="text-warning font-bold"><small>WAITLIST</small></span></td><td><h3>{{ dashboard.todayData.totalDayOccupancy.waitlistEventsCount | number}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.todayData.totalDayOccupancy.waitlistCoversCount | number}}</small></td><td><h3>{{ dashboard.comparedDayData.totalDayOccupancy.waitlistEventsCount | number}}</h3><small><stran stext="person" type="c"></stran>{{ dashboard.comparedDayData.totalDayOccupancy.waitlistCoversCount | number}}</small></td><td><h3><level class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.waitlistEventsCount-dashboard.comparedDayData.totalDayOccupancy.waitlistEventsCount" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.waitlistEventsCount,dashboard.comparedDayData.totalDayOccupancy.waitlistEventsCount) | percentage:2 }}</level></h3><small><level class="font-bold text-navy" value="dashboard.todayData.totalDayOccupancy.waitlistCoversCount-dashboard.comparedDayData.totalDayOccupancy.waitlistCoversCount" display="right">{{ dashboard.calcPct(dashboard.todayData.totalDayOccupancy.waitlistCoversCount,dashboard.comparedDayData.totalDayOccupancy.waitlistCoversCount) | percentage:2 }}</level></small></td></tr></tbody></table></div></div></div></div></uib-tab></uib-tabset></div></div></div></div></div><div class="col-lg-3"><div class="row"><div class="col-lg-12"><table class="table"><thead><tr><th><h4 class="text-navy"><i class="fa fa-link"></i> Quick links</h4></th></tr></thead><tbody><tr><td>&nbsp;&nbsp;<a class="" ui-sref="tables.newreservation"><i class="fa fa-plus-square text-success"></i>&nbsp;&nbsp;Create new reservation</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref="tables.addtowaitlist"><i class="fa fa-plus-square text-success"></i>&nbsp;&nbsp;Add to waitlist</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref="tables.management({tab: \'walkin\'})"><i class="fa fa-info-circle text-info"></i>&nbsp;&nbsp;Show available tables</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref="tables.management({tab: \'arrivals\'})"><i class="fa fa-info-circle text-info"></i>&nbsp;&nbsp;Show expected arrivals</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref="tables.management({tab: \'waitlist\'})"><i class="fa fa-info-circle text-info"></i>&nbsp;&nbsp;Show waitlist details</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref="tables.management({tab: \'walkout\'})"><i class="fa fa-info-circle text-info"></i>&nbsp;&nbsp;Show checkout list</a></td></tr></tbody></table></div></div><div class="row"><div class="col-lg-12"><div feedbacks-widget list-scope="location" title="Latest customer feedback" size="5"></div></div></div></div></div></div></div></div>');
$templateCache.put('app/tables/management/cancel.dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeCancelDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title" id="myModalLabel">Personalize cancel message to customer</h3><small>Predefined cancel message populated by default, if you don\'t want to personalize just press button send.</small></div><div class="modal-body"><div class="row" ng-if="vm.cancelCustomerEmail">Cancel notification email will be sent to customer <span class="text-navy">{{vm.cancelCustomerName}}</span> on <span class="text-navy">{{vm.cancelCustomerEmail}}.</span><br><br><textarea class="form-control" rows="10" placeholder="Write notification message to customer that reservation cannot be accommodated." ng-model="vm.cancelMessageText" maxlength="2048" ng-maxlength="2048"></textarea></div><div class="row" ng-if="!vm.cancelCustomerEmail"><span class="text-danger">Cancel notification cannot be sent since customer <span class="text-navy">{{vm.cancelCustomerName}}</span> does not have an email address defined in SeatoOn system.<br>Please notify customer through other channel directly.</span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeCancelDialog()">Do not cancel</button> <button ng-if="vm.cancelCustomerEmail" ng-disabled="!vm.cancelMessageText" type="button" class="btn btn-primary" ng-click="vm.cancelWithPersonalizedMessage()">Proceed with cancellation.</button></div>');
$templateCache.put('app/tables/management/management.html','<div class="wrapper wrapper-content" ng-scope><div class="row"><div class="col-lg-12"><div class="panel"><div class="panel-body"><uib-tabset active="vm.activeTab"><uib-tab select="vm.selectTab(0)"><uib-tab-heading class="font-bold text-navy" title="{{vm.arrivalsTotal}} expected arrival(s)"><span class=""></span>&nbsp;RESERVATIONS&nbsp;&nbsp; <span ng-if="!vm.tabTimeout(0,vm.timeNow)" class="badge badge-primary pull-right" data-toggle="tooltip" data-placement="right">{{vm.arrivalsTotal}}</span> <span ng-if="vm.tabTimeout(0,vm.timeNow)" class="badge pull-right" data-toggle="tooltip" data-placement="right">{{vm.arrivalsTotal}}</span></uib-tab-heading><br><div class="row"><div class="col-lg-6 col-sm-7"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-danger pull-right">Filter</span><h5 class="">Filter today\'s expected arrivals</h5></div><div class="ibox-content"><div class="row"><form class="form-horizontal"><div class="form-group"><label class="col-lg-2 control-label">Filter by</label><div class="col-lg-10"><div class="input-group m-b"><span class="input-group-addon"><i class="fa fa-filter"></i></span> <input ng-model="arrivalsFilter.keyword" placeholder="...search..." class="form-control"></div></div></div></form></div></div></div></div><div class="col-lg-3 col-sm-5"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Total</span><h5 class="">Today\'s expected arrivals</h5></div><div class="ibox-content"><h1 class="no-margins">{{vm.arrivalsTotal}}</h1><br>Number of overdue arrivals:&nbsp;<span class="text-danger">{{vm.arrivalsTotalOverdue}}</span></div></div></div><div class="col-lg-3 visible-lg-block"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Total</span><h5 class="">Today\'s expected<stran stext="person"></stran></h5></div><div class="ibox-content"><h1 class="no-margins">{{vm.arrivalsTotalCover}}</h1><br>Number of overdue<stran stext="person"></stran>:&nbsp;<span class="text-danger">{{vm.arrivalsTotalOverdueCover}}</span></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3 class="pull-left">Today\'s expected arrivals</h3><button class="btn btn-primary btn-outline pull-right" ng-click="vm.loadExpArrivals()"><i class="fa fa-refresh" ng-class="vm.isRefreshing ? \'fa-pulse\' : \'\'"></i> &nbsp;{{vm.refreshText}}</button></div><br><div class="ibox-content"><div class="row"><div class="col-lg-12"><h3 class="text-danger text-center font-bold" ng-if="vm.arrivals.length === 0">No expected arrivals for today.</h3><table ng-if="vm.arrivals.length > 0" class="table table-striped"><thead><tr><th><i class="fa fa-globe"></i>&nbsp;Channel</th><th><i class="fa fa-clock-o"></i>&nbsp;Arrival time</th><th><i class="fa fa-user"></i>&nbsp;Customer</th><th><i class="fa fa-phone"></i>&nbsp;Contact(s)</th><th class="hidden-xs"><i class="fa fa-info-circle"></i>&nbsp;Description</th><th><i class="fa fa-circle"></i>&nbsp;<stran stext="resource" type="c"></stran></th><th><i class=""></i></th><th><i class="fa fa-gears"></i>&nbsp;Actions</th></tr></thead><tbody><tr ng-repeat="arrival in vm.arrivals | filter : {$: arrivalsFilter.keyword, status: arrivalsFilter.status } "><td class="text-center"><span class="fa fa-2x {{channelIcon(arrival.channel)}} seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">{{channelToolTipText(arrival.channel)}}</span></span></td><td ng-class="arrival.overdue ? \'text-danger\' : \'text-navy\'" class="font-bold"><time am-time-ago="arrival.expectedStartTime"></time> @ {{arrival.expectedStartTime | amDateFormat: \'LT\'}}</td><td class="font-bold"><a ui-sref="customers.profile({customerId: arrival.customer.id})">{{arrival.customer.name}}&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></td><td><a href="mailto:{{arrival.customer.primaryEmail}}">{{arrival.customer.primaryEmail}}</a><br><a href="tel:{{arrival.customer.primaryPhone}}">{{arrival.customer.primaryPhone}}</a></td><td class="font-bold hidden-xs">{{arrival.description}}</td><td><span class="badge badge-success" ng-repeat="table in arrival.resources | orderBy: \'id\'">{{table.name}} ({{table.capacity}})</span></td><td class="font-bold"><a href="" ui-sref="tables.eventDetails({eventId: arrival.id})" ng-if="arrival.productModifiers"><span class="fa fa-shopping-cart text-danger seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">Modifiers added to the reservation</span> </span></a>&nbsp; <a href="" ui-sref="tables.eventDetails({eventId: arrival.id})" ng-if="arrival.note"><span class="fa fa-file-text-o text-warning seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">{{arrival.note}}</span></span></a></td><td><button type="submit" class="btn btn-primary btn-sm btn-outline" ng-click="vm.triggerShow(arrival.id, arrival.expectedStartTime)">Show</button> <button type="submit" class="btn btn-danger btn-sm btn-outline" ng-click="vm.triggerStateChange(arrival.id, \'NO_ARRIVAL\', \'Are you sure you want to remove this entry from expected arrivals (customer did not show up)?\')">No Show</button> <button type="submit" class="btn btn-danger btn-sm btn-outline" ng-click="vm.cancelEvent(arrival.id, arrival.customer.name, arrival.customer.primaryEmail)">Cancel</button> <button type="submit" class="btn btn-success btn-sm btn-outline" ui-sref="tables.eventDetails({eventId: arrival.id})">Details</button></td></tr></tbody></table></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectTab(1)"><uib-tab-heading class="font-bold text-info" title="{{vm.walkinsAvailableTables}} free tables ({{vm.walkinsAvailableSeats}} seats available)"><span class=""></span>&nbsp;WALK IN&nbsp;&nbsp; <span ng-if="!vm.tabTimeout(1,vm.timeNow)" class="badge badge-info pull-right" data-toggle="tooltip" data-placement="right">{{vm.walkinsAvailableTables}}</span> <span ng-if="vm.tabTimeout(1,vm.timeNow)" class="badge pull-right" data-toggle="tooltip" data-placement="right">{{vm.walkinsAvailableTables}}</span></uib-tab-heading><br><div class="row"><div class="col-lg-6 col-sm-7"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-danger pull-right">Filter</span><h5 class="">Filter available<stran stext="resource"></stran></h5></div><div class="ibox-content"><div class="row"><form class="form-horizontal"><div class="col-lg-12" ng-if="vm.isTableManaged"><label class="col-lg-3 control-label">Show only</label><div class="col-lg-9 input-group m-b"><span class="input-group-addon"><i class="fa fa-filter"></i></span><select ng-model="vm.walkinsFilterSeats" class="form-control" name="noSeats"><option value="0">all tables</option><option value="1">1 seat tables</option><option value="2">2 seat tables</option><option value="3">3 seat tables</option><option value="4">4 seat tables</option><option value="5">5 seat tables</option><option value="6">6 seat tables</option><option value="8">8 seat tables</option><option value="10">10 seat tables</option><option value="12">12 seat tables</option></select></div></div><div class="col-lg-12"><label class="col-lg-3 control-label">Available more than</label><div class="col-lg-9 input-group m-b"><span class="input-group-addon"><i class="fa fa-filter"></i></span><select ng-model="vm.walkinsFilterAvailableTime" class="form-control" name="noSeats"><option value="0">unlimited</option><option value="30">30 min</option><option value="60">1 hour</option><option value="90">1 hour 30 min</option><option value="120">2 hours</option><option value="150">2 hours 30 min</option><option value="180">3 hours</option><option value="210">3 hours 30 min</option><option value="240">4 hours</option></select></div></div></form></div></div></div></div><div class="col-lg-3 col-sm-5"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Total</span><h5 class="">Currently available</h5></div><div class="ibox-content"><h1 class="no-margins"><span class="text-navy">{{vm.walkinsAvailableTables}}</span><stran stext="resource"></stran></h1><br>Number of available<stran stext="capacity"></stran>:&nbsp;<span class="text-navy">{{vm.walkinsAvailableSeats}}</span></div></div></div><div class="col-lg-3 visible-lg-block"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Total</span><h5 class="">Currently occupied</h5></div><div class="ibox-content"><h1 class="no-margins"><span class="text-danger">{{vm.walkinsOccupiedTables}}</span><stran stext="resource"></stran></h1><br>Number of occupied<stran stext="capacity"></stran>:&nbsp;<span class="text-danger">{{vm.walkinsOccupiesSeats}}</span></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3 class="pull-left">Current<stran stext="resource"></stran>statuses</h3><button class="btn btn-primary btn-outline pull-right" ng-click="vm.loadWalkins()"><i class="fa fa-refresh" ng-class="vm.isRefreshing ? \'fa-pulse\' : \'\'"></i> &nbsp;{{vm.refreshText}}</button></div><br><div class="ibox-content"><div class="row"><div class="col-lg-12"><span class="pull-right text-danger font-2x"><span ng-if="vm.walkinsAvailableTables == 0">No<stran stext="resource"></stran>available at the moment.&nbsp;</span> <button ui-sref="tables.addtowaitlist()" ng-if="vm.walkinsAvailableTables == 0" class="btn btn-danger btn-outline"><i class="fa fa-plus-square-o"></i>&nbsp;Add to waitlist</button></span></div></div><br><div class="row"><div class="col-lg-1"></div><div class="col-lg-7"><table class="table table-striped"><thead><tr><th></th><th><i class="fa fa-circle"></i>&nbsp;<stran stext="resource" type="sc"></stran></th><th><i class="fa fa-info-circle"></i>&nbsp;Status</th><th><i class="fa fa-history"></i>&nbsp;Available time</th><th><i class="fa fa-clock-o"></i>&nbsp;Next book time</th></tr></thead><tbody><tr ng-repeat="table in vm.tables" ng-if="(table.resource.capacity >= vm.walkinsFilterSeats) && (vm.walkinsFilterAvailableTime == 0 || (table.availableTime >= vm.walkinsFilterAvailableTime && table.availableIn == 0))"><td><checkbox type="checkbox" ng-disabled="table.availableIn != 0" ng-model="table.selected"></checkbox></td><td class="font-bold" ng-style="{color:table.resource.areaColor}">{{table.resource.name}} ({{table.resource.capacity}}<stran stext="capacity" type="p"></stran>)</td><td ng-class="(table.availableIn == 0) ? (table.availableTime < 60 ? \'text-warning\' : \'text-navy\') : \'text-danger\'" class="font-bold">{{table.status}}</td><td><span ng-if="!table.nextBookTime">Till end of day</span><span ng-if="table.nextBookTime">{{vm.utils.formatMinutes(table.availableTime)}}</span></td><td><span ng-if="table.nextBookTime"><time am-time-ago="table.nextBookTime"></time> @ {{table.nextBookTime | amDateFormat: \'LT\'}}&nbsp;&nbsp; <a ng-if="!table.block" ui-sref="tables.eventDetails({eventId: table.nextBookEventId})"><i class="fa fa-info-circle"></i></a> <a ng-if="table.block" ui-sref="tables.block"><i class="fa fa-step-forward text-danger seaton-tooltip"><span class="seaton-tooltiptext seaton-tooltip-bottom">Block event</span> </i></a></span><span ng-if="!table.nextBookTime">Unknown</span></td></tr></tbody></table></div><div class="col-lg-3"><table class="table"><thead><tr><th colspan="3"><h3>Selected<stran stext="resource"></stran></h3></th></tr></thead><tbody><tr ng-if="vm.getWalkinsMaxCapacity() > 0"><td class="text-center"><h2 class="text-warning font-bold"><span ng-repeat="table in vm.tables | filter: {selected:true}">{{table.resource.name}}{{$last ? \'\' : \', \'}}</span></h2><h4>Maximum capacity: {{vm.getWalkinsMaxCapacity()}} persons</h4></td></tr><tr ng-if="vm.getWalkinsMaxCapacity() == 0"><td class="text-center"><h2 class="text-warning font-bold">None</h2></td></tr><tr><td class="text-center"><button ng-disabled="vm.getWalkinsMaxCapacity() == 0" type="submit" class="btn btn-primary ng-isolate-scop btn-lg" ng-click="vm.showWalkinDialog();">Create event</button></td></tr></tbody></table></div><div class="col-lg-1"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectTab(2)"><uib-tab-heading class="font-bold text-warning" title="{{vm.waitlistQueues.waitQueue.length}} customer waitlisted"><span class=""></span>&nbsp;WAITLIST&nbsp;&nbsp; <span ng-if="!vm.tabTimeout(2,vm.timeNow)" class="badge badge-warning pull-right" data-toggle="tooltip" data-placement="right">{{vm.waitlistQueues.waitQueue.length}}</span> <span ng-if="vm.tabTimeout(2,vm.timeNow)" class="badge pull-right" data-toggle="tooltip" data-placement="right">{{vm.waitlistQueues.waitQueue.length}}</span></uib-tab-heading><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3>Waitlist list management</h3></div><div class="ibox-content"><div class="row"><div class="col-lg-6"><table class="table" border="0"><thead><tr><th></th><th bgcolor="#f0f8ff">1-2 persons</th><th bgcolor="#f0f8ff">3-4 persons</th><th bgcolor="#f0f8ff">5+ persons</th></tr></thead><tbody><tr class=""><th>Current queue</th><td class="font-bold">{{vm.waitlistQueues.oneToTwoPerson}}</td><td class="font-bold">{{vm.waitlistQueues.threeToFourPerson}}</td><td class="font-bold">{{vm.waitlistQueues.fivePlusPerson}}</td></tr><tr class=""><th>Wait time (approximation)</th><td class="font-bold text-danger">{{vm.waitlistQueues.approxWaitTimeOneToTwo}} min</td><td class="font-bold text-danger">{{vm.waitlistQueues.approxWaitTimeThreeToFour}} min</td><td class="font-bold text-danger">{{vm.waitlistQueues.approxWaitTimeFivePlus}} min</td></tr></tbody></table></div><div class="col-lg-offset-2 col-lg-3"><button class="btn btn-danger btn-lg" ui-sref="tables.addtowaitlist()"><i class="fa fa-plus-square-o"></i>&nbsp;Add to waitlist</button> <button class="btn btn-primary btn-outline btn-lg" ng-click="vm.refreshWaitlistQueue()" data-toggle="modal"><i class="fa fa-refresh" ng-class="vm.isRefreshing ? \'fa-pulse\' : \'\'"></i> &nbsp;{{vm.refreshText}}</button></div></div></div></div></div></div><div class="row"><div class="col-lg-6"><div class="ibox float-e-margins"><div class="ibox-title"><h3>Current waitlist queue</h3></div><div class="ibox-content"><h3 class="text-danger text-center font-bold" ng-if="vm.waitlistQueues.waitQueue.length == 0">No customers in queue.</h3><table ng-if="vm.waitlistQueues.waitQueue.length > 0" class="table"><thead><tr><th><i class="fa fa-clock-o"></i>&nbsp;Waiting time</th><th><i class="fa fa-clock-o"></i>&nbsp;Quoted time</th><th><i class="fa fa-user"></i>&nbsp;Customer</th><th><i class="fa fa-group"></i>&nbsp;<stran stext="person" type="c"></stran></th><th><i class="fa fa-gears"></i>&nbsp;Actions</th></tr></thead><tbody><tr ng-repeat="entry in vm.waitlistQueues.waitQueue" class=""><td ng-class="entry.waitingTime > entry.quotedTime ? \'text-danger\' : \'text-navy\'" class="font-bold">{{entry.waitingTime}} min</td><td class="font-bold">{{entry.quotedTime}} min</td><td class="font-bold"><a ui-sref="customers.profile({customerId: entry.customerId})">{{entry.customerName}}&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></td><td class="font-bold">{{entry.numberOfPersons}}</td><td><button type="submit" class="btn btn-xs btn-warning btn-outline" ng-click="vm.waitlistNotify(entry.eventId, entry.numberOfPersons)" data-toggle="modal" data-target="#modalConfirm">Notify</button> <button type="submit" class="btn btn-xs btn-danger btn-outline" ng-click="vm.triggerStateChange(entry.eventId, \'CANCELLATION\', \'Are you sure you want to remove this customer from waitlist?\')" data-toggle="modal" data-target="#modalConfirm">Remove</button> <button type="submit" class="btn btn-xs btn-info btn-outline" ui-sref="tables.eventDetails({eventId: entry.eventId})">Details</button></td></tr></tbody></table></div></div></div><div class="col-lg-6"><div class="ibox float-e-margins"><div class="ibox-title"><h3>Expected waitlist arrivals</h3></div><div class="ibox-content"><h3 class="text-danger text-center font-bold" ng-if="vm.waitlistQueues.arrivalQueue.length == 0">No expected arrivals of waitlisted customers.</h3><table ng-if="vm.waitlistQueues.arrivalQueue.length > 0" class="table"><thead><tr><th><i class="fa fa-clock-o"></i>&nbsp;Notified before</th><th><i class="fa fa-info-circle"></i>&nbsp;Status</th><th><i class="fa fa-user"></i>&nbsp;Customer</th><th><i class="fa fa-circle"></i>&nbsp;<stran stext="resource" type="c"></stran></th><th><i class="fa fa-gears"></i>&nbsp;Actions</th></tr></thead><tbody><tr ng-repeat="entry in vm.waitlistQueues.arrivalQueue" class=""><td ng-class="entry.notifiedBefore > 10 ? \'text-danger\' : \'text-navy\'" class="font-bold">{{entry.notifiedBefore}} min</td><td ng-class="entry.status ? \'text-navy\' : \'text-danger\'" class="font-bold">{{entry.status ? \'Confirmed\' : \'Not confirmed\'}}</td><td class="font-bold"><a ui-sref="customers.profile({customerId: entry.customerId})">{{entry.customerName}}&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></td><td><span class="badge badge-success">{{entry.tables}}</span></td><td><button type="submit" class="btn btn-xs btn-primary btn-outline" ng-click="vm.triggerStateChange(entry.eventId, \'ARRIVAL\')">Show</button> <button type="submit" class="btn btn-xs btn-danger btn-outline" ng-click="vm.triggerStateChange(entry.eventId, \'NO_ARRIVAL\', \'Are you sure you want to remove this entry from expected arrivals (customer did not show up)?\')">No Show</button> <button type="submit" class="btn btn-xs btn-info btn-outline" ui-sref="tables.eventDetails({eventId: entry.eventId})">Details</button></td></tr></tbody></table></div></div></div></div></uib-tab><uib-tab select="vm.selectTab(3)"><uib-tab-heading class="font-bold text-danger" title="{{vm.activeEvents.length}} occupied table(s)"><span class=""></span>&nbsp;ACTIVE VISITS&nbsp;&nbsp; <span ng-if="!vm.tabTimeout(3,vm.timeNow)" class="badge badge-danger pull-right" data-toggle="tooltip" data-placement="right">{{vm.activeEvents.length}}</span> <span ng-if="vm.tabTimeout(3,vm.timeNow)" class="badge pull-right" data-toggle="tooltip" data-placement="right">{{vm.activeEvents.length}}</span></uib-tab-heading><br><div class="row"><div class="col-lg-6 col-sm-7"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-danger pull-right">Filter</span><h5 class="">Filter active visits</h5></div><div class="ibox-content"><div class="row"><form class="form-horizontal"><div class="form-group"><label class="col-lg-2 control-label">Filter by</label><div class="col-lg-10"><div class="input-group m-b"><span class="input-group-addon"><i class="fa fa-filter"></i></span> <input ng-model="walkoutFilter.keyword" placeholder="...search..." class="form-control" type="text"></div></div></div><div class="form-group"><label class="col-lg-2 control-label">Show only</label><div class="col-sm-3"><label class="checkbox-inline"><input ng-model="walkoutFilter.overdue" ng-false-value="undefined" type="checkbox" id="walkoutOverdueCheckbox" value="option1"> Overdue visits</label></div></div></form></div></div></div></div><div class="col-lg-3 col-sm-5"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Total</span><h5 class="">Occupied<stran stext="resource"></stran></h5></div><div class="ibox-content"><h1 class="no-margins">{{vm.walkoutTotal}}</h1><br>Number of overdue<stran stext="resource"></stran>:&nbsp;<span class="text-danger">{{vm.walkoutTotalOverdue}}</span></div></div></div><div class="col-lg-3 visible-lg-block"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Total</span><h5 class=""><stran stext="person" type="c"></stran></h5></div><div class="ibox-content"><h1 class="no-margins">{{vm.walkoutTotalCovers}}</h1><br>Number of overdue<stran stext="person"></stran>:&nbsp;<span class="text-danger">{{vm.walkoutTotalOverdueCovers}}</span></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3 class="pull-left">Active visits list</h3><button class="btn btn-primary btn-outline pull-right" ng-click="vm.loadWalkouts()"><i class="fa fa-refresh" ng-class="vm.isRefreshing ? \'fa-pulse\' : \'\'"></i> &nbsp;{{vm.refreshText}}</button></div><br><div class="ibox-content"><div class="row"><div class="col-lg-12"><h3 class="text-danger text-center font-bold" ng-if="vm.activeEvents.length === 0">No currently occupied<stran stext="resource"></stran>.</h3><table ng-if="vm.activeEvents.length > 0" class="table table-striped"><thead><tr><th><i class="fa fa-tag"></i>&nbsp;Type</th><th><i class="fa fa-clock-o"></i>&nbsp;Check in</th><th><i class="fa fa-clock-o"></i>&nbsp;Expected checkout</th><th class="hidden-md hidden-sm hidden-xs"><i class="fa fa-clock-o"></i>&nbsp;Estimated duration</th><th><i class="fa fa-history" data-toggle="tooltip"></i>&nbsp;Release in</th><th><i class="fa fa-user"></i>&nbsp;Customer</th><th class="hidden-md hidden-sm hidden-xs"><i class="fa fa-info-circle"></i>&nbsp;Description</th><th><i class="fa fa-circle"></i>&nbsp;<stran stext="resource" type="c"></stran></th><th><i class="fa fa-gears"></i>&nbsp;Actions</th></tr></thead><tbody><tr ng-repeat="event in vm.activeEvents | filter : {$: walkoutFilter.keyword, overdue: walkoutFilter.overdue } "><td><span ng-class="vm.utils.getEventTypeBkg(event.type)">{{vm.utils.formatEventType(event.type)}}</span></td><td class="">{{event.arrivalTime | amDateFormat: \'LT\'}}</td><td ng-class="event.overdue ? \'text-danger\' : \'text-navy\'" class="font-bold">{{event.expectedEndTime | amDateFormat: \'LT\'}}</td><td class="hidden-md hidden-sm hidden-xs">{{vm.utils.formatMinutes(event.expectedDuration)}}</td><td ng-class="event.overdue ? \'text-danger\' : \'text-navy\'"><time am-time-ago="event.expectedEndTime"></time></td><td class="font-bold"><a ng-if="event.customer" ui-sref="customers.profile({customerId: event.customer.id})">{{event.customer.name}}&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></td><td class="font-bold hidden-md hidden-sm hidden-xs">{{event.description}}</td><td><span class="badge badge-success" ng-repeat="table in event.resources | orderBy: \'id\'">{{table.name}} ({{table.capacity}})</span></td><td><button type="submit" class="btn btn-danger btn-sm btn-outline" ng-click="vm.releaseTable(event.id)" data-toggle="modal" data-target="#modalConfirmCheckOut">Release</button> <button type="submit" class="btn btn-success btn-sm btn-outline" ui-sref="tables.eventDetails({eventId: event.id})">Details</button></td></tr></tbody></table></div></div></div></div></div></div></uib-tab><uib-tab select="vm.selectTab(4)"><uib-tab-heading class="font-bold text-navy" title="{{vm.totalReservations}} online reservation request(s)"><span class=""></span>&nbsp;PRE-RESERVATIONS&nbsp;&nbsp; <span ng-if="!vm.tabTimeout(4,vm.timeNow)" class="badge badge-primary pull-right" data-toggle="tooltip" data-placement="right">{{vm.totalReservations}}</span> <span ng-if="vm.tabTimeout(4, vm.timeNow)" class="badge pull-right" data-toggle="tooltip" data-placement="right">{{vm.totalReservations}}</span></uib-tab-heading><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3 class="text-navy">Pre-reservation list</h3><small>List of reservation requests by your customers using the online reservation widget or IVR phone line for which<stran stext="resource" type="s"></stran>&nbsp;is not assign.</small><br><small>Please assign<stran stext="resource"></stran>&nbsp;to each request below. <strong>Once assigned, a reservation conformation message will be sent to customer</strong>.</small><br><small><b>Please note:</b> automatic<stran stext="resource"></stran>assignment can be setup in Settings/Online Reservation/Settings section.</small></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4>List of requested online/IVR reservations requiring your action (<stran stext="resource" type="s"></stran>&nbsp;assignment)</h4><button class="btn btn-primary btn-outline pull-right" ng-click="vm.getPreresevedReservations()"><i class="fa fa-refresh" ng-class="vm.isRefreshing ? \'fa-pulse\' : \'\'"></i> &nbsp;{{vm.refreshText}}</button></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><div class="text-danger text-center font-bold" ng-if="vm.totalReservations === 0"><h3>No reservations for the selected period.</h3></div><table ng-if="vm.totalReservations > 0" class="table table-striped"><thead><tr><th><i class="fa fa-globe"></i>&nbsp;Channel</th><th class="hidden-xs hidden-sm"><i class="fa fa-calendar"></i>&nbsp;Received</th><th><i class="fa fa-calendar"></i>&nbsp;Requested for</th><th><i class="fa fa-info-circle"></i>&nbsp;Verified</th><th><i class="fa fa-user"></i>&nbsp;Customer</th><th class="hidden-xs hidden-sm"><i class="fa fa-phone"></i>&nbsp;Contact(s)</th><th><i class="fa fa-info-circle"></i>&nbsp;Description</th><th></th><th><i class="fa fa-gears"></i>&nbsp;Actions</th></tr></thead><tbody><tr ng-repeat="reservation in vm.reservations"><td class="text-center"><span class="fa fa-2x {{channelIcon(reservation.channel)}} seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">{{channelToolTipText(reservation.channel)}}</span></span></td><td ng-class="text-navy" class="font-bold hidden-xs hidden-sm">{{reservation.createdDate | amDateFormat: \'D MMM YYYY @ h:mm A\'}}<br>({{ reservation.createdDate | amTimeAgo }})</td><td ng-class="text-navy" class="font-bold">{{reservation.expectedStartTime | amDateFormat: \'D MMM YYYY @ h:mm A\'}}</td><td ng-class="reservation.status === \'CONFIRMED\' ? \'text-navy\' : \'text-danger\'"><span ng-if="reservation.status == \'PRERESERVED\'">No</span> <span ng-if="reservation.status == \'CONFIRMED\'">Yes</span></td><td class="font-bold"><a ui-sref="customers.profile({customerId: reservation.customer.id})">{{reservation.customer.name}}&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></td><td class="hidden-xs hidden-sm"><a href="mailto:{{reservation.customer.primaryEmail}}">{{reservation.customer.primaryEmail}}</a><br><a href="tel:{{reservation.customer.primaryPhone}}">{{reservation.customer.primaryPhone}}</a></td><td class="font-bold">{{reservation.description}} <span ng-if="reservation.seatingOptionLabel"><br>Customer choice: {{reservation.seatingOptionLabel}}</span></td><td class="font-bold"><a href="" ui-sref="tables.eventDetails({eventId: reservation.id})" ng-if="reservation.productModifiers"><span class="fa fa-shopping-cart text-danger seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">Modifiers added to the reservation</span> </span></a>&nbsp; <a href="" ui-sref="tables.eventDetails({eventId: reservation.id})" ng-if="reservation.note"><span class="fa fa-file-text-o text-warning seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">{{reservation.note}}</span></span></a></td><td><button type="submit" class="btn btn-info btn-sm btn-outline" ng-click="vm.findTables(reservation)">Assign<stran stext="resource"></stran></button> <button type="submit" class="btn btn-danger btn-sm btn-outline" ng-click="vm.cancelEvent(reservation.id, reservation.customer.name, reservation.customer.primaryEmail)">Cancel</button> <button type="submit" class="btn btn-success btn-sm btn-outline" ui-sref="tables.eventDetails({eventId: reservation.id})">Details</button></td></tr></tbody></table><div class="text-center" ng-if="vm.totalReservations > 0"><div class="info font-bold">Showing {{((vm.currentPage-1)*vm.itemsPerPage) + 1}} - {{((vm.currentPage-1)*vm.itemsPerPage)+vm.reservations.length}} of {{vm.totalReservations}} items.</div><ul uib-pagination boundary-links="true" direction-links="true" total-items="vm.totalReservations" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" ng-change="vm.pageChanged()"></ul></div></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div></div></div>');
$templateCache.put('app/tables/management/waitlist.notify.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeWaitlistNotifyDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title" id="myModalLabel">Please assign<stran stext="resource"></stran>to customer</h3></div><div class="modal-body"><div class="row"><div class="col-sm-12"><table class="table table-striped"><thead><tr><th></th><th><i class="fa fa-circle"></i>&nbsp;<stran stext="resource" type="sc"></stran></th><th><i class="fa fa-info-circle"></i>&nbsp;Status</th><th><i class="fa fa-history"></i>&nbsp;Available time</th></tr></thead><tbody><tr ng-repeat="table in vm.tables" ng-if="table.availableIn == 0"><td><checkbox type="checkbox" ng-model="table.selected"></checkbox></td><td class="font-bold" ng-style="{color:table.resource.areaColor}">{{table.resource.name}} ({{table.resource.capacity}} seats)</td><td ng-class="(table.availableIn == 0) ? (table.availableTime < 60 ? \'text-warning\' : \'text-navy\') : \'text-danger\'" class="font-bold">{{table.status}}</td><td><span ng-if="!table.nextBookTime">Till end of day</span><span ng-if="table.nextBookTime">{{vm.utils.formatMinutes(table.availableTime)}}</span></td></tr></tbody></table></div></div><div class="row"><div class="col-lg-4"><h4>Please select{{vm.selectText()}}:</h4></div></div><div class="row"><div class="col-lg-7"><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label ng-repeat="product in vm.settings.shortProductList" uib-btn-radio="product.id" ng-change="vm.changeDuration(vm.waitlistProductId)" ng-model="vm.waitlistProductId" class="btn btn-sm btn-primary btn-outline" title="Select product" style="margin: 1px">{{product.nameWithDuration}}</label></div></div></div><div class="col-lg-5"><div class="form-group" ng-if="vm.settings.selectProductList.length > 0"><div class="input-group time"><span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-hourglass-1"></i></button></span><select ng-model="vm.waitlistProductId" class="form-control" ng-options="product.id as product.name for product in vm.settings.selectProductList" ng-change="vm.changeDuration(vm.waitlistProductId)" placeholder="... or select alternative" name="duration_element"><option value="">... or select alternative</option></select></div></div></div></div></div><div class="modal-footer"><div uib-alert ng-if="vm.getWalkinsMaxCapacity() == 0" class="alert-danger" close="closeAlert(0)">Please select one or more<stran stext="resource" type="p"></stran>.</div><div uib-alert ng-if="vm.getWalkinsMaxCapacity() > 0 && vm.getWalkinsMaxCapacity() < vm.waitlistSelectedNumberOfPersons" class="alert-danger" close="closeAlert(0)">Total capacity of selected<stran stext="resource"></stran>({{vm.getWalkinsMaxCapacity()}}) is not enough to accommodate {{vm.waitlistSelectedNumberOfPersons}} persons.</div><div uib-alert ng-if="vm.isAvailableTimeTooShort()" class="alert-warning" close="closeAlert(0)">Selected<stran stext="resource" type="p"></stran>are available only for the next {{vm.getSelectedTablesAvailTime()}} minutes, which is less that the selected duration ({{vm.eventDuration}} min).</div><div uib-alert ng-if="!vm.waitlistProductId" class="alert-danger" close="closeAlert(0)">Please select{{vm.selectText()}}.</div><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeWaitlistNotifyDialog()">Close</button> <button ng-disabled="vm.getWalkinsMaxCapacity() < vm.waitlistSelectedNumberOfPersons || vm.eventDuration > vm.getSelectedTablesAvailTime() || !vm.waitlistProductId" type="button" class="btn btn-primary" ng-click="vm.waitlistNotifyCustomer()">Notify customer</button></div>');
$templateCache.put('app/tables/management/walkins.dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeWalkinDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title" id="myModalLabel">Create new walkin</h3></div><div class="modal-body"><div class="row"><h4 class="control-label">Select number of persons (*):</h4></div><div class="row"><div class="col-sm-7"><div class="btn-group form-group" data-toggle="buttons"><label ng-repeat="capacity in [1, 2, 3, 4, 5, 6]" uib-btn-radio="capacity" ng-model="vm.walkinForm.noOfPersons" class="btn btn-primary btn-outline" style="margin: 2px"><input type="radio" name="capacity" value="{{capacity}}" checked="checked"> {{capacity}} <i class="fa fa-user"></i></label></div></div><div class="col-sm-5"><div class="input-group pull-right"><span class="input-group-addon" id="basic-addon1"><i class="fa fa-group"></i></span> <input type="number" min="1" ng-model="vm.walkinForm.noOfPersons" class="form-control" placeholder="Define number of persons" aria-describedby="basic-addon1"></div></div></div><div class="row"><hr style="margin-bottom: 0; margin-top: 0"><h4>Please select{{vm.selectText}}:</h4></div><div class="row"><div class="col-lg-7"><div class="row"><div class="col-lg-12 btn-group" data-toggle="buttons"><label ng-repeat="product in vm.settings.shortProductList" uib-btn-radio="product.id" ng-change="vm.changeDuration(vm.walkinForm.productId)" ng-model="vm.walkinForm.productId" class="btn btn-sm btn-primary btn-outline" title="Select product" style="margin: 1px">{{product.nameWithDuration}}</label></div></div></div><div class="col-lg-5"><div class="form-group" ng-if="vm.settings.selectProductList.length > 0"><div class="input-group time"><span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-hourglass-1"></i></button></span><select ng-model="vm.walkinForm.productId" class="form-control" ng-options="product.id as product.nameWithDuration for product in vm.settings.selectProductList" ng-change="vm.changeDuration(vm.walkinForm.productId)" placeholder="... or select alternative" name="duration_element"><option value="">... or select alternative</option></select></div></div></div></div><div class="row"><hr style="margin-bottom: 0; margin-top: 0"><h4>Assign customer (optional):</h4><form name="form"><div class="col-lg-9"><div class="input-group"><span class="input-group-addon"><i class="fa fa-search"></i></span> <input name="keyword" ng-model="customerSearchKeyword" ng-required="true" ng-minlength="3" type="text" class="form-control" placeholder="...search customer by name, phone or email..."></div><p ng-if="form.keyword.$error.minlength" class="text-warning text-small">&nbsp;* at least 3 characters required</p><p ng-if="customerSearchKeyword || form.keyword.$error.required" style="color: white">_</p></div><div class="col-lg-3 pull-right"><div class="btn-group btn-block"><button ng-disabled="!customerSearchKeyword" id="searchButton" type="submit" class="btn btn-block btn-default btn-outline" customer-search-dialog customer-search-keyword="customerSearchKeyword" customer-selected-callback="customerSelected"><i class="fa fa-search"></i>&nbsp;Search</button></div></div></form></div><div ng-if="!showWalkinCustomerForm" class="row"><div class="col-lg-12 btn-group"><button type="submit" class="btn btn-default btn-outline" ng-click="vm.showNewWalkinCustomerForm(true)"><i class="fa fa-plus" aria-hidden="true"></i>&nbsp;Add new customer</button></div></div><div ng-if="showWalkinCustomerForm" class="row"><div class="hr-line-dashed" style="margin: 0 0 15px 0"></div><form name="customerWalkinForm" class="form-horizontal"><div class="col-lg-12"><div class="form-group" ng-class="{ \'has-error\': customerWalkinForm.firstName.$invalid}"><label class="col-sm-3 control-label">First name (*)</label><div class="col-sm-9"><input name="firstName" ng-model="vm.walkinForm.customer.firstName" type="text" class="form-control" placeholder="...enter first name..." ng-required="true" ng-maxlength="64"></div></div><div class="form-group"><label class="col-sm-3 control-label">Last name</label><div class="col-sm-9"><input name="lastName" ng-model="vm.walkinForm.customer.lastName" type="text" class="form-control" placeholder="...enter last name..." ng-maxlength="128"></div></div><div class="form-group" ng-class="{ \'has-error\': (customerWalkinForm.primaryEmail.$invalid && customerWalkinForm.primaryPhone.$invalid) || customerWalkinForm.primaryEmail.$error.email}"><label class="col-sm-3 control-label">Email (*)</label><div class="col-sm-9"><div class="input-group m-b" style="margin: 0"><span class="input-group-addon">@</span> <input type="email" validate-email name="primaryEmail" ng-model="vm.walkinForm.customer.primaryEmail" class="form-control" placeholder="...enter email..." ng-required="true"></div></div></div><div class="form-group" ng-class="{ \'has-error\': customerWalkinForm.primaryEmail.$invalid && customerWalkinForm.primaryPhone.$invalid}"><label class="col-sm-3 control-label">Phone (*)</label><div class="col-sm-9"><div class="input-group m-b" style="margin: 0"><span class="input-group-addon"><i class="fa fa-phone" aria-hidden="true"></i></span><input id="primaryPhone" name="primaryPhone" ng-model="vm.walkinForm.customer.primaryPhone" size="35" class="form-control" model-view-value="true" ng-required="true" type="text" ng-intl-tel-input data-initial-country="{{vm.phoneRegion}}" data-default-country="{{vm.phoneRegion}}" ng-keyup="vm.reformatPhone()" placeholder="...enter phone number..."></div><div ng-if="customerWalkinForm.primaryEmail.$invalid && customerWalkinForm.primaryPhone.$invalid" class="text-danger">* either email or phone is required</div></div></div><div class="form-group"><label class="col-sm-3 control-label">Note:</label><div class="col-sm-9"><input ng-model="vm.walkinForm.customer.note" type="text" class="form-control" placeholder="...enter a note/remark about this customer..."></div></div><div ng-if="vm.walkinForm.customer.id" class="col-sm-12 pull-right"><a ui-sref="customers.profile({customerId: vm.walkinForm.customer.id})" target="_blank" class="btn btn-success btn-outline pull-right"><i class="fa fa-info-circle" aria-hidden="true"></i> View full customer profile</a></div><br></div></form></div><div class="row"><hr><h4>Enter note/remark (optional):</h4></div><div class="row"><div class="col-lg-12"><textarea class="form-control" rows="2" placeholder="... note or remark (optional) ..." ng-model="vm.walkinForm.note" ng-maxlength="512"></textarea></div></div></div><div class="modal-footer"><div uib-alert ng-if="vm.walkinForm.noOfPersons > vm.getWalkinsMaxCapacity()" class="alert-warning" close="closeAlert(0)"><stran stext="resource" type="sc"></stran>capacity ({{vm.getWalkinsMaxCapacity()}}) is not enough to accommodate {{vm.walkinForm.noOfPersons}} person(s).</div><div uib-alert ng-if="!vm.walkinForm.noOfPersons" class="alert-danger" close="closeAlert(0)">You need to select the number of persons.</div><div uib-alert ng-if="showWalkinCustomerForm" class="alert-danger" close="closeAlert(0)">Invalid email address.</div><div uib-alert ng-if="showWalkinCustomerForm && !vm.isWalkinFormCustomerDataFilled()" class="alert-danger" close="closeAlert(0)">Please fill in missing customer information.</div><div uib-alert ng-if="!vm.walkinForm.productId" class="alert-danger" close="closeAlert(0)">Please select{{vm.selectText()}}.</div><div uib-alert ng-if="vm.isAvailableTimeTooShort()" class="alert-warning" close="closeAlert(0)">Selected<stran stext="resource"></stran>are available only for the next {{vm.getSelectedTablesAvailTime()}} minutes, which is less that the selected duration ({{vm.eventDuration}} min).</div><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeWalkinDialog()">Close</button> <button ng-disabled="!vm.walkinForm.noOfPersons || vm.walkinForm.noOfPersons < 1 || (showWalkinCustomerForm && !vm.isWalkinFormCustomerDataFilled()) || !vm.walkinForm.productId" type="button" class="btn btn-primary" ng-click="vm.createWalkin()">Create</button></div>');
$templateCache.put('app/tables/management/walkout.option.select.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeWalkoutDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title" id="myModalLabel">Select checkout option</h3></div><div class="modal-body"><div class="row"><div class="col-lg-6"><form name="paymentInfo" class="form-horizontal"><div class="col-lg-12"><div class="form-group" ng-class="{ \'has-error\': paymentInfo.amount.$invalid}"><div class="row"><label class="col-sm-3 control-label">Amount:</label><div class="col-sm-9"><input name="amount" ng-model="vm.walkoutPaymentInfo.amount" ng-required="true" required class="form-control" placeholder="enter amount" type="number"></div></div></div><div class="form-group"><div class="row"><label class="col-sm-3 control-label">Tip:</label><div class="col-sm-9"><input name="tip" ng-model="vm.walkoutPaymentInfo.tip" class="form-control" placeholder="enter tip" type="number"></div></div></div></div><button type="button" class="btn btn-primary col-lg-12" ng-click="vm.walkoutWithPaymentInfo()">With payment information</button></form></div><div class="col-lg-6"><form class="form-horizontal"><div class="col-lg-12"><div class="form-group"><div class="row"><label class="col-sm-3 control-label">Amount:</label><div class="col-sm-9"><input name="amount" ng-disabled="true" value="UNKNOWN" class="form-control" type="text"></div></div></div><div class="form-group"><div class="row"><label class="col-sm-3 control-label">Tip:</label><div class="col-sm-9"><input name="tip" ng-disabled="true" value="UNKNOWN" class="form-control" type="text"></div></div></div></div><button type="button" class="btn btn-warning col-lg-12" ng-click="vm.walkoutNoPaymentInfo()">Without payment information</button></form></div></div></div>');
$templateCache.put('app/tables/online-res/assign.dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeWalkinDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title" id="myModalLabel">Assign table(s) to online reservation</h3><small>Confirm online reservation by assigning table(s) for required number of covers. After table(s) are assigned, confirmation email will be sent to customer.</small></div><div class="modal-body"><form method="post" class="form-horizontal"><div class="row"><div class="form-group"><label class="col-lg-3 control-label">Special request</label><div class="col-lg-9"><input type="text" disabled="" placeholder="Table in non smoking area please." class="form-control"></div></div></div><div class="row"><div class="form-group"><label class="col-lg-3 control-label">Duration</label><div class="col-lg-9"><div class="input-group m-b"><span class="input-group-addon"><i class="fa fa-hourglass-1"></i></span> <input class="form-control" placeholder="90" min="1" ng-min="1" aria-invalid="true" type="number"></div></div></div></div><div class="row"><div class="col-lg-8 col-lg-offset-2"><table class="table table-striped"><thead><tr><th><i class="text-center"></i>&nbsp;Requireed capacity</th><th><i class="text-center"></i>&nbsp;Assigned capcity</th></tr></thead><tbody><tr><td class="font-bold text-center">4 seats</td><td class="font-bold text-center">0 seats</td></tr></tbody></table></div></div><div class="row"><div class="col-sm-12"></div></div><div class="hr-line-dashed"></div><div class="row" style="overflow: auto"><div class="col-lg-12"><table class="table table-striped"><thead><tr><th></th><th><i class="fa fa-circle"></i>&nbsp;Table</th><th><i class="fa fa-info-circle"></i>&nbsp;Status</th><th><i class="fa fa-history"></i>&nbsp;Available time</th><th><i class="fa fa-clock-o"></i>&nbsp;Next book time</th></tr></thead><tbody><tr class="ng-scope"><td><button type="checkbox button" ng-style="stylebtn" class="btn btn-default"><span class="glyphicon" style="width: 6px; left: -1px"></span></button></td><td class="font-bold ng-binding">T1 (4 seats)</td><td class="font-bold ng-binding text-navy">Available now</td><td><span class="ng-scope">Till end of day</span></td><td><span class="ng-scope">Unknown</span></td></tr><tr class="ng-scope"><td><button type="checkbox button" ng-style="stylebtn" class="btn btn-default"><span class="glyphicon" style="width: 6px; left: -1px"></span></button></td><td class="font-bold ng-binding">T2 (4 seats)</td><td class="font-bold ng-binding text-navy">Available now</td><td><span class="ng-scope">Till end of day</span></td><td><span class="ng-scope">Unknown</span></td></tr><tr class="ng-scope"><td><button type="checkbox button" ng-style="stylebtn" class="btn btn-default"><span class="glyphicon" style="width: 6px; left: -1px"></span></button></td><td class="font-bold ng-binding">T3 (4 seats)</td><td class="font-bold ng-binding text-navy">Available now</td><td><span class="ng-scope">Till end of day</span></td><td><span class="ng-scope">Unknown</span></td></tr><tr class="ng-scope"><td><button type="checkbox button" ng-style="stylebtn" class="btn btn-default"><span class="glyphicon" style="width: 6px; left: -1px"></span></button></td><td class="font-bold ng-binding">T4 (4 seats)</td><td class="font-bold ng-binding text-navy">Available now</td><td><span class="ng-scope">Till end of day</span></td><td><span class="ng-scope">Unknown</span></td></tr><tr class="ng-scope"><td><button type="checkbox button" ng-style="stylebtn" class="btn btn-default"><span class="glyphicon" style="width: 6px; left: -1px"></span></button></td><td class="font-bold ng-binding">T5 (4 seats)</td><td class="font-bold ng-binding text-navy">Available now</td><td><span class="ng-scope">Till end of day</span></td><td><span class="ng-scope">Unknown</span></td></tr><tr class="ng-scope"><td><button type="checkbox button" ng-style="stylebtn" class="btn btn-default"><span class="glyphicon" style="width: 6px; left: -1px"></span></button></td><td class="font-bold ng-binding">T6 (4 seats)</td><td class="font-bold ng-binding text-navy">Available now</td><td><span class="ng-scope">Till end of day</span></td><td><span class="ng-scope">Unknown</span></td></tr><tr class="ng-scope"><td><button type="checkbox button" ng-style="stylebtn" class="btn btn-default"><span class="glyphicon" style="width: 6px; left: -1px"></span></button></td><td class="font-bold ng-binding">T7 (4 seats)</td><td class="font-bold ng-binding text-navy">Available now</td><td><span class="ng-scope">Till end of day</span></td><td><span class="ng-scope">Unknown</span></td></tr><tr class="ng-scope"><td><button type="checkbox button" ng-style="stylebtn" class="btn btn-default"><span class="glyphicon" style="width: 6px; left: -1px"></span></button></td><td class="font-bold ng-binding">T8 (4 seats)</td><td class="font-bold ng-binding text-navy">Available now</td><td><span class="ng-scope">Till end of day</span></td><td><span class="ng-scope">Unknown</span></td></tr><tr class="ng-scope"><td><button type="checkbox button" ng-style="stylebtn" class="btn btn-default"><span class="glyphicon" style="width: 6px; left: -1px"></span></button></td><td class="font-bold ng-binding">T9 (4 seats)</td><td class="font-bold ng-binding text-navy">Available now</td><td><span class="ng-scope">Till end of day</span></td><td><span class="ng-scope">Unknown</span></td></tr></tbody></table></div></div></form></div><div class="modal-footer"><div uib-alert class="alert-warning" close="closeAlert(0)">Assigned capacity 0 is not enough to seat 4 person(s).</div><div uib-alert class="alert-danger" close="closeAlert(0)">You need to define duration for this reservation.</div><div uib-alert class="alert-warning" close="closeAlert(0)">Selected tables are available only for the next {{vm.getSelectedTablesAvailTime()}} minutes, which is less that the current meal duration ({{vm.getCurrentMealDuration()}} min).</div><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeWalkinDialog()">Close</button> <button ng-disabled="!vm.walkinForm.noOfPersons || vm.walkinForm.noOfPersons < 1 || (showWalkinCustomerForm && !vm.isWalkinFormCustomerDataFilled()) || vm.walkinForm.duration > vm.getSelectedTablesAvailTime() " type="button" class="btn btn-primary" ng-click="vm.createWalkin()">Confirm reservation</button></div>');
$templateCache.put('app/tables/online-res/online-res.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3 class="text-navy">Online reservations overview</h3><small>List of reservation requested by your customer using online reservation widget.</small><br><small>Please assign table(s) to below listed online reservations. Once assigned notification will be sent to customer.</small></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4>List of requested online reservations which requires your action</h4></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><div class="text-danger text-center font-bold" ng-if="vm.totalItems === 0"><h3>No reservations for the selected period.</h3></div><table ng-if="vm.totalItems > 0" class="table table-striped"><thead><tr><th><i class="fa fa-calendar"></i>&nbsp;Reservation requested for</th><th><i class="fa fa-info-circle"></i>&nbsp;Waiting for confirmation</th><th><i class="fa fa-user"></i>&nbsp;Customer</th><th><i class="fa fa-phone"></i>&nbsp;Contact(s)</th><th><i class="fa fa-group"></i>&nbsp;Covers</th><th>About customer</th><th><i class="fa fa-gears"></i>&nbsp;Actions</th></tr></thead><tbody><tr ng-repeat="reservation in vm.reservations"><td ng-class="text-navy" class="font-bold">{{reservation.expectedStartTime | amDateFormat: \'D MMM YYYY @ h:mm A\'}}</td><td ng-class="reservation.status === \'CONFIRMED\' ? \'text-navy\' : \'text-danger\'"><span ng-if="reservation.status == \'PRERESERVED\'">Request email not yet verified</span> <span ng-if="reservation.status == \'CONFIRMED\'">{{vm.utils.formatMinutes(vm.diffInMinutes(reservation.createdDate))}}<br>(Web reservation verified)</span></td><td class="font-bold"><a ui-sref="customers.profile({customerId: reservation.customer.id})">{{reservation.customer.name}}&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></td><td><a href="mailto:{{reservation.customer.primaryEmail}}">{{reservation.customer.primaryEmail}}</a><br><a href="tel:{{reservation.customer.primaryPhone}}">{{reservation.customer.primaryPhone}}</a></td><td class="font-bold">{{reservation.numberOfPersons}}</td><td class="text-info">Total NoShow: {{reservation.customer.totalNoShow}}<br>Total visits: {{reservation.customer.totalVisits}}<br>Points: {{reservation.customer.totalPoints}}<br>Note: {{reservation.customer.note}}</td><td><button type="submit" class="btn btn-info btn-sm btn-outline" ng-click="vm.findTables(reservation)">Assign table(s)</button> <button type="submit" class="btn btn-danger btn-sm btn-outline" ng-click="vm.triggerStateChange(reservation.id, \'CANCELLATION\', \'Are you sure you want to cancel this reservation?\')">Cancel</button> <button type="submit" class="btn btn-success btn-sm btn-outline" ui-sref="tables.eventDetails({eventId: reservation.id})">Details</button></td></tr></tbody></table><div class="text-center" ng-if="vm.totalItems > 0"><div class="info font-bold">Showing {{((vm.currentPage-1)*vm.itemsPerPage) + 1}} - {{((vm.currentPage-1)*vm.itemsPerPage)+vm.reservations.length}} of {{vm.totalItems}} items.</div><ul uib-pagination boundary-links="true" direction-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" ng-change="vm.pageChanged()"></ul></div><div class="ibox-content"><div class="row"><div class="col-lg-8 col-lg-offset-2"><table class="table"><thead><tr><th colspan="4"><h4>Online reservation summary</h4></th></tr></thead><tbody><tr><td><button class="btn btn-outline btn-primary dim" type="button">{{vm.overview.reservations}}</button></td><td>Number of requested online reservations<br><small class="text-muted">Total number of online reservation request by customer via online reservation widget.</small></td><td><button class="btn btn-outline btn-danger dim" type="button"><i class="{{currencyIcon}}"></i></button></td><td><b>Estimated revenue <span class="text-danger">{{(vm.overview.avgRevenuePerCover * vm.overview.covers) | currency}}</span></b><br><small class="text-muted">Calculation based on historical information.</small></td></tr><tr><td><button class="btn btn-outline btn-primary dim" type="button">{{vm.overview.covers}}</button></td><td>Number of covers<br><small class="text-muted">Avg {{vm.overview.reservations == 0 ? \'0\' : (vm.overview.covers/vm.overview.reservations).toFixed(1)}} covers per reservation.</small></td><td><button class="btn btn-outline btn-danger dim" type="button"><i class="{{currencyIcon}}"></i></button></td><td><b>Estimated tips <span class="text-danger">{{(vm.overview.avgTipsPerCover * vm.overview.covers) | currency}}</span></b><br><small class="text-muted">Calculation based on historical information.</small></td></tr></tbody></table></div></div></div>TO BE DELETED (HTML ONLY):<table ng-if="vm.totalItems > 0" class="table table-striped"><thead><tr><th><i class="fa fa-calendar"></i>&nbsp;Reservation requested for</th><th><i class="fa fa-info-circle"></i>&nbsp;Waiting for confirmation</th><th><i class="fa fa-user"></i>&nbsp;Customer</th><th><i class="fa fa-phone"></i>&nbsp;Contact(s)</th><th><i class="fa fa-group"></i>&nbsp;Covers</th><th>About customer</th><th><i class="fa fa-gears"></i>&nbsp;Actions</th></tr></thead><tbody><tr class="ng-scope"><td ng-class="text-navy" class="font-bold ng-binding">9 Apr 2018 @ 6:30 PM</td><td class="ng-binding text-navy">1 hour(s) 34 minutes</td><td class="font-bold"><a ui-sref="customers.profile({customerId: reservation.customer.id})" class="ng-binding" href="#/customers/profile/223">Luetta Benoit&nbsp;&nbsp;</a><i class="fa fa-info-circle"></i> <sup class="text-danger text-superscript">NEW</sup></td><td class="ng-binding">LuettaBenoit@yopmail.com<br>(631) 296-2013</td><td class="font-bold ng-binding">4</td><td><strong class="text-navy">0.0 %</strong><br><small>no visits</small></td><td><button ng-click="vm.showAssignDialog();" type="submit" class="btn btn-info btn-sm btn-outline">Assign table(s)</button> <button type="submit" class="btn btn-danger btn-sm btn-outline">Cancel</button> <button type="submit" class="btn btn-success btn-sm btn-outline" ui-sref="tables.eventDetails({eventId: reservation.id})" href="#/tables/events/100011">Details</button></td></tr><tr class="ng-scope"><td ng-class="text-navy" class="font-bold ng-binding">9 Apr 2018 @ 7:30 PM</td><td ng-class="" class="ng-binding text-warning">2 hours 45 minutes</td><td class="font-bold"><a ui-sref="customers.profile({customerId: reservation.customer.id})" class="ng-binding" href="#/customers/profile/247">Booker Fraser&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></td><td class="ng-binding">BookerFraser@yopmail.com<br>(631) 296-2013</td><td class="font-bold ng-binding">2</td><td><strong class="text-warning">5.00 %</strong><br><small>3 no show out of 60 visits</small></td><td><button type="submit" class="btn btn-info btn-sm btn-outline">Assign table(s)</button> <button type="submit" class="btn btn-danger btn-sm btn-outline">Cancel</button> <button type="submit" class="btn btn-success btn-sm btn-outline" ui-sref="tables.eventDetails({eventId: reservation.id})" href="#/tables/events/100013">Details</button></td></tr><tr class="ng-scope"><td ng-class="text-navy" class="font-bold ng-binding">9 Apr 2018 @ 8:00 PM</td><td ng-class="reservation.status === \'CONFIRMED\' ? \'text-navy\' : \'text-danger\'" class="ng-binding text-danger">1 day 5 hour(s) 32 minutes</td><td class="font-bold"><a ui-sref="customers.profile({customerId: reservation.customer.id})" class="ng-binding" href="#/customers/profile/138">Johnathan Gonzalez&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></td><td class="ng-binding">JohnathanGonzalez@yopmail.com<br>(631) 296-2013</td><td class="font-bold ng-binding">2</td><td class="text-danger"><strong>20.00 %</strong><br><small>5 no show out of 25 visits</small></td><td><button type="submit" class="btn btn-info btn-sm btn-outline">Assign table(s)</button> <button type="submit" class="btn btn-danger btn-sm btn-outline">Cancel</button> <button type="submit" class="btn btn-success btn-sm btn-outline" ui-sref="tables.eventDetails({eventId: reservation.id})" href="#/tables/events/100012">Details</button></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/tables/overview/list.html','<div class="modal-header"><h3 class="modal-title text-navy" id="myModalLabel11"><div class="btn btn-sm btn-danger pull-right" ng-click="printElement()">PRINT</div></h3></div><div id="printThis"><div class="modal-header"><h3 ng-show="vm.viewType ==\'daily\'" class="modal-title text-navy" id="myModalLabel">Reservation list for {{vm.range.from | amDateFormat: \'dddd Do MMM YYYY\' }}</h3><h3 ng-show="vm.viewType ==\'weekly\'" class="modal-title text-navy" id="myModalLabel">Reservation list for period {{vm.range.from | amDateFormat: \'dddd Do MMM YYYY\' }} - {{vm.range.to | amDateFormat: \'dddd Do MMM YYYY\' }}</h3></div><div class="modal-body" id="tableToPrint"><div class="row"><div class="col-md-12"><div class="text-danger text-center font-bold" ng-if="vm.overview.reservations === 0"><h3>No reservations for the selected period.</h3></div><table ng-if="vm.overview.reservations > 0" class="table table-striped"><thead><tr><th><i class="fa fa-calendar"></i>&nbsp;Date and time</th><th><i class="fa fa-user"></i>&nbsp;Customer</th><th><i class="fa fa-phone"></i>&nbsp;Contact(s)</th><th><i class="fa fa-info-circle"></i>&nbsp;Description</th><th><i class="fa fa-circle"></i>&nbsp;<stran stext="resource" type="c"></stran></th><th><i class="fa fa-comment"></i>&nbsp;Note</th></tr></thead><tbody><tr ng-repeat="reservation in vm.reservations"><td ng-class="text-navy" class="font-bold">{{reservation.expectedStartTime | amDateFormat: \'D MMM YYYY @ h:mm A\'}}</td><td class="font-bold"><a ui-sref="customers.profile({customerId: reservation.customer.id})">{{reservation.customer.name}}&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></td><td>{{reservation.customer.primaryEmail}}<br>{{reservation.customer.primaryPhone}}</td><td><span class="font-bold">{{reservation.description}}</span></td><td class="text-info"><span ng-repeat="table in reservation.resources | orderBy: \'name\'">{{table.name}} ({{table.capacity}}){{$last ? \'\' : \',\'}}</span></td><td><span ng-if="!(reservation.note === null)">{{reservation.note}}.</span> <span ng-if="!(reservation.customer.note === null)">Customer note: {{reservation.customer.note}}</span></td></tr></tbody></table></div></div></div><div class="modal-footer"><small class="text-center">SeatOn Reservations 2022</small></div></div>');
$templateCache.put('app/tables/overview/overview.html','<div class="wrapper wrapper-content"><div class="row" ng-show="openingHourNotDefined()"><div class="col-lg-12"><div class="widget yellow-bg text-center"><h4>WARNING: Business hours not defined. Occupancy rate calculation might be wrong. Please define business hours through Clover Setup and restart SeatOn app.</h4></div></div></div><div class="row"><div class="col-lg-9"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3 class="text-navy">Upcoming reservations overview<div class="pull-right"><div class="btn btn-sm btn-info" ng-click="showReservationListForPrinting()">PRINT</div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<div class="btn-group"><label ng-model="vm.viewType" uib-btn-radio="\'daily\'" class="btn btn-primary btn-outline" ng-change="vm.reload(\'daily\')" required><span>Daily</span><br></label><label ng-model="vm.viewType" uib-btn-radio="\'weekly\'" class="btn btn-primary btn-outline" ng-change="vm.reload(\'weekly\')" required><span>Weekly</span><br></label></div></div></h3><small ng-show="vm.viewType ==\'daily\'">Showing details for selected day. Please select any other day for details. </small><small ng-show="vm.viewType ==\'weekly\'">Showing details for selected week. Please select any other week for details.</small></div><div class="ibox-content"><div class="row" ng-show="vm.viewType !=\'weekly\'"><div class="btn-group col-lg-8 col-md-6"><label ng-repeat="(day_name, day_data) in vm.ranges" uib-btn-radio="day_name" ng-model="vm.selectedRange" ng-change="vm.reload()" title="Select the day" class="btn btn-primary btn-outline"><span>{{day_data.label}}</span><br></label></div><div class="col-lg-4 col-md-6 pull-right"><div class="form-group"><div ng-show="vm.viewType !=\'weekly\'" class="input-group date"><span class="input-group-btn"><button type="button" ng-class="vm.selectedRange == \'custom\' ? \'btn-primary\' : \'btn-default\'" class="btn" ng-click="vm.openPicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="Or select another day" type="text" class="form-control" name="pickerDates" style="background-color: #FFF"></div></div></div></div><div class="row" ng-show="vm.viewType ==\'weekly\'"><div class="btn-group col-lg-12 col-md-6"><label ng-repeat="(day_name, day_data) in vm.ranges" uib-btn-radio="day_name" ng-model="vm.selectedRange" ng-change="vm.reload()" title="Select the day" class="btn btn-primary btn-outline"><span>{{day_data.label}}</span><br></label></div></div></div></div></div></div><div class="row" ng-show="vm.viewType !=\'weekly\'"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-9"><h4 class="font-bold no-margins">Expected occupancy rate for the selected day: <span class="text-danger">{{vm.hourData.dayNameFormatted }}</span></h4></div></div><div class="row"><div class="col-lg-12"><div class="dashboard-chart"><div google-chart chart="chartComboObjectOccupancyDay"></div></div></div></div><div class="row"><div class="col-lg-6 col-lg-offset-3"><br><table class="table"><tr><td class=""><span class="text-navy font-bold"><stran stext="capacity" type="SC"></stran>&nbsp;OCCUPANCY {{vm.hourData.totalDayOccupancy.occupancyPct | percentage:2 }}</span></td><td class=""><span class="text-danger font-bold"><stran stext="resource" type="SC"></stran>&nbsp;OCCUPANCY {{vm.hourData.totalDayOccupancy.occupancyTablePct | percentage:2 }}</span></td></tr></table></div></div></div></div></div></div><div class="row" ng-show="vm.viewType ==\'weekly\'"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-9"><h4 class="font-bold no-margins">Expected occupancy rate for the selected week: <span class="text-danger">{{vm.range.from | amDateFormat: \'dddd Do MMM YYYY\' }} - {{vm.range.to | amDateFormat: \'dddd Do MMM YYYY\' }}</span></h4></div></div><div class="row"><div class="col-lg-12"><div class="dashboard-chart"><div google-chart chart="chartComboObjectOccupancyWeek"></div></div></div></div><div class="row"><div class="col-lg-6 col-lg-offset-3"><br><table class="table"><tr><td class=""><span class="text-navy font-bold">SELECTED WEEK OCCUPANCY {{ vm.data.totalWeekOccupancy.occupancyPct | percentage:2}}</span></td><td class=""><span class="text-danger font-bold">WEEK BEFORE OCCUPANCY {{ vm.lastWeekData.totalWeekOccupancy.occupancyPct | percentage:2}}</span></td></tr></table></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h4 ng-show="vm.viewType !=\'weekly\'">List of reservations for selected day: <span class="text-danger">{{vm.range.from | amDateFormat: \'dddd Do MMM YYYY\' }}</span></h4><h4 ng-show="vm.viewType ==\'weekly\'">List of reservations for selected week: <span class="text-danger">{{vm.range.from | amDateFormat: \'dddd Do MMM YYYY\' }} - {{vm.range.to | amDateFormat: \'dddd Do MMM YYYY\' }}</span></h4></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><div class="text-danger text-center font-bold" ng-if="vm.overview.reservations === 0"><h3>No reservations for the selected period.</h3></div><table ng-if="vm.overview.reservations > 0" class="table table-striped"><thead><tr><th><i class="fa fa-globe"></i>&nbsp;Channel</th><th><i class="fa fa-calendar"></i>&nbsp;Date and time</th><th><i class="fa fa-user"></i>&nbsp;Customer</th><th><i class="fa fa-phone"></i>&nbsp;Contact(s)</th><th><i class="fa fa-info-circle"></i>&nbsp;Description</th><th><i class="fa fa-circle"></i>&nbsp;<stran stext="resource" type="c"></stran></th><th></th><th><i class="fa fa-gears"></i>&nbsp;Actions</th></tr></thead><tbody><tr ng-repeat="reservation in vm.reservations"><td class="text-center"><span class="fa fa-2x {{channelIcon(reservation.channel)}} seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">{{channelToolTipText(reservation.channel)}}</span></span></td><td ng-class="text-navy" class="font-bold">{{reservation.expectedStartTime | amDateFormat: \'D MMM YYYY @ h:mm A\'}}</td><td class="font-bold"><a ui-sref="customers.profile({customerId: reservation.customer.id})">{{reservation.customer.name}}&nbsp;&nbsp;<i class="fa fa-info-circle"></i></a></td><td><a href="mailto:{{reservation.customer.primaryEmail}}">{{reservation.customer.primaryEmail}}</a><br><a href="tel:{{reservation.customer.primaryPhone}}">{{reservation.customer.primaryPhone}}</a></td><td><span class="font-bold">{{reservation.description}}</span></td><td class="text-info"><span ng-repeat="table in reservation.resources | orderBy: \'name\'">{{table.name}} ({{table.capacity}}){{$last ? \'\' : \',\'}}</span></td><td class="font-bold"><a href="" ui-sref="tables.eventDetails({eventId: reservation.id})" ng-if="reservation.productModifiers"><span class="fa fa-shopping-cart text-danger seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">Modifiers added to the reservation</span> </span></a>&nbsp; <a href="" ui-sref="tables.eventDetails({eventId: reservation.id})" ng-if="reservation.note"><span class="fa fa-file-text-o text-warning seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">{{reservation.note}}</span></span></a></td><td><button type="submit" class="btn btn-success btn-sm btn-outline" ui-sref="tables.eventDetails({eventId: reservation.id})">Details</button> <button type="submit" class="btn btn-info btn-sm btn-outline" ui-sref="tables.rearrange({eventId: reservation.id})">Rearrange</button></td></tr></tbody></table><div class="text-center" ng-if="vm.totalItems > 0"><div class="info font-bold">Showing {{((vm.currentPage-1)*vm.itemsPerPage) + 1}} - {{((vm.currentPage-1)*vm.itemsPerPage)+vm.reservations.length}} of {{vm.totalItems}} items.</div><ul uib-pagination boundary-links="true" direction-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" ng-change="vm.pageChanged()"></ul></div></div></div></div></div></div></div></div><div class="col-lg-3 grey-bg"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><table class="table"><thead><tr><th colspan="2"><h3 ng-show="vm.viewType !=\'weekly\'" class="text-navy">Reservations for selected day</h3><h3 ng-show="vm.viewType ==\'weekly\'" class="text-navy">Reservations for selected week</h3></th></tr></thead><tbody><tr><td><button class="btn btn-outline btn-primary dim" type="button">{{vm.overview.reservations}}</button></td><td><b>Number of reservations</b><br><small class="text-muted">Total number of reservations.</small></td></tr><tr><td><button class="btn btn-outline btn-primary dim" type="button">{{vm.overview.covers}}</button></td><td><b>Number of<stran stext="person" type="p"></stran></b><br><small class="text-muted">Avg {{vm.overview.reservations == 0 ? \'0\' : (vm.overview.covers/vm.overview.reservations).toFixed(1)}}<stran stext="person" type="p"></stran>per reservation.</small></td></tr><tr><td><button class="btn btn-outline btn-danger dim" type="button"><i class="{{currencyIcon}}"></i></button></td><td><b>Estimated revenue <span class="text-danger">{{(vm.overview.avgRevenuePerCover * vm.overview.covers) | currency}}</span></b><br><small class="text-muted">Calculation based on historical information.</small></td></tr><tr><td><button class="btn btn-outline btn-danger dim" type="button"><i class="{{currencyIcon}}"></i></button></td><td><b>Estimated tips <span class="text-danger">{{(vm.overview.avgTipsPerCover * vm.overview.covers) | currency}}</span></b><br><small class="text-muted">Calculation based on historical information.</small></td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content ibox-heading"><table class="table"><thead><tr><th colspan="2"><h3 class="text-navy">All reservations</h3></th></tr></thead><tbody><tr><td><button class="btn btn-outline btn-primary dim" type="button">{{vm.overviewAll.reservations}}</button></td><td><b>Number of reservations</b><br><small class="text-muted">Total number of reservation.</small></td></tr><tr><td><button class="btn btn-outline btn-primary dim" type="button">{{vm.overviewAll.covers}}</button></td><td><b>Number of<stran stext="person" type="p"></stran></b><br><small class="text-muted">Avg {{vm.overviewAll.reservations == 0 ? \'0\' : (vm.overviewAll.covers/vm.overviewAll.reservations).toFixed(1)}}<stran stext="person" type="p"></stran>per reservation.</small></td></tr><tr><td><button class="btn btn-outline btn-danger dim" type="button"><i class="{{currencyIcon}}"></i></button></td><td><b>Estimated revenue <span class="text-danger">{{(vm.overviewAll.avgRevenuePerCover * vm.overviewAll.covers) | currency}}</span></b><br><small class="text-muted">Calculation based on historical information.</small></td></tr><tr><td><button class="btn btn-outline btn-danger dim" type="button"><i class="{{currencyIcon}}"></i></button></td><td><b>Estimated tips <span class="text-danger">{{(vm.overviewAll.avgTipsPerCover * vm.overviewAll.covers) | currency}}</span></b><br><small class="text-muted">Calculation based on historical information.</small></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/tables/rearrange/rearrange.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="panel float-e-margins"><div class="panel-heading"><h3 class="font-bold">Re-arrange<stran stext="resource" type="p"></stran>&nbsp;for <span class="text-danger">{{dateDisplay}}</span> between <span class="text-danger">{{startTimeDisplay}}</span> and <span class="text-danger">{{endTimeDisplay}}</span></h3>Drag and drop<stran stext="resource" type="p"></stran>&nbsp;between reservations to accommodate guest special request and to optimize occupancy in defined period. <span class="pull-right"><button aria-pressed="false" data-toggle="button" class="btn btn-default" type="button" ng-click="vm.restore()">Restore</button>&nbsp;&nbsp; <button aria-pressed="false" data-toggle="button" class="btn btn-primary" type="button" ng-click="vm.save()">Save</button></span></div><div class="panel-body"><div class="row"><div class="col-lg-2 col-lg-offset-3"><h4>Requested capacity: {{vm.requiredCapacity}}</h4></div><div class="col-lg-2"><h4>Assigned capacity: {{vm.totalCapacity(model)}}</h4></div><div class="col-lg-2"><h4><stran stext="capacity" type="c"></stran>&nbsp;occupancy: <span class="{{vm.textColor}}">{{vm.calculateOccupancy(vm.totalCapacity(model))}}%</span></h4></div></div></div></div></div></div></div><div class="col-lg-12"><div class="row"><div class="col-lg-4"><h3>Selected reservation</h3></div><div class="col-lg-4"><h3>Reservations in same period as selected reservation</h3></div><div class="col-lg-4"><h3>Free<stran stext="resource" type="p"></stran>for selected period</h3></div></div><div class="advancedDemo row"><div ng-repeat="containers in model" class="col-md-4"><div class="dropzone box box-yellow"><ul dnd-list="containers" dnd-allowed-types="[\'container\']" dnd-external-sources="true" dnd-dragover="dragoverCallback(index, external, type, callback)" dnd-drop="dropCallback(index, item, external, type)"><li ng-if="containers.length<=0"><br><h5 class="font-bold text-danger">No other reservation in same period as selected reservation.</h5></li><li ng-repeat="container in containers" dnd-draggable="container" dnd-type="\'container\'" dnd-effect-allowed="none" dnd-moved="containers.splice($index, 1)" dnd-callback="container.items.length"><div class="container-element panel {{container.panel}}"><div ng-if="container.type!=\'available\'" class="panel-heading"><h3>{{container.customer}}, {{container.covers}} person(s)</h3><div class="row"><div class="col-lg-6"><span ng-if="container.customerEmail" class="fa fa-envelope">{{container.customerEmail}}<br></span><span ng-if="container.customerPhone" class="fa fa-phone">{{container.customerPhone}}</span></div><div class="col-lg-6"><small class="font-bold">Requested capacity <strong>{{container.covers}}</strong><br><span ng-if="container.covers > sumCapacity(container)" style="background-color: #D80056;padding:3px" class="fa fa-exclamation-circle font-bold text-white">Assigned capacity <strong>{{sumCapacity(container)}}</strong> </span><span ng-if="container.covers <= sumCapacity(container)">Assigned capacity <strong>{{sumCapacity(container)}}</strong></span></small></div></div><div class="row" ng-if="container.note"><div class="col-lg-12"><span class="text-danger">Note: {{container.note}}<br></span></div></div></div><div ng-if="container.type===\'available\'" class="panel-heading"><div class="row"><div class="col-lg-12"><h3>List of available<stran stext="resource" type="p"></stran></h3>Available<stran stext="resource" type="p"></stran><strong>&nbsp;{{container.items.length}}</strong><br>Available capacity <strong>{{sumCapacity(container)}}</strong></div></div></div><div class="panel-body"><ul dnd-list="container.items" dnd-allowed-types="[\'item\']" dnd-horizontal-list="true" dnd-external-sources="true" dnd-effect-allowed="move" dnd-dragover="dragoverCallback(index, external, type)" dnd-drop="dropCallback(index, item, external, type)" dnd-inserted="logListEvent(\'inserted at\', index, external, type)" class="itemlist"><li style="background-color: #EEE; border-color: {{item.areaColor}}" ng-repeat="item in container.items" dnd-draggable="item" dnd-type="\'item\'" dnd-effect-allowed="{{item.effectAllowed}}" dnd-dragstart="logEvent(\'Started to drag an item\')" dnd-moved="container.items.splice($index, 1)" dnd-dragend="logEvent(\'Drag operation ended. Drop effect: \' + dropEffect)"><span style="">{{item.name}} ({{item.capacity}}<stran stext="capacity" type="p"></stran>)</span></li></ul></div><div class="clearfix"></div></div></li></ul></div></div></div></div><div class="row" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\')"><div class="col-lg-12"><h2>Generated Model</h2><pre>{{modelAsJson}}</pre></div></div></div></div>');
$templateCache.put('app/tables/search/search.html','<div class="wrapper wrapper-content" ng-scope><div class="row"><div class="col-lg-12" ng-show="!(\'\'+vm.keyword).startsWith(\'customerId:\') && !(\'\'+vm.keyword).startsWith(\'canceled:\') && !(\'\'+vm.keyword).startsWith(\'cancelled:\')"><div class="panel"><div class="panel-body"><h3 class="text-navy"><i class="fa fa-search-plus"></i>&nbsp;&nbsp;Event search</h3><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-12">Search by predefined criteria&nbsp; &nbsp;<button class="btn btn-primary btn-sm" type="submit" ng-click="vm.searchToday()"><i class="glyphicon glyphicon-eye-open"></i>&nbsp;List all today\'s events</button> &nbsp;<button class="btn btn-primary btn-sm" type="submit" ng-click="vm.searchLastWeek()"><i class="glyphicon glyphicon-eye-open"></i>&nbsp;List all events in the last 7 days</button> &nbsp;&nbsp; or define your own search criteria below. <button class="btn btn-primary btn-sm pull-right" type="submit" ng-click="vm.exportCSV()"><i class="glyphicon glyphicon-eye-open"></i>&nbsp;EXPORT to CSV</button></div></div><br><div class="row"><div class="col-lg-5"><form name="form" ng-submit="vm.searchEvents()"><input name="keyword" ng-model="vm.keyword" ng-required="true" ng-minlength="3" placeholder="search by reservation code, customer name, email or phone" class="form-control" type="text"><p ng-if="form.keyword.$error.minlength" class="text-warning text-small">&nbsp;* at least 3 characters required</p><p ng-if="vm.keyword || form.keyword.$error.required" style="color: white">_</p></form></div><div class="col-lg-3"><div class="form-group"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="select time period" type="text" class="form-control" name="pickerDates" style="background-color: #FFF"></div></div></div><div class="col-lg-2"><button ng-disabled="!vm.searchAllowed()" class="btn btn-primary" type="submit" ng-click="vm.searchEvents()"><i class="fa fa-search"></i>&nbsp;Search</button> &nbsp;<button class="btn btn-default btn-outline" type="submit" ng-click="vm.resetSearch()"><i class="fa fa-remove"></i>&nbsp;Reset</button></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h5>Events matching defined criteria (sorted by date when event is created)</h5></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><div class="text-danger text-center font-bold" ng-if="vm.events && vm.totalItems === 0"><h3>No search results.</h3></div><table ng-if="vm.totalItems > 0" class="table table-striped"><thead><tr><th><i class="fa fa-info-circle"></i>&nbsp;Type / Status</th><th><i class="fa fa-calendar"></i>&nbsp;Created at</th><th><i class="fa fa-info-circle"></i>&nbsp;Channel</th><th><i class="fa fa-calendar"></i>&nbsp;Date and time</th><th><i class="fa fa-user"></i>&nbsp;Customer</th><th><i class="fa fa-phone"></i>&nbsp;Contact(s)</th><th><i class="fa fa-group"></i>&nbsp;<stran stext="person" type="c"></stran></th><th></th><th><i class="fa fa-gears"></i>&nbsp;Action</th></tr></thead><tbody><tr ng-repeat="event in vm.events"><td><h3 class="" ng-class="vm.utils.getEventTypeTextStyle(event.type)">{{vm.utils.formatEventType(event.type)}}</h3><span ng-class="vm.utils.prettyStatusBkg(event.state, event.status)" class="label">{{vm.utils.prettyStatus(event.state, event.status)}}</span></td><td><span>{{event.createdDateTime | amDateFormat: \'D MMM YYYY h:mm A\'}}</span></td><td><span class="fa fa-2x {{channelIcon(event.channel)}} seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">{{channelToolTipText(event.channel)}}</span></span></td><td><span class="font-bold">{{event.dateTime | amDateFormat: \'D MMM YYYY @ h:mm A\'}}</span></td><td class="font-bold"><a ng-if="event.customer" ui-sref="customers.profile({customerId: event.customer.id})">{{event.customer.name}}&nbsp;<span class="fa fa-info-circle"></span></a></td><td><a href="mailto:{{event.customer.primaryEmail}}">{{event.customer.primaryEmail}}</a><br><a href="tel:{{event.customer.primaryPhone}}">{{event.customer.primaryPhone}}</a></td><td>{{event.covers}}</td><td><a href="" ui-sref="tables.eventDetails({eventId: event.id})" ng-if="event.productModifiers"><span class="fa fa-shopping-cart text-danger seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">Modifiers added to the reservation</span> </span></a>&nbsp; <a href="" ui-sref="tables.eventDetails({eventId: event.id})" ng-if="event.note"><span class="fa fa-file-text-o text-warning seaton-tooltip"><span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">{{event.note}}</span></span></a></td><td><button type="submit" class="btn btn-success btn-sm btn-outline" ui-sref="tables.eventDetails({eventId: event.id})">Details</button></td></tr></tbody></table><div class="text-center" ng-if="vm.totalItems > 0"><div class="info font-bold">Showing {{((vm.currentPage-1)*vm.itemsPerPage) + 1}} - {{((vm.currentPage-1)*vm.itemsPerPage)+vm.events.length}} of {{vm.totalItems}} items.</div><ul uib-pagination boundary-links="true" direction-links="true" total-items="vm.totalItems" ng-model="vm.currentPage" items-per-page="vm.itemsPerPage" ng-change="vm.pageChanged()"></ul></div></div></div></div></div></div></div></div>');
$templateCache.put('app/tables/timeline/timeline.drag.dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeConfirmationDialog()"><span aria-hidden="true">&times;</span></button><h1 class="modal-title" id="myModalLabel2"><b>Update event?</b><br></h1></div><div class="modal-body"><div class="row"><span style="font-size: 125%"><b>Update event for {{ vm.ev.customer_name}}</b><br><br><b>Changes:</b><br><br><span ng-show="vm.isTimeChanged"><span class="font-bold fa fa-clock-o text-danger">Reservation time changed from <b>{{vm.initial_start_time}} </b>to <b>{{vm.new_start_time}}</b></span><br><br>Select to change time:<checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.changeTime"></checkbox><br><br><br></span><span ng-show="vm.isSectionChanged"><span ng-show="vm.isSectionChanged" class="font-bold fa fa-dot-circle-o text-danger">Reservation moved from <b>{{ vm.original.seaton_resource_name }} </b>to <b>{{ vm.new_resource_name }}</b></span><br><br>Select to add new ({{vm.new_resource_name }}):<checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.addNew"></checkbox><br><br>Select to keep existing ({{ vm.original.seaton_resource_name }}):<checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.keepOld"></checkbox></span></span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeConfirmationDialog()">Cancel</button> <button type="button" class="btn btn-primary" ng-click="vm.closeConfirmationDialog();vm.displayNotifictionMessageDialog();">Update</button></div>');
$templateCache.put('app/tables/timeline/timeline.html','<div class="wrapper wrapper-content"><div class="row" ng-show="openingHourNotDefined()"><div class="col-lg-12"><div class="widget yellow-bg text-center"><h4>WARNING: Business hours not defined. Occupancy rate calculation might be wrong. Please define business hours through Clover Setup and restart SeatOn app.</h4></div></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3 class="text-navy">Timeline for <span class="text-danger">{{vm.range.from | amDateFormat: \'dddd, Do MMM YY\' }}</span><div class="pull-right"><div class="btn-group"><button class="btn btn-primary btn-outline" ng-click="vm.reload(\'refresh\')"><i class="fa fa-refresh" ng-class="vm.isRefreshing ? \'fa-pulse\' : \'\'"></i> &nbsp;Refresh</button></div></div></h3><small ng-show="vm.viewType ==\'daily\'">Showing details for selected day. Please select any other day for details. </small><span class="text-danger">&nbsp; <strong>Use drag&drop to change or click and select free space to create new events.</strong></span></div><div class="ibox-content"><div class="row" ng-show="vm.viewType !=\'weekly\'"><div class="btn-group col-lg-8 col-md-6"><label ng-repeat="(day_name, day_data) in vm.ranges" uib-btn-radio="day_name" ng-model="vm.selectedRange" ng-change="vm.reload()" title="Select the day" class="btn btn-primary btn-outline"><span>{{day_data.label}}</span><br></label></div><div class="col-lg-4 col-md-6 pull-right"><div class="form-group"><div ng-show="vm.viewType !=\'weekly\'" class="input-group date"><span class="input-group-btn"><button type="button" ng-class="vm.selectedRange == \'custom\' ? \'btn-primary\' : \'btn-default\'" class="btn" ng-click="vm.openPicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="Or select another day" type="text" class="form-control" name="pickerDates" style="background-color: #FFF"></div></div></div></div><div class="row" ng-show="vm.viewType ==\'weekly\'"><div class="btn-group col-lg-12 col-md-6"><label ng-repeat="(day_name, day_data) in vm.ranges" uib-btn-radio="day_name" ng-model="vm.selectedRange" ng-change="vm.reload()" title="Select the day" class="btn btn-primary btn-outline"><span>{{day_data.label}}</span><br></label></div></div><div class="row"><div id="calendar"></div><div id="scheduler_here" class="dhx_cal_container" style="width:100%; height:900px"><div id="timeline_navline" class="dhx_cal_navline"><div id="timeline_navline_date" class="dhx_cal_date"></div></div><div class="dhx_cal_header"></div><div class="dhx_cal_data"></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/tables/yearview/yearview.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3 class="text-navy">Reservation overview</h3><small>Annual overview of upcoming reservations</small></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><span class="text-success">Click on the marked day to open details.</span><br><br></div></div><div class="row"><div id="yearview"></div></div><br><div class="row"><div class="col-lg-3"><img src="/content/images/year-reservation.png" width="40" class=""> A day with reservation event(s).</div><div class="col-lg-6"><img src="/content/images/year-prereservation.png" width="40" class=""> A day with pre-reservation and/or reservation event(s).</div></div></div></div></div></div></div>');
$templateCache.put('app/account/clover/logout/logout.html','<div class="loginColumns animated fadeInDown"><div class="row"><div class="col-lg-12"><div class="text-center"><h1 class="text-center text-navy font-bold">You are logged out of SeatOn application</h1><p>For security reasons close your browser after logout, especially in case you are accessing the application from a public computer.</p><br><br><br><br></div></div></div><div class="row"><div class="col-lg-12"><div class="panel panel-danger"><div class="panel-heading text-uppercase text-center" style="font-size:150%">We love feedback</div><div class="panel-body"><div class="col-lg-3"><img class="img-responsive" src="content/email/images/feedback.jpg"></div><div class="col-lg-9" style="font-size:110%"><p>Your feedback is highly appreciated and will help us to improve our service.</p><p>Please share with us your comments, questions and suggestions. Tell us what we do well and where we can do better.</p><p>Send us your feedback on e-mail <a href="mailto:support@seaton.site" class="email">support@seaton.site</a></p></div></div></div></div></div></div>');
$templateCache.put('app/account/old/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/old/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/old/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/old/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/import/customer/import.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-lg-12"><h4 class="no-margins">Import customer for current location</h4><small>Please place list of customer you want to import in cvs format in below textarea.</small></div></div></div><div class="ibox-content"><div class="row"><div class="col-lg-12">CVS row structure: FirstName;LastName;Email;Phone;Address;City;Zipcode;State<br>Delimiter: semi colon \';\' &nbsp;&nbsp;&nbsp;&nbsp; Phone format: numbers (only US phones)<br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-10"><textarea ng-model="vm.dataToImport" rows="25" cols="150" placeholder="Copy here cvs data and press Import button"></textarea></div><div class="col-lg-2"><button class="btn btn-outline btn-primary col-lg-12" ng-click="vm.importAllCustomers()" ng-disabled="!vm.dataToImport">Import customers</button></div></div></div></div><div class="row" ng-if="vm.importResult"><div class="col-lg-12"><br><br><strong>Result of import:</strong><br>- total number of customers: {{vm.importResult.totalItems}}<br>- number of successfully import customers: {{vm.importResult.succeedNumber}}<br>- number of failed import customers: {{vm.importResult.failedNumber}}<br><br></div></div><div class="row" ng-if="vm.importResult"><div class="col-lg-12"><table class="table table-hover" ng-table="list.tableParams55"><thead><tr><th>First Name</th><th>Last Name</th><th>Email</th><th>Phone</th><th>Address</th><th>City</th><th>Zipcode</th><th>State</th><th>Message</th></tr></thead><tbody><tr ng-repeat="customer in vm.importResult.resultList"><td>{{customer.firstName}}</td><td>{{customer.lastName}}</td><td>{{customer.email}}</td><td>{{customer.phone}}</td><td>{{customer.address}}</td><td>{{customer.city}}</td><td>{{customer.zipcode}}</td><td>{{customer.state}}</td><td><strong>{{customer.importStatus}}</strong></td><td>{{customer.failedReason}}</td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/import/event/import.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-lg-12"><h4 class="no-margins">Import event for current location</h4><small>Please place list of event you want to import in cvs format in below textarea.</small></div></div></div><div class="ibox-content"><div class="row"><div class="col-lg-12">CVS row structure: Date;Time;PartySize;FirstName;LastName;Email;Phone;Note<br>Delimiter: semi colon \';\' &nbsp;&nbsp;&nbsp;&nbsp; Date format: \'MM/dd/yyyy\' &nbsp;&nbsp;&nbsp;&nbsp; Time format: \'hh:mm a\'<br><br><i class="text-danger">Note:<br>- If you do not want table to be assign while importing events, switch off automation in Online Reservation Settings page.<br>- if you do not want to send confirmation or verification messages please switch of sending on Notification Settings page.</i><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-10"><textarea ng-model="vm.dataToImport" rows="25" cols="150" placeholder="Copy here cvs data and press Import button"></textarea></div><div class="col-lg-2"><button class="btn btn-outline btn-primary col-lg-12" ng-click="vm.importAllEvents()" ng-disabled="!vm.dataToImport">Import events</button></div></div></div></div><div class="row" ng-if="vm.importResult"><div class="col-lg-12"><br><br><strong>Result of import:</strong><br>- total number of events: {{vm.importResult.totalItems}}<br>- number of successfully import events: {{vm.importResult.succeedNumber}}<br>- number of failed import events: {{vm.importResult.failedNumber}}<br><br></div></div><div class="row" ng-if="vm.importResult"><div class="col-lg-12"><table class="table table-hover" ng-table="list.tableParams55"><thead><tr><th>Date</th><th>Time</th><th>Party size</th><th>First Name</th><th>Last Name</th><th>Email</th><th>Phone</th><th>Note</th><th>Status</th><th>Message</th></tr></thead><tbody><tr ng-repeat="event in vm.importResult.resultList"><td class="font-bold"><strong>{{event.date}}</strong></td><td class="font-bold"><strong>{{event.time}}</strong></td><td class="font-bold"><strong>{{event.partySize}}</strong></td><td>{{event.firstName}}</td><td>{{event.lastName}}</td><td>{{event.email}}</td><td>{{event.phone}}</td><td>{{event.note}}</td><td><strong>{{event.importStatus}}</strong></td><td>{{event.failedReason}}</td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/admin/migration/timeslot/migration.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><div class="row"><div class="col-lg-12"><h4 class="no-margins">Time Slot Migration</h4><small>Migration fo time slot to new solution.</small></div></div></div><div class="ibox-content"><div class="row"><div class="col-lg-4"><input ng-model="vm.locationIdToMigrate" placeholder="Location id to migrate" class="form-control" style="margin-bottom: 20px"></div><div class="col-lg-4"><button class="btn btn-outline btn-primary" ng-click="vm.migrateOne()">Migrate One location</button></div><div class="col-lg-4"><button class="btn btn-outline btn-danger" ng-click="vm.migrateAll()">Migrate All locations</button></div></div><div class="row"><div class="col-lg-12"><br><br><h4>Migration result table:</h4><br><table class="table table-hover"><thead><tr><th>Location Id</th><th>Location Name</th><th>Migration status</th><th>Message</th><th></th></tr></thead><tbody><tr ng-repeat="result in vm.resultList"><td>{{result.locationId}}</td><td>{{result.locationName}}</td><td>{{result.status}}</td><td>{{result.message}}</td><td ng-if="result.status == \'FAILED\'"><button type="button" class="btn btn-xs btn-info" ng-click="vm.migrateOne(result.locationId)"><small>MIGRATE</small></button></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/customer/create/partials/address_list.html','<div class="ibox"><div class="ibox-title"><h3>Address</h3></div><div class="ibox-content"><div class="content" ng-form="newAddressForm" isolate-form><div class="form-group" ng-class="{ \'has-error\': ngModelCtrl.$invalid}"><label class="control-label col-sm-3" for="country">Country*</label><div class="col-sm-9"><select id="country" class="form-control" ng-model="newAddress.country" ng-options="country.code as country.name for country in countries" ng-change="newAddress.countryState=\'\'"></select></div></div><div class="form-group" ng-class="{ \'has-error\': newAddressForm.$dirty && newAddressForm.countryState.$invalid}"><label class="control-label col-sm-3">State*</label><div ng-show="us_selected" class="col-sm-9"><select class="form-control" ng-model="newAddress.countryState" ng-options="state.name as state.name for state in us_states" required></select></div><div ng-hide="us_selected" class="col-sm-9"><input class="form-control" name="countrystate" type="text" ng-model="newAddress.countryState" ng-maxlength="32" required></div></div><div class="form-group" ng-class="{ \'has-error\': newAddressForm.$dirty && newAddressForm.zipcode.$invalid}"><label class="control-label col-sm-3" for="zipcode">Zip code*</label><div class="col-sm-9"><input id="zipcode" name="zipcode" class="form-control" type="text" ng-model="newAddress.zipcode" ng-maxlength="16" placeholder="Please enter zipcode" required></div></div><div class="form-group" ng-class="{ \'has-error\': newAddressForm.$dirty && newAddressForm.city.$invalid}"><label class="control-label col-sm-3" for="city">City*</label><div class="col-sm-9"><input id="city" name="city" class="form-control" type="text" ng-model="newAddress.city" ng-maxlength="64" placeholder="Please enter city" required></div></div><div class="form-group"><label class="control-label col-sm-3" for="street">Street*</label><div class="col-sm-9"><input id="street" name="street" class="form-control" type="text" ng-model="newAddress.address1" ng-maxlength="64" placeholder="Please enter street address" required></div></div><div class="form-group"><span class="pull-right p-sm"><button type="button" class="btn btn-primary" ng-click="addAddress(); newAddressForm.$setUntouched(); newAddressForm.$setPristine();" ng-class="{\'btn-danger\': newAddressForm.$invalid}" ng-disabled="newAddressForm.$invalid "><i class="fa fa-plus-square"></i></button></span></div></div><div class="row"><div class="col-lg-offset-1 col-lg-11"><table class="table"><tr ng-repeat="address in addresses"><td class="col-sm-9"><i class="fa fa-home"></i>{{ formatAddress(address) }}</td><td class="col-sm-3"><button type="submit" ng-click="editAddress($index); newAddressForm.$setUntouched(); newAddressForm.$setPristine();" class="btn btn-primary btn-xs"><i class="fa fa-pencil"></i></button> <button ng-if="!address.id" type="submit" ng-click="deleteAddress($index)" class="btn btn-primary btn-xs"><i class="fa fa-trash"></i></button></td></tr></table></div></div></div><div ng-if="debug == \'true\'"><ul class="well"><li>new address:{{newAddress}}</li></ul><div ng-repeat="address in addresses"><ul class="well"><li>raw model:{{address}}</li></ul></div></div></div>');
$templateCache.put('app/customer/create/partials/allergy_list.html','<label class="col-sm-2 control-label">Allergies</label><div class="col-sm-10 form-horizontal" style="padding-left: 0 !important"><div ng-repeat="(k, al) in allergyCtrl.predefinedAllergies"><div class="col-sm-4"><label for="{{al.allergy.otherName}}" style="font-weight: normal"><checkbox type="checkbox" class="btn-primary btn" id="{{al.allergy.otherName}}" ng-model="al.checked" ng-checked="{{al.checked}}" ng-change="allergyCtrl.updateAllergies(al)"></checkbox>{{k}}</label></div></div></div><div><div class="col-sm-2"></div><div class="col-sm-10"><tags-input placeholder="Add an allergy" ng-model="allergyCtrl.otherAllergies" key-property="otherName" display-property="otherName" on-tag-added="allergyCtrl.newAllergy($tag)" on-tag-removed="allergyCtrl.removeAllergy($tag)"></tags-input></div></div><div ng-if="allergyCtrl.debug==\'true\'"><div class="well"><div ng-repeat="(k, av) in allergyCtrl.selectedAllergies" class="row">{{k}} -> {{av | json}}</div></div><div class="well"><div ng-repeat="(k, av) in allergyCtrl.predefinedAllergies" class="row">{{k}} -> {{av | json}}</div></div></div>');
$templateCache.put('app/customer/create/partials/email_list.html','<div class="ibox"><div class="ibox-title"><h3>Email (*)</h3></div><div class="ibox-content"><div class="content"><div class="col-sm-12"><div class="form-group" ng-class="{ \'has-error\': (ngModelCtrl.$dirty && ngModelCtrl.$invalid) || ngFormCtrl.email.$invalid}"><div class="input-group m-b"><label class="input-group-addon" for="email">@</label><input id="email" name="email" ng-model="newItem.email" class="form-control" placeholder="Enter email address" type="email" validate-email ng-keyup="$event.keyCode == 13 && ngFormCtrl.email.$valid && addItem()" ng-blur="addItem()"> <span class="input-group-btn"><div type="button" class="btn btn-primary" ng-class="{\'btn-danger\': ngModelCtrl.$invalid || ngFormCtrl.email.$invalid}" ng-click="ngFormCtrl.email.$valid && addItem()"><i class="fa fa-plus-square"></i></div></span></div></div><div class="validation-error" ng-show="ngFormCtrl.email.$invalid"><div ng-messages="ngFormCtrl.email.$error" role="alert"><div ng-message="email">Email format is not valid.</div></div></div><div ng-transclude></div></div><div class="row"><div class="col-lg-offset-1 col-lg-11"><table class="table"><tr ng-repeat="email in items"><td class="col-lg-9"><i class="fa fa-envelope"></i> <span ng-class="email.primaryEmail ? \'font-bold\' : \'\'">{{email.email}}</span></td><td class="col-lg-3"><button type="submit" ng-click="editItem($index)" class="btn btn-primary btn-xs"><i class="fa fa-pencil"></i></button> <button ng-if="!email.id" type="submit" ng-click="deleteItem($index)" class="btn btn-primary btn-xs"><i class="fa fa-trash"></i></button> <button ng-if="!email.primaryEmail" type="submit" ng-click="makePrimary($index)" class="btn btn-primary btn-xs">Make primary</button></td></tr></table></div></div></div></div></div>');
$templateCache.put('app/customer/create/partials/favorite_table.html','<div class="form-group"><label for="favoriteTable" class="control-label col-sm-3">Favorite<stran stext="resource" type="s"></stran></label><div class="col-sm-9"><select id="favoriteTable" class="form-control" ng-model="ctrl.favorite_table" ng-options="resource.resource as ( resource.area.name + \' - \' + resource.resource.name) for resource in ctrl.resources_with_areas" ng-disabled="ctrl.readonly"></select></div></div><div ng-if="ctrl.debug == \'true\'"><div class="well">selected<stran stext="resource" type="s"></stran>:{{ctrl.favorite_table | json }}</div></div>');
$templateCache.put('app/customer/create/partials/important_dates.html','<ng-form name="importantDatesForm"><div class="form-group m-b"><label for="birthday" class="control-label col-sm-3">Birthday</label><div class="col-sm-9"><div class="input-group"><input id="birthday" placeholder="Select birthday" type="text" class="form-control" name="picker_birthday" style="background-color: #FFF"> <span class="input-group-btn"><button type="button" class="btn btn-primary" options="vm.datepicker_options" ng-click="vm.openBirthday()"><i class="fa fa-birthday-cake"></i></button> </span><span class="input-group-btn input-group-append"><button type="button" class="btn" ng-click="vm.clearBirthday()"><i class="fa fa-remove"></i></button></span></div></div></div><div class="form-group m-b"><label for="anniversary" class="control-label col-sm-3">Anniversary</label><div class="col-sm-9"><div class="input-group"><input id="anniversary" placeholder="Or choose date" type="text" class="form-control" name="picker_anniversary" style="background-color: #FFF"> <span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openAnniversary()"><i class="fa fa-heart"></i></button> </span><span class="input-group-btn input-group-append"><button type="button" class="btn" ng-click="vm.clearAnniversary()"><i class="fa fa-remove"></i></button></span></div></div></div><div ng-repeat="date in vm.otherDates track by $index" class="form-group" ng-class="{ \'has-error\': importantDatesForm.$dirty && (importantDatesForm.otherDate_{{$index}}_desc.$invalid ) } "><span class="col-sm-3 controls"><input name="otherDate_{{$index}}_desc" placeholder="{{date.otherName?date.otherName:\'Description\'}}" ng-model="date.otherName" type="text" class="form-control" placeholder="Enter description" ng-required="true"></span><div class="col-sm-9"><div class="input-group controls m-b"><input readonly="readonly" placeholder="Or choose date" type="text" class="form-control" name="otherDate_{{$index}}_date" style="background-color: #FFF"> <span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openImportantDate($index)"><i class="fa fa-calendar"></i></button> </span><span class="input-group-btn input-group-append"><button type="button" class="btn" ng-click="vm.removeOtherDate($index)"><i class="fa fa-remove"></i></button></span></div></div></div><div class="form-group"><span class="pull-right p-sm"><button type="button" class="btn btn-primary" ng-click="vm.newOtherDate()">Add important date</button></span></div></ng-form><div ng-if="vm.debug == \'true\'"><div ng-repeat="date in vm.otherDates track by $index"><ul class="well"><li>raw model:{{date}}</li><li>parsed:{{date.value | date : "MM/dd/yyyy \'at\' h:mma Z" }}</li></ul></div><hr><div class="well">Important dates<div ng-repeat="date in vm.importantDates track by $index"><ul class="well"><li>raw model:{{date}}</li><li>parsed:{{date.value | date : "MM/dd/yyyy \'at\' h:mma Z" }}</li></ul></div></div></div>');
$templateCache.put('app/customer/create/partials/phone_list.html','<div class="ibox"><div class="content" ng-form="newPhones" isolate-form><div class="ibox-title"><h3>Phone (*)</h3></div><div class="ibox-content"><div class="content"><div class="col-sm-12"><div class="form-group" ng-class="{ \'has-error\': ngModelCtrl.$invalid || (!newItem.phoneNumber && ngFormCtrl.phoneNumber.$viewValue)}"><div class="input-group m-b"><label class="input-group-addon" for="phoneNumber"><i class="fa fa-phone"></i></label><input id="phoneNumber" name="phoneNumber" ng-model="newItem.phoneNumber" size="35" class="form-control" model-view-value="true" type="text" ng-intl-tel-input data-initial-country="{{phoneRegion}}" data-default-country="{{phoneRegion}}" ng-keyup="reformatPhone()" placeholder="Please enter phone number"> <span class="input-group-btn"><button type="button" class="btn btn-primary" ng-class="{\'btn-danger\': ngModelCtrl.$invalid || (!newItem.phoneNumber && ngFormCtrl.phoneNumber.$viewValue)}" ng-click="addItem()"><i class="fa fa-plus-square"></i></button></span></div></div><div class="validation-error" ng-show="!newItem.phoneNumber && ngFormCtrl.phoneNumber.$viewValue"><div><div ng-message="phone">Phone number format is not valid.</div></div></div><div ng-transclude></div></div><div class="row"><div class="col-lg-offset-1 col-lg-11"><table class="table"><tr ng-repeat="phone in items"><td class="col-lg-9"><i class="fa fa-phone"></i> <span ng-class="phone.primaryPhone ? \'font-bold\' : \'\'">{{ phone.phoneNumber }}</span></td><td class="col-lg-3"><button type="submit" ng-click="editItem($index)" class="btn btn-primary btn-xs"><i class="fa fa-pencil"></i> Edit</button> <button ng-if="!phone.id" type="submit" ng-click="deleteItem($index)" class="btn btn-primary btn-xs"><i class="fa fa-trash"></i> Delete</button> <button ng-if="!phone.primaryPhone" type="submit" ng-click="makePrimary($index)" class="btn btn-primary btn-xs">Make primary</button></td></tr></table></div></div></div></div></div></div>');
$templateCache.put('app/customer/dashboard/partials/general_statistic_tab.html','<div class="row"><div class="col-lg-12"><br><div class="row"><div class="col-lg-6"><div google-chart chart="dashboard.chartObjectKnownVSUnknown"></div></div><div class="col-lg-6"><span ng-if="dashboard.chartObjectMembership"><include-pie-chart piechartdata="dashboard.chartObjectMembership"></span></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h3 class="text-navy">Regulars vs non-regulars</h3><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><table class="table"><thead><tr><th></th><th align="center"><i class="{{currencyIcon}} fa-2x text-navy"></i></th><th align="center"><span class="text-navy font-bold">TIPS</span></th><th align="center"><i class="fa fa-user fa-2x text-success"></i></th></tr></thead><tbody><tr><th bgcolor="#f0ffff"><h3>Regulars</h3></th><td bgcolor="#f0ffff"><h3>{{dashboard.generalData.regulars.totalSpend | currency}}</h3>{{dashboard.generalData.regularsSpendVsTotalPct | percentage:2 }}<br><small>Avg per customer {{dashboard.generalData.regulars.avgSpendByCustomer | currency}}</small><br><small>Avg per visit {{dashboard.generalData.regulars.avgSpendByVisit | currency}}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{dashboard.generalData.regulars.avgSpendByCover | currency}} </small><span class="text-navy">&nbsp;&nbsp;&nbsp;<level value="dashboard.generalData.regularsAvgPerCoverPct" display="right">{{ dashboard.generalData.regularsAvgPerCoverPct | percentage:2 }}</level></span></td><td bgcolor="#f0ffff"><h3>{{dashboard.generalData.regulars.totalTips | currency}}</h3>{{dashboard.generalData.regularsTipsVsTotalPct | percentage:2 }}<br><small>Avg per visit {{dashboard.generalData.regulars.avgTipPerVisit | currency}} ({{dashboard.generalData.regulars.totalTipsPerTotalSpendPct | percentage:2}})</small> <span class="text-navy">&nbsp;&nbsp;&nbsp;<level value="dashboard.generalData.regularsAvgTipVsTotalAvgTipPct" display="right">{{ dashboard.generalData.regularsAvgTipVsTotalAvgTipPct | percentage:2 }}</level></span></td><td bgcolor="#f0ffff"><h3>{{dashboard.generalData.regulars.totalVisits | number}} visit(s)</h3>{{dashboard.generalData.regularsVisitsVsTotalPct | percentage:2 }}<br><small>Total<stran stext="person"></stran>{{dashboard.generalData.regulars.totalCovers | number}}</small><br><small>Avg<stran stext="person"></stran>per visit {{dashboard.generalData.regulars.avgCoversPerVisit | number:2}} </small><span class="text-navy">&nbsp;&nbsp;&nbsp;<level value="dashboard.generalData.regularsAvgCoversPerVisitPct" display="right">{{ dashboard.generalData.regularsAvgCoversPerVisitPct | percentage:2 }}</level></span></td></tr><tr><th><h3>Non-regulars</h3></th><td><h3>{{dashboard.generalData.nonRegulars.amountSum | currency}}</h3>{{1-dashboard.generalData.regularsSpendVsTotalPct | percentage:2 }}<br><small>Avg per visit {{dashboard.generalData.nonRegulars.amountAvgPerVisit | currency}}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{dashboard.generalData.nonRegulars.amountAvgPerCover | currency}} </small><span class="text-danger">&nbsp;&nbsp;&nbsp;<level value="dashboard.generalData.nonRegularsAvgPerCoverPct" display="right">{{ dashboard.generalData.nonRegularsAvgPerCoverPct | percentage:2 }}</level></span></td><td><h3>{{dashboard.generalData.nonRegulars.tipSum | currency}}</h3>{{1-dashboard.generalData.regularsTipsVsTotalPct | percentage:2 }}<br><small>Avg per visit {{dashboard.generalData.nonRegulars.tipAvg | currency}} ({{dashboard.generalData.nonRegulars.tipAvgPct | percentage:2}}) </small><span class="text-danger">&nbsp;&nbsp;&nbsp;<level value="dashboard.generalData.nonRegularsAvgTipVsTotalAvgTipPct" display="right">{{ dashboard.generalData.nonRegularsAvgTipVsTotalAvgTipPct | percentage:2 }}</level></span></td><td><h3>{{dashboard.generalData.nonRegulars.visitsCount | number}} visit(s)</h3>{{1-dashboard.generalData.regularsVisitsVsTotalPct | percentage:2 }}<br><small>Total<stran stext="person"></stran>{{dashboard.generalData.nonRegulars.covers | number}}</small><br><small>Avg<stran stext="person"></stran>per visit {{dashboard.generalData.nonRegulars.coversPerVisit | number:2}} </small><span class="text-danger">&nbsp;&nbsp;&nbsp;<level value="dashboard.generalData.nonRegularsAvgCoversPerVisitPct" display="right">{{ dashboard.generalData.nonRegularsAvgCoversPerVisitPct | percentage:2 }}</level></span></td></tr></tbody></table></div></div></div></div><br><div class="row"><div class="col-lg-4"><div class="widget style1 navy-bg"><div class="row"><div class="col-xs-3"><i class="fa fa-group fa-3x"></i></div><div class="col-xs-9 text-right"><h2>{{dashboard.generalData.regularsVisitsVsTotalPct | percentage:2 }}</h2><span class="font-bold">of all visits was made by regulars</span></div></div></div></div><div class="col-lg-4"><div class="widget style1 navy-bg"><div class="row"><div class="col-xs-3"><i class="{{currencyIcon}} fa-3x"></i></div><div class="col-xs-9 text-right"><h2>{{dashboard.generalData.regularsSpendVsTotalPct | percentage:2 }}</h2><span class="font-bold">of total revenue from regulars</span></div></div></div></div><div class="col-lg-4"><div class="widget style1 navy-bg"><div class="row"><div class="col-xs-3"><i class="fa fa-bullhorn fa-3x"></i></div><div class="col-xs-9 text-right"><h2>{{dashboard.generalData.optedForMarketingPct | percentage:2 }}</h2><span class="font-bold">of regulars opted for marketing</span></div></div></div></div></div></div></div>');
$templateCache.put('app/customer/dashboard/partials/growth_trend_tab.html','<div class="row" ng-show="!dashboard.growthTrendEnabled"><div class="col-lg-12"><div class="widget gray-bg text-center">Find out how your customer base is growing at a monthly level.<br><br><small>Follow this link to find more information about <a href="https://support.seaton.site/298278-Customer-Dashboard#sect3_1_growthTrend" target="_blank">Customer growth trend</a> report.</small><br><br><button class="btn btn-danger" ng-click="dashboard.openWindow()" target="_blank">{{::dashboard.growthTrendText}}</button><br><br><small><span class="text-success">Below picture show an example of a report.</span></small></div></div></div><div class="row" ng-show="!dashboard.growthTrendEnabled"><div class="col-lg-12"><br><img src="/content/images/profile/CustomerGrowthTrend.png" class="img-responsive"></div></div><div class="row" ng-show="dashboard.growthTrendEnabled"><div class="col-lg-12"><div google-chart chart="dashboard.chartObjectGrowthTrend"></div></div></div><div class="row" ng-show="dashboard.growthTrendEnabled"><div class="col-lg-2"></div><div class="col-lg-10"><h4 class="no-margins"><i class="fa fa-users text-navy"></i> Average number of new customer monthly: {{dashboard.growthTrendData.avgCustomersByMonth }}</h4><small>Note: Current month excluded from average calculation.</small></div></div>');
$templateCache.put('app/customer/dashboard/partials/member_type_stats_tab.html','<div class="row" ng-show="!dashboard.memberTypeEnabled"><div class="col-lg-12"><div class="widget gray-bg text-center">Explore customers behavior with respect to memberships in five key indicators - share in total number of customers,<br>share in total revenue, share in total tips, share in total visits and share in no show visits.<br><br><small>Follow this link to find more information about <a href="https://support.seaton.site/298278-Customer-Dashboard#sect3_4_memberStats" target="_blank">Member type statistics</a> report.</small><br><br><button class="btn btn-danger" ng-click="dashboard.openWindow()" target="_blank">{{::dashboard.memberTypeText}}</button><br><br><small><span class="text-success">Below picture show an example of a report.</span></small></div></div></div><div class="row" ng-show="!dashboard.memberTypeEnabled"><div class="col-lg-12"><br><img src="/content/images/profile/CustomerMembershipStatistics.png" class="img-responsive"></div></div><div class="row" ng-show="dashboard.memberTypeEnabled"><div class="col-lg-12"><br><div google-chart chart="dashboard.chartObjectMemberTypeComperation"></div></div></div><br><div class="row" ng-show="dashboard.memberTypeEnabled"><div class="col-lg-12"><h3 class="text-navy">Member type details</h3><br><table class="table table-hover"><thead><tr><th></th><th ng-repeat="status in dashboard.settings.memberStatuses"><h3>{{status.name}}</h3><span uib-rating ng-model="status.stars" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="text-warning"></span></th></tr></thead><tbody><tr><td align="center"><i class="fa fa-group fa-2x text-warning"></i></td><td ng-repeat="status in dashboard.settings.memberStatuses"><h3>{{dashboard.memberTypeData.data[status.stars-1].stats.totalCustomers | number}}</h3>{{dashboard.memberTypeData.data[status.stars-1].customersPct | percentage:2}}</td></tr><tr><td align="center"><i class="{{currencyIcon}} fa-2x text-navy"></i></td><td ng-repeat="status in dashboard.settings.memberStatuses"><h3>{{dashboard.memberTypeData.data[status.stars-1].stats.totalSpend | currency }}</h3>{{dashboard.memberTypeData.data[status.stars-1].revenuePct | percentage:2}}<br><small>Avg per customer {{dashboard.memberTypeData.data[status.stars-1].stats.avgSpendByCustomer | currency}} </small><small>&nbsp;<level value="dashboard.memberTypeData.data[status.stars-1].avgSpendByCustomerVsTotalAvg" display="right">{{ dashboard.memberTypeData.data[status.stars-1].avgSpendByCustomerVsTotalAvg | percentage:2 }}</level></small></td></tr><tr><td align="center"><span class="text-navy font-bold"><small>TIPS</small></span></td><td ng-repeat="status in dashboard.settings.memberStatuses"><h3>{{dashboard.memberTypeData.data[status.stars-1].stats.totalTips | currency }}</h3>{{dashboard.memberTypeData.data[status.stars-1].tipPct | percentage:2}}<br><small>Avg per visit {{dashboard.memberTypeData.data[status.stars-1].stats.avgTipPerVisit | currency}} ({{dashboard.memberTypeData.data[status.stars-1].stats.totalTipsPerTotalSpendPct | percentage:2}})</small> <small>&nbsp;<level value="dashboard.memberTypeData.data[status.stars-1].avgTipPerVisitVsTotalAvg" display="right">{{ dashboard.memberTypeData.data[status.stars-1].avgTipPerVisitVsTotalAvg | percentage:2 }}</level></small></td></tr><tr><td align="center"><i class="fa fa-user fa-2x text-success"></i></td><td ng-repeat="status in dashboard.settings.memberStatuses"><h3>{{dashboard.memberTypeData.data[status.stars-1].stats.totalVisits | number }} visit(s)</h3>{{dashboard.memberTypeData.data[status.stars-1].visitsPct | percentage:2}}<br><small>Avg spend per visit {{dashboard.memberTypeData.data[status.stars-1].stats.avgSpendByVisit | currency}} </small><small>&nbsp;<level value="dashboard.memberTypeData.data[status.stars-1].avgSpendByVisitVsTotalAvg" display="right">{{ dashboard.memberTypeData.data[status.stars-1].avgSpendByVisitVsTotalAvg | percentage:2 }}</level></small></td></tr><tr><td align="center"><span class="text-danger font-bold"><small>NO<br>SHOW</small></span></td><td ng-repeat="status in dashboard.settings.memberStatuses"><h3>{{dashboard.memberTypeData.data[status.stars-1].stats.totalReservationNoShow+dashboard.memberTypeData.data[status.stars-1].stats.totalWaitlistNoShow | number }}</h3>{{dashboard.memberTypeData.data[status.stars-1].noShowPct | percentage:2}}<br><small>No show rate {{dashboard.memberTypeData.data[status.stars-1].stats.totalNoShowRatio | percentage:2}}</small> <small>&nbsp;<level value="dashboard.calcPct(dashboard.memberTypeData.data[status.stars-1].stats.totalNoShowRatio,dashboard.generalData.regulars.totalNoShowRatio)" display="right" invert="true">{{ dashboard.calcPct(dashboard.memberTypeData.data[status.stars-1].stats.totalNoShowRatio,dashboard.generalData.regulars.totalNoShowRatio) | percentage:2 }}</level></small></td></tr><tr><td align="center"><span class="text-warning font-bold"><small>CANCELLED<br>EVENTS</small></span></td><td ng-repeat="status in dashboard.settings.memberStatuses"><h3>{{dashboard.memberTypeData.data[status.stars-1].stats.totalReservationCanceled+dashboard.memberTypeData.data[status.stars-1].stats.totalWaitlistCanceled | number }}</h3>{{dashboard.memberTypeData.data[status.stars-1].cancelledPct | percentage:2}}<br><small>Cancellation rate {{dashboard.memberTypeData.data[status.stars-1].stats.totalCancellationRatio | percentage:2}}</small> <small>&nbsp;<level value="dashboard.calcPct(dashboard.memberTypeData.data[status.stars-1].stats.totalCancellationRatio,dashboard.generalData.regulars.totalCancellationRatio)" display="right" invert="true">{{ dashboard.calcPct(dashboard.memberTypeData.data[status.stars-1].stats.totalCancellationRatio,dashboard.generalData.regulars.totalCancellationRatio) | percentage:2 }}</level></small></td></tr><tr><td align="center"><span class="text-navy font-bold"><small>RESERVATION<br>RATIO</small></span></td><td ng-repeat="status in dashboard.settings.memberStatuses"><h3>{{dashboard.memberTypeData.data[status.stars-1].stats.totalReservationShowGenaralRatio | percentage:2}}</h3></td></tr></tbody></table></div></div>');
$templateCache.put('app/customer/dashboard/partials/visit_statistic_tab.html','<div class="row"><div class="col-lg-12"><div class="panel white-panel"><div class="panel-body"><div class="row"><div class="col-lg-6"><br><br><h3><span class="text-navy font-bold">General visit statistics for regulars</span></h3><span class="label label-info pull-right">Overall</span><br><br><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th><th>Avg per<br>customer</th><th>#<stran stext="person"></stran></th></thead><tbody><tr><td>Reservation</td><td>{{dashboard.generalData.regulars.totalReservationShow | number }}</td><td>{{dashboard.generalData.locationVisitsStats.totalReservationShowPerTotalVisitsPct | percentage:2}}</td><td>{{dashboard.generalData.regulars.avgReservationByCustomer | number : 2}}</td><td>{{dashboard.generalData.regulars.totalReservations | number }}</td></tr><tr><td>Walk-in seated</td><td>{{dashboard.generalData.regulars.totalWalkinSeated | number }}</td><td>{{dashboard.generalData.locationVisitsStats.walkinSeatedPerTotalVisitsPct | percentage:2}}</td><td>{{dashboard.generalData.regulars.avgWalkinSeatedByCustomer | number : 2}}</td><td>{{dashboard.generalData.regulars.totalWalkinSeatedCover | number }}</td></tr><tr><td>Walk-in waitlisted</td><td>{{dashboard.generalData.regulars.totalWaitlistShow | number }}</td><td>{{dashboard.generalData.locationVisitsStats.totalWaitlistShowPerTotalVisitsPct | percentage:2}}</td><td>{{dashboard.generalData.regulars.avgWaitlistByCustomer | number : 2}}</td><td>{{dashboard.generalData.regulars.totalWaitlistCover | number }}</td></tr><tr><th>Totals</th><th>{{dashboard.generalData.regulars.totalVisits | number }}</th><th>100%</th><th>{{dashboard.generalData.regulars.avgVisitsByCustomer | number : 2}}</th><th>{{dashboard.generalData.regulars.totalCovers | number }}</th></tr></tbody></table></div><div class="col-lg-6"><span ng-if="dashboard.chartObjectVisitGeneral"><include-pie-chart piechartdata="dashboard.chartObjectVisitGeneral"></span></div></div></div></div></div></div><div class="row"><div class="col-lg-6"><div class="panel white-panel"><div class="panel-heading"><h3><span class="font-bold text-navy">Reservation statistics</span></h3><span class="label label-info pull-right">Overall</span></div><div class="panel-body"><div class="row"><div class="col-lg-12"><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th></thead><tbody><tr><td>Show</td><td>{{dashboard.generalData.regulars.totalReservationShow | number }}</td><td>{{dashboard.generalData.locationVisitsStats.totalReservationShowPct | percentage:2}}</td></tr><tr><td>No Show</td><td>{{dashboard.generalData.regulars.totalReservationNoShow | number }}</td><td>{{dashboard.generalData.locationVisitsStats.totalReservationNoShowPct | percentage:2}}</td></tr><tr><td>Cancellation</td><td>{{dashboard.generalData.regulars.totalReservationCanceled | number }}</td><td>{{dashboard.generalData.locationVisitsStats.totalReservationCanceledPct | percentage:2}}</td></tr><tr><th>Totals</th><th>{{dashboard.generalData.regulars.totalReservation | number }}</th><th>100%</th></tr></tbody></table></div></div><div class="row"><div class="col-lg-12"><span ng-if="dashboard.chartObjectReservationGeneral"><include-pie-chart piechartdata="dashboard.chartObjectReservationGeneral"></span></div></div></div></div></div><div class="col-lg-6"><div class="panel white-panel"><div class="panel-heading"><h3><span class="font-bold text-navy">Waitlist statistics</span></h3><span class="label label-info pull-right">Overall</span></div><div class="panel-body"><div class="row"><div class="col-lg-12"><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th></thead><tbody><tr><td>Show</td><td>{{dashboard.generalData.regulars.totalWaitlistShow | number }}</td><td>{{dashboard.generalData.locationVisitsStats.totalWaitlistShowPct | percentage:2}}</td></tr><tr><td>No Show</td><td>{{dashboard.generalData.regulars.totalWaitlistNoShow | number }}</td><td>{{dashboard.generalData.locationVisitsStats.totalWaitlistNoShowPct | percentage:2}}</td></tr><tr><td>Cancellation</td><td>{{dashboard.generalData.regulars.totalWaitlistCanceled | number }}</td><td>{{dashboard.generalData.locationVisitsStats.totalWaitlistCanceledPct | percentage:2}}</td></tr><tr><th>Totals</th><th>{{dashboard.generalData.regulars.totalWaitlist | number }}</th><th>100%</th></tr></tbody></table></div></div><div class="row"><div class="col-lg-12"><span ng-if="dashboard.chartObjectWaitlistGeneral"><include-pie-chart piechartdata="dashboard.chartObjectWaitlistGeneral"></span></div></div></div></div></div></div>');
$templateCache.put('app/customer/profile/partials/aggrSpendByHour.html','<table class="table table-hover"><thead><tr><th></th><th><h3 ng-if="vm.isMeal">Breakfast (Start of day - {{ vm[data].breakfestEnd }})</h3><h3 ng-if="!vm.isMeal">Start of day - {{ vm[data].breakfestEnd }}</h3></th><th><h3 ng-if="vm.isMeal">Lunch ({{ vm[data].lunchStart }} - {{ vm[data].lunchEnd }})</h3><h3 ng-if="!vm.isMeal">{{ vm[data].lunchStart }} - {{ vm[data].lunchEnd }}</h3></th><th><h3 ng-if="vm.isMeal">Dinner ({{ vm[data].dinnerStart }} - End of day)</h3><h3 ng-if="!vm.isMeal">{{ vm[data].dinnerStart }} - End of day</h3></th></tr></thead><tbody><tr><td align="center"><i class="{{currencyIcon}} fa-2x text-navy"></i></td><td><h3>{{ vm[data].breakfest.amountSum | currency }}</h3><small>Avg per visit {{ vm[data].breakfest.amountAvgPerVisit | currency }}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{ vm[data].breakfest.amountAvgPerCover | currency }}</small></td><td><h3>{{ vm[data].lunch.amountSum | currency }}</h3><small>Avg per visit {{ vm[data].lunch.amountAvgPerVisit | currency }}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{ vm[data].lunch.amountAvgPerCover | currency }}</small></td><td><h3>{{ vm[data].dinner.amountSum | currency }}</h3><small>Avg per visit {{ vm[data].dinner.amountAvgPerVisit | currency }}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{ vm[data].dinner.amountAvgPerCover | currency }}</small></td></tr><tr><td align="center"><span class="text-navy font-bold"><small>TIPS</small></span></td><td><h3>{{ vm[data].breakfest.tipSum | currency }}</h3><small>Avg tip per visit {{ vm[data].breakfest.tipAvg | currency }} ({{ vm[data].breakfest.tipAvgPct | percentage:2 }})</small></td><td><h3>{{ vm[data].lunch.tipSum | currency }}</h3><small>Avg tip per visit {{ vm[data].lunch.tipAvg | currency }} ({{ vm[data].lunch.tipAvgPct | percentage:2 }})</small></td><td><h3>{{ vm[data].dinner.tipSum | currency }}</h3><small>Avg tip per visit {{ vm[data].dinner.tipAvg | currency }} ({{ vm[data].dinner.tipAvgPct | percentage:2 }})</small></td></tr><tr><td align="center"><i class="fa fa-user fa-2x text-success"></i></td><td><h3>{{ vm[data].breakfest.visitsCount | number }} visit(s)</h3><small>Total<stran stext="person"></stran>{{ vm[data].breakfest.covers | number }}</small><br><small>Avg<stran stext="person"></stran>per visit {{ vm[data].breakfest.coversPerVisit | number:2 }}</small></td><td><h3>{{ vm[data].lunch.visitsCount | number }} visit(s)</h3><small>Total<stran stext="person"></stran>{{ vm[data].lunch.covers | number }}</small><br><small>Avg<stran stext="person"></stran>per visit {{ vm[data].lunch.coversPerVisit | number:2 }}</small></td><td><h3>{{ vm[data].dinner.visitsCount | number }} visit(s)</h3><small>Total<stran stext="person"></stran>{{ vm[data].dinner.covers | number }}</small><br><small>Avg<stran stext="person"></stran>per visit {{ vm[data].dinner.coversPerVisit | number:2 }}</small></td></tr><tr><td align="center"><span class="text-danger font-bold"><small>NO<br>SHOW</small></span></td><td><h3>{{ vm[data].breakfest.noShowPct | percentage:2 }}</h3><small>Visit(s) {{ vm[data].breakfest.noShowVisits | number }}</small><br><small><stran stext="person" type="c"></stran>{{ vm[data].breakfest.noShowCovers | number }}</small><br><small class="text-danger" ng-show="avgSpendPerCover==\'NA\'">Loss {{ vm[data].breakfest.noShowCovers * vm[data].breakfest.amountAvgPerCover | currency }}</small> <small class="text-danger" ng-show="avgSpendPerCover!=\'NA\'">Loss {{lossLabel}} {{ vm[data].breakfest.noShowCovers * vm[avgSpendPerCover] | currency }}</small></td><td><h3>{{ vm[data].lunch.noShowPct | percentage:2 }}</h3><small>Visit(s) {{ vm[data].lunch.noShowVisits | number }}</small><br><small><stran stext="person" type="c"></stran>{{ vm[data].lunch.noShowCovers | number }}</small><br><small class="text-danger" ng-show="avgSpendPerCover==\'NA\'">Loss {{ vm[data].lunch.noShowCovers * vm[data].lunch.amountAvgPerCover | currency }}</small> <small class="text-danger" ng-show="avgSpendPerCover!=\'NA\'">Loss {{lossLabel}} {{ vm[data].lunch.noShowCovers * vm[avgSpendPerCover] | currency }}</small></td><td><h3>{{ vm[data].dinner.noShowPct | percentage:2 }}</h3><small>Visit(s) {{ vm[data].dinner.noShowVisits | number }}</small><br><small><stran stext="person" type="c"></stran>{{ vm[data].dinner.noShowCovers | number }}</small><br><small class="text-danger" ng-show="avgSpendPerCover==\'NA\'">Loss {{ vm[data].dinner.noShowCovers * vm[data].dinner.amountAvgPerCover | currency }}</small> <small class="text-danger" ng-show="avgSpendPerCover!=\'NA\'">Loss {{lossLabel}} {{ vm[data].dinner.noShowCovers * vm[avgSpendPerCover] | currency }}</small></td></tr></tbody></table>');
$templateCache.put('app/customer/profile/partials/aggrSpendByWeekday.html','<table class="table table-hover"><thead><tr><th></th><th align="center"><i class="{{currencyIcon}} text-navy"></i>&nbsp;<span class="font-bold text-navy">REVENUE</span></th><th align="center"><i class="{{currencyIcon}} text-success"></i>&nbsp;<span class="text-success font-bold">TIPS</span></th><th align="center"><i class="fa fa-users text-info"></i>&nbsp;<span class="font-bold text-info">VISITS</span></th><th align="center"><i class="fa fa-ban text-danger"></i> &nbsp;<span class="text-danger font-bold">NO SHOW</span></th><th align="center"><span class="text-navy font-bold"><small>RESERVATION<br>RATIO</small></span></th></tr></thead><tbody><tr ng-repeat="dayData in vm[data] | orderBy:vm.dynamicOrder:vm.order.reverse"><th><h3>{{ dayData.groupedItemDisplayName }}</h3></th><td><h3>{{ dayData.amountSum | currency }}</h3>{{ dayData.amountTotalPct | percentage: 2 }}<br><small>Avg per visit {{ dayData.amountAvgPerVisit | currency }}</small><br><small>Avg per<stran stext="person" tyep="s"></stran>{{ dayData.amountAvgPerCover | currency }} </small><small>&nbsp;<level value="dayData.calcAmountAvgPerCoverPct" display="right">{{ dayData.calcAmountAvgPerCoverPct | percentage:2 }}</level></small></td><td><h3>{{ dayData.tipSum | currency }}</h3>{{ dayData.tipsTotalPct | percentage: 2 }}<br><small>Avg tip per visit {{ dayData.tipAvg | currency }} ({{ dayData.tipAvgPct | percentage:2 }})</small> <small>&nbsp;<level value="dayData.calcTipAvgPct" display="right">{{ dayData.calcTipAvgPct | percentage:2 }}</level><br></small><small>Avg tip per<stran stext="person" tyep="s"></stran>{{ dayData.tipAvgPerCover | currency }}</small></td><td><h3>{{ dayData.visitsCount | number }} visit(s)</h3>{{ dayData.visitsTotalPct | percentage: 2 }}<br><small>Total<stran stext="person"></stran>{{ dayData.covers | number }}</small><br><small>Avg<stran stext="person"></stran>per visit {{ dayData.coversPerVisit | number: 2 }}</small><level value="dayData.calcCoversPerVisitPct" display="right">{{ dayData.calcCoversPerVisitPct | percentage:2 }}</level></td><td><h3>{{ dayData.noShowPct | percentage: 2 }}</h3><small>Visit(s) {{ dayData.noShowVisits | number }}</small><br><small><stran stext="person" tyep="c"></stran>{{ dayData.noShowCovers | number }}</small><br><small class="text-danger" ng-show="avgSpendPerCover==\'NA\'">Loss {{ dayData.noShowCovers * dayData.amountAvgPerCover | currency }}</small> <small class="text-danger" ng-show="avgSpendPerCover!=\'NA\'">Loss {{lossLabel}} {{ dayData.noShowCovers * vm[avgSpendPerCover] | currency }}</small></td><td><h3>{{ dayData.reservationRatio | percentage: 2 }}</h3></td></tr></tbody></table>');
$templateCache.put('app/customer/profile/partials/spendTrendByMonth.html','<table class="table"><thead><tr><th></th><th><h3>Reservation</h3></th><th><h3>Walk-in Seated</h3></th><th><h3>Walk-in Waitlisted</h3></th><th bgcolor="#f0ffff"><h3 class="text-danger">Total</h3></th></tr></thead><tbody><tr><td align="center"><i class="{{currencyIcon}} fa-2x text-navy"></i></td><td><h3>{{ vm[data].reservation.amountSum | currency }}</h3><small>Avg per visit {{ vm[data].reservation.amountAvgPerVisit | currency }}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{ vm[data].reservation.amountAvgPerCover | currency }}</small></td><td><h3>{{ vm[data].seated.amountSum | currency }}</h3><small>Avg per visit {{ vm[data].seated.amountAvgPerVisit | currency }}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{ vm[data].seated.amountAvgPerCover | currency }}</small></td><td><h3>{{ vm[data].waitlist.amountSum | currency }}</h3><small>Avg per visit {{ vm[data].waitlist.amountAvgPerVisit | currency }}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{ vm[data].waitlist.amountAvgPerCover | currency }}</small></td><td bgcolor="#f0ffff"><h3>{{ vm[data].total.amountSum | currency }}</h3><small>Avg per visit {{ vm[data].total.amountAvgPerVisit | currency }}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{ vm[data].total.amountAvgPerCover | currency }}</small><level value="vm.calcPct(vm[data].total.amountAvgPerCover,vm[param1])" display="right" class="pull-right">{{ vm.calcPct(vm[data].total.amountAvgPerCover,vm[param1]) | percentage:2 }}</level></td></tr><tr><td align="center"><span class="text-navy font-bold"><small>TIPS</small></span></td><td><h3>{{ vm[data].reservation.tipSum | currency }}</h3><small>Avg tip per visit {{ vm[data].reservation.tipAvg | currency }} ({{ vm[data].reservation.tipAvgPct | percentage:2 }})</small></td><td><h3>{{ vm[data].seated.tipSum | currency }}</h3><small>Avg tip per visit {{ vm[data].seated.tipAvg | currency }} ({{ vm[data].seated.tipAvgPct | percentage:2 }})</small></td><td><h3>{{ vm[data].waitlist.tipSum | currency }}</h3><small>Avg tip per visit {{ vm[data].waitlist.tipAvg | currency }} ({{ vm[data].waitlist.tipAvgPct | percentage:2 }})</small></td><td bgcolor="#f0ffff"><h3>{{ vm[data].total.tipSum | currency }}</h3><small>Avg tip per visit {{ vm[data].total.tipAvg | currency }} ({{ vm[data].total.tipAvgPct | percentage:2 }})</small><level value="vm.calcPct(vm[data].total.tipAvg,vm[param2])" display="right" class="pull-right">{{ vm.calcPct(vm[data].total.tipAvg,vm[param2]) | percentage:2 }}</level></td></tr><tr><td align="center"><i class="fa fa-user fa-2x text-success"></i></td><td><h3>{{ vm[data].reservation.visitsCount | number }} visit(s)</h3><small>Total<stran stext="person"></stran>{{ vm[data].reservation.covers | number }}</small><br><small>Avg<stran stext="person"></stran>per visit {{ vm[data].reservation.coversPerVisit | number:2 }}</small></td><td><h3>{{ vm[data].seated.visitsCount | number }} visit(s)</h3><small>Total<stran stext="person"></stran>{{ vm[data].seated.covers | number }}</small><br><small>Avg<stran stext="person"></stran>per visit {{ vm[data].seated.coversPerVisit | number:2 }}</small></td><td><h3>{{ vm[data].waitlist.visitsCount | number }} visit(s)</h3><small>Total<stran stext="person"></stran>{{ vm[data].waitlist.covers | number }}</small><br><small>Avg<stran stext="person"></stran>per visit {{ vm[data].waitlist.coversPerVisit | number:2 }}</small></td><td bgcolor="#f0ffff"><h3>{{ vm[data].total.visitsCount | number }} visit(s)</h3><small>Total<stran stext="person"></stran>{{ vm[data].total.covers | number }}</small><br><small>Avg<stran stext="person"></stran>per visit {{ vm[data].total.coversPerVisit | number:2 }}</small><level value="vm.calcPct(vm[data].total.coversPerVisit,vm[param3])" display="right" class="pull-right">{{ vm.calcPct(vm[data].total.coversPerVisit,vm[param3]) | percentage:2 }}</level></td></tr><tr><td align="center"><span class="text-danger font-bold"><small>NO<br>SHOW</small></span></td><td><h3>{{ vm[data].reservation.noShowPct | percentage:2 }}</h3><small>Visit(s) {{ vm[data].reservation.noShowVisits | number }}</small><br><small><stran stext="person" type="c"></stran>{{ vm[data].reservation.noShowCovers | number }}</small><br><small class="text-danger" ng-show="avgSpendPerCover==\'NA\'">Loss {{ vm[data].reservation.noShowCovers * vm[data].reservation.amountAvgPerCover | currency }}</small> <small class="text-danger" ng-show="avgSpendPerCover!=\'NA\'">Loss {{lossLabel}} {{ vm[data].reservation.noShowCovers * vm[avgSpendPerCover] | currency }}</small></td><td></td><td><h3>{{ vm[data].waitlist.noShowPct | percentage:2 }}</h3><small>Visit(s) {{ vm[data].waitlist.noShowVisits | number }}</small><br><small><stran stext="person" type="c"></stran>{{ vm[data].waitlist.noShowCovers | number }}</small><br><small class="text-danger" ng-show="avgSpendPerCover==\'NA\'">Loss {{ vm[data].waitlist.noShowCovers * vm[data].waitlist.amountAvgPerCover | currency }}</small> <small class="text-danger" ng-show="avgSpendPerCover!=\'NA\'">Loss {{lossLabel}} {{ vm[data].waitlist.noShowCovers * vm[avgSpendPerCover] | currency }}</small></td><td bgcolor="#f0ffff"><div style="float:left"><h3>{{ vm[data].total.noShowPct | percentage:2 }}</h3></div><div style="float:right"><level value="vm.calcPct(vm[data].total.noShowPct,vm[param4])" display="right" class="pull-right" invert="true">{{ vm.calcPct(vm[data].total.noShowPct,vm[param4]) | percentage:2 }}</level></div><br><br><small>Visit(s) {{ vm[data].total.noShowVisits | number }}</small><br><small><stran stext="person" type="c"></stran>{{ vm[data].total.noShowCovers | number }}</small><br><small class="text-danger" ng-show="avgSpendPerCover==\'NA\'">Loss {{ vm[data].reservation.noShowCovers * vm[data].reservation.amountAvgPerCover + vm[data].waitlist.noShowCovers * vm[data].waitlist.amountAvgPerCover | currency }}</small> <small class="text-danger" ng-show="avgSpendPerCover!=\'NA\'">Loss {{lossLabel}} {{ vm[data].total.noShowCovers * vm[avgSpendPerCover] | currency }}</small></td></tr></tbody></table>');
$templateCache.put('app/public/online/contact/contact.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1 col-xs-10 col-xs-offset-1"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-10"><h1 class="font-bold">{{vm.settings.locationName}}</h1><strong>{{vm.settings.locationAddress}}</strong><hr><span class="text-danger"><i class="fa fa-phone"></i>&nbsp; <span>{{vm.settings.contactPhone}}</span> </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="text-danger"><i class="fa fa-envelope-o"></i>&nbsp; {{vm.settings.contactEmail}}</span><hr></div></div><div class="row"><div class="col-lg-10 col-md-offset-1"><form name="customerForm" class="form-horizontal"><div class="row"><div class="col-md-10 text-center" style="background-color: #fff; border-color: #444"><span class="font-bold" style="margin-top: 7px"><i class="fa fa-calendar"></i>&nbsp; {{ vm.moment(vm.request.date, vm.DATE_FORMAT).format(\'dddd, MMMM D, YYYY\');}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="font-bold" style="margin-top: 7px"><i class="fa fa-clock-o"></i>&nbsp; {{ vm.moment(vm.request.time, vm.TIME_SERVER_FORMAT).format(vm.TIME_DISPLAY_FORMAT) }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="font-bold" style="margin-top: 7px"><i class="fa fa-users"></i>&nbsp; {{vm.request.party_size}} person(s) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span ng-if="vm.request.product" class="font-bold" style="margin-top: 7px"><i class="fa fa-hourglass-1"></i>&nbsp; {{ vm.request.product.name }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><button class="btn btn-xs public-button-reschedule" ng-click="vm.reschedule()">RESCHEDULE</button></div></div><div class="row"><div class="col-md-6 text-center font-bold"><br><br><h3>Please enter your information to complete the reservation.</h3><br></div></div><div class="row" ng-if="vm.resourceNotAvailableAnymore==true" `><div class="col-md-6 text-center"><br><br><div uib-alert class="alert-danger text-center" style="font-size: 120%"><i class="fa fa-exclamation-triangle"></i>&nbsp;&nbsp; Ooops, we are in high demand for requested date and time.<br><br>We are sorry, but someone else just booked the last {{vm.resourceText}}. Chosen time slot {{ vm.moment(vm.request.date, vm.DATE_FORMAT).format(\'dddd, MMMM D, YYYY\') }} at {{ vm.moment(vm.request.time, vm.TIME_SERVER_FORMAT).format(vm.TIME_DISPLAY_FORMAT) }} for {{vm.request.party_size}} person(s) is not available anymore. Please choose alternative time for your visit.<br><br><button class="btn btn-xs public-button-reschedule" ng-click="vm.reschedule()">RESCHEDULE</button></div><br></div></div><div class="row"><div class="col-md-6"><div class="row" ng-if="vm.inputErrorOccurs()"><br><div class="col-md-12"><div class="row" ng-if="!vm.customer.firstName"><div class="col-md-8 col-md-offset-2"><div uib-alert class="alert-danger">Please enter your first name!</div></div></div><div class="row" ng-if="!vm.customer.lastName"><div class="col-md-8 col-md-offset-2"><div uib-alert class="alert-danger">Please enter your last name.</div></div></div><div class="row" ng-if="!(vm.customer.primaryEmail && customerForm.primaryEmail.$valid)"><div class="col-md-8 col-md-offset-2"><div uib-alert class="alert-danger">Please enter a valid email address.</div></div></div><div class="row" ng-if="!(vm.customer.primaryPhone && customerForm.primaryPhone.$valid)"><div class="col-md-8 col-md-offset-2"><div uib-alert class="alert-danger">Please enter a valid mobile phone number.</div></div></div><br></div></div><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-7"><div class="row"><div class="col-md-11"><div class="form-group" ng-class="{ \'has-error\': customerForm.firstName.$invalid}"><input autofocus name="firstName" ng-model="vm.customer.firstName" class="form-control" placeholder="First name" ng-required="true" ng-maxlength="64" type="text" tabindex="1" style="background-color: rgba(0,0,0,0)"></div><div class="form-group" ng-class="{ \'has-error\': customerForm.lastName.$invalid}"><input name="lastName" ng-model="vm.customer.lastName" class="form-control" placeholder="Last name" ng-required="true" ng-maxlength="128" type="text" tabindex="2" style="background-color: rgba(0,0,0,0)"></div><div class="form-group" ng-class="{ \'has-error\': !(vm.customer.primaryPhone && customerForm.primaryPhone.$valid)}"><div class="input-group m-b" style="margin: 0; z-index: 100"><input id="primaryPhone" name="primaryPhone" ng-model="vm.customer.primaryPhone" size="35" class="form-control" model-view-value="true" ng-required="false" type="text" ng-intl-tel-input data-initial-country="{{vm.phoneRegion}}" data-default-country="{{vm.phoneRegion}}" ng-keyup="vm.reformatPhone()" placeholder="Mobile phone number" tabindex="3" style="background-color: rgba(0,0,0,0)"></div></div><div class="form-group"><div class="input-group m-b" ng-class="{ \'has-error\': !(vm.customer.primaryEmail && customerForm.primaryEmail.$valid)}"><span class="input-group-addon text-danger">@</span> <input type="email" validate-email name="primaryEmail" ng-model="vm.customer.primaryEmail" class="form-control" ng-required="true" ng-maxlength="128" placeholder="Email address" tabindex="4" style="background-color: rgba(0,0,0,0)"></div></div><div class="form-group" ng-class="{ \'has-error\': !(vm.customer.primaryPhone && customerForm.primaryPhone.$valid)}"><div class="input-group m-b" style="margin: 0; z-index: 100"><checkbox type="checkbox" class="btn-primary btn" ng-model="vm.allowSMS"></checkbox>&nbsp;&nbsp;Yes, I agree to get text or email updates and reminders about this reservation.<br>Note: You can opt out of receiving messages at any time.</div></div></div></div></div><div class="col-md-5"><div class="row"><div class="col-md-11"><div class="form-group"><textarea rows="8" ng-model="vm.customer.note" ng-if="vm.locationId != \'79549BD7\' && vm.settings.locationName.indexOf(\'Chinuk Sushi\') == -1" placeholder="Please share with us any questions or special request here." class="form-control" ng-maxlength="512" tabindex="6"></textarea></div></div></div></div></div></div></div><div class="row"><div class="col-md-10 col-md-offset-1 text-center"><br><button class="btn btn public-button-logo" ng-disabled="vm.actionSubmitted || !vm.allowSMS" ng-click="vm.actionSubmmitted=true;vm.makeReservation(customerForm.primaryPhone.$valid)" type="button" tabindex="7"><i ng-class="vm.actionSubmitted ? \'fa fa-refresh fa-pulse\' : \'\'"></i> {{ vm.secondPageActionButtonText() }}</button> &nbsp; <button class="btn btn btn-white" ng-click="vm.resetSecondPage()" type="reset">Clear</button></div><br><br></div></div><div class="col-md-4" style="background-color: #eeeeee; padding: 10px"><h4>NEED TO KNOW</h4><span ng-bind-html="vm.settings.notice"></span></div></div></form></div></div></div></div></div></div><div class="row"><div class="col-md-12"><br><br><br><br></div></div></div>');
$templateCache.put('app/public/online/error/error.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="row" ng-if="vm.settings"><div class="col-md-10"><h1 class="font-bold">{{vm.settings.locationName}}</h1><strong>{{vm.settings.locationFullAddress}}</strong><hr><span class="text-danger"><i class="fa fa-phone"></i>&nbsp; <a class="text-danger" ng-href="tel:{{vm.settings.contactPhone}}">{{vm.settings.contactPhone}}</a> </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="text-danger"><i class="fa fa-envelope-o"></i>&nbsp; <a class="text-danger" ng-href="mailto:{{vm.settings.contactEmail}}">{{vm.settings.contactEmail}}</a></span><hr></div></div><div class="row" ng-if="!vm.settings"><div class="col-md-10"><h1 class="font-bold">Oops, something\'s gone wrong!</h1><hr></div></div><div class="row"><div class="col-md-12 col-md-offset-1"><br><span ng-if="vm.errorCode==1"><h2 class="text-danger">Reservation page not found!<br><br>Please check reservation link and try again.<br></h2></span><span ng-if="vm.errorCode==99"><div class="row" ng-if="vm.settings"><div class="col-md-10"><h1 class="font-bold">Oops, something\'s gone wrong!</h1></div></div><h2><br><br>We apologize for any inconvenience this may have caused.<br><br>If this message persists, please contact us.</h2></span><span><h2 ng-if="vm.type==\'PAYMENT\'" class="text-danger"><br><br>Important note : In case you submit credit card details and service become temporarily unavailable,<br>your card will not be charged for the reservation fee.</h2></span><br><br><br></div></div></div></div></div>');
$templateCache.put('app/public/online/modifier/modifier.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1 col-xs-10 col-xs-offset-1"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-10"><h1 class="font-bold">{{vm.settings.locationName}}</h1><strong>{{vm.settings.locationAddress}}</strong><hr><span class="text-danger"><i class="fa fa-phone"></i>&nbsp; <span>{{vm.settings.contactPhone}}</span> </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="text-danger"><i class="fa fa-envelope-o"></i>&nbsp; {{vm.settings.contactEmail}}</span><hr></div></div><div class="row"><div class="col-lg-11 col-md-offset-1"><div class="row"><div class="col-md-10 text-center" style="background-color: #fff; border-color: #444"><span class="font-bold" style="margin-top: 7px"><i class="fa fa-calendar"></i>&nbsp; {{ vm.moment(vm.request.date, vm.DATE_FORMAT).format(\'dddd, MMMM D, YYYY\');}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="font-bold" style="margin-top: 7px"><i class="fa fa-clock-o"></i>&nbsp; {{ vm.moment(vm.request.time, vm.TIME_SERVER_FORMAT).format(vm.TIME_DISPLAY_FORMAT) }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="font-bold" style="margin-top: 7px"><i class="fa fa-users"></i>&nbsp; {{vm.request.party_size}} person(s) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span ng-if="vm.request.product" class="font-bold" style="margin-top: 7px"><i class="fa fa-hourglass-1"></i>&nbsp; {{ vm.request.product.name }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><button class="btn btn-xs public-button-reschedule" ng-click="vm.reschedule()">RESCHEDULE</button></div></div><br><br><br><div class="row" ng-if="vm.minimumModiferAmountError==true"><div class="col-md-8 text-center"><br><br><div uib-alert class="alert-danger text-center" style="font-size: 120%"><i class="fa fa-exclamation-triangle"></i>&nbsp;&nbsp; Total modifier amount is lower than required minimum.</div><br></div></div><div class="row"><div class="col-sm-8"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-6"><div class="row" ng-if="vm.modifierList && vm.modifierList.length>0"><div class="col-sm-12"><h4 class="text-danger">RESERVATION MODIFIERS</h4><h5 ng-if="!vm.isBamboo()">Please select one or more modifiers to reservation.</h5><h5 class="text-warning" ng-if="vm.isBamboo()">Specify {{vm.request.party_size}} ordered bamboo biryani from below list.</h5><h4 ng-if="vm.minimumModifierAmountDefined()">Minimum required amount is {{vm.formatAmount(vm.request.product.minModifierAmount)}}.</h4><br></div></div><div class="row" ng-if="vm.modifierList && vm.modifierList.length>0"><div class="col-sm-12"><div class="row" ng-repeat="modifier in vm.modifierList"><div class="col-sm-12"><div class="btn-group"><button class="btn btn-xs btn-default btn-outline dim" ng-click="vm.adjustModifierNumber($index, 1)"><i class="fa fa-plus"></i></button> <button class="btn btn-xs btn-default btn-outline dim" ng-click="vm.adjustModifierNumber($index, -1)"><i class="fa fa-minus"></i></button><label class="btn btn-outline btn-link" style="margin: 2px; overflow:auto"><span class="">{{modifier.name}} {{vm.formatAmount(modifier.fee)}}</span></label></div></div></div></div></div><div class="row" ng-if="vm.serviceChargeAllowed()"><div class="col-sm-12"><br><h4 class="text-danger" ng-show="vm.modifierList.length > 0">SERVICE CHARGE</h4><h4 class="text-danger" ng-show="vm.modifierList.length <= 0">LEAVE A TIP</h4>Please select tip amount. Thank you <i class="fa fa-heart fa-sm text-danger"></i><br><br></div></div><div class="row" ng-if="vm.serviceChargeAllowed()"><div class="col-sm-6 btn-group" data-toggle="buttons"><label ng-repeat="serviceCharge in [15, 20, 25]" uib-btn-radio="serviceCharge" ng-model="vm.fees.serviceCharge" ng-change="vm.calculateTotalFee()" class="btn btn-default btn-outline" title="Select service charge / tip amount" style="margin: 1px">{{serviceCharge}}%</label></div><div class="col-sm-4"><select ng-model="vm.fees.serviceCharge" ng-options="serviceChargeSelect.value as serviceChargeSelect.name for serviceChargeSelect in vm.serviceChargeOtherList" placeholder="Other" name="tip_element" ng-change="vm.calculateTotalFee()" class="form-control m-b"><option value="">Other</option></select></div></div></div><div class="col-md-5"><div class="row"><div class="col-md-12"><h4 class="text-danger">TOTAL FOR PAYMENT</h4></div></div><div class="row" style="background-color: #f2dede; padding-top: 10px"><div class="col-md-12"><div class="row"><div class="col-sm-7"><span class="font-bold">Reservation fee</span><br><span ng-if="vm.request.product.rule==\'COVER\'">({{vm.request.party_size}} persons {{vm.formatAmount(vm.request.product.fee)}} each)</span><br><br></div><div class="col-sm-4 text-right font-bold">{{vm.formatAmount(vm.calculateReservationFee())}}</div></div><div class="row" ng-repeat="modifier in vm.modifierList" ng-if="modifier.number > 0"><div class="col-sm-7">{{modifier.number}}x {{modifier.name}}</div><div class="col-sm-4 text-right">{{vm.formatAmount((modifier.number * modifier.fee))}}</div></div><div class="row" ng-if="!vm.isModifierListWithAddedNumberIsEmpty() && (vm.modifierList.length > 0)"><div class="col-sm-7"><i>No modifier added</i></div><div class="col-sm-4 text-right"></div></div><div class="row font-bold" ng-if="vm.modifierList.length > 0"><div class="col-sm-7">Total modifiers</div><div class="col-sm-4 text-right">{{vm.formatAmount(vm.calculateTotalModifierFee())}}</div><br><br></div><div class="row font-bold" ng-if="vm.serviceChargeAllowed()"><div class="col-sm-7"><span ng-show="vm.modifierList.length > 0">Service charge</span> <span ng-show="vm.modifierList.length <= 0">Tip amount</span> ({{vm.fees.serviceCharge}}%)</div><div class="col-sm-4 text-right">{{vm.formatAmount(vm.calculateServiceChargeFee())}}</div></div><div class="row font-bold text-danger"><br><div class="col-md-7"><h4 class="font-bold">TOTAL</h4></div><div class="col-sm-4 text-right">{{vm.formatAmount(vm.calculateTotalFee())}}</div></div></div></div><br><div class="row"><div class="col-md-12"><small>NOTE: Credit card payment will be performed in last step.</small></div></div></div></div></div></div><div class="row"><div class="col-md-10 col-md-offset-1 text-center"><br><button class="btn btn public-button-logo" ng-disabled="vm.actionSubmitted" ng-click="vm.actionSubmmitted=true;vm.proceedToContactPage();" type="button" tabindex="7"><i ng-class="vm.actionSubmitted ? \'fa fa-refresh fa-pulse\' : \'\'"></i> Proceed with reservation</button> &nbsp; <button class="btn btn btn-white" ng-click="vm.clear()" type="reset">Clear</button></div><br><br></div></div><div class="col-sm-4" style="background-color: #eeeeee; padding: 10px"><h4>NEED TO KNOW</h4><span ng-bind-html="vm.settings.noticeModifier"></span></div></div></div></div></div></div></div></div><div class="row"><div class="col-md-12"><br><br><br><br></div></div></div>');
$templateCache.put('app/public/online/payment/payment.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1 col-xs-12"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-10"><h1 class="font-bold">{{vm.settings.locationName}}</h1><strong>{{vm.settings.locationFullAddress}}</strong><hr><span class="text-danger"><i class="fa fa-phone"></i>&nbsp; <span>{{vm.settings.contactPhone}}</span> </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="text-danger"><i class="fa fa-envelope-o"></i>&nbsp; {{vm.settings.contactEmail}}</span><hr></div></div><div class="row"><div class="col-lg-10 col-md-offset-1"><div class="row"><div class="col-md-10 text-center" style="background-color: #fff; border-color: #444"><span class="font-bold" style="margin-top: 7px"><i class="fa fa-calendar"></i>&nbsp; {{ vm.moment(vm.request.date, vm.DATE_FORMAT).format(\'dddd, MMMM D, YYYY\');}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="font-bold" style="margin-top: 7px"><i class="fa fa-clock-o"></i>&nbsp; {{ vm.moment(vm.request.time, vm.TIME_SERVER_FORMAT).format(vm.TIME_DISPLAY_FORMAT) }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="font-bold" style="margin-top: 7px"><i class="fa fa-users"></i>&nbsp; {{vm.request.party_size}} person(s) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span ng-if="vm.request.product" class="font-bold" style="margin-top: 7px"><i class="fa fa-hourglass-1"></i>&nbsp; {{ vm.request.product.name }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><button class="btn btn-xs public-button-reschedule" ng-click="vm.reschedule()">RESCHEDULE</button><br><br><br></div></div><div class="row"><div class="col-md-8 col-md-offset-1"><div class="row text-center font-bold"><div class="col-sm-12"><div class="alert alert-danger"><h2 class="text-center font-bold">Total amount for payment: {{ vm.amountDisplay }}</h2><span ng-if="vm.settings.paymentRule==\'COVER\'">{{vm.amountPerCoverDisplay}} per cover, {{vm.request.party_size}} covers</span> <button type="button" class="btn btn-xs btn-outline btn-default text-right" ng-click="vm.showPaymentDetails=!vm.showPaymentDetails;"><span ng-show="!vm.showPaymentDetails">SHOW</span><span ng-show="vm.showPaymentDetails">HIDE</span> DETAILS</button></div></div></div><div class="row" ng-show="vm.showPaymentDetails"><div class="col-sm-6 col-sm-offset-3" style="background-color: #EFEFEF; padding-top: 10px"><div class="row"><div class="col-sm-7"><span class="font-bold">Reservation fee</span><br><span ng-if="vm.request.product.rule==\'COVER\'">({{vm.request.party_size}} persons {{vm.amountPerCoverDisplay}} each)</span><br><br></div><div class="col-sm-4 text-right font-bold"><span ng-if="vm.request.product.rule==\'COVER\'">{{vm.formatAmount(vm.amountValue*vm.request.party_size)}}</span> <span ng-if="vm.request.product.rule!=\'COVER\'">{{vm.formatAmount(vm.amountValue)}}</span></div></div><div class="row" ng-repeat="modifier in vm.modifierList" ng-if="vm.request.product.modifierEnabled && (modifier.number > 0)"><div class="col-sm-7">{{modifier.number}}x {{modifier.name}}</div><div class="col-sm-4 text-right">{{vm.formatAmount((modifier.number * modifier.fee))}}</div></div><div class="row font-bold" ng-show="vm.request.product.modifierEnabled && (vm.modifierList.length > 0)"><div class="col-sm-7">Total modifiers<br><br></div><div class="col-sm-4 text-right">{{vm.formatAmount(vm.fees.totalModifiers)}}</div></div><div ng-if="vm.fees.serviceChargeFee" class="row font-bold"><div class="col-sm-7"><span ng-show="vm.modifierList.length > 0">Service charge</span> <span ng-show="vm.modifierList.length <= 0">Tip amount</span> ({{vm.fees.serviceCharge}}%)<br><br></div><div class="col-sm-4 text-right">{{vm.formatAmount(vm.fees.serviceChargeFee)}}</div></div><div class="row font-bold text-danger"><div class="col-md-7"><h4 class="font-bold">TOTAL</h4></div><div class="col-sm-4 text-right">{{vm.amountDisplay}}</div></div></div></div></div></div><div class="row"><div class="col-md-10 text-center"><h3>Please enter card details you want to use to pay the reservation fee.</h3></div></div><div class="row" ng-if="vm.resourceNotAvailableAnymore==true" `><div class="col-md-6 text-center"><br><br><div uib-alert class="alert-danger text-center" style="font-size: 120%"><i class="fa fa-exclamation-triangle"></i>&nbsp;&nbsp; Ooops, we are in high demand for requested date and time.<br><br>We are sorry, but someone else just book the last {{vm.resourceText}}. Chosen time slot {{ vm.moment(vm.request.date, vm.DATE_FORMAT).format(\'dddd, MMMM D, YYYY\') }} at {{ vm.moment(vm.request.time, vm.TIME_SERVER_FORMAT).format(vm.TIME_DISPLAY_FORMAT) }} for {{vm.request.party_size}} person(s) is not available anymore. Please choose alternative time for your visit.<br><br>Note: Your card is not charged for the reservation fee.<br><br><button class="btn btn-xs public-button-reschedule" ng-click="vm.reschedule()">RESCHEDULE</button></div><br></div></div><div class="row" ng-if="vm.errorStatus==-1"><div class="col-md-6"><br><br><div uib-alert class="alert-danger font-bold text-center"><i class="fa fa-exclamation-triangle"></i>&nbsp;&nbsp; Transaction declined. Please check card details or use different card.</div></div></div><div class="row"><div class="col-lg-3 col-lg-offset-4 col-md-6 col-sm-12"><div class="text-danger text-center" id="card-errors" role="alert"></div></div></div><div class="row"><div class="col-md-4 col-md-offset-1"><div class="row"><div class="col-xs-12"><div class="container"><form id="payment-form"><div class="form-row top-row"><div id="card-number" class="field card-number"></div><div class="input-errors" id="card-number-errors" role="alert"></div></div><div class="form-row"><div id="card-date" class="field third-width"></div><div class="input-errors" id="card-date-errors" role="alert"></div></div><div class="form-row"><div id="card-cvv" class="field third-width"></div><div class="input-errors" id="card-cvv-errors" role="alert"></div></div><div class="form-row"><div id="card-postal-code" class="field third-width"></div><div class="input-errors" id="card-postal-code-errors" role="alert"></div></div><div id="card-response" role="alert"></div><div class="button-container"><button id="paymentSubmit" ng-click="vm.completeReservationWithPayment()"><i ng-class="vm.actionSubmitted ? \'fa fa-refresh fa-pulse\' : \'\'"></i> Complete reservation</button></div></form></div></div></div><div class="row"><div class="col-xs-12 text-center"><br><br><a href="https://www.cvvnumber.com/cvv.html" target="_blank" style="font-size:11px">What is my CVV code?</a><br><a href="https://www.mapdevelopers.com/what-is-my-zip-code.php" target="_blank" style="font-size:11px">What is my zip code?</a><br><br></div></div></div><br><div class="col-md-4 col-xs-10 col-xs-offset-1" style="background-color: #efefef; padding: 10px"><h4>NEED TO KNOW</h4><span ng-bind-html="vm.settings.noticePayment"></span></div></div></div></div></div></div><br><br><br></div></div></div>');
$templateCache.put('app/public/online/reservation/proxy.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-xs-12 col-md-12"><div class="ibox float-e-margins"><div class="ibox-content"></div></div></div></div></div>');
$templateCache.put('app/public/online/success/success.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1 col-xs-12"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-10"><h1 class="font-bold">{{vm.settings.locationName}}</h1><strong>{{vm.settings.locationAddress}}</strong><hr><span class="text-danger"><i class="fa fa-phone"></i>&nbsp; <a class="text-danger" href="tel:{{vm.settings.contactPhone}}">{{vm.settings.contactPhone}}</a> </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="text-danger"><i class="fa fa-envelope-o"></i>&nbsp; <a class="text-danger" href="mailto:{{vm.settings.contactEmail}}">{{vm.settings.contactEmail}}</a></span><hr></div></div><div class="row" ng-if="vm.type==\'w\'"><div class="col-md-6 col-md-offset-1 col-xs-10 col-xs-offset-1 text-center"><br><h1 class="font-bold">Successfully added to wait list.</h1><br><br><h2>Text message was sent and you should receive it soon.</h2><h2>There you\'ll find a link to track your status in the wait list.</h2><br><br><h3 class="">Once a table is ready, we\'ll notify you with another text message.</h3><br><br><div class="text-center"><br><button class="btn btn public-button-reschedule" ng-click="vm.newWaitList()" type="button">Add new entry to wait list</button></div></div></div><div class="row" ng-if="vm.type==\'r\'"><div class="col-md-6 col-md-offset-1 col-xs-10 col-xs-offset-1 text-center"><br><h1 class="font-bold">Reservation request successfully completed.</h1><br><br><h2><span ng-bind-html="vm.generalMessage"></span></h2><br><div ng-show="vm.verificationSent==false" uib-alert class="alert-danger" style="font-size: 150%"><span ng-bind-html="vm.confirmationSentMessage"></span></div><div ng-show="vm.verificationSent==true" uib-alert class="alert-danger" style="font-size: 150%"><span ng-bind-html="vm.verificationSentMessage"></span></div><br><br><div class="text-center"><br><button class="btn btn public-button-reschedule" ng-click="vm.newReservation()" type="button">Create new reservation</button></div></div></div><div class="row" ng-if="!(vm.type==\'w\' || vm.type==\'r\')"><div class="col-md-6 col-md-offset-1 col-xs-10 col-xs-offset-1 text-center"><br><h1 class="font-bold">Action successfully finished.</h1><br><br><h2>Confirmation message was sent and you should receive it soon.</h2><br><br><br></div></div><br><br><br><br><br></div></div></div></div></div>');
$templateCache.put('app/public/online/waitlist/add.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1 col-xs-10 col-xs-offset-1"><div class="row" ng-if="vm.systemErrorOccurs()"><div class="col-md-10"><br><h2 class="text-danger">We are sorry!<br>Service is temporarily unavailable, please try again later.</h2><br><br><h3 class="text-center">We apologize for any inconvenience this may have caused.<br><br>If this message persists, please contact us.</h3></div></div><div class="row" ng-if="!vm.systemErrorOccurs()"><div class="col-md-10"><div class="row"><div class="col-md-10"><h1 class="font-bold">{{vm.locationName}}</h1><strong>{{vm.locationAddress}}</strong><hr><span class="text-danger"><i class="fa fa-phone"></i>&nbsp; <a href="tel:{{vm.contactPhone}}">{{vm.contactPhone}}</a> </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="text-danger"><i class="fa fa-envelope-o"></i>&nbsp; <a href="mailto:{{vm.contactEmail}}">{{vm.contactEmail}}</a></span><hr></div></div><div class="row"><div class="col-md-8 text-center"><h2 class="text-center font-bold" ng-if="vm.isAddingAllowed">ADD TO THE WAITLIST</h2><h2 class="text-center font-bold" ng-if="!vm.isAddingAllowed">RESTAURANT AVAILABILITY</h2><h3 class="font-bold" ng-if="vm.isAddingAllowed">Please enter your information and party size.</h3><h3 class="font-bold" ng-if="!vm.isAddingAllowed">Check current restaurant availability status.</h3><br></div></div><div class="row" ng-if="vm.availabilityStatus"><div class="col-md-8 text-center"><div class="panel" style="border: 1px solid {{vm.getStatusColor(\'background\')}}; border-radius: 5px; overflow: hidden; box-shadow: 0 2px 5px rgba(0,0,0,0.1)"><div style="background-color: {{vm.getStatusColor(\'background\')}}; color: white; padding: 10px; font-size: 16px"><strong>Current Restaurant Availability</strong></div><div style="padding: 15px; background-color: #f9f9f9"><div style="color: {{vm.getStatusColor(\'text\')}}; font-size: 18px; font-weight: bold; margin-bottom: 10px">{{vm.availabilityStatus.title}}</div><div style="color: #555; margin-bottom: 15px">{{vm.availabilityStatus.text}}</div><div ng-if="!vm.isAddingAllowed && vm.availabilityStatus.status !== 4" style="background-color: #f8f8f8; border-top: 1px solid #eee; padding: 10px; margin-top: 10px"><i class="fa fa-info-circle" style="color: {{vm.getStatusColor(\'text\')}}"></i> <span style="color: #666">We currently have tables available. Please contact the restaurant directly for immediate seating.</span></div><div ng-if="!vm.isAddingAllowed && vm.availabilityStatus.status === 4" style="background-color: #f8f8f8; border-top: 1px solid #eee; padding: 10px; margin-top: 10px"><i class="fa fa-clock-o" style="color: {{vm.getStatusColor(\'text\')}}"></i> <span style="color: #666">The restaurant is currently closed. Please check back during business hours.</span></div><div ng-if="vm.isAddingAllowed" style="background-color: #f8f8f8; border-top: 1px solid #eee; padding: 10px; margin-top: 10px"><i class="fa fa-info-circle" style="color: {{vm.getStatusColor(\'text\')}}"></i> <span style="color: #666">All tables are currently occupied. Please add your information below to join our waitlist.</span></div></div></div><br></div></div><div class="row" ng-if="vm.inputErrorOccurs()"><div class="col-md-8"><div class="row" ng-if="!(vm.numberOfPersons > 0)"><div class="col-md-6 col-md-offset-1"><div uib-alert class="alert-danger">Please enter the number of persons.</div></div></div><div class="row" ng-if="!vm.customer.firstName"><div class="col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3"><div uib-alert class="alert-danger">Please enter your first name.</div></div></div><div class="row" ng-if="!vm.customer.lastName"><div class="col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3"><div uib-alert class="alert-danger">Please enter your last name.</div></div></div><div class="row" ng-if="!(vm.customer.primaryPhone && customerForm.primaryPhone.$valid)"><div class="col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3"><div uib-alert class="alert-danger">Please enter a valid mobile phone number.</div></div></div><div class="row" ng-if="!(vm.customer.primaryEmail && customerForm.primaryEmail.$valid)"><div class="col-lg-6 col-lg-offset-3 col-md-6 col-md-offset-3"><div uib-alert class="alert-danger">Please enter valid email address!</div></div></div><br></div></div><div ng-if="!vm.isAddingAllowed && vm.availabilityStatus && vm.availabilityStatus.status !== 4"><div class="row"><div class="col-md-8 text-center"><div class="well" style="background-color: #f9f9f9; border-color: #eee"><h4>Would you like to contact the restaurant?</h4><div class="row" style="margin-top: 20px"><div class="col-md-6 text-center"><a href="tel:{{vm.contactPhone}}" class="btn btn-lg" style="background-color: {{vm.getStatusColor(\'background\')}}; color: white; width: 80%"><i class="fa fa-phone"></i> Call Restaurant</a></div><div class="col-md-6 text-center"><a href="mailto:{{vm.contactEmail}}" class="btn btn-lg" style="background-color: {{vm.getStatusColor(\'background\')}}; color: white; width: 80%"><i class="fa fa-envelope"></i> Email Restaurant</a></div></div></div></div></div></div><div ng-if="vm.availabilityStatus && vm.availabilityStatus.status === 4"><div class="row"><div class="col-md-8 text-center"><div class="well" style="background-color: #f9f9f9; border-color: #eee"><h4><i class="fa fa-clock-o" style="color: {{vm.getStatusColor(\'text\')}}"></i> Restaurant Hours</h4><p class="text-muted">Please check back during our regular business hours to make a reservation or join our waitlist.</p><div class="row" style="margin-top: 20px"><div class="col-md-6 col-md-offset-3 text-center"><a href="mailto:{{vm.contactEmail}}" class="btn btn-lg" style="background-color: {{vm.getStatusColor(\'background\')}}; color: white; width: 80%"><i class="fa fa-envelope"></i> Contact Restaurant</a></div></div></div></div></div></div><div ng-if="vm.isAddingAllowed"><div class="row"><form name="customerForm" class="form-horizontal"><div class="col-md-8"><div class="row"><div class="col-md-6"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="form-group" ng-class="{ \'has-error\': customerForm.firstName.$invalid}"><input autofocus name="firstName" ng-model="vm.customer.firstName" class="form-control" placeholder="First name" ng-required="true" ng-maxlength="64" type="text" tabindex="1"></div><div class="form-group" ng-class="{ \'has-error\': customerForm.lastName.$invalid}"><input name="lastName" ng-model="vm.customer.lastName" class="form-control" placeholder="Last name" ng-required="true" ng-maxlength="128" type="text" tabindex="2"></div><div ng-if="vm.phoneRegion!=null && vm.phonePattern!=null" class="form-group" ng-class="{ \'has-error\': customerForm.primaryPhone.$invalid}"><div class="input-group m-b" style="margin: 0; z-index: 100"><input id="primaryPhone" name="primaryPhone" ng-model="vm.customer.primaryPhone" ng-pattern="vm.phonePattern" size="40" class="form-control" model-view-value="true" ng-required="true" type="text" ng-intl-tel-input data-initial-country="{{vm.phoneRegion}}" data-default-country="{{vm.phoneRegion}}" ng-keyup="vm.reformatPhone()" placeholder="Mobile phone number" tabindex="3"></div><div ng-if=" customerForm.primaryPhone.$viewValue.length >4 && !(\'\'+customerForm.primaryPhone.$viewValue).startsWith(vm.phonePrefix)" class="text-success"><div ng-if="!(vm.isInternationalSmsEnabled || vm.isEU)" class="text-success">Only local phone numbers are supported!</div></div></div><div class="form-group" ng-class="{ \'has-error\': customerForm.numberOfPersons.$invalid}"><div class="input-group"><span class="input-group-addon"><i class="fa fa-group"></i></span><select ng-model="vm.numberOfPersons" name="numberOfPersons" placeholder="Party size" class="form-control" ng-options="item.id as item.label for item in vm.persons" tabindex="4" ng-change="vm.setQuotedWaitTime()"><option value="2" selected="selected">2 persons</option></select></div></div></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="form-group"><div class="input-group m-b" ng-class="{ \'has-error\': !(vm.customer.primaryEmail && customerForm.primaryEmail.$valid)}" style="margin: 0"><span class="input-group-addon">@</span> <input name="primaryEmail" ng-model="vm.customer.primaryEmail" class="form-control ng-pristine ng-untouched ng-valid" placeholder="Email address" type="email" validate-email tabindex="5"></div></div><div class="form-group"><textarea rows="6" ng-model="vm.customer.note" rows="1" placeholder="Please share with us any questions or special request here." class="form-control" ng-maxlength="512" tabindex="6"></textarea></div></div></div></div></div></div></form></div><div class="row"><div class="col-md-8 text-center"><br><button class="btn btn ng-isolate-scope public-button-logo" ng-disabled="vm.addSubmitted" ng-click="vm.addToWaitlist(customerForm.primaryPhone.$valid)" type="button" tabindex="7">Yes, add me to the wait list</button> &nbsp; <button class="btn btn btn-white" ng-click="vm.reset()" type="reset">Clear</button><br><br>Note: Please contact us if your party size is above 6 persons and we will do our best to accommodate your need.</div></div></div></div></div><br><br><br></div></div></div>');
$templateCache.put('app/public/setup/success/success.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1 col-xs-12"><div class="row"><div class="col-md-12"><br><span><div class="row"><div class="col-md-10"><h1 class="font-bold">Questionnaire submitted successfully!</h1><h3><br><br>Dear,<br><br>Thank you for being interested in SeatOn and for providing information for SeatOn customisation.<br>Based on you input we will setup SeatOn for you within 24 hours.<br>In case any additional question or clarification needed we will contact you on email you left.<br><br>Once setup is completed we will notify you on your email.<br><br>Sincerely,<br>SeatOn Team</h3></div></div></span><br><br><br><br><br></div></div></div></div></div>');
$templateCache.put('app/reporting/performance/partials/PerformanceEventsStatsTotal.html','<table class="table"><thead><tr><th colspan="2"><h3>{{ title }}</h3></th></tr></thead><tbody><tr><td align="right"><i class="{{currencyIcon}} fa-2x text-navy"></i></td><td><h3>{{ vm[data].amountSum | currency }}</h3><small>Avg per visit {{ vm[data].amountAvgPerVisit | currency }}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{ vm[data].amountAvgPerCover | currency }}</small></td><td align="right"><span class="text-success font-bold"><i class="{{currencyIcon}}"></i><br><small>TIPS</small></span></td><td><h3>{{ vm[data].tipSum | currency }}</h3><small>Avg per visit {{ vm[data].tipAvg | currency }} ({{ vm[data].tipAvgPct | percentage:2 }})</small></td><td align="right"><i class="fa fa-users fa-2x text-info"></i></td><td><h3>{{ vm[data].visitsCount | number }} visit(s)</h3><small>Total<stran stext="person"></stran>{{ vm[data].covers | number }}</small><br><small>Avg<stran stext="person"></stran>per visit {{ vm[data].coversPerVisit | number:2 }}</small></td><td align="right"><span class="text-danger font-bold"><i class="fa fa-ban"></i>&nbsp;<small>NO<br>SHOW</small></span></td><td><h3>{{ vm[data].noShowPct | percentage:2 }}</h3><small>Visit(s) {{ vm[data].noShowVisits | number }}</small><br><small><stran stext="person" type="c"></stran>{{ vm[data].noShowCovers | number }}</small><br><small class="text-danger">Loss {{ vm[data].noShowCovers * vm[data].amountAvgPerCover | currency }}</small></td></tr></tbody></table>');
$templateCache.put('app/reporting/revenuetrend/partials/SpendTrendEventsStatsTotal.html','<table class="table"><thead><tr><th colspan="2"><h3>{{ title }}</h3></th></tr></thead><tbody><tr><td align="center"><i class="{{currencyIcon}} fa-2x text-navy"></i></td><td><h3>{{ vm[data].amountSum | currency }}</h3><small>Avg per visit {{ vm[data].amountAvgPerVisit | currency }}</small><br><small>Avg per<stran stext="person" type="s"></stran>{{ vm[data].amountAvgPerCover | currency }}</small></td></tr><tr><td align="center"><span class="text-success font-bold"><i class="{{currencyIcon}}"></i><br><small>TIPS</small></span></td><td><h3>{{ vm[data].tipSum | currency }}</h3><small>Avg per visit {{ vm[data].tipAvg | currency }} ({{ vm[data].tipAvgPct | percentage:2 }})</small></td></tr><tr><td align="center"><i class="fa fa-users fa-2x text-info"></i></td><td><h3>{{ vm[data].visitsCount | number }} visit(s)</h3><small>Total<stran stext="person"></stran>{{ vm[data].covers | number }}</small><br><small>Avg<stran stext="person"></stran>per visit {{ vm[data].coversPerVisit | number:2 }}</small></td></tr><tr><td align="center"><span class="text-danger font-bold"><i class="fa fa-ban"></i>&nbsp;<small>NO<br>SHOW</small></span></td><td><h3>{{ vm[data].noShowPct | percentage:2 }}</h3><small>Visit(s) {{ vm[data].noShowVisits | number }}</small><br><small><stran stext="person" type="c"></stran>{{ vm[data].noShowCovers | number }}</small><br><small class="text-danger">Loss {{ vm[data].noShowCovers * vm[data].amountAvgPerCover | currency }}</small></td></tr></tbody></table>');
$templateCache.put('app/settings/application/partials/actions.html','<div class="row"><div class="col-lg-12"><table class="table"><thead><tr><th><h4 class="text-navy"><i class="fa fa-link"></i> Quick links</h4></th></tr></thead><tbody><tr><td>&nbsp;&nbsp;<a class="" ui-sref=""><i class="fa fa-gears text-success"></i>&nbsp;&nbsp;General settings</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref=")"><i class="fa fa-table text-info"></i>&nbsp;&nbsp;Tables list and settings</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref=")"><i class="fa fa-envelope text-info"></i>&nbsp;&nbsp;Notification settings</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref=")"><i class="fa fa-users text-info"></i>&nbsp;&nbsp;Customer membership settings</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref=")"><i class="fa fa-cutlery text-info"></i>&nbsp;&nbsp;Meals settings</a></td></tr><tr><td>&nbsp;&nbsp;<a class="" ui-sref=""><i class="fa fa-list text-success"></i>&nbsp;&nbsp;List of employees</a></td></tr></tbody></table></div></div>');
$templateCache.put('app/settings/application/partials/company-view.html','<div class="ibox"><div class="ibox-content"><div class="row"><div class="col-lg-12"><div class="widget style1 navy-bg"><div class="row"><div class="col-lg-12"><p></p><h2>{{ ::company.name }}</h2><div class="font-bolder" lookup code="{{company.industryType}}" list="industryTypes"></div><p></p><p class="ng-binding"><small>Using app since <span class="font-bold">October 18, 2015</span></small></p></div></div></div><div class="m-b-md"><p><small div class="pull-right text-danger">last update on 12th Oct 2015 @ 12:32pm</small></p></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><table><tr><td class="font-bold text-right" valign="top">Status:&nbsp;&nbsp;</td><td><span class="label label-primary">Active</span></td></tr></table></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 font-bold"><br>Address:&nbsp;&nbsp;</div></div><div class="row"><div class="col-lg-10 col-lg-offset-2"><addr model="company"></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 font-bold"><br>Contact:&nbsp;&nbsp;</div></div><div class="row"><div class="col-lg-10 col-lg-offset-2">{{ ::company.phone }}<br><a href="mailto:{{ ::company.email }}" class="text-navy">{{ ::company.email }}</a><br><a href="{{ ::company.url }}" class="text-navy" target="_blank">{{ ::company.url }}</a></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1 font-bold"><br>Note:&nbsp;&nbsp;</div></div><div class="row"><div class="col-lg-10 col-lg-offset-2"><p class="gray-bg">{{ ::company.note }}</p></div></div></div></div>');
$templateCache.put('app/settings/application/partials/general.html','<div class="row"><div class="col-lg-12"><div class="row ng-scope"><div class="col-lg-12"><br><h4 class="text-navy">General application settings</h4></div></div></div><div class="col-lg-10 col-lg-offset-1"><div class="row"><div class="col-sm-3 text-right" style="padding-top: 10px"><select><option>1 day</option><option>2 days</option><option>3 days</option><option>5 days</option><option>1 week</option><option>2 weeks</option><option>3 weeks</option><option>1 month</option><option>2 months</option><option>3 months</option><option selected="selected">6 months</option></select></div><span class="col-sm-9" style="padding-top: 10px">in advance customers can make reservations.</span></div><div class="row"><div class="col-sm-3 text-right" style="padding-top: 10px"><input type="checkbox"></div><span class="col-sm-9" style="padding-top: 10px">confirmation required for all reservations.</span></div><div class="row"><div class="col-sm-3 text-right" style="padding-top: 10px"><input type="checkbox"></div><span class="col-sm-9" style="padding-top: 10px">allow online reservation (through restaurant web page).</span></div><div class="row"><div class="col-sm-3 text-right" style="padding-top: 10px"><input type="checkbox"></div><span class="col-sm-9" style="padding-top: 10px">show appointment statistics for customers when making reservations.</span></div><div class="row"><div class="col-sm-3 text-right" style="padding-top: 10px"><input type="checkbox"></div><span class="col-sm-9" style="padding-top: 10px">allow waiting lists.</span></div></div></div>');
$templateCache.put('app/settings/application/partials/meals.html','<div class="row"><div class="col-lg-12 col-md-12"><div class="panel white-panel"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><p>Define Lunch start and end time in a day. Breakfast and Dinner start and end time will be calculated automatically.</p></div></div><br><div class="row"><div class="col-lg-10 col-lg-offset-1"><div id="slider_meals"></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><table class="table table-hover"><thead><tr><th></th><th><h4>Start</h4></th><th><h4>End</h4></th><th><h4>Average duration</h4></th></tr></thead><tbody><tr><td class="text-right"><span class="text-navy font-bold">BREAKFAST</span></td><td>7:00pm</td><td>11:00pm</td><td><div id="slider_duration_breakfast"></div><small>Average duration in last 30 days <span class="text-danger">0:32h</span></small></td></tr><tr><td class="text-right"><span class="font-bold text-success">LUNCH</span></td><td>11:00pm</td><td>18:00pm</td><td><div id="slider_duration_lunch"></div><small>Average duration in last 30 days <span class="text-danger">1:32h</span></small></td></tr><tr><td class="text-right"><span class="text-danger font-bold">DINNER</span></td><td>6:00pm</td><td>11:00pm</td><td><div id="slider_duration_dinner"></div><small>Average duration in last 30 days <span class="text-danger">1:32h</span></small></td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/settings/application/partials/members.html','<uib-tabset><uib-tab><uib-tab-heading class="text-center">Beginner member<div class="profile-stars"><span><i class="fa fa-star"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i></span></div></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><br><p>Beginner member membership will be assigned to all new customer automatically when account is created.<br>Please define parameters for "Beginner member" membership type.</p><br></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Status name</label><div class="col-md-4"><input class="form-control" required="" ng-maxlength="32" type="text"></div></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Benefits</label><div class="col-md-4"><ul class="todo-list ui-sortable"><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Can book VIP tables</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has priority on waiting list</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has favorite table available</span></li></ul></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Bronze member<div class="profile-stars"><span><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i></span></div></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><br><p>Bronze member membership will be assigned to customer automatically when defined treshold is reached.<br>Please define parameters for "Bronze member" membership type.</p><br></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Status name</label><div class="col-md-4"><input class="form-control" required="" ng-maxlength="32" type="text"></div></div></div><div class="row"><div class="form-group m-t-lg ng-scope"><label class="col-lg-2 col-md-3 control-label">Points threshold</label><div class="col-md-4"><input ng-model="memberStatus.threshold" class="form-control input-sm ng-pristine ng-untouched ng-valid ng-valid-min ng-valid-required" required="" ng-min="0" type="number"></div></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Benefits</label><div class="col-md-4"><ul class="todo-list ui-sortable"><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Can book VIP tables</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has priority on waiting list</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has favorite table available</span></li></ul></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Silver member<div class="profile-stars"><span><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i></span></div></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><br><p>Silver member membership will be assigned to customer automatically when defined treshold is reached.<br>Please define parameters for "Silver member" membership type.</p><br></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Status name</label><div class="col-md-4"><input class="form-control" required="" ng-maxlength="32" type="text"></div></div></div><div class="row"><div class="form-group m-t-lg ng-scope"><label class="col-lg-2 col-md-3 control-label">Points threshold</label><div class="col-md-4"><input ng-model="memberStatus.threshold" class="form-control input-sm ng-pristine ng-untouched ng-valid ng-valid-min ng-valid-required" required="" ng-min="0" type="number"></div></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Benefits</label><div class="col-md-4"><ul class="todo-list ui-sortable"><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Can book VIP tables</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has priority on waiting list</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has favorite table available</span></li></ul></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Gold member<div class="profile-stars"><span><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star-o"></i></span></div></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><br><p>Gold member membership will be assigned to customer automatically when defined treshold is reached.<br>Please define parameters for "Gold member" membership type.</p><br></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Status name</label><div class="col-md-4"><input class="form-control" required="" ng-maxlength="32" type="text"></div></div></div><div class="row"><div class="form-group m-t-lg ng-scope"><label class="col-lg-2 col-md-3 control-label">Points threshold</label><div class="col-md-4"><input ng-model="memberStatus.threshold" class="form-control input-sm ng-pristine ng-untouched ng-valid ng-valid-min ng-valid-required" required="" ng-min="0" type="number"></div></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Benefits</label><div class="col-md-4"><ul class="todo-list ui-sortable"><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Can book VIP tables</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has priority on waiting list</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has favorite table available</span></li></ul></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Platinum member<div class="profile-stars"><span><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i></span></div></uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><br><p>Platinum member membership will be assigned to customer automatically when defined treshold is reached.<br>Please define parameters for "Platinum member" membership type.</p><br></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Status name</label><div class="col-md-4"><input class="form-control" required="" ng-maxlength="32" type="text"></div></div></div><div class="row"><div class="form-group m-t-lg ng-scope"><label class="col-lg-2 col-md-3 control-label">Points threshold</label><div class="col-md-4"><input ng-model="memberStatus.threshold" class="form-control input-sm ng-pristine ng-untouched ng-valid ng-valid-min ng-valid-required" required="" ng-min="0" type="number"></div></div></div><div class="row"><div class="form-group m-t-lg"><label class="col-lg-2 col-md-3 control-label">Benefits</label><div class="col-md-4"><ul class="todo-list ui-sortable"><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Can book VIP tables</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has priority on waiting list</span></li><li><button type="checkbox button" ng-style="stylebtn" class="btn-primary btn btn-default ng-isolate-scope ng-valid btn-xs" ng-class="{\'btn-xs\': size===\'default\', \'btn-sm\': size===\'large\', \'btn-lg\': size===\'largest\'}" ng-model="settingsCtrl.multiselect(memberStatus.benefits, code.value)" ng-model-options="{ getterSetter: true }"><span ng-style="styleicon" class="glyphicon" ng-class="{\'glyphicon-ok\': checked===true}" style="width: 10px; left: -1px"></span></button> <span class="m-l-xs ng-binding">Has favorite table available</span></li></ul></div></div></div></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/settings/application/partials/notifications.html','<uib-tabset><uib-tab><uib-tab-heading class="text-center">Reservation</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-check text-navy"></i>&nbsp;Confirmation message</h5><small>This message will be sent to customer when reservation is created, asking customer to confirm reservation.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1"><input type="checkbox">&nbsp;&nbsp;Ask confirmation for phone/email reservation.</div></div><div class="row"><div class="col-lg-offset-1"><input type="checkbox">&nbsp;&nbsp;Ask confirmation for online/facebook reservation.</div></div><br><div class="row"><div class="col-lg-offset-1">Message:<br><textarea class="" rows="6" style="width: 80%"></textarea></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-bell text-warning"></i>&nbsp;Reminder message</h5><small>This message will be sent to remind customer about upcoming reservation.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1"><input type="checkbox">&nbsp;&nbsp;Send reminder to customer.</div></div><div class="row"><div class="col-lg-offset-1"><select><option value="1">1 hour</option><option value="2" selected="selected">2 hours</option><option value="3">3 hours</option><option value="4">4 hours</option><option value="5">5 hours</option><option value="6">6 hours</option><option value="7">7 hours</option><option value="8">8 hours</option><option value="12">12 hours</option><option value="24">1 day</option><option value="48">2 days</option></select>&nbsp;&nbsp;Before the event send reminder to customer.</div></div><br><div class="row"><div class="col-lg-offset-1">Message:<br><textarea class="" rows="6" style="width: 80%"></textarea></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-heart text-danger"></i>&nbsp;Thank you message</h5><small>This message will be sent to customer certain time after customer visit ends.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1"><input type="checkbox">&nbsp;&nbsp;Send thank you message to customer.</div></div><div class="row"><div class="col-lg-offset-1"><input type="checkbox">&nbsp;&nbsp;Ask customer to provide feedback for visit.</div></div><br><div class="row"><div class="col-lg-offset-1">Message:<br><textarea class="" rows="6" style="width: 80%"></textarea></div></div></div></div></div></div><br></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Waitlist</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-check text-navy"></i>&nbsp;Added to waitlist message</h5><small>This message will be sent when customer is added to waitlist.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1">Message:<br><textarea class="" rows="6" style="width: 80%"></textarea></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-bell text-success"></i>&nbsp;Table is avilable message</h5><small>This message will be sent to customer when matched table is available.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1">Message:<br><textarea class="" rows="6" style="width: 80%"></textarea></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-heart text-danger"></i>&nbsp;Thank you message</h5><small>This message will be sent to customer certain time after customer visit ends.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1"><input type="checkbox">&nbsp;&nbsp;Send thank you message to customer.</div></div><div class="row"><div class="col-lg-offset-1"><input type="checkbox">&nbsp;&nbsp;Ask customer to provide feedback for visit.</div></div><br><div class="row"><div class="col-lg-offset-1">Message:<br><textarea class="" rows="6" style="width: 80%"></textarea></div></div></div></div></div></div><br></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/settings/application/partials/tables.html','<div class="row"><div class="col-sm-12"><div ng-repeat="area in settings.areas"><div class="panel panel-primary"><div class="panel-heading"><h4><i class="fa fa-cutlery">&nbsp;</i> {{area.name}} <a ng-click="editArea(area)" href="" class="m-l-xs"><i class="fa fa-pencil fa-lg"></i></a> <a ng-click="removeArea(area)" href="" class="pull-right"><i class="fa fa-trash fa-lg"></i></a></h4></div><div class="panel-body"><div class="row"><div class="col-sm-12"><div deckgrid class="deckgrid" source="area.resources"><div class="table-area" style="height: 150px"><a ng-click="mother.editTable(card)" href="" class="pull-right m-t-xs m-r-xs"><i class="fa fa-pencil fa-sm"></i></a> <a ng-click="mother.removeTable(mother.area, card)" href="" class="pull-right m-t-xs m-r-xs"><i class="fa fa-trash fa-sm"></i></a><p class="center">&nbsp;</p><p class="text-center m-b-sm"><span class="label label-primary" style="font-size: 16px">{{card.name}}</span><br><br><span><i class="fa fa-group"></i> {{card.capacity}}</span><br><span ng-show="card.vip"><i class="fa fa-credit-card"></i> VIP</span></p></div></div></div></div><div class="row"><div class="col-sm-12"><button type="submit" ng-click="addTable(area)" class="btn btn-primary pull-right"><i class="fa fa-plus-square fa-lg"></i>&nbsp;Add table</button></div></div></div></div></div></div></div><div class="row m-b-md"><div class="col-sm-12"><button type="submit" ng-click="addArea()" class="btn btn-primary pull-right"><i class="fa fa-plus-square fa-lg"></i>&nbsp;Add area</button></div></div><div class="clearfix"></div>');
$templateCache.put('app/settings/application/partials/widget.html','<div class="row"><div class="col-lg-7"><div class="row"><div class="col-lg-12"><p>Choose reservation widget theme:</p><button class="btn btn-primary dim btn-large-dim btn_outline active" type="button"></button> <button class="btn btn-warning dim btn-large-dim btn-outline" type="button"></button> <button class="btn btn-danger dim btn-large-dim btn-outline" type="button"></button> <button class="btn btn-info dim btn-large-dim btn-outline" type="button"></button> <button class="btn btn-success dim btn-large-dim btn-outline" type="button"></button></div></div><div class="row"><div class="col-lg-12"><br><p>Customize reservation widget text:</p></div></div><div class="row"><form class="form-horizontal"><div class="form-group"><label class="col-sm-3 control-label">Widget title</label><div class="col-sm-7"><input class="form-control" type="text" value="Book a table"></div></div></form></div><div class="row"><div class="col-lg-12"><br><p>Widget position in browser window:</p></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><button aria-pressed="false" data-toggle="button" class="btn btn-primary btn-outline" type="button">Top left</button>&nbsp; <button aria-pressed="false" data-toggle="button" class="btn btn-primary btn-outline" type="button">Top right</button>&nbsp; <button aria-pressed="false" data-toggle="button" class="btn btn-primary btn-outline" type="button">Bottom left</button>&nbsp; <button aria-pressed="false" data-toggle="button" class="btn btn-primary btn-outline active" type="button">Bottom right</button>&nbsp;</div></div></div><div class="col-lg-5"><div class="ibox float-e-margins"><div class="ibox-title text-center"><h4 class="">Preview reservation widget</h4></div><div class="ibox-content ibox-heading"><div class="row"><div class="col-lg-10 col-lg-offset-1"><div class="row"><div class="col-lg-12"><br><a class="btn btn-primary btn-rounded btn-block" href="#"><i class="fa fa-calendar"></i> Book a table</a></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-4"><div class="widget navy-bg"><div class="row"><div class="col-xs-12 font-bold"><span>FIND<br>TABLE</span></div></div></div></div><div class="col-lg-4"><div class="widget"><div class="row"><div class="col-xs-12 font-bold"><span>CONTACT<br>DETAILS</span></div></div></div></div><div class="col-lg-4"><div class="widget"><div class="row"><div class="col-xs-12 font-bold"><span>BOOK<br>TABLE</span></div></div></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><h4>Find a table for desired time and date.</h4></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><form class=""><div class="row"><div class="col-lg-12"><div class="input-group m-b"><span class="input-group-addon"><i class="fa fa-calendar text-navy"></i></span> <input placeholder="Choose date" class="form-control" type="text"></div></div></div><div class="row"><div class="col-lg-12"><div class="input-group m-b"><span class="input-group-addon"><i class="fa fa-clock-o text-navy"></i></span> <input placeholder="Choose time" class="form-control" type="text"></div></div></div><div class="row"><div class="col-lg-12"><div class="input-group m-b"><span class="input-group-addon"><i class="fa fa-users text-navy"></i></span> <input placeholder="# of people" class="form-control" type="text"></div></div></div><div class="row"><div class="col-lg-12"><button class="btn btn-primary col-lg-12" type="button"><i class="fa fa-search-plus"></i>&nbsp;&nbsp;Find available table</button></div></div></form></div></div></div></div></div></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><br><p>To enable visitors of your website to make reservation please add below code to your website pages.</p><small>More information on how to integrate reservation widget in your website you can found in <a href="" class="text-success">help pages</a>.</small><br><br><div class="panel panel-default"><div class="panel-heading">Please copy the below code and paste it in your webpages just before &lt;/body&gt; tag</div><div class="panel-body"><div class="row"><div class="" col-lg-12><pre>\n    &lt;!-- Reservation widget for websites --&gt;\n    &lt;script type=\'text/javascript\'&gt;\n    var _glc =_glc || []; _glc.push(\'all_ag9zfmNsaWNrZGVza2NoYXRyDwsSBXVzZXJzGJDXn70NDA\');\n    var glcpath = ((\'https:\' == document.location.protocol) ? \'https://my.clickdesk.com/clickdesk-ui/browser/\' :\n    \'http://my.clickdesk.com/clickdesk-ui/browser/\');\n    var glcp = ((\'https:\' == document.location.protocol) ? \'https://\' : \'http://\');\n    var glcspt = document.createElement(\'script\'); glcspt.type = \'text/javascript\';\n    glcspt.async = true; glcspt.src = glcpath + \'livechat-new.js\';\n    var s = document.getElementsByTagName(\'script\')[0];s.parentNode.insertBefore(glcspt, s);\n    &lt;/script&gt;\n    &lt;!-- End of reservation widget --&gt;\n</pre></div></div><div class="row"><div class="col-lg-12"><a type="button" class="btn btn-w-m btn-primary col-lg-12">Copy Code to Clipboard</a></div></div></div></div></div></div>');
$templateCache.put('app/settings/employees/partials/employee.history.html','<div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3 class="text-navy"><i class="fa fa-wifi"></i> Latest activity</h3></div><div class="ibox-content"><table class="table table-striped"><thead><tr><th><i class="fa fa-info-circle"></i>&nbsp;Type</th><th><i class="fa fa-clock-o"></i> Time</th><th><i class="fa fa-check-circle-o"></i> Activity description</th><th><i class="fa fa-info-circle"></i></th></tr></thead><tbody><tr ng-repeat="change in employeeCtrl.employeeChangeHistory | orderBy: \'-createdDate\'"><td><span ng-class="employeeCtrl.utils.getEventTypeBkg(change.eventType)">{{employeeCtrl.utils.formatEventType(change.eventType)}}</span></td><td>{{change.createdDate | amDateFormat: \'lll\'}} ({{change.createdDate | amTimeAgo}})</td><td ng-bind-html="change.description | highlight:\'(created|seated|closed|canceled|modified|confirmed|waitlist|sent|re-opened|reverted)\':\'text-navy\'"></td><td><button type="submit" class="btn btn-success btn-sm btn-outline" ui-sref="tables.eventDetails({eventId: change.event.id})">Show details</button></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/settings/employees/partials/general.employee.stats.html','<div class="row"><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-success pull-right">Overall</span><h5 class="">Lifetime Revenue</h5></div><div class="ibox-content"><h1 class="no-margins">{{ employeeCtrl.employee.totalCustomerRevenue | currency }}</h1><br>Avg per<stran stext="person" type="s"></stran>{{ employeeCtrl.employeeStats.avgSpendPerCover | currency }} <span class="font-bold pull-right text-navy"><level-pct val1="employeeCtrl.employeeStats.avgSpendPerCover" val2="employeeCtrl.locationStats.avgSpendByCover"></level-pct></span></div></div></div><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-success pull-right">Overall</span><h5 class="">Lifetime Tips</h5></div><div class="ibox-content"><h1 class="no-margins">{{ employeeCtrl.employee.totalTips | currency }}</h1><br>Avg tip per<stran stext="person" type="s"></stran>{{ employeeCtrl.employee.avgTipPerCover | currency }} ({{ employeeCtrl.employeeStats.tipsPct | percentage:2 }}) <span class="font-bold pull-right text-danger"><level-pct val1="employeeCtrl.employee.totalTips" val2="employeeCtrl.locationStats.totalTips / employeeCtrl.numberOfEmployees"></level-pct></span></div></div></div><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><span ng-if="employeeCtrl.employeeStats.noShowPct>employeeCtrl.locationStats.totalNoShowRatio" class="label label-danger pull-right">High</span> <span ng-if="employeeCtrl.employeeStats.noShowPct<=employeeCtrl.locationStats.totalNoShowRatio" class="label label-info pull-right">Low</span><h5 class="text-danger">No show rate</h5></div><div class="ibox-content"><h1 class="no-margins">{{ employeeCtrl.employeeStats.noShowPct | percentage:2}}</h1><br>Total no show events <span class="text-danger">{{ employeeCtrl.employee.totalReservationNoShow + employeeCtrl.employee.totalWaitlistNoShow | number}} <span class="font-bold pull-right text-danger text-small"><level-pct val1="employeeCtrl.employeeStats.noShowPct" val2="employeeCtrl.locationStats.totalNoShowRatio" invert="true"></level-pct></span></span></div></div></div></div>');
$templateCache.put('app/settings/employees/partials/monthly_performance_tab.html','<div class="row"><div class="col-lg-12"><div class="penal white-panel"><div class="panel-content"><div class="row"><div class="col-lg-12"><br><h4 class="font-bold no-margins">Last 12 months plus current month performance statistics</h4><small>Calculated for events closed by employee.</small></div></div><div class="row" ng-show="!employeeCtrl.monthlyPerformance"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Analyze performance of your employee for last 12 months.<br>Identify employee performance in several key categories (total sales, total tips, averages per visit or cover, etc).<br><br><small>Follow this link to find more information about <a href="https://support.seaton.site/275736-Employee-details#MonthlyPerf" target="_blank">Employee weekly performance report</a>.</small><br><br><button class="btn btn-danger" ng-click="employeeCtrl.openWindow()" target="_blank">{{::employeeCtrl.monthlyPerformanceText}}</button><br><br><small><span class="text-success">Below you can see an example of the Employee performance report for last 12 months.</span></small></div></div></div><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/SettingsEmployeesMonthPerf.png" class="img-responsive"></div></div></div></div><div class="row" ng-show="employeeCtrl.monthlyPerformance"><div class="col-lg-12"><div class="row"><div class="col-md-9"><div class="dashboard-chart"><div google-chart chart="employeeCtrl.chartObjectTrend"></div></div></div><div class="col-md-3"><br><div ng-include-template="app/reporting/revenuetrend/partials/SpendTrendEventsStatsTotal.html" ng-include-variables="{vm: employeeCtrl, currencyIcon: currencyIcon, data: \'monthlyStatsTotal\', title: \'Last 12 month totals\' }"></div></div><div class="col-md-1"></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><p>Average revenue on monthly basis: <strong>{{employeeCtrl.averageRevenuePerMonth | currency}}</strong></p><p>Average tips on monthly basis: <strong>{{employeeCtrl.averageTipsPerMonth | currency}} ({{employeeCtrl.avgTipsVsRevenuePct_monthly | percentage:2}})</strong></p></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-12 col-lg-4 pull-right"><select class="" data-ng-model="employeeCtrl.order.field"><option>Sort months by ...</option><option value="amountSum">Sort by revenue</option><option value="amountAvgPerCover">Sort by average revenue per person</option><option value="tipSum">Sort by total tips</option><option value="tipAvg">Sort by average tips per visit</option><option value="tipAvgPct">Sort by average tips in percentage</option><option value="tipAvgPerCover">Sort by average tips per person</option><option value="visitsCount">Sort by number of visits</option><option value="covers">Sort by number of persons</option><option value="noShowPct">Sort by no show rate</option><option value="reservationRatio">Sort by reservation ratio</option></select>&nbsp; Reverse order: <input type="checkbox" data-ng-model="employeeCtrl.order.reverse"></div></div><div class="row"><div class="col-lg-12"><div ng-include-template="app/customer/profile/partials/aggrSpendByWeekday.html" ng-include-variables="{ vm: employeeCtrl, currencyIcon: currencyIcon, data: \'aggrByMonthData\', avgSpendPerCover: \'avgSpendPerCover\', lossLabel: \'(gen avg)\' }"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/settings/employees/partials/visit_statisitic_tab.html','<div class="row"><div class="col-lg-12"><div class="panel white-panel"><div class="panel-body"><div class="row"><div class="col-lg-6"><br><br><span class="text-info font-bold">General visit statistics</span> <span class="label label-info pull-right">Overall</span><br><br><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th><th>% diff</th><th># covers</th></thead><tbody><tr><td>Reservation</td><td>{{employeeCtrl.employee.totalReservationShow | number}}</td><td>{{employeeCtrl.employeeStats.totalReservationShowPerTotalVisitsPct | percentage:2}}</td><td class="text-navy"><level-pct val1="employeeCtrl.employeeStats.totalReservationShowPerTotalVisitsPct" val2="employeeCtrl.locationStats.totalReservationShowGenaralRatio"></level-pct></td><td>{{employeeCtrl.employee.totalReservationCover | number}}</td></tr><tr><td>Walk-in seated</td><td>{{employeeCtrl.employee.totalWalkinSeated | number}}</td><td>{{employeeCtrl.employeeStats.walkinSeatedPerTotalVisitsPct | percentage:2}}</td><td class="text-navy"><level-pct val1="employeeCtrl.employeeStats.walkinSeatedPerTotalVisitsPct" val2="employeeCtrl.locationStats.totalWalkinSeatedGenaralRatio"></level-pct></td><td>{{employeeCtrl.employee.totalWalkinSeatedCover | number}}</td></tr><tr><td>Walk-in waitlisted</td><td>{{employeeCtrl.employee.totalWaitlistShow | number}}</td><td>{{employeeCtrl.employeeStats.totalWaitlistShowPerTotalVisitsPct | percentage:2}}</td><td class="text-navy"><level-pct val1="employeeCtrl.employeeStats.totalWaitlistShowPerTotalVisitsPct" val2="employeeCtrl.locationStats.totalWaitlistShowGenaralRatio"></level-pct></td><td>{{employeeCtrl.employee.totalWaitlistCover | number}}</td></tr><tr><th>Totals</th><th>{{employeeCtrl.employeeStats.totalVisits}}</th><th></th><th><level-pct val1="employeeCtrl.employeeStats.totalVisits" val2="employeeCtrl.locationStats.totalVisits / employeeCtrl.numberOfEmployees"></level-pct>({{ employeeCtrl.locationStats.totalVisits / employeeCtrl.numberOfEmployees | number : 2}})</th><th>{{employeeCtrl.employeeStats.totalCovers}}</th></tr></tbody></table></div><div class="col-lg-6"><span ng-if="employeeCtrl.chartObjectVisitGeneral"><include-pie-chart piechartdata="employeeCtrl.chartObjectVisitGeneral"></span></div></div></div></div></div></div><div class="row"><div class="col-lg-6"><div class="panel white-panel"><div class="panel-heading"><span class="font-bold text-info">Reservation statistics</span> <span class="label label-info pull-right">Overall</span></div><div class="panel-body"><div class="row"><div class="col-lg-12"><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th><th>% diff</th></thead><tbody><tr><td>Show</td><td>{{employeeCtrl.employee.totalReservationShow | number}}</td><td>{{employeeCtrl.employeeStats.totalReservationShowPct | percentage:2 }}</td><td class="text-navy"><level-pct val1="employeeCtrl.employeeStats.totalReservationShowPct" val2="employeeCtrl.locationStats.totalReservationShowRatio"></level-pct></td></tr><tr><td>No Show</td><td>{{employeeCtrl.employee.totalReservationNoShow | number}}</td><td>{{employeeCtrl.employeeStats.totalReservationNoShowPct | percentage:2 }}</td><td class="text-danger"><level-pct val1="employeeCtrl.employeeStats.totalReservationNoShowPct*100" val2="employeeCtrl.locationStats.totalReservationNoShowRatio*100" invert="true"></level-pct></td></tr><tr><td>Cancelation</td><td>{{employeeCtrl.employee.totalReservationCanceled | number}}</td><td>{{employeeCtrl.employeeStats.totalReservationCanceledPct | percentage:2 }}</td><td class="text-danger"><level-pct val1="employeeCtrl.employeeStats.totalReservationCanceledPct" val2="employeeCtrl.locationStats.totalReservationCanceledRatio" invert="true"></level-pct></td></tr><tr><th>Totals</th><th>{{employeeCtrl.employeeStats.totalReservation}}</th><th></th><th class="text-danger"><level-pct val1="employeeCtrl.employeeStats.totalReservation" val2="employeeCtrl.locationStats.totalReservation / employeeCtrl.numberOfEmployees"></level-pct></th></tr></tbody></table></div></div><div class="row"><div class="col-lg-12"><span ng-if="employeeCtrl.chartObjectReservationGeneral"><include-pie-chart piechartdata="employeeCtrl.chartObjectReservationGeneral"></span></div></div></div></div></div><div class="col-lg-6"><div class="panel white-panel"><div class="panel-heading"><span class="font-bold text-info">Waitlist statistics</span> <span class="label label-info pull-right">Overall</span></div><div class="panel-body"><div class="row"><div class="col-lg-12"><table class="table table-striped"><thead><th></th><th>#</th><th>% share</th><th>% diff</th></thead><tbody><tr><td>Show</td><td>{{employeeCtrl.employee.totalWaitlistShow | number}}</td><td>{{employeeCtrl.employeeStats.totalWaitlistShowPct | percentage:2 }}</td><td class="text-navy"><level-pct val1="employeeCtrl.employeeStats.totalWaitlistShowPct*100" val2="employeeCtrl.locationStats.totalWaitlistShowRatio*100"></level-pct></td></tr><tr><td>No Show</td><td>{{employeeCtrl.employee.totalWaitlistNoShow | number}}</td><td>{{employeeCtrl.employeeStats.totalWaitlistNoShowPct | percentage:2 }}</td><td class="text-danger"><level-pct val1="employeeCtrl.employeeStats.totalWaitlistNoShowPct*100" val2="employeeCtrl.locationStats.totalWaitlistNoShowRatio*100" invert="true"></level-pct></td></tr><tr><td>Cancelation</td><td>{{employeeCtrl.employee.totalWaitlistCanceled | number}}</td><td>{{employeeCtrl.employeeStats.totalWaitlistCanceledPct | percentage:2 }}</td><td class="text-danger"><level-pct val1="employeeCtrl.employeeStats.totalWaitlistCanceledPct*100" val2="employeeCtrl.locationStats.totalWaitlistCanceledRatio*100" invert="true"></level-pct></td></tr><tr><th>Totals</th><th>{{employeeCtrl.employeeStats.totalWaitlist | number}}</th><th></th><th class="text-danger"><level-pct val1="employeeCtrl.employeeStats.totalWaitlist" val2="employeeCtrl.locationStats.totalWaitlist / employeeCtrl.numberOfEmployees"></level-pct></th></tr></tbody></table></div></div><div class="row"><div class="col-lg-12"><span ng-if="employeeCtrl.chartObjectWaitlistGeneral"><include-pie-chart piechartdata="employeeCtrl.chartObjectWaitlistGeneral"></span></div></div></div></div></div></div>');
$templateCache.put('app/settings/employees/partials/weekly_performance_tab.html','<div class="row"><div class="col-lg-12"><div class="panel float-e-margins"><div class="panel-content"><br><div class="row"><div class="col-lg-12"><h4 class="font-bold no-margins">Weekly performance statistics - week: {{employeeCtrl.filterStartDate | amDateFormat: \'Do MMM YY\' }} - {{employeeCtrl.filterEndDate | amDateFormat: \'Do MMM YY\'}}</h4><small>Calculated with events closed by the employee.</small></div></div><br><div class="row" ng-show="!employeeCtrl.weeklyPerformance"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Analyze performance of your employee for each day of the selected week.<br>Identify employee performance in several key categories (total sales, total tips, averages per visit or cover, etc).<br><br><small>Follow this link to find more information about <a href="https://support.seaton.site/275736-Employee-details#WeeklyPerf" target="_blank">Employee weekly performance report</a>.</small><br><br><button class="btn btn-danger" ng-click="employeeCtrl.openWindow()" target="_blank">{{::employeeCtrl.weeklyPerformanceText}}</button><br><br><small><span class="text-success">Below you can see an example of the Employee weekly performance report.</span></small></div></div></div><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/SettingsEmployeesWeekPerf.png" class="img-responsive"></div></div></div></div><div class="row" ng-show="employeeCtrl.weeklyPerformance"><div class="col-lg-12"><div class="row"><div class="col-lg-8"><div class="uib-btn-group col-lg-8 col-md-12"><label ng-model="employeeCtrl.selectedInterval" uib-btn-radio="\'lastWeek\'" class="btn btn-primary btn-outline" ng-change="employeeCtrl.changedSelectedInterval()" required><span>Last week</span></label><label ng-model="employeeCtrl.selectedInterval" uib-btn-radio="\'currentWeek\'" class="btn btn-primary btn-outline" ng-change="employeeCtrl.changedSelectedInterval()" required><span>Current week</span></label></div></div><div class="col-lg-4 col-md-12 pull-right"><div class="form-group"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="employeeCtrl.openPicker(\'pickerDate\')"><i class="fa fa-calendar"></i></button> </span><input placeholder="Choose week to display" class="form-control" name="pickerDate"></div></div></div></div><div class="row"><div class="col-md-9"><div class="dashboard-chart"><div google-chart chart="employeeCtrl.chartObjectWeekPerf"></div></div></div><div class="col-md-3"><br><div ng-include-template="app/reporting/revenuetrend/partials/SpendTrendEventsStatsTotal.html" ng-include-variables="{vm: employeeCtrl, currencyIcon: currencyIcon, data: \'weeklyStatsTotal\', title: \'Week totals\' }"></div></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><p>Average revenue on daily basis in the selected week: <strong>{{employeeCtrl.averageRevenuePerDay | currency}}</strong></p><p>Average tips on daily basis in the selected week: <strong>{{employeeCtrl.averageTipsPerDay | currency}} ({{employeeCtrl.avgTipsVsRevenuePct | percentage:2}})</strong></p></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-12 col-lg-4 pull-right"><select class="" data-ng-model="employeeCtrl.order.field"><option>Sort week days by ...</option><option value="amountSum">Sort by revenue</option><option value="amountAvgPerCover">Sort by average revenue per person</option><option value="tipSum">Sort by total tips</option><option value="tipAvg">Sort by average tips per visit</option><option value="tipAvgPct">Sort by average tips in percentage</option><option value="tipAvgPerCover">Sort by average tips per person</option><option value="visitsCount">Sort by number of visits</option><option value="covers">Sort by number of persons</option><option value="noShowPct">Sort by no show rate</option><option value="reservationRatio">Sort by reservation ratio</option></select>&nbsp; Reverse order: <input type="checkbox" data-ng-model="employeeCtrl.order.reverse"></div></div><div class="row"><div class="col-lg-12"><div ng-include-template="app/customer/profile/partials/aggrSpendByWeekday.html" ng-include-variables="{ vm: employeeCtrl, currencyIcon: currencyIcon, data: \'aggrByWeekdayDetailData\', avgSpendPerCover: \'avgSpendPerCover\', lossLabel: \'(gen avg)\' }"></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/settings/online/availability/availability.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12 col-md-10"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Online availability status widget settings</h2>Online availability status widget will appear on restaurant web pages and provide to visitors current table availability status.<br>Here you can enable web widget, customize to match your restaurant web page look and feel and get information on how to integrate widget on your web page.</div><div class="panel-body"><div class="row"><div class="col-lg-12 col-lg-offset-1"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.custo.enabled"></checkbox>&nbsp;&nbsp;Enable online availability widget<br><br></div></div><div class="row"><div class="col-lg-12 text-right"><button ng-disabled="formGroups.$invalid" aria-pressed="false" data-toggle="button" class="btn btn-primary" type="button" ng-click="vm.save()">Save settings</button></div></div><div class="row"><form name="formGroups"><div class="col-sm-12"><uib-tabset><uib-tab><uib-tab-heading class="text-center">Status messages</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class="text-navy"><i class="fa fa-exclamation-circle"></i>&nbsp;Availability status GREEN</h5><small>This message will be show to customer if more than defined percentage of tables are free and available.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1">If minimum &nbsp;&nbsp;<select ng-model="vm.custo.availableThreshold" ng-required="true" ng-options="item.id as item.name for item in vm.threshold_options"></select>&nbsp;&nbsp; tables are free, availability status will be GREEN.</div></div><br><div class="row"><div class="col-lg-offset-1">Title:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.greenTitle.$invalid}"><input name="greenTitle" class="form-control" type="text" style="width: 80%" ng-model="vm.custo.availableTitle" ng-required="true" ng-maxlength="32" maxlength="32"><div class="validation-error" ng-show="formGroups.greenTitle.$invalid"><div ng-messages="formGroups.greenTitle.$error" role="alert" class="text-danger"><div ng-message="required">Title is required.</div><div ng-message="maxlength">Title cannot exceed 32 characters.</div></div></div></div></div></div><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.greenMessage.$invalid}"><textarea name="greenMessage" class="form-control" type="text" rows="6" style="width: 80%" ng-model="vm.custo.availableText" ng-required="true" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.greenMessage.$invalid"><div ng-messages="formGroups.greenMessage.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="vm.custo.availableText == \'\' || !vm.custo.availableText">0/2048</div><div ng-if="vm.custo.availableText != \'\' && vm.custo.availableText">{{vm.custo.availableText.length}}/2048</div><div><button type="submit" class="btn btn-sm btn-default btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showAvailabilityStatusDialog(\'green\')"><i class="fa fa-external-link"></i> Preview availability status GREEN</button></div></div></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class="text-warning"><i class="fa fa-exclamation-circle"></i>&nbsp;Availability status YELLOW</h5><small>This message will be show to web page visitors if less than {{vm.custo.availableThreshold}}% percentage of tables are free and available.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-offset-1">Title:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.yellowTitle.$invalid}"><input name="yellowTitle" class="form-control" type="text" style="width: 80%" ng-model="vm.custo.almostFullTitle" ng-required="true" ng-maxlength="32" maxlength="32"><div class="validation-error" ng-show="formGroups.yellowTitle.$invalid"><div ng-messages="formGroups.yellowTitle.$error" role="alert" class="text-danger"><div ng-message="required">Title is required.</div><div ng-message="maxlength">Title cannot exceed 32 characters.</div></div></div></div></div></div><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.yellowText.$invalid}"><textarea name="yellowText" class="form-control" type="text" rows="6" style="width: 80%" ng-model="vm.custo.almostFullText" ng-required="true" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.yellowText.$invalid"><div ng-messages="formGroups.yellowText.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="vm.custo.almostFullText == \'\' || !vm.custo.almostFullText">0/2048</div><div ng-if="vm.custo.almostFullText != \'\' && vm.custo.almostFullText">{{vm.custo.almostFullText.length}}/2048</div><div><button type="submit" class="btn btn-sm btn-default btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showAvailabilityStatusDialog(\'yellow\')"><i class="fa fa-external-link"></i> Preview availability status YELLOW</button></div></div></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class="text-danger"><i class="fa fa-exclamation-circle"></i>&nbsp;Availability status RED</h5><small>This message will be show to web page visitors if all tables are occupied.</small><br><br></div></div><div class="row"><div class="col-lg-12"><br><div class="row"><div class="col-lg-offset-1"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.custo.allowAdding"></checkbox>&nbsp;&nbsp;allow visitors to add to the wait list (enable online wait list)<br><br></div></div><div class="row"><div class="col-lg-offset-1">Title:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.redTitle.$invalid}"><input name="redTitle" class="form-control" type="text" style="width: 80%" ng-model="vm.custo.occupiedTitle" ng-required="true" ng-maxlength="32" maxlength="32"><div class="validation-error" ng-show="formGroups.redTitle.$invalid"><div ng-messages="formGroups.redTitle.$error" role="alert" class="text-danger"><div ng-message="required">Title is required.</div><div ng-message="maxlength">Title cannot exceed 32 characters.</div></div></div></div></div></div><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.redMessage.$invalid}"><textarea name="redMessage" class="form-control" type="text" rows="6" style="width: 80%" ng-model="vm.custo.occupiedText" ng-required="true" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.redMessage.$invalid"><div ng-messages="formGroups.redMessage.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="vm.custo.occupiedText == \'\' || !vm.custo.occupiedText">0/2048</div><div ng-if="vm.custo.occupiedText != \'\' && vm.custo.occupiedText">{{vm.custo.occupiedText.length}}/2048</div><div><button type="submit" class="btn btn-sm btn-default btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showAvailabilityStatusDialog(\'red\')"><i class="fa fa-external-link"></i> Preview availability status RED</button></div></div></div></div></div></div></div></div><br><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-exclamation-circle"></i>&nbsp;Availability status CLOSED</h5><small>This message will be show to web page visitors if restaurant is closed.</small><br><br></div></div><div class="row"><div class="col-lg-12"><br><div class="row"><div class="col-lg-offset-1">Title:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.blackTitle.$invalid}"><input name="blackTitle" class="form-control" type="text" style="width: 80%" ng-model="vm.custo.closedTitle" ng-required="true" ng-maxlength="32" maxlength="32"><div class="validation-error" ng-show="formGroups.blackTitle.$invalid"><div ng-messages="formGroups.blackTitle.$error" role="alert" class="text-danger"><div ng-message="required">Title is required.</div><div ng-message="maxlength">Title cannot exceed 32 characters.</div></div></div></div></div></div><div class="row"><div class="col-lg-offset-1">Message:<br><div class="form-group" ng-class="{ \'has-error\': formGroups.blackMessage.$invalid}"><textarea name="blackMessage" class="form-control" type="text" rows="6" style="width: 80%" ng-model="vm.custo.closedText" ng-required="true" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.blackMessage.$invalid"><div ng-messages="formGroups.blackMessage.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="vm.custo.closedText == \'\' || !vm.custo.closedText">0/2048</div><div ng-if="vm.custo.closedText != \'\' && vm.custo.closedText">{{vm.custo.closedText.length}}/2048</div><div><button type="submit" class="btn btn-sm btn-default btn-outline ng-isolate-scop" style="margin-top: 6px" ng-click="showAvailabilityStatusDialog(\'black\')"><i class="fa fa-external-link"></i> Preview availability status CLOSED</button></div></div></div></div></div></div></div></div><br></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Customization</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-check text-navy"></i>&nbsp;Customize Avilability Widget Button</h5><small>Customize availability status widget button to better match your web page look and feel..</small><br><br></div></div><div class="row"><div class="col-lg-6"><div class="row"><div class="col-lg-12"><strong>Button position</strong><br><small>Button will be floated to selected page edge and will be fixed in selected position.</small><br><br></div></div><div class="row"><div class="col-lg-5 col-lg-offset-1"><select ng-model="vm.custo.position" ng-options="item.id as item.name for item in vm.position_options" class="col-lg-12" ng-change="vm.updatePreview()"></select></div><div class="col-lg-5"><select ng-model="vm.custo.padding" ng-options="item.id as item.name for item in vm.padding_options" class="col-lg-12" ng-change="vm.updatePreview()"></select></div></div><div class="row"><div class="col-lg-12"><br><br><strong>Button text</strong><br><small>Define text for floating button. You can use HTML tags to decorate button text.</small><br><br></div></div><div class="row"><div class="col-lg-12"><input class="col-lg-10 col-lg-offset-1" ng-model="vm.custo.buttonText" ng-change="vm.updatePreview()"></div></div><div class="row"><div class="col-lg-12"><br><br><strong>Button colors</strong><br><small>Define button colors to better match look and feel of your web page.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-5 col-lg-offset-1"><input color-picker color-picker-model="vm.custo.backgroundColor" ng-model="vm.custo.backgroundColor" ng-style="{background:vm.custo.backgroundColor}"><br><small>Background color</small></div><div class="col-lg-6"><input color-picker color-picker-model="vm.custo.textColor" ng-model="vm.custo.textColor" ng-style="{background:vm.custo.textColor}"><br><small>Text color</small></div></div></div></div><div class="row"><div class="col-lg-12"><br><div class="row"><div class="col-lg-5 col-lg-offset-1"><input color-picker color-picker-model="vm.custo.backgroundColorHover" ng-model="vm.custo.backgroundColorHover" ng-style="{background:vm.custo.backgroundColorHover}"><br><small>Hover background color</small></div><div class="col-lg-6"><input color-picker color-picker-model="vm.custo.textColorHover" ng-model="vm.custo.textColorHover" ng-style="{background:vm.custo.textColorHover}"><br><small>Hover text color</small></div></div></div></div><div class="row"><div class="col-lg-12"><br><div class="row"><div class="col-lg-5 col-lg-offset-1"><input color-picker color-picker-model="vm.custo.buttonLineColor" ng-model="vm.custo.buttonLineColor" ng-style="{background:vm.custo.buttonLineColor}"><br><small>Button line color</small></div></div></div></div><div class="row"><div class="col-lg-12"><br><br><strong>Font size</strong><br><small>Define button text font size.</small><br><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><select ng-model="vm.custo.fontSize" ng-options="fnt.id.toString() as fnt.name for fnt in vm.font_size" class="col-lg-4" ng-change="vm.updatePreview()"></select></div></div><div class="row"><div class="col-lg-12"><br><br><strong>Button transparency</strong><br><small>Define button transparency to better match look and feel of your web page.</small><br><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><input id="slider_transparency"></div></div></div><div class="col-lg-6"><iframe id="previewFrame" allowtransparency="true" style="background: #c3d9ec; border-width: 1px" src="app/settings/online/availability/preview.html" frameborder="2" height="600" width="100%"></iframe></div></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Integration</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h5 class=""><i class="fa fa-at text-success"></i>&nbsp;Integrate availability widget with you web page</h5><small>Easy integration with your web page in just 2 minutes.</small><br><br></div></div><div class="row"><div class="col-lg-12"><p>To enable visitors of your website to check table availability status by adding below code to your restaurant main web page.<br>More information on how to integrate availability status widget in your website you can found in <a href="" class="text-success">help pages</a>.</p><br>Please copy the below code and paste it in your main web page just before &lt;/body&gt; tag<br><textarea id="onlineWaitlistCode" ng-model="vm.integrationScript" class="col-lg-12" disabled="true" rows="10">\n    </textarea><small>Note: Once you have code on your web page, you can customize online availability status widget without modifying code on your page.</small><br><br></div></div><div class="row"><div class="col-lg-12"><a type="button" ng-click="vm.copyToClipboard()" class="btn btn-w-m btn-primary col-lg-12">Copy Code to Clipboard</a></div></div></div></div></div></div></uib-tab></uib-tabset></div></form></div></div></div></div></div></div>');
$templateCache.put('app/settings/online/availability/preview.html','<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>Title</title></head><body></body></html>');
$templateCache.put('app/settings/online/availability/preview.status.message.html','<div class="modal-body large" style="background-image: url(\'/content/images/availability_preview_bg2.jpg\')"><div class="row"><div class="col-lg-5" style="background: rgba(0,0,0,0.55)"><div ng-show="vm.type==\'green\'"><br><br><br><br><br><div class="text-center text-white" style="border: 2px; padding: 5px; background:rgba(0,200,0,0.2)"><strong>Current availability</strong></div><br><div class="text-center text-white" style="border: 2px; padding: 5px; background:rgba(0,0,0,0.5)"><br><span style="color: rgb(169,209,142)">{{vm.custo.availableTitle}}</span><br><br><span>{{vm.custo.availableText}}</span><br><br></div><br><br><br><br><br><br><br><br><br><br><br></div><div ng-show="vm.type==\'yellow\'"><br><br><br><br><br><div class="text-center text-white" style="border: 2px; padding: 5px; background:rgba(255,205,50,0.6)"><strong>Current availability</strong></div><br><div class="text-center text-white" style="border: 2px; padding: 5px; background:rgba(0,0,0,0.5)"><br><span style="color: rgb(235,125,50)">{{vm.custo.almostFullTitle}}</span><br><br><span>{{vm.custo.almostFullText}}</span><br><br></div><br><br><br><br><br><br><br><br><br></div><div ng-show="vm.type==\'red\'"><br><br><br><br><br><div class="text-center text-white" style="border: 2px; padding: 5px; background:rgba(255,0,0,0.4)"><strong>Current availability</strong></div><br><div class="text-center text-white" style="border: 2px; padding: 5px; background:rgba(0,0,0,0.5)"><br><span style="color: rgb(255,0,0)">{{vm.custo.occupiedTitle}}</span><br><br><span>{{vm.custo.occupiedText}}</span><br><br><button ng-show="vm.custo.allowAdding" style="border: 2px; padding: 5px; background:rgba(235,125,50,0.3)">ADD TO WAIT LIST</button><br><br></div><br><br><br><br><br><br><br><br><br></div><div ng-show="vm.type==\'black\'"><br><br><br><br><br><div class="text-center text-white" style="border: 2px; padding: 5px; background:rgba(17,17,17,0.4)"><strong>Current availability</strong></div><br><div class="text-center text-white" style="border: 2px; padding: 5px; background:rgba(0,0,0,0.5)"><br><span style="color: rgb(204,204,221)">{{vm.custo.closedTitle}}</span><br><br><span>{{vm.custo.closedText}}</span><br><br></div><br><br><br><br><br><br><br><br><br></div></div><div class="col-lg-7"><br><br><h1 class="text-center">Restaurant<br>Web<br>Page<br></h1><br><br><h3 class="text-center">Availability widget will float on the left side over the restaurant web page</h3></div></div></div>');
$templateCache.put('app/tables/create/reservation/reservation.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-7"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3>Search available<stran stext="resource" type="p"></stran></h3></div><div class="ibox-content"><div class="row"><div class="col-lg-9"><div class="col-lg-1"><i class="fa fa-calendar fa-2x"></i></div><div class="col-lg-11 btn-group" data-toggle="buttons"><label ng-repeat="day in vm.days" uib-btn-radio="day.date" ng-model="vm.selectedDay" ng-change="vm.daySelected()" title="Select the day" class="btn btn-primary btn-outline" style="margin: 1px"><input type="radio" name="dateRes" value="{{day.date}}" checked="checked"> {{day.label}}</label></div></div><div class="col-lg-3"><div class="form-group"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openDatePicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="select date" name="datePicker" type="text" class="form-control" ng-model="vm.selectedDayFormatted" close-text="Close"></div></div></div></div><div class="row"><div class="col-lg-9"><div class="col-lg-1"><i class="fa fa-clock-o fa-2x"></i></div><div class="col-lg-11 btn-group" data-toggle="buttons"><h4 ng-if="vm.slots.length == 0">Please select the desired time for the reservation:</h4><label ng-repeat="time in vm.slots" uib-btn-radio="time" ng-model="vm.selectedTime" ng-change="vm.timeChanged()" ng-class="vm.isWithinOpenHours(time) ? \'btn-primary\' : \'btn-warning\'" title="Select reservation time" class="btn btn-outline btn-sm" style="margin: 1px"><input type="radio" name="timeSlot" value="{{time}}" checked="checked"> {{time}}</label></div></div><div class="col-lg-3"><div class="form-group"><div class="input-group clockpicker" data-autoclose="true"><span class="input-group-addon" style="padding: 0px; margin-bottom: 0px; border-radius: 3px 0 0 3px"><span class="btn btn-default" style="border: 0px; margin-bottom: 0px"><i class="fa fa-clock-o"></i></span> </span><input placeholder="Other time" ng-change="vm.timeChanged()" ng-model="vm.selectedTime" type="text" class="form-control"></div></div></div></div><div class="row"><br></div><div class="row"><div class="col-lg-9"><div class="col-lg-1"><i class="fa fa-group fa-2x"></i></div><div class="col-lg-11 btn-group" data-toggle="buttons"><label ng-repeat="numberOfPersons in [1, 2, 3, 4, 5, 6]" uib-btn-radio="numberOfPersons" ng-change="vm.clearTables()" ng-model="vm.numberOfPersons" class="btn btn-primary btn-outline" title="Select the number of persons" style="margin: 1px">{{numberOfPersons}} Person<span ng-if="numberOfPersons > 1">s</span></label></div></div><div class="col-lg-3"><div class="form-group"><div class="input-group time"><span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-group"></i></button> </span><input ng-model="vm.numberOfPersons" ng-change="vm.clearTables()" placeholder="Other party size" type="number" class="form-control" min="1" ng-min="1"></div></div></div></div><div class="row"><br></div><div class="row"><div class="col-lg-9"><div class="col-lg-1"><i class="fa fa-hourglass-1 fa-2x"></i></div><div class="col-lg-11 btn-group" data-toggle="buttons"><label ng-repeat="product in vm.settings.shortProductList" uib-btn-radio="product.id" ng-change="vm.clearTables()" ng-model="vm.productId" class="btn btn-primary btn-outline" title="Select product" style="margin: 1px">{{product.nameWithDuration}}</label></div></div><div class="col-lg-3"><div class="form-group" ng-if="vm.settings.selectProductList.length > 0"><div class="input-group time"><span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-hourglass-1"></i></button></span><select ng-model="vm.productId" class="form-control" ng-options="product.id as product.nameWithDuration for product in vm.settings.selectProductList" ng-change="vm.clearTables()" placeholder="Select item" name="duration_element"><option value="">Other item</option></select></div></div></div></div><div class="row"><br></div><div class="row"><div class="col-lg-9 pull-left"><div class="col-lg-1"><span></span></div><div class="col-lg-11 btn-group"><button ng-disabled="!vm.selectedDay || !vm.isTimeSet() || !(vm.numberOfPersons > 0) || !vm.productId" ng-click="vm.findTables()" type="button" class="col-lg-6 btn btn-danger" style="margin: 0 0px"><i class="fa fa-search-plus"></i>&nbsp;Find<stran stext="resource" type="p"></stran></button> &nbsp;<br><br><span ng-show="vm.timelineNewEvent" class="text-navy"><b>Selected on timeline: <strong>{{vm.timelineNewEvent.new_resource_name}}</strong></b></span></div></div><div class="col-lg-3 pull-right"></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3 class="no-margins">Available<stran stext="resource" type="p"></stran>&nbsp;matching criteria</h3></div><div class="ibox-content"><div ng-if="vm.nonWorkingDay" class="row"><div class="col-lg-12"><span class="text-warning">Warning: Please note, selected day <span class="font-bold">{{vm.formatDateForDisplay(vm.selectedDay)}}</span> is defined as non working day in SeatOn settings!<br>However, you can proceed with reservation if you want.<br><br></span></div></div><div ng-if="vm.seatingOptionId" class="row"><div class="col-lg-12"><span class="text-navy">Guest seating choice is <strong>{{vm.seatingOptionLabel}}</strong>. Please take into account when assigning tables. Tables that match guest choice have green border.<br><br></span></div></div><div class="row"><div class="col-lg-12"><div class="btn-group col-lg-12"><label ng-repeat="table in vm.tables" ng-model="table.selected" uib-btn-checkbox class="" ng-class="vm.tableButtonStyle(table)" style="margin: 2px"><span class="font-bold text-success" ng-style="{color:table.areaColor}">{{table.name}}</span><br><span><i class="fa fa-male"></i>&nbsp;x {{table.capacity}}</span></label></div></div></div><div ng-if="vm.selectedDay && vm.isTimeSet() && vm.numberOfPersons && (vm.productId > 0) && vm.tables.length == 0 && vm.alternativeTimes.length == 0" class="row"><div class="col-lg-12"><h4 class="text-danger font-bold">No available<stran stext="resource" type="p"></stran>found for the defined criteria.</h4></div></div></div></div></div></div><div ng-show="vm.tables.length === 0 && vm.alternativeTimes.length > 0" class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3>Alternative time slots</h3></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><div class="btn-group col-lg-12" data-toggle="buttons"><label ng-repeat="altTime in vm.alternativeTimes" uib-btn-radio="altTime.time" ng-model="vm.selectedAltTime" ng-change="vm.altTimeSelected()" class="col-lg-2 btn btn-info btn-outline" style="margin: 0 2px"><input type="radio" name="time" value="{{altTime}}"> {{altTime.time}} ({{altTime.capacity}})</label></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Comment</label><div class="col-sm-9"><textarea ng-model="vm.note" rows="2" placeholder="Please enter additional comment" class="form-control" ng-maxlength="512"></textarea></div></div></form></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-12 text-center"><button class="btn btn-white" ng-click="vm.reset()" type="reset">Reset</button> &nbsp; <button ng-disabled="vm.isCreateDisabled()" class="btn btn-primary ng-isolate-scope" ng-click="vm.createReservation()" type="button">Create reservation</button></div></div><div class="row" ng-if="vm.isCreateDisabled() || vm.isCreateWithWarning()"><div class="ibox-content"><div class="row" ng-if="vm.getSelectedTables().length === 0"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-danger" close="closeAlert(0)">Please select a<stran stext="resource" type="s"></stran>!</div></div></div><div class="row" ng-if="vm.getSelectedTables().length > 0 && vm.getSelectedTablesCapacity() < vm.numberOfPersons"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-warning" close="closeAlert(0)">Selected<stran stext="resource" type="s"></stran>capacity ({{vm.getSelectedTablesCapacity()}}) is not enough to seat {{vm.numberOfPersons}} person(s).</div></div></div><div class="row" ng-if="vm.customer.id && !vm.customer.reservationAllowed"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-danger" close="closeAlert(0)">Creating reservations for this customer is not allowed!</div></div></div><div class="row" ng-if="customerForm.primaryEmail.$error.email"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-danger" close="closeAlert(0)">Invalid email address.</div></div></div><div class="row" ng-if="!vm.customer.firstName || !(vm.customer.primaryEmail || vm.customer.primaryPhone)"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-danger" close="closeAlert(0)">Please fill in missing customer information.</div></div></div></div></div></div></div></div></div></div><div class="col-lg-5"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3>Customer information</h3></div><div class="ibox-content"><div class="row"><form name="form" novalidate><div class="col-lg-8"><div class="input-group"><span class="input-group-addon"><i class="fa fa-search-plus"></i></span> <input name="keyword" ng-model="customerSearchKeyword" ng-required="true" ng-minlength="3" placeholder="Search by name, email or phone number" class="form-control" type="text"></div><p ng-if="form.keyword.$error.minlength" class="text-warning text-small">&nbsp;* at least 3 characters required</p><p ng-if="customerSearchKeyword || form.keyword.$error.required" style="color: white">_</p></div><div class="col-lg-4"><button ng-disabled="!customerSearchKeyword" id="searchButton" type="submit" class="btn btn-default btn-outline" customer-search-dialog customer-search-keyword="customerSearchKeyword" customer-selected-callback="customerSelected"><i class="fa fa-search"></i>&nbsp;Search</button> <button class="btn btn-default btn-outline" ng-click="vm.resetCustomer()"><i class="fa fa-remove" aria-hidden="true"></i>&nbsp;Reset</button></div></form></div><div class="hr-line-dashed" style="margin: 0 0 15px 0"></div><div class="row"><form name="customerForm" class="form-horizontal"><div class="col-lg-12"><div class="form-group" ng-class="{ \'has-error\': customerForm.firstName.$invalid}"><label class="col-sm-3 control-label">First name (*)</label><div class="col-sm-9"><input name="firstName" ng-model="vm.customer.firstName" class="form-control" placeholder="Please enter first name" ng-required="true" ng-maxlength="64" type="text"></div></div><div class="form-group"><label class="col-sm-3 control-label">Last name</label><div class="col-sm-9"><input name="lastName" ng-model="vm.customer.lastName" class="form-control" placeholder="Please enter last name" ng-maxlength="128" type="text"></div></div><div class="form-group" ng-class="{ \'has-error\': (customerForm.primaryEmail.$invalid && customerForm.primaryPhone.$invalid)  || customerForm.primaryEmail.$error.email}"><label class="col-sm-3 control-label">Email (*)</label><div class="col-sm-9"><div class="input-group m-b" style="margin: 0"><span class="input-group-addon">@</span> <input type="email" validate-email name="primaryEmail" ng-model="vm.customer.primaryEmail" class="form-control ng-pristine ng-untouched ng-valid" ng-required="true" placeholder="Please enter email address"></div></div></div><div class="form-group" ng-class="{ \'has-error\': customerForm.primaryEmail.$invalid && customerForm.primaryPhone.$invalid}"><label class="col-sm-3 control-label">Phone (*)</label><div class="col-sm-9"><div class="input-group m-b" style="margin: 0"><input id="primaryPhone" name="primaryPhone" ng-model="vm.customer.primaryPhone" size="35" class="form-control" model-view-value="true" ng-required="true" type="text" ng-intl-tel-input data-initial-country="{{vm.phoneRegion}}" data-default-country="{{vm.phoneRegion}}" ng-keyup="vm.reformatPhone()" placeholder="Please enter phone number"></div><div ng-if="customerForm.primaryEmail.$invalid && customerForm.primaryPhone.$invalid" class="text-danger">* either email or phone is required</div></div></div><div class="form-group"><label class="col-sm-3 control-label">Favorite<stran stext="resource" type="s"></stran></label><div class="col-sm-9"><span ng-if="vm.customer.favoriteTable" class="badge badge-success">{{vm.customer.favoriteTable.name}}</span> <span ng-if="!vm.customer.favoriteTable">--</span></div></div><div class="form-group"><label class="col-sm-3 control-label">Note</label><div class="col-sm-9"><textarea ng-model="vm.customer.note" rows="1" placeholder="Customer note" class="form-control" ng-maxlength="512"></textarea></div></div><div ng-if="vm.customer.id" class="form-group col-sm-9 pull-right"><a ui-sref="customers.profile({customerId: vm.customer.id})" target="_blank" class="btn btn-success btn-outline pull-right"><i class="fa fa-info-circle" aria-hidden="true"></i> View full customer profile</a></div></div></form></div></div></div></div></div><div class="row" ng-if="vm.customer.id"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3>Customer statistics</h3></div><div class="ibox-content"><div class="row" ng-show="!vm.showCustomerStatistic"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Make decision based on customer historical behavior.<br>Identify high valuable or frequent no-show customers.<br><br><button class="btn btn-danger btn-sm" ng-click="vm.openWindow()" target="_blank">{{::vm.showCustomerStatisticText}}</button><br><br><small><span class="text-success">Below you can see an example of the Customer visit statistics.</span></small></div></div></div><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/EventCreateCustomerStat.png" class="img-responsive"></div></div></div></div><div class="row" ng-show="vm.showCustomerStatistic"><div class="col-lg-6"><b>Total visits:</b>&nbsp;{{vm.customerTotal}}<br><b>Last visit:</b>&nbsp;{{vm.customer.lastVisitedDate | amDateFormat: \'DD MMM YYYY @ h:mm A\'}}<br><br><b ng-if="!vm.customer.reservationAllowed" class="text-danger">Reservation not allowed!</b><br><b ng-if="!vm.customer.waitlistAllowed" class="text-danger">Waitlist not allowed!</b></div><div class="col-lg-6"><div class="row"><div class="col-lg-12 center"><span class="text-warning"><h2>{{vm.customer.memberStatus}}</h2><span uib-rating style="font-size: 1.2em" ng-model="vm.customer.customerLevel" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="text-warning"></span><h3>{{vm.customer.totalPoints}} points</h3></span></div><div class="row"><div class="col-lg-12"></div></div></div></div></div><div class="row" ng-show="vm.showCustomerStatistic"><div class="col-lg-6"><table class="table"><thead><tr><th colspan="2">Spending statistic</th></tr></thead><tbody><tr><td>Total spend</td><td>{{vm.customer.totalSpend | currency}}</td></tr><tr><td>Average spend</td><td>{{vm.customer.avgSpendPerVisit | currency}}</td></tr></tbody></table></div><div class="col-lg-6"><table class="table table-striped"><thead><tr><th colspan="2">Reservation statistic</th></tr></thead><tbody><tr><td>Show</td><td>{{vm.customer.totalReservationShow}} ({{(vm.customer.totalReservation != 0) ? (100 * vm.customer.totalReservationShow/vm.customer.totalReservation).toFixed(2) : 0}}%)</td></tr><tr class="text-danger"><td>No Show</td><td>{{vm.customer.totalReservationNoShow}} ({{(vm.customer.totalReservation != 0) ? (100 * vm.customer.totalReservationNoShow/vm.customer.totalReservation).toFixed(2) : 0}}%)</td></tr><tr class="text-danger"><td>Cancel</td><td>{{vm.customer.totalReservationCanceled}} ({{(vm.customer.totalReservation != 0) ? (100 * vm.customer.totalReservationCanceled/vm.customer.totalReservation).toFixed(2) : 0}}%)</td></tr><tr><td><b>Total</b></td><td><b>{{vm.customer.totalReservation}}</b></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/tables/create/waitlist/waitlist.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-7"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3>Current waitlist statistics</h3></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><h4><span class="fa fa-group"></span>&nbsp;&nbsp;Total waitlist queue size: <span class="text-danger">{{vm.waitlistQueues.oneToTwoPerson + vm.waitlistQueues.threeToFourPerson + vm.waitlistQueues.fivePlusPerson}} customer(s) in queue</span></h4></div></div><div class="row"><div class="col-lg-12"><table class="table" border="0"><thead><tr><th></th><th bgcolor="#f0f8ff">1-2 seats</th><th bgcolor="#f0f8ff">3-4 seats</th><th bgcolor="#f0f8ff">5+ seats</th></tr></thead><tbody><tr class=""><th>Queue size</th><td class="font-bold">{{vm.waitlistQueues.oneToTwoPerson}}</td><td class="font-bold">{{vm.waitlistQueues.threeToFourPerson}}</td><td class="font-bold">{{vm.waitlistQueues.fivePlusPerson}}</td></tr><tr class=""><th>Wait time (approximation)</th><td class="font-bold text-danger">{{vm.waitlistQueues.approxWaitTimeOneToTwo}} min</td><td class="font-bold text-danger">{{vm.waitlistQueues.approxWaitTimeThreeToFour}} min</td><td class="font-bold text-danger">{{vm.waitlistQueues.approxWaitTimeFivePlus}} min</td></tr></tbody></table></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3>Please define waitlist entry</h3></div><div class="ibox-content"><div class="row"><div class="col-lg-1"><i class="fa fa-group fa-2x"></i></div><div class="col-lg-8"><div class="btn-group" data-toggle="buttons"><label ng-repeat="numberOfPersons in [1, 2, 3, 4, 5, 6]" uib-btn-radio="numberOfPersons" ng-model="vm.numberOfPersons" class="btn btn-primary btn-outline" title="Select the number of persons" style="margin: 2px"><input type="radio" name="numberPersons" value="{{numberOfPersons}}" checked="checked"> {{numberOfPersons}} Person<span ng-if="numberOfPersons > 1">s</span></label></div></div><div class="col-lg-3"><div class="form-group"><div class="input-group time"><span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-group"></i></button> </span><input ng-model="vm.numberOfPersons" placeholder="select number" type="number" class="form-control" datepicker-popup="{{format}}" ng-model="dt" min="1" ng-min="1" close-text="Close"></div></div></div></div><div class="row"><div class="col-lg-1"><i class="fa fa-hourglass-1 fa-2x"></i></div><div class="col-lg-8"><div class="btn-group" data-toggle="buttons"><label ng-repeat="minutes in [5, 10, 15, 20, 25]" ng-model="vm.quotedWaitTime" uib-btn-radio="minutes" class="btn btn-warning btn-outline" title="Select the expected wait time" style="margin: 2px"><input type="radio" name="quotedWaitTime" value="{{minutes}}" checked="checked"> {{minutes}} min</label></div></div><div class="col-lg-3"><div class="form-group"><div class="input-group time"><span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-hourglass-1"></i></button> </span><input ng-model="vm.quotedWaitTime" placeholder="select wait time" type="number" min="1" ng-min="1" class="form-control"></div></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><form class="form-horizontal"><div class="form-group"><label class="col-sm-2 control-label">Comment</label><div class="col-sm-9"><textarea ng-model="vm.note" rows="2" placeholder="Please enter additional comment" class="form-control" ng-maxlength="512"></textarea></div></div></form></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-12 text-center"><button class="btn btn-white" ng-click="vm.reset()" type="reset">Reset</button> &nbsp; <button class="btn btn-primary ng-isolate-scope" ng-disabled="vm.isAddingDisabled()" ng-click="vm.addToWaitlist()" type="button">Add to waitlist</button></div></div><div class="row" ng-if="vm.isAddingDisabled()"><div class="ibox-content"><div class="row" ng-if="!(vm.numberOfPersons > 0)"><div class="col-lg-2"></div><div class="col-lg-8"><div uib-alert class="alert-danger" close="closeAlert(0)">Please enter the number of persons.</div></div></div><div class="row" ng-if="!(vm.quotedWaitTime > 0)"><div class="col-lg-2"></div><div class="col-lg-8"><div uib-alert class="alert-danger" close="closeAlert(0)">Please enter the quoted time.</div></div></div><div class="row" ng-if="vm.customer.id && !vm.customer.waitlistAllowed"><div class="col-lg-2"></div><div class="col-lg-8"><div uib-alert class="alert-danger" close="closeAlert(0)">Adding this customer to waitlist is not allowed!</div></div></div><div class="row" ng-if="!vm.customer.firstName || (isEU && !vm.customer.primaryEmail) || !(vm.customer.primaryPhone && customerForm.primaryPhone.$valid)"><div class="col-lg-2"></div><div class="col-lg-8"><div uib-alert class="alert-danger" close="closeAlert(0)">Please fill in missing customer information!</div></div></div><div class="row" ng-if="customerForm.primaryEmail.$error.email"><div class="col-lg-2"></div><div class="col-lg-8"><div uib-alert class="alert-danger" close="closeAlert(0)">Invalid email address.</div></div></div></div></div></div></div></div></div></div><div class="col-lg-5"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3>Customer information</h3></div><div class="ibox-content"><div class="row"><form name="form" novalidate><div class="col-lg-8"><div class="input-group"><span class="input-group-addon"><i class="fa fa-search-plus"></i></span> <input name="keyword" ng-model="customerSearchKeyword" ng-required="true" ng-minlength="3" placeholder="Search by name, email or phone number" class="form-control" type="text"></div><p ng-if="form.keyword.$error.minlength" class="text-warning text-small">&nbsp;* at least 3 characters required</p><p ng-if="customerSearchKeyword || form.keyword.$error.required" style="color: white">_</p></div><div class="col-lg-4"><button ng-disabled="!customerSearchKeyword" id="searchButton" type="submit" class="btn btn-default btn-outline" customer-search-dialog customer-search-keyword="customerSearchKeyword" customer-selected-callback="customerSelected"><i class="fa fa-search"></i>&nbsp;Search</button> <button class="btn btn-default btn-outline" ng-click="vm.resetCustomer()"><i class="fa fa-remove" aria-hidden="true"></i>&nbsp;Reset</button></div></form></div><div class="hr-line-dashed" style="margin: 0 0 15px 0"></div><div class="row"><form name="customerForm" class="form-horizontal"><div class="col-lg-12"><div class="form-group" ng-class="{ \'has-error\': customerForm.firstName.$invalid}"><label class="col-sm-3 control-label">First name (*)</label><div class="col-sm-9"><input name="firstName" ng-model="vm.customer.firstName" class="form-control" placeholder="Please enter first name" ng-required="true" ng-maxlength="64" type="text"></div></div><div class="form-group"><label class="col-sm-3 control-label">Last name</label><div class="col-sm-9"><input name="lastName" ng-model="vm.customer.lastName" class="form-control" placeholder="Please enter last name" ng-maxlength="128" type="text"></div></div><div class="form-group" ng-class="{ \'has-error\': (isEU==true && !(vm.customer.primaryEmail && customerForm.primaryEmail.$valid)) || customerForm.primaryEmail.$error.email}"><label class="col-sm-3 control-label">Email<span ng-show="isEU">(*)</span></label><div class="col-lg-9"><div class="input-group m-b" style="margin: 0"><span class="input-group-addon">@</span> <input type="email" validate-email name="primaryEmail" ng-model="vm.customer.primaryEmail" class="form-control ng-pristine ng-untouched ng-valid" placeholder="Please enter email address"></div></div></div><div class="form-group" ng-class="{ \'has-error\': customerForm.primaryPhone.$invalid}"><label class="col-sm-3 control-label">Phone (*)</label><div class="col-lg-9"><div class="input-group m-b" style="margin: 0"><input id="primaryPhone" name="primaryPhone" ng-model="vm.customer.primaryPhone" ng-pattern="vm.phonePattern" size="35" class="form-control" model-view-value="true" ng-required="true" type="text" ng-intl-tel-input data-initial-country="{{vm.phoneRegion}}" data-default-country="{{vm.phoneRegion}}" ng-keyup="vm.reformatPhone()" placeholder="Please enter phone number"></div><div ng-if=" customerForm.primaryPhone.$viewValue.length >4 && !(\'\'+customerForm.primaryPhone.$viewValue).startsWith(vm.phonePrefix)" class="text-success"><div ng-if="vm.isInternationalSmsEnabled" class="text-success">International phone number entered.<span ng-show="isEU!=true"> Text message will be sent, however please check if this is your intention.</span></div><span ng-show="isEU!=true"><div ng-if="!vm.isInternationalSmsEnabled" class="text-danger">Sending international sms messages are not enabled. Please upgrade your subscription!</div></span></div></div></div><div class="form-group"><label class="col-sm-3 control-label">Note</label><div class="col-sm-9"><textarea ng-model="vm.customer.note" rows="1" placeholder="Customer note" class="form-control" ng-maxlength="512"></textarea></div></div><div ng-if="vm.customer.id" class="form-group col-sm-9 pull-right"><a ui-sref="customers.profile({customerId: vm.customer.id})" target="_blank" class="btn btn-success btn-outline pull-right"><i class="fa fa-info-circle" aria-hidden="true"></i> View full customer profile</a></div></div></form></div></div></div></div></div><div class="row" ng-if="vm.customer.id"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h3>Customer statistics</h3></div><div class="ibox-content"><div class="row" ng-show="!vm.showCustomerStatistic"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Make decision based on customer historical behavior.<br>Identify high valuable or frequent no-show customers.<br><br><button class="btn btn-danger btn-sm" ng-click="vm.openWindow()" target="_blank">{{::vm.showCustomerStatisticText}}</button><br><br><small><span class="text-success">Below you can see an example of the Customer visit statistics.</span></small></div></div></div><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/EventCreateCustomerStat.png" class="img-responsive"></div></div></div></div><div class="row" ng-show="vm.showCustomerStatistic"><div class="col-lg-6"><b>Total visits:</b>&nbsp;{{vm.customerTotal}}<br><b>Last visit:</b>&nbsp;{{vm.customer.lastVisitedDate | amDateFormat: \'DD MMM YYYY @ h:mm A\'}}<br><br><b ng-if="!vm.customer.reservationAllowed" class="text-danger">Reservation not allowed!</b><br><b ng-if="!vm.customer.waitlistAllowed" class="text-danger">Waitlist not allowed!</b></div><div class="col-lg-6"><div class="row"><div class="col-lg-12 center"><span class="text-warning"><h2>{{vm.customer.memberStatus}}</h2><span uib-rating style="font-size: 1.2em" ng-model="vm.customer.customerLevel" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="text-warning"></span><h3>{{vm.customer.totalPoints}} points</h3></span></div><div class="row"><div class="col-lg-12"></div></div></div></div></div><div class="row" ng-show="vm.showCustomerStatistic"><div class="col-lg-6"><table class="table"><thead><tr><th colspan="2">Spending statistic</th></tr></thead><tbody><tr><td>Total spend</td><td>{{vm.customer.totalSpend | currency}}</td></tr><tr><td>Average spend</td><td>{{vm.customer.avgSpendPerVisit | currency}}</td></tr></tbody></table></div><div class="col-lg-6"><table class="table table-striped"><thead><tr><th colspan="2">Waitlist statistic</th></tr></thead><tbody><tr><td>Show</td><td>{{vm.customer.totalWaitlistShow}} ({{(vm.customer.totalWaitlist != 0) ? (100 * vm.customer.totalWaitlistShow/vm.customer.totalWaitlist).toFixed(2) : 0}}%)</td></tr><tr class="text-danger"><td>No Show</td><td>{{vm.customer.totalWaitlistNoShow}} ({{(vm.customer.totalWaitlist != 0) ? (100 * vm.customer.totalWaitlistNoShow/vm.customer.totalWaitlist).toFixed(2) : 0}}%)</td></tr><tr class="text-danger"><td>Cancel</td><td>{{vm.customer.totalWaitlistCanceled}} ({{(vm.customer.totalWaitlist != 0) ? (100 * vm.customer.totalWaitlistCanceled/vm.customer.totalWaitlist).toFixed(2) : 0}}%)</td></tr><tr><td><b>Total</b></td><td><b>{{vm.customer.totalWaitlist}}</b></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/tables/event/details/event.details.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-3"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row text-center"><div class="col-lg-12"><div ng-class="vm.utils.getEventTypeBkg(vm.event.type)" class="widget text-white font-bold"><div class="row"><div class="col-lg-12"><h1>{{vm.utils.formatEventType(vm.event.type)}}</h1></div></div></div><h3 class="font-bold" ng-class="vm.event.state==\'OPEN\' ? \'text-navy\': \'text-danger\'">{{vm.capitalize(vm.event.state)}} | {{vm.utils.prettyStatusEventDetails(vm.event.state, vm.event.status)}}</h3><bt><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-10 col-lg-offset-1 label label-default"><h4><span>Channel: {{vm.formatChannel(vm.event.channel)}}</span></h4></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><br><h4 class="text-danger"><span>Customer choice: {{vm.event.seatingOptionLabel}}</span></h4></div></div></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-12 center"><button ng-if="!(vm.event.state == \'CLOSED\' || vm.event.status == \'WAITLISTED\' || vm.event.status == \'PRERESERVED\' || (vm.event.status == \'CONFIRMED\' && vm.event.type == \'RESERVATION\'))" type="button" class="btn btn-outline btn-primary col-xs-8 col-xs-offset-2" ui-sref="tables.eventUpdate({eventId: vm.event.id, event: vm.event})">Edit event</button> <span ng-if="vm.event.state == \'OPEN\' && vm.event.status == \'RESERVED\'"><br><button type="button" class="btn btn-outline btn-primary col-xs-8 col-xs-offset-2" ui-sref="tables.rearrange({eventId: vm.event.id})">Rearrange<stran stext="resource"></stran></button><br><br></span><span ng-if="vm.event.state == \'OPEN\' && (vm.event.status == \'PRERESERVED\' || (vm.event.status == \'CONFIRMED\' && vm.event.type == \'RESERVATION\'))"><br><button type="submit" class="btn btn-outline btn-primary col-xs-8 col-xs-offset-2" ng-click="vm.findTables(vm.event)">Assign<stran stext="resource"></stran></button><br></span><button ng-repeat="action in vm.getActions()" type="button" ng-class="vm.utils.buttonForAction(action)" class="btn btn-outline col-xs-8 col-xs-offset-2" ng-click="vm.changeStatus(action)">{{action}}</button> <button ng-if="vm.event.state == \'CLOSED\' && vm.event.status == \'SHOW\'" type="button" class="btn btn-outline btn-primary col-xs-8 col-xs-offset-2" ng-click="vm.sendThankYou()">Send Thank you email</button></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><br><strong>Created by</strong><br><p>{{vm.event.createdByName}}, {{vm.event.createdDate | amDateFormat: \'D MMM YYYY @ h:mm A\'}}</p></div></div><div class="row"><div class="col-lg-12"><strong>Last modifed by</strong><br><p>{{vm.event.lastModifiedByName}}, {{vm.event.lastModifiedDate | amDateFormat: \'D MMM YYYY @ h:mm A\'}}</p></div></div></div></div></div></div></div><div class="col-lg-9"><div class="row"><div class="col-lg-8"><div class="row"><div class="col-lg-5"><div class="ibox float-e-margins"><div class="ibox-title"><h5 class="text-success"><span class="fa fa-calendar-check-o"></span> Date and time</h5></div><div class="ibox-content"><h3 ng-if="vm.event.expectedStartTime" class="no-margins">{{vm.event.expectedStartTime | amDateFormat: \'D MMM YYYY @ h:mm A\'}}</h3><h3 ng-if="!vm.event.expectedStartTime" class="no-margins">{{vm.event.createdDate | amDateFormat: \'D MMM YYYY @ h:mm A\'}}</h3></div></div></div><div class="col-lg-3"><div class="ibox float-e-margins"><div class="ibox-title"><h5 class="text-success"><span class="fa fa-group"></span> Person(s)</h5></div><div class="ibox-content"><h3 class="no-margins">{{vm.event.numberOfPersons}}</h3></div></div></div><div class="col-lg-4"><div class="ibox float-e-margins"><div class="ibox-title"><h5 class="text-success"><span class="fa fa-book"></span> Assigned resources</h5></div><div class="ibox-content"><span ng-if="vm.event.resources && (vm.event.resources.length > 0)" class="badge badge-success no-margins" ng-repeat="table in vm.event.resources | orderBy: \'id\'">{{table.name}} </span><i ng-if="!vm.event.resources || (vm.event.resources.length <= 0)" class="text-danger">Not assigned.</i></div></div></div></div><div class="row"><div class="col-lg-6"><div class="ibox float-e-margins"><div class="ibox-title"><h5 class="text-success"><span class="fa fa-info-circle"></span> Description</h5></div><div class="ibox-content"><span ng-if="!vm.event.description" class="no-margins text-danger"><i>No description.</i></span> <span ng-if="vm.event.description" class="no-margins font-bold">{{vm.event.description}}</span></div></div></div><div class="col-lg-6"><div class="ibox float-e-margins"><div class="ibox-title"><h5 class="text-success"><span class="fa fa-comment-o"></span> Note</h5><div style="float: right"><a ng-if="!vm.editNoteMode" ng-click="vm.enableEditNote();"><h5 class="text-success"><span class="fa fa-pencil"></span> Edit</h5></a><a ng-if="vm.editNoteMode" ng-click="vm.saveNote();"><h5 class="text-success"><span class="fa fa-save"></span> Save</h5></a><a ng-if="vm.editNoteMode" ng-click="vm.cancelEditNote();"><h5 class="text-danger" style="margin-left: 10px"><span class="fa fa-undo"></span> Cancel</h5></a></div></div><div class="ibox-content"><h5 ng-if="!vm.event.note && !vm.editNoteMode" class="no-margins"><i>Note not added.</i></h5><h5 ng-if="vm.event.note && !vm.editNoteMode" class="no-margins">{{vm.event.note}}</h5><textarea ng-if="vm.editNoteMode" rows="2" ng-model="vm.newNote" placeholder="Enter note" class="form-control" ng-maxlength="512"></textarea></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-6"><div class="row"><div class="col-lg-12"><table class="table"><thead><tr><th class="text-navy">Other information <span class="pull-right fa fa-calendar"></span></th></tr></thead></table></div></div><div ng-if="vm.event.type === \'WALK_IN_WAITLISTED\'" class="row"><div class="col-lg-6 text-right">Quoted time:</div><div class="col-lg-6 font-bold">{{vm.utils.formatMinutes(vm.event.quotedWaitTime)}}</div></div><div class="row"><div class="col-lg-6 text-right">Expected Duration:</div><div class="col-lg-6 font-bold">{{vm.utils.formatMinutes(vm.event.expectedDuration)}}</div></div><div class="row"><div class="col-lg-6 text-right">Actual Duration:</div><div class="col-lg-6 font-bold">{{vm.utils.formatMinutes(vm.calculateActualDuration())}}</div></div></div><div class="col-lg-6"><div class="row"><div class="col-lg-12"><table class="table"><thead><tr><th class="text-navy">Order payment information <span class="pull-right fa fa-money"></span></th></tr></thead></table></div></div><span ng-if="vm.event.state==\'CLOSED\' && !(vm.event.status==\'CANCELLED\' || vm.event.status==\'NO_SHOW\')"><div class="row"><div class="col-lg-5 text-right">Revenue:</div><div class="col-lg-7 font-bold">{{vm.event.amount | currency}}</div></div><div class="row"><div class="col-lg-5 text-right">Tip:</div><div class="col-lg-7 font-bold">{{vm.event.tip | currency}} <span ng-if="vm.event.amount > 0">({{(vm.event.tip*100/vm.event.amount).toFixed(1)}} %)</span></div></div></span><div class="row" ng-if="!vm.event.amount || (vm.event.state!==\'CLOSED\' && (vm.event.status==\'CANCELLED\' || vm.event.status==\'NO_SHOW\'))"><div class="col-lg-12 text-danger"><small>Note: Order payment information will be visible when event is closed in SeatOn properly. Follow this <a href="https://support.seaton.site/442644-How-to-release-tables-and-manage-customer-payments" target="_blank">link</a> for more info.</small></div></div></div></div></div></div></div></div><div ng-if="vm.event.type==\'RESERVATION\'" class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><div class="panel-options"><ul class="nav nav-tabs"><li class="active"><h3 class="text-navy"><i class="fa fa-money"></i> Reservation fee <span ng-show="vm.event.productModifierList">and modifiers</span></h3></li></ul></div></div><div class="ibox-content"><div class="row" ng-if="!vm.paymentEnabled()"><div class="col-md-12"><span class="text-danger">Fee not charged for this event.</span><br><small>If you want to charge fee in Seetings/Online reservation set up fee in section Online reservation fee.</small></div></div><div class="row" ng-if="vm.paymentEnabled()"><div class="col-md-5"><div class="row"><div class="col-lg-5 text-right"><h4>Status:</h4></div><div class="col-lg-7 font-bold"><h4>{{vm.event.paymentStatus}}</h4></div></div><div class="row"><div class="col-lg-12"><span ng-if="vm.event.paymentStatus==\'RESERVED\'" class="text-danger">Please note: Capture of reserved funds is possible until {{vm.captureUntil(vm.event.createdDate)}}.</span></div></div></div><div class="col-md-7" ng-if="vm.event.amount!=\'NO_PAYMENT\'"><div class="row"><div class="col-lg-5 font-bold text-navy text-right">Total fee amount:</div><div class="col-lg-7 font-bold">{{vm.event.paymentFeeAmount | currency}}</div></div><div class="row"><div class="col-lg-5 text-right font-bold">Approved amount:</div><div class="col-lg-7 font-bold">{{vm.event.paymentApprovedAmount | currency}} &nbsp;&nbsp;&nbsp; <button ng-if="vm.event.paymentStatus==\'PAID\'" class="btn btn-danger btn-xs" ng-click="vm.refundApprovedAmount()" target="_blank">Click to refund</button> <button ng-if="vm.event.paymentStatus==\'RESERVED\'" class="btn btn-success btn-xs" ng-click="vm.captureApprovedAmount()" target="_blank">Click to capture funds</button></div></div></div></div><hr ng-if="vm.showPaymentDetails()" class="hr-solid"><div class="row" ng-if="vm.showPaymentDetails()"><div class="col-md-6"><div class="row"><div class="col-lg-12"><h4>Payment details</h4></div></div><div class="row"><div class="col-lg-6 text-right">Reservation fee:</div><div class="col-lg-6 font-bold">{{vm.event.paymentReservationFee | currency}}</div></div><div class="row"><div class="col-lg-6 text-right">Modifier fee:</div><div class="col-lg-6 font-bold">{{vm.event.paymentProductModifierFee | currency}}</div></div><div class="row"><div class="col-lg-6 text-right">Service Charge/Tip:</div><div class="col-lg-6 font-bold">{{vm.event.paymentTipAmount | currency}} ({{vm.event.paymentTipPercentage/100 | percentage}})</div></div><div class="row"><br><div class="col-lg-6 text-right text-navy font-bold">Total fee amount:</div><div class="col-lg-6 font-bold">{{vm.event.paymentFeeAmount | currency}}</div></div></div><div class="col-md-6" ng-if="vm.hasModifiers()"><div class="row"><div class="col-lg-12"><h4>Modifier fee details</h4></div></div><div class="row"><div class="col-lg-12"><table class="table"><thead><tr><th><i class="fa fa-clock-o"></i> Modifier</th><th><i class="fa fa-info-circle"></i> Quantity</th><th><i class="fa fa-money"></i> Unit price</th><th><i class="fa fa-money"></i> Total</th></tr></thead><tbody><tr ng-repeat="modifier in vm.event.productModifierList | orderBy:\'id\'"><td class="font-bold">{{modifier.name}}</td><td>{{modifier.number}}</td><td class="">{{modifier.fee | currency}}</td><td class="font-bold">{{modifier.amount | currency}}</td></tr></tbody></table></div></div></div></div><hr ng-if="vm.paymentEnabled()" class="hr-solid"><div ng-if="vm.paymentEnabled()" class="row"><div class="col-lg-12"><table class="table table-striped"><thead><tr><th><i class="fa fa-clock-o"></i> When</th><th><i class="fa fa-info-circle"></i> Status</th><th><i class="fa fa-money"></i> Amount</th><th><i class="fa fa-check-circle-o"></i> Description</th><th><i class="fa fa-info-circle"></i> Changed by</th></tr></thead><tbody><tr ng-repeat="entry in vm.event.eventPaymentHistories | orderBy:\'-createdDate\'"><td class="font-bold">{{entry.createdDate | amDateFormat: \'DD MMM YYYY @ h:mm A\'}}</td><td>{{entry.paymentStatus}}</td><td class="font-bold">{{entry.amount | currency}}</td><td class="">{{entry.description}}</td><td class="">{{entry.createdByName}}</td></tr></tbody></table></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><div class="panel-options"><ul class="nav nav-tabs"><li class="active"><h3 class="text-navy"><i class="fa fa-history"></i> Change history</h3></li></ul></div></div><div class="ibox-content"><div class="row" ng-show="!vm.showChangeHistory"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><div class="widget gray-bg text-center">Find out the history of changes on each event, including information which employee made the change.<br><br><button class="btn btn-danger btn-sm" ng-click="vm.openWindow()" target="_blank">{{::vm.showChangeHistoryText}}</button><br><br><small><span class="text-success">Below is an example of the event change history.</span></small></div></div></div><div class="row"><div class="col-lg-12"><br><img src="/content/images/profile/TablesEventChangeHistory.png" class="img-responsive"></div></div></div></div><div class="row" ng-show="vm.showChangeHistory"><div class="col-lg-12"><table class="table table-striped"><thead><tr><th><i class="fa fa-clock-o"></i> When</th><th><i class="fa fa-check-circle-o"></i> Description</th><th><i class="fa fa-info-circle"></i> Changed by</th></tr></thead><tbody><tr ng-repeat="entry in vm.event.eventChangeHistories | orderBy:\'-createdDate\'"><td class="font-bold">{{entry.createdDate | amDateFormat: \'DD MMM YYYY @ h:mm A\'}}</td><td>{{entry.description}}</td><td class="font-bold">{{entry.createdByName}}</td></tr></tbody></table></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><div class="panel-options"><ul class="nav nav-tabs"><li class="active"><h3 class="text-navy"><i class="fa fa-history"></i> Notifications sent or received from customer</h3></li></ul></div></div><div class="ibox-content"><div class="tab-content"><div class="tab-pane active" id="tab-activity"><table class="table table-striped"><thead><tr><th><i class="fa fa-clock-o"></i> When</th><th><i class="fa fa-check-circle-o"></i> Channel</th><th><i class="fa fa-info-circle"></i> Direction</th><th><i class="fa fa-check-circle-o"></i> Text</th><th ng-show="vm.event.type==\'WALK_IN_WAITLISTED\'"><i class="fa fa-check-circle-o"></i> SmsStatus</th></tr></thead><tbody><tr ng-repeat="entry in vm.event.eventNotificationHistories | orderBy:\'-sent\'"><td class="font-bold">{{entry.sent | amDateFormat: \'DD MMM YYYY @ h:mm A\'}}</td><td>{{entry.channel}}</td><td class="font-bold">{{entry.direction==\'SENT\' ? \'To customer\' : \'From customer\'}}</td><td>{{entry.text}}</td><td ng-show="entry.channel==\'SMS\'">{{entry.smsStatus}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class="col-lg-4"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><span class="label label-info pull-right">Customer</span><h3 class="text-navy pull-left"><i class="fa fa-user"></i>&nbsp;Customer</h3><br><br></div><div ng-if="!vm.event.customer" class="ibox-content"><h2>Unknown customer</h2></div><div ng-if="vm.event.customer" class="ibox-content"><div class="row"><div class="col-lg-12"><p></p><h1><a ui-sref="customers.profile({customerId: vm.event.customer.id})">{{vm.event.customer.firstName}} {{vm.event.customer.lastName}}</a></h1><p></p><p></p><h3><span class="text-warning"><i ng-repeat="i in [1, 2, 3, 4, 5] | limitTo:vm.event.customer.customerLevel" class="fa fa-star"></i><i ng-repeat="i in [1, 2, 3, 4, 5] | limitTo:(5 - vm.event.customer.customerLevel)" class="fa fa-star-o"></i> ({{vm.event.customer.totalPoints}} points)</span></h3><p></p><p></p><h4>Email:&nbsp;<a href="mailto:{{vm.event.customer.primaryEmail}}">{{vm.event.customer.primaryEmail}}</a></h4><p></p><p></p><h4>Phone:&nbsp;<a href="tel:{{vm.event.customer.primaryPhone}}">{{vm.event.customer.primaryPhone}}</a></h4><p></p><p></p><h4>Note:&nbsp; {{vm.event.customer.note}}</h4><p></p><br><dl class="dl-horizontal"><dt>Favorite<stran stext="resource" tyep="s"></stran>:</dt><dd><span ng-if="vm.event.customer.favoriteTable" class="badge badge-success">{{vm.event.customer.favoriteTable.name}}</span></dd><dt>Allergies:</dt><dd><span ng-repeat="allergy in vm.event.customer.allergies" class="badge badge-danger">{{vm.capitalize(allergy.allergyType)}}&nbsp;</span></dd></dl><p></p><h4 class="text-danger" ng-show="vm.specialDate"><span class="fa fa-exclamation-triangle"></span> Special date today ({{vm.specialDate}})</h4><p></p><div class="btn-group m-t col-lg-12"><a ui-sref="customers.profile({customerId: vm.event.customer.id})" class="btn btn-default btn-block btn-outline m-t"><i class="fa fa-info-circle" aria-hidden="true"></i> View customer profile</a></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="panel white-panel"><div class="panel-heading"><h3 class="text-navy pull-left"><i class="fa fa-comments-o"></i>&nbsp;Customer feedback</h3><br></div><div class="panel-body"><div class="row"><div class="col-lg-12"><ul class="list-group"><li ng-repeat="feedback in vm.event.feedbacks" class="list-group-item"><p class=""><small>Event for {{vm.event.numberOfPersons}} persons at {{vm.event.expectedStartTime | amDateFormat: \'DD MMM YYYY @ h:mm A\'}}</small> <span ng-if="vm.isNewFeedback(feedback.createdTime)" class="badge badge-danger pull-right">NEW</span></p><p class="">{{feedback.feedback}}</p><small class="block text-muted"><i class="fa fa-clock-o"></i> {{ feedback.createdTime | amTimeAgo }} <span uib-rating style="font-size: 1.2em" ng-model="feedback.rating" read-only="true" state-on="\'fa fa-star\'" state-off="\'fa fa-star-o\'" class="text-warning pull-right"></span></small></li><li ng-if="vm.event.feedbacks.length == 0" class="list-group-item"><p class="">No feedback was provided.</p></li></ul></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/tables/event/update/event.update.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-4"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><div class="row"><div class="col-lg-1"><i class="fa fa-calendar fa-2x"></i></div><div class="col-lg-11"><h3>Reschedule (new date & time)</h3></div></div></div><div class="ibox-content"><div class="row"><div class="col-lg-5"><p class="font-bold">Current date:</p></div><div class="col-lg-6"><p>{{vm.oldExpectedStartTime | amDateFormat: \'D MMM YYYY\'}}</p></div></div><div class="row"><div class="col-lg-5"><p class="font-bold">Current time:</p></div><div class="col-lg-6"><p>{{vm.oldExpectedStartTime | amDateFormat: \'hh:mmA\'}}</p></div></div><div class="row"><div class="col-lg-5"><p class="font-bold">Current{{vm.selectProductText()}}:</p></div><div class="col-lg-6"><p>{{vm.getProductInfo()}}</p></div></div><div class="row"><div class="col-lg-5"><p class="font-bold">Current number of persons:</p></div><div class="col-lg-6"><p>{{vm.oldNumberOfPersons}}</p></div></div><div class="row"><div class="hr-line-dashed"></div><div class="col-lg-5"><p class="font-bold">New date:</p></div><div class="col-lg-6"><div class="form-group"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-disabled="!vm.isExpectedArrival" ng-click="vm.openDatePicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="select date" ng-change="vm.findTables()" ng-disabled="!vm.isExpectedArrival" name="datePicker" type="text" class="form-control" ng-model="vm.selectedDayFormatted" close-text="Close"></div></div></div></div><div class="row"><div class="col-lg-5"><p class="font-bold">New time:</p></div><div class="col-lg-6"><div class="form-group"><div class="input-group clockpicker" data-autoclose="true" ng-disabled="!vm.isExpectedArrival"><span class="input-group-addon" ng-disabled="!vm.isExpectedArrival" style="padding: 0px; margin-bottom: 0px; border-radius: 3px 0 0 3px"><span class="btn btn-default" ng-disabled="!vm.isExpectedArrival" style="border: 0px; margin-bottom: 0px"><i class="fa fa-clock-o"></i></span> </span><input placeholder="select time" ng-change="vm.findTables()" ng-model="vm.selectedTime" ng-disabled="!vm.isExpectedArrival" type="text" class="form-control"></div></div></div></div><div class="row"><div class="col-lg-5"><p class="font-bold">New party size:</p></div><div class="col-lg-6"><div class="form-group"><div class="input-group time"><span class="input-group-btn"><button type="button" ng-disabled="!vm.isExpectedArrival" class="btn btn-default"><i class="fa fa-group"></i></button> </span><input ng-model="vm.numberOfPersons" ng-change="vm.findTables()" ng-disabled="!vm.isExpectedArrival" placeholder="enter number of persons" type="number" min="1" ng-min="1" class="form-control"></div></div></div></div><div class="row"><div class="col-lg-5"><p class="font-bold">Change{{vm.selectProductText()}}:</p></div><div class="col-lg-6"><div class="form-group"><div class="input-group time"><span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-hourglass-1"></i></button></span><select ng-model="vm.productId" class="form-control" ng-options="product.id as product.nameWithDuration for product in vm.productList" ng-change="vm.changeDuration(vm.productId)" placeholder="Select from list" name="duration_element" ng-disabled="!vm.isExpectedArrival"><option value="">Select from list</option></select></div></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><div class="row"><div class="col-lg-1"><i class="fa fa-comment fa-2x"></i></div><div class="col-lg-11"><h3>Comment</h3></div></div></div><div class="ibox-content"><div class="row"><form class="form-horizontal"><div class="form-group"><div class="col-sm-11 col-sm-offset-1"><textarea ng-model="vm.note" rows="2" placeholder="Please enter additional comment" class="form-control" ng-maxlength="512"></textarea></div></div></form></div></div></div></div></div></div><div class="col-lg-4"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><div class="row"><div class="col-lg-1"><i class="fa fa-cutlery fa-2x"></i></div><div class="col-lg-11"><h3>Reassign<stran stext="resource"></stran></h3></div></div></div><div class="ibox-content"><div class="row"><div class="col-lg-6"><p class="font-bold">Currently selected<stran stext="resource"></stran>:</p></div><div class="col-lg-6"><span class="badge badge-success" ng-repeat="table in vm.oldResources | orderBy: \'id\'">{{table.name}}</span></div></div><div class="row" ng-show="vm.tables.length > 0"><div class="hr-line-dashed"></div><div class="col-lg-12"><p class="font-bold">Please select new<stran stext="resource"></stran>:</p></div><br><br></div><div class="row" ng-show="vm.tables.length > 0"><div class="col-lg-12"><div class="btn-group col-lg-12"><label ng-repeat="table in vm.tables" ng-model="table.selected" uib-btn-checkbox class="btn btn-default btn-outline" style="margin: 2px"><span class="font-bold text-success">{{table.name}}</span><br><span><i class="fa fa-male"></i>&nbsp;x {{table.capacity}}</span></label></div></div></div><div ng-if="vm.selectedDay && vm.isTimeSet() && vm.numberOfPersons && (vm.duration > 0) && vm.tables.length == 0 && vm.alternativeTimes.length == 0" class="row"><div class="col-lg-12"><h4 class="text-danger font-bold">No available tables found for the defined criteria.</h4></div></div><div class="row" ng-show="vm.tables.length === 0 && vm.alternativeTimes.length > 0"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><p class="font-bold">No available tables. Please select alternative time slot:</p></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><div class="btn-group col-lg-12" data-toggle="buttons"><label ng-repeat="altTime in vm.alternativeTimes" uib-btn-radio="altTime.time" ng-model="vm.selectedAltTime" ng-change="vm.altTimeSelected()" class="col-lg-4 btn btn-info btn-outline" style="margin: 0 2px"><input type="radio" name="time" value="{{altTime}}"> {{altTime.time}} ({{altTime.capacity}})</label></div></div></div></div></div></div></div></div></div></div></div></div><div class="col-lg-4"><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><div class="row"><div class="col-lg-1"><i class="fa fa-user fa-2x"></i></div><div class="col-lg-11"><h3>Change customer</h3></div></div></div><div class="ibox-content"><div class="row"><form name="form" novalidate><div class="col-lg-8"><div class="input-group"><span class="input-group-addon"><i class="fa fa-search-plus"></i></span> <input name="keyword" ng-model="customerSearchKeyword" ng-required="true" ng-minlength="3" placeholder="Search by name, email or phone number" class="form-control" type="text"></div><p ng-if="form.keyword.$error.minlength" class="text-warning text-small">&nbsp;* at least 3 characters required</p><p ng-if="customerSearchKeyword || form.keyword.$error.required" style="color: white">_</p></div><div class="col-lg-4"><button ng-disabled="!customerSearchKeyword" id="searchButton" type="submit" class="btn btn-default btn-outline" customer-search-dialog customer-search-keyword="customerSearchKeyword" customer-selected-callback="customerSelected"><i class="fa fa-search"></i>&nbsp;</button> <button class="btn btn-default btn-outline" ng-click="vm.resetCustomer()"><i class="fa fa-remove" aria-hidden="true"></i>&nbsp;</button></div></form></div><div class="hr-line-dashed" style="margin: 0 0 15px 0"></div><div class="row"><form name="customerForm" class="form-horizontal"><div class="col-lg-12"><div class="form-group" ng-class="{ \'has-error\': customerForm.firstName.$invalid}"><label class="col-sm-3 control-label">First name (*)</label><div class="col-sm-9"><input name="firstName" ng-model="vm.customer.firstName" class="form-control" placeholder="Please enter first name" ng-required="true" ng-maxlength="64" type="text"></div></div><div class="form-group"><label class="col-sm-3 control-label">Last name</label><div class="col-sm-9"><input name="lastName" ng-model="vm.customer.lastName" class="form-control" placeholder="Please enter last name" ng-maxlength="128" type="text"></div></div><div class="form-group" ng-class="{ \'has-error\': (customerForm.primaryEmail.$invalid && customerForm.primaryPhone.$invalid) || customerForm.primaryEmail.$error.email}"><label class="col-sm-3 control-label">Email (*)</label><div class="col-sm-9"><div class="input-group m-b" style="margin: 0"><span class="input-group-addon">@</span> <input type="email" validate-email name="primaryEmail" ng-model="vm.customer.primaryEmail" class="form-control ng-pristine ng-untouched ng-valid" ng-required="true" placeholder="Please enter email address"></div></div></div><div class="form-group" ng-class="{ \'has-error\': customerForm.primaryEmail.$invalid && customerForm.primaryPhone.$invalid}"><label class="col-sm-3 control-label">Phone (*)</label><div class="col-sm-9"><div class="input-group m-b" style="margin: 0"><span class="input-group-addon"><i class="fa fa-phone"></i></span><input id="primaryPhone" name="primaryPhone" ng-model="vm.customer.primaryPhone" size="35" class="form-control" model-view-value="true" ng-required="true" type="text" ng-intl-tel-input data-initial-country="{{vm.phoneRegion}}" data-default-country="{{vm.phoneRegion}}" ng-keyup="vm.reformatPhone()" placeholder="Please enter phone number"></div><div ng-if="customerForm.primaryEmail.$invalid && customerForm.primaryPhone.$invalid" class="text-danger">* either email or phone is required</div></div></div><div class="form-group"><label class="col-sm-3 control-label">Favorite</label><div class="col-sm-9"><span ng-if="vm.customer.favoriteTable" class="badge badge-success">{{vm.customer.favoriteTable.name}}</span> <span ng-if="!vm.customer.favoriteTable">--</span></div></div><div class="form-group"><label class="col-sm-3 control-label">Note</label><div class="col-sm-9"><textarea ng-model="vm.customer.note" rows="1" placeholder="Customer note" class="form-control" ng-maxlength="512"></textarea></div></div><div ng-if="vm.customer.id" class="form-group col-sm-9 pull-right"><a ui-sref="customers.profile({customerId: vm.customer.id})" target="_blank" class="btn btn-success btn-outline pull-right"><i class="fa fa-info-circle" aria-hidden="true"></i> View full customer profile</a></div></div></form></div></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-content"><div class="row"><div class="col-lg-12 text-center"><button ng-disabled="vm.isUpdateDisabled()" class="btn btn-primary ng-isolate-scope" ng-click="vm.startUpdate()" type="button">Update event</button></div></div><div class="row" ng-if="vm.isUpdateDisabled() || vm.isUpdateWithWarning()"><div class="ibox-content"><div class="row" ng-if="vm.getSelectedResources().length === 0"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-danger" close="closeAlert(0)">Please select a table!</div></div></div><div class="row" ng-if="!vm.numberOfPersons || vm.numberOfPersons < 1"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-danger" close="closeAlert(0)">Please enter a valid party size.</div></div></div><div class="row" ng-if="!vm.isTimeSet()"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-danger" close="closeAlert(0)">Please enter the start time.</div></div></div><div class="row" ng-if="!vm.duration"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-danger" close="closeAlert(0)">Please enter the duration.</div></div></div><div class="row" ng-if="vm.getSelectedResources().length > 0 && vm.getSelectedResourcesCapacity() < vm.numberOfPersons"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-warning" close="closeAlert(0)">Selected table capacity ({{vm.getSelectedResourcesCapacity()}}) is not enough to seat {{vm.numberOfPersons}} person(s).</div></div></div><div class="row" ng-if="customerForm.primaryEmail.$error.email"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-danger" close="closeAlert(0)">Invalid email address.</div></div></div><div class="row" ng-if="vm.event.type != \'WALK_IN_SEATED\' && (!vm.customer.firstName || !(vm.customer.primaryEmail || vm.customer.primaryPhone))"><div class="col-lg-3"></div><div class="col-lg-6"><div uib-alert class="alert-danger" close="closeAlert(0)">Please fill in missing customer information.</div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/tables/event/update/notification.message.dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeNotificationDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title" id="myModalLabel">Please enter the notification message for the customer</h3><small>If you\'re OK with the default one, just click Update &amp; Send button.</small></div><div class="modal-body"><div class="row" ng-if="vm.event.customer.primaryEmail">Notification email will be sent to customer <span class="text-navy">{{vm.event.customer.firstName + \' \' + vm.event.customer.lastName}}</span> on <span class="text-navy">{{vm.event.customer.primaryEmail}}.</span><br><br><textarea class="form-control" rows="10" placeholder="Write a custom notification message to customer..." ng-model="vm.notificationMessageText" maxlength="2048" ng-maxlength="2048"></textarea></div><div class="row" ng-if="!vm.event.customer.primaryEmail"><span class="text-danger">Notification cannot be sent since customer <span class="text-navy">{{vm.event.customer.firstName + \' \' + vm.event.customer.lastName}}</span> does not have an email address defined in SeatOn.<br>Please notify the customer using other channels.</span></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeNotificationDialog()">Cancel</button> <button ng-if="vm.event.customer.primaryEmail" ng-disabled="!vm.notificationMessageText" type="button" class="btn btn-primary" ng-click="vm.doUpdate()">Update &amp; Send</button></div>');
$templateCache.put('app/account/old/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/old/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/public/online/reservation/legacy/create.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1 col-xs-10 col-xs-offset-1"><div class="row"><div class="col-md-7"><div class="row"><div class="col-md-10"><h1 class="font-bold">{{vm.settings.locationName}}</h1><strong>{{vm.settings.locationCity}}</strong><hr><span class="text-danger"><i class="fa fa-phone"></i>&nbsp; <a class="text-danger" href="tel:{{vm.settings.contactPhone}}">{{vm.settings.contactPhone}}</a> </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="text-danger"><i class="fa fa-envelope-o"></i>&nbsp; <a class="text-danger" href="mailto:{{vm.settings.contactEmail}}">{{vm.settings.contactEmail}}</a></span><hr></div></div><div ng-if="vm.status==99" class="row"><div class="col-md-10 col-md-offset-1 text-center text-danger"><br><h2>Reservation service disabled by the restaurant.</h2><h3>Please contact us in case of any questions.</h3></div></div><div ng-if="vm.status!=99" class="row"><div class="col-md-11" style="background-color: #fff0f0" ng-if="vm.settings.importantNotice"><br><strong>NOTE TO CUSTOMER</strong><br><br><span ng-bind-html="vm.settings.importantNotice"></span><br><br></div></div><div ng-if="vm.status!=99" class="row"><div class="col-md-12"><br><br></div></div><div class="row" ng-if="vm.status!=99"><div class="col-md-10 col-md-offset-1"><div class="row"><div class="col-md-12 text-center"><br><h3 class="font-bold">Select date and time of your visit and specify party size.</h3></div></div><br><div class="row" ng-if="vm.resourceNotAvailableAnymore==true" `><div class="col-md-12 text-center"><div uib-alert class="alert-danger" style="font-size: 120%">We are sorry, chosen time slot {{ vm.moment(vm.selectedDay, vm.DATE_FORMAT).format(\'dddd, MMMM D, YYYY\');}} at {{ vm.moment(vm.selectedTime, vm.TIME_SERVER_FORMAT).format(vm.TIME_DISPLAY_FORMAT) }} for {{vm.numberOfPersons}} person(s) is not available anymore. Please choose alternative time for your visit.</div><br></div></div><div class="row" ng-if="vm.status==5 || vm.status==6" `><div class="col-md-12 text-center"><div uib-alert class="alert-danger" style="font-size: 120%">We are CLOSED for {{ vm.moment(vm.selectedDay, vm.DATE_FORMAT).format(\'dddd, MMMM D, YYYY\');}}, please selected another date.</div><br></div></div><div class="row" ng-if="vm.status==10" `><div class="col-md-12 text-center"><div uib-alert class="alert-danger" style="font-size: 120%"><strong>Important note:</strong><br>Dear Guest, first possible time slot for your reservation is from {{vm.addText}}.<br>Thank you for understanding.</div><br></div></div><div class="row" ng-if="vm.status==1" `><div class="col-md-12 text-center"><div uib-alert class="alert-danger" style="font-size: 120%">No available time slots for selected date, please choose another date.</div><br></div></div><div class="row"><div class="col-md-12 text-center"><div class="row" ng-if="vm.inputErrorOccurs() && !vm.selectedDayFormatted"><div class="col-md-10 col-md-offset-1"><div uib-alert class="alert-danger">Please select visit date.</div></div></div><div class="row" ng-if="vm.isDateBeforeToday"><div class="col-md-10 col-md-offset-1 text-center"><div uib-alert class="alert-danger">Selected date is before today. Please select valid date!</div></div></div><div class="row" ng-if="vm.isAfterMaxReservationDate"><div class="col-md-10 col-md-offset-1 text-center"><div uib-alert class="alert-danger">Maximum allowed reservation date is {{vm.settings.maxReservationDate}}. Please select an earlier date.</div></div></div><div class="row" ng-if="vm.inputErrorOccurs() && !vm.selectedTime"><div class="col-md-10 col-md-offset-1 text-center"><div uib-alert class="alert-danger">Please select visit time!</div></div></div><div class="row" ng-if="vm.inputErrorOccurs() && !(vm.numberOfPersons > 0)"><div class="col-md-10 col-md-offset-1 text-center"><div uib-alert class="alert-danger">Please define party size!</div></div></div><div class="row" ng-if="vm.hoursListData.length <= 0"><div class="col-md-10 col-md-offset-1 text-center"><div uib-alert class="alert-danger">No time slot available for selected date! Select alternative date <span ng-if="vm.settings.productChosenByGuest">or define different visit duration</span>.</div></div></div><div class="row" ng-if="vm.settings.productChosenByGuest && vm.inputErrorOccurs() && !vm.productId"><div class="col-md-10 col-md-offset-1 text-center"><div uib-alert class="alert-danger">Please choose {{vm.settings.productType==\'PRODUCT\'?\'the product you want to book\':\'duration of your visit\'}} from the list!</div></div></div><br></div></div><div class="row"><form name="findTableForm" class="form-horizontal"><div class="col-md-12"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="form-group" ng-class="{ \'has-error\': findTableForm.reservationDate.$invalid}"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openDatePicker()"><i class="fa fa-calendar text-danger"></i></button> </span><input placeholder="Select date" name="datePicker" type="text" class="form-control" ng-model="vm.selectedDayFormatted" close-text="Close"></div></div><div class="form-group" ng-class="{ \'has-error\': findTableForm.selectedTime.$invalid}"><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o text-danger"></i></span><select ng-model="vm.selectedTimeId" name="selectedTime" placeholder="Select time" class="form-control" ng-options="timeItem.id as timeItem.label for timeItem in vm.times | filter: vm.filterByParams" tabindex="1" ng-change="vm.onTimeChange()"><option value="">{{(vm.status==5 || vm.status==6)?\'No available time slots for selected date.\':\'Select time.\'}}</option></select></div></div><div class="form-group" ng-class="{ \'has-error\': findTableForm.numberOfPersons.$invalid}"><div class="input-group"><span class="input-group-addon"><i class="fa fa-group text-danger"></i></span><select ng-model="vm.numberOfPersons" name="numberOfPersons" placeholder="Party size" class="form-control" ng-options="item.id as item.label for item in vm.persons" tabindex="4"></select></div></div><div ng-if="vm.settings.productChosenByGuest" class="form-group" ng-class="{ \'has-error\': findTableForm.durationTime.$invalid}"><div class="input-group"><span class="input-group-addon"><i class="fa fa-hourglass-1 text-danger"></i></span><select ng-model="vm.selectedProductId" ng-disabled="vm.productList.length==0" name="productId" placeholder="Select your choice" class="form-control" ng-options="item.id as item.name for item in vm.productList" tabindex="5"><option value="">Select {{vm.settings.productType==\'DURATION\'?\'duration of your visit\':\'what you want to book\'}}</option></select></div><br></div></div></div><div class="row"><div class="col-md-10 col-md-offset-1 text-center"><br><br><button class="btn btn ng-isolate-scope public-button-logo" ng-click="vm.findTable()" type="button" tabindex="7"><i ng-class="vm.actionSubmitted ? \'fa fa-refresh fa-pulse\' : \'\'"></i> Submit</button> &nbsp;</div></div><br><br><span ng-show="!vm.settings.showAlternative && vm.findTableData.tableFound==false"><div class="row"><div class="col-md-10 col-md-offset-1 text-center"><strong class="text-danger">No available table for {{ vm.moment(vm.selectedTime, vm.TIME_SERVER_FORMAT).format(vm.TIME_DISPLAY_FORMAT) }}.</strong><br>Please select another time or date<span ng-if="vm.settings.productChosenByGuest"> or define different visit duration</span>.</div></div></span><span ng-show="vm.settings.showAlternative && vm.findTableData && vm.findTableData.tableFound==false"><div class="row"><div class="col-md-10 col-md-offset-1 text-center"><h4>No available table for {{ vm.moment(vm.selectedTime, vm.TIME_SERVER_FORMAT).format(vm.TIME_DISPLAY_FORMAT) }}.</h4>Select another date or choose alternative time<span ng-if="vm.settings.productChosenByGuest"> or define different visit duration</span> for {{ vm.moment(vm.selectedDay, vm.DATE_FORMAT).format(\'dddd, MMMM D, YYYY\');}}.<br><br></div></div><div class="row"><div class="col-md-10 col-md-offset-1 text-center"><span ng-repeat="timeSlot in vm.findTableData.alternativeTimes"><button class="btn public-button-gray" type="reset" ng-click="vm.selectAlternativeSlot(timeSlot.time)">{{ vm.moment(timeSlot.time, vm.TIME_SERVER_FORMAT).format(vm.TIME_DISPLAY_FORMAT) }}</button></span></div></div><br><br></span></div></form></div></div></div></div><div class="col-md-5"><div class="row hidden-xs hidden-sm" ng-if="vm.settings.coordinate"><div class="col-md-8 hidden-"><h3 class="">HOW TO REACH US</h3><a target="_blank" ng-href="https://www.google.com/maps/dir//{{vm.settings.coordinate}}/@{{vm.settings.coordinate}},10z"><iframe width="100%" style="border:0" loading="lazy" allowfullscreen referrerpolicy="no-referrer-when-downgrade" ng-src="{{(\'https://www.google.com/maps/embed/v1/place?key=AIzaSyCmoCT8DEF2-yj1Fof1xLXZxhaQWlAKkEM&q=\' + vm.settings.coordinate) | trustAsResourceUrl}}"></iframe></a></div></div><div class="row hidden-xs hidden-sm"><div class="col-md-10"><br><h3 class="font-bold">{{vm.settings.locationName}}</h3>{{vm.settings.locationAddress}}<br>{{vm.settings.locationCity}}, {{vm.settings.locationState}} {{vm.settings.locationZipCode}}<br>{{vm.settings.locationCountry}}<hr><span class="text-danger" ng-if="vm.settings.coordinate"><a class="text-danger" target="_blank" ng-href="https://www.google.com/maps/dir/Current+Location/{{vm.settings.coordinate}}/@{{vm.settings.coordinate}},1z"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;Get directions</a><br><br></span><span class="text-danger" ng-if="vm.settings.businessWebPage"><a class="text-danger" ng-href="{{vm.formattedWebPageLink}}" target="_blank"><i class="fa fa-home"></i>&nbsp;&nbsp;{{vm.settings.businessWebPage}}</a></span><br><br></div></div><div class="row"><div class="col-md-8" style="background-color: #FAFAFA" ng-if="vm.settings.notice"><br><strong>NEED TO KNOW</strong><br><br><span ng-bind-html="vm.settings.notice"></span><br><br></div><br><br></div></div></div></div></div><div class="row"><div class="col-md-12"><br><br></div></div></div>');
$templateCache.put('app/public/online/reservation/reserve/create.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-md-10 col-md-offset-1"><div class="row"><div class="col-md-7"><div class="row"><div class="col-md-10"><h1 class="font-bold">{{vm.settings.locationName}}</h1><strong>{{vm.settings.locationCity}}</strong><hr><span class="text-danger"><i class="fa fa-phone"></i>&nbsp; <a class="text-danger" ng-href="tel:{{vm.settings.contactPhone}}">{{vm.settings.contactPhone}}</a> </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="text-danger"><i class="fa fa-envelope-o"></i>&nbsp; <a class="text-danger" ng-href="mailto:{{vm.settings.contactEmail}}">{{vm.settings.contactEmail}}</a></span><hr></div></div><div class="row"><div class="col-md-11" style="background-color: #fff0f0" ng-if="vm.settings.importantNotice"><br><strong>NOTE TO CUSTOMER</strong><br><br><span ng-bind-html="vm.settings.importantNotice"></span><br><br></div></div><div class="row"><div class="col-md-12"><br><br><br></div></div><div class="row"><div class="col-md-7 col-lg-6"><div class="row"><div class="col-md-12"><div style="width:315px"><h4 class="text-danger">PICK A DATE</h4><input id="daterangepicker1" type="hidden" tabindex="1"><div id="daterangepicker1-container" class="embedded-daterangepicker"></div></div></div></div><br><br></div><div class="col-md-5 col-lg-6"><div class="row"><div class="col-md-12 btn-group"><h4 class="text-danger">{{vm.pickAPartySizeText()}}</h4><label ng-repeat="numberOfPersons in vm.seatOptions" uib-btn-radio="numberOfPersons" ng-change="vm.numberOfPersonsChanged()" ng-model="vm.numberOfPersons" class="btn btn-danger btn-lg btn-outline" title="Select party size" style="margin: 1px; border-color: #888" tabindex="2">{{numberOfPersons}}</label></div><div class="col-lg-8 col-md-10 col-sm-10" ng-if="vm.additionalSeatOptions"><br><select ng-model="vm.numberOfPersons" name="numberOfPersons" placeholder="Party size" class="form-control m-b" ng-options="item.id as item.label for item in vm.additionalSeatOptions" tabindex="3" style="">><option value="" label="">... or select larger party size</option></select></div></div><div class="row" ng-if="vm.settings.productChosenByGuest"><div class="col-xs-10"><br><br><h4 class="text-danger">PICK A {{vm.settings.productType}}</h4><select ng-model="vm.selectedProductId" ng-disabled="vm.settings.productList.length==0" name="productId" placeholder="Select your choice" class="form-control" ng-options="item.id as item.name for item in vm.settings.productList | filter:{name:\'!!\'}" ng-change="vm.onParametersChange()" tabindex="4"><option value="">Select {{vm.settings.productType==\'DURATION\'?\'duration of you visit\':\'what you want to book\'}}</option></select><small ng-if="vm.productNotSelectedError" class="text-danger">Please select your preference!</small></div></div></div></div><div class="row" ng-if="vm.productAlertDate!=null"><div class="col-md-8 col-md-offset-2"><div uib-alert class="alert-danger"><b>{{vm.productAlertDate}}</b></div></div></div><div class="row"><div class="col-md-12"><br><br><h4 class="font-bold text-danger">AVAILABLE TIME SLOTS - PICK THE ONE THAT SUITS YOU BEST</h4><span class="">Note: Time slots in <span class="text-warning">orange</span> could soon be unavailable.</span></div></div><div ng-if="!vm.availability.containerList || vm.availability.containerList.length==0"><div class="row"><div class="col-md-12"><hr></div></div><div class="row"><div class="col-md-9 col-md-offset-3"><div ng-if="vm.availability.status==5 || vm.availability.status==6" class="row"><div class="col-xs-12"><h2 class="">No available time slot(s) for {{ vm.moment(vm.selectedDay, vm.DATE_FORMAT).format(vm.DATE_PICKER_FORMAT) }}.</h2><h3>Please select another date.</h3></div></div><div ng-if="vm.availability.status==10" class="row"><div class="col-xs-12 text-danger text-center"><h2 class="">Dear Guest, first possible time slot for your reservation is from:<br>{{vm.availability.statusText}}.<br><br>Thank you for understanding.</h2></div></div><div ng-if="vm.availability.status==20" class="row"><div class="col-xs-12 text-danger text-center"><h2 class="">Selected date {{ vm.moment(vm.selectedDay, vm.DATE_FORMAT).format(vm.DATE_PICKER_FORMAT) }} is in past. Please select valid date.</h2></div></div><div ng-if="vm.availability.status==99" class="row"><div class="col-xs-12 text-danger text-center"><h2>Reservation service temporary disabled.<br>Please contact us in case of any questions.</h2></div></div><br><br></div></div></div><div class="row" ng-repeat="container in (vm.availability.containerList | filter:vm.filterAvailability)"><div class="col-md-12"><div class="row"><div class="col-md-12"><hr></div></div><div class="row"><div class="col-md-3"><h3 class="font-bold">{{container.name}}</h3><small ng-if="container.description">{{container.description}}</small></div><div class="col-md-9"><div ng-if="!container.timeSlotList || container.timeSlotList.length==0"><h3>No available time slots for selected date or party size.</h3></div><span ng-repeat="timeSlot in (filteredTimeSlot = (container.timeSlotList | filter:vm.filterByParams))"><button ng-model="timeSlot" type="button" class="btn {{vm.calculateButtonColor(container.warningThreshold, timeSlot)}} btn-outline" style="margin: 2px" ng-click="vm.proceedToContactPage(container.id, timeSlot.time, container.name)">{{vm.moment(timeSlot.time, vm.TIME_SERVER_FORMAT).format(vm.TIME_DISPLAY_FORMAT)}}</button> </span><span ng-if="filteredTimeSlot.length===0" class="text-danger">No available time slots for selected date or party size. Please choose another date {{vm.alternativeProduct(vm.settings.productType)}}.</span></div></div></div></div><br><br><br></div><div class="col-md-5"><div class="row hidden-xs hidden-sm" ng-if="vm.settings.coordinate && vm.settings.coordinate!=\'null\'"><div class="col-md-8 hidden-"><h3 class="">HOW TO REACH US</h3><a target="_blank" ng-href="https://www.google.com/maps/dir//{{vm.settings.coordinate}}/@{{vm.settings.coordinate}},10z"><iframe width="100%" style="border:0" loading="lazy" allowfullscreen referrerpolicy="no-referrer-when-downgrade" ng-src="{{(\'https://www.google.com/maps/embed/v1/place?key=AIzaSyCmoCT8DEF2-yj1Fof1xLXZxhaQWlAKkEM&q=\' + vm.settings.coordinate) | trustAsResourceUrl}}"></iframe></a></div></div><div class="row hidden-xs hidden-sm"><div class="col-md-10"><br><h3 class="font-bold">{{vm.settings.locationName}}</h3>{{vm.settings.locationAddress}}<br>{{vm.settings.locationCity}}, {{vm.settings.locationState}} {{vm.settings.locationZipCode}}<br>{{vm.settings.locationCountry}}<hr><span class="text-danger" ng-if="vm.settings.coordinate && vm.settings.coordinate!=\'null\'"><a class="text-danger" target="_blank" ng-href="https://www.google.com/maps/dir/Current+Location/{{vm.settings.coordinate}}/@{{vm.settings.coordinate}},1z"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;Get directions</a><br><br></span><span class="text-danger" ng-if="vm.settings.businessWebPage"><a class="text-danger" ng-href="{{vm.formattedWebPageLink}}" target="_blank"><i class="fa fa-home"></i>&nbsp;&nbsp;{{vm.settings.businessWebPage}}</a></span><br><br><br></div></div><div class="row"><div class="col-md-9" style="background-color: #FAFAFA" ng-if="vm.settings.notice"><br><strong>NEED TO KNOW</strong><br><br><span ng-bind-html="vm.settings.notice"></span><br><br></div><br><br></div></div></div></div></div><div class="row"><div class="col-md-12"><br><br><br></div></div></div>');
$templateCache.put('app/settings/online/reservation/facebook/facebook.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12 col-md-10"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Facebook Integration</h2>Start receiving online reservation from your Facebook business account and increase number of reservations.</div><div class="panel-body"><div class="row"><div class="col-sm-12"><div class="panel panel-default"><div class="col-lg-12"><div class="ibox"><div class="row"><div class="col-lg-12"><h3 class=""><i class="fa fa-facebook text-success"></i>&nbsp;Follow a few simple steps to integrate SeatOn with Facebook</h3><br><h4 class="text-danger"><b>IMPORTANT NOTE:</b></h4><p>Facebook recently removed an option to easily customize the "Book Now" button that appears on Facebook business pages. We are currently working on a full integration which will allow you to add a link for online reservations to the "Book Now" button on your Facebook business page. Until this is available, please use the temporary solution described in the steps below.</p></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><h5><span class="text-danger">Step 1</span>: Create a Facebook post with a link for online reservations</h5><div class="ibox-tools"><a class="collapse-link"><i class="fa fa-chevron-up" ng-click="vm.scrollToTop()"></i></a></div></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><p>Go to your Facebook page, and create a new post using the text below. You can use any text you want, but please make sure you copy the link/URL correctly.</p></div></div><div class="row"><div class="col-lg-12"><textarea id="onlineResBaseUrlFacebook" ng-model="vm.onlineResFacebookPost" class="col-md-6 col-sm-12" disabled="true" rows="e"></textarea><br></div></div><div class="row"><div class="col-lg-12"><br><a type="button" ng-click="vm.copyToClipboard(\'onlineResBaseUrlFacebook\')" class="btn btn-w-m btn-primary col-md-6 col-sm-12">Copy Text to Clipboard</a></div></div><div class="ibox-content"><img src="/content/images/facebook_workaround_01.png"></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><h5><span class="text-danger">Step 2</span>: Pin the new post to the top of your timeline</h5><div class="ibox-tools"><a class="collapse-link"><i class="fa fa-chevron-up" ng-click="vm.scrollToTop()"></i></a></div></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><p>After you\'ve created a new post, pin it to the top of the page, so that it always appears at the top of your timeline on Facebook.</p></div></div><div class="ibox-content"><img src="/content/images/facebook_workaround_02.png"></div></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/settings/online/reservation/google/google.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12 col-md-10"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Google Integration</h2>Start receiving online reservation from your <strong>Google listing</strong> and your <strong>Google Maps page</strong> to increase number of reservations.</div><div class="panel-body"><div class="row"><div class="col-sm-12"><div class="panel panel-default"><div class="col-lg-12"><div class="ibox"><div class="row"><div class="col-lg-12"><h3 class=""><i class="fa fa-google text-success"></i>&nbsp;Add SeatOn reservations to your Google account</h3><p>Easy integration with Google search/Google maps in a couple of minutes</p></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><h5><span class="text-danger">Step 1</span>: Copy the link below to clipboard</h5><div class="ibox-tools"><a class="collapse-link"><i class="fa fa-chevron-up" ng-click="vm.scrollToTop()"></i></a></div></div><div class="ibox-content"><div class="row"><div class="col-lg-12"><textarea id="onlineResBaseUrlGoogle" ng-model="vm.onlineResGoogleAnchor" class="col-md-6 col-sm-12" disabled="true" rows="1"></textarea><br></div></div><div class="row"><div class="col-lg-12"><br><a type="button" ng-click="vm.copyToClipboard(\'onlineResBaseUrlGoogle\')" class="btn btn-w-m btn-primary col-md-6 col-sm-12">Copy Link to Clipboard</a></div></div></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><h5><span class="text-danger">Step 2</span>: Open www.google.com and make sure you\'re logged into the Google account that manages Google business account</h5><div class="ibox-tools"><a class="collapse-link"><i class="fa fa-chevron-up" ng-click="vm.scrollToTop()"></i></a></div></div><div class="ibox-content"><img src="/content/images/google_integration_00.png"></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><h5><span class="text-danger">Step 3</span>: Do a Google search to find your business page on Google and click on "Bookings"</h5><div class="ibox-tools"><a class="collapse-link"><i class="fa fa-chevron-up" ng-click="vm.scrollToTop()"></i></a></div></div><div class="ibox-content"><img src="/content/images/google_integration_01.png"></div><div class="ibox-footer"></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><h5><span class="text-danger">Step 4</span>: Click the "Add a link" button</h5><div class="ibox-tools"><a class="collapse-link"><i class="fa fa-chevron-up" ng-click="vm.scrollToTop()"></i></a></div></div><div class="ibox-content"><img src="/content/images/google_integration_02.png"></div><div class="ibox-footer"></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><h5><span class="text-danger">Step 5</span>: Paste the link from Step 1 into the "Booking URL" field, and click "Save"</h5><div class="ibox-tools"><a class="collapse-link"><i class="fa fa-chevron-up" ng-click="vm.scrollToTop()"></i></a></div></div><div class="ibox-content"><img src="/content/images/google_integration_03.png"></div><div class="ibox-footer"></div></div></div></div><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><h5><span class="text-danger">Step 6</span>: You\'re done! After the change is applied (it can take some time), a new link (getseat.net) will show up on your Google search page (Reservations) and your Google Maps page (Find a table). Clicking the link opens the online reservation page in a new browser tab</h5><div class="ibox-tools"><a class="collapse-link"><i class="fa fa-chevron-up" ng-click="vm.scrollToTop()"></i></a></div></div><div class="ibox-content"><img src="/content/images/google_integration_04.png"></div><div class="ibox-footer"></div></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/settings/online/reservation/settings/preview.completed.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeReservationCompletedDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Online reservation request page preview</h3></div><div class="modal-body"><div class="row"><div class="col-md-12 text-center" style="background-image: url(\'/content/images/online-header-bg.jpg\'); padding: 5px; color: #FFF"><h1 class="font-bold">Your restaurant name</h1><h3>Your restaurant address</h3></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-12 text-center"><br><img style="max-width: 100%; height: auto" ng-if="!vm.custo.enablePayment" src="/content/images/online-res-step-3-3.jpg"> <img style="max-width: 100%; height: auto" ng-if="vm.custo.enablePayment" src="/content/images/online-res-step-4-4.jpg"><br></div><br><div class="row"><div class="col-md-10 col-md-offset-1 text-center"><br><h1 class="font-bold">Reservation request successfully completed.</h1><br><br><h2><span ng-bind-html="vm.custo.noticeCompleted"></span></h2><br><small>Note: this message will be displayed if resources assigned and confirmation email sent to customer.</small><div uib-alert class="alert-success" style="font-size: 150%"><span ng-bind-html="vm.custo.noticeCompletedConfirm"></span></div><br><small>Note: this message will be displayed if email verfication required and resources not assign.</small><div uib-alert class="alert-success" style="font-size: 150%"><span ng-bind-html="vm.custo.noticeCompletedVerify"></span></div><br><br><div class="text-center"><br><button class="btn btn public-button-reschedule" type="button">Create new reservation</button></div></div></div></div></div></div><div class="row"><div class="col-md-8 col-md-offset-2 text-center" style="background-color: #FFF; border-color: #444; padding: 5px; color: #444"><hr><span><img src="/content/images/favicon-16x16.png"> <small style="vertical-align: middle">POWERED BY SEAT<span style="color: #d80257">ON</span> PLATFORM</small></span></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeReservationCompletedDialog()">Close</button></div></div>');
$templateCache.put('app/settings/online/reservation/settings/preview.details.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeReservationDetailDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Online reservation customer contact details page preview</h3></div><div class="modal-body"><div class="row"><div class="col-md-12 text-center" style="background-image: url(\'/content/images/online-header-bg.jpg\'); padding: 5px; color: #FFF"><h1 class="font-bold">Your restaurant name</h1><h3>Your restaurant address</h3></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-12 text-center"><br><img style="max-width: 100%; height: auto" ng-if="!vm.custo.enablePayment" src="/content/images/online-res-step-3-2.jpg"> <img style="max-width: 100%; height: auto" ng-if="vm.custo.enablePayment" src="/content/images/online-res-step-4-2.jpg"><br></div></div><form name="customerForm" class="form-horizontal"><div class="row"><div class="col-md-12 text-center" style="background-color: #fff; border-color: #444; padding: 15px"><span class="font-bold" style="margin-top: 7px"><i class="fa fa-calendar"></i>&nbsp; Monday, September 21, 2020&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="font-bold" style="margin-top: 7px"><i class="fa fa-clock-o"></i>&nbsp; 07:00PM&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="font-bold" style="margin-top: 7px"><i class="fa fa-users"></i>&nbsp; 2 person(s)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span ng-if="vm.custo.enableManualDuration" class="font-bold" style="margin-top: 7px"><i class="fa fa-hourglass-1"></i>&nbsp; 60 min&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><button class="btn btn-xs public-button-reschedule">RESCHEDULE</button></div></div><div class="row"><div class="col-md-12 text-center font-bold"><br><h2 class="text-center font-bold">WE FOUND A TABLE FOR YOU!</h2><h4>Please enter your contact information and special request if any.</h4><br></div></div><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-6 col-md-offset-1"><div class="row"><div class="col-md-6"><div class="row"><div class="col-md-11"><div class="form-group"><input autofocus name="firstName" class="form-control" placeholder="First name" type="text" tabindex="1" style="background-color: rgba(0,0,0,0)"></div><div class="form-group"><input name="lastName" class="form-control" placeholder="Last name" type="text" tabindex="2" style="background-color: rgba(0,0,0,0)"></div><div class="form-group"><div class="input-group m-b" style="margin: 0; z-index: 100"><input id="primaryPhone" name="primaryPhone" size="35" class="form-control" type="text" placeholder="Mobile phone number" tabindex="3" style="background-color: rgba(0,0,0,0)"></div></div><div class="form-group"><div class="input-group m-b"><span class="input-group-addon">@</span> <input name="primaryEmail" class="form-control" placeholder="Email address" type="email" validate-email tabindex="4" style="background-color: rgba(0,0,0,0)"></div></div></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-11"><div class="form-group"><textarea rows="8" placeholder="Please share with us any questions or special request here." class="form-control" tabindex="6"></textarea></div></div></div></div></div></div><div class="col-md-4" style="background-color: #eeeeee; padding: 10px"><h4>NOTE FROM THE RESTAURANT</h4><span ng-bind-html="vm.custo.notice"></span></div></div></div></div><div class="row"><div class="col-md-12 text-center"><br><button class="btn btn public-button-logo" ng-disabled="true" type="button" tabindex="7"><span ng-if="vm.custo.enablePayment">Proceed to payment page</span> <span ng-if="!vm.custo.enablePayment">Complete reservation</span></button> &nbsp; <button class="btn btn btn-white" type="reset">Clear</button></div></div></form></div></div><div class="row"><div class="col-md-8 col-md-offset-2 text-center" style="background-color: #FFF; border-color: #444; padding: 5px; color: #444"><hr><span><img src="/content/images/favicon-16x16.png"> <small style="vertical-align: middle">POWERED BY SEAT<span style="color: #d80257">ON</span> PLATFORM</small></span></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeReservationDetailDialog()">Close</button></div></div>');
$templateCache.put('app/settings/online/reservation/settings/preview.html','<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>Title</title></head><body></body></html>');
$templateCache.put('app/settings/online/reservation/settings/preview.payment.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeReservationDetailDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Online reservation customer contact details page preview</h3></div><div class="modal-body"><div class="row"><div class="col-md-12 text-center" style="background-image: url(\'/content/images/online-header-bg.jpg\'); padding: 5px; color: #FFF"><h1 class="font-bold">Your restaurant name</h1><h3>Your restaurant address</h3></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-12 text-center"><br><img style="max-width: 100%; height: auto" src="/content/images/online-res-step-4-3.jpg"><br></div></div><form name="customerForm" class="form-horizontal"><div class="row"><div class="col-md-12 text-center" style="background-color: #fff; border-color: #444; padding: 15px"><span class="font-bold" style="margin-top: 7px"><i class="fa fa-calendar"></i>&nbsp; Monday, September 21, 2020&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="font-bold" style="margin-top: 7px"><i class="fa fa-clock-o"></i>&nbsp; 07:00PM&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span class="font-bold" style="margin-top: 7px"><i class="fa fa-users"></i>&nbsp; 2 person(s)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span ng-if="vm.custo.enableManualDuration" class="font-bold" style="margin-top: 7px"><i class="fa fa-hourglass-1"></i>&nbsp; 60 min&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><button class="btn btn-xs public-button-reschedule">RESCHEDULE</button></div></div><br><div class="row"><div class="col-md-6 col-md-offset-3 text-center font-bold"><div class="alert alert-success"><h2 class="text-center font-bold">Reservation fee: 20.00 $</h2><span>10.00 $ per cover, 2 covers</span></div></div></div><div class="row"><div class="col-md-12 text-center"><strong>Please enter card details you want to use to pay the reservation fee.</strong><br><br></div></div><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-4 col-md-offset-2"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-11"><div class="form-group"><input autofocus name="cardnumber" class="form-control" placeholder="Card number" tabindex="1" style="background-color: rgba(0,0,0,0)"></div><div class="form-group"><input id="expiry" name="expiry" class="form-control" placeholder="MM/YY" size="12" tabindex="2" style="background-color: rgba(0,0,0,0)"></div><div class="form-group"><input id="cvv" name="cvv" size="12" class="form-control" placeholder="CVV" tabindex="3" style="background-color: rgba(0,0,0,0)"></div><div class="form-group"><input id="zip" name="zip" class="form-control" placeholder="Zip" size="12" tabindex="4" style="background-color: rgba(0,0,0,0)"></div></div></div></div></div></div><div class="col-md-4" style="background-color: #eeeeee; padding: 10px"><h4>NOTE FROM THE RESTAURANT</h4><span ng-bind-html="vm.custo.noticePayment"></span></div></div></div></div><div class="row"><div class="col-md-12 text-center"><br><button class="btn btn public-button-logo" ng-disabled="true" type="button" tabindex="7"><span>Complete reservation</span></button> &nbsp; <button class="btn btn btn-white" type="reset">Clear</button></div></div><div class="row"><div class="col-lg-12 text-center"><br><a href="https://www.cvvnumber.com/cvv.html" target="_blank" style="font-size:11px">What is my CVV code?</a><br><a href="https://www.mapdevelopers.com/what-is-my-zip-code.php" target="_blank" style="font-size:11px">What is my zip code?</a></div></div></form></div></div><div class="row"><div class="col-md-8 col-md-offset-2 text-center" style="background-color: #FFF; border-color: #444; padding: 5px; color: #444"><hr><span><img src="/content/images/favicon-16x16.png"> <small style="vertical-align: middle">POWERED BY SEAT<span style="color: #d80257">ON</span> PLATFORM</small></span></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeReservationDetailDialog()">Close</button></div></div>');
$templateCache.put('app/settings/online/reservation/settings/preview.request.preview.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="closeReservationRequestDialog()"><span aria-hidden="true">&times;</span></button><h3 class="modal-title text-navy" id="myModalLabel">Online reservation request page preview</h3></div><div class="modal-body"><div class="row"><div class="col-md-12 text-center" style="background-image: url(\'/content/images/online-header-bg.jpg\'); padding: 5px; color: #FFF"><h1 class="font-bold">Your restaurant name</h1><h3>Your restaurant address</h3></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-md-12 text-center"><br><img style="max-width: 100%; height: auto" ng-if="!vm.custo.enablePayment" src="/content/images/online-res-step-3-1.jpg"> <img style="max-width: 100%; height: auto" ng-if="vm.custo.enablePayment" src="/content/images/online-res-step-4-1.jpg"><br></div><br><div class="row"><div class="col-md-8 col-md-offset-2 text-center"><h2 class="text-center font-bold">BOOK A TABLE</h2><h3 class="font-bold">Select date and time of your visit and specify party size.</h3></div></div><br><div class="row"><form name="findTableForm" class="form-horizontal"><div class="col-md-10 col-md-offset-1"><div class="row"><div class="col-md-6 col-md-offset-3"><div class="form-group"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-calendar text-success"></i></button> </span><input placeholder="Select date" name="datePicker" type="text" class="form-control"></div></div><div class="form-group"><div class="input-group"><span class="input-group-addon"><i class="fa fa-clock-o text-success"></i></span><select name="selectedTime" placeholder="Select time" class="form-control" tabindex="1"><option value="">Select time</option></select></div></div><div class="form-group"><div class="input-group"><span class="input-group-addon"><i class="fa fa-group text-success"></i></span><select name="numberOfPersons" placeholder="Party size" class="form-control" tabindex="4"><option value="">Select party size</option></select></div></div><div ng-if="vm.custo.enableManualDuration" class="form-group"><div class="input-group"><span class="input-group-addon"><i class="fa fa-hourglass-1 text-success"></i></span><select name="durationTime" placeholder="Select duration" class="form-control" tabindex="5"><option value="">Select duration</option></select></div><br></div></div></div></div></form></div><div class="row"><div class="col-md-12 text-center"><button class="btn btn public-button-logo" type="button" tabindex="7">Find a table</button> &nbsp; <button class="btn btn btn-white" type="reset">Clear</button></div></div></div></div></div><div class="row"><div class="col-md-8 col-md-offset-2 text-center" style="background-color: #FFF; border-color: #444; padding: 5px; color: #444"><hr><span><img src="/content/images/favicon-16x16.png"> <small style="vertical-align: middle">POWERED BY SEAT<span style="color: #d80257">ON</span> PLATFORM</small></span></div></div><div class="modal-footer"><button type="button" class="btn btn-sm btn-default" data-dismiss="modal" ng-click="closeReservationRequestDialog()">Close</button></div></div>');
$templateCache.put('app/settings/online/reservation/settings/settings.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12 col-md-10"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Online reservation settings</h2>Online reservation enables your guest to create reservation though various channels. Visitors of your <strong>Web page</strong>, your <strong>Facebook page</strong> and through <strong>Google services</strong> can make reservations online.<br>Here, you can customize online reservations to match your business process, your restaurant web page look and feel and get information on how to integrate with various channels.</div><div class="panel-body"><div class="row"><div class="col-lg-6"></div><div class="col-lg-6 text-right"><a ng-href="/#/public/online/reservation/{{vm.hashedLocationId}}?channel=merchant_web" target="_target"><button class="btn btn-info btn-outline" type="button">Click to view reservation page</button></a> &nbsp;&nbsp; <button ng-disabled="formGroups.$invalid" aria-pressed="false" data-toggle="button" class="btn btn-primary" type="button" ng-click="vm.save()">Save settings</button><br><small class="text-danger">Note: Save to apply new settings to online reservation page</small></div></div><div class="row"><div class="col-sm-12"><uib-tabset><uib-tab><uib-tab-heading class="text-center">Settings</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h3 class="">&nbsp;Online reservation settings</h3><small>Set up reservation widget to better match your requirements. After each parameter change please save settings by clicking on "Save settings" button on top left corner of the screen.</small><br><br></div></div><div class="row"><div class="col-lg-1"></div><form name="formGroups"><div class="col-lg-10"><div class="row"><div class="col-sm-12"><div class="row"><div class="col-lg-12"><h4 class="row font-bold text-navy"><i class="fa fa-toggle-on"></i> DISABLE / ENABLE Online reservations</h4></div></div><div class="row"><div class="col-lg-4"><div class="radio"><input class="radio-primary" ng-model="vm.custo.status" type="radio" name="radio_offline" id="radio_offline_0" value="0" checked=""><label for="radio_offline_0"><strong ng-class="vm.custo.status==0?\'text-info\':\'text-muted\'">ENABLED</strong><br><small>Online reservation available for your guests.</small></label></div><br><br></div><div class="col-lg-4"><div class="radio"><input class="radio-primary" ng-model="vm.custo.status" type="radio" name="radio_offline" id="radio_offline_2" value="2" checked=""><label for="radio_offline_2"><strong ng-class="vm.custo.status==2?\'text-danger\':\'text-muted\'">DISABLED</strong><br><small>Online reservation permanently disabled for your guests.</small></label></div><br><br></div><div class="col-lg-4"><div class="radio"><input class="radio-primary" ng-model="vm.custo.status" type="radio" name="radio_offline" id="radio_offline_1" value="1" checked=""><label for="radio_offline_1"><strong ng-class="vm.custo.status==1?\'text-warning\':\'text-muted\'">TEMPORARY DISABLED</strong><br><small>Online reservation temporary disabled until defined time for your guests. Select date and time until online reservations will be disabled.</small></label></div><div class="row" ng-show="vm.custo.status==1"><div class="col-lg-6"><div class="input-group date"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openDatePicker()"><i class="fa fa-calendar"></i></button> </span><input placeholder="select date" name="datePicker" type="text" class="form-control" ng-model="vm.custo.disableUntilDate" close-text="Close"></div></div><div class="col-lg-6"><select class="form-control" ng-model="vm.custo.disableUntilTime" ng-options="obj.timeForDB as obj.time for obj in availableTimes" ng-change=""><option value="" selected="selected">select time</option></select></div></div><br><br></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div class="row"><div class="col-lg-12"><h4 class="row font-bold text-navy"><i class="fa fa-calendar text-navy"></i> GENERAL</h4></div></div><div class="row"><div class="col-lg-12"><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.custo.showAlternative"></checkbox>&nbsp;&nbsp;offer alternatives to visitors if there are no free tables for the requested time<br><br></div></div><div class="row"><div class="col-lg-12">Allow online reservations up to &nbsp;&nbsp;<select ng-model="vm.custo.reservationInAdvanceLimit" ng-required="true" ng-options="item.id as item.name for item in vm.reservationDateLimit"></select>&nbsp;&nbsp; in advance.</div><br></div></div><div class="col-lg-6 col-md-12"><div class="row"><div class="col-lg-12"><h4 class="row font-bold text-navy"><i class="fa fa-group text-navy"></i> MIN / MAX PERSONS</h4></div></div><div class="row"><div class=""><select ng-model="vm.custo.minSeats" ng-required="true" ng-options="item.id as item.name for item in vm.maxSeats"></select>&nbsp;&nbsp; minimum number of persons required per reservation</div><br></div><div class="row"><div class=""><select ng-model="vm.custo.maxSeats" ng-required="true" ng-options="item.id as item.name for item in vm.maxSeats"></select>&nbsp;&nbsp; maximum number of persons allowed per reservation</div><span ng-if="vm.custo.minSeats>vm.custo.maxSeats" ng-init="formGroups.$invalid = true;" class="text-danger"><br>Note: The maximum number of seats must be greater than or equal to the minimum required.</span></div><br></div></div><div class="row"><div class="col-lg-6 col-md-12"><div class="row"><div class="col-lg-12"><br><h4 class="row font-bold text-navy"><i class="fa fa-clock-o text-navy"></i> CANCEL / CREATE POLICY</h4></div></div><div class="row"><div class="col-lg-12">Reservation can be cancelled &nbsp;&nbsp;<select ng-model="vm.custo.cancelCutOffTime" ng-required="true" ng-options="item.id as item.name for item in vm.cancelTimeList"></select>&nbsp;&nbsp; before the event starts.<br><small>This prevents last-minute cancellations, as customer will not be able to cancel reservation after that time.</small></div></div><br><div class="row"><div class="col-lg-12">Reservation can be created &nbsp;&nbsp;<select ng-model="vm.custo.reservationLeadTime" ng-required="true" ng-options="item.id as item.name for item in vm.cancelTimeList"></select>&nbsp;&nbsp; before the event starts.<br><small>This prevents last-minute reservations.</small></div></div><br></div><div class="col-lg-6 col-md-12"><div class="row"><div class="col-lg-12"><br><h4 class="row font-bold text-navy"><i class="fa fa-arrows-h text-navy"></i> GRACE TIME</h4></div></div><div class="row"><div class="">Time between two reservations &nbsp;&nbsp;<select ng-model="vm.custo.timeBetweenEvents" ng-required="true" ng-options="item.id as item.name for item in vm.timeBetweenEventsist"></select><br><small>Time between event to prepare for the next guest.</small></div></div><br></div></div><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-12"><div class="row"><h4 class="font-bold text-navy"><i class="fa fa-gears text-navy"></i> AUTOMATION</h4><small>Tables will be automatically assigned when users creates an online or IVR reservation. Reassignment is possible through the Reservation center page.</small></div><br><div class="row"><div class=""><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.custo.autoAssignment"></checkbox>&nbsp;&nbsp;Enable automatic table assignment for online and IVR reservations<br><br></div></div><div class="row"><div class="">Define assignment strategy:<select ng-model="vm.custo.autoAssignmentStrategy" ng-required="vm.custo.autoAssignment" ng-options="item.id as item.name for item in vm.automationStrategyList"></select><br><br></div></div><div class="row"><div class="text-success">Please note:<br><ul><li>A table can later be reassigned through the Reservation center page or the Event update page</li><li>If table(s) are not assigned to the event automatically, you can assign it manually through Pre-reservation page</li><li>If a guest selected a seating option when requesting a reservation, this will be taken into account when assigning tables (only tables of the requested seating option will be available for auto assigned)</li></ul></div></div></div></div><span ng-hide="isEU==true"><div class="hr-line-dashed"></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h4 class="row font-bold text-navy"><i class="fa fa-money text-navy"></i> ONLINE RESERVATION FEE</h4><br></div></div><div class="row"><div class=""><checkbox style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.custo.enablePayment"></checkbox>&nbsp;&nbsp;enable online reservation fee (if enabled, a customer will be asked for card details to charge a reservation fee)<br></div></div><div class="row"><div class=""><checkbox ng-disabled="!vm.custo.enablePayment" style="margin-bottom: 5px" type="checkbox" class="btn-primary btn" ng-model="vm.custo.paymentCapture"></checkbox>&nbsp;&nbsp;enable instant capture of funds, otherwise only reservation of funds will be processed<br><br></div></div><div class="row"><div class=""><select ng-model="vm.custo.paymentRule" ng-disabled="!vm.custo.enablePayment" ng-required="true" ng-options="item.id as item.name for item in vm.paymentBehaviorList"></select>&nbsp;&nbsp; in amount of &nbsp;&nbsp; <input name="paymentAmount" ng-model="vm.custo.paymentAmount" ng-required="vm.custo.enablePayment" ng-disabled="!vm.custo.enablePayment" min="0" max="999" type="number" step="0.01" ng-pattern="/^[0-9]+\\.?[0-9]*$/"> {{vm.currencySymbol}}, &nbsp;&nbsp; tax <input name="paymentTax" ng-model="vm.custo.paymentTax" ng-required="vm.custo.enablePayment" ng-disabled="!vm.custo.enablePayment" type="number" min="0" max="100" step="0.01" ng-pattern="/^[0-9]+\\.?[0-9]*$/"> % included.<br><ng-messages for="formGroups.paymentAmount.$error" ng-show="formGroups.paymentAmount.$invalid" role="alert" class="text-danger">Please enter fee amount number between 0.00 and 999.00.</ng-messages><div ng-messages="formGroups.paymentTax.$error" ng-show="formGroups.paymentTax.$invalid" role="alert" class="text-danger">Please enter tax percentage number between 0.00 and 100.00. Put 0 if tax should not be calculated.</div><br><span class="text-success">Please note:<br><ul><li>If reservation of funds is your preference, capture of the funds will be possible in the next 7 days from time of the authorization. After 7 days, reservation of funds will be automatically released if the funds are not captured.</li><li>You can capture and/or refund funds on the Reservation details page.</li></ul></span></div></div></div></div></span></div></form><div class="col-lg-1"></div></div></div></div></div></div></uib-tab><uib-tab select="vm.loadSeatingOptions()"><uib-tab-heading class="text-center">Seating Options</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h4 class=""><i class="fa fa-bullseye text-navy"></i>&nbsp;Seating options</h4><small>Define seating options for online reservation and allow your customers to choose seating preference (e.g Inside, Outside, etc).</small><br><br><br><br></div></div><div class="row"><div class="col-lg-5"><span name="optionForm" class="form-horizontal"><div class="form-group"><label class="col-sm-5 control-label">Option name (*)<br><small>(Not visible to customer)</small></label><div class="col-sm-6"><input placeholder="Internal name of the option" type="text" class="form-control" ng-model="vm.option.name" maxlength="64"></div></div><div class="form-group"><label class="col-sm-5 control-label">Option label (*)<br><small>(Visible to customer)</small></label><div class="col-sm-6"><input placeholder="Name of the option visible to guests" type="text" class="form-control" ng-model="vm.option.label" maxlength="24" oninput="this.value = this.value.toUpperCase()"></div></div><div class="form-group"><label class="col-sm-5 control-label">Option description<br><small>(Visible to customer)</small></label><div class="col-sm-6"><textarea placeholder="Option description" class="form-control" ng-model="vm.option.description" maxlength="256" rows="3" columns="20" onkeypress="return ( this.value.length < 250 );"></textarea></div></div><div class="form-group"><label class="col-sm-5 control-label">Area(s) (*)<br><small>(Select one or more areas you want to have under this seating option)</small></label><div class="col-sm-6 btn-group"><span ng-if="vm.availableAreas && vm.availableAreas.length>0"><label ng-repeat="area in vm.availableAreas" ng-model="area.selected" uib-btn-checkbox class="btn btn-default btn-outline" style="margin: 2px; overflow:auto"><span class="font-bold text-success">{{area.name}}</span></label></span><span ng-if="vm.availableAreas && vm.availableAreas.length==0" class="text-danger text-center">No available Area(s).</span></div></div><div class="form-group"><label class="col-sm-5 control-label">Time slot set<br><small>(Select time slot set for this seating option)</small></label><div class="col-sm-6 btn-group"><select ng-model="vm.option.timeSlotSetId" class="form-control" ng-options="timeSlotSet.id as timeSlotSet.name for timeSlotSet in vm.timeSlotSetList" name="timeSlotSetId"><option value="">Use standard (**)</option></select></div></div><button ng-disabled="vm.validateInput()" type="button" class="btn btn-primary col-lg-offset-4" ng-click="vm.saveSeatingOption()()">Save Seating Option</button>&nbsp;&nbsp; <button type="button" class="btn btn-default" ng-click="vm.option=null">Clear</button><br><br><br><span class="text-center">(*) Mandatory fields.</span><br><span class="text-center">(**) Standard time slot defined on restaurant level in Settings/Time slots - online time slots section.</span><br><span class="text-center" ng-if="vm.option.timeSlotSetId">(***) Only limitation defind in choosen Time Slot Set marked with "Default limitation" will be used for all seating options, on restaurant level, other will be ignored.</span></span></div><div class="col-lg-7"><ul class="todo-list m-t ui-sortable"><li><span class="text-danger font-bold"><i class="fa fa-calendar"></i>&nbsp; Seating option list</span><table class="table table-hover"><thead><tr><th>Name</th><th>Label</th><th>Areas included</th><th>Time slot set</th><th>Action</th><th colspan="2">Reorder</th></tr></thead><tbody><tr ng-repeat="(key, option) in vm.seatingOptions"><td>{{option.name}}</td><td>{{option.label}}</td><td><span ng-repeat="areaInOption in option.areaList">&nbsp;&nbsp;{{areaInOption.name}};</span></td><td><span ng-if="option.timeSlotSetId">{{option.timeSlotSetName}}</span> <span ng-if="!option.timeSlotSetId"><a href=""><span class="seaton-tooltip">(**) <span class="seaton-tooltiptext-large seaton-tooltip-bottom-large">Standard time slot defined on restaurant level will be used.</span></span></a></span></td><td class="text-danger"><button type="button" class="btn btn-xs btn-info" ng-disabled="" ng-click="vm.editSeatingOption(option)"><i class="fa fa-edit"></i><small> EDIT</small></button> <button type="button" class="btn btn-xs btn-danger" ng-disabled="" ng-click="vm.deleteSeatingOption(option)"><i class="fa fa-times"></i><small> DELETE</small></button></td><td><a ng-if="key<(vm.seatingOptions.length-1)" class="fa fa-arrow-circle-down text-success" ng-click="vm.reOrderOption(option.id, vm.seatingOptions[key+1].id)"></a></td><td><a ng-if="key>0" class="fa fa-arrow-circle-up text-info" ng-click="vm.reOrderOption(option.id, vm.seatingOptions[key-1].id)"></a></td></tr></tbody></table></li></ul><br><small>Note: Same seating option order will be respected on online reservation page as defined in above table. Please adjust order to fit your needs.</small></div></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Reservation Page</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h4 class=""><i class="fa fa-globe text-navy"></i>&nbsp;Online reservation page</h4><small>Choose online reservation page which better fits you requirements and your web page look & feel.</small><br><br></div></div><div class="row"><div class="col-lg-1"></div><div class="col-lg-10"><div class="row"><div class="col-md-12">Define coordinates of your business location. If defined, the reservation page will provide driving directions to your guest.<br><br><input class="col-md-6" placeholder="Copy here longitude and latitude of your business location" type="text" ng-model="vm.custo.coordinate" maxlength="32"> &nbsp; <a href="https://support.seaton.site/910790-How-to-find-my-business-coordinates" target="_blank"><i class="fa fa-question-circle fa-2x" data-toggle="tooltip" data-placement="bottom" title="Press here for help on how to find your business coordinate."></i></a><br><br></div></div><div class="row"><div class="col-md-6"><div class="radio"><input class="radio-primary" ng-model="vm.custo.reservationPage" ng-change="vm.changeReservationPage()" type="radio" name="radio1" id="radio_legacy" value="LEGACY" checked=""><label for="radio_legacy"><strong ng-class="vm.reservationPageChoice==\'LEGACY\'?\'text-navy\':\'text-muted\'">Legacy online reservation page</strong><br><small>Simple look and feel for a simple and fast reservation.</small></label></div><br><a href="content/images/legacy_reservation_page.png" target="_blank"><img class="img-responisive col-md-12" src="content/images/legacy_reservation_page.png" alt="Click on image to enlarge."></a></div><div class="col-md-6"><div class="radio"><input class="radio-primary" ng-model="vm.custo.reservationPage" ng-change="vm.changeReservationPage()" type="radio" name="radio1" id="radio_new" value="RESERVE" checked=""><label for="radio_new"><strong ng-class="vm.reservationPageChoice==\'SEATING\'?\'text-navy\':\'text-muted\'">New online reservation page with seating options support</strong><br><small>New and modern look and feel with support for seating options.</small></label></div><br><a href="content/images/new_reservation_page.png" target="_blank"><img class="img-responisive col-md-12" src="content/images/new_reservation_page.png" alt="Click on image to enlarge."></a></div></div></div><div class="col-lg-1"></div></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Messages</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h4 class=""><i class="fa fa-bullhorn text-navy"></i>&nbsp;Online reservation customer messages</h4><small>Define messages which will be shown to customer during the online reservation process.</small><br><br></div></div><div class="row"><div class="col-lg-1"></div><div class="col-lg-10"><div class="hr-line-dashed"></div><div class="row font-bold text-navy">Message to customers<br><small>Please note: You can define html tags in messages to improve look and feel.</small></div><br><div class="row"><div class="col-md-12"><h3 class="font-bold text-success">Note to customer</h3><small>Shown to the customer on the first reservation page.<br>Define a short greeting message or the most important information related to reservation.<br><br></small><div class="form-group" ng-class="{ \'has-error\': formGroups.importantNotice.$invalid}"><textarea name="importantNotice" class="form-control" type="text" rows="4" style="width: 80%" ng-model="vm.custo.importantNotice" ng-required="true" ng-maxlength="512" maxlength="512"></textarea><div class="validation-error" ng-show="formGroups.importantNotice.$invalid"><div ng-messages="formGroups.importantNotice.$error" role="alert" class="text-danger"><div ng-message="maxlength">Message cannot exceed 512 characters.</div></div></div><div ng-if="vm.custo.importantNotice == \'\' || !vm.custo.importantNotice">0/512</div><div ng-if="vm.custo.importantNotice != \'\' && vm.custo.importantNotice">{{vm.custo.importantNotice.length}}/512</div></div></div></div><div class="row"><div class="col-md-12"><h3 class="font-bold text-success">Need to know</h3><small>Shown to the customer on the first reservation page and the second page where the customer leaves contact information.<br>Define all relevant information related to reservations, like how long you keep table in case the guest is late, reservation fee if any, etc.<br><br></small><div class="form-group" ng-class="{ \'has-error\': formGroups.notice.$invalid}"><textarea name="notice" class="form-control" type="text" rows="6" style="width: 80%" ng-model="vm.custo.notice" ng-required="true" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.notice.$invalid"><div ng-messages="formGroups.notice.$error" role="alert" class="text-danger"><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="vm.custo.notice == \'\' || !vm.custo.notice">0/2048</div><div ng-if="vm.custo.notice != \'\' && vm.custo.notice">{{vm.custo.notice.length}}/2048</div></div></div></div><div class="row"><div class="col-md-12"><h3 class="font-bold text-success">Need to know about modifiers</h3><small>Shown to the customer on the optional online reservation page, where customers can add modifiers to the reservation. Modifiers can be defined for each product on the Settings/Product page.<br>Define all relevant information related to modifiers your customers need to know before making the reservation.<br><br></small><div class="form-group" ng-class="{ \'has-error\': formGroups.noticeModifier.$invalid}"><textarea name="noticeModifier" class="form-control" type="text" rows="6" style="width: 80%" ng-model="vm.custo.noticeModifier" ng-required="true" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.noticeModifier.$invalid"><div ng-messages="formGroups.noticeModifier.$error" role="alert" class="text-danger"><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="vm.custo.noticeModifier == \'\' || !vm.custo.noticeModifier">0/2048</div><div ng-if="vm.custo.noticeModifier != \'\' && vm.custo.noticeModifier">{{vm.custo.notice.length}}/2048</div></div></div></div><div ng-hide="isEU==true" class="row"><div class="col-md-12"><h3 class="font-bold text-success">Need to know about payment</h3><small>Shown to the customer on the payment page when the customer leaves credit card information.<br>Define information related to payment, reservation fee rules, cancellation policy, etc.<br><br></small><div class="form-group" ng-class="{ \'has-error\': formGroups.noticePayment.$invalid}"><textarea name="noticePayment" class="form-control" type="text" rows="6" style="width: 80%" ng-model="vm.custo.noticePayment" ng-required="vm.custo.enablePayment" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.noticePayment.$invalid"><div ng-messages="formGroups.noticePayment.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="vm.custo.noticePayment == \'\' || !vm.custo.noticePayment">0/2048</div><div ng-if="vm.custo.noticePayment != \'\' && vm.custo.noticePayment">{{vm.custo.noticePayment.length}}/2048</div></div></div></div><div class="row"><div class="col-md-12"><br><h3 class="font-bold text-success">Reservation completed messages</h3><small>Shown to the customer after they submit the reservation request.<br>You can thank the customer for the reservation, warn the guest to verify the reservation or leave any other information for the customer.<br><br></small><br><div class="row"><div class="col-md-4"><div class="text-info">Reservation completed message</div><small>Message where you can thank the customer for the reservation.</small><br><br><div class="form-group" ng-class="{ \'has-error\': formGroups.noticeCompleted.$invalid}"><textarea name="noticeCompleted" class="form-control" type="text" rows="6" ng-model="vm.custo.noticeCompleted" ng-required="true" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.noticeCompleted.$invalid"><div ng-messages="formGroups.noticeCompleted.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="vm.custo.noticeCompleted == \'\' || !vm.custo.noticeCompleted">0/2048</div><div ng-if="vm.custo.noticeCompleted != \'\' && vm.custo.noticeCompleted">{{vm.custo.noticeCompleted.length}}/2048</div></div></div><div class="col-md-4"><div class="text-info">Reservation confirmation email sent message</div><small>Customer note when confirmation email is sent to customer.</small><br><br><div class="form-group" ng-class="{ \'has-error\': formGroups.noticeCompletedConfirm.$invalid}"><textarea name="noticeCompletedConfirm" class="form-control" type="text" rows="6" ng-model="vm.custo.noticeCompletedConfirm" ng-required="true" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.noticeCompletedConfirm.$invalid"><div ng-messages="formGroups.noticeCompletedConfirm.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="vm.custo.noticeCompletedConfirm == \'\' || !vm.custo.noticeCompletedConfirm">0/2048</div><div ng-if="vm.custo.noticeCompletedConfirm != \'\' && vm.custo.noticeCompletedConfirm">{{vm.custo.noticeCompletedConfirm.length}}/2048</div></div></div><div class="col-md-4"><div class="text-info">Reservation verification email sent message</div><small>Customer note when email verification is required.</small><br><br><div class="form-group" ng-class="{ \'has-error\': formGroups.noticeCompletedVerify.$invalid}"><textarea name="noticeCompletedVerify" class="form-control" type="text" rows="6" ng-model="vm.custo.noticeCompletedVerify" ng-required="true" ng-maxlength="2048" maxlength="2048"></textarea><div class="validation-error" ng-show="formGroups.noticeCompletedVerify.$invalid"><div ng-messages="formGroups.noticeCompletedVerify.$error" role="alert" class="text-danger"><div ng-message="required">Message is required.</div><div ng-message="maxlength">Message cannot exceed 2048 characters.</div></div></div><div ng-if="vm.custo.noticeCompletedVerify == \'\' || !vm.custo.noticeCompletedVerify">0/2048</div><div ng-if="vm.custo.noticeCompletedVerify != \'\' && vm.custo.noticeCompletedVerify">{{vm.custo.noticeCompletedVerify.length}}/2048</div></div></div></div></div></div></div><div class="col-lg-1"></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></div>');
$templateCache.put('app/settings/online/reservation/web/web.html','<div class="wrapper wrapper-content"><div class="row"><div class="col-lg-12 col-md-10"><div class="panel white-panel"><div class="panel-heading"><h2 class="text-navy">Web page integration options</h2>Add reservation functionality for your web page visitors. Choose one of available integration options which best fit to your web page look and feel.</div><div class="panel-body"><div class="row"><div class="col-lg-12 text-right"><a ng-href="/?channel=merchant_web#/public/online/reservation/{{vm.hashedLocationId}}?channel=merchant_web" target="_target"><button class="btn btn-info btn-outline" type="button">Click to view reservation page</button></a> &nbsp;&nbsp; <button ng-disabled="formGroups.$invalid" aria-pressed="false" data-toggle="button" class="btn btn-primary" type="button" ng-click="vm.save()">Save settings</button><br><small class="text-danger">Note: Save to apply new settings to online reservation page</small></div></div><div class="row"><form name="formGroups"><div class="col-sm-12"><uib-tabset><uib-tab><uib-tab-heading class="text-center">Link</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h3 class="text-success">Add reservation link to your web page or anywhere else</h3><p>Using this option, you can add a link to an existing element on your restaurant\'s web site (e.g a button, or text).<br>When the user clicks on the link, SeatOn reservation page opens in a new browser tab. Users can then create a reservation in the new tab.<br>SeatOn customization of the look and feel is not used if you use this option.</p><br></div></div><div class="row"><div class="col-lg-6 col-md-6"><textarea id="onlineReservationLink" ng-model="vm.onlineResAnchor" class="col-sm-12" disabled="true" rows="2"></textarea><br></div></div><div class="row"><div class="col-lg-12"><br><a type="button" ng-click="vm.copyToClipboard(\'onlineReservationLink\')" class="btn btn-w-m btn-primary col-lg-6 col-md-6">Copy Code to Clipboard</a></div></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">QR code</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-6"><h3 class="text-success">Print the QR code</h3><p>Download the QR code and print it out. Guests will be able to scan the QR code with their smartphones, which will open the online reservation form. Try it out now by scanning the QR code with your phone.</p><br></div></div><div class="row"><div class="col-lg-6 col-md-6"><img ng-src="/api/v1/merchants/{{vm.locationId}}/settings/online/qr-code"></div></div><div class="row"><div class="col-lg-6"><br><a ng-href="/api/v1/merchants/{{vm.locationId}}/settings/online/qr-code" download="qr-code.png" class="btn btn-w-m btn-primary col-lg-6 col-md-6">Download</a></div></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Widget</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h3>Add the SeatOn widget to your web site</h3><p>Using this option, you can add the SeatOn reservation widget to your web page. You can customize the widget below - the preview is updated in real-time. To add the widget to your size, copy the code in the bottom of this page and add it to your web page.</p><br></div></div><div class="row"><div class="col-lg-4"><div class="row"><div class="col-lg-12"><h3>Widget type</h3><p>Select the type of the widget you want for your web page:</p><br></div></div><div class="row"><div class="col-lg-6 col-lg-offset-1"><select ng-model="vm.custo.widgetType" class="col-lg-12" ng-change="vm.updateWidgetPreview()"><option selected="selected" value="VERTICAL">{{vm.widgetTypeVerticalDesc}}</option><option value="HORIZONTAL">{{vm.widgetTypeHorizontalDesc}}</option></select></div></div><div class="row"><div class="col-lg-12"><br><h3>Background color</h3><p>Select the background color of <strong>your</strong> web site:</p><br></div></div><div class="row"><div class="col-lg-6 col-lg-offset-1"><select ng-model="vm.custo.widgetBackground" class="col-lg-12" ng-change="vm.updateWidgetPreview()"><option selected="selected" value="LIGHT">Light background</option><option value="DARK">Dark background</option></select></div></div><div class="row"><div class="col-lg-12"><br><br><h3>Code to add to your web site</h3><p>Add the SeatOn online reservation widget, by adding the code below to your restaurant main web page.<br>More information on how to integrate the widget with your website you can found in help pages.</p>Please copy this code and paste to your restaurant\'s web page<br><textarea id="inlineWidgetCode" ng-model="vm.inlineWidgetCode" class="col-lg-12" disabled="true" rows="5">\n                                                                        </textarea><small>Note: if you want to change the type of the widget later (e.g. from Vertical to Horizontal), you\'ll need to copy the code again and update your web site with the new code.</small><br><br></div></div><div class="row"><div class="col-lg-12"><a type="button" ng-click="vm.copyToClipboard(\'inlineWidgetCode\')" class="btn btn-w-m btn-primary col-lg-12">Copy Code to Clipboard</a></div></div></div><div class="col-lg-8"><h3><b>Preview</b></h3><br><iframe id="widgetPreviewFrame" ng-src="{{vm.widgetFrameSrc}}" ng-style="vm.custo.widgetBackground === \'LIGHT\' && {\'background\': \'rgb(226, 236, 234)\'} || vm.custo.widgetBackground === \'DARK\' && {\'background\':\'rgb(44, 45, 45)\'} " allowtransparency="true" style="border-width: 1px" frameborder="2" height="600" width="100%"></iframe></div></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading class="text-center">Floating button</uib-tab-heading><div class="panel panel-default"><div class="panel-body"><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><h3>Add a floating button to your web site</h3><p>Using this option, you can add a button that is always visible on your web page. The button is always displayed over other content on your site. Below, you can customize the button, set the position, the look and feel, and the size - the preview is updated in real-time. You can add the button to your web page by copying the code in the bottom of this page.</p><br></div></div><div class="row"><div class="col-lg-5"><div class="row"><div class="col-lg-12"><toggle id="enabledFloatingButton" ng-model="vm.custo.enabled" on="On" off="Off" ng-checked="false" ng-click=""></toggle>&nbsp;&nbsp;<strong>Enable online reservation floating button on page</strong><br><br></div></div><div class="row"><div class="col-lg-12"><strong>Button position</strong><br><small>Button will be floated to selected page edge and will be fixed in selected position.</small><br><br></div></div><div class="row"><div class="col-lg-5 col-lg-offset-1"><select ng-model="vm.custo.position" ng-options="item.id as item.name for item in vm.position_options" class="col-lg-12" ng-change="vm.updateBtnPreview()"></select></div><div class="col-lg-5"><select ng-model="vm.custo.padding" ng-options="item.id as item.name for item in vm.padding_options" class="col-lg-12" ng-change="vm.updateBtnPreview()"></select></div></div><div class="row"><div class="col-lg-12"><br><strong>Button text</strong><br><small>Define text for floating button. You can use HTML tags to decorate button text.</small><br><br></div></div><div class="row"><div class="col-lg-12"><input class="col-lg-10 col-lg-offset-1" ng-model="vm.custo.buttonText" ng-change="vm.updateBtnPreview()"></div></div><div class="row"><div class="col-lg-12"><br><strong>Button colors</strong><br><small>Define button colors to better match look and feel of your web page.</small><br><br></div></div><div class="row"><div class="col-lg-12"><div class="row"><div class="col-lg-5 col-lg-offset-1"><input color-picker color-picker-model="vm.custo.backgroundColor" ng-model="vm.custo.backgroundColor" ng-style="{background:vm.custo.backgroundColor}"><br><small>Background color</small></div><div class="col-lg-6"><input color-picker color-picker-model="vm.custo.textColor" ng-model="vm.custo.textColor" ng-style="{background:vm.custo.textColor}"><br><small>Text color</small></div></div></div></div><div class="row"><div class="col-lg-12"><br><div class="row"><div class="col-lg-5 col-lg-offset-1"><input color-picker color-picker-model="vm.custo.backgroundColorHover" ng-model="vm.custo.backgroundColorHover" ng-style="{background:vm.custo.backgroundColorHover}"><br><small>Hover background color</small></div><div class="col-lg-6"><input color-picker color-picker-model="vm.custo.textColorHover" ng-model="vm.custo.textColorHover" ng-style="{background:vm.custo.textColorHover}"><br><small>Hover text color</small></div></div></div></div><div class="row"><div class="col-lg-12"><br><div class="row"><div class="col-lg-5 col-lg-offset-1"><input color-picker color-picker-model="vm.custo.buttonLineColor" ng-model="vm.custo.buttonLineColor" ng-style="{background:vm.custo.buttonLineColor}"><br><small>Button line color</small></div></div></div></div><div class="row"><div class="col-lg-12"><br><strong>Font size</strong><br><small>Define button text font size.</small><br><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><select ng-model="vm.custo.fontSize" ng-options="item.id.toString() as item.name for item in vm.font_size" class="col-lg-4" ng-change="vm.updateBtnPreview()"></select></div></div><div class="row"><div class="col-lg-12"><br><strong>Button transparency</strong><br><small>Define button transparency to better match look and feel of your web page.</small><br><br></div></div><div class="row"><div class="col-lg-10 col-lg-offset-1"><input id="slider_transparency"></div></div><div class="row"><div class="col-lg-12"><br><br><h3>Add the button to your web page</h3><p>Copy the code below, and add it to your web page (just before the &lt;/body&gt; tag). This will create a floating button that is always visible on your website. More information on how to integrate reservation widget in your website you can found in the help pages.</p><br>Please copy the below code and paste it in your main web page just before &lt;/body&gt; tag<br><textarea id="onlineReservationCode" ng-model="vm.integrationScript" class="col-lg-12" disabled="true" rows="10">\n                                                                </textarea><small>Note: Once you have code on your web page, you can customize online reservation widget without modifying code on your page.</small><br><br></div></div><div class="row"><div class="col-lg-12"><a type="button" ng-click="vm.copyToClipboard(\'onlineReservationCode\')" class="btn btn-w-m btn-primary col-lg-12">Copy Code to Clipboard</a></div></div></div><div class="col-lg-7"><h3><b>Preview</b></h3><br><iframe id="btnPreviewFrame" allowtransparency="true" style="background: #c3d9ec; border-width: 1px" src="app/settings/online/availability/preview.html" frameborder="2" height="600" width="100%"></iframe></div></div></div></div></div></div></uib-tab></uib-tabset></div></form></div></div></div></div></div></div>');}]);})();